// Vietnamese translations — UI shell.
const vi = {
  /* Zájemci, prohlídky a předání financím
     (pages/RealityZajemciPage.js + pages/ProhlidkaPrihlaskaPage.js).
     Klíče `ver*` mluví na ZÁJEMCE — bez odborných slov, krátké věty.
     Zbytek mluví na makléře. Znění samotných souhlasů tu NENÍ: chodí ze
     serveru (backend/lib/reality_souhlas.py), protože se ukládá jeho otisk
     a ten musí sedět s tím, co člověk doopravdy viděl. */
  realZaj: {
    nadpis: "Người quan tâm và buổi xem nhà",
    nacitam: "Đang tải…",
    chyba: "Không thành công. Vui lòng thử lại.",
    terminy: "Lịch xem nhà",
    terminyPopis: "Đặt một lịch và gửi liên kết. Người quan tâm tự đăng ký.",
    vypsatTermin: "Đặt lịch",
    termin: "Ngày và giờ",
    delka: "Số phút",
    kapacita: "Bao nhiêu người",
    ulozit: "Lưu",
    zadneTerminy: "Bạn chưa đặt lịch nào.",
    volno: "Còn {n} trong {z} chỗ",
    neplatny: "Liên kết hết hiệu lực",
    vDiari: "Đã vào lịch",
    kopirovat: "Sao chép liên kết",
    zkopirovano: "Đã sao chép",
    zneplatnit: "Huỷ liên kết",
    zajemci: "Người quan tâm",
    pridatZajemce: "Thêm người quan tâm",
    rozesilka: "{n} trong {z} người được nhận chào bán tiếp theo.",
    jmeno: "Tên",
    telefon: "Điện thoại",
    email: "E-mail",
    rucneBezSouhlasu: "Người bạn tự nhập chưa có đồng ý — chỉ họ mới cho được, trong mẫu đăng ký.",
    nikdoTu: "Chưa có ai ở đây.",
    bezJmena: "Chưa có tên",
    stav: "Bước",
    financovani: "Tài chính",
    okamzik: "Khi nào chuyển",
    predatPoradci: "Chuyển cho chuyên viên",
    predanoPoradci: "Đã chuyển",
    bezSouhlasuNejde: "Không có đồng ý thì không được. Hãy gửi họ liên kết đăng ký để họ tự yêu cầu.",
    odvolat: "Rút lại đồng ý",
    smazatPotvrzeni: "Xoá người này và dữ liệu của họ? Bản chuyển giao vẫn còn nhưng không có dữ liệu cá nhân.",
    souhlasPoradci: "Đồng ý gặp chuyên viên",
    souhlasAno: "Đồng ý nhận chào bán",
    souhlasNe: "Chưa đồng ý",
    souhlasNezeptano: "Chưa hỏi",
    souhlasOdvolan: "Đã rút đồng ý",
    souhlasImport: "Từ cơ sở dữ liệu cũ",
    predani: "Chuyển sang tài chính",
    zadnePredavky: "Bạn chưa chuyển ai.",
    odmenaNenastavena: "Chưa đặt mức chia",
    odmenaVysvetleni: "Chừng nào chưa chọn tính trên cơ sở nào, hệ thống không tính ra số tiền.",
    zpetNaNemovitost: "Quay lại bất động sản",
    smlouvaZalozit: "Hợp đồng đặt cọc",
    smlouvaOtevrit: "Mở hợp đồng đặt cọc",
    smlouvaPodepsana: "Hợp đồng đặt cọc đã ký",
    fin: {
      neptal_jsem_se: "Chưa hỏi",
      hotovost: "Tiền mặt",
      hypoteka: "Vay mua nhà",
      nevim: "Chưa biết",
    },
    predavkaStav: {
      navrzena: "Chờ chuyên viên",
      odeslana: "Đã gửi",
      prijata: "Chuyên viên đã nhận",
      odmitnuta: "Chuyên viên từ chối",
      propadla: "Đã quá hạn",
    },
    verNadpis: "Đăng ký xem nhà",
    verNacitam: "Đang tải…",
    verNeplatnyNadpis: "Liên kết không hợp lệ",
    verNeplatny: "Lịch đã qua hoặc liên kết hết hạn. Vui lòng liên hệ môi giới.",
    verJazyk: "Ngôn ngữ",
    verJmeno: "Họ và tên",
    verTelefon: "Điện thoại",
    verEmail: "E-mail",
    verPlno: "Buổi xem này đã đầy. Vui lòng liên hệ môi giới.",
    verOdeslat: "Đăng ký xem nhà",
    verOdesilam: "Đang gửi…",
    verPovinne: "Không tích ô đầu tiên thì chúng tôi không lưu được đăng ký.",
    verChybiKontakt: "Vui lòng để lại điện thoại hoặc e-mail để chúng tôi liên hệ.",
    verChyba: "Gửi không thành công. Vui lòng thử lại.",
    verHotovo: "Xong, bạn đã đăng ký.",
    verHotovoPoradce: "Chuyên viên vay mua nhà cũng sẽ liên hệ với bạn.",
  },
  /* Kalkulačka na veřejné stránce nemovitosti
     (components/nemovitost/KalkulackaNemovitosti.js). Mluví na KLIENTA,
     ne na poradce — krátké věty, žádný odborný slovník. */
  nemKalk: {
    otazka: "Bạn mua để ở hay để đầu tư?",
    proSebe: "Để ở",
    jakoInvestici: "Để đầu tư",
    vlastni: "Vốn tự có",
    sazba: "Lãi suất",
    splatnost: "Thời hạn vay",
    najem: "Tiền thuê hằng tháng dự kiến",
    splatkaPopis: "trả góp hằng tháng",
    vetaSplatka: "Với {podil} vốn tự có, bạn cần {vlastni} và khoản trả góp sẽ là {splatka} mỗi tháng.",
    hruby: "Lợi suất gộp",
    cisty: "Lợi suất ròng",
    cashflow: "Dòng tiền hằng tháng",
    vetaMinus: "Tiền thuê không đủ trả góp và chi phí — mỗi tháng bạn bù thêm {castka}.",
    vetaPlus: "Sau khi trả góp và chi phí, mỗi tháng bạn còn lại {castka} từ tiền thuê.",
    vetaNajem: "Hãy nhập tiền thuê dự kiến — không có nó thì không tính được lợi suất.",
    predpoklady: "Tính với chi phí vận hành {naklady} mỗi tháng, {mesicu} trên 12 tháng có người thuê và thuế cho thuê 15 % trên 70 % thu nhập.",
    orientacni: "Đây là tính toán tham khảo, không phải chào giá hay bảo đảm. Lãi suất thực tế do ngân hàng quyết định theo năng lực tài chính của bạn.",
    zaM2: "{cena} mỗi m²",
    rokOne: "{n} năm",
    rokFew: "{n} năm",
    rokMany: "{n} năm",
  },
  /* Realitni zakazky (/zakazky). Klice musi byt ve VSECH peti slovnicich —
     t() na chybejicim klici tise vrati klic a na obrazovce sviti `zakazky.nazev`.
     Hlida to frontend/src/__tests__/klicVeSlovniku.test.js. */
  poptavka: {
    prohlidka: 'Buổi xem nhà',
    dorazil: 'đã đến',
    nedorazil: 'không đến',
    teplotaVlazno: 'Đứng yên đã lâu — hãy gọi người mua',
    teplotaHorko: 'Đứng yên quá lâu — người mua đã im lặng',
    stitek: 'Nhu cầu mua',
    zpetNaPipeline: 'Quay lại quy trình bất động sản',
    otevritObchod: 'Lịch sử hồ sơ',
    otevritKlienta: 'Hồ sơ khách hàng',
    followUp: 'Follow-up',
    nenalezena: 'Nhu cầu này không tồn tại hoặc không thuộc về bạn.',
    faze0: 'Đã liên hệ',
    faze1: 'Đã hẹn xem nhà',
    faze2: 'Đã xem nhà',
    faze3: 'Quan tâm nghiêm túc',
    faze4: 'Đặt cọc',
    faze5: 'Hợp đồng mua bán',
    faze6: 'Bàn giao',
    ukol0: 'Gọi điện và tìm hiểu họ cần gì và thanh toán bằng cách nào.',
    ukol1: 'Xác nhận giờ và gửi địa chỉ.',
    ukol2: 'Hỏi về tài chính và liên hệ lại trong ba ngày.',
    ukol3: 'Trước khi đặt cọc, hãy chắc chắn có người lo phần tài chính.',
    ukol4: 'Soạn hợp đồng đặt cọc cho bất động sản đã chọn.',
    ukol5: 'Chuyển hồ sơ cho luật sư và theo dõi thời hạn.',
    ukol6: 'Bàn giao chìa khóa và kết thúc hồ sơ.',
    akce0: 'Chào một bất động sản',
    akce1: 'Xác nhận giờ xem nhà',
    akce2: 'Ghi lại cách họ thanh toán',
    akce3: 'Thu xếp khoản vay',
    akce4: 'Soạn hợp đồng đặt cọc',
    akce5: 'Gửi hợp đồng cho luật sư',
    akce6: 'Bàn giao chìa khóa',
    coHleda: 'Họ đang tìm gì',
    doptatSe: 'Còn cần hỏi về:',
    typ: 'Loại bất động sản',
    typNevybrano: 'Chưa xác định',
    lokalita: 'Khu vực',
    lokalitaPlaceholder: 'Trung tâm, cách trung tâm 20 phút…',
    rozpocet: 'Mức tối đa họ trả',
    dispozice: 'Bố cục',
    dispoziceAtypicke: 'Không theo chuẩn',
    nabidnoutPoradce: 'Nhiều khả năng họ cần khoản vay — hãy sắp xếp chuyên viên trước khi tới bước đặt cọc.',
    nabidky: 'Những gì đã chào cho họ',
    nabidnuto: 'Đã chào: {n}',
    zadneNabidky: 'Chúng ta chưa chào gì cho họ.',
    coJesteMuzeme: 'Còn có thể chào gì cho họ',
    zadneDoporucene: 'Họ đã biết mọi bất động sản của bạn.',
    nabidnout: 'Chào',
    stahnout: 'Rút lại',
    nemovitostPryc: 'Bất động sản không còn trong hệ thống',
    nabidkaStazena: 'Đã rút lại đề nghị.',
    ulozeno: 'Đã lưu.',
    chybaUlozeni: 'Lưu không thành công.',
    chybaFaze: 'Không thể chuyển giai đoạn.',
    chybaNabidky: 'Có lỗi với đề nghị.',
    chybaSeznamu: 'Không tải được nhu cầu mua.',
  },
  zakazky: {
    novaPoptavka: 'Người mua mới',
    filtrProdej: 'Bán',
    filtrNakup: 'Mua',
    nabidnutoKupujicim: 'Đã chào cho người mua',
    otevritPoptavku: 'Mở nhu cầu',
    poptavkaPryc: 'Nhu cầu không còn',
    neaktivni: 'Đã dừng bán',
    tymUlozit: 'Lưu nhóm',
    neulozeno: 'Chưa lưu',
    tymZavolat: 'Gọi',
    osaOdkaz: 'Liên kết cho người mua',
    historieVse: 'Xem toàn bộ lịch sử',
    historieMene: 'Chỉ xem gần đây',
    /* Realitni pipeline (/reality) + prokliky z karty. */
    /* Souhrnne dlazdice nad realitni pipeline (vzor: hypotecni pipeline). */
    bezNemovitosti: "Giao dịch này chưa gắn bất động sản nào, nên không có địa chỉ, người xem hay tin rao để hiển thị. Hãy tạo bất động sản trong danh sách bất động sản.",
    souhrnProdej: "Đang bán",
    souhrnProdejSub: "tổng giá trị {v}",
    souhrnNakup: "Người mua",
    souhrnNakupSub: "đang tìm bất động sản",
    souhrnStoji: "Đứng yên quá lâu",
    souhrnStojiSub: "gọi trước khi họ gọi bạn",
    souhrnHotovo: "Hoàn tất",
    souhrnHotovoSub: "đã bàn giao và kết thúc",
    souhrnNic: "—",
    pipelineNazev: 'Pipeline bất động sản',
    pipelinePodnadpis: 'Mỗi bất động sản đang ở đâu và đã đứng đó bao lâu',
    pipelineSeznam: 'Danh sách và hợp đồng mới',
    pipelineOtevrit: 'Mở pipeline',
    prodatNechat: 'Bán, hay giữ lại?',
    prodatNechatSub: 'Tính toán tham khảo cho chủ sở hữu — bán ngay, hay cho thuê',
    sloupecNemovitost: 'Bất động sản',
    sloupecFaze: 'Giai đoạn',
    sloupecStani: 'Trong giai đoạn',
    sloupecDalsiKrok: 'Bước tiếp theo',
    sloupecCena: 'Giá',
    denOne: '{n} ngày',
    denFew: '{n} ngày',
    denMany: '{n} ngày',
    teplotaVlazno: 'Đứng quá lâu — hãy liên hệ chủ nhà',
    teplotaHorko: 'Đứng quá lâu — chủ nhà không biết chuyện gì đang xảy ra',
    filtrVse: 'Tất cả',
    filtrStoji: 'Đứng quá lâu',
    stojiPocet: 'Đứng quá lâu: {n}',
    coTed: 'Bây giờ làm gì',
    akce0: 'Xin giấy tờ từ chủ nhà',
    akce1: 'Hẹn thợ chụp ảnh',
    akce2: 'Đăng tin rao bán',
    akce3: 'Mở lịch xem nhà',
    akce4: 'Soạn hợp đồng đặt cọc',
    akce5: 'Chuyển hợp đồng cho luật sư',
    akce6: 'Chuyển người mua cho chuyên viên tư vấn',
    zajemci: 'Người mua và buổi xem nhà',
    smlouvy: 'Hợp đồng đặt cọc',
    tym: 'Ai đang làm việc này',
    tymSub: 'Thợ chụp ảnh, chuyên viên tư vấn, luật sư. Để biết gọi cho ai khi bị tắc.',
    tymPrazdno: 'Chưa có ai.',
    tymPridat: 'Thêm người',
    tymRole: 'Vai trò',
    tymJmeno: 'Tên',
    tymTelefon: 'Điện thoại',
    tymOdebrat: 'Xóa',
    tymUlozeno: 'Đã lưu nhóm',
    tymBezObchodu: 'Nhóm được lưu cùng giao dịch và hợp đồng này chưa có giao dịch.',
    roleMakler: 'Môi giới',
    roleFotograf: 'Thợ chụp ảnh',
    rolePoradce: 'Chuyên viên tư vấn tài chính',
    roleAdvokat: 'Luật sư',
    roleJine: 'Vai trò khác',
    osa: 'Dòng thời gian',
    osaSub: 'Khi nào chụp ảnh, khi nào đăng tin, khi nào xem nhà. Đây là câu trả lời cho chủ nhà.',
    osaHotovo: 'Xong',
    osaNestalo: 'Chưa xảy ra',
    osaUlozit: 'Lưu dòng thời gian',
    osaProhlidky: 'Buổi xem nhà',
    osaProhlidkyPrazdno: 'Chưa mở lịch nào.',
    osaPrihlaseno: 'đã đăng ký',
    osaVypsat: 'Mở lịch xem nhà',
    mkPriprava: 'Chuẩn bị và chụp ảnh',
    mkInzerce: 'Trang rao bán',
    mkSite: 'Mạng xã hội',
    mkPlacenaReklama: 'Quảng cáo trả phí',
    mkPr: 'PR ngoại tuyến',
    historie: 'Đã gửi gì cho ai',
    historieSub: 'Ghi chép từ giao dịch — email cho chủ nhà, chuyển giai đoạn, ghi chú của bạn.',
    historiePrazdno: 'Chưa có gì.',
    historiePridat: 'Ghi lại cuộc gọi hoặc tin nhắn',
    historieUlozit: 'Ghi lại',
    historieZapsano: 'Đã ghi vào giao dịch',
    nazev: 'Bất động sản',
    podnadpis: 'Những bất động sản bạn đang bán và chúng đang ở bước nào',
    nova: 'Bất động sản mới',
    nacitam: 'Đang tải…',
    chyba: 'Không tải được danh sách.',
    zadne: 'Chưa có bất động sản nào',
    zadneSub: 'Thêm bất động sản đầu tiên — địa chỉ, chủ sở hữu, giá. Phần còn lại bổ sung dần.',
    hledat: 'Tìm theo địa chỉ hoặc chủ sở hữu',
    typ: 'Loại bất động sản',
    typByt: 'Căn hộ',
    typDum: 'Nhà',
    typPozemek: 'Đất',
    typKomercni: 'Thương mại',
    vlastnictvi: 'Hình thức sở hữu',
    vlastnictviOsobni: 'Sở hữu cá nhân',
    vlastnictviDruzstevni: 'Sở hữu hợp tác xã',
    vlastnictviHint: 'Nhà hợp tác xã dùng mẫu hợp đồng đặt cọc khác.',
    adresa: 'Địa chỉ',
    adresaHint: 'Đường, số nhà và thành phố. Hợp đồng và tin rao đều lấy từ đây.',
    majitel: 'Chủ sở hữu',
    vyberMajitele: 'Chọn chủ sở hữu từ danh bạ',
    majitelHint: 'Người bán. Phải có trong danh bạ — hồ sơ gắn với người này.',
    cenaNabidkova: 'Giá chào bán',
    cenaOdhad: 'Định giá thị trường',
    cenaHint: 'Ô trống nghĩa là chưa định giá, không phải bằng không.',
    lvCislo: 'Số giấy chứng nhận sở hữu',
    katUzemi: 'Khu vực địa chính',
    podepsano: 'Đã ký hợp đồng môi giới',
    exkluzivitaDo: 'Độc quyền đến',
    exkluzivitaHint: 'Với người tiêu dùng tối đa 6 tháng (§ 17 luật 39/2020).',
    provizePct: 'Hoa hồng (%)',
    stitek: 'Chứng chỉ năng lượng',
    stitekMa: 'Đã có',
    stitekChybi: 'Chưa có',
    stitekObjednano: 'Đã đặt làm',
    poznamka: 'Ghi chú',
    nezadano: 'Chưa điền',
    zalozit: 'Tạo hồ sơ',
    zrusit: 'Hủy',
    ulozit: 'Lưu',
    ulozeno: 'Đã lưu',
    krok: 'Bước',
    dalsiKrok: 'Bước tiếp theo',
    hotovoKrok: 'Xong, bước tiếp theo',
    zpetKrok: 'Lùi một bước',
    dokonceno: 'Đã hoàn tất',
    hotovoStav: 'xong',
    cekaStav: 'đang chờ',
    tedStav: 'hiện tại',
    bezObchodu: 'Hồ sơ này không có giao dịch nên không có chỗ ghi bước. Hãy tạo lại.',
    kdeJsme: 'Chúng ta đang ở bước nào',
    faze0: 'Nhận bán',
    faze1: 'Chuẩn bị',
    faze2: 'Đăng tin',
    faze3: 'Xem nhà',
    faze4: 'Đặt cọc',
    faze5: 'Hợp đồng mua bán',
    faze6: 'Bàn giao',
    ukol0: 'Ký hợp đồng môi giới, kiểm tra sổ địa chính và xin chủ nhà các thông tin cần thiết.',
    ukol1: 'Hẹn thợ chụp ảnh, chuẩn bị mặt bằng và home staging, lo chứng chỉ năng lượng.',
    ukol2: 'Đăng tin lên các trang rao bán và mạng xã hội. Lưu lại liên kết vào hồ sơ.',
    ukol3: 'Hẹn lịch xem nhà, hỏi cách thanh toán và ghi lại từng người quan tâm.',
    ukol4: 'Soạn hợp đồng đặt cọc, thu tiền giữ chỗ và gửi cho luật sư.',
    ukol5: 'Luật sư đang soạn hợp đồng mua bán. Theo dõi bước và thường xuyên báo cho chủ nhà.',
    ukol6: 'Ghi chỉ số đồng hồ, ký biên bản bàn giao và sang tên các hợp đồng dịch vụ.',
    komunikace: 'Chúng ta gửi gì cho chủ nhà',
    komunikaceSub: 'Hệ thống soạn sẵn nội dung. Bạn gửi từ đây, hoặc sao chép và tự gửi theo cách của mình.',
    podklady: 'Xin thông tin',
    podkladySub: 'Một liên kết để chủ nhà điền thông tin giấy tờ, email và điện thoại. Chúng tôi không cần ảnh giấy tờ.',
    uvitani: 'Lời chào và kế hoạch',
    uvitaniSub: 'Ngay ngày đầu chủ nhà đã biết điều gì sẽ diễn ra — chụp ảnh, đăng tin, mạng xã hội, quảng cáo, PR.',
    nahled: 'Xem trước nội dung',
    kopirovat: 'Sao chép nội dung',
    zkopirovano: 'Đã sao chép',
    vEmailu: 'Mở trong email',
    odeslatJmenem: 'Gửi dưới tên tôi',
    odesilam: 'Đang gửi…',
    odeslanoNa: 'Đã gửi tới',
    neodeslano: 'Chưa gửi — bạn chưa kết nối email. Hãy sao chép nội dung và tự gửi.',
    bezEmailu: 'Chủ sở hữu chưa có email trong danh bạ. Hãy bổ sung rồi thử lại.',
    odkazProMajitele: 'Liên kết cho chủ nhà',
    platiDo: 'Có hiệu lực đến',
    udaje: 'Thông tin hồ sơ',
    zpetNaSeznam: 'Quay lại danh sách',
    smazat: 'Xóa hồ sơ',
    smazatPotvrd: 'Xóa hồ sơ? Giao dịch và lịch sử trao đổi vẫn được giữ lại.',
    smazano: 'Đã xóa hồ sơ',
    nenalezena: 'Không tìm thấy hồ sơ.',
  },
  /* Tri odkazy pro klienty (web nemovitosti /n/:slug, stav prodeje pro
     majitele /z/:token, podklady /f/:token) + obe verejne stranky. */
  nemWeb: {
    sekce: 'Liên kết cho khách',
    sekceSub: 'Ba trang khách mở mà không cần đăng nhập. Mỗi trang tạo bằng một cú nhấp.',
    nenacetlo: 'Không tải được các liên kết. Hãy thử tải lại trang.',
    webNazev: 'Trang bất động sản',
    webSub: 'Ảnh, mô tả và bảng tính cho người mua. Địa chỉ có thể đọc qua điện thoại.',
    majitelNazev: 'Tình trạng bán cho chủ nhà',
    majitelSub: 'Trang riêng để chủ nhà thấy mọi việc đang diễn ra. Tự cập nhật từ những gì bạn làm.',
    podkladyNazev: 'Thông tin từ chủ nhà',
    podkladyZnovu: 'Hiện lại',
    zatimNevyrobeno: 'Chưa tạo',
    vyrobit: 'Tạo liên kết',
    vyrobeno: 'Đã tạo',
    otevrit: 'Mở',
    kopirovat: 'Sao chép liên kết',
    odeslatMajiteli: 'Gửi cho chủ nhà',
    odeslano: 'Đã gửi',
    zatimNeodeslano: 'Chưa gửi',
    zverejneno: 'Đã đăng',
    jenProTebe: 'Hiện chỉ mình bạn thấy',
    zverejnit: 'Đăng',
    skryt: 'Ẩn',
    platny: 'Còn hiệu lực',
    propadly: 'Đã hết hạn',
    obnovit: 'Tạo liên kết mới',
    obnovitPotvrd: 'Tạo liên kết mới? Liên kết cũ sẽ ngừng hoạt động và chủ nhà không mở được trang từ email.',
    fotky: 'Ảnh',
    fotkyPrazdno: 'Chưa có ảnh nào.',
    fotkyPridat: 'Thêm ảnh',
    fotkyOdebrat: 'Bỏ',
    fotkyOdmitnuto: 'Chưa tải lên được:',
    dotaznikNadpis: 'Bảng hỏi ngắn',
    dotaznikSub: 'Hãy trả lời ngắn gọn tám câu hỏi. Hệ thống sẽ soạn tiêu đề và mô tả từ đó — sau này bạn vẫn có thể viết lại.',
    oDispozice: 'Bố trí',
    oDispoziceHint: 'ví dụ 3+1, 2+kk, phòng studio',
    oPlochaM2: 'Diện tích (m²)',
    oPlochaM2Hint: 'ví dụ 78',
    oPatro: 'Tầng',
    oPatroHint: 'ví dụ tầng 2 trên 5, có thang máy',
    oStav: 'Tình trạng',
    oStavHint: 'ví dụ đã cải tạo năm 2023 / nguyên bản, dọn vào ở ngay',
    oNejlepsi: 'Điểm tốt nhất là gì?',
    oNejlepsiHint: 'ví dụ ban công lớn nhìn ra công viên',
    oProKoho: 'Phù hợp với ai?',
    oProKohoHint: 'ví dụ gia đình có một đến hai con',
    oOkoli: 'Xung quanh có gì?',
    oOkoliHint: 'ví dụ nhà trẻ 200 m, tàu điện, công viên',
    oProcProdava: 'Vì sao chủ nhà bán?',
    oProcProdavaHint: 'ví dụ họ chuyển đi vì công việc',
    oProcProdavaVarovani: 'Nội dung này sẽ vào tin rao. Đừng ghi lý do nhạy cảm (ly hôn, nợ nần) — nó làm giảm giá và là chuyện của chủ nhà, không phải của bất động sản.',
    slozit: 'Soạn nội dung từ câu trả lời',
    slozeno: 'Nội dung do hệ thống soạn',
    slozenoRucne: 'Nội dung do bạn viết',
    slozitPotvrd: 'Ghi đè nội dung bạn đã tự viết? Nó sẽ được soạn lại từ các câu trả lời.',
    chybi: 'Nội dung còn thiếu — hãy bổ sung và soạn lại:',
    nadpisPole: 'Tiêu đề tin rao',
    lokalita: 'Khu vực',
    fotkyPoradi: 'Ảnh đầu tiên là ảnh chính. Kéo ảnh lên đầu, hoặc dùng Đặt làm ảnh chính.',
    fotkyHlavni: 'Ảnh chính',
    fotkyDatHlavni: 'Đặt làm ảnh chính',
    cena: 'Giá',
    najem: 'Giá thuê khu vực',
    najemHint: 'Giá thuê chỉ dùng trong bảng tính cho người mua. Nếu không biết, hãy để trống.',
    popis: 'Mô tả bất động sản',
    ulozitText: 'Lưu nội dung tin rao',
    nacitam: 'Đang tải…',
    neplatny: 'Tin rao này không còn khả dụng. Hãy xin môi giới liên kết mới.',
    neplatnyMajitel: 'Trang này không khả dụng. Hãy xin môi giới liên kết mới.',
    propocet: 'Mỗi tháng nghĩa là bao nhiêu',
    zajemNadpis: 'Tôi muốn xem nhà',
    zajemSub: 'Để lại liên hệ, môi giới sẽ báo bạn thời gian.',
    zajemHotovo: 'Cảm ơn bạn, môi giới sẽ liên hệ.',
    zajemOdeslat: 'Gửi',
    odesilam: 'Đang gửi…',
    jmeno: 'Tên',
    telefon: 'Điện thoại',
    email: 'Email',
    vzkaz: 'Lời nhắn (không bắt buộc)',
    chybiJmeno: 'Vui lòng nhập tên.',
    chybiKontakt: 'Vui lòng để lại điện thoại hoặc email để chúng tôi liên hệ.',
    chybaOdeslani: 'Gửi không thành công. Vui lòng thử lại.',
    kontaktNadpis: 'Người phụ trách',
    zavrit: 'Đóng',
    majitelNadpis: 'Việc bán bất động sản của bạn',
    majitelPata: 'Trang tự cập nhật. Bạn có thể xem bất cứ lúc nào.',
    zatimNic: 'Hiện chưa có gì để hiển thị. Khi có diễn biến, bạn sẽ thấy ở đây.',
    veFazi: 'ở giai đoạn này',
    zajemceOne: 'người quan tâm',
    zajemceFew: 'người quan tâm',
    zajemceMany: 'người quan tâm',
    prohlidkaOne: 'buổi xem nhà đã diễn ra',
    prohlidkaFew: 'buổi xem nhà đã diễn ra',
    prohlidkaMany: 'buổi xem nhà đã diễn ra',
    prohlidkyChystane: 'sắp tới:',
    prohlidkyNadpis: 'Buổi xem nhà',
    prohlidkaChysta: 'sắp diễn ra',
    krokyNadpis: 'Chúng tôi đang làm gì để bán',
    krokChysta: 'sắp làm',
    tymNadpis: 'Ai lo việc bán',
    inzeratOtevrit: 'Mở tin rao',
    inzeratPopis: 'Người mua thấy bất động sản như thế này',
  },
  /* Levá lišta + chrome aplikace. Dřív to byl SK-only overlay `SK_NAV`,
   * takže vietnamec i ukrajinec viděli českou navigaci na KAŽDÉ obrazovce. */
  /* Uvítací modal po prvním přihlášení (components/FirstLoginWizard.js).
   * {jmeno} se dosazuje v komponentě — nesmí se z překladu vypustit. */
  wizard: {
    /* Zástupné slovo, když poradce nemá vyplněné jméno. Do 23. 8. 2026
       bylo v FirstLoginWizard.js natvrdo české „svoji“, takže Vietnamec
       četl „danh thiếp số của svoji“. */
    zastupneJmeno: 'bạn',
    vitej: 'Chào mừng đến với BEplan University',
    nadpis: 'Thiết lập danh thiếp số của {jmeno}',
    popisA: 'Danh thiếp là trang công khai của bạn — khách hàng có thể đặt lịch hẹn, gọi điện và tìm bạn trên LinkedIn.',
    popisZvyraznene: 'Chỉ mất 30 giây',
    popisB: 'và sau đó tất cả liên kết Leadovač cùng thẻ giới thiệu sẽ hoạt động.',
    slugLabel: 'Địa chỉ URL của bạn (slug)',
    nahled: 'Xem trước:',
    nastavitVizitku: 'Thiết lập danh thiếp',
    preskocit: 'Tạm bỏ qua',
    pozdejiA: 'Nếu bỏ qua bây giờ, bạn có thể thiết lập danh thiếp bất cứ lúc nào trong',
    pozdejiKde: 'Cài đặt → Danh thiếp',
    pozdejiB: 'Nhưng nên làm ngay — không có slug thì Leadovač sẽ không chạy.',
    hotovo: 'Xong!',
    vrhnemeSe: 'Chuyển đến CRM…',
    ulozeno: 'Đã lưu danh thiếp!',
    chyba: 'Lưu slug thất bại. Bạn có thể thử lại trong Cài đặt → Danh thiếp.',
  },
  lista: {
    nastenka: 'Bảng điều khiển',
    klienti: 'Khách hàng',
    obchody: 'Giao dịch',
    diar: 'Lịch',
    posta: 'Thư',
    manazer: 'Quản lý',
    vzdelavani: 'Đào tạo',
    nastroje: 'Công cụ',
    adresar: 'Danh bạ',
    zrcadloVolani: 'Nhật ký cuộc gọi',
    pipelineKlientu: 'Pipeline khách hàng',
    radarPrilezitosti: 'Radar cơ hội',
    mapaKlientu: 'Bản đồ khách hàng',
    leadyProjekt100: 'Khách tiềm năng (Dự án 100)',
    obchodniNastenka: 'Bảng giao dịch',
    hypotecniPipeline: 'Pipeline vay thế chấp',
    naborovaPipeline: 'Pipeline tuyển dụng',
    naborovyRadar: 'Radar tuyển dụng',
    zakazkyReality: 'Bất động sản (nhà đất)',
    realitniPipeline: 'Pipeline bất động sản',
    rezervacniSmlouva: 'Hợp đồng giữ chỗ',
    prehledTymu: 'Tổng quan đội nhóm',
    ikKonzultace: 'Tư vấn IK',
    mojiPoradci: 'Cố vấn của tôi',
    vyhlaseniVysledku: 'Công bố kết quả',
    tymoveAkce: 'Sự kiện đội nhóm',
    diarTymu: 'Lịch đội nhóm',
    startNovacka: 'Khởi đầu cho người mới (Hành trình 90 ngày)',
    adaptace7: 'Hội nhập 7 ngày',
    adaptaceTymu: 'Hội nhập của nhóm',
    akademieModuly: 'Học viện — mô-đun và đồ họa',
    metodikaPlan: 'Phương pháp: Lập kế hoạch',
    zkouskaCertifikat: 'Kỳ thi và chứng chỉ',
    skriptyNamitky: 'Kịch bản và xử lý từ chối',
    kdeShanetKlienty: 'Tìm khách hàng ở đâu',
    videaKurzy: 'Video và khóa học',
    rozcestnikNastroju: 'Danh mục công cụ',
    financniMatematika: 'Toán tài chính',
    kalkulacky21: 'Máy tính (20)',
    penzijniKalkulacka: 'Máy tính hưu trí',
    zivotniPojisteni: 'Bảo hiểm nhân thọ',
    historickaKalkulacka: 'Máy tính lịch sử',
    investicniStrategie: 'Chiến lược đầu tư',
    srovnavacFondu: 'So sánh quỹ',
    nemovitostPronajem: 'Bất động sản cho thuê',
    provizniKalkulacka: 'Máy tính hoa hồng',
    hledat: 'Tìm kiếm',
    hledatVCeleAplikaci: 'Tìm kiếm trong toàn ứng dụng',
    naNastenku: 'Về bảng điều khiển',
    profilPoradce: 'Hồ sơ cố vấn (đặt ảnh trong Cài đặt)',
    zavritMenu: 'Đóng menu',
    sbalit: 'Thu gọn',
    pripnout: 'Ghim',
    sbalitListu: 'Thu gọn thanh',
    pripnoutRozbalene: 'Ghim khi mở rộng',
    novyZaznam: 'Bản ghi mới — khách hàng, lead, giao dịch, nhiệm vụ…',
    novyZaznamTlacitko: 'Bản ghi mới',
    ucet: 'Tài khoản',
    novyKlient: 'Khách hàng mới',
    novyKlientSub: 'Thêm vào pipeline',
    novyLead: 'Lead mới',
    novyLeadSub: 'Cơ hội / liên hệ chưa sẵn sàng',
    obchodniPripad: 'Hồ sơ giao dịch',
    obchodniPripadSub: 'Tạo giao dịch ngay',
    naborKandidat: 'Tuyển dụng — ứng viên',
    naborKandidatSub: 'Tạo ứng viên ngay',
    ukolSchuzka: 'Nhiệm vụ / Cuộc hẹn',
    ukolSchuzkaSub: 'Mở Lịch',
    leadZDoporuceni: 'Lead từ giới thiệu',
    leadZDoporuceniSub: 'Liên kết cho khách hàng',
    // horní lišta záložek (GlobalTabBar) — zbylých 28; ostatní sdílí klíče výše
    tabLeady: 'Khách tiềm năng',
    tabServisRadar: 'Radar dịch vụ',
    tabKomunikace: 'Giao tiếp',
    tabDoporuceni: 'Giới thiệu',
    tabCile: 'Mục tiêu',
    tabVyhlaseni: 'Công bố',
    tabSmlouva: 'Hợp đồng',
    tabHypoteky: 'Vay thế chấp',
    tabNabor: 'Tuyển dụng',
    tabHlasovyRezim: 'Chế độ giọng nói',
    tabRezervace: 'Đặt lịch',
    tabTrychtyre: 'Phễu',
    tabHistoricka: 'Lịch sử',
    tabFinMatematika: 'Toán tài chính',
    tabInvesticniStudio: 'Studio đầu tư',
    tabStrategie: 'Chiến lược',
    tabPenze: 'Hưu trí',
    tabIzp: 'Phân tích cho người Việt',
    tabRentaPorovnavac: "So sánh rút tiền",
    tabAnalyza: "Phân tích",
    tabFixace: "Kỳ cố định",
    tabSvoboda: "Khi nào được tự do",
    tabHypotekaRozhodnuti: "Vay mua nhà — quyết định",
    tabPortfolioDoktor: 'Bác sĩ danh mục',
    tabReality: 'Bất động sản',
    tabZakazky: 'Hợp đồng môi giới',
    tabRezervacniSmlouva: 'Hợp đồng đặt cọc',
    tabNemovitost: 'Bất động sản',
    tabKalkulackaVizual: 'Máy tính trực quan',
    tabProvize: 'Hoa hồng',
    tabDesignLab: 'Design Lab',
    tabAdmin: 'Quản trị',
    tabAiKnowledge: 'AI Knowledge',
    tabHlasovky: 'Tin nhắn thoại',
    tabHromadnyEmail: 'Email hàng loạt',
    tabPortfolioAdmin: 'Danh mục (quản trị)',
    tabTrzniData: 'Dữ liệu thị trường',
    tabMesicnikAdmin: 'Bản tin tháng (quản trị)',
    tabMesicnik: 'Bản tin tháng',
    tabDataHygiena: 'Vệ sinh dữ liệu',
    tabNastaveni: 'Cài đặt',
    tabNovinky: 'Có gì mới',
  },
  nav: { dashboard: "Bảng điều khiển", calculators: "Máy tính", tools: "Công cụ", admin: "Quản trị", logout: "Đăng xuất", theme: "Đổi giao diện" },
  login: {
    subtitle: "Hệ thống đào tạo cho cố vấn tài chính",
    welcomePre: "Chào mừng đến với",
    welcomeEm: "trường đại học",
    name: "Họ và tên",
    accessCode: "Mã truy cập",
    registerClosed: "Hiện tại chưa mở đăng ký. Hãy liên hệ quản trị viên để được mời hoặc bật đăng ký.",
    email: "Email",
    password: "Mật khẩu",
    submit: "Đăng nhập",
    register: "Đăng ký",
    loading: "Đang tải…",
    loginOk: "Đăng nhập thành công!",
    registerOk: "Đăng ký thành công!",
    loginErr: "Lỗi đăng nhập",
    hasAccount: "Đã có tài khoản? Đăng nhập",
    noAccount: "Chưa có tài khoản? Đăng ký",
    forgot: "Quên mật khẩu?",
    forgotTitle: "Khôi phục mật khẩu",
    sendCode: "Gửi mã qua email",
    codeSent: "Nếu email tồn tại, chúng tôi đã gửi mã đến địa chỉ đó.",
    codeLabel: "Mã khôi phục từ email",
    newPass: "Mật khẩu mới (tối thiểu 8 ký tự)",
    resetBtn: "Đặt mật khẩu mới",
    resetOk: "Đã khôi phục mật khẩu — hãy đăng nhập",
    backToLogin: "Quay lại đăng nhập",
  },
  dash: {
    welcome: "Chào mừng đến beplan University",
    subtitle: "Hệ thống đào tạo cho tư vấn tài chính",
    progress: "Tiến độ tổng",
    completedVids: "Video đã hoàn thành",
    activeSeries: "Series đang học",
    totalProgress: "Tiến độ tổng",
    series: "Series đào tạo",
    done: "HOÀN THÀNH",
    inProgress: "ĐANG HỌC",
    vidsDone: "video hoàn thành",
    lastWatch: "Xem gần nhất",
  },
  detail: { notFound: "Không tìm thấy series", locked: "Series bị khóa", lockedDesc: "Hoàn thành series trước để mở khóa.", back: "Về Bảng điều khiển", seriesLabel: "Series", markDone: "Đánh dấu hoàn thành", isDone: "Đã hoàn thành", download: "Tải tài liệu", noMaterial: "Tài liệu không có", comments: "Bình luận", writeComment: "Viết bình luận hoặc phản hồi…", send: "Gửi", sending: "Đang gửi…", noComments: "Chưa có bình luận. Hãy là người đầu tiên!", reply: "Trả lời", del: "Xóa", writeReply: "Viết trả lời…", vidDone: "Video đã được đánh dấu!", saveErr: "Lỗi lưu", commentOk: "Đã thêm bình luận!", commentErr: "Lỗi thêm bình luận", replyOk: "Đã thêm trả lời!", delOk: "Đã xóa bình luận", delErr: "Lỗi xóa" },
  calcPage: { title: "Máy tính tài chính", subtitle: "Công cụ chuyên nghiệp cho lập kế hoạch tài chính", all: "Tất cả", realestate: "Bất động sản", investment: "Đầu tư", insurance: "Bảo hiểm & Hưu trí", personal: "Tài chính cá nhân", open: "Mở máy tính" },
  toolsPage: { title: "Công cụ cho cố vấn tài chính", subtitle: "Công cụ chuyên nghiệp cho công việc hiệu quả", open: "Mở", catObchod: "Kinh doanh & hoa hồng", catKalkulacky: "Máy tính & phép tính", catVzdelavani: "Đào tạo", tileObchod: "Kinh doanh", tileKalkulacka: "Máy tính", tileVzdelavani: "Đào tạo", },
  admin: { loading: "Đang tải…", title: "Quản trị", codeTitle: "Mã truy cập", codeDesc: "Người dùng mới cần mã này để đăng ký.", save: "Lưu", curCode: "Mã hiện tại:", users: "Người dùng", videoTitle: "Quản lý video", videoDesc: "Thêm liên kết YouTube và tài liệu.", vids: "video", ytUrl: "YouTube URL", matUrl: "Tài liệu (Google Drive)", saving: "Đang lưu…", saved: "Đã cập nhật video!", saveErr: "Lỗi lưu", loadErr: "Lỗi tải", codeOk: "Đã cập nhật mã!", codeErr: "Lỗi cập nhật", noName: "Không tên", confirmDelete: "Thực sự xóa người dùng này?", userDeleted: "Đã xóa người dùng", deleteErr: "Lỗi xóa", deleteUser: "Xóa người dùng" },
  common: { reset: "Đặt lại", start: "Bắt đầu", pause: "Tạm dừng", min: "phút", progress: "Tiến độ", phase: "Giai đoạn", search: "Tìm kiếm…", noResults: "Không có kết quả", example: "Ví dụ", save: "Lưu", saving: "Đang lưu…", cancel: "Hủy", delete: "Xóa", edit: "Sửa", add: "Thêm", close: "Đóng", back: "Quay lại", next: "Tiếp", yes: "Có", no: "Không", confirm: "Xác nhận", loading: "Đang tải…", copy: "Sao chép", copied: "Đã sao chép", open: "Mở", new: "Mới", today: "hôm nay", week: "tuần", total: "tổng", name: "Tên", phone: "Điện thoại", email: "Email", note: "Ghi chú", required: "Bắt buộc", optional: "Tùy chọn", submit: "Gửi", submitting: "Đang gửi…", detail: "Chi tiết", settings: "Cài đặt", backToSettings: "Quay lại cài đặt" },
  crm: {
    title: "CRM Cố vấn",
    advisorWord: "Cố vấn",
    subtitle: "Liên hệ, pipeline, cuộc gọi và tư vấn IK — tất cả ở một nơi.",
    beginner: "Người mới",
    overview: "Tổng quan",
    p100: "Dự án 100",
    calls: "Gương cuộc gọi",
    pipeline: "Pipeline",
    ik: "Tư vấn IK",
    goals: "Mục tiêu & Rocks",
    team: "Cố vấn của tôi",
    leadovac: "Leadovač",
    stages: { lead: "Lead", calling: "Cần gọi", meeting: "Đã đặt cuộc họp", onboarding: "Onboarding", proposal: "Đề xuất", contract: "Hợp đồng", active: "Khách hàng đang hoạt động", lost: "Mất" },
    actions: { call: "Gọi", schedule: "Đặt lịch", callback: "Gọi lại", later: "Sau", noInterest: "Không quan tâm", addContact: "Thêm liên hệ", newLead: "Lead mới" },
  },
  leadovac: {
    title: "Leadovač",
    subtitle: "Phễu bán hàng để thu thập lead. Gửi liên kết cho khách qua WhatsApp — họ xem chủ đề, tính lợi ích bằng máy tính và để lại yêu cầu. Bạn có lead mới.",
    latestLeads: "Lead mới nhất",
    latestLeadsSub: "Cập nhật mỗi 20 giây · yêu cầu mới đến",
    live: "live",
    today: "hôm nay",
    week: "tuần",
    total: "tổng",
    filter: { all: "Tất cả" },
    tools: "Công cụ leadovač của bạn",
    toolsSub: "4 phễu cao cấp đã sẵn sàng — nhấp và chia sẻ với khách hàng.",
    setSlugFirst: "Trước tiên hãy đặt slug trong hồ sơ →",
    open: "Mở",
    detail: "Chi tiết & chia sẻ →",
    detailRef: "Tạo liên kết cho khách →",
    noLeads: "Chưa có lead. Hãy gửi liên kết cho khách.",
    moreLeads: "khác — mở thẻ chủ đề",
    badgeLead: "lead",
    badgeLeads: "lead",
    badgeLink: "liên kết",
    badgeLinks: "liên kết",
  },
  leadForm: {
    eyebrowConsult: "30 phút miễn phí",
    yourName: "Tên của bạn",
    yourNamePh: "Nguyễn Văn A",
    yourPhone: "Điện thoại",
    yourPhonePh: "+84 90 000 0000",
    yourEmail: "Email (tùy chọn)",
    yourEmailPh: "ten@example.com",
    note: "Lời nhắn ngắn (tùy chọn)",
    notePh: "Điều gì quan trọng nhất với bạn, khi nào gọi, v.v.",
    preferredTime: "Thời gian gặp mong muốn",
    preferredTimePh: "VD. ngày làm việc buổi chiều",
    consent: "Bằng cách gửi, tôi đồng ý xử lý dữ liệu để liên hệ.",
    successTitle: "Cảm ơn!",
    successSubtitle: "Tôi sẽ liên hệ trong vòng 24 giờ.",
    successHint: "Hãy giữ điện thoại bên cạnh — tôi thường gọi lại ngay trong ngày.",
    bookHeading: "Hoặc chọn thời gian ngay",
    bookSubtitle: "Chọn ngày và giờ phù hợp với bạn. Không ràng buộc, không áp lực.",
    bookCta: "Chọn thời gian tư vấn",
    ctaTryCalc: "Thử máy tính",
    ctaWantConsult: "Tôi muốn được tư vấn",
    notFound: "Không tìm thấy trang",
    unknownTopic: "Chủ đề không tồn tại",
    errName: "Vui lòng nhập họ tên đầy đủ",
    errPhone: "Vui lòng nhập số điện thoại hợp lệ",
    errSend: "Gửi không thành công, vui lòng thử lại.",
    calcEyebrow: "Tự bạn thử xem",
    calcTitle: "Máy tính {tema}",
    calcSub: "Kéo các thông số và xem con số thay đổi ngay lập tức. Đây không phải tính toán khoa học, nhưng đủ chính xác để bạn hình dung.",
    howEyebrow: "Cách hoạt động",
    howTitle: "Bốn bước từ câu hỏi đến giải pháp",
    examplesEyebrow: "Ví dụ mẫu",
    examplesTitle: "Trong hoàn cảnh của bạn có thể như thế nào",
    examplesNote: "Các tình huống minh họa — để bạn thấy cụ thể có thể giải quyết được gì. Kết quả thực tế luôn phụ thuộc vào hoàn cảnh riêng của bạn.",
    exSituation: "Tình huống:",
    exSolution: "Giải pháp:",
    preparedBy: "Trang này được chuẩn bị cho bạn bởi",
    bookPoint1: "30-45 phút, trực tuyến qua Google Meet hoặc gặp trực tiếp",
    bookPoint2: "Không hề gây áp lực ký hợp đồng",
    bookPoint3: "Sau buổi gặp bạn nhận bản tổng hợp trong 48 giờ",
    nextWeek: "Tuần sau",
    freeEyebrow: "Không ràng buộc · Miễn phí",
    getTitle: "Bạn nhận được gì",
    get1: "Tính toán riêng theo số liệu của bạn — miễn phí",
    get2: "Tôi sẽ liên hệ trong 24 giờ, vào lúc bạn thuận tiện",
    get3: "Không ràng buộc — quyết định luôn là của bạn",
    timeMorning: "Buổi sáng (11–13)",
    timeAfternoon: "Buổi chiều (13–17)",
    timeEvening: "Buổi tối (17–20)",
    timeAnytime: "Bất cứ lúc nào",
    privacy: "Chính sách bảo mật",
    weekdayShort: "T2,T3,T4,T5,T6,T7,CN",
    midCtaHeading: "Chỉ cần 30 phút. Không mất gì.",
    midCtaSub: "Không áp lực, không hứa hẹn. Chỉ là con số và đầu óc minh mẫn.",
    whatToExpect: "Bạn có thể mong đợi gì từ hợp tác",
    wantToDiscuss: "Bạn muốn trao đổi thêm?",
    freeConsult30: "Tư vấn 30 phút miễn phí · không ràng buộc",
    term: "Thời gian hẹn",
    inquiry: "Yêu cầu",
  },
  vizitka: { title: "Danh thiếp số", subtitle: "URL slug, mã QR, màu sắc và in danh thiếp.", slug: "URL slug", slugHelp: "3–40 ký tự, chữ thường, số, dấu gạch.", qrTitle: "URL slug & mã QR", qrSaveHint: "Lưu QR vào chữ ký email, danh thiếp, web…", print: "Tạo danh thiếp in (A4)", colors: "Màu danh thiếp", custom: "Tùy chỉnh", bg: "Nền", accent: "Nhấn", save: "Lưu danh thiếp" },
  booking: {
    pub: {
      inactive: "Cố vấn này chưa bật đặt lịch trực tuyến.",
      notFound: "Không tìm thấy cố vấn hoặc liên kết không hợp lệ.",
      loading: "Đang tải…",
      notAvailable: "Không thể đặt lịch",
      meeting: "Cuộc hẹn",
      chooseService: "Chọn loại cuộc hẹn",
      changeService: "Đổi loại cuộc hẹn",
      pickHeading: "Chọn ngày và giờ",
      pickDate: "Chọn ngày trong lịch",
      loadingSlots: "Đang tải các giờ trống…",
      noSlots: "Ngày này không còn giờ trống.",
      prevMonth: "Tháng trước",
      nextMonth: "Tháng sau",
      tzLabel: "Múi giờ",
      reservingFor: "Bạn đang đặt lịch",
      changeTime: "Đổi giờ",
      detailsHeading: "Thông tin của bạn",
      nameLabel: "Họ và tên",
      emailLabel: "E-mail",
      phoneLabel: "Điện thoại",
      noteLabel: "Bạn muốn trao đổi điều gì?",
      submitBtn: "Xác nhận đặt lịch",
      submitting: "Đang đặt lịch…",
      fillRequired: "Hãy điền họ tên và e-mail",
      badEmail: "Hãy nhập e-mail hợp lệ",
      bookingFailed: "Đặt lịch không thành công",
      gdprInfo: "Khi gửi đặt lịch, bạn cung cấp họ tên, e-mail, số điện thoại và ghi chú cho cố vấn; cố vấn lưu chúng trong hồ sơ khách hàng để chuẩn bị cho buổi hẹn và liên hệ với bạn. Bạn có thể yêu cầu xóa bất cứ lúc nào.",
      confirmedTitle: "Đã xác nhận cuộc hẹn",
      date: "Thời gian",
      sentTo: "Xác nhận đã gửi tới",
      sentNone: "Hiện chúng tôi chưa gửi được e-mail xác nhận — bạn hãy ghi lại thời gian hẹn. Cố vấn sẽ liên hệ với bạn.",
      advisorContact: "Nếu cần, hãy viết cho cố vấn tại",
      meetLink: "Liên kết Google Meet",
    },
    svc: {
      uvod15: "Giới thiệu ban đầu", uvod15d: "Làm quen nhanh, không ràng buộc — tôi là ai, tôi làm việc thế nào và chúng ta có hợp nhau không.",
      analyza45: "Phân tích tài chính", analyza45d: "Cùng xem mục tiêu, thu nhập và chi tiêu của bạn — nền tảng cho kế hoạch tài chính.",
      hypoteka: "Tư vấn vay thế chấp (hypotéka)", hypotekad: "Chúng ta tính khoản vay và so sánh đề nghị của nhiều ngân hàng.",
      servis60: "Buổi gặp bảo trì hợp đồng", servis60d: "Rà soát các hợp đồng hiện có và cập nhật kế hoạch của bạn.",
    },
    title: "Đặt lịch trực tuyến — cài đặt",
    subtitle: "Kết nối Google Calendar, đặt giờ làm việc.",
    enable: "Bật đặt lịch trực tuyến",
    embedTitle: "Hiển thị Cal.com embed trên danh thiếp",
    embedSub: "Khách hàng đặt lịch ngay trên danh thiếp (cần Calendar URL trong hồ sơ).",
    googleConnected: "Đã kết nối Google Calendar",
    connectGoogle: "Kết nối Google Calendar",
    workHours: "Giờ làm việc",
    meetingLength: "Thời lượng cuộc họp (phút)",
    buffer: "Khoảng nghỉ giữa cuộc họp (phút)",
    save: "Lưu cài đặt",
    publicLink: "Liên kết công khai",
    upcoming: "Cuộc họp sắp tới",
  },
  settings: {
    jazykAplikace: 'Ngôn ngữ ứng dụng',
    jazykNeniMena: 'Ngôn ngữ chỉ đổi phần chữ. Tiền tệ theo quốc gia (Séc → Kč, Slovakia → €), không theo ngôn ngữ.',
    menaAplikace: 'Tiền tệ của toàn ứng dụng: {kod} ({symbol}). Đổi ngôn ngữ KHÔNG đổi tiền tệ và số tiền không được quy đổi — ứng dụng không biết tỷ giá. Đổi quốc gia chỉ đổi nhãn cho các khoản nhập mới, dữ liệu cũ vẫn giữ nguyên tiền tệ ban đầu.',
    motivAktivni: 'Giao diện đang dùng: ',
    motivJenHotove: 'Chỉ những giao diện đã hoàn thiện mới xuất hiện ở đây. Elite Light đã bị gỡ và giao diện tối chưa bao giờ được làm xong.',
    motivPoznamka: ' · Giao diện là thiết lập cá nhân của bạn trên trình duyệt này, không gửi cho khách hàng. Nó KHÔNG đổi màu danh thiếp gửi khách — màu đó nằm trong Danh thiếp số.',
    oMne: 'Về tôi (hiển thị trên danh thiếp)',
    oMnePlaceholder: 'Tôi giúp mọi người đạt được tự do tài chính...',
    vzhledSub: 'Chọn giao diện ứng dụng — màu sắc đổi ngay và lựa chọn vẫn giữ sau khi tải lại trang.',
    zeme: 'Quốc gia (quyết định tiền tệ)',
    zemeCZ: 'Séc',
    zemeSK: 'Slovakia',
    title: "Cài đặt",
    profile: "Hồ sơ",
    web: "Trang web của tôi",
    webSub: "Mini-web chuyên nghiệp với đặt lịch.",
    booking: "Đặt lịch họp",
    bookingSub: "Google Calendar, giờ làm việc.",
    vizitka: "Danh thiếp số",
    vizitkaSub: "URL slug, QR, màu, in A4.",
    active: "ĐANG HOẠT ĐỘNG",
    saveProfile: "Lưu hồ sơ",
    tabZakladni: "Thông tin cơ bản", tabVzhled: "Giao diện ứng dụng", tabManazer: "Quản lý của tôi", tabSocialni: "Mạng xã hội",
    tabModelace: "Mô hình tính toán", tabVideo: "Video giới thiệu", tabStatistiky: "Thống kê", tabHeslo: "Đổi mật khẩu", tabRezervace: "Đặt lịch hẹn",
    fJmeno: "Tên *", fTelefon: "Điện thoại", fEmail: "Email công khai", fSpolecnost: "Công ty",
    stareHeslo: "Mật khẩu cũ", noveHeslo: "Mật khẩu mới", potvrditHeslo: "Xác nhận mật khẩu mới", zmenitHeslo: "Đổi mật khẩu",
    fFotka: "Ảnh cố vấn", fLogo: "Logo công ty (tùy chọn)", fEmailManazera: "Email của quản lý",
  },
  c: [
    { t: "Máy tính vay thế chấp", s: "Tính khoản trả hàng tháng và tổng lãi vay.", d: "Tìm khoản trả hàng tháng, tổng tiền lãi và phân chia gốc/lãi theo thời gian.", i: ["Số tiền vay", "Lãi suất", "Thời hạn"], o: ["Khoản trả hàng tháng", "Tổng phải trả", "Tổng tiền lãi", "Tỷ lệ lãi %"], ds: ["Gốc", "Lãi"] },
    { t: "Máy tính tái cấp vốn", s: "So sánh khoản vay cũ và mới.", d: "So sánh khoản vay hiện tại và mới. Xem khoản tiết kiệm hàng tháng và tổng.", i: ["Gốc còn lại", "Lãi suất hiện tại", "Lãi suất mới", "Thời hạn còn lại"], o: ["Tiết kiệm hàng tháng", "Tổng tiết kiệm", "Khoản trả cũ", "Khoản trả mới"], ds: ["Vay cũ", "Vay mới"] },
    { t: "Trả nợ sớm", s: "Tiết kiệm với khoản trả thêm.", d: "Tìm hiểu thời gian rút ngắn nhờ trả thêm.", i: ["Số tiền vay", "Lãi suất", "Thời hạn", "Trả thêm hàng năm"], o: ["Rút ngắn", "Tiết kiệm lãi", "Thời hạn ban đầu", "Thời hạn mới"], ds: ["Không trả thêm", "Có trả thêm"] },
    { t: "Máy tính LTV", s: "Tỷ lệ vay/giá trị tài sản.", d: "LTV cho thấy tỷ lệ khoản vay so với giá trị tài sản.", i: ["Giá trị tài sản", "Số tiền vay"], o: ["LTV", "Vốn tự có", "Đánh giá lãi suất"], ds: ["Vốn tự có", "Khoản vay"] },
    { t: "Thuê vs Mua", s: "So sánh tổng chi phí.", d: "So sánh tổng chi phí thuê và mua.", i: ["Giá tài sản", "Tiền thuê tháng", "Lãi suất vay", "Thời gian", "Tăng giá hàng năm"], o: ["Tổng chi phí thuê", "Chi phí mua ròng", "Khoản trả tháng", "Giá trị tài sản"], ds: ["Thuê (cộng dồn)", "Mua (ròng)"] },
    { t: "Đầu tư định kỳ", s: "Tăng trưởng danh mục.", d: "Đầu tư định kỳ là cách dễ tiếp cận nhất để xây dựng tài sản.", i: ["Đầu tư hàng tháng", "Lợi nhuận hàng năm", "Thời gian", "Số tiền ban đầu"], o: ["Giá trị cuối", "Tổng đã đóng", "Lãi", "Lãi %"], ds: ["Đã đóng", "Giá trị danh mục"] },
    { t: "Lãi kép", s: "Sức mạnh lãi kép.", d: "Lãi kép là kỳ quan thứ tám.", i: ["Đầu tư một lần", "Lợi nhuận hàng năm", "Thời gian"], o: ["Giá trị cuối", "Vốn ban đầu", "Tổng lợi nhuận", "Lợi nhuận %"], ds: ["Giá trị đầu tư"] },
    { t: "DCA vs một lần", s: "So sánh chiến lược.", d: "DCA là đầu tư đều đặn bất chấp thị trường.", i: ["DCA hàng tháng", "Thời gian", "Lợi nhuận trung bình", "Lãi tiết kiệm"], o: ["Kết quả DCA", "Một lần", "Tài khoản tiết kiệm", "Tổng đã đóng"], ds: ["DCA", "Một lần", "Tiết kiệm"] },
    { t: "Máy tính lạm phát", s: "Lạm phát giảm giá trị.", d: "Lạm phát giảm giá trị thực mỗi năm.", i: ["Số tiền hiện tại", "Lạm phát trung bình", "Thời gian"], o: ["Giá trị thực", "Mất sức mua", "Mất %"], ds: ["Giá trị danh nghĩa", "Giá trị thực"] },
    { t: "Máy tính FIRE", s: "Vốn cho tự do tài chính.", d: "FIRE — vốn cần cho tự do tài chính. Quy tắc 4%.", i: ["Chi tiêu tháng khi hưu", "Tuổi hiện tại", "Tuổi FIRE mục tiêu", "Lợi nhuận danh mục"], o: ["Vốn FIRE cần thiết", "Tiết kiệm hàng tháng", "Số năm đến FIRE"], ds: ["Tích lũy vốn", "Mục tiêu"] },
    { t: "Tiết kiệm theo mục tiêu", s: "Bao lâu để đạt mục tiêu.", d: "Có mục tiêu cụ thể? Xem cần bao lâu.", i: ["Số tiền mục tiêu", "Số tiền ban đầu", "Lợi nhuận hàng năm", "Tiết kiệm tháng"], o: ["Đạt mục tiêu sau", "Tổng đã đóng", "Lợi nhuận thêm"], ds: ["Tiết kiệm", "Mục tiêu"] },
    { t: "Máy tính lương hưu", s: "Bạn sẽ tích lũy bao nhiêu.", d: "Lương hưu nhà nước trung bình chỉ thay thế 40-54% lương.", i: ["Tuổi", "Tuổi nghỉ hưu", "Đóng góp tháng", "Đóng góp chủ", "Lợi nhuận quỹ"], o: ["Tổng tích lũy", "Đóng góp nhà nước", "Tiền hưu/tháng (20 năm)"], ds: ["Cá nhân", "Chủ", "Nhà nước", "Lợi nhuận"] },
    { t: "Khoảng trống lương hưu", s: "Khoảng trống lương hưu của bạn.", d: "Lương hưu nhà nước không đủ duy trì mức sống.", i: ["Thu nhập net hiện tại", "Lương hưu nhà nước", "Tuổi nghỉ hưu", "Số năm hưu"], o: ["Khoảng trống tháng", "Tổng khoảng trống", "Vốn cần thiết"], ds: ["Thu nhập hiện tại (70%)", "Lương hưu nhà nước", "Khoảng trống"] },
    { t: "Bảo hiểm nhân thọ", s: "Mức bảo hiểm khuyến nghị.", d: "Mức bảo hiểm đúng bao gồm mất thu nhập.", i: ["Thu nhập tháng", "Chi tiêu gia đình tháng", "Số tiền vay", "Số năm bảo vệ"], o: ["Bảo hiểm tử vong", "Mất sức lao động mức III", "Trợ cấp ốm/tháng"], ds: ["Bảo hiểm khuyến nghị"] },
    { t: "Tiết kiệm xây dựng", s: "Trợ cấp nhà nước.", d: "Tiết kiệm xây dựng — sản phẩm duy nhất với trợ cấp nhà nước được đảm bảo.", i: ["Đóng tháng", "Thời gian", "Lãi suất"], o: ["Số tiền cuối", "Đóng góp tự có", "Trợ cấp nhà nước", "Lợi nhuận hiệu quả p.a."], ds: ["Đóng góp", "Trợ cấp", "Lãi"] },
    { t: "Máy tính đầu tư — DIP", s: "Sản phẩm đầu tư dài hạn.", d: "DIP — sản phẩm đầu tư dài hạn được khấu trừ thuế tới 48 000 Kč mỗi năm. Quy tắc 120/60: rút sau 10 năm VÀ ở tuổi 60.", i: ["Khoản nộp hàng tháng", "Đóng góp của chủ lao động", "Thời gian đầu tư", "Lợi nhuận", "Thuế suất"], o: ["Giá trị danh mục", "Tiết kiệm thuế hàng năm", "Tổng tiết kiệm thuế", "Đóng góp của chủ lao động"], ds: ["Danh mục"] },
    { t: "Cash flow", s: "Sức khỏe cash flow tháng.", d: "Cash flow lành mạnh là nền tảng kế hoạch tài chính.", i: ["Lương net", "Thu nhập khác", "Nhà ở", "Ăn uống & sinh hoạt", "Giao thông", "Bảo hiểm", "Giải trí", "Tiết kiệm & đầu tư", "Chi phí khác"], o: ["Cash flow tự do", "Tổng thu nhập", "Tổng chi phí", "Đánh giá"], ds: ["Nhà ở", "Ăn uống", "Giao thông", "Bảo hiểm", "Giải trí", "Tiết kiệm", "Khác", "Tự do"] },
    { t: "Giá trị ròng", s: "Số quan trọng nhất của sức khỏe tài chính.", d: "Giá trị ròng = tài sản trừ nợ.", i: ["Bất động sản", "Đầu tư & quỹ", "Tiết kiệm hưu", "Tiền mặt & tiết kiệm", "Xe & khác", "Vay thế chấp (số dư)", "Vay tiêu dùng", "Nợ khác"], o: ["Giá trị ròng", "Tổng tài sản", "Tổng nợ"], ds: ["Tài sản", "Nợ"] },
    { t: "Tiết kiệm thuế", s: "Tiết kiệm thuế tối đa.", d: "Sản phẩm tài chính được thiết lập đúng có thể tiết kiệm hàng nghìn mỗi năm.", i: ["Lương gross tháng", "Bảo hiểm nhân thọ/tháng", "Tiết kiệm hưu/tháng", "Lãi vay thế chấp p.a.", "Quyên góp & khấu trừ khác"], o: ["Tiết kiệm thuế hàng năm", "Tổng khấu trừ", "Thuế không khấu trừ", "Thuế có khấu trừ"], ds: ["BH nhân thọ", "Hưu", "Lãi vay", "Quyên góp"] },
    { t: "Máy tính khoản vay — RPSN", s: "Chi phí thực của khoản vay gồm mọi khoản phí.", d: "RPSN cho thấy chi phí thực của khoản vay. Luôn so sánh RPSN.", i: ["Số tiền vay", "Lãi suất", "Phí hàng tháng", "Thời hạn"], o: ["Khoản trả tháng", "Tổng phải trả thêm", "RPSN", "Tổng phải trả"], ds: ["Gốc", "Lãi", "Phí"] },
    { t: "Điểm sức khỏe tài chính", s: "Đánh giá toàn diện.", d: "Đánh giá toàn diện tình hình tài chính ở 5 chiều.", i: ["Dự phòng tiền mặt (tháng)", "Nợ (% thu nhập)", "Tỷ lệ tiết kiệm (% thu nhập)", "Bảo hiểm", "Đầu tư"], o: ["Tổng điểm", "Hạng", "Khuyến nghị"], ds: ["Điểm của bạn"] },
  ],
  s: [null,
    { t: "Tư duy & Khởi đầu", st: "Cơ bản về kinh doanh và giá trị beplan" },
    { t: "Kế hoạch tài chính & Hệ thống", st: "Cơ bản về lập kế hoạch tài chính và CRM" },
    { t: "Quy trình bán hàng & Kỹ năng", st: "Từ cuộc gọi đầu tiên đến ký hợp đồng" },
    { t: "Sản phẩm", st: "Tổng quan các sản phẩm tài chính" },
    { t: "Tình huống thực tế", st: "Ví dụ thực từ thực tế" },
    { t: "Nâng cao", st: "Chủ đề chuyên sâu và lãnh đạo nhóm" },
  ],
  cui: {
    mortgageModeling: "Mô hình khoản vay mua nhà",
    loanSummary: "Tóm tắt khoản vay",
    amortTableTitle: "Lịch trả nợ (theo năm)",
    tableYear: "Năm",
    remaining: "Còn phải trả",
    interestOfWhich: "Trong đó là tiền lãi",
    disclaimerMortgagePdf: "Phép tính chỉ mang tính tham khảo. Đề nghị thực tế của ngân hàng có thể khác tùy theo năng lực tài chính của khách hàng, tỷ lệ LTV và điều kiện thị trường hiện tại. Mô hình này không thay thế một đề nghị cho vay có ràng buộc.",
    modelReady: "Mô hình đã sẵn sàng",
    pdfFailed: "Không tạo được PDF. Vui lòng thử lại.",
    narrativeRate: "Mức trả hằng tháng và tổng chi phí khoản vay chủ yếu do lãi suất và thời hạn cố định quyết định — nên so sánh chúng thường xuyên.",
    narrativeInterest: "Trong cả thời gian trả nợ, bạn trả tiền lãi nhiều hơn hẳn chính số tiền vay; thời hạn ngắn hơn sẽ giảm phần trả thừa.",
    live: "Tính trực tiếp",
    exportPdf: "Xuất PDF cho khách",
    mortgageHeadline: "Ngôi nhà <em>của bạn</em> sẽ tốn bao nhiêu?",
    propertyPrice: "Giá bất động sản",
    downPayment: "Vốn tự có",
    rate: "Lãi suất",
    years: "Thời gian vay",
    yearsUnit: "năm",
    monthsUnit: "tháng",
    monthlyPayment: "Khoản trả hàng tháng",
    annuitySub: "Khoản trả cố định với lãi suất cố định",
    overpayment: "Trả thêm",
    overPrincipal: "trên gốc",
    times: "×",
    loanAmount: "Số tiền vay",
    totalPaid: "Tổng phải trả",
    interestPaid: "Trong đó lãi",
    ltvLow: "LTV thấp — bạn sẽ có lãi suất tốt hơn.",
    ltvStd: "LTV chuẩn — không vấn đề với hầu hết ngân hàng.",
    ltvHigh: "Vượt giới hạn bắt buộc {limit} — cần ít nhất {castka} vốn tự có.",
    applicantAge: "Tuổi người vay",
    ltvLimit: "Giới hạn bắt buộc của {regulator}: {limit}.",
    ltvBezVeku: "Chưa có tuổi thì áp dụng giới hạn chặt hơn {limit} (dưới 36 tuổi: {mladi}).",
    principal: "Gốc",
    interest: "Lãi",
    investmentHeadline: "Tiền của bạn có thể ở đâu trong <em>X</em> năm?",
    monthlyDeposit: "Đóng góp hàng tháng",
    initialAmount: "Số tiền ban đầu",
    horizon: "Thời gian đầu tư",
    expectedReturn: "Lợi nhuận mong đợi",
    portfolioValue: "Giá trị danh mục",
    deposited: "Đã đóng góp",
    earned: "Kiếm từ lãi",
    chartLegendDeposit: "Đóng góp",
    chartLegendValue: "Giá trị danh mục",
    disclaimer: "Tính toán mang tính minh họa. Đề nghị thực tế từ ngân hàng có thể khác.",
    disclaimerInv: "Lợi nhuận quá khứ không đảm bảo cho tương lai. Tính toán minh họa.",
    investmentModeling: "Mô hình đầu tư",
    oneTimeInvest: "Đầu tư một lần",
    monthlyInvest: "Đầu tư hàng tháng",
    investHorizon: "Thời gian đầu tư dự kiến",
    riskProfile: "Hồ sơ rủi ro",
    expectedValue: "Giá trị kỳ vọng",
    expectedValueSub: "Giá trị kỳ vọng cuối kỳ đầu tư",
    optimistic: "Kịch bản lạc quan",
    pessimistic: "Kịch bản bi quan",
    totalDeposited: "Tổng đã đóng",
    today: "Hôm nay",
    yearN: "năm",
    deposit: "Khoản nộp",
    zhodnoceni: "Tăng trưởng",
    poslatKlientovi: "Gửi cho khách hàng",
    rizikoPopis: "Hồ sơ rủi ro cao hơn có thể mang lại lợi nhuận cao hơn nhưng giá trị cũng dao động mạnh hơn. Số liệu dựa trên lợi nhuận lịch sử của thị trường cổ phiếu toàn cầu.",
    narrativeInv1: "Đầu tư định kỳ tận dụng sức mạnh của lãi kép — bắt đầu càng sớm, thời gian càng làm việc cho bạn nhiều hơn.",
    narrativeInv2: "Đây là ước tính mô hình theo hồ sơ rủi ro đã chọn; lợi nhuận không được đảm bảo và giá trị khoản đầu tư dao động theo thời gian.",
  },
  webui: {
    bookNow: "Đặt lịch",
    bookFree: "Đặt buổi gặp miễn phí",
    bookMeeting: "Đặt buổi gặp",
    advisorRole: "Cố vấn tài chính của bạn",
    freeSlots: "Lịch trống trong tuần này",
    downloadFree: "Tải miễn phí",
    services: "Dịch vụ",
    scroll: "cuộn",
    readyToTalk: "Sẵn sàng trò chuyện chưa?",
    firstMeetingFree: "Buổi gặp đầu tiên miễn phí · 30 phút online",
    webNotFound: "Không tìm thấy trang hoặc trang chưa được công bố.",
    loadingError: "Lỗi tải trang",
    backHome: "Về beplan University",
    retry: "Thử lại",
    webLoadFailed: "Hiện không tải được trang. Vui lòng kiểm tra kết nối và thử lại.",
    lmEmailLabel: "Email",
    bookingMeta: "Online qua Google Meet · Miễn phí và không ràng buộc · Khoảng 30 phút",
    bookingHint: "Buổi gặp đầu tiên miễn phí. Chỉ cần chọn giờ và chuẩn bị câu hỏi của bạn.",
    bookSlotBtn: "Đặt lịch hẹn",
    // điều khiển (a11y)
    musicPlay: "Bật nhạc",
    musicMute: "Tắt tiếng nhạc",
    themeToDark: "Chuyển sang nền tối",
    themeToLight: "Chuyển sang nền sáng",
    playIntroVideo: "Phát video giới thiệu",
    whatsappWrite: "Nhắn qua WhatsApp",
    // các phần
    servicesHeading: "Tôi có thể giúp bạn những gì",
    aboutEyebrow: "Về tôi",
    dayEyebrow: "Một ngày với tôi",
    dayHeading: "Một ngày của tôi trông như thế này",
    testimonialsEyebrow: "Đánh giá",
    testimonialsHeading: "Khách hàng nói gì",
    testimonialItem: "Đánh giá",
    testimonialPrev: "Đánh giá trước",
    testimonialNext: "Đánh giá tiếp theo",
    quoteOpen: "“",
    quoteClose: "”",
    bookingEyebrow: "Đặt lịch",
    bookingHeading: "Chọn thời gian gặp",
    bookingInactive: "Đặt lịch trực tuyến chưa hoạt động. Hãy liên hệ trực tiếp với cố vấn:",
    faqHeading: "Câu hỏi thường gặp",
    partnersLabel: "Tôi hợp tác với",
    finalCtaHeading: "Cùng trò chuyện nhé",
    writeEmail: "Gửi email",
    digitalCard: "Danh thiếp số",
    privacy: "Quyền riêng tư",
    madeIn: "Được tạo trong beplan University",
    prev: "Trước",
    next: "Tiếp",
    close: "Đóng",
    storyPrev: "Câu chuyện trước",
    storyNext: "Câu chuyện tiếp theo",
    storyItem: "Câu chuyện",
    // tiến trình hợp tác
    processEyebrow: "Hợp tác diễn ra thế nào",
    processHeadingSuffix: "đến tài chính rõ ràng",
    processScrollHint: "Cuộn xuống – các thẻ trôi sang phải",
    processNextStep: "Bước tiếp theo",
    // tiếng Việt không chia số nhiều — cả ba dạng đều là „bước"
    stepOne: "bước",
    stepFew: "bước",
    stepMany: "bước",
    step1Title: "Liên hệ đầu tiên",
    step1Desc: "Chỉ cần bấm đặt lịch hoặc gọi điện. Chúng ta nói về điều bạn đang cần giải quyết.",
    step2Title: "Phân tích tình hình của bạn",
    step2Desc: "Tôi lập miễn phí bức tranh tổng thể – bạn đang ở đâu, có gì, thiếu gì.",
    step3Title: "Đề xuất kế hoạch",
    step3Desc: "Bạn nhận các bước cụ thể theo đúng tình huống – vay thế chấp (hypotéka), bảo hiểm, đầu tư.",
    step4Title: "Triển khai",
    step4Desc: "Tôi lo giấy tờ với ngân hàng và công ty bảo hiểm. Bạn cứ tập trung vào công việc của mình.",
    step5Title: "Rà soát hằng năm",
    step5Desc: "Mỗi năm một lần chúng ta cùng xem kế hoạch chạy thế nào và cần chỉnh gì.",
    // câu chuyện khách hàng
    storiesEyebrow: "Câu chuyện khách hàng",
    storiesHeading: "Tôi đã giúp họ ra sao",
    storiesSubtitle: "Tình huống cụ thể. Giải pháp cụ thể. Kết quả cụ thể.",
    storyClient: "Khách hàng",
    storyProblem: "Tình huống",
    storySolution: "Chúng tôi đã làm gì",
    storyResult: "Kết quả",
    storyCta: "Tôi muốn kết quả tương tự",
    galleryEyebrow: "Thư viện ảnh",
    galleryHeading: "Hậu trường",
    galleryPhotoAlt: "Ảnh {n}",
    blogEyebrow: "Blog",
    blogHeading: "Mẹo và góc nhìn",
    blogRead: "Đọc bài",
    blogLoading: "Đang tải…",
    blogLoadError: "Không tải được bài viết.",
    // nam châm thu hút (lead magnet)
    lmBadge: "Tải miễn phí",
    lmInstant: "Tải xuống ngay",
    lmNoSpam: "Không spam",
    lmDone: "Xong",
    lmDoneDesc: "PDF đã được tải. Hãy kiểm tra cả email của bạn.",
    lmNamePh: "Tên của bạn (tùy chọn)",
    lmEmailPh: "ten@email.cz",
    lmDownloading: "Đang tải…",
    lmDownload: "Tải PDF miễn phí",
    lmPrivacy: "Tôi chỉ dùng dữ liệu của bạn để gửi PDF. Không bao giờ spam.",
    lmInvalidEmail: "Hãy nhập email hợp lệ",
    lmSuccess: "PDF đã được tải + chúng tôi cũng gửi vào email của bạn",
    lmError: "Không tải được",
    // máy tính trên web cố vấn
    calcEyebrow: "Tính thử, không ràng buộc",
    calcHeading: "Thử các máy tính của tôi",
    calcSubtitle: "Đơn giản, nhanh, không cần đăng ký. Có câu trả lời đầu tiên trong một phút.",
    calcCompare: "So sánh",
    calcBookCta: "Tôi muốn tính chính xác tại buổi gặp",
    calcReset: "Thử số khác",
    calcDisclaimer: "Tính toán mang tính tham khảo. Con số chính xác tôi tính tại buổi gặp – miễn phí và không ràng buộc.",
    calcUnitBn: "tỷ",
    calcUnitM: "triệu",
    calcUnitK: "nghìn",
    calcUnitYears: "năm",
    calcUnitPa: "% p.a.",
    calcUnitCount: "",
    // máy tính: vay thế chấp
    calcHypoTitle: "Máy tính vay thế chấp (hypotéka)",
    calcHypoTagline: "Tính khoản trả hàng tháng",
    calcHypoHint: "Trong 60 giây bạn biết mình trả bao nhiêu",
    calcHypoAmount: "Số tiền vay",
    calcHypoRate: "Lãi suất",
    calcHypoYears: "Thời gian trả nợ",
    calcHypoSubmit: "Tính khoản trả hàng tháng",
    calcHypoResult: "Khoản trả hàng tháng của bạn sẽ là",
    calcHypoSubtitle: "Trong {years} {yearsUnit} bạn trả tổng cộng {total}",
    calcHypoContext: "Tính toán tham khảo theo khoản trả cố định đều. Lãi suất chính xác thay đổi theo LTV, năng lực trả nợ (bonita) và lãi suất hiện hành.",
    calcHypoBank: "Ngân hàng trung bình ({rate} %)",
    calcHypoMine: "Với sự hỗ trợ của tôi ({rate} %)",
    calcHypoSavings: "Tiết kiệm {amount}",
    // máy tính: đầu tư
    calcInvestTitle: "Đầu tư",
    calcInvestTagline: "Bạn kiếm được bao nhiêu trong dài hạn?",
    calcInvestHint: "Lãi kép sẽ làm bạn bất ngờ",
    calcInvestMonthly: "Mỗi tháng tôi để dành",
    calcInvestYears: "Thời gian đầu tư",
    calcInvestRate: "Lợi nhuận kỳ vọng",
    calcInvestSubmit: "Tính giá trị tương lai",
    calcInvestResult: "Sau {years} {yearsUnit} bạn sẽ có",
    calcInvestSubtitle: "Trong đó tiền bạn nộp: {deposited}",
    calcInvestContext: "Tính toán giả định lợi nhuận trung bình ổn định – thực tế sẽ khác nhau theo từng năm.",
    calcInvestBank: "Tài khoản tiết kiệm ngân hàng (2 %)",
    calcInvestInvested: "Đầu tư ({rate} %)",
    calcInvestDelta: "Nhiều hơn {amount}",
    // máy tính: bảo hiểm nhân thọ
    calcLifeTitle: "Bảo hiểm nhân thọ (životní pojištění)",
    calcLifeTagline: "Bạn thực sự cần mức bảo hiểm bao nhiêu",
    calcLifeHint: "Không trả thừa cho thứ không cần",
    calcLifeIncome: "Thu nhập ròng hàng tháng",
    calcLifeLoans: "Vay thế chấp + các khoản vay tổng cộng",
    calcLifeKids: "Số con",
    calcLifeSubmit: "Tính số tiền bảo hiểm cần thiết",
    calcLifeResult: "Số tiền bảo hiểm bạn nên có là",
    calcLifeSubtitle: "Trong trường hợp tử vong hoặc mất sức lao động vĩnh viễn",
    calcLifeContext: "Gia đình bạn sẽ trả hết các khoản nợ ({loans}), các con có tiền học ({kids}) và sống được 10 năm từ khoản tiết kiệm ({savings}). Phần lớn mọi người có mức bảo hiểm thấp hơn 10× – trả tiền cho một hợp đồng không cứu được gì.",
    // máy tính: tự do tài chính
    calcFiTitle: "Tự do tài chính",
    calcFiTagline: "Khi nào bạn có thể nghỉ hưu?",
    calcFiHint: "Quy tắc 4 % sẽ chỉ cho bạn",
    calcFiTarget: "Tôi muốn thu nhập thụ động hàng tháng",
    calcFiCurrent: "Tiết kiệm / đầu tư hiện có",
    calcFiYears: "Tôi muốn đạt được sau",
    calcFiRate: "Lợi nhuận kỳ vọng",
    calcFiSubmit: "Tính con đường đến tự do tài chính",
    calcFiResult: "Để tự do tài chính bạn cần tích lũy",
    calcFiSubtitle: "Chỉ cần mỗi tháng dành ra {monthly} trong {years} {yearsUnit}",
    calcFiSubtitleDone: "Chúc mừng – khoản tiết kiệm hiện tại của bạn tự làm được điều đó sau {years} {yearsUnit} 🎉",
    calcFiContext: "Theo quy tắc rút 4 % mỗi năm, số vốn này sẽ tạo ra {annual} mỗi năm ({monthly} mỗi tháng) gần như mãi mãi – mà không phải động vào vốn gốc.",
  },
  webtpl: {
    universal: {
      headline: "Tài chính của bạn, trong tầm kiểm soát.",
      subheadline: "Tôi giúp khách hàng sắp xếp tài chính để không còn phải lo về tương lai – vay thế chấp (hypotéka), đầu tư, bảo hiểm và hưu trí.",
      s1Title: "Vay thế chấp (hypotéka)", s1Desc: "Tôi tìm khoản vay có lợi nhất trong tất cả các ngân hàng và dẫn bạn qua toàn bộ quy trình.",
      s2Title: "Đầu tư", s2Desc: "Tôi xây danh mục phù hợp với mục tiêu và khẩu vị rủi ro của bạn.",
      s3Title: "Bảo hiểm", s3Desc: "Bảo vệ gia đình, tài sản và thu nhập. Không hợp đồng thừa.",
      s4Title: "Hưu trí", s4Desc: "Tôi chỉ cho bạn cần để dành bao nhiêu để có tuổi hưu thoải mái.",
    },
    family: {
      headline: "Tài chính cho gia đình muốn yên tâm.",
      subheadline: "Tôi chăm sóc các gia đình để họ biết rõ – cái gì đã được bảo hiểm, để dành cho con ở đâu, và làm sao hưởng tuổi hưu không lo lắng.",
      s1Title: "Bảo vệ gia đình", s1Desc: "Bảo hiểm nhân thọ và tai nạn thực sự bảo vệ – không chỉ thu tiền.",
      s2Title: "Tiết kiệm cho con", s2Desc: "Bắt đầu thế nào – và bao nhiêu là đủ – để con có chỗ dựa khi tròn 18.",
      s3Title: "Nhà ở", s3Desc: "Vay thế chấp, bảo hiểm bất động sản, tái cấp vốn.",
      s4Title: "Sức khỏe", s4Desc: "Bảo hiểm y tế tư nhân, nếu bạn muốn được chăm sóc nhanh hơn.",
    },
    mortgage: {
      headline: "Vay thế chấp không căng thẳng. Tôi lo mọi thứ thay bạn.",
      subheadline: "13+ năm kinh nghiệm. Tôi so sánh đề nghị của tất cả ngân hàng, thương lượng lãi suất và dẫn bạn từ lúc nộp đơn đến khi giải ngân.",
      s1Title: "Khoản vay thế chấp mới", s1Desc: "Từ căn hộ đến nhà riêng. Tôi lo giấy tờ thay bạn.",
      s2Title: "Tái cấp vốn (refinancování)", s2Desc: "Tiết kiệm hàng nghìn mỗi tháng khi chuyển sang ngân hàng có điều kiện tốt hơn.",
      s3Title: "Máy tính", s3Desc: "Chúng ta tính bạn vay được bao nhiêu và với lãi suất nào.",
      s4Title: "Tư vấn miễn phí", s4Desc: "Buổi gặp đầu tiên không mất gì – cùng đánh giá tình hình của bạn.",
    },
    corporate: {
      headline: "Tài chính doanh nghiệp không rườm rà.",
      subheadline: "Tôi giúp chủ doanh nghiệp và quản lý cấu trúc thù lao, phúc lợi cho nhân viên và khoản đầu tư của chính mình.",
      s1Title: "Phúc lợi cho nhân viên", s1Desc: "Hưu trí, bảo hiểm nhân thọ, phiếu ăn – tối ưu về thuế.",
      s2Title: "Thù lao cho chủ sở hữu", s2Desc: "Kết hợp tối ưu lương/cổ tức/phúc lợi cho chủ công ty s.r.o.",
      s3Title: "Đầu tư của công ty", s3Desc: "Cách sinh lời cho khoản tiền nhàn rỗi trong công ty.",
      s4Title: "Bảo hiểm trách nhiệm", s4Desc: "D&O, bảo hiểm mạng, bảo hiểm tài sản doanh nghiệp.",
    },
    investments: {
      headline: "Xây dựng tài sản. Dài hạn. Kỷ luật.",
      subheadline: "Danh mục đầu tư dựa trên dữ liệu, chi phí thấp và mục tiêu của bạn – không dựa trên lời hứa 20 % chắc chắn mỗi năm.",
      s1Title: "Danh mục toàn cầu", s1Desc: "Đa dạng hóa qua các thị trường, đồng tiền và loại tài sản.",
      s2Title: "Đầu tư theo mục tiêu", s2Desc: "Căn hộ, hưu trí, học hành của con – mỗi mục tiêu một chiến lược riêng.",
      s3Title: "Rebalancing (tái cân bằng)", s3Desc: "Bảo trì danh mục định kỳ để nó làm việc cho bạn.",
      s4Title: "Khai vấn tài chính", s4Desc: "Tôi dạy bạn cách suy nghĩ về tiền một cách hệ thống.",
    },
  },
  klienti: {
    srcDoporuceni: 'Giới thiệu',
    srcInzerat: 'Quảng cáo',
    srcJine: 'Khác',
    srcNabor: 'Tuyển dụng',
    srcNavolavka: 'Gọi điện qua Beplan',
    srcTipar: 'Qua người giới thiệu',
    srcVlastni: 'Vòng quen biết riêng',
    crm: "CRM",
    title: "Khách hàng",
    segmentace: "Phân khúc",
    segmDesc: "vàng, bạch kim, đồng, tiêu chuẩn.",
    pipelineView: "Pipeline view",
    smartOnboarding: "Smart Onboarding",
    manual: "Thêm khách hàng mới",
    advanced: "Nâng cao",
    search: "Tìm khách hàng theo tên, điện thoại, e-mail hoặc thành phố…",
    totalClients: "tổng số khách hàng",
    active: "đang hoạt động",
    signedMonth: "đã ký trong tháng này",
    pipelineFull: "Pipeline view (KPI, phễu, giai đoạn)",
    noContact: "Chưa liên hệ",
    fAll: "Tất cả",
    fActive: "Đang hoạt động",
    fStagnation: "Ngưng trệ 14+",
    fSigned: "Ký trong tháng này",
    fNoContact: "Không liên hệ 30+",
    fParked: "Không quan tâm",
    colClient: "Khách hàng",
    colPhase: "Giai đoạn",
    colDays: "Ngày",
    colBj: "BJ",
    colAction: "HÀNH ĐỘNG",
    loading: "Đang tải…",
    noClients: "Chưa có khách hàng",
    mNew: "Khách hàng mới",
    mSmartAdd: "Tôi kiểm tra trùng lặp ngay khi bạn nhập — theo tên, điện thoại, e-mail và IČO.",
    mIdent: "Định danh",
    mName: "Tên *", mSurname: "Họ", mPhone: "Điện thoại", mEmail: "Email",
    mCity: "Thành phố", mAge: "Tuổi", mIco: "IČO (tùy chọn)", mCompany: "Công ty / hộ kinh doanh (OSVČ)",
    mCheckingDup: "Đang tìm trùng lặp…",
    mSegSource: "Phân khúc và nguồn",
    mDisc: "Phân loại DISC (Pavel Procházka)",
    mRecruit: "Ứng viên tuyển dụng (vào đội cố vấn)",
    mNotePh: "Bối cảnh, nơi hai bên gặp nhau, thông tin quan trọng…",
    mCancel: "Hủy",
  },
  obchody: {
    addDealToPhase: 'Thêm giao dịch vào giai đoạn',
    addToPhase: 'Thêm vào giai đoạn',
    awaitingPayout: 'đang chờ chi trả',
    dealFew: 'giao dịch',
    dealMany: 'giao dịch',
    dealOne: 'giao dịch',
    phaseOfTotal: 'Giai đoạn {poradi}/{celkem}',
    progressLeftRight: 'Tiến trình giao dịch từ trái sang phải',
    weighted: 'trọng số',
    label: "Giao dịch",
    // tiếng Việt không chia số nhiều — cả ba dạng đều giống nhau
    caseOne: "trường hợp", caseFew: "trường hợp", caseMany: "trường hợp",
    boardPre: "Bảng", boardEm: "giao dịch",
    subtitle: "BJ trong pipeline · màu thẻ = loại sản phẩm · kéo thẻ sang Thắng/Thua/Đã hủy",
    newDeal: "Giao dịch mới",
    search: "Tìm giao dịch, khách hàng…",
    fAll: "Tất cả", fHypo: "Vay thế chấp (hypotéka)", fLoans: "Khoản vay", fInsur: "Bảo hiểm", fInv: "Đầu tư", fPension: "Hưu trí",
    fReality: "Bất động sản",
    kanban: "Kanban", table: "Bảng biểu",
    loading: "Đang tải giao dịch…",
    unknownClient: "Khách hàng không rõ",
    stale: "không hoạt động", activeDeal: "đang mở",
    modalTitle: "Trường hợp giao dịch mới", whatAbout: "Liên quan đến điều gì", clientFromCard: "Khách hàng từ thẻ",
    clientSearchPh: "Nhập tên khách hàng, điện thoại hoặc e-mail…", productType: "Loại sản phẩm *", provider: "Nhà cung cấp",
    dealName: "Tên giao dịch *", dealNamePh: "Nhập tên giao dịch", phase: "Giai đoạn", estBj: "BJ ước tính", valueCur: "Giá trị",
    note: "Ghi chú", cancel: "Hủy", create: "Tạo giao dịch", selectClient: "Chọn khách hàng", cantCreate: "Không thể tạo giao dịch",
  },
  /* Realitni obchod ve slozce klienta (components/crm/RealityVeSlozce.js
     + realitni rezim v NewDealModal). Prodavajici a kupujici maji jiny obsah,
     proto jsou popisky oddelene od `zakazky`, ktere mluvi na kartu zakazky. */
  realSlozka: {
    kterouNemovitostVolitelne: 'Bất động sản nào (không bắt buộc)',
    zatimNevybrano: 'Chưa chọn',
    otevritPoptavku: 'Mở nhu cầu',
    prodejNem: "Bán bất động sản",
    koupeNem: "Mua bất động sản",
    nadpisProdej: "Đang bán",
    nadpisKoupe: "Đang mua",
    bezAdresy: "Không có địa chỉ",
    cenaChybi: "chưa có giá",
    veFaziNeznamo: "Ở giai đoạn này — không rõ từ khi nào",
    bezObchodu: "Hồ sơ này chưa có giao dịch nên không xác định được giai đoạn.",
    koupeBezObchodu: "Chưa có giao dịch — chỉ có hợp đồng đặt cọc.",
    zajemcu: "Người quan tâm",
    pristiProhlidka: "Buổi xem gần nhất",
    zadnaProhlidka: "Chưa có lịch",
    prihlaseno: "đã đăng ký",
    majitelOdkaz: "Trang cho chủ nhà",
    majitelOdkazSub: "Chủ nhà tự xem chúng ta đang ở giai đoạn nào và đang làm gì.",
    majitelChybi: "Chưa tạo — hãy tạo trên thẻ hồ sơ.",
    odkazPropadly: "đã hết hạn",
    otevrit: "Mở",
    kopirovat: "Sao chép liên kết",
    zkopirovano: "Đã sao chép liên kết",
    nezkopirovano: "Sao chép thất bại — hãy chọn liên kết thủ công.",
    otevritZakazku: "Mở hồ sơ",
    otevritObchod: "Mở giao dịch",
    zajemciAProhlidky: "Người quan tâm và buổi xem",
    inzeratOtevrit: "Mở tin rao",
    inzeratSkryty: "Tin rao (hiện chỉ mình bạn thấy)",
    provize: "Hoa hồng bán",
    provizeNenastavena: "chưa đặt",
    postupZajemce: "Tiến trình",
    rezervace: "Hợp đồng đặt cọc",
    rezervacePodepsana: "Đã ký",
    rezervaceRozepsana: "Đã soạn, chưa ký",
    rezervaceZadna: "Chưa có",
    rezervaceSepsat: "Soạn hợp đồng đặt cọc",
    rezervaceOtevrit: "Mở hợp đồng đặt cọc",
    hypoteka: "Vay mua nhà",
    hypotekaZadna: "Chưa có hồ sơ vay",
    hypotekaZalozit: "Tạo hồ sơ vay",
    nemovitostNeznama: "Bất động sản không còn trong hệ thống",
    predani: "Chuyển giao liên hệ",
    predaniSub: "Chuyển liên hệ cho bên quản lý khác là việc xử lý dữ liệu cá nhân. Chỉ xảy ra khi có đồng ý và được ghi lại ở đây.",
    predaniTy: "Bạn",
    predaniNekdo: "Một người trong nhóm",
    predaniPoradce: "Chuyên viên",
    souhlasDan: "Đã đồng ý",
    souhlasNeznamy: "Đồng ý nhưng không ghi thời điểm",
    vzniklObchod: "Đã tạo giao dịch",
    vzniklObchodJinde: "Chuyên viên đã mở hồ sơ",
    vzniklObchodNe: "Chưa phát sinh giao dịch nào",
    odmena: "Phần chia",
    odmenaNenastavena: "Chưa đặt mức chia — chưa chọn cơ sở và tỷ lệ thì không ai biết là bao nhiêu.",
    chyba: "Phần bất động sản tải không thành công. Các giao dịch bên dưới vẫn ổn.",
    adresa: "Địa chỉ bất động sản",
    adresaPlaceholder: "Địa chỉ bất động sản — Kotlářská 12, Brno",
    adresaChybi: "Hãy nhập địa chỉ bất động sản",
    typNemovitosti: "Loại bất động sản",
    cenaNabidkova: "Giá chào bán",
    kterouNemovitost: "Bất động sản nào",
    vyberNemovitost: "Chọn bất động sản",
    zadnaNemovitost: "Bạn chưa có hồ sơ nào",
    nacitamNemovitosti: "Đang tải…",
    nemovitostiChyba: "Không tải được danh sách",
    koupePrefix: "Mua —",
    koupeFaze0: "Đã liên hệ",
    koupeFaze1: "Đã hẹn xem nhà",
    koupeFaze2: "Đã xem nhà",
    koupeFaze3: "Quan tâm nghiêm túc",
    koupeFaze4: "Đặt cọc",
    koupeFaze5: "Hợp đồng mua bán",
    koupeFaze6: "Bàn giao",
    predavkaStav: {
      navrzena: "Đã đề xuất",
      odeslana: "Đã gửi",
      prijata: "Đã nhận",
      odmitnuta: "Đã từ chối",
      propadla: "Đã quá hạn",
    },
  },
  dealmeta: {
    board: {
      analyza: "Phân tích tài chính / Đã chào",
      proces: "Đơn / Đang xử lý",
      podpis: "Phê duyệt / Ký",
      cerpani: "Giải ngân (čerpání) / Chờ hoa hồng",
    },
    products: {
      hypoteka: "Vay thế chấp (hypotéka)", refinancovani: "Tái cấp vốn (refinancování)", podnikatelsky_uver: "Vay kinh doanh",
      spotrebitelsky_uver: "Vay tiêu dùng", uver: "Khoản vay", pojisteni_zivot: "Nhân thọ", pojisteni_auta: "Ô tô",
      pojisteni_majetek: "Tài sản", investice: "Đầu tư", penzijko: "Hưu trí", stavebni: "Tiết kiệm xây dựng (stavební spoření)", jine: "Khác",
      prodej_nemovitosti: "Bán bất động sản", koupe_nemovitosti: "Mua bất động sản",
    },
  },
  /* BLOK:bilanceFlag START — generuje scratchpad/slovnik.py, ručně needitovat */
  bilanceFlag: {
    cfNegative: 'Chi phí và trả nợ vượt thu nhập {castka}/tháng',
    dstiHigh: 'Nợ cao — tiền trả nợ chiếm {pct} % thu nhập (ČNB khuyến nghị tối đa {max} %)',
    dstiHighBezRegulatora: 'Nợ cao — tiền trả nợ chiếm {pct} % thu nhập',
    kidsNoLife: 'Gia đình có con — hãy kiểm tra bảo hiểm nhân thọ (bảo vệ thu nhập)',
    reserveLow: 'Quỹ dự phòng chỉ đủ {n} tháng — lý tưởng là 6× chi phí',
    reserveMid: 'Quỹ dự phòng đủ {n} tháng — hãy bổ sung lên 6×',
    reserveOk: 'Quỹ dự phòng đủ {n} tháng ✓',
  },
  /* BLOK:bilanceFlag END */
  bilancePanel: {
    title: "Cân đối trực tiếp",
    close: "Đóng",
    netWorth: "Giá trị tài sản ròng",
    assets: "Tài sản",
    debts: "Nợ",
    zTohoFinNefin: "tài chính {fin} · phi tài chính {nefin}",
    month: "Mỗi tháng",
    income: "Thu nhập",
    expenses: "Chi tiêu",
    repayments: "Trả nợ",
    free: "Còn dư",
    deficit: "Thâm hụt",
    notEntered: "chưa nhập",
    perMonth: "/tháng",
    reserve: "Quỹ dự phòng",
    reserveUnit: "× chi phí",
    dsti: "Gánh nặng nợ (DSTI)",
    /* Země bez závazného verdiktu DSTI (SK): jiná definice než NBS — AP-08, 19. 10. 2026. */
    dstiBezRegulatora: "Trả nợ / thu nhập ròng",
    savingRate: "Tỷ lệ tiết kiệm",
    cil: {
      reserve: "khuyến nghị {cil}×",
      dsti: "ČNB khuyến nghị tối đa {max} %",
      saving: "lý tưởng {ideal} %",
    },
    stav: {
      reserveLow: "quỹ dự phòng thấp",
      reserveMid: "bổ sung lên {cil}×",
      reserveOk: "đạt",
      dstiOk: "ổn",
      dstiHigh: "vượt khuyến nghị",
      dstiHighBezRegulatora: "nợ cao",
    },
    aria: {
      jmeni: "Tài sản ròng {ciste}: tài sản {majetek}, nợ {dluhy}",
      mesic: "Mỗi tháng thu nhập {prijmy}: chi tiêu {vydaje}, trả nợ {splatky}, tiền còn dư {volne}",
      mesicSchodek: "Mỗi tháng thu nhập {prijmy}: chi tiêu {vydaje} và trả nợ {splatky} vượt thu nhập {schodek}",
    },
    chipNetWorth: "Tài sản ròng",
    chipFreeCf: "Dòng tiền tự do",
  },
  kompletnost: {
    jmeno: "Họ và tên khách hàng",
    narozeni: "Ngày sinh (tuổi)",
    kontakt: "Liên hệ (điện thoại / e-mail)",
    cil: "Ít nhất một mục tiêu có số tiền",
    prijmy: "Thu nhập hộ gia đình",
    vydaje: "Chi phí hàng tháng thường lệ",
    rezerva: "Quỹ dự phòng (tài khoản / tiền mặt)",
    investice: "Đầu tư / tiết kiệm",
    rizika: "Bảo hiểm / rủi ro",
  },
  crmdash: {
    greetMorning: "Chào buổi sáng", greetAfternoon: "Chào buổi chiều", greetEvening: "Chào buổi tối",
    kObvolani: "{n} cần gọi",
    poTerminuOne: "{n} công việc quá hạn", poTerminuFew: "{n} công việc quá hạn", poTerminuMany: "{n} công việc quá hạn",
    otevrenychUkoluOne: "{n} công việc đang mở", otevrenychUkoluFew: "{n} công việc đang mở", otevrenychUkoluMany: "{n} công việc đang mở",
    podpisuOne: "{n} hợp đồng ký tháng này", podpisuFew: "{n} hợp đồng ký tháng này", podpisuMany: "{n} hợp đồng ký tháng này",
    bezPodpisu: "tháng này chưa có hợp đồng ký", cistyStul: "Hôm nay không có gì chờ — bàn làm việc sạch.",
    cipSplneno: "Đạt kế hoạch", cipVTempu: "Đúng tiến độ", cipZbyvaBj: "Còn {n} BJ", cipBezPlanu: "Chưa có kế hoạch",
    cipPrazdnaPipeline: "Chưa có gì đang xử lý", cipPoTerminu: "{n} quá hạn", cipNicPoTerminu: "Không có gì quá hạn", cipVolno: "Không có công việc",
    metrPlneni: "Tiến độ kế hoạch BJ tháng", metrMesic: "Phần tháng đã trôi qua",
    rozvrzeni: "Bố cục", rozvrzeniKlasicke: "Cổ điển", rozvrzeniDenMesic: "Ngày → Tháng", sekceDnes: "Hôm nay", sekceMesic: "Tháng",
    monthProgress: "Tiến độ tháng", day: "ngày", of: "trên",
    kpiBj: "BJ tháng này", planNotSet: "Chưa đặt kế hoạch", plan: "Kế hoạch",
    kpiProvize: "Hoa hồng tháng", coef: "Hệ số",
    kpiPipeline: "Pipeline đang mở", openDeals: "giao dịch đang mở", contactsTotal: "tổng số liên hệ",
    kpiTasks: "Việc cần xử lý", noTasks: "Không có việc", doneOf: "đã xong trên",
    dealsPipeline: "Pipeline giao dịch", openBoard: "Mở bảng", loadingDeals: "Đang tải giao dịch…", noDeals: "Không có giao dịch", more: "khác",
    todayCalls: "Hôm nay cần gọi", upcomingTasks: "Việc sắp tới", stageDistribution: "Phân bố giai đoạn",
    leadSources: "Nguồn lead", noData: "Không có dữ liệu", pipelineByStage: "Pipeline theo giai đoạn", recentActivity: "Hoạt động gần đây",
    callAction: "Gọi", meetingAction: "Cuộc hẹn", noInterestAction: "Không quan tâm",
    funnelCalling: "Gọi điện", funnelSigned: "Ký",
    saved: "Đã lưu", saveFailed: "Không lưu được", loadFailed: "Không tải được dữ liệu CRM",
    noTasksYet: "Không có việc", noCallsToday: "Hôm nay không có ai cần gọi", inPipeline: "Trong pipeline",
    subtitle: "Tổng quan danh mục, lịch hẹn và khách hàng — ở một nơi.",
    openDiary: "Mở lịch hẹn", adviser: "Cố vấn", adviserRole: "Cố vấn",
    topClients: "Khách hàng hàng đầu theo AUM", topClientsSub: "Danh mục mạnh nhất của bạn", allClients: "Tất cả",
    kpiClients: "Khách hàng", kpiClientsHint: "Danh mục đang hoạt động", kpiVip: "VIP", kpiVipHint: "Hạng vàng",
    kpiWeek: "Tuần này", kpiWeekHint: "Cuộc hẹn đã lên lịch", kpiAum: "AUM / BJ", kpiAumHint: "Đang quản lý",
    noTopClients: "Chưa có khách hàng",
    bulkToday: "Sang hôm nay",
    bulkWeek: "Hoãn một tuần",
    bulkTodayHint: "Chuyển mọi việc quá hạn sang hôm nay",
    bulkWeekHint: "Hoãn mọi việc quá hạn thêm một tuần",
    bulkConfirmToday: "Chuyển {n} việc quá hạn sang hôm nay?",
    bulkConfirmWeek: "Hoãn {n} việc quá hạn thêm một tuần?",
    bulkRunning: "Đang chuyển…",
    bulkDoneOne: "Đã chuyển {n} việc",
    bulkDoneFew: "Đã chuyển {n} việc",
    bulkDoneMany: "Đã chuyển {n} việc",
    bulkPartial: "Đã chuyển {ok}, {err} thất bại",
    bulkFailed: "Không chuyển được",
  /* PANELY NÁSTĚNKY — dřív mapy PANEL_*_SK v pages/crm/CRMDashboardPage.js,
     které uměly jen cs+sk (Vietnamec i Ukrajinec dostal češtinu). */
  panelKat: {
    vse: 'Tất cả',
    prehledy: 'Tổng quan nhanh',
    obchod: 'Giao dịch',
    klienti: 'Khách hàng & dịch vụ',
    nastroje: 'Công cụ',
  },
  panel: {
    zrcadlo: {
      title: 'Nhật ký cuộc gọi — hôm nay gọi cho ai',
      desc: 'Hàng đợi gọi: ai chờ lâu nhất, đến từ đâu, gọi bằng một cú nhấp.',
      helpLabel: 'Nhật ký cuộc gọi',
      helpText: 'Ai đang chờ được gọi — cùng hàng đợi như trang Nhật ký cuộc gọi, chỉ rút gọn. Phía trên là số người đang chờ, bên dưới là năm người chờ lâu nhất (chờ lâu nhất đứng đầu), mỗi người kèm nguồn lead và số điện thoại. Gọi sẽ mở điện thoại, Đã hẹn chuyển liên hệ sang giai đoạn Giới thiệu và nó biến mất khỏi hàng đợi.',
    },
    brifink: {
      title: 'Tóm tắt buổi sáng',
      desc: 'Hôm nay có gì · quá hạn gì · đã xong gì · sắp tới gì.',
      helpLabel: 'Tóm tắt buổi sáng',
      helpText: 'Bốn câu hỏi ở một chỗ: hôm nay có gì, quá hạn gì, đã xong gì, sắp tới gì. Mỗi mục hiển thị khách hàng và giao dịch liên quan. Tất cả lấy từ lịch, khách hàng và giao dịch — nếu không có gì, mục sẽ báo. Ở mỗi mục: + thêm vào kế hoạch, đồng hồ hoãn lại sau, × xoá khỏi tóm tắt hôm nay.',
    },
    diar: {
      title: 'Lịch — tuần',
      desc: 'Cuộc hẹn và công việc cả tuần ở một chỗ.',
      helpLabel: 'Lịch — tuần',
      helpText: 'Cuộc hẹn và công việc của cả tuần. Số bên cạnh ngày = số công việc; nhấp để mở lịch.',
    },
    radar: {
      title: 'Radar dịch vụ',
      desc: 'Khách hàng sắp đến kỳ gặp dịch vụ.',
      helpLabel: 'Radar dịch vụ',
      helpText: 'Khách hàng sắp hết kỳ cố định lãi suất, đến ngày kỷ niệm hợp đồng hoặc đáo hạn — ai cần liên hệ để phục vụ.',
    },
    prilezitosti: {
      title: 'Radar cơ hội',
      desc: 'Khoảng trống trong danh mục và cơ hội để tiếp cận.',
      helpLabel: 'Radar cơ hội',
      helpText: 'Khoảng trống trong danh mục của khách hàng, sắp xếp theo điểm — nơi có cơ hội tiếp cận lớn nhất.',
    },
    kpi: {
      title: 'Thẻ KPI',
      desc: 'Số liệu chính của tháng: BJ, hoa hồng, pipeline, công việc.',
      helpLabel: 'Thẻ KPI',
      helpText: 'Số liệu chính của tháng (BJ, hoa hồng, pipeline, công việc). Nhấp vào thẻ để mở chi tiết trong Giao dịch hoặc Lịch.',
    },
    pipeline: {
      title: 'Pipeline giao dịch',
      desc: 'Giao dịch chia theo giai đoạn pipeline.',
      helpLabel: 'Pipeline giao dịch',
      helpText: 'Giao dịch đang mở theo giai đoạn (phân tích → giải ngân) kèm dự báo hoa hồng có trọng số. Nhấp → Giao dịch.',
    },
    akce: {
      title: 'Cần xử lý hôm nay',
      desc: 'Việc gấp hôm nay đang chờ bạn xử lý.',
      helpLabel: 'Cần xử lý hôm nay',
      helpText: 'Hàng đợi hôm nay: công việc quá hạn và giao dịch chưa có bước tiếp theo. Nhấp → chi tiết.',
    },
    volani: {
      title: 'Hôm nay cần gọi',
      desc: 'Các liên hệ cần gọi hôm nay.',
      helpLabel: 'Hôm nay cần gọi',
      helpText: 'Liên hệ cần gọi theo thứ tự ưu tiên VIP → A → B → C. Nút: điện thoại = gọi · ✓ đã hẹn gặp · ✗ không quan tâm.',
    },
    ukoly: {
      title: 'Việc sắp tới',
      desc: 'Các việc gần nhất sắp xếp theo hạn.',
      helpLabel: 'Việc sắp tới',
      helpText: 'Các việc chưa hoàn thành gần nhất theo hạn. Nhấp → Lịch.',
    },
    emaily: {
      title: 'Email',
      desc: 'Email chưa đọc ngay trên bảng điều khiển.',
      helpLabel: 'Email',
      helpText: 'Các email chưa đọc mới nhất từ Gmail đã kết nối. Nhấp → Thư.',
    },
    klienti: {
      title: 'Hoạt động gần đây của khách hàng',
      desc: 'Thay đổi mới nhất ở khách hàng của bạn.',
      helpLabel: 'Khách hàng',
      helpText: 'Khách hàng vừa được chỉnh sửa — truy cập nhanh vào hồ sơ. Nhấp → Khách hàng.',
    },
    topklienti: {
      title: 'Khách hàng hàng đầu theo AUM',
      desc: 'Khách hàng giá trị nhất theo quy mô tài sản.',
      helpLabel: 'Khách hàng hàng đầu theo AUM',
      helpText: 'Khách hàng giá trị nhất theo quy mô tài sản (BJ). Nhấp → Khách hàng.',
    },
    faze: {
      title: 'Phân bố giai đoạn',
      desc: 'Phân bố liên hệ theo giai đoạn giao dịch.',
      helpLabel: 'Phân bố giai đoạn',
      helpText: 'Số liên hệ ở từng giai đoạn giao dịch — chỗ nào công việc đang dồn lại.',
    },
    zdroje: {
      title: 'Nguồn lead',
      desc: 'Lead đến với bạn nhiều nhất từ đâu.',
      helpLabel: 'Nguồn lead',
      helpText: 'Liên hệ đến với bạn nhiều nhất từ đâu (công cụ tạo lead, giới thiệu, web…).',
    },
    nastroje: {
      title: 'Công cụ nhanh',
      desc: 'Lối tắt nhanh đến các máy tính và công cụ.',
      helpLabel: 'Công cụ nhanh',
      helpText: 'Lối tắt đến các máy tính và công cụ, chia theo danh mục.',
    },
    poznamky: {
      title: 'Ghi chú',
      desc: 'Tờ giấy trắng cho ghi chú nhanh có gắn nhãn.',
      helpLabel: 'Ghi chú',
      helpText: 'Tờ giấy trắng cho mọi thứ — văn bản tự lưu. Dùng nhãn để phân loại ghi chú và lọc theo nhãn ở phía trên.',
    },
    vyvoj: {
      title: 'Diễn biến giao dịch',
      desc: 'Diễn biến các giao dịch đã chốt theo thời gian.',
      helpLabel: 'Diễn biến giao dịch',
      helpText: 'Giao dịch đã chốt theo thời gian — xu hướng BJ đã ký theo tháng. Đổi kỳ bằng các nút.',
    },
    plan: {
      title: 'Tiến độ kế hoạch',
      desc: 'Bạn đang gần kế hoạch BJ tháng đến đâu.',
      helpLabel: 'Tiến độ kế hoạch',
      helpText: 'Bạn đang gần kế hoạch BJ tháng đến đâu; kim chỉ % hoàn thành và ước tính hoa hồng.',
    },
    trychtyr: {
      title: 'Phễu bán hàng',
      desc: 'Bạn đang có bao nhiêu ở từng giai đoạn.',
      helpLabel: 'Phễu bán hàng',
      helpText: 'Bạn có bao nhiêu giao dịch và BJ ở từng giai đoạn và trung bình chúng nằm ở đó bao lâu.',
    },
  },
  },
  /* BLOK:diar START — generuje scratchpad/slovnik.py, ručně needitovat */
  diar: {
    activity: 'Hoạt động',
    agenda: 'Danh sách',
    agendaSub: 'Danh sách hoạt động',
    agendaTitle: 'Sắp tới',
    allDay: 'Cả ngày',
    calls: 'cuộc gọi',
    dFri: 'T6',
    dMon: 'T2',
    dSat: 'T7',
    dSun: 'CN',
    dThu: 'T5',
    dTue: 'T3',
    dWed: 'T4',
    day: 'Ngày',
    days: 'ngày',
    editActivity: 'Sửa hoạt động',
    filters: 'Bộ lọc',
    hintKlik: 'Nhấp vào lưới',
    hintKlikZbytek: 'để tạo nhanh một sự kiện.',
    hintTah: 'Kéo thả',
    hintTahZbytek: 'để di chuyển, kéo mép dưới để đổi độ dài.',
    m01: 'Tháng 1',
    m02: 'Tháng 2',
    m03: 'Tháng 3',
    m04: 'Tháng 4',
    m05: 'Tháng 5',
    m06: 'Tháng 6',
    m07: 'Tháng 7',
    m08: 'Tháng 8',
    m09: 'Tháng 9',
    m10: 'Tháng 10',
    m11: 'Tháng 11',
    m12: 'Tháng 12',
    meetings: 'cuộc hẹn',
    month: 'Tháng',
    monthOverview: 'Tổng quan tháng',
    newActivity: 'Hoạt động mới',
    nextWeek: 'Tuần sau',
    prevWeek: 'Tuần trước',
    refreshed: 'Đã làm mới lịch',
    sync: 'Đồng bộ',
    tDopis: 'Thư',
    tEmail: 'Email',
    tSchuzka: 'Cuộc hẹn',
    tTelefonat: 'Cuộc gọi',
    tUdalost: 'Sự kiện',
    tUkol: 'Nhiệm vụ',
    tasks: 'công việc',
    tip: 'Mẹo',
    today: 'Hôm nay',
    week: 'Tuần',
    weekNo: 'tuần',
  },
  /* BLOK:diar END */
  hypo: {
    active: "Đang xử lý", waitOdhad: "Chờ định giá (odhad)", naKatastru: "Ở cơ quan địa chính (katastr)", blizkoCerpani: "Sắp giải ngân", cerpanoMesic: "Đã giải ngân (tháng)",
    search: "Tìm khoản vay thế chấp…", colClient: "Khách hàng", colBank: "Ngân hàng", colPhase: "Giai đoạn xử lý", colWaiting: "Chờ", colNextStep: "Bước tiếp theo", aiWatch: "AI THEO DÕI", colAmount: "Số tiền / LTV", loading: "Đang tải khoản vay…", shown: "Hiển thị", activeMortgages: "khoản vay thế chấp đang xử lý",
  },
  deal: {
    notFound: "Không tìm thấy giao dịch", dealValue: "Giá trị giao dịch", caseProgress: "Tiến độ hồ sơ",
    save: "Lưu", edit: "Sửa", nextStep: "Bước tiếp theo của hồ sơ",
    subject: "Đối tượng", price: "Giá", ownFunds: "Vốn tự có", note: "Ghi chú",
    purchasePrice: "Giá mua", ownResources: "Nguồn vốn tự có", monthlyPayment: "Khoản trả hàng tháng",
    keyParam: "Tham số chính", keyPh: "Khóa (vd. LTV)", valuePh: "Giá trị",
    people: "Những người trong hồ sơ", addRole: "Thêm nhanh vai trò",
    resWon: "Thắng", resLost: "Thua", resCancelled: "Đã hủy", resOpen: "Đang xử lý",
    cantSave: "Không thể lưu", cantChangeStage: "Không thể đổi giai đoạn", cantAddNote: "Không thể thêm ghi chú",
    cantWin: "Không thể xác nhận thắng", error: "Lỗi", cancelled: "Đã hủy", deleted: "Đã xóa",
    roleRealitni: "Môi giới bất động sản", roleProdejce: "Người bán", roleKupujici: "Người mua", roleOdhadce: "Người định giá (odhadce)",
    roleBanker: "Nhân viên ngân hàng", rolePravnik: "Luật sư / công chứng viên", roleDruhyKlient: "Khách hàng thứ hai", roleDeveloper: "Chủ đầu tư", roleHlavniKlient: "Khách hàng chính", rolePlaceholder: "Vai trò (vd. Nhân viên ngân hàng)", roleSystemovaHint: "Vai trò này do hệ thống giữ — không thể sửa.",
  },
  tools: {
    /* Nástroje ke schůzce — dlaždice na /nastroje. Bez těchhle klíčů by
       titulek i popis zůstaly česky ve všech jazycích (fallback). */
    "kalk-zlato": { t: "Vàng — khách còn lại bao nhiêu", d: "Tháng nào có gram đầu tiên, phí và chênh lệch mua/bán ăn mất bao nhiêu, rủi ro tỷ giá đô la tách riêng, và so sánh với tài sản khác. Có cả chỉ và lượng.", short: "Gram, phí và tỷ giá đô la" },
    "kalk-konsolidace": { t: "Gộp nợ (konsolidace)", d: "Tổng phải trả bây giờ so với tổng sau khi gộp — không so hai khoản trả góp. Tính ngược lãi suất từng khoản vay và cho thấy cả khi gộp nợ KHÔNG có lợi.", short: "Tổng bây giờ so với tổng sau" },
    "kalk-podpojisteni": { t: "Bảo hiểm thiếu cho cửa hàng", d: "Bảo hiểm thật sự trả bao nhiêu khi số tiền bảo hiểm thấp hơn giá trị tài sản (§ 2854). Có cả cao điểm hàng hóa trước Tết và Giáng sinh.", short: "Bảo hiểm thật sự trả bao nhiêu" },
    "kalk-doplaceni": { t: "Trả hết thế chấp sớm", d: "Trả thêm vào khoản vay so với đầu tư, trên cùng một dòng tiền. Biểu đồ hai đường và điểm cắt, ba con số cho khách, kịch bản „thị trường không cho gì“ và bảo hiểm giảm dần. Có chế độ trình bày cho buổi gặp.", short: "Trả thêm hay đầu tư?" },
    provize: { t: "Máy tính hoa hồng", d: "201 sản phẩm từ danh mục BJ. Nhập vị trí và sản phẩm → hoa hồng năm đầu và hoa hồng lặp lại. Cho cố vấn và cho tuyển dụng.", short: "201 sản phẩm từ danh mục BJ" },
    analyza: { t: "Phân tích tài chính", d: "Buổi gặp 45 phút có dẫn dắt — giá trị, mục tiêu, nguồn lực, rủi ro. Kịch bản dẫn cả người mới. Chọn khách hàng hoặc tạo khách mới.", short: "Buổi gặp 45 phút có dẫn dắt từ A đến Z" },
    posta: { t: "Hộp thư + AI Email", d: "Gmail của bạn ngay trong CRM. Lệnh bằng giọng nói hay văn bản → AI soạn email và gửi. Chiến dịch AI hàng loạt.", short: "Gmail trong CRM + email AI" },
    leadgen: { t: "Leadovač", d: "15 phễu thu khách hàng tiềm năng — Vay mua nhà, Đầu tư, Hộ kinh doanh, Gia đình và nhiều nữa. Chia sẻ liên kết, nhận khách vào CRM.", short: "15 phễu thu khách → CRM" },
    trychtyre: { t: "Phễu bán hàng", d: "15 trang đích phễu làm sẵn (giá trị miễn phí → liên hệ). Xem trước, sao chép liên kết của bạn, chia sẻ. Khách hàng tiềm năng rơi vào CRM.", short: "15 trang đích phễu để chia sẻ" },
    "funnel-knihovna": { t: "Thư viện phễu", d: "53 phễu làm sẵn đầy đủ: nội dung trang đích, chuỗi e-mail, quảng cáo, ebook, kịch bản hội thảo và cuộc gọi. Kèm biểu mẫu biến câu trả lời của bạn thành đề bài cho phễu mới.", short: "53 phễu + trình tạo đề bài" },
    mesicnik: { t: "Bản tin tháng cho khách hàng", d: "Gửi số bản tin đã phát hành cho khách hàng đã đồng ý nhận tiếp thị: xem trước email và bản web, hủy đăng ký một cú nhấp. Dữ liệu từ ČNB, ECB và các nguồn công khai khác.", short: "Bản tin tháng cho khách" },
    "byznys-plan": { t: "Kế hoạch kinh doanh của tôi", d: "Kế hoạch năm của tư vấn viên theo mẫu khóa học: số liệu năm ngoái từ CRM, tầm nhìn, mục tiêu kinh doanh và cá nhân, tiếp thị, mục tiêu tháng có phần thưởng, thói quen hằng ngày, ngày rà soát. Lưu trên máy chủ, in A4.", short: "Tầm nhìn, mục tiêu, tiếp thị, kế hoạch tháng" },
    trychtyrBuilder: { t: "Phễu bán hàng từ A đến Z", d: "Hướng dẫn 7 bước theo phương pháp Konverzky: mồi thu hút, trang đích, trang cảm ơn, kịch bản gọi điện, mini-webinar, chuỗi e-mail, quảng cáo và đo lường (pixel). Mẫu điền sẵn không dùng AI, lưu cho bạn; trang thu lead, phễu và website có sẵn chỉ cần nối vào.", short: "7 bước: mồi thu hút → pixel" },
    "fin-matematika": { t: "Toán tài chính", d: "Khoản vay / Thế chấp, Đầu tư và Thu nhập. Lá cờ = tính ra bất kỳ ô nào. Biểu đồ lớn, kiểm tra, tần suất nhập lãi.", short: "Khoản vay, đầu tư, thu nhập — tính ngược" },
    penze: { t: "Máy tính hưu trí (DPS/DIP)", d: "Quỹ hưu trí và DIP: mô phỏng tương lai có hỗ trợ nhà nước và thuế, máy tính lịch sử trên lợi nhuận thực của các quỹ, so sánh quỹ và kế hoạch niên kim.", short: "DPS + DIP, lịch sử, quỹ, niên kim" },
    izp: { t: "Phân tích cho người Việt", d: "Giải thích cho khách vì sao cần bảo hiểm nhân thọ: thu nhập, gói 10/20/30 %, rủi ro, biểu đồ đến 60/65/70 tuổi, gia đình nhận gì và còn lại bao nhiêu.", short: "Bảo hiểm và đầu tư, từng bước" },
    "zivotni-pojisteni": { t: "Bảo hiểm nhân thọ", d: "Mức bảo vệ khuyến nghị trong vài giây: tử vong, mất sức lao động, nghỉ ốm, di chứng vĩnh viễn, bệnh hiểm nghèo. Dễ bán ngay cả với người mới.", short: "Mức bảo vệ khuyến nghị trong vài giây" },
    "rodinny-plan": { t: "Kế hoạch tài chính gia đình (CZ/VI)", d: "Mười lăm phút với khách: thu nhập → chi tiêu → còn lại bao nhiêu → điều gì xảy ra khi mất thu nhập → cần bao nhiêu bảo vệ và bao nhiêu cho tài sản. Song ngữ tiếng Séc và tiếng Việt, có chế độ trình bày cho khách. Không bắt đầu bằng sản phẩm.", short: "Mười lăm phút với khách" },
    historicka: { t: "Máy tính lịch sử", d: "Dùng dữ liệu thật 1926–2026 để cho khách hàng thấy khoản đầu tư sẽ ra sao. S&P 500, trái phiếu, vàng, lạm phát.", short: "Dữ liệu thật 1926–2026" },
    "svoboda": { t: 'Khi nào bạn được tự do', d: 'Tiền được quy đổi thành thời gian. Thay vì nghe năm phần trăm trên lạm phát, khách hàng nghe được sớm hơn bao nhiêu năm thì không còn bắt buộc phải đi làm. Kéo thanh trượt và dấu trên trục chạy sang trái. Kèm cái giá của việc chờ đợi.', short: 'Tiền quy đổi thành thời gian' },
    "hypoteka-rozhodnuti": { t: 'Vay mua nhà — bốn quyết định', d: 'Hết kỳ cố định, 20 hay 30 năm, bỏ bao nhiêu tiền tự có, thời gian làm gì. So sánh toàn bộ gánh nặng hằng tháng chứ không chỉ khoản trả góp — vì thế kết quả thường ngược với điều khách hàng nghĩ. Mỗi thẻ kết thúc bằng một câu.', short: 'Kỳ cố định, thời hạn, tiền tự có' },
    fixace: { t: 'Kỳ cố định trong tầm kiểm soát', d: 'Điều gì xảy ra SAU kỳ cố định. Kỳ ngắn và kỳ dài trên cùng một trục, khoản trả góp đặt cạnh ngân sách gia đình, và một con số: mức lãi suất mà vượt qua nó là vỡ. Dựa trên lãi suất thực của Ngân hàng Quốc gia Séc 2006–2026 — kèm tần suất lãi suất thực sự nhảy vọt sau khi tái cố định.', short: 'Điều gì xảy ra sau kỳ cố định' },
    "renta-porovnavac": { t: "Rút thu nhập hưu trí — ba cách", d: "Khách hàng nhận bao nhiêu mỗi tháng với tỷ lệ cố định, trung bình trượt và lan can an toàn. Cái giá cũng hiện rõ: khi nào và phải giảm bao nhiêu. Danh mục học hỏi từ Quỹ Nobel, dẫn chứng bằng năm 1966 và 2000.", short: "Cố định % vs. trung bình vs. lan can" },
    "investicni-strategie": { t: "Chiến lược đầu tư", d: "Các quỹ lớn nhất và người giàu nhất đầu tư thế nào — Quỹ Na Uy, Quỹ Nobel, Ray Dalio, Core-Satellite. Cho khách hàng + lãi kép và thu nhập vô hạn.", short: "Các quỹ lớn nhất đầu tư thế nào" },
    "srovnavac-fondu": { t: "So sánh quỹ", d: "So sánh hai quỹ/ETF — phí lấy đi bao nhiêu phần lợi nhuận. Danh mục ETF và các quỹ Séc, biểu đồ, chênh lệch bằng tiền. Cho khách hàng, không cần AI.", short: "Hai quỹ và phần phí lấy đi" },
    "portfolio-doktor": { t: "Bác sĩ danh mục", d: "Toàn bộ danh mục của khách hàng cùng lúc: chi phí bình quân gia quyền (và tính từ bao nhiêu % tài sản), khoản chênh lệch trong cả kỳ hạn, phân bổ, kết luận cho từng mục — kể cả „giữ nguyên“. Chi phí bạn nhập từ KID, ứng dụng không tự nghĩ ra gì.", short: "Chi phí của toàn bộ danh mục" },
    "investicni-studio": { t: "Studio đầu tư (DEMO)", d: "Bài trình bày đào tạo cho khách hàng: HWM Lab (phí theo hiệu quả), Hôm nay so với đề xuất, Portfolio Composer, các cuộc khủng hoảng trong lịch sử, phân rã chi phí. Khách hàng mẫu, không phải lời khuyên cá nhân.", short: "Bài trình bày đào tạo cho khách hàng" },
    "nemovitost-pronajem": { t: "Bất động sản cho thuê", d: "Một căn hộ cho thuê THỰC SỰ mang lại bao nhiêu — dòng tiền theo thời gian, bao nhiêu năm bạn phải bù, lợi suất thực, kiểm tra sức chịu đựng. Phá vỡ hình dung màu hồng của khách hàng.", short: "Căn hộ cho thuê mang lại bao nhiêu" },
    calculators: { t: "Máy tính", d: "20 máy tính tài chính — vay mua nhà, đầu tư, bảo hiểm, hưu trí, tài chính cá nhân.", short: "20 máy tính tài chính" },
    "portfolio-doctor": { t: "Portfolio Doctor", d: "Chẩn đoán danh mục của khách hàng — ISIN → phương án ETF thay thế + bản tóm tắt AI.", short: "ISIN → phương án ETF + tóm tắt AI" },
    "akademie-produkty": { t: "Học viện sản phẩm cho người mới", d: "10 mô-đun: sản phẩm, gọi điện, lập luận, chốt hợp đồng — kèm câu hỏi và kịch bản. Từ người mới thành chuyên nghiệp.", short: "10 mô-đun kèm câu hỏi và kịch bản" },
    akademie: { t: "Học viện cố vấn (video)", d: "Loạt video đào tạo — Tư duy, Kế hoạch tài chính, Quy trình bán hàng và nhiều nữa.", short: "Loạt video đào tạo" },
    income: { t: "Thu nhập mục tiêu", d: "Tính ngược từ thu nhập mong muốn ra số buổi gặp và số cuộc gọi.", labels: ["Thu nhập mong muốn hàng tháng","Hoa hồng trung bình/hợp đồng","Chuyển đổi buổi gặp → hợp đồng","Chuyển đổi cuộc gọi → buổi gặp"], funnel: ["Cuộc gọi mỗi ngày","Cuộc gọi mỗi tháng","Buổi gặp mỗi tháng","Hợp đồng mỗi tháng"] },
    objections: { t: "Phản đối & câu trả lời", d: "Nhấp vào thẻ để xem câu trả lời gợi ý.", q: ["Tôi không quan tâm","Tôi đã có cố vấn","Tôi không có thời gian","Tôi không có tiền","Gửi email cho tôi","Tôi phải hỏi ý vợ/chồng","Tôi tự làm được","Hợp đồng của tôi vẫn ổn","Bây giờ chưa phải lúc","Sao anh biết mình tốt hơn?"], a: ["Tôi hiểu. Cho tôi hỏi chính xác điều gì khiến anh/chị thấy không thú vị?","Tuyệt vời! Cố vấn của anh/chị rà soát kế hoạch tài chính bao lâu một lần?","Tôi hiểu, thời gian rất quý. Tôi đề nghị một buổi gặp hiệu quả 45 phút.","Chính vì vậy mà nên gặp nhau. Chúng tôi giúp tìm khoản tiết kiệm trong các hợp đồng hiện có.","Tôi sẽ gửi. Tuy nhiên mỗi tình huống một khác. Chúng ta gặp nhau 30 phút được không?","Tất nhiên! Cả hai anh chị sẽ cùng dự — quyết định nên là quyết định chung.","Tôi tôn trọng điều đó. Anh/chị biết là người không có cố vấn mỗi năm mất trung bình 15–30 nghìn không?","Tuyệt vời! Lần cuối anh/chị rà soát là khi nào? Thị trường luôn thay đổi.","Tôi hiểu. Khi nào thì tiện hơn? Tôi sẽ liên hệ lại.","Chúng tôi không nhận mình là tốt nhất. Sức mạnh của chúng tôi là cách tiếp cận toàn diện."] },
    checklist: { t: "Danh sách kiểm tra buổi gặp A1", d: "Checklist đầy đủ cho buổi gặp đầu tiên.", cols: ["Trước buổi gặp","Trong buổi gặp","Sau buổi gặp"], before: ["Chuẩn bị bài trình bày","Kiểm tra dữ liệu trong CRM","Chuẩn bị hợp đồng để ký","Xác nhận khách hàng có mặt","Chuẩn bị danh thiếp và tài liệu","Đặt báo thức/nhắc nhở"], during: ["Phá băng và xây dựng quan hệ","Tìm hiểu kỳ vọng của khách hàng","Giới thiệu beplan","Phân tích tài chính (7 lĩnh vực)","Trình bày giải pháp","Thống nhất bước tiếp theo","Xin giới thiệu thêm khách hàng"], after: ["Ghi chú vào CRM","Gửi email tóm tắt","Chuẩn bị dự thảo hợp đồng","Lên lịch follow-up","Cập nhật pipeline"] },
    timer: { t: "Đồng hồ buổi gặp", d: "Đồng hồ 5 giai đoạn cho buổi gặp có cấu trúc.", phases: ["Phá băng","Tìm hiểu kỳ vọng","Giới thiệu","Nguyên tắc toàn diện","Kết thúc và hẹn lịch"] },
    pyramid: { t: "Kim tự tháp tài chính cá nhân", d: "Nhấp vào từng tầng để xem chi tiết.", layers: [{ n: "Đầu tư", d: "Chủ động xây dựng tài sản — cổ phiếu, quỹ, bất động sản." },{ n: "Nhu cầu khác", d: "Tài khoản tiết kiệm, tiết kiệm xây dựng (stavební spoření), tiết kiệm có mục đích." },{ n: "Nhà ở", d: "Nhà ở của chính mình hoặc đầu tư bất động sản." },{ n: "Thu nhập tương lai (hưu trí)", d: "Trụ cột III của hệ thống hưu trí (DPS) có trợ cấp nhà nước." },{ n: "Bảo đảm thu nhập", d: "Bảo hiểm nhân thọ, bảo hiểm tai nạn, trợ cấp ốm đau." }] },
    compare: { t: "So sánh sản phẩm", d: "So sánh các sản phẩm tài chính cạnh nhau." },
    glossary: { t: "Từ điển thuật ngữ", d: "Từ điển thuật ngữ tài chính có thể tìm kiếm." },
  },
  g: [
    { t: "RPSN", d: "Tỷ lệ phần trăm chi phí hằng năm — cho thấy giá thực của khoản vay gồm mọi khoản phí.", e: "Ngân hàng chào lãi suất 5 %, nhưng RPSN là 6,2 % do các khoản phí." },
    { t: "LTV", d: "Loan to Value — tỷ lệ giữa số tiền vay và giá trị bất động sản.", e: "Mua căn hộ 5 triệu Kč với khoản vay 4 triệu Kč thì LTV là 80 %." },
    { t: "Mất sức lao động mức I (invalidita 1. stupně)", d: "Khả năng lao động giảm 35–49 %. Được hưởng lương hưu mất sức lao động một phần.", e: "Khách hàng mắc bệnh mạn tính, vẫn làm việc bán thời gian được." },
    { t: "Mất sức lao động mức II (invalidita 2. stupně)", d: "Khả năng lao động giảm 50–69 %.", e: "Khách hàng sau tai nạn nặng, chỉ làm được việc nhẹ." },
    { t: "Mất sức lao động mức III (invalidita 3. stupně)", d: "Khả năng lao động giảm từ 70 % trở lên. Lương hưu mất sức lao động toàn phần.", e: "Khách hàng không còn khả năng làm bất kỳ công việc nào." },
    { t: "DPS", d: "Doplňkové penzijní spoření — tiết kiệm hưu trí bổ sung, trụ cột III có trợ cấp nhà nước.", e: "Tiết kiệm 1 000 Kč mỗi tháng thì được nhà nước trợ cấp 230 Kč." },
    { t: "Quỹ chuyển đổi (transformovaný fond)", d: "Các quỹ hưu trí cũ có bảo đảm lợi nhuận không âm.", e: "Bảo hiểm hưu trí bổ sung cũ ký trước năm 2013." },
    { t: "Biến động (volatilita)", d: "Mức dao động giá trị khoản đầu tư theo thời gian.", e: "Cổ phiếu biến động mạnh hơn trái phiếu." },
    { t: "Đa dạng hóa (diverzifikace)", d: "Phân bổ đầu tư vào nhiều tài sản để giảm rủi ro.", e: "Đầu tư đồng thời vào cổ phiếu, trái phiếu và bất động sản." },
    { t: "Lãi kép (složené úročení)", d: "Lãi được cộng vào vốn gốc và tiếp tục sinh lãi.", e: "100 000 Kč với 7 % p.a. sau 20 năm = 386 968 Kč." },
    { t: "Cash flow", d: "Dòng tiền — chênh lệch giữa thu nhập và chi tiêu trong một kỳ.", e: "Thu nhập tháng 55 000 Kč trừ chi tiêu 42 000 Kč = cash flow tự do 13 000 Kč." },
    { t: "Kế hoạch tài chính (finanční plán)", d: "Tài liệu tổng thể mô tả tình hình tài chính của khách hàng và đề xuất giải pháp tối ưu.", e: "Kế hoạch bao gồm bảo hiểm, đầu tư, tiết kiệm và hưu trí." },
    { t: "Sự kiện bảo hiểm (pojistná událost)", d: "Sự kiện ngẫu nhiên thuộc phạm vi bảo hiểm.", e: "Tai nạn, bệnh tật, thiệt hại tài sản do thiên tai." },
    { t: "Chi trả bảo hiểm (pojistné plnění)", d: "Số tiền công ty bảo hiểm trả khi xảy ra sự kiện bảo hiểm.", e: "Sau tai nạn để lại di chứng vĩnh viễn, công ty bảo hiểm chi trả 500 000 Kč." },
    { t: "Kỳ cố định lãi suất (fixace)", d: "Khoảng thời gian lãi suất khoản vay thế chấp không thay đổi.", e: "Fixace 5 năm nghĩa là lãi suất giữ nguyên trong 5 năm." },
    { t: "Khoản trả cố định (anuitní splátka)", d: "Khoản trả hàng tháng bằng nhau trong suốt thời hạn vay.", e: "Trả 15 000 Kč mỗi tháng suốt thời gian vay thế chấp." },
    { t: "Năng lực trả nợ (bonita)", d: "Khả năng trả nợ của khách hàng theo đánh giá của ngân hàng.", e: "Ngân hàng xem xét thu nhập, chi tiêu và các nghĩa vụ hiện có." },
    { t: "ETF", d: "Exchange Traded Fund — quỹ giao dịch trên sàn, bám theo một chỉ số.", e: "ETF S&P 500 bám theo 500 công ty lớn nhất của Mỹ." },
    { t: "Trái phiếu (dluhopis)", d: "Chứng khoán mà tổ chức phát hành cam kết trả vốn gốc và lãi.", e: "Trái phiếu chính phủ được coi là khoản đầu tư an toàn." },
    { t: "Danh mục (portfolio)", d: "Tổng hợp toàn bộ khoản đầu tư và tài sản của khách hàng.", e: "Danh mục gồm 60 % cổ phiếu và 40 % trái phiếu." },
    { t: "Tái cân bằng (rebalancing)", d: "Điều chỉnh định kỳ cơ cấu danh mục về tỷ trọng mục tiêu.", e: "Nếu cổ phiếu tăng lên 70 %, bán bớt và mua thêm trái phiếu." },
    { t: "TER", d: "Total Expense Ratio — tổng chi phí của quỹ tính theo phần trăm.", e: "Quỹ có TER 0,5 % mỗi năm thu 0,5 % giá trị khoản đầu tư." },
    { t: "Trợ cấp nhà nước (státní příspěvek)", d: "Khoản nhà nước góp thêm vào tiết kiệm hưu trí hoặc tiết kiệm xây dựng.", e: "Tối đa 230 Kč mỗi tháng cho tiết kiệm hưu trí khi nộp 1 700 Kč." },
    { t: "Phong tỏa quyền lợi (vinkulace)", d: "Hạn chế định đoạt khoản tiền có lợi cho bên thứ ba.", e: "Vinkulace hợp đồng bảo hiểm có lợi cho ngân hàng khi vay thế chấp." },
    { t: "Thời gian chờ (odkladná doba)", d: "Khoảng thời gian từ khi xảy ra sự kiện bảo hiểm đến khi bắt đầu chi trả.", e: "Thời gian chờ 28 ngày với chế độ nghỉ ốm." },
    { t: "Hợp nhất nợ (konsolidace dluhů)", d: "Gộp nhiều khoản vay thành một với điều kiện tốt hơn.", e: "Thay 3 khoản vay tiêu dùng bằng một khoản có mức trả thấp hơn." },
    { t: "FIRE", d: "Financial Independence, Retire Early — phong trào hướng tới tự do tài chính.", e: "Mục tiêu: tích lũy gấp 25 lần chi tiêu một năm và sống bằng mức rút 4 %." },
    { t: "Compliance", d: "Tuân thủ các yêu cầu pháp lý và quy định trong ngành.", e: "Tuân thủ quy định của ČNB đối với cố vấn tài chính." },
  ],
  poznamky: {
    title: "Ghi chú",
    new: "Ghi chú mới",
    placeholder: "Viết…",
    emptyTitle: "Chưa có ghi chú nào",
    emptyDesc: "Nhấp và viết — trang giấy trắng tự lưu lấy.",
    allTags: "Tất cả",
    addTag: "Thêm nhãn",
    removeTag: "Bỏ nhãn",
    tagPlaceholder: "nhãn",
    filterEmpty: "Không có gì với nhãn này.",
    clearFilter: "Bỏ bộ lọc",
    delete: "Xóa ghi chú",
    deleteConfirm: "Thực sự muốn xóa?",
    saving: "Đang lưu…",
    saved: "Đã lưu",
    saveFailed: "Chưa lưu — bộ nhớ trình duyệt đã đầy",
  },
  /* === NASTROJE: ruční převod jazykových ternárů (dávka „nastroje") === */
  nastroje: {
    /* === CÔNG CỤ NHANH TRONG THANH BÊN CỦA BẢN PHÂN TÍCH ===
     * Các máy tính hiện ra ĐÈ LÊN bản phân tích đang mở, đã điền sẵn số liệu
     * của khách. Bản mô phỏng KHÔNG được lưu (chân bảng), còn các thông báo
     * của engine trả nợ dùng lại các khóa đã dịch
     * `nastroje.schuzka.doplaceni.hlaska*`.
     * Thuật ngữ tiếng Séc để trong ngoặc ở những chỗ khách sẽ thấy trên hợp đồng. */
    pruh: {
      nadpis: "Công cụ nhanh",
      otevrit: "Mở công cụ nhanh",
      zavrit: "Đóng",
      tabHypo: "Vay mua nhà (hypotéka)",
      tabDoplaceni: "Vay mua nhà kèm đầu tư",
      tabZivot: "Bảo hiểm nhân thọ",
      tabInvestice: "Đầu tư",
      znovuZAnalyzy: "Nạp lại số liệu từ bản phân tích",
      neukladaSeTuk: "Bản mô phỏng này không được lưu.",
      neukladaSeText: "Số liệu trong bảng này không vào bản phân tích cũng không vào kế hoạch, và sẽ mất khi tải lại trang. Điều gì muốn để lại cho khách thì hãy nhập vào bản phân tích hoặc vào đề xuất giải pháp.",
      padTuk: "Không hiển thị được công cụ.",
      padText: "Bản phân tích vẫn ổn và vẫn đang mở. Hãy thử công cụ khác và báo lỗi — chi tiết nằm trong console của trình duyệt.",
      zAnalyzy: "từ bản phân tích",
      zPrebytku: "từ phần thặng dư trong bản phân tích",
      bezPrijmu: "Không có thu nhập ròng trong bản phân tích thì không tính được gánh nặng nợ.",
      chybiNadpis: "Thiếu dữ liệu",
      chybiObecne: "Có dữ liệu bị thiếu hoặc ngoài khoảng cho phép — hãy kiểm tra lại phần nhập.",
      skriptNadpis: "Nói gì với khách",
      hypo: {
        zadani: "Bất động sản và khoản vay",
        cena: "Giá bất động sản",
        vlastni: "Vốn tự có",
        sazba: "Lãi suất",
        splatnost: "Thời hạn vay",
        dosaditPrumer: "Lấy mức trung bình thị trường {sazba} ({obdobi})",
        prumerNeniNabidka: "Lãi suất chào bình quân trên thị trường, không phải chào giá của một ngân hàng cụ thể.",
        vysledek: "Tiền trả hằng tháng và các hạn mức",
        splatka: "Tiền trả hằng tháng",
        splatkaNote: "Trả đều như nhau suốt thời hạn vay theo lãi suất đã nhập.",
        uver: "Số tiền vay",
        ltv: "LTV — vay so với giá",
        ltvLimit: "Hạn mức bắt buộc {limit}.",
        bezVeku: "bản phân tích chưa có tuổi, dùng hạn mức nghiêm hơn {limit}",
        ltvNad: "Vượt hạn mức — cần ít nhất {castka} vốn tự có.",
        dsti: "DSTI — tiền trả so với thu nhập",
        dstiLimit: "Hạn mức khuyến nghị {limit} thu nhập ròng, đã tính cả các khoản đang trả.",
        dti: "DTI — nợ so với thu nhập",
        dtiLimit: "Hạn mức khuyến nghị {limit}× thu nhập ròng một năm.",
        celkemZaplaceno: "Tổng đã trả cho ngân hàng",
        zTohoUroky: "Trong đó tiền lãi",
        stavajiciSplatky: "Các khoản đang trả, lấy từ bản phân tích",
        skript: "Ngân hàng nhìn ba con số: anh chị vay bao nhiêu so với giá nhà, tiền trả hằng tháng chiếm bao nhiêu thu nhập, và nợ bao nhiêu so với thu nhập một năm. Ta xem anh chị đang ở đâu — và chỗ nào cần thêm vốn tự có.",
        chybiCena: "Hãy nhập giá bất động sản.",
        chybiSazba: "Hãy nhập lãi suất — không có nó thì không ra được tiền trả hằng tháng.",
        chybiSplatnost: "Hãy nhập thời hạn vay theo năm.",
        chybiVlastni: "Nhập vốn tự có — không có nó thì không tính được số tiền vay.",
        bezVlastnich: "Khách hàng không có vốn tự có",
        chybiVlastniNadCenu: "Vốn tự có lớn hơn giá bất động sản — vậy không còn gì phải vay.",
      },
      doplaceni: {
        zadani: "Khoản vay và tiền dư",
        jistina: "Phần gốc còn lại",
        sazba: "Lãi suất khoản vay",
        splatnost: "Thời hạn vay",
        volnaCastka: "Tiền dư mỗi tháng",
        vynos: "Lợi nhuận đầu tư kỳ vọng",
        horizont: "Muốn trả hết sau",
        predpoklad: "giả định của tư vấn viên",
        neniVAnalyze: "bản phân tích không có — hãy nhập",
        predpokladyPoznamka: "Đã tính phí quỹ {ter} mỗi năm và thuế khi bán để trả hết. Hãy nhập lợi nhuận theo giá trị danh nghĩa, tức cùng cách với lãi suất khoản vay — nếu không, khoản đầu tư được cho không cả phần lạm phát.",
        stitkyPoznamka: "Nhãn dưới mỗi ô cho biết con số đến từ đâu khi bảng vừa mở. Số nào được ghi lại thì đó là giả định của tư vấn viên.",
        chybiJistina: "Hãy nhập phần gốc còn lại của khoản vay.",
        chybiSazba: "Hãy nhập lãi suất của khoản vay. Số không không phải là lãi suất, và không có lãi suất thì đầu tư luôn thắng.",
        vysledek: "Sau {roky}: khách còn lại gì",
        cestaSplaceni: "Trả thêm vào khoản vay",
        cestaSplaceniNote: "Trả hết nợ sau {kdy}, sau đó cùng số tiền ấy đem đi đầu tư.",
        cestaInvestice: "Đầu tư rồi trả hết một lần",
        cestaInvesticeNote: "Danh mục sau thuế {portfolio} trừ phần nợ còn lại {dluh}.",
        vitezInvestice: "Đầu tư ra kết quả tốt hơn",
        vitezInvesticeText: "Sau {roky} khách còn lại nhiều hơn {castka} so với trả thêm vào khoản vay. Điều đó chỉ đúng khi thị trường thật sự cho mức lợi nhuận ấy.",
        vitezSplaceni: "Trả thêm vào khoản vay ra kết quả tốt hơn",
        vitezSplaceniText: "Sau {roky} khách còn lại nhiều hơn {castka} nếu đưa tiền vào khoản vay. Tiền trả hằng tháng là chắc chắn, lợi nhuận thì không.",
        remiza: "Hai đường ngang nhau",
        remizaText: "Sau {roky} chênh lệch giữa hai đường là không đáng kể. Vậy quyết định nằm ở sự chắc chắn, không nằm ở lợi nhuận — và chắc chắn là khoản trả thêm.",
        splatka: "Tiền trả khoản vay",
        vydajObe: "Ngân sách chi ra ở cả hai đường",
        usporaSplaceni: "Tiết kiệm tiền lãi — trả thêm",
        usporaInvestice: "Tiết kiệm tiền lãi — đầu tư",
        danPriDoplaceni: "Thuế khi bán để trả hết",
        poplatky: "Tổng phí của khoản đầu tư",
        hranice: "Lợi nhuận hòa vốn của khoản đầu tư",
        hraniceNote: "Dưới mức lợi nhuận này thì đầu tư thua — đã tính cả thuế và phí. Trên mức đó thì có lời.",
        hraniceNikdy: "Đầu tư không vượt được khoản trả thêm dù lợi nhuận rất cao — thường là vì thời gian ngắn, vì phí hoặc vì thuế.",
        prusecikText: "Danh mục lần đầu đủ phủ phần nợ còn lại sau {roky}. Lúc đó phải trả hết {castka} — từ đó khách được quyền chọn.",
        prusecikNikdy: "Trong khoảng thời gian đã nhập, danh mục không đạt tới mức phủ được nợ.",
        urokyPoznamka: "Tiền lãi tiết kiệm được so sánh cho tới khi trả hết hẳn, không chỉ tới ngày trả hết một lần — nếu không, đường nào vẫn còn nợ sẽ trông tiết kiệm hơn thực tế.",
        orientacniNadpis: "Mô phỏng tham khảo",
        orientacni: "Đây không phải là chào vay cũng không phải cam kết chi trả, và không tính theo điều kiện của một hợp đồng cụ thể. Hạn mức trả trước miễn phí, phí của ngân hàng và lãi suất sau kỳ lãi cố định hãy kiểm tra trong hợp đồng; quy định về thuế từ giờ tới ngày trả hết có thể đổi.",
        plnaKalkulacka: "Các tình huống thị trường sụt giảm, kỳ lãi cố định và mức bảo hiểm giảm dần do máy tính đầy đủ trong phần Công cụ tính.",
        skript: "Có hai cách để hết khoản vay này. Một là trả thêm vào khoản vay, hai là đem số tiền đó đi đầu tư rồi trả hết một lần. Ta tính cả hai — và nhất là tính xem sẽ thế nào nếu thị trường không lời được như ta mong.",
      },
      zivot: {
        zadani: "Gia đình và nghĩa vụ nợ",
        nezbytne: "Chi tiêu thiết yếu của gia đình",
        horizont: "Cần bảo vệ bao nhiêu năm",
        dluhy: "Tổng nợ",
        rezerva: "Quỹ dự phòng",
        vdovsky: "Trợ cấp góa phụ",
        sirotci: "Trợ cấp mồ côi tổng cộng",
        davkaSablona: "mẫu theo quốc gia — chỉnh theo khách",
        varianta: "Phương án bảo vệ",
        smrt: "Số tiền bảo hiểm — tử vong",
        invalidita: "Số tiền bảo hiểm — mất sức lao động",
        zavazne: "Bệnh hiểm nghèo",
        tnu: "Di chứng vĩnh viễn do tai nạn",
        pn: "Nghỉ ốm dài ngày",
        denne: " / ngày",
        rozpad: "Trong đó nợ {dluhy}, mục tiêu {cile} và chi tiêu gia đình {vydaje}.",
        chybiPrijem: "Trong bản phân tích không ai có thu nhập — vậy phương pháp vốn hóa không có gì để tính.",
        chybiVydaje: "Hãy nhập chi tiêu thiết yếu của gia đình.",
        chybiHorizont: "Hãy nhập mức bảo vệ cần đủ cho bao nhiêu năm.",
        chybiPozustalostni: "Chưa có mức trợ cấp tử tuất đã kiểm chứng cho quốc gia này — thiếu nó, mức bảo vệ tử vong sẽ bị tính thấp. Hãy bổ sung vào hạn mức bảo hiểm.",
        skript: "Tôi sẽ tính ngược lại với cách công ty bảo hiểm làm. Không phải anh chị trả được bao nhiêu, mà gia đình cần bao nhiêu để sống tiếp như cũ và hoàn thành những gì anh chị đã dự định. Từ con số đó ta mới nói tới giá.",
      },
      invest: {
        zadani: "Số tiền góp và thời gian",
        mesicne: "Mỗi tháng",
        jednorazove: "Một lần hôm nay",
        rezervaNeni: "quỹ dự phòng không được đưa vào đây",
        roky: "Thời gian đầu tư",
        vynos: "Lợi nhuận kỳ vọng",
        vynosPredpoklad: "giả định của tư vấn viên",
        vysledek: "Sẽ được bao nhiêu",
        konecnaHodnota: "Giá trị cuối kỳ",
        vDnesnichCenach: "Theo giá trị danh nghĩa, chưa quy về giá hôm nay — lạm phát sẽ làm sức mua giảm đi.",
        vlozeno: "Tổng đã góp",
        vynosCelkem: "Trong đó phần lợi nhuận",
        neniGaranceNadpis: "Lợi nhuận không được bảo đảm.",
        neniGarance: "Đây là giả định, không phải lời hứa. Thị trường có thể giảm vài năm liền và giá trị có thể thấp hơn cả số tiền đã góp. Hãy nói điều này với khách trước khi đưa ra con số cuối.",
        skript: "Đây là phần mỗi tháng anh chị còn lại. Cứ để nó nằm trong tài khoản thì mười năm sau vẫn là số tiền đó, chỉ là mua được ít hơn. Đây là cách thứ hai — và đi kèm ngay câu tôi buộc phải nói: lợi nhuận là giả định, không phải lời hứa.",
        chybiVklad: "Hãy nhập số tiền góp mỗi tháng hoặc số tiền góp một lần.",
        chybiRoky: "Hãy nhập thời gian đầu tư theo năm.",
        chybiVynos: "Hãy nhập lợi nhuận kỳ vọng.",
      },
    },
    /* === NÁSTROJE KE SCHŮZCE (zlato / konsolidace / podpojištění) ===
     * Klientské kalkulačky na /kalkulacka/:nastroj. Texty jsou psané tak, aby
     * je poradce mohl na schůzce ŘÍCT NAHLAS — proto tu jsou celé věty, ne
     * jen štítky. Vietnamská verze nese české odborné termíny v závorce,
     * protože klient i úřad je uvidí na smlouvě.
     * ⚠️ Čísla v kalkulačkách jsou ŠABLONA, ne nabídka — viz `sablonaText`. */
    schuzka: {
      sekce: "Công cụ cho buổi gặp khách",
      titulek: "Máy tính để đặt trên bàn cho khách xem",
      podtitulek: "Bốn phép tính quyết định buổi gặp: khách thật sự còn lại bao nhiêu vàng, gộp nợ có lợi hay không — kể cả khi không có lợi — bảo hiểm thật sự trả bao nhiêu, và nên trả thêm vào khoản vay thế chấp hay đem đầu tư rồi trả hết một lần. Đồng tiền lấy theo quốc gia của tenant, không lấy theo ngôn ngữ.",
      zpet: "Quay lại Công cụ (Nástroje)",
      tabZlato: "Vàng",
      tabKonsolidace: "Gộp nợ (konsolidace)",
      tabPodpojisteni: "Bảo hiểm thiếu (podpojištění)",
      tabDoplaceni: "Trả hết thế chấp sớm (doplacení hypotéky)",
      zadani: "Nhập số liệu",
      vysledek: "Kết quả",
      vetaNaSchuzku: "Câu nói tại buổi gặp — hãy nói đúng như vậy",
      kdyNedoporucit: "Khi nào KHÔNG nên khuyên",
      postup: "Từng bước một",
      orientacniTuk: "Tính tham khảo, không phải bản chào.",
      orientacniText: "Bảng tính chỉ để giải thích sản phẩm hoạt động thế nào. Đây không phải bản chào, không phải cam kết chi trả, cũng không phải khuyến nghị cá nhân. Số ràng buộc chỉ có trong hợp đồng, biểu phí (ceník) và điều khoản bảo hiểm (pojistné podmínky).",
      sablonaTuk: "Các con số là MẪU — hãy kiểm tra trước buổi gặp.",
      sablonaText: "Giá, lãi suất và phí luôn thay đổi. Hãy lấy số liệu hiện hành từ cổng đối tác hoặc biểu phí đúng ngày gặp khách rồi nhập lại vào đây.",
      mesicOne: "tháng",
      mesicFew: "tháng",
      mesicMany: "tháng",
      rokOne: "năm",
      rokFew: "năm",
      rokMany: "năm",
      zlato: {
        popis: "Khách không chỉ mua vàng — khách mua vàng, mua phí, mua chênh lệch giữa giá mua vào và giá thu mua lại, và mua luôn cả ngoại tệ. Hãy cho khách thấy tất cả cùng một lúc, để hai năm sau không có bất ngờ.",
        jednorazove: "Nộp một lần",
        mesicne: "Nộp hằng tháng",
        roky: "Thời gian (horizont)",
        typ: "Loại hợp đồng — bao nhiêu phần trăm tiền nộp đi vào phí",
        typJednorazovy: "Mua một lần",
        typPopis100: "100/0 — khi phí chưa trả xong, khách CHƯA mua được một gram vàng nào. Hãy nói câu này đầu tiên.",
        typPopis7030: "70/30 — bảy mươi phần trăm tiền nộp vào phí, ba mươi vào vàng. Vàng có ngay từ đầu nhưng tổng phí cao hơn.",
        typPopis5050: "50/50 — một nửa vào phí, một nửa vào vàng. Bắt đầu nhanh nhất, phí đắt nhất.",
        typPopisJednorazovy: "Mua một lần — không trừ phí từ tiền nộp, khách chỉ trả giá kim loại và chênh lệch mua/bán.",
        vstupniPoplatek: "Phí đầu vào (vstupní poplatek)",
        vstupniPoplatekHint: "Nếu chương trình tính phí cho từng miếng riêng, hãy cộng phí của tất cả các miếng.",
        cenaNakup: "Giá mua vào cho một gram",
        cenaVykup: "Giá thu mua lại cho một gram",
        cenyHint: "Lấy cả hai giá từ cổng đối tác đúng ngày gặp khách. Chênh lệch giữa chúng là chi phí không có trong bất kỳ biểu phí nào.",
        rustKov: "Giá kim loại tăng (tính bằng USD) % / năm",
        zmenaKurzu: "Tỷ giá USD/{mena} thay đổi % / năm",
        kurzHint: "Vàng niêm yết bằng đô la, khách sống bằng tiền trong nước. Khi tiền trong nước mạnh lên, phần lãi bằng đô la sẽ mất trên đường về. Vì vậy ở đây có hai thanh trượt, không phải một.",
        gramy: "Khách sẽ có bao nhiêu vàng",
        jednotky: "{chi} chỉ · {luong} lượng",
        vlozeno: "Tổng tiền đã nộp",
        hodnota: "Giá trị khi bán lại",
        rozdil: "Chênh lệch: {castka}",
        naklady: "Đã trả cho phí và chênh lệch giá",
        spread: "Chênh lệch mua vào / bán lại",
        vynosPa: "Lợi nhuận mỗi năm (tỷ suất nội hoàn)",
        nedoplaceno: "Phí đầu vào vẫn chưa trả hết",
        prvniGramNadpis: "Gram vàng đầu tiên",
        prvniGramHned: "Khách mua được kim loại ngay từ lần nộp đầu tiên.",
        prvniGramZa: "Khách chỉ mua được gram đầu tiên vào tháng thứ {mesic}. Trước đó là trả phí.",
        prvniGramNikdy: "Trong toàn bộ thời gian đã chọn, khách không mua được một gram nào — phí không kịp trả xong. Hãy rút ngắn mục tiêu hoặc tăng số tiền nộp.",
        bodZvratuNadpis: "Khi nào khách hòa vốn",
        bodZvratu: "Vào tháng thứ {mesic}, tức khoảng {roky} năm.",
        bodZvratuNikdy: "Trong thời gian đã chọn, khách không lấy lại được số tiền đã nộp. Hãy nói điều này trước khi khách ký.",
        menoveRizikoNadpis: "Rủi ro tỷ giá — khách không chỉ mua vàng",
        menoveRizikoText: "Giá vàng tính bằng đô la, nhưng khách trả và nhận bằng {mena}. Ai mua vàng lúc tiền trong nước yếu sẽ mất một phần lãi khi tiền mạnh trở lại. Con số này cho thấy bao nhiêu phần kết quả là do tỷ giá, không phải do vàng.",
        kurzUdelal: "Phần do tỷ giá tạo ra",
        kurzScenareNadpis: "Nếu tỷ giá đi hướng khác",
        kurzScenarLabel: "Tỷ giá {proc} / năm",
        grafNadpis: "Tiền đã nộp so với giá trị vàng",
        grafVlozeno: "Đã nộp",
        grafHodnota: "Giá trị khi bán lại",
        grafRok: "Năm",
        porovnaniNadpis: "Cùng số tiền đó ở tài sản khác",
        porovnaniText: "Trung bình danh nghĩa dài hạn từ dữ liệu công khai (1928–2024, tính bằng đô la), chưa trừ phí và thuế ở cả hai bên. Dùng để so sánh độ lớn, không phải để chọn sản phẩm — và tuyệt đối không phải lời hứa lợi nhuận.",
        aktivumAkcie: "Chỉ số cổ phiếu rộng",
        aktivumZlato: "Vàng (trung bình lịch sử)",
        aktivumDluhopisy: "Trái phiếu",
        aktivumNemovitosti: "Bất động sản",
        aktivumHotovost: "Tiền mặt và tài khoản tiết kiệm",
        aktivumTentoPlan: "Phương án vàng này",
        mesicuInfo: "Bảng tính chạy theo từng tháng, tổng cộng {mesicu}.",
        skript: "„Trước khi ký bất cứ điều gì, tôi cho anh chị xem ba con số. Thứ nhất: gram vàng đầu tiên anh chị chỉ mua được vào tháng ghi trên màn hình này — trước đó là trả phí. Thứ hai: giữa giá mua vào và giá bán lại có chênh lệch, nên ngay sau khi mua, vàng của anh chị đã có giá trị thấp hơn số tiền đã bỏ ra. Thứ ba: vàng tính bằng đô la, còn anh chị sống bằng tiền trong nước — nếu tiền trong nước mạnh lên, tỷ giá sẽ lấy mất một phần lãi. Nếu anh chị thấy ổn, mình đi tiếp. Nếu không, tôi có phương án khác.“",
        kdyNe: [
          "Khách chưa có quỹ dự phòng bằng ba đến sáu tháng chi tiêu. Vàng không phải quỹ dự phòng — bán lại mất vài ngày và giá lúc đó có thể đang thấp.",
          "Khách đang có nợ đắt. Thẻ tín dụng hai mươi phần trăm một năm thắng mọi kỳ vọng lợi nhuận của vàng. Gộp nợ trước, mua kim loại sau.",
          "Thời gian ngắn hơn năm đến bảy năm. Phí đầu vào và chênh lệch mua/bán không kịp được bù lại.",
          "Khách chưa lo xong bảo vệ thu nhập và chỗ ở. Vàng không trả hộ tiền vay mua nhà (hypotéka) khi khách bị tai nạn không đi làm được.",
          "Khách muốn dồn phần lớn tài sản vào vàng hoặc muốn sống bằng vàng. Vàng không sinh lãi cũng không có cổ tức — lấy tiền từ vàng chính là bán dần tài sản.",
        ],
      },
      konsolidace: {
        popis: "Trả góp thấp hơn KHÔNG có nghĩa là khoản vay rẻ hơn. Ta so sánh hai tổng số tiền, không so sánh hai khoản trả góp. Máy tính này còn cho thấy cả trường hợp gộp nợ KHÔNG có lợi — và chính điều đó khiến khách tin bạn.",
        predlohy: "Tình huống mẫu",
        predlohaVyplati: "Ví dụ: có lợi",
        predlohaNevyplati: "Ví dụ: không có lợi",
        predlohyHint: "Số liệu mẫu để luyện tập, không phải dữ liệu khách thật. Bấm vào rồi sửa theo giấy tờ khách mang đến.",
        uveryNadpis: "Hôm nay khách đang trả những gì",
        pridat: "Thêm khoản vay",
        smazat: "Bỏ khoản vay",
        zustatek: "Dư nợ còn lại",
        splatka: "Trả góp hằng tháng",
        zbyva: "Còn lại bao nhiêu kỳ",
        poplatekPredcasne: "Phí trả nợ trước hạn",
        dopoctenaSazba: "Lãi suất tính ngược",
        sazbaNelze: "không tính được",
        nazevKreditka: "Thẻ tín dụng",
        nazevNebankovni: "Vay ngoài ngân hàng",
        nazevSplatkovyProdej: "Mua trả góp",
        nazevBankovniPujcka: "Vay ngân hàng",
        nazevAutoUver: "Vay mua xe",
        nazevNovy: "Khoản nợ khác",
        nabidkaNadpis: "Ngân hàng chào gì",
        novaSazba: "Lãi suất mới",
        novaSplatnost: "Kỳ hạn mới",
        poplatekZaSjednani: "Phí làm hợp đồng",
        splatkaRucne: "Trả góp ngân hàng báo",
        splatkaRucneHint: "Để số không thì máy tự tính. Nếu ngân hàng đã báo con số, hãy nhập vào đây.",
        celkemTed: "Tổng phải trả nếu giữ nguyên",
        celkemTedNote: "Trả góp hiện tại: {splatka}",
        celkemPo: "Tổng phải trả sau khi gộp",
        celkemPoNote: "Trả góp mới: {splatka}",
        uspora: "Tiết kiệm được",
        zaplatiNavic: "Phải trả thêm",
        ulevaMesicne: "Nhẹ đi mỗi tháng",
        prodlouzeni: "Kéo dài thời gian trả",
        prodlouzeniZadne: "không kéo dài",
        odsunuto: "Phần nhẹ đi chỉ là dời sang sau",
        sazbaTed: "Lãi suất bình quân hiện nay",
        novaJistina: "Dư nợ mới đã gồm phí",
        poplatkyCelkem: "Tổng phí",
        verdiktVyhra: "Có lợi",
        verdiktVyhraText: "Khách trả ít hơn cả theo tháng lẫn tổng cộng. Hãy kiểm tra phí trả nợ trước hạn và xin từng chủ nợ giấy xác nhận dư nợ bằng không.",
        verdiktLevnejsi: "Tổng rẻ hơn, nhưng trả góp cao hơn",
        verdiktLevnejsiText: "Khách trả ít hơn về tổng, nhưng mỗi tháng phải gánh nhiều hơn. Hãy kiểm tra ngân sách có chịu nổi không — nếu không, bạn đang đẩy khách tới chậm trả.",
        verdiktUleva: "Trả góp thấp hơn, nhưng tổng cao hơn",
        verdiktUlevaText: "Đôi khi đây vẫn là quyết định đúng, khi mục tiêu là không bị chậm trả và không vào danh sách nợ xấu (registry). Nhưng phải nói to rõ: khách đang mua sự nhẹ nhõm và trả tiền cho nó. Đừng bao giờ bán nó như là tiết kiệm.",
        verdiktNevyplati: "Không có lợi",
        verdiktNevyplatiText: "Không lợi cả về tổng lẫn về trả góp. Hãy nói thẳng với khách và đưa phương án khác — trả thêm một khoản, đổi kỳ hạn, hoặc chỉ gộp những khoản đắt nhất.",
        hranice: "Để việc gộp nợ ít nhất hòa về chi phí, kỳ hạn không được dài hơn {mesicu}.",
        hraniceNelze: "Với lãi suất này thì không kỳ hạn nào làm cho việc gộp nợ rẻ hơn. Hãy hỏi một bản chào khác.",
        skript: "„Anh chị nhìn hai con số này. Bên trái là số tiền anh chị phải trả nếu để nguyên như bây giờ. Bên phải là số tiền phải trả sau khi gộp nợ. Trả góp hằng tháng sẽ giảm — điều đó đúng. Nhưng ta quyết định theo hai con số tổng này, không theo con số trả góp. Nếu bên phải lớn hơn, nghĩa là anh chị đang mua sự yên tâm và trả tiền cho nó. Đó vẫn có thể là quyết định đúng, chỉ cần anh chị biết mình đang làm gì.“",
        kroky: [
          "Ghi ra từng khoản nợ: dư nợ, trả góp, số kỳ còn lại, lãi suất và phí trả nợ trước hạn.",
          "Bảo khách lấy bản trích lục từ các danh bạ tín dụng (registry). Khách thường quên hai ba khoản — thiếu chúng là tính sai.",
          "Tính hai con số tổng trước, nói chuyện về trả góp sau.",
          "Nộp hồ sơ kèm giấy tờ: giấy tùy thân, hợp đồng của tất cả khoản vay được gộp, chứng minh thu nhập hoặc sao kê tài khoản.",
          "Sau khi tất toán, xin từng chủ nợ cũ giấy xác nhận dư nợ bằng không. Đây là lỗi hay gặp nhất của cả quy trình gộp nợ.",
          "Hủy thẻ tín dụng và hạn mức thấu chi vừa được giải phóng. Nếu không, chưa đầy một năm khách lại nợ như cũ và bạn đã không giúp được gì.",
        ],
        kdyNe: [
          "Lãi suất mới bằng hoặc cao hơn, thay đổi duy nhất là kỳ hạn dài hơn.",
          "Khách định gộp cả những khoản sắp trả xong trong vài tháng — ở đó gần như không còn lãi để tiết kiệm.",
          "Phí trả nợ trước hạn cộng phí làm hợp đồng ăn hết phần tiết kiệm.",
          "Khách vẫn giữ thẻ tín dụng và thấu chi ở trạng thái mở.",
          "Một phần nợ đang bị thi hành án, quá hạn, nợ nhà nước hoặc vay của người quen — ngân hàng không nhận gộp, dù chúng vẫn ăn vào ngân sách.",
        ],
      },
      podpojisteni: {
        popis: "Khi số tiền bảo hiểm (pojistná částka) thấp hơn giá trị thật của tài sản, công ty bảo hiểm sẽ giảm tiền bồi thường theo đúng tỷ lệ đó — và giảm cả với thiệt hại nhỏ. Với cửa hàng thực phẩm, khoản chênh này thường là hàng trăm nghìn.",
        polozkyNadpis: "Cộng lại xem trong cửa hàng thật sự có gì",
        polozkyHint: "Phần lớn trường hợp bảo hiểm thiếu là do quên mất một thứ gì đó. Hãy cùng khách đi qua từng khoản mục.",
        stavebniUpravy: "Sửa chữa, lắp đặt cố định",
        vybaveni: "Thiết bị và máy móc",
        elektronika: "Đồ điện tử và máy tính tiền",
        zasoby: "Hàng hóa trong kho",
        hotovost: "Tiền mặt tại cửa hàng",
        veciKlientu: "Đồ nhận từ khách hàng",
        polozkyCelkem: "Tổng giá trị",
        dosadit: "Đưa vào phép tính",
        hodnota: "Giá trị thật của tài sản",
        hodnotaHint: "Là số tiền để mua sắm lại từ đầu, không phải số tiền đã bỏ ra ngày xưa.",
        castka: "Số tiền bảo hiểm trong hợp đồng",
        castkaHint: "Hãy chép từ hợp đồng, đừng nhớ theo trí nhớ.",
        skoda: "Mức thiệt hại",
        spoluucast: "Mức miễn thường (spoluúčast)",
        sezonni: "Cao điểm hàng hóa theo mùa",
        sezonniHint: "Trước Tết và trước Giáng sinh, cửa hàng trữ gấp nhiều lần hàng bình thường. Số tiền bảo hiểm vẫn giữ nguyên từ ngày ký — và tai nạn thường xảy ra đúng lúc đó.",
        podpojisteni: "Mức bảo hiểm thiếu",
        pomerNote: "Chỉ được bảo hiểm {pomer} giá trị",
        vyplati: "Bảo hiểm trả",
        doplaci: "Khách tự bù",
        hodnotaVeSpicce: "Giá trị tài sản lúc cao điểm",
        chybiVCastce: "Cần nâng số tiền bảo hiểm thêm",
        ztrataProti: "Mất mát so với hợp đồng đúng",
        varovaniTuk: "Hợp đồng này đang bảo hiểm thiếu.",
        varovaniText: "Công ty bảo hiểm sẽ giảm bồi thường theo đúng tỷ lệ giữa số tiền bảo hiểm và giá trị tài sản. Điều này áp dụng cả với thiệt hại nhỏ. Hãy nâng số tiền bảo hiểm, hoặc nói thẳng cho khách biết sẽ phải bù bao nhiêu.",
        vporadkuTuk: "Mức bảo hiểm khớp với giá trị tài sản.",
        vporadkuText: "Bồi thường sẽ không bị giảm. Hãy kiểm tra lại ở mỗi buổi gặp chăm sóc — giá xây dựng và giá hàng đều tăng, còn số tiền bảo hiểm thì không tự tăng.",
        tabulkaNadpis: "Thiệt hại nhỏ cũng bị giảm",
        tabSkoda: "Thiệt hại",
        tabPlneni: "Bảo hiểm trả",
        tabDoplaci: "Khách bù",
        zakonNadpis: "Căn cứ ở đâu",
        zakonText: "Bộ luật dân sự Séc (89/2012 Sb.), § 2854: nếu tại thời điểm xảy ra sự kiện bảo hiểm, số tiền bảo hiểm thấp hơn giá trị bảo hiểm của tài sản, thì công ty bảo hiểm giảm tiền bồi thường theo đúng tỷ lệ đó — trừ khi hợp đồng có thỏa thuận là không giảm. Luôn kiểm tra điều khoản bảo hiểm cụ thể.",
        skript: "„Số tiền bảo hiểm của anh chị đang thấp hơn giá trị thật của cửa hàng. Không phải là bảo hiểm sẽ không trả — mà là mỗi thiệt hại họ chỉ trả đúng bằng tỷ lệ phần trăm mà cửa hàng được bảo hiểm. Tôi cho anh chị xem: đây là thiệt hại, còn đây là số tiền thật sự về tài khoản. Và trước Tết, khi kho đầy hàng, khoảng chênh này còn lớn hơn nữa. Mình chỉnh lại ngay bây giờ, khi chưa có chuyện gì xảy ra.“",
        kdyNe: [
          "Khách không muốn hoặc không thể chứng minh giá trị tài sản — đừng tự nghĩ ra số tiền bảo hiểm, hãy để kế toán hoặc người thẩm định tính.",
          "Trong hợp đồng có thỏa thuận không giảm bồi thường. Khi đó phép tính này không áp dụng, phải theo điều khoản bảo hiểm cụ thể.",
          "Khách muốn nâng số tiền bảo hiểm nhưng chưa đạt yêu cầu về an ninh, kiểm định điện hay vệ sinh — bảo hiểm vẫn có thể giảm vì lý do khác và số tiền cao hơn cũng không cứu được.",
          "Đó là vật có giá trị đặc biệt, ví dụ đồ quý và kim loại quý — chúng có hạn mức riêng trong bảo hiểm và phép tính này không bao gồm.",
        ],
      },
      /* === DOPLACENÍ HYPOTÉKY (mimořádné splátky vs. investice) ===
       * Nástroj, kterým se klient přemlouvá, aby NESPLÁCEL dluh. Texty proto
       * musí unést i opačný závěr: `verdiktSplaceni`, `rizikoText`, scénáře
       * a `kdyNe` nejsou zdvořilostní vata — bez nich je to slib výnosu.
       * Odborné termíny nechávej v závorce česky, klient je uvidí na smlouvě. */
      doplaceni: {
        popis: "Khách có khoản vay thế chấp (hypotéka) và mỗi tháng dư ra vài nghìn. Một là gửi thêm vào khoản vay, hai là đem đầu tư rồi tới thời điểm đã hẹn trả hết nợ một lần. Cả hai đường đều lấy từ ngân sách đúng bằng nhau — chỉ khác ở chỗ cuối cùng khách còn lại bao nhiêu. Và quan trọng nhất: thấy rõ thời điểm khoản đầu tư lần đầu đủ để trả hết phần nợ còn lại.",
        prezentace: "Mở phần trình bày",
        zadaniHypoteka: "Khoản vay thế chấp (hypotéka)",
        jistina: "Còn nợ bao nhiêu",
        jistinaHint: "Phần gốc còn lại (jistina), không phải số vay ban đầu. Lấy từ sao kê, đừng lấy theo trí nhớ của khách.",
        sazba: "Lãi suất",
        splatnost: "Thời hạn vay",
        horizont: "Muốn trả hết sau bao nhiêu năm",
        horizontHint: "Ngày trả hết là cố định. Thị trường không hỏi ngày đó — vì vậy cạnh phần tiết kiệm luôn có bảng rủi ro.",
        fixace: "Kỳ cố định lãi suất (fixace)",
        fixaceHint: "Số 0 = một lãi suất cho suốt thời gian. Nếu khác, sau kỳ cố định tiền trả hằng tháng cũng được tính lại, đúng như ngân hàng làm.",
        sazbaPoFixaci: "Lãi suất sau kỳ cố định",
        splatkaInfo: "Trả hằng tháng {splatka} · khoản vay tự kết thúc sau {splatnost}.",
        zadaniInvestice: "Tiền dư và khoản đầu tư",
        volnaCastka: "Số tiền dư mỗi tháng",
        volnaCastkaHint: "Cùng số tiền đó chạy trên cả hai đường — một lần vào khoản vay, một lần vào đầu tư. Không thế thì so sánh không công bằng.",
        jednorazovyVklad: "Một lần ngay hôm nay",
        vynos: "Lợi nhuận kỳ vọng",
        rezim: "Lợi nhuận vừa nhập là",
        rezimNominalni: "Danh nghĩa (như lãi suất)",
        rezimRealny: "Thực (trên lạm phát)",
        rezimHint: "Lãi suất vay là danh nghĩa (nominální). Đặt 6 % thực đối lại 4,9 % danh nghĩa nghĩa là tặng không cho khoản đầu tư toàn bộ lạm phát — nên ở đây phải chọn, không được đoán.",
        poplatekVstupni: "Phí đầu vào trên mỗi lần nộp",
        poplatekRocni: "Phí thường niên (TER)",
        poplatkyHint: "Quỹ thật tốn 1–2 % mỗi năm. Để số 0 là cách nhanh nhất làm kết quả đầu tư đẹp hơn sự thật.",
        trojiceNadpis: "Sau {roky} khách còn lại gì",
        cestaSplaceni: "Trả thêm vào khoản vay",
        cestaSplaceniNote: "Hết nợ sau {kdy}, sau đó phần tiền trả được giải phóng đem đi đầu tư.",
        cestaInvestice: "Đầu tư rồi trả hết một lần",
        cestaInvesticeNote: "Danh mục sau thuế {portfolio} trừ phần nợ còn lại {dluh}.",
        rozdilZisk: "Đầu tư được thêm",
        rozdilZtrata: "Đầu tư mất đi",
        rozdilNote: "Chênh lệch tài sản ròng của hai đường.",
        vydajObe: "Ngân sách chi ra ở cả hai đường",
        urokyBezZasahu: "Tiền lãi nếu không làm gì",
        urokySplaceni: "Tiền lãi khi trả thêm",
        urokyInvestice: "Tiền lãi khi đầu tư",
        usporaSplaceni: "Tiết kiệm tiền lãi — trả thêm",
        usporaInvestice: "Tiết kiệm tiền lãi — đầu tư",
        danPriDoplaceni: "Thuế khi bán để trả hết",
        poplatkyCelkem: "Tổng phí của khoản đầu tư",
        urokyPoznamka: "Tiền lãi được tính cho tới khi khoản vay thật sự hết, không chỉ tới năm đã chọn. Đường nào tới năm mục tiêu vẫn còn nợ thì nếu không tính tiếp sẽ khoe một khoản tiết kiệm mà thực ra chỉ là chưa trả.",
        verdiktInvestice: "Đầu tư ra kết quả tốt hơn — và khách phải biết vì sao",
        verdiktInvesticeText: "Chênh lệch đến từ lợi nhuận cao hơn lãi suất vay, mà điều đó không được bảo đảm. Hãy đi cùng khách qua bảng rủi ro ngay bên dưới và nói cả mức lợi nhuận hòa vốn.",
        verdiktSplaceni: "Trả thêm vào khoản vay tốt hơn",
        verdiktSplaceniText: "Tiền lãi tiết kiệm được là chắc chắn và không bị đánh thuế, lợi nhuận đầu tư thì không được cả hai. Ở đây không có gì phải giải thích — khuyên khách trả thêm.",
        verdiktRemiza: "Hai đường ngang nhau",
        verdiktRemizaText: "Khi chênh lệch chỉ vài đồng thì quyết định nằm ở sự chắc chắn và yên tâm của khách, không nằm ở bảng số. Tiền trả hằng tháng là chắc chắn, lợi nhuận thì không.",
        grafNadpis: "Nợ đi xuống, đầu tư đi lên",
        grafDluh: "Nợ còn lại",
        grafPortfolio: "Giá trị đầu tư sau thuế",
        grafRok: "Năm",
        grafJednotka: "Trục dọc tính bằng nghìn {mena}. Rê chuột lên đường cong để xem số chính xác.",
        prusecikNadpis: "Thời điểm đã đủ để trả hết",
        prusecikText: "Khoảng sau {rok} khoản đầu tư lần đầu đủ phủ phần nợ còn lại ({castka}). Từ lúc đó khách được chọn: trả hết, hay để tiền tiếp tục làm việc.",
        prusecikNikdy: "Trong khoảng thời gian đã chọn, khoản đầu tư không đủ phủ phần nợ còn lại. Hãy tăng số tiền dư hoặc dời ngày trả hết — và nói với khách trước khi khách quyết định.",
        rizikoNadpis: "Còn nếu thị trường không cho gì thì sao",
        rizikoText: "Tiền trả hằng tháng là chắc chắn, lợi nhuận đầu tư thì không. Hãy cho khách xem cả hai mặt — người tư vấn dám đưa ra cả kịch bản xấu mới là người được tin. Số dương nghĩa là đầu tư tốt hơn, số âm nghĩa là trả thêm tốt hơn.",
        scenarBezVynosu: "Thị trường không cho gì",
        scenarPesimisticky: "Lợi nhuận bi quan",
        scenarZadani: "Theo số đã nhập",
        scenarPropad: "Thị trường sụp đúng năm trả hết",
        hraniceNadpis: "Lợi nhuận hòa vốn",
        hraniceText: "Dưới {nominalni} danh nghĩa (tức {realni} trên lạm phát) thì trả thêm có lợi hơn. Để ý: ngưỡng này nằm CAO HƠN lãi suất vay — phần chênh bị thuế và phí lấy mất.",
        hraniceNelze: "Với số liệu này không tính được lợi nhuận hòa vốn — đầu tư không vượt được trả thêm ngay cả ở mức lợi nhuận cực cao.",
        pojNadpis: "Bảo hiểm giảm dần",
        pojPopis: "Nếu khách qua đời hoặc mất sức lao động, bảo hiểm sẽ bù phần nợ còn lại. Số tiền bảo hiểm giảm dần cùng với nợ — đó là phần diện tích dưới đường cong. Số tiền bảo hiểm được tính bằng phương pháp vốn hóa (kapitálová metoda) từ thu nhập và chi tiêu của gia đình; khoản vay chỉ là phần giảm dần của nó.",
        pojZapnout: "Có tính",
        pojVypnout: "Bỏ qua",
        pojPrijem: "Thu nhập ròng hằng tháng",
        pojVydaje: "Chi tiêu thiết yếu của gia đình",
        pojVydajeHint: "Mỗi tháng gia đình bắt buộc phải chi bao nhiêu để sống — chưa tính tiết kiệm và mục tiêu.",
        pojDeti: "Số con",
        pojSmrt: "Số tiền bảo hiểm — tử vong",
        pojInvalidita: "Số tiền bảo hiểm — mất sức lao động",
        pojZToho: "Trong đó khoản vay {hypoteka} (giảm dần) và gia đình {domacnost} (giữ nguyên).",
        pojCena: "Phí bảo hiểm tham khảo",
        pojCenaNote: "Mỗi tháng, chỉ là mẫu biểu phí. Đây không phải chào giá.",
        pojGrafKryti: "Số tiền bảo hiểm",
        pojPrumerSplaceni: "Nợ chưa trả trung bình — trả thêm",
        pojPrumerInvestice: "Nợ chưa trả trung bình — đầu tư",
        pojRozdilText: "Đây là cái giá của chiến lược mà không ai nói to: đường đầu tư giữ nợ ở mức cao suốt thời gian, nên bảo hiểm giảm dần phải chạy lâu hơn và đắt hơn. Bù lại, lỗ hổng thật cho người ở lại của đường đó nhỏ hơn, vì danh mục cũng là tài sản. Người tư vấn cần cả hai con số, không phải con số dễ nghe hơn.",
        pojSablona: "Số tiền bảo hiểm và biểu phí là mẫu lấy từ thực tế của người tư vấn, không phải chào giá cũng không phải cam kết. Hạn mức và giá cụ thể hãy kiểm tra với công ty bảo hiểm.",
        pojBezPrijmu: "Chưa nhập thu nhập thì phương pháp vốn hóa không có gì để tính, nên chỉ hiện phần bảo hiểm giảm dần cho khoản vay. Hãy điền thu nhập ròng và chi tiêu thiết yếu, khi đó phần giữ cho gia đình sống cũng sẽ được tính.",
        skript: "„Hiện anh chị đang gửi thêm {volna} vào khoản vay. Tôi cho anh chị xem cách thứ hai: cũng số tiền đó nhưng để nó làm việc, rồi trả hết khoản vay một lần. Anh chị nhìn biểu đồ — chỗ này nợ đi xuống, chỗ này đầu tư đi lên, và đây là chỗ hai đường cắt nhau. Đó là lúc anh chị được chọn. Và tôi cho xem luôn mặt kia: nếu thị trường không cho gì thì kết quả sẽ như thế này. Vì vậy đi kèm phải có bảo hiểm bù đúng phần nợ đó, phòng khi anh chị có chuyện.“",
        kroky: [
          "Lấy từ sao kê phần gốc còn lại, lãi suất, tiền trả hằng tháng và ngày hết kỳ cố định. Đừng lấy theo trí nhớ của khách — chênh lệch thường tới hàng trăm nghìn.",
          "Hỏi mỗi tháng khách dư bao nhiêu và liệu năm năm nữa còn gửi đều được không. Số tiền không ổn định làm hỏng cả phép tính.",
          "Đặt số năm khách muốn hết nợ. Ngày này sau đó không đổi nữa.",
          "Nói to lên rằng lợi nhuận vừa nhập là danh nghĩa hay là trên lạm phát. Đây là lỗi hay gặp nhất trong kiểu tính này.",
          "Điền phí quỹ lấy từ tài liệu KID. Thiếu nó thì kết quả đầu tư bị thổi lên.",
          "Cho xem biểu đồ và điểm cắt trước. Số liệu để sau.",
          "Đi qua bảng rủi ro, kể cả kịch bản thị trường không cho gì. Đừng bỏ qua.",
          "Bật phần bảo hiểm giảm dần và tính xem chuyện gì xảy ra nếu khách mất sức lao động. Thiếu nó thì cả chiến lược không có gì che.",
          "Kiểm tra trong hợp đồng hạn mức trả trước miễn phí và phí cho khoản trả thêm.",
        ],
        kdyNe: [
          "Khách chưa có quỹ dự phòng ba đến sáu tháng chi tiêu. Quỹ dự phòng trước, cái này sau.",
          "Lợi nhuận kỳ vọng thấp hơn hoặc sát lãi suất vay. Khi đó đầu tư không có cách nào thắng và trả thêm rõ ràng tốt hơn.",
          "Khách sẽ mất ngủ nếu danh mục rơi ba mươi phần trăm. Ngày trả hết là cố định, còn thị trường thì không hỏi.",
          "Số tiền dư không chắc chắn — thu nhập thất thường, hộ kinh doanh theo mùa, vừa nghỉ sinh. Trả thêm chịu được gián đoạn, đầu tư với ngày cố định thì khó hơn.",
          "Kỳ cố định lãi suất kết thúc sau một hai năm và chưa biết lãi suất mới. Có lãi suất rồi hãy tính.",
          "Khách chưa có bảo hiểm tử vong và mất sức lao động. Thiếu nó thì chiến lược dựa vào việc không có chuyện gì xảy ra.",
          "Ngân hàng thu bồi hoàn cho khoản trả thêm vượt hạn mức luật định. Hãy kiểm tra hợp đồng — phép tính không mô phỏng khoản đó.",
        ],
        metodika: "Thuế khi bán được tính theo từng lần mua, theo luật đang có hiệu lực hôm nay. Việc bán vào năm {rok} vì thế được xét theo quy định của hôm nay, mà từ giờ tới đó luật có thể đổi vài lần. Kết quả chỉ mang tính tham khảo, không phải chào bán cũng không phải khuyến nghị riêng.",
        hlaskaJistina: "Hãy nhập phần gốc còn lại của khoản vay.",
        hlaskaSazbaChybi: "Hãy nhập lãi suất của khoản vay.",
        hlaskaHorizontChybi: "Hãy nhập sau bao nhiêu năm khách muốn trả hết khoản vay.",
        hlaskaHorizontNekladny: "Thời hạn trả hết phải ít nhất một năm.",
        hlaskaSplatnost: "Hãy nhập thời hạn vay tính bằng năm.",
        hlaskaNicNavic: "Khách không dư đồng nào — không có gì để so sánh. Hãy nhập số tiền dư hằng tháng hoặc khoản nộp một lần.",
        hlaskaZapornaAmortizace: "Tiền trả hằng tháng không đủ trả cả tiền lãi tháng — nợ sẽ tăng và khoản vay không bao giờ trả hết. Kiểm tra lại gốc, lãi suất và thời hạn.",
        hlaskaVynosPodUrokem: "Lợi nhuận kỳ vọng {vynos} thấp hơn hoặc bằng lãi suất vay {sazba}. Đầu tư không có cách nào thắng, kể cả khi chưa tính thuế và phí — hãy khuyên khách trả thêm.",
        hlaskaDoplaceniNevyslo: "Danh mục không đủ để trả hết. Sau khi bán và nộp thuế còn thiếu {castka} và khách vẫn còn nợ. Hãy tăng số tiền dư hoặc dời ngày trả hết.",
        hlaskaHorizontZaSplatnosti: "Khoản vay tự kết thúc sau {roky}, tức là sớm hơn thời điểm khách muốn trả hết. Không còn gì để trả.",
        hlaskaSplatnostNedosazena: "Với số tiền trả đã nhập, khoản vay không trả hết ngay cả trong toàn bộ thời gian mô phỏng. Hãy kiểm tra lại số liệu.",
        hlaskaNad25: "Tổng khoản trả thêm trong năm vượt một phần tư số gốc ban đầu. Theo luật chỉ phần trả tới 25 % mỗi năm trong tháng trước ngày kỷ niệm hợp đồng là miễn bồi hoàn; vượt mức đó ngân hàng có thể thu bồi hoàn chi phí. Hãy kiểm tra hợp đồng.",
        hlaskaPrepocetNaNominalni: "Lợi nhuận thực vừa nhập đã được quy đổi thành {vynos} danh nghĩa để so với khoản vay (lạm phát {inflace}). Lãi suất vay là danh nghĩa.",
        hlaskaPoplatkyNezadany: "Chưa nhập phí của khoản đầu tư — đang tính bằng 0. Quỹ thật tốn 1–2 % mỗi năm, nên kết quả đầu tư đang bị thổi lên đúng bằng chừng đó.",
        hlaskaFixaceBezDelky: "Bạn đã nhập lãi suất sau kỳ cố định nhưng chưa nhập độ dài kỳ cố định — nên lãi suất kia sẽ không bao giờ được áp dụng.",
        hlaskaSok: "Đang mô phỏng thị trường sụt {propad} vào năm thứ {rok}.",
        hlaskaObecna: "Phép tính gặp một giá trị không xử lý được. Hãy kiểm tra lại số liệu.",
        krokDluh: "NỢ",
        krokCesta: "HAI ĐƯỜNG",
        krokVysledek: "KẾT QUẢ",
        krokRiziko: "RỦI RO",
        krokOchrana: "BẢO VỆ",
        prezRok: "Năm",
        prezZavrit: "Đóng phần trình bày",
        prezNapoveda: "bấm / → tiếp · Esc kết thúc",
        prezKonec: "Mình tính riêng cho anh chị nhé",
        prezDisclaimer: "Mô phỏng tham khảo, không phải chào bán cũng không phải cam kết chi trả. Con số ràng buộc chỉ có trong hợp đồng, biểu phí và điều khoản bảo hiểm.",
        prezDluhStitek: "Hôm nay anh chị đang nợ",
        prezDluhVeta: "Trả {splatka} mỗi tháng với lãi suất {sazba}.",
        prezDluhUroky: "Tiền lãi anh chị sẽ trả là {castka}, nếu không thay đổi gì",
        prezProtnutoTuk: "Tới đây là đã đủ để trả hết",
        prezProtnutoText: "Khoản đầu tư lần đầu phủ hết phần nợ còn lại — khoảng năm thứ {rok}.",
        prezCestaBezi: "Anh chị nhìn nhé — nợ đi xuống, đầu tư đi lên…",
        prezCestaHotovo: "Khoảng năm thứ {rok} hai đường cắt nhau. Đó là lúc anh chị được chọn. Bấm để xem kết quả →",
        prezCestaNikdy: "Trong khoảng thời gian đã chọn hai đường không cắt nhau — vẫn chưa đủ để trả hết. Bấm để đi tiếp →",
        prezVysledekStitek: "Sau {roky} anh chị còn lại",
        prezVysledekVeta: "Cả hai đường lấy từ ngân sách đúng bằng nhau. Chỉ khác ở chỗ trong thời gian đó tiền nằm ở đâu.",
        prezRizikoStitek: "Còn nếu thị trường không cho gì",
        prezRizikoVeta: "Kịch bản xấu nhất trong các kịch bản đã tính: {scenar}. Số âm nghĩa là đầu tư sẽ kết thúc tệ hơn trả thêm.",
        prezRizikoNeznamo: "Không tính được các kịch bản cho số liệu này.",
        prezOchranaStitek: "Nếu anh chị có chuyện",
        prezOchranaRozpad: "Trong đó khoản vay là {hypoteka} — phần này giảm dần cùng với nợ. Phần còn lại {domacnost} giữ cho gia đình tiếp tục sống.",
        prezOchranaVeta: "Khoảng {cena} mỗi tháng. Mẫu biểu phí, không phải chào giá.",
        prezOchranaVypnuto: "Phần bảo hiểm giảm dần đang tắt. Hãy bật trong máy tính và đi cùng khách qua cả phần này — thiếu nó thì cả chiến lược dựa vào việc không có chuyện gì xảy ra.",
      },
    },
    finMat: {
      freqCtvrtletni: 'Hằng quý',
      freqDenni: 'Hằng ngày',
      freqMesicni: 'Hằng tháng',
      freqRocni: 'Hằng năm',
      rokFew: 'năm',
      rokMany: 'năm',
      rokOne: 'năm',
      tabInvestice: 'Đầu tư',
      tabRenta: 'Thu nhập',
      tabUver: 'Khoản vay / Thế chấp',
      varovaniNekonecnaRenta: 'Khoản rút thấp hơn hoặc bằng lợi nhuận → vốn sẽ không bao giờ cạn (thu nhập vô hạn). 🎉',
      varovaniZapornaAmortizace: 'Khoản trả thấp hơn tiền lãi hằng tháng → khoản vay sẽ không bao giờ trả hết (khấu hao âm). Hãy tăng khoản trả.',
    },
    investStrategie: {
      aktivaAkcie: 'Cổ phiếu (S&P 500)',
      aktivaBtc: 'Bitcoin',
      aktivaDluhopisy: 'Trái phiếu',
      aktivaMsci: 'MSCI World',
      aktivaPt: 'Tiền mặt / thị trường tiền tệ',
      aktivaReit: 'Bất động sản',
      aktivaZlato: 'Vàng',
      akumulacniInsight: 'Thời gian làm dịu rủi ro. Trong 15 năm trở lên, cổ phiếu trong lịch sử luôn thắng mọi thứ khác.',
      akumulacniKdo: 'Cho người trẻ và tầm nhìn dài',
      akumulacniName: 'Tích lũy (100 % cổ phiếu)',
      akumulacniStory: '100 % cổ phiếu trong các ETF tích lũy — cổ tức được tái đầu tư tự động (hiệu quả về thuế). Tầm nhìn càng dài, tỷ trọng cổ phiếu càng cao.',
      coreInsight: 'Phần chính thì rẻ và thụ động, một chút cho lợi nhuận cao hơn. Tỷ lệ chi phí trên kết quả tốt nhất.',
      coreKdo: 'Chuẩn mực của giới chuyên nghiệp và các quỹ',
      coreName: 'Core–Satellite',
      coreStory: 'Phần lõi (80 %) = chỉ số toàn cầu chi phí thấp, tăng đều đến mức nhàm chán. Phần vệ tinh (20 %) = gia vị — chủ đề, vàng, tiền mã hóa.',
      dalioInsight: 'Khi khủng hoảng đến, bạn vẫn ngủ ngon. Biến động nhỏ hơn = ít quyết định hoảng loạn hơn.',
      dalioKdo: 'Bridgewater, quỹ đầu cơ lớn nhất thế giới',
      dalioName: 'Ray Dalio — All Weather',
      dalioStory: 'Danh mục „cho mọi thời tiết“ — cân bằng để sống sót qua tăng trưởng, suy thoái, lạm phát và giảm phát. Cân bằng theo rủi ro, không theo số tiền.',
      milionariInsight: 'Sự giàu có không đến từ tiết kiệm, mà từ việc sở hữu những tài sản tăng giá và trả thu nhập.',
      milionariKdo: 'UBS / Knight Frank Wealth Report',
      milionariName: 'Các triệu phú đô la đầu tư thế nào',
      milionariStory: 'Người giàu không giữ đống tiền mặt — họ sở hữu tài sản: cổ phiếu, bất động sản, doanh nghiệp, vàng. Đa dạng hóa rộng khắp.',
      nobelInsight: 'Đây là danh mục hưởng thu nhập: bạn rút đều mà vốn không giảm. Đúng như khoản thu nhập tương lai của bạn.',
      nobelKdo: 'Trao giải Nobel hơn 120 năm',
      nobelName: 'Quỹ Nobel',
      nobelStory: 'Mỗi năm chi hàng triệu cho giải Nobel — mà vốn hôm nay còn lớn hơn lúc ban đầu. Vì tiền được đem đi đầu tư, không để nằm yên.',
      norskyInsight: 'Một quốc gia dư dả lại chọn đầu tư toàn cầu. Đa dạng hóa và kiên nhẫn.',
      norskyKdo: 'Quỹ nhà nước lớn nhất thế giới (1,8 nghìn tỷ $)',
      norskyName: 'Quỹ dầu mỏ Na Uy',
      norskyStory: 'Na Uy không tiêu tiền dầu mỏ — họ đầu tư cho các thế hệ tương lai vào khoảng 9 000 công ty trên toàn thế giới. Hơn 70 % nằm ở cổ phiếu.',
      rokFew: 'năm',
      rokMany: 'năm',
      rokOne: 'năm',
    },
    pdDisclaimer: {
      titulek: 'Điều khách hàng bắt buộc phải biết',
    },
    pdGraf: {
      let: 'năm',
      popisGrafu: 'Diễn biến giá trị của cả hai phương án theo thời gian',
      zdroj: 'Nguồn: tính toán mô hình từ dữ liệu của tư vấn viên — không phải diễn biến lịch sử hay dự báo.',
    },
    pdModel: {
      horizont: 'Thời hạn (năm)',
      horizontAria: 'Thời hạn tính bằng năm',
      jenPorovnatelna: '— chỉ phần danh mục mà chúng tôi có thể so với phương án của mình trong cùng loại tài sản.',
      kurzPouzit: 'Ngoại tệ được quy đổi theo tỷ giá ngày {datum} ({seznam}). Nguồn: {zdroj}.',
      kurzNepouzit: 'Ngoại tệ không được quy đổi — {duvod} Vì vậy các khoản bằng những loại tiền khác nhau không được cộng gộp.',
      kurzStary: 'bảng tỷ giá ngày {datum} đã cũ hơn 30 ngày.',
      kurzChybi: 'thiếu tỷ giá cho {meny}.',
      kurzBezListku: 'không có bảng tỷ giá hợp lệ.',
      tisk: 'In / PDF',
      tiskTitle: 'In trang hoặc lưu thành PDF',
      smazat: 'Xóa dữ liệu nhập',
      smazatTitle: 'Xóa các bảng và cài đặt mô hình',
      mena: 'Đồng tiền nội địa',
      menaNapoveda: 'theo quốc gia của tổ chức, không theo ngôn ngữ',
      nepocitaSe: 'không tính',
      pocatecniHodnota: 'Giá trị khởi đầu của mô hình',
      popis: 'Lợi suất mô hình là giả định đầu vào của BẠN, không phải dự báo. Ứng dụng không đề xuất lợi suất nào — chưa điền thì không tính mô hình.',
      titulek: '3 · Thiết lập mô hình',
      vklad: 'Khoản nộp hằng tháng',
      vkladNapoveda: 'để trống = không có khoản nộp định kỳ',
      vstupni: 'Phí vào của danh mục hiện tại %',
      vstupniAria: 'Phí vào của danh mục hiện tại',
      vstupniNapoveda: 'chỉ áp dụng cho các khoản nộp TƯƠNG LAI — tiền đã đầu tư không bị thu lại lần nữa',
      vynos: 'Lợi suất gộp mô hình % mỗi năm',
      vynosAria: 'Lợi suất gộp mô hình',
      vynosNapoveda: 'bạn tự điền — ứng dụng không gợi ý gì',
    },
    pdPrazdny: {
      krok1Nadpis: 'Chép lại các vị thế của khách hàng',
      krok1Popis: 'Từ sao kê tài khoản hoặc cổng thông tin của nhà phân phối. ISIN là tùy chọn — nếu nhập, chữ số kiểm tra sẽ được xác thực.',
      krok2Nadpis: 'Điền chi phí lấy từ KID',
      krok2Popis: 'Mỗi quỹ đều có KID (tài liệu thông tin chính). Phí thường xuyên và chi phí khi vào nằm ở mục Chi phí, mức rủi ro 1–7 nằm ở mục Chỉ số rủi ro tổng hợp.',
      krok3Nadpis: 'Nhập phương án của chúng ta và mô hình',
      krok3Popis: 'Chi phí chiến lược của chúng ta do bạn nhập — ứng dụng không biết. Sau đó đặt thời hạn và lợi suất gộp mô hình.',
      pridatPrvni: 'Thêm vị thế đầu tiên',
      proc: 'Ứng dụng không biết chi phí của bất kỳ quỹ nào — không tra theo ISIN, cũng không ước lượng theo loại quỹ. Mọi con số đều do bạn nhập từ nguồn có thể chứng minh. Nhờ vậy kết quả đứng vững trước khách hàng và trước cơ quan giám sát.',
      titulek: 'Chưa có gì để tính',
    },
    pdRozlozeni: {
      bezKategorie: 'Chưa xác định loại',
      bezMeny: 'Chưa điền tiền tệ',
      kategoriePopis: 'Theo các loại bạn đã nhập. Chúng tôi không tính phần trùng lặp của từng cổ phiếu bên trong các quỹ — nếu không có danh mục thật của quỹ thì đó chỉ là con số bịa.',
      kategorieTitulek: 'Phân bổ theo loại tài sản',
      menyPopis: 'Chỉ từ dữ liệu đã điền. Tiền tệ còn thiếu không bị mặc định thành koruna — nó vào mục “chưa xác định”.',
      menyTitulek: 'Phân bổ theo tiền tệ',
    },
    pdTabulka: {
      hodnota: 'Giá trị',
      hodnotaNapoveda: 'khách hàng đang giữ bao nhiêu',
      isin: 'ISIN',
      isinNapoveda: 'tùy chọn — từ sao kê hoặc từ KID',
      kategorie: 'Loại quỹ',
      kategorieNapoveda: 'chỉ so sánh trong cùng một loại',
      mena: 'Tiền tệ',
      menaNapoveda: 'tiền tệ của vị thế',
      nazev: 'Tên quỹ',
      nazevNapoveda: 'đúng như trên sao kê',
      neuveden: 'chưa nêu',
      prazdno: 'Chưa có gì — hãy thêm dòng đầu tiên.',
      pridatRadek: 'Thêm dòng',
      smazatRadek: 'Xóa dòng',
      sri: 'Rủi ro 1–7',
      sriNapoveda: 'KID, chỉ số rủi ro tổng hợp',
      ter: 'TER % mỗi năm',
      terNapoveda: 'KID, mục Chi phí — phí thường xuyên',
      vstupni: 'Phí vào %',
      vstupniNapoveda: 'KID, mục Chi phí — chi phí khi vào',
      zdroj: 'Nguồn của con số',
      zdrojEmt: 'EMT (có chứng từ)',
      zdrojKatalog: 'danh mục — chỉ mang tính tham khảo',
      zdrojKid: 'KID (có chứng từ)',
      zdrojNapoveda: 'chỉ KID hoặc EMT mới được coi là có chứng từ',
      zdrojPoradce: 'do tư vấn viên nhập',
    },
    pdVerdikt: {
      hodnota: 'giá trị',
      hodnotaPonechat: 'Giá trị có kết luận giữ nguyên',
      keZvazeni: 'cần cân nhắc',
      nakladovostPolozky: 'Chi phí của vị thế',
      naseVarianta: 'phương án của chúng ta',
      nescitaSe: 'không cộng gộp (nhiều loại tiền)',
      popis: 'Tài liệu để trao đổi với khách hàng, không phải khuyến nghị đầu tư hay lệnh bán. Chỉ so sánh trong cùng một loại tài sản.',
      rozdil: 'chênh lệch',
      stitekNelze: 'Không thể đánh giá',
      stitekPonechat: 'Giữ nguyên',
      stitekZvazit: 'Cân nhắc thay đổi',
      stretZajmu: 'Xung đột lợi ích: chúng tôi so sánh với sản phẩm do chính chúng tôi phân phối và được trả hoa hồng khi ký hợp đồng.',
      titulek: 'Kết luận theo từng vị thế',
    },
    pdVety: {
      aDalsi: 'và {n} mục nữa',
      bezHodnoty: 'Có {n} {polozek} chưa điền giá trị.',
      bezKategorie: 'Có {n} {polozek} chưa xác định loại.',
      bezMeny: 'Có {n} {polozek} chưa điền loại tiền.',
      bezTer: 'Chúng ta chưa biết chi phí của {n} {polozek}.',
      duvodBezReference: 'Chúng ta chưa có phương án của mình với chi phí đã điền — thiếu nó thì không so sánh được. Hãy bổ sung từ KID.',
      duvodMichaneMeny: 'Các mục có thể so sánh nằm ở nhiều loại tiền và chưa quy đổi. Hệ thống không biết tỷ giá nên không cộng lại — hãy thống nhất một loại tiền, hoặc mô hình từng loại riêng.',
      duvodNulovaHodnota: 'Tất cả các mục có thể so sánh đều có giá trị bằng không và chi phí lại khác nhau — không thể tính bình quân gia quyền.',
      duvodPrazdno: 'Danh mục đang trống — không tính mô hình.',
      duvodZadnaShoda: 'Không mục nào của khách hàng có phương án của chúng ta trong cùng một loại với chi phí đã biết. Không so sánh giữa các loại khác nhau — hãy thêm phương án của chúng ta vào loại mà bạn muốn đánh giá.',
      koncentrace: 'Đây là mức tập trung cao — không phải lỗi, nhưng hãy hỏi khách hàng về điều đó.',
      menySeznam: 'Loại tiền: {seznam}. Không tính được tỷ trọng — thiếu giá trị.',
      modelujeCast: 'Chỉ phần danh mục có thể so sánh được đưa vào mô hình — {z} % giá trị của danh mục.',
      modelujeVse: 'Toàn bộ danh mục được đưa vào mô hình.',
      nakladovostNejde: 'Không tính được chi phí của danh mục — chúng ta không biết chi phí của bất kỳ mục nào.',
      nakladovostNulaHodnot: 'Không thể tính bình quân gia quyền của chi phí — tất cả các mục đều có giá trị bằng không.',
      nejvetsiKategorie: 'Loại lớn nhất „{kategorie}“ chiếm {podil} danh mục.',
      nevstupujeFew: 'không tham gia',
      nevstupujeMany: 'không tham gia',
      nevstupujeOne: 'không tham gia',
      orientacniHlavniCislo: 'Một phần chi phí chưa được chứng minh bằng KID hay EMT — vì vậy con số chính chỉ mang tính tham khảo.',
      orientacniTer: 'Chi phí của {n} {polozek} chỉ mang tính tham khảo — hãy kiểm tra trong KID.',
      podilyNejdou: 'Không tính được tỷ trọng — thiếu giá trị.',
      polozkaBezNazvu: 'mục không có tên',
      polozkaBezNazvuCislo: 'Mục không có tên{cislo}',
      polozkaFew: 'mục',
      polozkaMany: 'mục',
      polozkaOne: 'mục',
      porovnaniVKategorii: 'Mỗi mục được so sánh với phương án của chúng ta trong cùng một loại — không so sánh giữa các loại khác nhau.',
      prazdnePortfolio: 'Danh mục đang trống.',
      rokFew: 'năm',
      rokMany: 'năm',
      rokOne: 'năm',
      rozdilZa: 'Chênh lệch sau {roky} {rok}',
      souhrnNelze: '{n}× không thể đánh giá',
      souhrnPonechat: '{n}× giữ nguyên',
      souhrnZvazit: '{n}× cân nhắc thay đổi',
      spocitanoZ: 'Được tính từ {z} % giá trị danh mục.',
      uPolozkyFew: 'mục',
      uPolozkyMany: 'mục',
      uPolozkyOne: 'mục',
      vazenaNakladovostVeta: 'Chi phí bình quân gia quyền của danh mục {pct} % mỗi năm',
      viceMenHodnoty: 'Các giá trị ở nhiều loại tiền và chưa quy đổi — tỷ trọng chỉ mang tính tham khảo.',
      viceMenPodily: 'Danh mục có nhiều loại tiền và chưa quy đổi — tỷ trọng chỉ mang tính tham khảo.',
      viceMenVahy: 'Danh mục có nhiều loại tiền và chưa quy đổi — trọng số chỉ mang tính tham khảo.',
      vynechaneVeta: '{n} {polozek} {nevstupuje} vào mô hình: {vypis}.',
      vynechanoBezHodnoty: 'chưa điền giá trị',
      vynechanoBezKategorie: 'chưa xác định loại',
      vynechanoBezReference: 'trong loại của mục này chúng ta không có phương án để so sánh',
      vynechanoBezTer: 'không biết chi phí',
      vynechanoBezTerReference: 'không biết chi phí phương án của chúng ta',
      vynechanoJineRiziko: 'mức rủi ro khác biệt rõ rệt',
      zadnaMena: 'Chưa có mục nào được điền loại tiền.',
    },
    pdVysledek: {
      doModelaceVstupuje: 'Đưa vào mô hình',
      doplnVstupy: 'Hãy điền các dữ liệu đầu vào của mô hình.',
      hodnotaNaKonci: 'giá trị ở cuối kỳ',
      hodnotyPortfolia: 'giá trị danh mục',
      klientVyhral: 'Danh mục hiện tại rẻ hơn về chi phí. Vậy chi phí không phải lý do để chuyển.',
      lepeVychazi: 'Phương án tốt hơn: {popis}',
      nepocitaSe: 'Mô hình chưa được tính',
      neuvedeno: 'chưa nêu',
      porovnatelnaNase: 'Phần so sánh được — các phương án của chúng ta',
      porovnatelnaSoucasne: 'Phần so sánh được — danh mục hiện tại',
      referenceBezNakladu: 'Mốc tham chiếu hoàn toàn không có chi phí',
      rozdilPorovnatelne: 'Chênh lệch trong phần so sánh được',
      rozpadModelace: 'Chi tiết mô hình',
      rozpadPopis: 'Phí đã trả và lợi nhuận bị mất là HAI con số KHÁC NHAU. Lợi nhuận bị mất còn bao gồm phần mà số tiền đã trả lẽ ra kiếm thêm được — đừng gọi nó là phí. Phí vào mà khách hàng từng trả lúc tham gia KHÔNG được tính lại vào danh mục hiện tại — đó là chi phí chìm.',
      spocitanoZ: 'tính từ',
      stejnyVynosPoznamka: 'Cả hai phương án đều tính với cùng mức lợi nhuận gộp {vynos} mỗi năm. Vì vậy mô hình so sánh CHI PHÍ, không phải khả năng sinh lời của các quỹ. Đây là phép tính mô hình, không phải lời hứa về lợi nhuận.',
      uslyVynos: 'lợi nhuận bị mất (kể cả lãi kép)',
      vazenaNakladovost: 'Chi phí bình quân gia quyền của danh mục',
      vazenaPopis: 'Trọng số theo giá trị vị thế. Vị thế chưa biết chi phí KHÔNG được tính vào bình quân — không thay bằng số không.',
      vlozenoCelkem: 'Tổng đã nộp',
      vyvojVCase: 'Diễn biến giá trị theo thời gian',
      zanedbatelny: 'Chênh lệch không đáng kể',
      zaplacenePoplatky: 'phí đã thực trả',
    },
    portfolioDoktor: {
      karta1: '1 · Danh mục của khách hàng',
      karta1Popis: 'Bạn gõ thẳng vào bảng — không cửa sổ phụ, không phải bấm vào chi tiết. Ô trống nghĩa là “không biết”, không phải số không.',
      karta2: '2 · Chiến lược của chúng ta để so sánh',
      karta2Popis: 'Chi phí phương án của chúng ta do bạn nhập — không có sẵn ở đâu cả. Việc so sánh luôn diễn ra trong cùng một loại tài sản, nên hãy thêm một dòng cho mỗi loại bạn muốn xem xét.',
      kteraVarianta: 'Phương án nào được đưa vào mô hình',
      nadrazenaSekce: 'Công cụ',
      naseVarianty: 'Các phương án của chúng ta (theo loại tài sản)',
      porovnatelnaCast: 'Phần so sánh được của danh mục hiện tại',
      pridejVariantu: 'Hãy thêm phương án của chúng ta, nếu không thì không có gì để so sánh.',
      soucasnePortfolio: 'Danh mục hiện tại',
      stretZajmu: 'Xung đột lợi ích: chúng tôi so sánh với sản phẩm do chính chúng tôi phân phối và được trả hoa hồng khi ký hợp đồng. Vì vậy công cụ được phép kết luận “giữ nguyên” — và khi kết quả là vậy, nó sẽ nói thẳng.',
      titulek: 'Bác sĩ danh mục',
      uvod1: 'Ghi lại khách hàng đang giữ gì, thêm chi phí từ KID và bạn sẽ thấy danh mục tốn của họ bao nhiêu và tạo ra chênh lệch bao nhiêu trong cả thời hạn.',
      uvod2: 'Ứng dụng không biết chi phí của bất kỳ quỹ nào',
      uvod3: '— bạn nhập các con số từ nguồn có thể chứng minh.',
      vseZKid: 'Tất cả từ KID',
      vseZKidTitle: 'Đánh dấu các chi phí đã điền là có chứng từ từ KID',
    },
    provize: {
      add: 'Thêm sản phẩm',
      amount: 'số tiền',
      koef: 'Hệ số',
      kpi1: 'Hoa hồng năm thứ 1',
      kpi5: 'Tổng trong 5 năm',
      kpi5Sub: 'Năm thứ 1 + 4× lặp lại',
      kpiRep: 'Lặp lại / năm',
      kpiRepSub: 'chăm sóc + phí',
      notFound: 'Không tìm thấy gì',
      note: '💡 Tính toán mang tính tham khảo theo danh mục. Điều kiện chính xác theo phụ lục hoa hồng trên cổng thông tin. “Lặp lại” = BJ chăm sóc (xe/tài sản từ năm 2, đầu tư thu phí quản lý, bảo hiểm nhân thọ từ năm 6).',
      pick: '— chọn sản phẩm —',
      pos: 'Vị trí của bạn',
      repeat: 'lặp lại',
      sample: 'mẫu',
      sub: 'Nhập vị trí và sản phẩm → bạn sẽ thấy hoa hồng năm đầu và hoa hồng lặp lại. 201 sản phẩm từ danh mục BJ · hoa hồng = BJ × hệ số.',
      title: 'Máy tính hoa hồng',
      tools: 'Công cụ',
      year1: 'Năm thứ 1',
    },
    srovnavacFondu: {
      coSniPoplatky: 'Phần bị phí ăn mất',
      disclaimer: 'Mức TER và phí vào chỉ mang tính tham khảo — hãy kiểm chứng trong KIID / biểu phí hiện hành. Dùng cùng một lợi suất gộp cho cả hai là để tách riêng yếu tố chi phí; các quỹ thực tế có thể bám theo những chỉ số khác nhau. Hiệu suất quá khứ không đảm bảo hiệu suất tương lai.',
      disclaimerTuk: 'Đây là tính toán mô hình, không phải cam kết lợi nhuận.',
      hintA: 'quỹ / ETF của chúng ta',
      hintB: 'quỹ của khách hàng',
      hledatPlaceholder: 'Nhập quỹ của khách hàng… (ví dụ “dynamický”)',
      hrubyVynos: 'Lợi suất gộp',
      nadrazenaSekce: 'Công cụ',
      nicNenalezeno: 'Không tìm thấy gì — hãy chọn quỹ tự nhập và điền TER thủ công.',
      rok: 'Năm',
      ter: 'TER (chi phí hằng năm)',
      uvod1: 'Tìm quỹ của khách hàng trong ô gợi ý (chỉ cần một phần tên, không cần dấu) và so với quỹ của chúng ta — phí ăn mất bao nhiêu lợi nhuận. Cùng một lợi suất gộp giả định cho cả hai, nên bạn thấy thuần túy',
      uvod2: 'chênh lệch về chi phí',
      uvod3: '. Không dùng AI, tính ngay tại đây.',
      vicNaKonci: 'NHIỀU HƠN Ở CUỐI',
      vlastniFond: 'Quỹ tự nhập',
      vlastniFondRucne: 'Quỹ tự nhập (điền TER thủ công)',
      vlozenoCelkem: 'Tổng đã nộp',
      vstupni: 'phí vào',
      vstupniPoplatek: 'Phí vào',
      vstupniProc: 'Phí vào %',
      vyvojHodnoty: 'Diễn biến giá trị',
      zisk: 'Lợi nhuận',
    },
  },
  /* === /NASTROJE === */
  /* === ANALÝZA V2+ — stavová lišta ukládání (lib/analyzaV2/stavUkladani.js) === */
  /* BLOK:analyza START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyza: {
    instituceVyber: {
      nabidka: 'Danh sách tổ chức',
      sipka: 'Hiện toàn bộ danh sách',
    },
    propis: {
      ceka: 'Đang chờ chuyển vào hồ sơ: {n}',
      chyba: 'Hiện chưa chuyển được vào hồ sơ khách hàng, tôi sẽ thử lại',
      hotovo: 'Đã chuyển vào hồ sơ',
      hotovoNove: 'mới: {n}',
      hotovoUpravene: 'đã sửa: {n}',
      klid: 'Hồ sơ khách hàng đã khớp với bản phân tích',
      nehotove: 'Các dòng chưa xong đang chờ bổ sung: {n}',
      nepropisovane: 'Tài khoản và tiền mặt chưa được chuyển vào hồ sơ: {n}',
      probiha: 'Đang chuyển vào hồ sơ khách hàng…',
      smazane: 'Dòng đã xóa khỏi bản phân tích vẫn còn trong hồ sơ: {n}',
    },
    uklad: {
      ceka: 'Đang chờ lưu',
      cekaDetail: 'Thay đổi cuối cùng chưa có trên máy chủ.',
      nepovedlo: 'Chưa lưu — đang thử lại',
      nepovedloDetail: 'Lần thử {n}, lần sau {s} giây',
      nepovedloPokus: 'Lần thử {n}',
      obnova: 'Đã tìm thấy thay đổi chưa lưu — khôi phục?',
      obnovaAno: 'Khôi phục',
      obnovaNe: 'Bỏ qua',
      obnovaSCasem: 'Đã tìm thấy thay đổi chưa lưu từ {cas} — khôi phục?',
      uklada: 'Đang lưu…',
      ulozeno: 'Đã lưu',
      zastaveno: 'Không lưu — phân tích chưa tải được',
      zastavenoDetail: 'Hãy tải lại trang để dữ liệu không bị ghi đè.',
    },
  },
  /* BLOK:analyza END */
  /* KẾ HOẠCH KHỦNG HOẢNG — xem chú thích trong cs.js. Không câu nào được hứa thay công ty bảo hiểm. */
  krize: {
    nadpis: 'Kế hoạch khủng hoảng',
    podnadpis: 'Làm gì khi có chuyện xảy ra',
    uvod1: 'Hãy giữ lại phần này. Nó không dành cho hôm nay — nó dành cho ngày bạn cần đến nó.',
    uvod2: 'Ở đây không có gì phải làm ngay lập tức. Thứ tự luôn giống nhau: lo cho bản thân, gọi cho tôi, báo cho công ty bảo hiểm.',
    proKoho: 'Kế hoạch khủng hoảng cho {jmeno}',
    platnost: 'Lập ngày {datum} theo các hợp đồng có trong hồ sơ tại thời điểm đó.',

    kontaktNadpis: 'Hãy gọi cho tôi trước',
    kontaktText: 'Bạn không cần biết hợp đồng nào ký ở đâu, cũng không cần biết viết cho ai. Việc đó là của tôi.',
    kontaktRole: 'Chuyên viên tư vấn của bạn',
    kontaktFirma: 'Công ty',
    kontaktTelefon: 'Điện thoại',
    kontaktEmail: 'E-mail',
    kontaktWeb: 'Trang web',
    kontaktRezervace: 'Hẹn gặp',

    krokyNadpis: 'Các bước',
    podkladyNadpis: 'Cần chuẩn bị gì',
    pozorNadpis: 'Cần lưu ý',
    smlouvyNadpis: 'Các hợp đồng có thể liên quan',
    smlouvaBezCisla: 'chưa có số hợp đồng',
    smlouvaBezInstituce: 'chưa có tên tổ chức',
    bezSmluv: 'Với rủi ro này tôi không thấy hợp đồng nào trong hồ sơ của bạn. Điều đó không có nghĩa là bạn không có — nghĩa là chúng ta phải cùng tìm lại.',
    bezSmluvVse: 'Trong hồ sơ không có hợp đồng bảo hiểm nào. Các bước bên dưới vẫn đúng; chỉ là trước hết chúng ta cùng xem bạn thực sự đang có những gì.',
    navrhNavic: 'Đề xuất thêm',

    pravniNadpis: 'Căn cứ ở đâu',
    pravniOvereno: 'đã kiểm chứng',
    disclaimer1: 'Bản tóm tắt này nói CẦN LÀM GÌ. Nó không nói công ty bảo hiểm có trả hay trả bao nhiêu — điều đó theo nội dung hợp đồng của bạn và các điểm loại trừ. Chúng ta sẽ cùng đọc lại.',
    disclaimer2: 'Các điều luật nêu ở đây là quy tắc chung, không phải lời hứa chi trả. Thời hạn và điều kiện thì mỗi hợp đồng một khác.',
    disclaimer3: 'Các bước dựa trên pháp luật Séc. Hợp đồng ký ở nước khác theo quy định của nước đó.',

    chybiNadpis: 'Trước khi gửi cho khách hàng',
    chybiKontaktVse: 'Hồ sơ tư vấn viên không có số điện thoại lẫn e-mail công khai. Kế hoạch khủng hoảng mà thiếu liên hệ thì vô nghĩa — hãy bổ sung trong phần Cài đặt.',
    chybiJmeno: 'Thiếu tên tư vấn viên.',
    chybiTelefon: 'Thiếu số điện thoại tư vấn viên.',
    chybiEmail: 'Thiếu e-mail công khai của tư vấn viên.',
    chybiWeb: 'Thiếu trang web của tư vấn viên.',
    chybiRezervace: 'Thiếu liên kết đặt lịch hẹn — hãy bổ sung danh thiếp hoặc lịch.',
    chybiSmlouvy: 'Trong hồ sơ không có hợp đồng bảo hiểm nào.',
    chybiCislaSmluv: 'Một số hợp đồng thiếu số hợp đồng. Khách hàng lúc khủng hoảng sẽ không đi tìm.',

    pravni: {
      oznameni: 'Sự kiện bảo hiểm phải được báo cho công ty bảo hiểm không chậm trễ quá mức.',
      setreni: 'Sau khi nhận báo, công ty bảo hiểm bắt đầu điều tra không chậm trễ quá mức. Kết quả, lý giải mức chi trả hoặc lý do từ chối được thông báo bằng văn bản.',
      splatnost: 'Nếu hợp đồng không thỏa thuận khác, tiền bảo hiểm đến hạn trong vòng mười lăm ngày kể từ ngày KẾT THÚC điều tra. Đó không phải thời hạn giải quyết toàn bộ vụ việc.',
      zaloha: 'Nếu không thể kết thúc điều tra trong ba tháng kể từ ngày báo, công ty bảo hiểm nêu lý do bằng văn bản và theo yêu cầu sẽ tạm ứng một khoản hợp lý.',
      stupne: 'Mức độ mất sức lao động xác định theo tỷ lệ suy giảm: mức I 35–49 %, mức II 50–69 %, mức III ít nhất 70 %.',
      nahradaMzdy: 'Trong 14 ngày dương lịch đầu tiên nghỉ ốm, người lao động nhận tiền bù lương từ người sử dụng lao động.',
      zadostID: 'Đơn xin trợ cấp mất sức lao động được lập tại cơ quan bảo hiểm xã hội khu vực hoặc nộp trực tuyến. Tình trạng sức khỏe do bác sĩ giám định đánh giá, thường dựa trên hồ sơ. Thời hạn luật định để ra quyết định là 90 ngày.',
    },

    uraz_nemoc: {
      nadpis: 'Tai nạn hoặc ốm đau — nghỉ ốm ngắn ngày',
      kdy: 'Bạn đang nghỉ ốm ở nhà và dự tính vài tuần nữa sẽ đi làm lại.',
      kroky: [
        { n: 'Xin giấy nghỉ ốm', d: 'Bác sĩ điều trị cấp giấy này bằng điện tử. Bạn không phải mang giấy tờ đến chỗ làm.' },
        { n: 'Báo cho người sử dụng lao động', d: 'Chỉ cần nhắn từ ngày nào bạn bắt đầu nghỉ ốm.' },
        { n: 'Liên hệ với tôi', d: 'Chúng ta cùng xem lại các hợp đồng và xác định hợp đồng nào áp dụng cho trường hợp này.' },
        { n: 'Báo cho công ty bảo hiểm', d: 'Điều 2796 Bộ luật Dân sự yêu cầu báo không chậm trễ quá mức. Nếu bạn chưa rõ cách làm, chúng ta sẽ báo cùng nhau.' },
        { n: 'Giữ lại mọi giấy tờ', d: 'Kết luận của bác sĩ, hóa đơn thuốc, giấy xác nhận thời gian nghỉ ốm. Sau này xin lại khó hơn nhiều.' },
      ],
      podklady: [
        'Số hợp đồng bảo hiểm',
        'Giấy tờ tùy thân',
        'Số tài khoản để nhận tiền',
        'Giấy xác nhận nghỉ ốm — từ ngày nào đến ngày nào',
        'Kết luận y tế về tai nạn hoặc bệnh',
      ],
      pozor: 'Trong 14 ngày dương lịch đầu tiên, người sử dụng lao động trả tiền bù lương; từ ngày thứ 15 cơ quan bảo hiểm xã hội trả trợ cấp ốm đau. Người tự kinh doanh chỉ nhận trợ cấp nếu có đóng bảo hiểm ốm đau tự nguyện. Thời gian chờ trong hợp đồng bảo hiểm lại là chuyện khác — mỗi hợp đồng một khác và chúng ta sẽ tìm trong hợp đồng của bạn.',
    },

    dlouhodoba_pn: {
      nadpis: 'Nghỉ ốm dài ngày',
      kdy: 'Thời gian nghỉ ốm kéo dài hàng tháng và rõ ràng đây không phải chuyện hai tuần.',
      kroky: [
        { n: 'Gọi cho tôi trước khi hết tiền', d: 'Biết càng sớm thì càng làm được nhiều với ngân sách và các khoản trả góp.' },
        { n: 'Chúng ta tính phần thiếu hụt mỗi tháng', d: 'Trợ cấp ốm đau chỉ thay thế một phần thu nhập thực nhận. Phần chênh lệch chính là thứ phải bù.' },
        { n: 'Yêu cầu trợ cấp theo ngày từ hợp đồng', d: 'Quyền lợi nghỉ ốm và quyền lợi tai nạn theo ngày được yêu cầu riêng — kể cả khi bạn đã báo tai nạn một lần.' },
        { n: 'Báo cho ngân hàng kịp thời', d: 'Xin hoãn trả góp phải làm trước khi trễ hạn. Sau một kỳ trễ hạn thì khó hơn hẳn.' },
        { n: 'Chúng ta hẹn buổi kiểm tra lại', d: 'Nghỉ ốm dài ngày thì tình hình thay đổi từng tháng. Tôi không muốn bạn tự theo dõi một mình.' },
      ],
      podklady: [
        'Quyết định nghỉ ốm (tạm thời không làm việc được)',
        'Các kết luận y tế theo từng đợt khám',
        'Số các hợp đồng bảo hiểm',
        'Bảng các khoản trả góp và lệnh chuyển tiền định kỳ',
        'Sao kê tài khoản những tháng gần đây',
      ],
      pozor: 'Trợ cấp ốm đau không được trả mãi mãi — thời gian hưởng có giới hạn, độ dài và khả năng gia hạn do cơ quan bảo hiểm xã hội xét theo hoàn cảnh của bạn. Chúng ta sẽ cùng kiểm tra để biết khi nào phải tính bước tiếp theo.',
    },

    zavazne_onemocneni: {
      nadpis: 'Bệnh hiểm nghèo',
      kdy: 'Chẩn đoán thuộc nhóm ung thư, nhồi máu cơ tim hay đột quỵ. Các bệnh này thường được liệt kê thẳng trong hợp đồng.',
      kroky: [
        { n: 'Chữa bệnh trước đã', d: 'Không có bước nào bên dưới phải làm ngay chiều nay. Giấy tờ chờ được vài ngày.' },
        { n: 'Gọi cho tôi', d: 'Chúng ta xem chẩn đoán của bạn có nằm trong danh sách được bảo hiểm không. Danh sách mỗi hợp đồng một khác.' },
        { n: 'Xin kết luận y tế ghi rõ chẩn đoán', d: 'Kèm ngày xác định chẩn đoán. Không có nó thì không chứng minh được sự kiện bảo hiểm.' },
        { n: 'Báo cho công ty bảo hiểm', d: 'Không chậm trễ quá mức, điều 2796 Bộ luật Dân sự. Chúng ta cùng điền đơn.' },
        { n: 'Xử lý cả phần thu nhập bị mất', d: 'Bệnh hiểm nghèo thường kèm theo nghỉ ốm dài ngày. Chúng ta yêu cầu cả hai, không chỉ một.' },
      ],
      podklady: [
        'Kết luận y tế có chẩn đoán và ngày tháng',
        'Giấy ra viện',
        'Kết quả xét nghiệm mà kết luận dẫn chiếu',
        'Số hợp đồng bảo hiểm và giấy tờ tùy thân',
        'Số tài khoản để nhận tiền',
      ],
      pozor: 'Mỗi hợp đồng có danh sách bệnh riêng, định nghĩa riêng và thời gian chờ riêng. Điều gì áp dụng cho bạn thì chúng ta đọc thẳng trong hợp đồng của bạn — không thể nói chung chung.',
    },

    invalidita: {
      nadpis: 'Mất sức lao động',
      kdy: 'Sức khỏe suy giảm lâu dài và việc trở lại công việc như trước là không thực tế.',
      kroky: [
        { n: 'Gọi cho tôi ngay từ đầu, đừng đợi đến cuối', d: 'Từ lúc nộp đến lúc có quyết định là nhiều tháng. Trong thời gian đó vẫn làm được nhiều việc với ngân sách và các khoản trả góp.' },
        { n: 'Nộp đơn xin trợ cấp mất sức lao động', d: 'Đơn được lập tại cơ quan bảo hiểm xã hội khu vực, hoặc nộp trực tuyến.' },
        { n: 'Chuẩn bị hồ sơ y tế từ trước', d: 'Bác sĩ giám định đánh giá sức khỏe, thường dựa trên hồ sơ. Hồ sơ càng đầy đủ thì thủ tục càng trôi chảy.' },
        { n: 'Biết rõ người ta đang quyết định điều gì', d: 'Về mức độ theo tỷ lệ suy giảm khả năng lao động: mức I 35–49 %, mức II 50–69 %, mức III ít nhất 70 %. Thời hạn luật định để ra quyết định là 90 ngày.' },
        { n: 'Mang quyết định đến công ty bảo hiểm', d: 'Phần lớn hợp đồng dẫn chiếu tới mức đã được công nhận. Hãy giữ quyết định, đó là giấy tờ quan trọng nhất.' },
      ],
      podklady: [
        'Giấy tờ tùy thân',
        'Hồ sơ y tế đầy đủ',
        'Giấy tờ về học vấn và bảng quá trình làm việc',
        'Phiếu khai nghề nghiệp do cơ quan bảo hiểm xã hội gửi',
        'Quyết định công nhận mất sức lao động và số hợp đồng bảo hiểm',
      ],
      pozor: 'Việc nhà nước công nhận mất sức lao động và việc công ty bảo hiểm chi trả là hai thủ tục riêng. Công ty bảo hiểm xét theo nội dung hợp đồng của bạn và có thể kết luận khác nhà nước. Chính vì vậy đừng tự mình xoay xở.',
    },

    umrti: {
      nadpis: 'Tử vong',
      kdy: 'Phần này do người thân đọc. Ở đây không có gì phải hoàn thành trong hôm nay.',
      kroky: [
        { n: 'Chỉ lo những việc bắt buộc', d: 'Giấy chứng tử do cơ quan hộ tịch cấp, thường do nhà tang lễ lo. Hãy xin nhiều bản, vì sẽ cần ở nhiều nơi.' },
        { n: 'Gọi cho tôi', d: 'Bạn không cần biết hợp đồng nào ký ở đâu. Tôi có danh sách những hợp đồng chúng tôi đã làm và sẽ cùng bạn xem lại.' },
        { n: 'Báo cho các công ty bảo hiểm', d: 'Điều 2796 Bộ luật Dân sự yêu cầu báo không chậm trễ quá mức. Chúng ta sẽ báo cùng nhau, kể cả hợp đồng ở nơi khác.' },
        { n: 'Nộp đơn xin trợ cấp tuất', d: 'Trợ cấp cho vợ, cho chồng hay cho con không tự phát sinh — mỗi loại đều phải nộp đơn tại cơ quan bảo hiểm xã hội.' },
        { n: 'Đừng vội với những quyết định lớn', d: 'Bán nhà, hủy hợp đồng, trả hết khoản vay. Không việc nào thuộc về mấy tuần đầu.' },
      ],
      podklady: [
        'Giấy chứng tử — nên xin nhiều bản',
        'Giấy tờ tùy thân của người thân đứng ra làm thủ tục',
        'Số các hợp đồng bảo hiểm và hợp đồng vay',
        'Giấy đăng ký kết hôn, giấy khai sinh của các con',
        'Số tài khoản để nhận tiền',
      ],
      pozor: 'Nợ không tự mất đi khi người vay qua đời, nợ được giải quyết trong thủ tục thừa kế. Ở một số khoản vay, bảo hiểm khả năng trả nợ nằm ngay trong hợp đồng vay chứ không nằm trong hợp đồng nhân thọ. Vì vậy chúng ta sẽ liên hệ cả ngân hàng.',
    },

    skoda_na_majetku: {
      nadpis: 'Thiệt hại tài sản',
      kdy: 'Ngập nước, cháy, giông bão, trộm đột nhập — hoặc thiệt hại bạn gây ra cho người khác.',
      kroky: [
        { n: 'Chặn thiệt hại lại nếu làm được an toàn', d: 'Khóa nước, ngắt điện. Nếu có nguy hiểm, hãy gọi 112.' },
        { n: 'Chụp ảnh mọi thứ trước khi bắt đầu dọn dẹp', d: 'Ảnh và video là bằng chứng mạnh nhất. Đừng vứt đồ hư hỏng trước khi công ty bảo hiểm nhìn thấy.' },
        { n: 'Trộm đột nhập hay tai nạn giao thông thì gọi cảnh sát', d: 'Không có biên bản của cảnh sát thì thiệt hại loại này rất khó chứng minh.' },
        { n: 'Báo cho công ty bảo hiểm và liên hệ với tôi', d: 'Không chậm trễ quá mức, điều 2796 Bộ luật Dân sự. Tôi sẽ giúp cả phần liệt kê thiệt hại lẫn phần điền đơn.' },
        { n: 'Liệt kê thiệt hại theo từng món', d: 'Là món gì, mua khi nào, giá bao nhiêu. Hóa đơn, chứng từ, phiếu bảo hành — có gì lấy nấy.' },
      ],
      podklady: [
        'Ảnh và video phần hư hỏng',
        'Bảng liệt kê đồ hư hỏng kèm giá trị',
        'Hóa đơn, chứng từ, phiếu bảo hành',
        'Số hợp đồng bảo hiểm và giấy tờ tùy thân',
        'Biên bản cảnh sát khi bị trộm hoặc tai nạn',
      ],
      pozor: 'Đừng bắt đầu sửa chữa trước khi thống nhất với công ty bảo hiểm — nhiều hợp đồng bắt buộc phải có giám định viên xem trước. Và nếu bạn gây thiệt hại cho người khác, đừng nhận trách nhiệm hay trả tiền trước khi chúng ta cùng xem lại.',
    },
  },

  /* === AUTO: klíče vytažené z jazykových ternárů (scripts/i18n-ternary-codemod.js) === */
  /* BLOK:auto START — generuje scratchpad/slovnik.py, ručně needitovat */
  auto: {
    aIEmailBulkModal: {
      aiFiltrujePise: 'AI đang lọc + viết…',
      cileni: 'Nhắm đối tượng:',
      hromadnyAiMailSmartemailing: 'Gửi thư hàng loạt bằng AI (Smartemailing miễn phí)',
      jmeno: 'Tên',
      klientu: 'khách hàng',
      klientuOdpovidaFiltru: 'khách hàng khớp bộ lọc',
      klientumOtazka: 'khách hàng không?',
      n2NahledEmailuPlaceholders: '2. Xem trước email (các trường thay thế được điền khi gửi)',
      odeslano: 'Đã gửi:',
      opravduOdeslatEmail: 'Bạn có chắc muốn gửi email cho',
      osloveni: 'Xưng hô',
      poradce: 'Chuyên viên tư vấn',
      posliVsemCoNemaji: 'Gửi cho tất cả những ai chưa có quỹ hưu trí rằng đang có ưu đãi + CTA gọi điện…',
      prepsano: 'Đã chuyển thành văn bản',
      prijemci: 'Người nhận',
      prijmeni: 'Họ',
      prikladyPosliVipKlientum: 'Ví dụ: „gửi khách hàng VIP bản tin về ČNB“ · „gửi tất cả những ai đã ký bảo hiểm nhân thọ thông tin về đối tác“ · „gửi tất cả khách đang hoạt động mẹo về thuế 2026“',
      selhalo: 'thất bại',
      skrytSeznamPrijemcu: 'Ẩn danh sách người nhận',
      spustitKampan: 'Chạy chiến dịch →',
      teloTemplate: 'Nội dung (mẫu):',
      uspesne: 'thành công',
      vybratVse: 'Chọn tất cả',
      vyfiltrovatKlientyNapsatEmail: 'Lọc khách hàng + Viết email',
      zadniKlientiNeodpovidajiFiltru: 'Không có khách hàng nào khớp bộ lọc',
      zadny: 'Không chọn ai',
      zobrazitUpravitSeznam: 'Xem / sửa danh sách',
    },
    aIEmailDraftModal: {
      aiEmailKlientovi: 'Email AI gửi khách hàng',
      aiPise: 'AI đang viết…',
      aiVygenerujEmail: 'AI tạo email',
      emailOdeslanSipka: 'Đã gửi email',
      emailOhledne: 'email về việc...',
      klientNemaEmailVCrm: '(khách hàng không có email trong CRM)',
      klienta: 'khách hàng',
      komu: 'Gửi đến:',
      komuKlientACeho: 'Gửi cho ai (khách hàng) và liên quan đến gì (cơ hội bán hàng)',
      n2NahledEmailu: '2. Xem trước email',
      obchod: 'cơ hội bán hàng',
      odeslatNa: 'Gửi đến',
      odeslatZMehoGmailu: 'Gửi từ Gmail của tôi',
      odpovezNaEmailOd: 'Trả lời email từ',
      posliPavloviInfoO: 'Gửi cho Pavel thông tin về buổi gặp dịch vụ thứ Ba lúc 14:00…',
      posliPredJmenem: 'Gửi cho',
      prepsanoKlikniAiVygeneruj: 'Đã chuyển thành văn bản — bấm „AI tạo nội dung“',
      sPredmetem: 'với tiêu đề',
      spustitNahravani: 'Bắt đầu ghi âm',
      telo: 'Nội dung:',
      volitelneObchod: 'Tùy chọn: cơ hội bán hàng…',
      zastavitNahravani: 'Dừng ghi âm',
    },
    academyLayout: {
    },
    analyzaTiskPage: {
      analyza: 'Phân tích',
      castka: 'Số tiền',
      celkem: 'Tổng cộng',
      cisteJmeni: 'Giá trị tài sản ròng',
      coBudemeResit: 'Những gì chúng ta sẽ cùng giải quyết',
      coBudemeResitUvod: 'Các chủ đề này rút ra từ những con số chúng ta đã cùng xem. Chúng ta sẽ đi qua khi chuẩn bị kế hoạch của anh/chị.',
      coJeProVasDulezite: 'Điều gì quan trọng với anh/chị',
      coOcekavate: 'Anh/chị mong đợi gì từ sự hợp tác',
      coOdVasPotrebuji: 'Những gì tôi cần từ anh/chị',
      coZnamenajiPenize: 'Tiền có ý nghĩa gì với anh/chị',
      dalsiKrok: 'Bước tiếp theo',
      dedictviBudouciProdej: 'Thừa kế / bán trong tương lai',
      dluhy: 'Nợ',
      dobryDenPosilamShrnuti: 'Xin chào, tôi gửi anh/chị bản tóm tắt phân tích tài chính của chúng ta. Anh/chị xem qua và cần gì thì nhắn lại nhé.',
      financniAnalyza: 'Phân tích tài chính',
      financniMajetek: 'Tài sản tài chính',
      firmaPodnikani: 'Công ty / kinh doanh',
      investiceOpfEtfAkcie: 'Đầu tư (quỹ mở/ETF, cổ phiếu)',
      majetekCelkem: 'Tổng tài sản',
      naZakladeTechtoCisel: 'Dựa trên những con số này, chúng tôi sẽ đề xuất các bước tiếp theo trong kế hoạch tài chính — hãy liên hệ và chúng ta cùng xem qua.',
      nasobekVydaju: '{n}× chi phí',
      nemovitostiAutoCennosti: 'Bất động sản / xe / tài sản quý',
      nezavazne: 'Bản tổng quan này không mang tính ràng buộc. Đây là cơ sở để chuẩn bị kế hoạch tài chính. Các giải pháp, sản phẩm cụ thể và điều kiện của chúng sẽ được thảo luận và thống nhất khi thực hiện.',
      penzijniDip: 'Hưu trí / DIP',
      pocetCilu: 'Số mục tiêu',
      prijmyMes: 'Thu nhập / tháng',
      pripravujiAnalyzu: 'Đang chuẩn bị phân tích…',
      registrace: 'Đăng ký {regulator}: {cislo}',
      rezerva: 'Quỹ dự phòng',
      schuzkaDne: 'Buổi gặp ngày {datum}',
      shrnutiNasiAnalyzy: 'Tóm tắt phân tích của chúng ta: giá trị tài sản ròng {jmeni}, quỹ dự phòng bằng {rezerva}× chi phí hằng tháng và dòng tiền tự do {cf} mỗi tháng.',
      shrnutiSchuzky: 'Tóm tắt buổi gặp',
      splatkaMes: 'Trả góp/tháng',
      stavebniSporeni: 'Tiết kiệm xây dựng',
      strucneOSituaci: 'Tóm tắt tình hình của anh/chị',
      terminDomluvime: 'Chúng ta sẽ cùng thống nhất ngày gặp tiếp theo.',
      uctyAHotovost: 'Tài khoản và tiền mặt',
      vaseCile: 'Mục tiêu của anh/chị',
      volnyCashFlowMes: 'Dòng tiền tự do / tháng',
      vydajeMes: 'Chi phí / tháng',
      zavazkyCelkem: 'Tổng các khoản nợ',
      zaznamZAnalyzy: 'Bản ghi phân tích ngày {datum} theo giá hiện tại. Đây là cơ sở cho kế hoạch tài chính; chúng tôi cập nhật khi hoàn cảnh thay đổi.',
      /* Vzhled zeleného PDF (25. 10. 2026): podnadpisy, velká karta volných peněz, pata listu. */
      dulezitUpozorneni: 'Lưu ý quan trọng',
      majetekAZavazky: 'Tài sản và nợ',
      prijmyAVydaje: 'Thu nhập và chi phí',
      volneProstredky: 'Tiền còn dư',
      volneProstredkyPopis: 'Số tiền bạn còn lại mỗi tháng sau chi phí và các khoản trả nợ.',
      vydajePodleKategorii: 'Chi phí theo danh mục',
      vytvoreno: 'Tạo ngày {datum}',
    },
    businessCharts: {
      celkemBj: 'Tổng BJ',
      cil: 'mục tiêu',
      nastavMesicniPlanBj: 'Đặt kế hoạch BJ hằng tháng trong mục Cíle & Rocks.',
      plneniPlanuBj: 'Mức hoàn thành kế hoạch (BJ)',
      provize: 'Hoa hồng',
    },
    cashflowGraf: {
      cashflowVCaseMesicni: 'Dòng tiền theo thời gian — thặng dư hằng tháng',
      naKonci: 'vào cuối kỳ',
      nastupHypoteky: 'bắt đầu trả thế chấp',
      poNastupuHypoteky: 'sau khi bắt đầu trả thế chấp',
      prebytekKlesneJenO: '). Thặng dư chỉ giảm bằng chênh lệch giữa khoản trả góp và tiền thuê nhà không còn phải trả, chứ không giảm cả khoản trả góp.',
      splatkaHypotekySeV: 'Khoản trả góp thế chấp chỉ xuất hiện trong dòng tiền từ khi giải ngân (năm ',
      start: 'khởi đầu',
    },
    casovaOsaCilu: {
      casovaOsa: 'Dòng thời gian',
      casovaOsaCiluOd: 'Dòng thời gian các mục tiêu từ hôm nay đến năm',
      chybi: 'còn thiếu',
      dnes: 'hôm nay',
      dosahne: 'đạt',
      kdySeKteryCil: 'Khi nào từng mục tiêu hoàn thành',
      let: 'năm',
      letech: 'tuổi',
      letos: 'năm nay',
      seNesplniChybiCelkem: 'sẽ không đạt — còn thiếu tổng cộng',
      ve: 'khi',
      vekKlientaUMilniku: 'Thiếu tuổi khách hàng ở các mốc — trong phân tích không có ngày sinh.',
      zatimZadnyCilOsa: 'Chưa có mục tiêu nào — dòng thời gian sẽ hiện ra ngay khi bạn thêm mục tiêu đầu tiên.',
    },
    cilCinema: {
      dalsi: 'Tiếp',
      poznamkaPoradce: 'Ghi chú của cố vấn ',
      poznamkaPoradceN: 'Ghi chú của cố vấn (N)',
      prehrat: 'Phát',
      proKlientskyRezimTu: 'Chưa có nội dung được duyệt cho chế độ khách hàng',
      scenyTohotoCileCekaji: 'Các cảnh của mục tiêu này đang chờ duyệt về phương pháp. Ở chế độ cố vấn vẫn có thể phát — nhưng chưa hiển thị cho khách hàng.',
      zavrit: 'Đóng',
      zpet: 'Quay lại',
    },
    clientDealsTab: {
      archiv: 'Lưu trữ',
      archivovane: 'Đã lưu trữ',
      klikniNovyObchodPro: 'Bấm “Cơ hội mới” để tạo.',
      nacitam: 'Đang tải…',
      nelzeNacistObchodyKlienta: 'Không tải được cơ hội của khách hàng',
      obchodySeNepodariloNacist: 'Không tải được danh sách cơ hội',
      otevritDetail: 'Mở chi tiết',
      prohraZruseno: 'Thua/Đã hủy',
      rozjednane: 'Đang xử lý',
      rozjednaneObchody: 'Giao dịch đang xử lý',
      vProcesu: 'đang xử lý',
      vyhrane: 'Đã thắng',
      vyhraneSmlouvy: 'Đã thắng → hợp đồng',
      zadneObchodyVTeto: 'Không có cơ hội nào trong mục này',
      zkusToZnovuNejde: 'Hãy thử lại — đây không phải danh sách rỗng mà là lỗi kết nối.',
    },
    clientMapPage: {
      kratkyServis: 'Dịch vụ ngắn',
      seznamKlientu: 'Danh sách khách hàng ({n})',
      vTrase: '{n} trong lộ trình',
      zavritSeznam: 'Đóng danh sách',
      shlukKlientuOne: '{n} khách hàng',
      shlukKlientuFew: '{n} khách hàng',
      shlukKlientuMany: '{n} khách hàng',
      shlukAOkoli: '{mesto} và khu vực lân cận',
      shlukStejneMisto: 'Cùng một địa điểm',
      shlukPriblizit: 'Phóng to xem tất cả',
      shlukZavrit: 'Đóng danh sách nhóm',
      shlukTip: '{pocet} — nhấn để xem danh sách',
      shlukZpet: 'Quay lại danh sách ({n})',
      shlukSeznam: 'Khách hàng trong nhóm',
      typKlient: 'Khách hàng',
      typNabor: 'Tuyển dụng',
      typLead: 'Tiềm năng',
      typOstatni: 'Khác',
    },
    composeEmailModal: {
      dobryDen: 'Kính gửi,…',
      eMailOdeslan: 'Đã gửi email',
      komuNapisJakykolivE: 'Gửi cho ai * — nhập bất kỳ email nào (không bắt buộc chọn khách hàng)',
      neboVyberKlientaVolitelne: '…hoặc chọn khách hàng (tùy chọn — tự điền email và lưu vào lịch sử của khách)',
      nelzeOdeslat: 'Không thể gửi',
      novyEMail: 'Email mới',
      obchodniPripadVolitelneVazba: 'Cơ hội bán hàng (tùy chọn — liên kết để sau này tra cứu)',
      odeslat: 'Gửi',
      predmet: 'Tiêu đề *',
      predmetEMailu: 'Tiêu đề email',
      teloZpravy: 'Nội dung thư *',
      zadejPredmet: 'Hãy nhập tiêu đề',
      zadejPrijemce: 'Hãy nhập người nhận',
      zadejTextEMailu: 'Hãy nhập nội dung email',
      zavrit: 'Đóng',
      zrusit: 'Hủy',
    },
    dashboardPage: {
      akademieProNovackyKlikaci: 'Học viện cho người mới · hướng dẫn từng bước',
      coJePoradenstviEtika: 'Tư vấn tài chính là gì, đạo đức nghề nghiệp, quy trình, sản phẩm, gọi điện tìm khách, lập luận, chốt hợp đồng + câu hỏi trắc nghiệm.',
      vitejteVBeplan: 'Chào mừng bạn đến với beplan ',
      zNovackaProfikKrok: 'Từ người mới thành chuyên gia — từng bước một',
    },
    dealAutocomplete: {
      najdiObchodniPripadKlienta: 'Tìm cơ hội bán hàng của khách…',
      nejprveVyberKlienta: 'Trước tiên hãy chọn khách hàng…',
      obchodniPripad: 'Cơ hội bán hàng',
      vymazat: 'Xóa',
      zadnyOtevrenyObchodniPripad: 'Khách hàng không có cơ hội bán hàng nào đang mở.',
    },
    dealResultModal: {
      datumUzavreni: 'Ngày chốt',
      duvodVolitelneZapiseSe: 'Lý do (không bắt buộc — sẽ được ghi vào lịch sử)',
      konecnaCenaBj: 'Giá cuối cùng (BJ)',
      naprKlientZustalU: 'Ví dụ: khách hàng vẫn ở lại ngân hàng cũ…',
      zpet: 'Quay lại',
    },
    diarPageV3: {
      adresatJmenoAdresa: 'Người nhận (tên + địa chỉ)',
      aktivitaUlozena: 'Đã lưu hoạt động',
      aktivitaVytvorena: 'Đã tạo hoạt động',
      aktualizovano: 'đã cập nhật',
      bezKlienta: 'Không có khách hàng?',
      cehoSeToTyka: 'Liên quan đến việc gì',
      celodenni: 'Cả ngày',
      celyDen: ' · cả ngày',
      dalsiMesic: 'Tháng sau',
      dalsiUcastniciVolitelneOddelene: 'Người tham dự khác (tùy chọn, phân tách bằng dấu phẩy)',
      dalsich: 'nữa',
      datum: 'Ngày *',
      delkaUpravena: 'Đã đổi thời lượng',
      diarVeTvemKalendari: 'Lịch công tác trong lịch của bạn',
      dnesVelke: 'Hôm nay',
      doba: 'Thời lượng',
      doplnitKlienta: 'Bổ sung khách hàng',
      editaceAktivity: 'Sửa hoạt động',
      editovat: 'Chỉnh sửa',
      importZGoogleCalendar: 'Nhập từ Google Calendar vào Lịch công tác',
      importovano: 'Đã nhập',
      jindeOnline: 'Nơi khác / trực tuyến',
      kalendar: 'Lịch',
      kalendarSeAktualizujeKazdou: 'Lịch được cập nhật khoảng mỗi giờ.',
      kdeSeSchuzkaKona: 'Nơi diễn ra cuộc hẹn',
      klient: 'Khách hàng',
      klientNemaVyplnenouAdresu: 'Khách hàng chưa có địa chỉ — hãy nhập và chọn từ gợi ý.',
      kopirovat: 'Sao chép',
      mistoAdresa: 'Địa điểm / địa chỉ',
      mistoVolitelne: 'Địa điểm (tùy chọn)',
      nacitam: 'Đang tải…',
      nacitamOdkaz: 'Đang tải liên kết…',
      nacitamStav: 'Đang tải trạng thái…',
      nacteSchuzkyAUdalosti: 'Tải các cuộc hẹn và sự kiện từ lịch Google của bạn (-7 ngày đến +6 tháng) và hiển thị chúng trong Lịch công tác dưới dạng hoạt động. Các cuộc hẹn tạo qua beplan sẽ không bị trùng lặp.',
      napisAdresuMestoMisto: 'nhập địa chỉ / thành phố / địa điểm…',
      nastaveni: 'Cài đặt',
      nastaveniKalendare: 'Cài đặt lịch',
      neboJenExportApple: 'Hoặc chỉ xuất (Apple / Outlook)',
      nelzeNacistUkoly: 'Không tải được công việc',
      nelzePresunoutUkol: 'Không chuyển được công việc',
      nelzeUlozit: 'Không lưu được',
      nelzeVratit: 'Không hoàn tác được',
      nenaplanovano: 'Chưa lên lịch',
      nepodariloSeNacistOdkaz: 'Không tải được liên kết',
      nepodariloSeVytvoritKlienta: 'Không tạo được khách hàng',
      nepovedloSe: 'Không thành công',
      nizka: 'Thấp',
      nova: 'Mới',
      novaAktivita: 'Hoạt động mới',
      novouPridasTlacitkemAktivita: 'Thêm hoạt động mới bằng nút „Hoạt động“.',
      novyBezpecnostniKodVytvoren: 'Đã tạo mã bảo mật mới',
      obchodniPripadVolitelne: 'Giao dịch (tùy chọn)',
      obnovit: 'Làm mới',
      odchozi: 'Gọi đi',
      odkazNaTvujKalendar: 'Liên kết tới lịch của bạn',
      polozkaUzNeniDostupna: 'Mục này không còn khả dụng',
      pracovniDobaDo: 'Giờ làm việc đến',
      pracovniDobaOd: 'Giờ làm việc từ',
      predchoziMesic: 'Tháng trước',
      preskoceno: 'đã bỏ qua',
      presunuto: 'Đã chuyển',
      presunutoDoCasu: 'Đã chuyển sang giờ',
      prichozi: 'Gọi đến',
      pridatDoAppleOutlook: 'Thêm vào Apple / Outlook',
      pridatDoGoogle: 'Thêm vào Google',
      priorita: 'Mức ưu tiên',
      resitel: 'Người phụ trách',
      schovatRealizovane: 'Ẩn mục đã hoàn thành',
      smerHovoru: 'Chiều cuộc gọi',
      soukromaAktivita: '(hoạt động riêng tư)',
      soukromaAktivita2: 'Hoạt động riêng tư',
      stavPropojeniSeNepodarilo: 'Không xác định được trạng thái kết nối.',
      stredni: 'Trung bình',
      synchronizace: 'Đồng bộ',
      synchronizaceSelhala: 'Đồng bộ thất bại',
      synchronizovatDoGoogleApple: 'Đồng bộ sang Google / Apple / Outlook',
      synchronizovatTed: 'Đồng bộ ngay',
      synchronizuji: 'Đang đồng bộ…',
      tahniProCas: '⇅ kéo để đổi giờ',
      telefonniCislo: 'Số điện thoại',
      tentoDen: 'Ngày này',
      typAktivity: 'Loại hoạt động',
      uKlienta: 'Tại chỗ khách hàng',
      uKlientaProste: 'Tại chỗ khách hàng',
      uNas: 'Tại văn phòng',
      uNasVKancelari: 'Tại văn phòng của chúng tôi',
      ucet: 'Tài khoản',
      ukladam: 'Đang lưu…',
      ukolNaplanovan: 'Đã lên lịch công việc',
      uloziSeDoDiare: 'Sẽ được lưu vào lịch công tác',
      ulozitJakoSoukromou: 'Lưu ở chế độ riêng tư',
      ulozitZmeny: 'Lưu thay đổi',
      vice: 'Thêm',
      volnoAiZavolejA: 'Trống lịch · hãy gọi cho khách tiềm năng hạng A',
      vraceno: 'Đã hoàn tác',
      vratit: 'Hoàn tác',
      vseNaplanovano: 'Đã lên lịch tất cả.',
      vychoziDelkaAktivity: 'Thời lượng hoạt động mặc định',
      vychoziTypNoveAktivity: 'Loại hoạt động mới mặc định',
      vychoziZobrazeni: 'Chế độ xem mặc định',
      vysledekHovoruPoDokonceni: 'Kết quả cuộc gọi (sau khi kết thúc)',
      vysoka: 'Cao',
      vytvorit: 'Tạo',
      zacatek: 'Bắt đầu *',
      zadejDatumACas: 'Hãy nhập ngày và giờ',
      zadejNazevPredmet: 'Hãy nhập tên / chủ đề',
      zadneNadchazejiciAktivity: 'Không có hoạt động sắp tới',
      zavritFiltry: 'Đóng bộ lọc',
      zitra: 'Ngày mai',
      zkopirovano: 'Đã sao chép',
      zkopirujOdkazRucne: 'Hãy sao chép liên kết thủ công',
      zkusitZnovu: 'Thử lại',
      zmenitBezpecnostniKod: 'Đổi mã bảo mật',
      zmenitBezpecnostniKodStary: 'Đổi mã bảo mật? Liên kết cũ sẽ ngừng hoạt động và bạn phải thêm lại các lịch.',
      zmeskany: 'Bị lỡ',
      zobrazeni: 'Chế độ xem',
      zobrazitZrusene: 'Hiện mục đã hủy',
      zrusit: 'Hủy',
    },
    dotaznikCteni: {
      definiceDotaznikuSeNenacetla: 'Không tải được định nghĩa bảng câu hỏi.',
      hodnotuSeNepodariloNacist: 'Không tải được giá trị.',
      rodneCisloACislaDokladu: 'Số căn cước và số giấy tờ được ẩn. Việc hiển thị là thao tác có chủ ý và sau 20 giây giá trị sẽ tự ẩn lại.',
      skryt: 'Ẩn',
      zobraziSeNa20Sekund: 'Hiển thị trong 20 giây',
      zobrazit: 'Hiển thị',
    },
    editableGoals: {
      akontace: 'Trả trước %',
      akontace2: 'Trả trước',
      akontaceSplnenaNa: 'Khoản trả trước đạt',
      budouciNavyseniVkladu: 'Tăng khoản đóng góp trong tương lai',
      castJeVProduktech: 'một phần đang nằm trong các sản phẩm',
      cil: 'Mục tiêu',
      cilSplnen: 'mục tiêu hoàn thành',
      dleProfiluVolnaHotovost: '(theo hồ sơ). Tiền mặt khả dụng',
      dobaSplaceniLet: 'Thời gian trả nợ (năm)',
      financniNezavislostRenta: 'Tự do tài chính — thu nhập thụ động',
      horizont: 'thời hạn',
      horizontLet: 'Thời hạn (năm)',
      hypotecniCil: 'Mục tiêu vay thế chấp',
      jakNasetritAkontaci: 'Cách tích lũy khoản trả trước',
      jednorazove: 'Một lần',
      jednorazoveDnes: 'Một lần hôm nay',
      kombinace: 'Kết hợp',
      ktereSeMusiZrusit: 'vốn sẽ phải tất toán (thường bất lợi). Tốt hơn nên đầu tư',
      let: 'năm',
      letDosahnes: 'năm bạn sẽ đạt',
      letDriv: 'năm!',
      letDvojtecka: 'năm:',
      letPrida: 'năm sẽ thêm',
      mesicne: 'Hằng tháng',
      navrhniPravidelne: 'Đề xuất định kỳ',
      navrhniZMajetku: 'Đề xuất từ tài sản',
      nutnoRusitZvazPravidelne: 'sẽ phải tất toán. Hãy cân nhắc phương án định kỳ.',
      o: 'sớm',
      pocitanoSVynosem: 'Tính với lợi suất',
      potrebnyKapital: 'Số vốn cần có',
      pravidelne: 'Định kỳ',
      pravidelne2: 'định kỳ',
      pridatNavyseniNapr: 'Thêm mức tăng (ví dụ sau khi tăng lương)',
      realne: '% thực',
      renta: 'thu nhập thụ động',
      splatka: 'khoản trả',
      splneni: 'Mức hoàn thành',
      splneni2: 'mức hoàn thành',
      tolikVolneHotovostiKlient: 'Khách hàng không có nhiều tiền mặt như vậy',
      uver: 'khoản vay',
      volneMaKlientJen: 'Khách hàng chỉ có sẵn',
      za: 'sau',
      zaLet: 'Sau (năm)',
      zaVelke: 'Sau',
      zadneCileZAnalyzy: 'Chưa có mục tiêu nào từ phân tích. Hãy bổ sung mục tiêu trong phân tích rồi quay lại đây để tinh chỉnh cách đạt được.',
      zamcenoVProduktech: 'bị khóa trong các sản phẩm',
      zbytekJeVeStavebku: '— phần còn lại nằm trong tiết kiệm xây dựng/quỹ hưu trí',
    },
    finMatematikaPage: {
      cerpaniNekonecna: '♾️ vô hạn',
      chartRok: 'Năm',
      dobaCerpani: 'Thời gian rút',
      dobaCerpaniRenty: 'Thời gian rút niên kim',
      dobaSplaceni: 'Thời gian trả nợ',
      dopocitatPole: 'Tính ra ô này',
      financniMatematika: 'Toán tài chính',
      frekvenceUroku: 'Tần suất nhập lãi',
      hodnotaInvestice: 'Giá trị khoản đầu tư',
      jednorazovyVklad: 'Khoản nộp một lần',
      jednotkaLet: 'năm',
      kartaCelkemVlozite: 'Tổng cộng bạn nộp',
      vstupniPoplatek: 'Phí đầu vào trên số tiền mục tiêu',
      kartaPoplatek: 'Phí',
      kartaCilovaCastka: 'Số tiền mục tiêu',
      vetaPoplatek: 'Phí đầu vào trên số tiền mục tiêu {cilova} là {poplatek} ({pct} %), khấu trừ ngay từ đầu.',
      dipPrepinac: 'Khấu trừ thuế DIP',
      dipBez: 'Không DIP',
      dipS: 'Có DIP',
      kartaStatDip: 'Nhà nước hoàn (DIP)',
      kartaSDip: 'Tổng có DIP',
      vetaDip: 'Với DIP nhà nước hoàn thuế {stat} trong {roky} năm (15 % khoản góp, tối đa 7 200 Kč mỗi năm). Tái đầu tư tăng lên {hodnota}, trong đó {vynos} lợi nhuận. Điều kiện: rút sớm nhất ở tuổi 60 và sau 10 năm hợp đồng, nếu không phải nộp lại thuế.',
      rozpisPoLetech: 'Chi tiết theo năm',
      thSplaceno: 'Đã trả',
      thUrok: 'Lãi',
      thJistina: 'Gốc',
      thZustatek: 'Dư nợ',
      thVlozeno: 'Tổng đã góp',
      thVynos: 'Tổng lợi nhuận',
      thHodnota: 'Giá trị',
      thVyplaceno: 'Tổng đã chi trả',
      thCelkem: 'Tổng',
      tiskZadani: 'Thông số',
      tiskVysledek: 'Kết quả',
      tiskPripraveno: 'Lập ngày {datum}',
      upozorneniUver: 'Tính toán mẫu khoản trả góp đều với lãi suất cố định suốt kỳ hạn. Khoản trả thực tế, APR và phí theo đề nghị của ngân hàng.',
      upozorneniInvestice: 'Mô hình với lợi suất năm cố định, không phải cam kết. Lợi nhuận thực tế biến động và có thể âm; lợi nhuận quá khứ hay mô hình không đảm bảo tương lai.',
      upozorneniRenta: 'Mô hình rút tiền với lợi suất cố định, không phải cam kết. Lợi nhuận thực tế biến động, khoản thu nhập có thể kéo dài ngắn hơn.',
      kartaCelkemZaplatite: 'Tổng cộng bạn trả',
      kartaDoba: 'Thời hạn',
      kartaDobaCerpani: 'Thời gian rút',
      kartaJednorazovyVklad: 'Khoản nộp một lần',
      kartaKonecnaHodnota: 'Giá trị cuối kỳ',
      kartaMesicniRenta: 'Thu nhập hằng tháng',
      kartaMesicniSplatka: 'Khoản trả hằng tháng',
      kartaPocatecniHodnota: 'Giá trị ban đầu',
      kartaPravidelnaMes: 'Đều đặn hằng tháng',
      kartaRentaCelkem: 'Tổng thu nhập',
      kartaSplatnost: 'Kỳ hạn',
      kartaUrokPa: 'Lãi suất mỗi năm',
      kartaVyseUveru: 'Số tiền vay',
      kartaZTohoUroky: 'Trong đó là lãi',
      kartaZhodnoceniPa: 'Lợi nhuận mỗi năm',
      konecnaHodnotaInvestice: 'Giá trị cuối của khoản đầu tư',
      mesZkratka: 'tháng',
      mesicniSplatka: 'Khoản trả hằng tháng',
      pocatecniHodnota: 'Giá trị ban đầu',
      pravidelnaMesInvestice: 'Đầu tư định kỳ hằng tháng',
      splatnost: 'Kỳ hạn',
      urokovaSazba: 'Lãi suất',
      vetaInvestice: 'Từ {vlozeno} đã nộp bạn tạo ra {konec} — nhiều hơn {navic} nhờ lãi kép. Thời gian làm việc thay bạn.',
      vetaRenta: '{kapital} trả cho bạn {renta}/{mes} trong {roky} {rok} (tổng cộng {celkem}).',
      vetaRentaNekonecna: '{kapital} với {sazba} % sinh lời nhiều hơn mức bạn rút — khoản thu nhập là VÔ HẠN. Đó là tự do tài chính. 🎉',
      vetaUver: 'Khoản vay {castka} trong {roky} {rok} với lãi {sazba} % — bạn trả tổng cộng {celkem}, trong đó {uroky} là lãi.',
      vlozenoCelkem: 'Tổng đã nộp',
      vyseMesicniRenty: 'Mức niên kim hằng tháng',
      vyseUveru: 'Số tiền vay',
      vyvojHodnotyInvestice: 'Diễn biến giá trị khoản đầu tư',
      vyvojRentyCerpaniKapitalu: 'Diễn biến niên kim (rút vốn)',
      vyvojZustatkuUveru: 'Diễn biến dư nợ vay',
      zhodnoceniPA: 'Lợi suất mỗi năm',
      zhodnoceniRentyPA: 'Lợi suất niên kim mỗi năm',
      zustatek: 'Số dư',
      zustatekUveru: 'Dư nợ vay',
    },
    funnelCalc: {
      casPrida: 'Thời gian cộng thêm ',
      cil: 'mục tiêu',
      coJsiVlozil: 'Phần bạn bỏ vào',
      investiceNeseRizikoHodnota: 'Đầu tư có rủi ro — giá trị dao động và có thể giảm; kết quả trong quá khứ không bảo đảm cho tương lai.',
      jakByToRostlo: 'Số tiền sẽ tăng thế nào theo thời gian',
      mesicnePotrebujesOdkladat: 'Mỗi tháng bạn cần để dành',
      orientacniVypocetZeSlozeneho: 'Tính toán tham khảo theo lãi kép.',
      potrebnyKapitalNaRentu: 'Số vốn cần để có thu nhập thụ động: ',
      spocitejSiToNazivo: 'Tự tính thử — ngay tại đây',
    },
    globalSearch: {
      beplanGlobalniHledani: 'Beplan · tìm kiếm toàn hệ thống',
      chytreHledani: 'Tìm kiếm thông minh',
      hledat: 'Tìm kiếm…',
      hledatCmdCtrlK: 'Tìm kiếm (Cmd/Ctrl + K)',
      hledatKlientaUkolHashtag: 'Tìm khách hàng, việc cần làm, #hashtag, số điện thoại…',
      navigaceOtevritEscZavrit: '↑↓ di chuyển · ↵ mở · ESC đóng',
      otevrit: 'Mở',
      ukoly: 'Việc cần làm',
      zadneVysledkyPro: 'Không có kết quả cho',
      zavrit: 'Đóng',
    },
    globalTabBar: {
      hledat: 'Tìm kiếm',
      nastaveni: 'Cài đặt',
      odhlasit: 'Đăng xuất',
      zavritVse: 'Đóng tất cả',
      zavritVsechnyZalozky: 'Đóng tất cả các thẻ',
    },
    gmailConnectCard: {
      gmailOdpojen: 'Đã ngắt kết nối Gmail',
      gmailPropojen: 'Đã kết nối Gmail',
      nacitamStavGmailPropojeni: 'Đang tải trạng thái kết nối Gmail…',
      odpojeniSelhalo: 'Ngắt kết nối không thành công',
      odpojit: 'Ngắt kết nối',
      opravduOdpojitGmailNebudes: 'Bạn chắc chắn muốn ngắt kết nối Gmail? Bạn sẽ không gửi được email trực tiếp từ CRM.',
      pripojSvujGmail: 'Kết nối Gmail của bạn',
      pripojitGmail: 'Kết nối Gmail',
      propojeniGmailuZatimNeni: 'Kết nối Gmail chưa được bật',
      serverNeodpovedelNevimeJestli: 'Máy chủ không phản hồi. Chưa rõ Gmail đã kết nối hay chưa — hãy thử tải lại trang.',
      stavEMailuSe: 'Không xác định được trạng thái e-mail',
    },
    gmailMessageDetail: {
      komu: 'Gửi đến',
      kopie: 'Cc',
      nepodariloSeNacistEmail: 'Không tải được email',
      odpovedetAi: 'Trả lời bằng AI',
      otevritVGmailu: 'Mở trong Gmail',
      textZpravyTadyNezobrazime: 'Không hiển thị nội dung thư tại đây',
    },
    hypotecniPipelinePage: {
      excelLikePrehledVsech: 'Bảng tổng quan kiểu Excel cho mọi khoản vay và tái cấp vốn đang mở · bấm vào dòng để mở cơ hội bán hàng',
      hypotekaZalozena: 'Đã tạo khoản vay',
      kanbanPohledPouzivaObchodni: 'Chế độ Kanban dùng ở Bảng kinh doanh — với khoản vay nên dùng chế độ bảng. ',
      klikNaRadekDetail: 'Bấm vào dòng → chi tiết cơ hội bán hàng',
      nelzeNacistHypoteky: 'Không tải được danh sách khoản vay mua nhà',
      otevritObchodniNastenku: 'Mở Bảng kinh doanh ›',
      pripraveno: 'đã sẵn sàng',
      tabulka: 'Bảng',
      tentoTyden: 'Tuần này',
      urgentni: 'gấp',
      uverovaPipeline: 'Quy trình khoản vay',
      vLimitu: 'còn hạn',
      vReseni: 'đang xử lý',
      vse: 'Tất cả',
      vyzadujeAkci: 'Cần xử lý',
      zadneHypotekyNeodpovidajiFiltru: 'Không có khoản vay nào khớp với bộ lọc.',
    },
    investicniStrategiePage: {
      celkemVlozi: 'Tổng cộng nộp vào',
      cenaNecinnosti: 'Cái giá của việc không làm gì',
      citat: '„Bao nhiêu là đủ? Đủ để lợi nhuận trang trải chi phí của bạn. Khi đó bạn tự do tài chính — tiền làm việc thay bạn.“',
      coSiKlientOdnese: 'Khách hàng mang về được gì',
      doba: 'Thời hạn',
      hodnotaLegenda: 'Giá trị',
      inflaceNiciHotovost: 'Lạm phát bào mòn tiền mặt',
      inflaceText: 'Tiền để mặt lặng lẽ mất giá trị. Sau {roky} {rok} với lạm phát 3 %, từ {vlozeno} chỉ còn sức mua khoảng ~{realne}. Không làm gì cũng là một quyết định — và là quyết định đắt nhất.',
      investicniStrategie: 'Chiến lược đầu tư',
      kapital: 'Vốn',
      kapitalZustava: '…và số vốn {kapital} vẫn còn nguyên vẹn cho các con.',
      kino: 'Trình chiếu',
      kinoTooltip: 'Bắt đầu phần trình chiếu',
      klientTip: 'Không quan trọng „bao nhiêu“ — quan trọng là bắt đầu và để thời gian làm việc.',
      mes: 'tháng',
      mesSlash: '/tháng',
      mesicniVklad: 'Khoản nộp hằng tháng',
      naKonciMa: 'Cuối kỳ có',
      nekonecnaMesicniRenta: 'Thu nhập hằng tháng vô hạn ({sazba} mỗi năm)',
      nekonecnaRentaSazba: 'Thu nhập vô hạn ({sazba} mỗi năm)',
      nevymyslimeNicNovehoKopirujeme: 'Chúng tôi không phát minh gì mới — chỉ học theo những người giỏi nhất',
      odklada: 'Để dành',
      odkladaHodnota: '{castka}/{mes} × {roky} {rok}',
      podnadpisA: 'Hãy cho khách hàng thấy rằng kế hoạch của họ dựa trên những chiến lược đã vận hành nhiều năm cho các quỹ lớn nhất thế giới. Bấm vào một chiến lược → bạn tính nó trên 100 năm dữ liệu thật. Hoặc mở ',
      podnadpisB: ' với bản đồ thế giới tương tác.',
      podnadpisTucne: 'phần trình chiếu',
      prezentovatKlientovi: 'Trình bày cho khách hàng',
      procInvestovat: 'Vì sao nên đầu tư',
      procNedojde: 'Vì sao khoản thu nhập không bao giờ cạn',
      rentaMilion: 'mỗi triệu = khoảng {naMilion} {symbol} mỗi tháng mãi mãi',
      rentaNavzdy: 'Thu nhập mãi mãi',
      rentaText: 'Từ {kapital} với {sazba} mỗi năm bạn có thu nhập {renta}/{mes} — mãi mãi và vốn vẫn còn. Đó là tự do tài chính.',
      rentaVetaA: 'Khi bạn chỉ rút phần ',
      rentaVetaB: ' (không rút vốn gốc), vốn sẽ không bao giờ cạn. Với {sazba} mỗi năm ',
      rentaVetaC: ' — và triệu đó vẫn là của bạn.',
      rentaVynos: 'lợi nhuận',
      silaSlozeneho: 'Sức mạnh của lãi kép',
      spocitat: 'Tính trên 100 năm',
      svoboda: 'Tự do',
      urokText: 'Sau {roky} {rok} tiền của bạn tự kiếm được {rust}. Bắt đầu càng sớm, lãi kép làm việc cho bạn càng lâu.',
      urokZUroku: 'Lãi mẹ đẻ lãi con',
      vlozenoLegenda: 'Đã nộp',
      vynosPa: 'Lợi nhuận mỗi năm',
      zTohoVydelaly: 'Trong đó do chính đồng tiền kiếm ra',
      zadejteVklad: 'Nhập khoản nộp — cho khách hàng thấy mức tăng trưởng',
    },
    klientiPage: {
      aresNapoviADoplni: 'ARES sẽ gợi ý và điền giúp',
      chybaPriUkladani: 'Lỗi khi lưu: ',
      coMaUMe: 'Đang có với tôi',
      coVlastni: 'Đang sở hữu',
      dnes: 'hôm nay',
      jmeno: 'Tên',
      jmenoJePovinne: 'Bắt buộc nhập tên',
      jmenoNazev: 'Tên / tên công ty',
      karty: 'Thẻ',
      kategorie: 'Phân loại',
      kategorieKlienta: 'Phân loại khách hàng',
      klientPridan: 'Đã thêm khách hàng',
      klientTrvaleSmazan: 'Đã xóa vĩnh viễn khách hàng',
      klientVracenDoPipeline: 'Đã trả khách hàng về quy trình',
      kos: 'Thùng rác',
      kosJePrazdny: 'Thùng rác trống',
      kosOdstraneniKlientiKdykoli: 'Thùng rác — khách hàng đã gỡ; có thể khôi phục bất cứ lúc nào',
      kosSeNepodariloNacist: 'Không tải được thùng rác',
      moznaDuplicita: 'Có thể trùng lặp',
      moznaDuplicitaPotvrdZe: 'Có thể trùng — hãy xác nhận nếu vẫn muốn thêm',
      naborKandidat: 'Tuyển dụng — ứng viên',
      nacitamKos: 'Đang tải thùng rác…',
      nactenoZAres: 'Đã lấy từ ARES',
      napisteJmenoNeboNazev: 'Nhập tên hoặc tên công ty của khách…',
      nepovedloSeUlozit: 'Lưu không thành công',
      neznamaChyba: 'lỗi không xác định',
      obnoveniSeNezdarilo: 'Khôi phục không thành công',
      obnovit: 'Khôi phục',
      odlozenDoSkupinyBez: 'đã chuyển sang nhóm chưa quan tâm',
      odlozitZatimBezZajmu: 'Tạm hoãn — chưa quan tâm',
      odstraneniKlientiSeObjevi: 'Khách hàng đã gỡ sẽ hiện ở đây — bạn có thể trả họ về quy trình bất cứ lúc nào.',
      otevrit: '→ mở',
      poznamkaPriZakladani: 'Ghi chú khi tạo',
      pridejKlientaVCrm: 'Hãy thêm khách hàng trong CRM Pipeline.',
      prijmeni: 'Họ',
      resetovatFiltry: 'Đặt lại bộ lọc',
      smazaniSeNezdarilo: 'Xóa không thành công: ',
      smazatNavzdy: 'Xóa vĩnh viễn',
      tabulka: 'Bảng',
      telefon: 'Điện thoại',
      titoKlientiSeVelmi: 'Những khách hàng này rất giống nhau — hãy mở một trong số họ, hoặc xác nhận rằng bạn thực sự muốn tạo bản ghi mới.',
      trvaToDlouhoKlikni: 'Tải lâu quá? Bấm để làm mới',
      trvaleSmazatNevratne: 'Xóa vĩnh viễn — không hoàn tác được',
      typologie: 'Kiểu khách hàng',
      ukladam: 'Đang lưu…',
      ulozit: 'Lưu',
      ulozitAOtevrit: 'Lưu và mở',
      vKosiKlientiNejsou: 'trong thùng rác · khách hàng chưa bị xóa — khôi phục lúc nào cũng được',
      vKosiOd: 'trong thùng rác từ',
      vimZeToNeni: 'Tôi biết đây không phải bản trùng — tôi muốn tạo bản ghi mới',
      volat: 'Gọi',
      vratitDoPipeline: 'Trả về quy trình',
      vratitKlientaZpetDo: 'Trả khách hàng về quy trình',
      vse: 'Tất cả',
      vymazat: 'Xóa',
      vymazatVsechnyPokrocileFiltry: '× Xóa toàn bộ bộ lọc nâng cao',
      zadniKlienti: 'Chưa có khách hàng nào.',
      zadnyKlientNeodpovidaHledani: 'Không có khách hàng nào khớp với tìm kiếm.',
      zadnyKlientNeodpovidaKombinaci: 'Không có khách hàng nào khớp với các bộ lọc đã chọn. Hãy thu hẹp lựa chọn hoặc đặt lại bộ lọc.',
      zdroj: 'Nguồn',
      zpetNaKlienty: 'Quay lại danh sách khách hàng',
    },
    leadgenCalculatorPremium: {
      orientacniVypocetPresnouNabidku: '* Tính toán tham khảo. Báo giá chính xác tôi sẽ gửi sau buổi tư vấn ngắn.',
    },
    newDealModal: {
      klientaSeNepodariloZalozit: 'Không tạo được khách hàng',
      krokAnalyza: 'Phân tích',
      krokCerpani: 'Giải ngân',
      krokPodpis: 'Ký kết',
      krokProces: 'Quy trình',
      napisNejdrivJmenoNoveho: 'Trước tiên hãy nhập tên khách hàng mới vào ô tìm kiếm',
      pravdepodobnostUzavreni: 'Xác suất chốt',
      ulozitAOtevrit: 'Lưu và mở',
      zadejNazevObchodnihoPripadu: 'Hãy nhập tên giao dịch',
    },
    notFoundPage: {
      strankaNenalezena: 'Không tìm thấy trang',
      tatoAdresaNeexistujeNebo: 'Địa chỉ này không tồn tại hoặc đã được chuyển đi.',
      zpetNaHlavniStranku: 'Quay về trang chủ',
    },
    notesPanel: {
      klikneteAPistePrazdny: 'Bấm và viết — tờ giấy trắng tự lưu lại.',
      neulozenoUlozisteProhlizeceJe: 'Chưa lưu — bộ nhớ trình duyệt đã đầy',
      sTimtoStitkemNic: 'Không có gì với nhãn này.',
      ulozeno: 'Đã lưu',
      vse: 'Tất cả',
      zatimZadnaPoznamka: 'Chưa có ghi chú nào',
    },
    notificationCenter: {
      celyDen: 'cả ngày',
      pripominkySeNepodariloNacist: 'Không tải được lời nhắc.',
      tohleNeniStavMas: 'Đây KHÔNG phải là trạng thái “đã xong hết” — dữ liệu chưa tải được.',
    },
    obchodyPage: {
      akce: 'Thao tác',
      akciSeNepodariloDokoncit: 'Không hoàn tất được thao tác',
      archivSoftDelete: 'Kho lưu trữ · Xóa mềm',
      cekaNaVyplatu: 'đang chờ chi trả',
      cekamNaProvizi: 'Đang chờ hoa hồng',
      duvod: 'Lý do',
      faze: 'Giai đoạn',
      kategorieKlienta: 'Hạng khách hàng',
      klient: 'Khách hàng',
      klientObchod: 'Khách hàng · Giao dịch',
      n1SchuzkaPredstaveni: 'Buổi gặp thứ 1 — giới thiệu',
      nacitamOdlozeneObchody: 'Đang tải giao dịch đã hoãn…',
      nelzeNacistArchiv: 'Không tải được kho lưu trữ',
      nelzePresunoutObchod: 'Không chuyển được giao dịch',
      nelzeReaktivovat: 'Không kích hoạt lại được',
      nelzeSmazat: 'Không xóa được',
      obchod: 'Giao dịch',
      obchodVytvoren: 'Đã tạo giao dịch',
      odlozene: 'Đã hoãn',
      odlozeneObchodySoftDelete: 'Giao dịch đã hoãn — kho lưu trữ xóa mềm, từ đó có thể kích hoạt lại giao dịch',
      odlozeno: 'Đã hoãn',
      odlozenychObchoduMuzesKdykoliv: 'giao dịch đã hoãn — bạn có thể kích hoạt lại bất cứ lúc nào',
      otevritSlozku: 'Mở hồ sơ',
      otevritSlozkuKlienta: 'Mở hồ sơ khách hàng',
      planUzavreni: 'Kế hoạch — chốt hợp đồng',
      prejitNaSloupec: 'Chuyển đến cột',
      presunutoDo: 'Đã chuyển sang',
      pretahnoutObchodSem: 'Kéo giao dịch vào đây',
      pridatAktivitu: 'Thêm hoạt động',
      produkt: 'Sản phẩm',
      prohra: 'Thua',
      prohraUzavrenoK: 'Thua — chốt ngày',
      reaktivovat: 'Kích hoạt lại',
      spustitPrezentaciFinancnihoPlanu: 'Chạy bài trình bày kế hoạch tài chính — dẫn khách hàng tới việc ký kết',
      spustitPrezentaciPro1: 'Chạy bài trình bày cho buổi gặp thứ 1 — dẫn khách hàng tới phân tích tài chính',
      trvaleSmazatZDatabaze: 'Xóa vĩnh viễn khỏi cơ sở dữ liệu (không thể hoàn tác)',
      typ: 'Loại',
      vazena: 'Trọng số:',
      vratitObchodDoAktivni: 'Đưa giao dịch trở lại pipeline đang hoạt động',
      vyhraSmlouva: 'Thắng → Hợp đồng',
      vyhraUzavrenoK: 'Thắng — chốt ngày',
      zadneObchody: 'Không có giao dịch',
      zadneOdlozeneObchody: 'Không có giao dịch đã hoãn',
      zruseno: 'Đã hủy',
      zrusenoK: 'Đã hủy ngày',
    },
    onePagePlanPage: {
      dnesSPlanemAz: 'hôm nay · với kế hoạch lên tới',
      dobryDenPosilamVas: 'Xin chào, tôi gửi anh/chị kế hoạch tài chính. Anh/chị xem qua và cần gì thì nhắn lại nhé.',
      financniNezavislost: 'Tự do tài chính',
      financniPlan: 'Kế hoạch tài chính',
      financniPlanNaJedne: 'Kế hoạch tài chính trên một trang',
      financniZdravi: 'Sức khỏe tài chính',
      financniZdraviDnesS: 'Sức khỏe tài chính (hôm nay → với kế hoạch)',
      hypotekouSplatka: 'bằng vay thế chấp · khoản trả',
      jednorazove: 'một lần',
      kapital: 'vốn',
      kapitalProRentu: 'Vốn cho thu nhập thụ động',
      klesajiciCastkyKryjeDeficit: 'số tiền giảm dần · bù thiếu hụt của gia đình, nợ và mục tiêu',
      mesicneNaCileA: 'Hằng tháng cho mục tiêu và thu nhập thụ động',
      mesicneProCile: 'Hằng tháng cho mục tiêu (đã thống nhất)',
      naAnalyzu: 'Đến phần phân tích',
      naplneniFinancniNezavislosti: 'Mức đạt tự do tài chính',
      naplneno: 'đã đạt',
      narativCislaVDnesnichCenach: 'Các con số theo giá hiện tại. Lợi suất thực trên mức lạm phát: cổ phiếu {akcie} %, trái phiếu {dluhopisy} %, tiền mặt {cash} %; lợi suất tích lũy trung bình ≈ {prumer} % mỗi năm. Thu nhập thụ động rút {renta} % vốn mỗi năm. Kết quả trong quá khứ không bảo đảm cho tương lai.',
      narativPlanNaJednuStranu: 'Kế hoạch tài chính gói gọn một trang — lý do của bạn, ba bước cho 90 ngày tới và cách bạn đạt được mục tiêu cùng thu nhập thụ động.',
      navrhReseni: 'Đề xuất giải pháp',
      nepodariloSeNacistData: 'Không tải được dữ liệu',
      oLetDrive: ' · sớm hơn {n} năm',
      ochranaPrijmuVarianta: 'Bảo vệ thu nhập ({varianta})',
      planJeVDnesnich: 'Kế hoạch được tính theo giá hiện tại. Lợi suất thực trên mức lạm phát: cổ phiếu {akcie} %, trái phiếu {dluhopisy} %, tiền mặt {cash} %; lợi suất tích lũy trung bình ≈ {prumer} % mỗi năm. Thu nhập thụ động rút {renta} % vốn mỗi năm. Khuyến nghị phụ thuộc vào dữ liệu bạn cung cấp; chúng tôi cập nhật khoảng 3 năm một lần hoặc khi hoàn cảnh thay đổi. Kết quả trong quá khứ không bảo đảm cho tương lai.',
      prijmyRodiny: 'Thu nhập gia đình',
      pripravujiPlan: 'Đang chuẩn bị kế hoạch…',
      procToVsechnoDelame: 'Vì sao chúng ta làm tất cả điều này — theo lời của bạn',
      rentaFinancniNezavislost: 'Thu nhập thụ động (tự do tài chính)',
      vDnesnichCenachRealne: 'theo giá hiện tại (thực, trên mức lạm phát)',
      vasPoradce: 'Cố vấn của bạn',
      vaseBilance: 'Bảng cân đối của bạn',
      vaseCileAJak: 'Mục tiêu của bạn và cách chúng ta đạt được',
      volnyCashFlow: 'Dòng tiền tự do',
      vydajeSplatky: 'Chi phí + trả nợ',
      zkontrolujtePripojeni: 'Hãy kiểm tra kết nối và thử lại.',
      zkusitZnovu: 'Thử lại',
    },
    pipelineFunnelCompact: {
      bjVPipeline: 'BJ trong pipeline',
      pipelinePoFazich: 'Quy trình theo giai đoạn',
      vymazatFiltr: 'Xóa bộ lọc',
    },
    planPrehled: {
      azPoCilovemDatu: ' — chỉ sau ngày mục tiêu',
      rentaOdVekuPenzijka: ' — vào thu nhập thụ động từ {vek} tuổi: thu nhập +{castka}',
      bezCerpaniZdroju: 'không rút từ nguồn nào',
      cerpani: 'Giải ngân',
      doraziV: 'sẽ đến khi ',
      finMajetek: 'Tài sản TC',
      investice: 'Đầu tư',
      jednorazove: 'một lần',
      let: 'năm',
      letech: ' tuổi',
      likvidni: 'Thanh khoản',
      likvidni2: 'thanh khoản',
      mesice: 'tháng',
      nefinancni: 'Phi tài chính',
      nezapojeno: 'Chưa phân bổ',
      od: 'từ',
      ostatniUcty: 'Tài khoản khác',
      penzijkoRenta: 'Quỹ hưu trí → thu nhập thụ động',
      poPlanu: 'Sau kế hoạch:',
      pravidelne: 'định kỳ',
      prebytek: 'Thặng dư',
      precerpanoO: 'vượt mức',
      precerpanoTolikKlient: '— vượt mức, khách hàng không có nhiều như vậy',
      prubeznyPrehled: 'Tổng quan liên tục',
      stavebko: 'Tiết kiệm xây dựng',
      stavebko2: 'tiết kiệm xây dựng',
      volnyPrebytek: 'thặng dư khả dụng',
      za: 'sau',
      zbyva: 'còn lại',
      zbyvaLikvidni: 'còn lại thanh khoản',
    },
    planPrezentacePage: {
      abysteDosahliSvychCilu: '„…để bạn đạt được mục tiêu **theo con đường an toàn nhất**.“',
      abysteNemuselRusit: '„Để bạn không phải bán tháo các khoản đầu tư chiến lược vì chi phí bất ngờ. Tiền vào tài khoản tiết kiệm (~3 %) — ở đây **không phải để làm giàu, mà để yên tâm**. Sáu tháng lương dự phòng nghĩa là không gì đụng được tới kế hoạch.“',
      akcie: 'cổ phiếu',
      akciePodilyVNejvetsich: '„Cổ phiếu là phần sở hữu trong những công ty lớn nhất thế giới. Ngắn hạn thì dao động, nhưng đó là **thứ duy nhất thắng lạm phát một cách đáng tin cậy về dài hạn** — còn tiền để trong tài khoản thì chắc chắn mất sức mua.“',
      aleJePotrebaPro: '„…nhưng cần phải làm gì đó cho điều ấy.“',
      anoCimZacneme: 'Vâng — chúng ta bắt đầu từ đâu?',
      barva: 'màu',
      bezJednorazovehoVkladu: 'không có khoản góp một lần',
      bezPlanuUcetInflace: 'Không có kế hoạch (tài khoản + lạm phát)',
      chtelJsteVeta: 'Bạn muốn **{castka}** trong **{roky}**.',
      chtelJsteVetaBezTerminu: 'Bạn muốn **{castka}**. Chúng ta chưa đặt thời hạn.',
      chtelJsteVetaHned: 'Bạn muốn **{castka}** — và **ngay bây giờ**.',
      chybi: 'còn thiếu',
      chybiCastka: 'còn thiếu {castka}',
      cilPokryt: '✓ mục tiêu đã được phủ',
      ciluFinancnePodlozeno: 'mục tiêu đã có nguồn tài chính',
      coDnesPlanOhrozuje: 'Điều gì đang đe dọa kế hoạch hôm nay',
      coToCelkemStoji: 'Tổng chi phí là bao nhiêu',
      coZaToMate: 'Bạn nhận được gì',
      dalsiZpetNamitkyEsc: '→ tiếp · ← lùi · ? phản đối · Esc kết thúc',
      davaVamToSmysl: 'Điều này **có hợp lý** với bạn không?',
      deficitBezOchrany: 'Thiếu hụt khi không có bảo vệ',
      den: '/ngày',
      dluhopisy: 'trái phiếu',
      dnesSiVymenimeRole: 'Hôm nay chúng ta đổi vai.',
      doRokaBudeteMit: 'Trong vòng một năm bạn sẽ có',
      dobraZpravaMatePlan: 'Tin tốt: **bạn đã có kế hoạch.**',
      dobreALevneZajistit: 'Bảo vệ tài sản và thu nhập tương lai tốt mà rẻ',
      domluvenoCoKdoPripravi: 'Đã thống nhất — ai chuẩn bị gì',
      doplnitLikvidniRezervu: 'Bổ sung quỹ dự phòng',
      dotazySiProsimNechte: '„Xin hãy để câu hỏi đến cuối — trước hết tôi muốn bạn thấy toàn cảnh, toàn bộ chiến lược.“',
      druhaBezpecnejsiCesta: 'Và tin thứ hai còn tốt hơn: **chúng ta sẽ đi con đường an toàn hơn.**',
      druhaNezavislostDrive: 'Và tin thứ hai còn tốt hơn: **độc lập sớm hơn {roky}.**',
      dveBudoucnostiVyberteSi: 'Hai tương lai — bạn chọn đi',
      financniMajetekCelkem: 'Tổng tài sản tài chính',
      glideRokTooltip: 'năm {rok}: cổ phiếu {akcie} % · trái phiếu {dluhopisy} % · tiền mặt {hotovost} %',
      hotovost: 'tiền mặt',
      iVNejhorsimObdobi: 'Ngay cả trong giai đoạn **tệ nhất** trong {pocet} giai đoạn lịch sử, kế hoạch vẫn kết thúc ở **{vysledek}** — vẫn {kde} số {vlozeno} đã bỏ ra. __Thời gian quyết định, không phải đoán thị trường.__',
      invalidita: 'mất sức lao động',
      investice: 'đầu tư',
      jaPoradce: 'Tôi (chuyên viên tư vấn)',
      jedenZOsmiInvalidita: 'Mất sức lao động dài hạn — điều chúng tôi bảo vệ là **tiền lương hằng tháng**',
      jednorazoveOdkud: 'Khoản một lần — lấy từ đâu',
      jenVicNavic: 'Chỉ thêm **{vklad}** → sau {roky} bạn lời thêm **{kdobru}**. Đó là thời gian làm việc, không phải bạn.',
      kazdyCilSiVezme: 'Mỗi mục tiêu lấy phần của mình — và **bạn thấy phần còn lại**.',
      kazdyMilionRentaMesicne: '„mỗi triệu = {naMilion} mỗi tháng, mãi mãi“',
      kdeJsteDnesStartovni: 'Bạn đang ở đâu hôm nay — vạch xuất phát',
      kdybysteInvestovalPred20: '„Nếu bạn đã đầu tư từ 20 năm trước…“ — 100 năm lịch sử',
      kdybysteTenhlePlanJel: 'Nếu bạn theo kế hoạch này trong **{roky}** vào bất kỳ lúc nào của 100 năm qua…',
      kdybysteTohleInvestoval: 'Nếu bạn đã đầu tư khoản này trong **{roky}** qua, theo **dữ liệu thực tế** hôm nay bạn sẽ có:',
      krok_bezVsSPlanem: 'KHÔNG vs. CÓ KẾ HOẠCH',
      krok_cile: 'MỤC TIÊU',
      krok_coDelateDobre: 'BẠN ĐANG LÀM TỐT',
      krok_dveZpravy: 'HAI TIN',
      krok_kdeJsteDnes: 'HÔM NAY BẠN Ở ĐÂU',
      krok_kroky: 'CÁC BƯỚC',
      krok_motivace: 'ĐỘNG LỰC',
      krok_proc: 'VÌ SAO',
      krok_rezerva: 'QUỸ DỰ PHÒNG',
      krok_rizika: 'RỦI RO',
      krok_rozpocet: 'NGÂN SÁCH',
      krok_silaCasu: 'SỨC MẠNH THỜI GIAN',
      krok_souhrn: 'TÓM TẮT',
      krok_uvod: 'MỞ ĐẦU',
      krok_vaseCesta: 'HÀNH TRÌNH CỦA BẠN',
      krok_zaver: 'KẾT THÚC',
      krytiInvalidita: 'Mất sức lao động',
      krytiInvaliditaProc: 'mất thu nhập dài hạn mà quỹ dự phòng không gánh nổi — trong khi chi phí lại tăng',
      krytiOdskodne: 'Trợ cấp tai nạn theo ngày',
      krytiOdskodneProc: 'tai nạn cắt thu nhập ngay từ ngày đầu — không có thời gian chờ',
      krytiPn: 'Nghỉ ốm dài ngày',
      krytiPnProc: 'trợ cấp ốm chỉ bù một phần thu nhập; quyền lợi bù đắp ngân sách từ tháng thứ {mesic}',
      krytiSmrt: 'Tử vong',
      krytiSmrtProc: 'thay thế thu nhập cho gia đình — chi tiêu, trả góp và mục tiêu; số tiền giảm dần thì rẻ hơn',
      krytiTrvaleHodnota: '{castka} có lũy tiến',
      krytiTrvaleNasledky: 'Di chứng vĩnh viễn do tai nạn',
      krytiTrvaleProc: 'di chứng càng nặng thì chi trả càng cao (trong mô hình của chúng tôi tối đa 2,8× số tiền bảo hiểm — tùy công ty bảo hiểm)',
      mamProVasDve: 'Tôi có hai tin dành cho bạn',
      mate: 'Bạn có:',
      mateZCehoStavet: 'bạn đã có nền tảng để xây dựng — đó là lợi thế rất lớn',
      mesicneNaStejnouRentu: 'mỗi tháng cho cùng mức thu nhập thụ động',
      mezernik: 'PHÍM CÁCH',
      minuleJsemSePtal: '„Lần trước tôi hỏi và bạn kể — hôm nay tôi sẽ là người nói.“',
      motivAplikace: 'Giao diện ứng dụng',
      motorPlanu: 'Đó là động cơ của kế hoạch — **{rok}/năm** để chúng ta làm việc tiếp. Không thêm gì cả.',
      moznaJeTechCisel: 'Có thể hơi nhiều con số — nhưng thật ra rất đơn giản',
      naCileARentu: ' cho mục tiêu và thu nhập thụ động',
      naNavrh: 'Về phần đề xuất',
      naZacatkuJsteRekl: '„Lúc đầu bạn nói điều quan trọng nhất với bạn là **„{hodnota}“** — và đây chính là kế hoạch để đạt được điều đó. Nếu thấy hợp lý, chúng ta hãy thống nhất bắt đầu từ đâu.“',
      nadPrebytek: 'Dòng tiền tự do của bạn là {prebytek} mỗi tháng — kế hoạch cao hơn {rozdil}. Chúng ta cùng xem phần chênh lệch lấy từ đâu.',
      nadVlozenymi: 'cao hơn',
      namitka1: '„Tôi cần suy nghĩ thêm.“',
      namitka1Odpoved: '„Tôi hiểu — cụ thể điều gì khiến bạn băn khoăn? Con số, bảo hiểm hay mức tiền? Ta cùng giải quyết ngay để bạn không phải nghĩ một mình.“ (Tìm ra phản đối THẬT — „để tôi nghĩ“ chỉ là vỏ bọc.)',
      namitka2: '„Tôi sẽ bàn với vợ/chồng.“',
      namitka2Odpoved: '„Hoàn toàn đúng — đây là quyết định của cả gia đình. Ta hẹn một buổi ba người để tôi giải thích cho bạn đời của bạn, bạn không phải bảo vệ những con số không phải của mình.“ (Đừng bao giờ để khách hàng bán thay bạn.)',
      namitka3: '„Bây giờ tôi không có tiền cho việc này.“',
      namitka3Odpoved: '„Kế hoạch không tốn thêm gì — nó chỉ dùng khoản dư mà chính bạn đã đồng ý. Nếu khoản dư nhỏ hơn, ta bắt đầu với số nhỏ hơn. Bắt đầu khi nào tốt hơn: hôm nay, hay 5 năm nữa với chi phí đắt hơn 40 %?“ (Mở slide Cái giá của việc chờ đợi.)',
      namitka4: '„Bảo hiểm là phí tiền.“',
      namitka4Odpoved: '„Tôi đồng ý — bảo hiểm tồi thì đúng vậy. Vì thế chúng ta hủy các hợp đồng đắt đỏ và chỉ giữ phần bảo vệ thu nhập, để ngân sách không bao giờ bị hụt. Nó là chiếc dù — bạn không trả tiền cho cú rơi, bạn trả cho việc sống sót.“ (Quay lại slide Rủi ro.)',
      namitka5: '„Cổ phiếu là đánh bạc / tôi sợ khủng hoảng.“',
      namitka5Odpoved: '„Ngắn hạn thì bạn đúng — vì vậy kế hoạch có quỹ dự phòng và có phanh. Nhưng hãy xem 100 năm dữ liệu: mọi khủng hoảng đều kết thúc và thị trường quay lại. Đánh bạc thật sự là để tiền nằm yên và chắc chắn dâng nó cho lạm phát.“ (Mở máy tính lịch sử — chuyến bay qua các cuộc khủng hoảng.)',
      nasporenoZaLet: 'Tích lũy sau {roky}',
      navrhKrytiJeV: 'đề xuất mức bảo vệ nằm trong phần phân tích',
      nejdrivToCoUz: 'Trước hết là những gì bạn đang làm tốt',
      nejdrivVyplnAnalyzu: 'Trước tiên hãy điền phần phân tích',
      nemateZadneSpatneDluhy: 'Bạn không có khoản nợ xấu nào',
      nepojisteno: 'Chưa có bảo hiểm: {co}',
      nesplaceneZavazky: 'Nghĩa vụ nợ chưa trả',
      neuplnaRezerva: 'Quỹ dự phòng chưa đủ',
      nezSePustimeDo: '„Trước khi lo cho các mục tiêu, tôi khuyên nên bảo vệ **tài sản** và trên hết là **thu nhập tương lai** của bạn.“',
      nezUkazuPlan: 'Trước khi trình bày kế hoạch, tôi sẽ cho bạn thấy **chúng ta xuất phát từ đâu**.',
      nezZacnemeInvestovatOchranime: 'Trước khi bắt đầu đầu tư — chúng tôi bảo vệ bạn',
      nicJsmeSiNevymysleli: '„Chúng tôi không bịa ra gì cả — chúng tôi bắt đầu từ những gì bạn đang có và chia cho các mục tiêu của bạn. Con số không ở dòng cuối nghĩa là mỗi đồng tiền và mỗi khoản dư hằng tháng đều có nhiệm vụ riêng.“',
      nikdyNebudeteMitVice: '„Bạn sẽ không bao giờ có **nhiều thời gian hơn hôm nay**. Mỗi lần trì hoãn đều tốn tiền.“',
      oMinMene: 'Ít hơn **{vklad}** → sau {roky} là **{mene}** ít hơn. Bạn thấy khác biệt chứ?',
      ochrana: 'bảo vệ',
      osvc: ' · OSVČ',
      pilirMajetek: 'tài sản và trách nhiệm',
      pilirPrace: 'công việc',
      pilirPrijem: 'thu nhập của bạn (bảo hiểm nhân thọ)',
      poKazdemCiliVidite: 'Sau mỗi mục tiêu bạn thấy **còn lại bao nhiêu**.',
      poblizVlozenym: 'gần bằng',
      pochvalaMajetek: 'Bạn đã tích lũy tài sản tài chính {castka}',
      pochvalaOdkladate: 'Bạn để dành {pct} % thu nhập ({castka})',
      pochvalaRezerva: 'Quỹ dự phòng của bạn đạt {pct} %',
      posunteSiSamiMesicni: 'Bạn tự kéo thử — mức đầu tư hằng tháng:',
      povinne: 'khoản bắt buộc',
      pravidelne: 'định kỳ',
      pravidelneInvestovatVolneCash: 'Đầu tư định kỳ dòng tiền tự do',
      prebytekNeznamy: 'Chúng ta chưa tính dòng tiền tự do — sẽ bổ sung chi phí rồi đối chiếu số tiền.',
      prezentaceFinancnihoPlanu: 'Bài trình bày kế hoạch tài chính',
      prijem: 'thu nhập',
      pripravujiPrezentaci: 'Đang chuẩn bị bài trình bày…',
      proTentoHorizontA: 'Với thời hạn và mức đóng này, hiện chưa có đủ khung dữ liệu lịch sử.',
      projitZnovu: 'Xem lại một lần nữa',
      protiPlanu: 'so với kế hoạch',
      prvniJeDobra: 'Tin đầu là tin tốt: **các mục tiêu của bạn có thể đạt được.**',
      realneVynosyNadInflaci: 'Lợi suất thực trên mức lạm phát (SBBI 1926–2026). Lợi nhuận quá khứ không bảo đảm cho tương lai — đây là khoảng dao động, không phải cam kết.',
      renta: 'thu nhập thụ động',
      rentaJeZatimNa: 'Thu nhập thụ động hiện ở mức **{pct} %** — và chúng ta biết chính xác phải làm gì.',
      rentierskePortfolio5035: 'danh mục hưởng thu nhập 50 / 35 / 15',
      rentierskePortfolioDrziSe: 'Danh mục hưởng thu nhập (giữ cả khi rút tiền)',
      rizikoDluhy: '{castka} — nếu có chuyện, gia đình phải gánh',
      rizikoInvalidita: 'khi mất sức lao động sẽ thiếu {castka}',
      rizikoRezerva: 'mới đạt {pct} % của mức 6 tháng lương',
      rocneRealne: 'mỗi năm theo giá trị thực',
      rodinaZajistenaAtSe: 'bảo vệ thu nhập cho gia đình',
      rozdilProtiPlanu: 'Chênh lệch so với kế hoạch',
      rozdilZaLet: 'Chênh lệch sau {roky}: {castka}',
      rozkliknoutNa100Letech: 'Mở trên 100 năm lịch sử + chiến lược',
      rozlozeniVCaseGlide: 'Phân bổ theo thời gian — càng về cuối càng ít cổ phiếu',
      rozlozitSoucasneUsporyNa: 'Phân bổ khoản tiết kiệm hiện có cho các mục tiêu',
      rozpocetPlanuKamJdou: 'Ngân sách kế hoạch — tiền của bạn đi đâu',
      sNefinancnim: 'gồm cả tài sản phi tài chính',
      sPlanem: 'Có kế hoạch',
      scenarOptimisticky: 'Kịch bản lạc quan',
      scenarOptimistickyPozn: '5 % giai đoạn tốt nhất',
      scenarPesimisticky: 'Kịch bản bi quan',
      scenarPesimistickyPozn: '5 % giai đoạn tệ nhất (kể cả khủng hoảng lớn)',
      scenarRealisticky: 'Kịch bản thực tế',
      scenarRealistickyPozn: 'trung vị — một nửa số giai đoạn còn tốt hơn',
      silaCasuCoRika: 'Sức mạnh của thời gian — 100 năm lịch sử nói gì',
      silaSlozenehoUroceniRoste: 'Sức mạnh của lãi kép tăng theo thời gian',
      smrt: 'tử vong',
      souhrnDoporuceniCelehoPlanu: 'Tóm tắt khuyến nghị của toàn bộ kế hoạch',
      splneno: 'đã đạt',
      spravneZajisteniJeZaklad: '„Bảo vệ đúng cách là nền tảng của kế hoạch — chúng tôi không bảo vệ hợp đồng, mà bảo vệ điều bạn coi là quan trọng nhất: **„{hodnota}“**.“',
      stavimeNaDobrychZakladech: '„Chúng ta đang xây trên nền tảng tốt — giờ hãy hoàn thiện nó.“',
      stejnePenizeStejnyClovek: '„Cùng số tiền, cùng con người — quyết định khác nhau.“',
      styl: 'kiểu',
      tahakNaNamitkyJen: 'Bản gợi ý xử lý phản đối (chỉ dành cho bạn)',
      tahakNaNamitkyKlient: 'Bản gợi ý xử lý phản đối (khách hàng không thấy)',
      takhleToDopadneKdyz: '„Kết quả sẽ như thế này nếu chúng ta không làm gì…“ — hãy bấm',
      toNedela8Z: 'để dành đều đặn là nền tảng cho mọi việc tiếp theo',
      tohleJeVaseCestaRok: 'Đây là hành trình của bạn — **từng năm một**.',
      tohleJeVychoziBod: '„Đây là điểm xuất phát. Giờ tôi sẽ cho bạn thấy chúng ta dựng cả kế hoạch từ đó ra sao.“',
      tohleNejsouStatistiky: '„Đây không phải thống kê — đây là **ngân sách của bạn**. Ngày lương không về, gia đình thiếu __{castka}__. Mỗi tháng.“',
      uCileBezTrzniho: 'cho mục tiêu không có rủi ro thị trường',
      udelJstePrvniKrok: 'Bạn đã bước bước đầu tiên — bạn đang lập một kế hoạch',
      ukazuVamCoUz: 'Tôi sẽ cho bạn thấy **điều bạn đang làm tốt**, **chỗ bạn có thể đang mất tiền** — và quan trọng nhất là __bạn đạt được bao nhiêu phần trăm mục tiêu__ cùng những việc cần làm.',
      ukolKlient1: 'quét các hợp đồng hiện có (trước thứ Sáu)',
      ukolKlient2: 'điền bảng hỏi đầu tư',
      ukolKlient3: 'gửi email các câu hỏi về kế hoạch',
      ukolPoradce1: 'hợp đồng bảo hiểm theo đúng kế hoạch',
      ukolPoradce2: 'hợp đồng môi giới (con đường để đầu tư)',
      ukolPoradce3: 'thiết lập danh mục theo kế hoạch',
      vasMajetek: 'Tài sản của bạn',
      vaseCestaKamTecou: 'Hành trình của bạn — dòng tiền chảy về đâu',
      vaseCestaKdySe: 'Hành trình của bạn — khi nào từng mục tiêu hoàn thành',
      vaseCileJedenPo: 'Các mục tiêu của bạn — lần lượt từng cái',
      vaseCileStojiNa: '▲ các mục tiêu của bạn dựa trên…',
      ve25MajiLide: '„Ở tuổi 25, người ta thấy phải tận hưởng. Ở tuổi 35, thu nhập dồn vào trả nhà. Ở tuổi 45, lo học phí cho con. Và ở tuổi 60, họ nhận ra **đã quá muộn**. Bạn thì bắt đầu ngay hôm nay.“',
      vejdeSeDoPrebytku: '= nằm gọn trong dòng tiền tự do {prebytek} mỗi tháng mà chúng ta đã tính.',
      vetsinaLidiFinanceOdklada: 'bước đầu tiên thường là khó nhất',
      vetsinaRodinNemaAni: 'quỹ dự phòng là nền móng của cả kế hoạch',
      vkladNavicNeZ: 'khoản góp thêm, không lấy từ tiết kiệm hiện có',
      vlozenoCelkem: 'Tổng đã đầu tư **{celkem}** ({jedn} một lần + {mes}) · chiến lược {akcie} % cổ phiếu / {dluhopisy} % trái phiếu',
      volneCashFlow: 'Dòng tiền tự do',
      volnyPrebytekKazdyMesic: 'Khoản dư mỗi tháng',
      vy: 'Bạn',
      vyhovujeVamSchuzkaZase: '„Bạn có tiện gặp lại vào thứ Tư cùng giờ không?“',
      vypadekPrijmu: 'Mất thu nhập',
      vzacnostGratuluji: 'điều hiếm thấy — xin chúc mừng',
      zPrebytkuDokudNedoplnime: 'trích từ khoản dư cho đến khi đủ',
      zToho: 'trong đó',
      zaLet: ' (sau {roky} năm)',
      zaLetBudeteMit: 'Sau {roky} bạn sẽ có',
      zaLetProste: 'sau {roky} năm',
      zacnuDnes: 'tôi bắt đầu HÔM NAY',
      zadneZasadniRizikoZ: 'Phân tích không cho thấy rủi ro lớn nào — điểm khởi đầu rất tốt.',
      zdrojInvestice: 'Đầu tư và tiết kiệm',
      zdrojInvesticePozn: 'đang làm việc cho bạn',
      zdrojLikvidni: 'Thanh khoản (tài khoản, tiền mặt)',
      zdrojLikvidniPozn: 'dùng được ngay',
      zdrojNefinancni: 'Tài sản phi tài chính',
      zdrojNefinancniPozn: 'bất động sản, công ty, thừa kế',
      zivotniStyl: 'lối sống',
      zmeniloSeZaTen: '„Trong tuần qua có gì quan trọng thay đổi không?“',
    },
    planVystupPage: {
      akceKoupit: 'Mua',
      akceNavysit: 'Tăng thêm',
      akcePonechat: 'Giữ nguyên',
      akceProdat: 'Bán',
      akcie2: 'Cổ phiếu',
      alokaceDela92Vysledku: 'phân bổ tài sản quyết định ~92 % kết quả',
      alokaceRadek: 'cổ phiếu {akcie} % · trái phiếu {dluhopisy} % · tiền mặt {penize} %',
      alokaceStartGlide: 'Tỷ trọng lúc khởi đầu. Mục tiêu càng gần, kế hoạch càng chuyển từ cổ phiếu sang trái phiếu và tiền mặt — năm cuối trước mục tiêu nằm hoàn toàn ở tiền mặt.',
      casuDost: 'Còn nhiều thời gian…',
      co: 'Việc gì',
      coKdyProc: 'việc gì / khi nào / vì sao',
      davkyOdhadPozn: 'Lương hưu mất sức lao động chỉ là ước tính theo thu nhập; mức thực tế do cơ quan bảo hiểm xã hội xác định theo thời gian đóng bảo hiểm.',
      dluhopisy: 'Trái phiếu',
      dnes: 'hôm nay',
      doporucenaAlokace: 'Phân bổ khuyến nghị',
      doporucenePortfolio: 'Danh mục khuyến nghị',
      doporuceniProVas: 'Khuyến nghị dành cho bạn',
      doporuceniVychazejiZPoskytnutych: 'Các khuyến nghị dựa trên dữ liệu đã cung cấp. Lợi suất thực trên mức lạm phát: cổ phiếu {akcie} %, trái phiếu {dluhopisy} %, tiền mặt {cash} %; lợi suất tích lũy trung bình ≈ {prumer} % mỗi năm. Thu nhập thụ động rút {renta} % vốn mỗi năm. Tài liệu là cơ sở làm việc và cần được cập nhật thường xuyên. Lợi nhuận quá khứ không bảo đảm cho tương lai.',
      doporucujemeDiverzifikovatMenove: 'Chúng tôi khuyến nghị đa dạng hóa theo tiền tệ và khu vực (chỉ số thế giới ~72 % là Mỹ), dùng quỹ của các công ty quản lý lớn có xếp hạng Morningstar. Cảm hứng: quỹ Na Uy, quỹ Nobel.',
      financniNezavislost: 'Độc lập tài chính',
      financniNezavislostPoRealizaci: 'Độc lập tài chính sau khi thực hiện',
      horizont: 'Thời hạn',
      hotovost2: 'Tiền mặt',
      invalidita: 'Mất sức lao động',
      kapitalovaMetodaKlesajiciPojistn: 'Phương pháp vốn (số tiền bảo hiểm giảm dần): bù đắp phần thu nhập thiếu hụt, các khoản nợ và mục tiêu sau khi trừ tài sản và phần dư của gia đình còn lại. Vốn cho thu nhập thụ động chỉ tính khi mất sức lao động — sau khi qua đời không còn ai rút nữa.',
      kdy: 'Khi nào',
      klient: 'Khách hàng',
      klient1: 'Khách hàng 1',
      klient2: 'Khách hàng 2',
      konkretniProdukty: 'sản phẩm cụ thể',
      likvidniRezerva: 'Quỹ dự phòng thanh khoản',
      mesicneInvestovatNaCile: 'Đầu tư hằng tháng cho mục tiêu và thu nhập thụ động',
      narativ1: 'Đây là kế hoạch tài chính của bạn — mỗi tháng cần để dành bao nhiêu và phân bổ đầu tư thế nào để đạt được độc lập tài chính và các mục tiêu khác.',
      narativ2: 'Các con số tính theo giá hôm nay. Lợi suất thực trên mức lạm phát: cổ phiếu {akcie} %, trái phiếu {dluhopisy} %, tiền mặt {cash} %; lợi suất tích lũy trung bình ≈ {prumer} % mỗi năm. Thu nhập thụ động rút {renta} % vốn mỗi năm; chúng ta sẽ cùng cập nhật kế hoạch định kỳ. Lợi nhuận quá khứ không bảo đảm cho tương lai.',
      naseDoporuceni: 'Khuyến nghị của chúng tôi',
      nehledejteVymluvy: 'ĐỪNG TÌM LÝ DO',
      nejdrivVyplnAnalyzu: 'Trước tiên hãy điền phần phân tích',
      nepodariloSeNacistData: 'Không tải được dữ liệu',
      oSveBudoucnostiRozhodnete: 'Hãy quyết định về tương lai của bạn NGAY HÔM NAY.',
      planProDosazeniFinancni: 'Kế hoạch đạt được độc lập tài chính và các mục tiêu khác',
      planVytvorenDne: 'Kế hoạch được lập ngày',
      poRealizaci: 'sau khi thực hiện',
      poznamka: 'Ghi chú:',
      prijmyCelkem: 'Tổng thu nhập',
      proc: 'Vì sao',
      produkt: 'Sản phẩm',
      profilDynamicky: 'Năng động',
      profilKonzervativni: 'Thận trọng',
      profilVychozi: 'mặc định — chưa chọn hồ sơ khác',
      profilVyvazeny: 'Cân bằng',
      riziko: 'Rủi ro',
      rizikovyProfil: 'Hồ sơ rủi ro',
      rizikovyProfil2: 'hồ sơ rủi ro',
      skorePlanuDnesS: 'Điểm kế hoạch (hôm nay → khi có kế hoạch)',
      smrt: 'Tử vong',
      socialniDavky: ' Trợ cấp nhà nước: lương hưu mất sức lao động {inval}/tháng{davka}.',
      socialniDavkyStarobni: ', lương hưu {starobni}/tháng',
      soucasnePortfolio: 'Danh mục hiện tại',
      souhrnMajetkuADluhu: 'Tổng hợp tài sản và nợ',
      splatkyUveru: 'Trả nợ vay',
      vaseHodnoty: 'Giá trị của bạn',
      vaseStrategickeCile: 'Mục tiêu chiến lược của bạn',
      vasichHodnotACilu: 'giá trị và mục tiêu của bạn',
      vekNejlepsiCas: 'Hôm nay bạn {vek} — thời điểm tốt nhất để bắt đầu là ngay bây giờ.',
      vstupniInformace: 'thông tin đầu vào',
      vydajeSpotreba: 'Chi tiêu (tiêu dùng)',
      vymluva25: 'Chúng tôi còn trẻ và mới bắt đầu. Thu nhập chưa nhiều. Không có gì để tiết kiệm.',
      vymluva35: 'Tiền trả góp nhà và chi phí ngốn hết thu nhập. Mà chúng tôi cũng có quyền đi du lịch chứ!',
      vymluva45: 'Chúng tôi không thể tiết kiệm. Các con đang đi học — tốt nhất là học ở nước ngoài.',
      vymluva55: 'Ở tuổi này thì bắt đầu không dễ.',
      vymluva65: 'Chúng tôi nên bắt đầu từ nhiều năm trước. Hôm nay thì đã muộn.',
      zajisteniPrijmuVPripade: 'bảo vệ thu nhập khi có sự cố bất ngờ',
      zivotniPojisteni: 'Bảo hiểm nhân thọ',
    },
    popisZdroje: {
      jednorazovyVklad: 'khoản nộp một lần',
    },
    portfolioDoctorPage: {
      aktualniTerAVstupni: '— TER và phí vào hiện tại lấy từ website của công ty quản lý',
      bezJmena: '(không có tên)',
      briefProSchuzkuClaude: 'Bản tóm tắt cho buổi gặp · Claude Haiku 4.5',
      briefSCnbCompliant: 'Bản tóm tắt với ngôn từ tuân thủ ČNB',
      celkovyModelovyRozdilVe: 'Tổng chênh lệch mô hình có lợi cho ETF · ',
      coDoctorUmi: 'Doctor làm được gì',
      diagnostikaSelhalaZkusTo: 'Chẩn đoán thất bại. Hãy thử lại.',
      doporuceni: 'Khuyến nghị',
      etfAlternativa: 'Phương án ETF:',
      fondIsinNeboNazev: 'Quỹ — ISIN hoặc tên',
      hledamFondyNaWebu: 'Đang tìm quỹ trên web… (15–30 giây)',
      ie00b4l5y983NeboConseqActive: 'IE00B4L5Y983 hoặc “Conseq Active Invest Dynamický”',
      investovanaCastkaKc: 'Số tiền đã đầu tư (Kč)',
      janNovak: 'Jan Novák',
      kategorieFonduUrcujeEtf: 'Loại quỹ (quyết định ETF thay thế)',
      klientJmeno: 'Khách hàng (tên)',
      klientovyPoziceIsinCastky: 'Vị thế của khách hàng (ISIN + số tiền)',
      knihovna35NejcastejsichCz: 'Thư viện hơn 35 quỹ Séc phổ biến nhất với tham số thực',
      knihovnaFondu: 'thư viện quỹ',
      marketingoveSdeleniCnbEsma: 'Thông tin tiếp thị · tuyên bố miễn trừ ČNB / ESMA',
      mesicneDaleKc: 'Hằng tháng từ nay (Kč)',
      modelovaKalkulaceMinulaVykonnost: 'Đây là tính toán mô hình. Hiệu suất trong quá khứ không đảm bảo hiệu suất trong tương lai.',
      modelovyRozdilVeProspech: 'Chênh lệch mô hình có lợi cho ETF:',
      naprConseqActiveInvest: 'Ví dụ “Conseq Active Invest Dynamický”',
      naprKlientSeBoji: 'Ví dụ “Khách hàng sợ biến động, vợ muốn nghỉ hưu ở tuổi 60.”',
      nazevFondu: 'Tên quỹ',
      nepodariloSeNacistDiagnostiku: 'Không tải được chẩn đoán.',
      odebratFond: 'Xóa quỹ',
      otevritZdroj: 'Mở nguồn ↗',
      overenoNaWebu: 'Đã kiểm chứng trên web:',
      posledniDiagnostiky: 'Các chẩn đoán gần đây',
      pozice: 'Vị thế',
      poznamkaProAiBrief: 'Ghi chú cho bản tóm tắt AI (tùy chọn)',
      prepocitanoSTvymiHodnotami: 'Đã tính lại với giá trị của bạn',
      prepocitatSMymiHodnotami: 'Tính lại với giá trị của tôi',
      pridatIsin: 'Thêm ISIN',
      pridejAlesponJednuPozici: 'Hãy thêm ít nhất một vị thế.',
      rozpoznaUcitsEtfPres: 'Nhận diện UCITS ETF qua justETF (~2 800 quỹ)',
      rucniZadani: 'nhập thủ công',
      smazaniSelhalo: 'Xóa thất bại.',
      smazano: 'Đã xóa',
      smazat: 'Xóa',
      smazatTutoDiagnostiku: 'Xóa chẩn đoán này?',
      spocita20LetyDopad: 'Tính tác động của phí trong 20 năm bằng Kč',
      spustitDiagnostikuPortfolia: 'Chạy chẩn đoán danh mục',
      tentoFondJeUz: 'Quỹ này vốn đã tốt.',
      terEtfCelkem: 'Tổng TER của ETF',
      terFondCelkem: 'Tổng TER của quỹ',
      terMusiByt0: 'TER phải nằm trong khoảng 0–10 %',
      terPod05: 'TER dưới 0,5 % và là ETF tích lũy — chúng tôi không khuyến nghị thay đổi.',
      tvojeKnihovna: 'thư viện của bạn',
      ulozeniSelhalo: 'Lưu thất bại',
      uloziFondDoKnihovny: 'Lưu quỹ vào thư viện — lần sau Doctor sẽ tự nhận ra quỹ này',
      ulozitDoKnihovny: 'Lưu vào thư viện',
      upravit: 'Sửa',
      upravitParametryFondu: 'Sửa tham số của quỹ',
      upravitRucne: 'Sửa thủ công',
      veProspechEtf: 'có lợi cho ETF',
      vek: 'Tuổi',
      vlozenoCelkem: 'Tổng đã nộp:',
      vstupni: 'Phí vào (%)',
      vstupni010: 'Phí vào 0–10 %',
      vstupni2: 'Phí vào',
      vstupniPop: 'Phí vào',
      vyberKategorii: 'Chọn loại quỹ',
      vyplnNazevTerA: 'Điền tên, TER và phí vào',
      zadejteFondIsinNebo: 'Nhập quỹ (ISIN hoặc tên), số tiền khách hàng đang giữ và thời hạn. Trong 30 giây bạn nhận được chẩn đoán phí theo mô hình, so sánh với phương án UCITS ETF và bản tóm tắt 3 đoạn cho buổi gặp.',
      zatimZadneUlozeneDiagnostiky: 'Chưa có chẩn đoán nào được lưu.',
      zavrit: 'Đóng',
      zrusit: 'Hủy',
    },
    postaPage: {
      aHlasTextPrikazem: 'và tạo thư mới bằng lệnh giọng nói hoặc văn bản.',
      aiEmailKlientovi: 'Email AI gửi khách hàng',
      bezPristupuKeGoogle: 'Ứng dụng chưa được quản trị viên cấp quyền truy cập Google — không thể chờ Gmail.',
      firemniEmailSmtp: 'email công ty (SMTP)',
      gmailPrepojenyPredek: 'Gmail của bạn tuy đã kết nối, nhưng để',
      gmailPrepojenyTucne: 'đọc thư trong CRM',
      gmailPrepojenyZadek: 'chúng tôi cần mở rộng quyền. Bạn chỉ cần đi qua màn hình OAuth một lần nữa — mất 10 giây.',
      gmailZatimPripojitNejde: 'Hiện chưa thể kết nối Gmail',
      hledatVGmailu: 'Tìm trong Gmail…',
      klikneTeToNa: 'Thao tác này sẽ đưa bạn tới màn hình Google, nơi bạn chỉ cần đồng ý „Đọc thư“.',
      nacteniEmailuSelhalo: 'Tải email không thành công',
      neboKlikniNa: 'Hoặc bấm vào',
      neboSpojka: ', hoặc',
      nepodariloSeOveritGmail: 'Không xác minh được Gmail',
      nepodariloSeSpustitReconnect: 'Không khởi động được việc kết nối lại',
      noveOpravneniPosta: 'Quyền mới cho Hộp thư',
      obnovit: 'Làm mới',
      otevritNastaveni: 'Mở Cài đặt',
      postaSeObjeviZde: 'Thư sẽ xuất hiện ở đây ngay khi bạn kết nối email trong Cài đặt. Bạn có hai lựa chọn:',
      pripojSiEMail: 'Hãy kết nối email của bạn',
      pripojitFiremniEMail: 'Kết nối email công ty',
      sLibovolnouAdresou: 'và với bất kỳ địa chỉ nào (Seznam, Microsoft 365, @beplan.cz…). Bạn kết nối trong vài phút là có thể viết và đọc ngay tại đây.',
      slozkaDorucene: 'Hộp thư đến',
      slozkaHvezdickovane: 'Có gắn sao',
      slozkaKoncepty: 'Thư nháp',
      slozkaKos: 'Thùng rác',
      slozkaOdeslane: 'Đã gửi',
      slozkaVse: 'Tất cả',
      slozky: 'Thư mục',
      smtpFungujeHned: 'Email công ty (SMTP) hoạt động ngay',
      spojeniNaChviliSelhalo: 'Kết nối bị gián đoạn trong giây lát. Hãy thử lại — Gmail của bạn nhiều khả năng vẫn đang kết nối.',
      tenFungujeSLibovolnou: '— loại này dùng được với mọi địa chỉ và không phải chờ Google.',
      vyberEmail: 'Chọn một email',
      zadneEmailyVeSlozce: 'Không có email trong thư mục',
      zkusitZnovu: 'Thử lại',
      znovuPripojitGmail1: 'Kết nối lại Gmail (1 lần bấm)',
      zpetNaSeznam: 'Quay lại danh sách',
    },
    publicBookingPage: {
      vybratTermin: 'Chọn giờ hẹn',
    },
    radarPrilezitostiPage: {
      dalsi: 'nữa',
      detailMezer: 'Chi tiết lỗ hổng',
      kdeMaKlientMezeru: 'Khách hàng còn thiếu chỗ nào — chọn, nhắn, xử lý xong.',
      klientuKOsloveni: 'khách hàng cần liên hệ',
      kritickychMezer: 'lỗ hổng nghiêm trọng',
      napsatEMail: 'Gửi e-mail',
      napsatNaWhatsapp: 'Nhắn qua WhatsApp',
      obchodSeNepodariloZalozit: 'Không tạo được giao dịch.',
      obchodniPripadZalozen: 'Đã tạo giao dịch.',
      obnovit: 'Làm mới',
      odlozenoO30Dni: 'Đã hoãn 30 ngày.',
      odlozitNa30Dni: 'Hoãn 30 ngày',
      otevritSlozkuKlienta: 'Mở hồ sơ khách hàng',
      prilezitostiCelkem: 'cơ hội tổng cộng',
      radarPrilezitosti: 'Radar cơ hội',
      radarSeNepodariloNacist: 'Không tải được Radar. Thử lại sau giây lát.',
      radarSeNepodariloNacist2: 'Không tải được Radar',
      sbalit: 'Thu gọn',
      skenujiSmlouvyAAnalyzy: 'Đang quét hợp đồng và phân tích…',
      skorePrilezitostiKlikniPro: 'Điểm cơ hội — bấm để xem chi tiết',
      terminyFixaceVyrociHlida: 'Các mốc thời hạn (kỳ hạn lãi suất, ngày kỷ niệm) do Radar dịch vụ theo dõi. Lỗ hổng đã hoãn sẽ quay lại sau 30 ngày.',
      tohleNeniZadnePrilezitosti: 'Đây KHÔNG phải là „không có cơ hội“ — dữ liệu chưa tải được.',
      ukol: 'Công việc',
      ukolSeNepodariloVytvorit: 'Không tạo được công việc.',
      ukolVytvorenZa3: 'Đã tạo công việc (sau 3 ngày).',
      vse: 'Tất cả',
      zadneOtevrenePrilezitosti: 'Không có cơ hội nào đang mở.',
      zkusitZnovu: 'Thử lại',
    },
    reseniCilu: {
      akcie: 'cổ phiếu',
      akontacePct: 'vốn tự có {pct} %',
      bezRustuNeboKroku: 'Không có mức tăng hoặc không có bậc — mẫu sẽ không điền gì.',
      bezpecneCerpani4: 'rút an toàn 4 %',
      castka: 'Số tiền',
      chybi: 'Còn thiếu',
      chybiProkazatelnyPrijem: 'Phân tích không có thu nhập chứng minh được — ứng dụng không biết lương tăng từ đâu.',
      cil: 'mục tiêu',
      cilJeVTomhle: 'Với thiết lập này mục tiêu không thể đạt được — con số chỉ là mức trần tham khảo.',
      cilKrytyJednorazoveBez: 'Mục tiêu được phủ bằng khoản một lần — không cần đầu tư định kỳ.',
      cilVelke: 'Mục tiêu',
      cilovaCastka: 'Số tiền mục tiêu',
      cimSeCilPoridi: 'Mục tiêu được chi trả bằng gì',
      cnbDo36Let: 'ČNB: dưới 36 tuổi chỉ cần 10 % vốn tự có (LTV 90 %), nếu không thì 20 %. Tài trợ 100 % là quyết định của cố vấn — 10 % giá trị được bù bằng khoản vay từ tiết kiệm xây dựng. Khoản trả góp chỉ xuất hiện trong dòng tiền từ khi giải ngân khoản vay',
      dluhopisy: 'trái phiếu',
      dopocitat: 'tự tính',
      dopocteno: 'đã tính',
      dynamicky: 'Năng động',
      glidePathAlokaceV: 'Giảm rủi ro dần theo thời gian',
      horizontVLetech: 'Thời hạn tính bằng năm',
      hotovost: 'tiền mặt',
      hypotekou: 'bằng vay thế chấp',
      inflacePct: 'Lạm phát (%)',
      jakToVyresit: 'Cách giải quyết',
      jeNadVolnymPrebytkem: 'vượt quá thặng dư khả dụng của hộ gia đình',
      jednorazove: 'Một lần',
      jednorazoveDnesNavic: 'Một lần hôm nay (thêm)',
      jednorazovy: 'một lần',
      kCili: 'Cho mục tiêu',
      kapital: 'vốn',
      kazdychLet: 'Mỗi (năm)',
      konzervativni: 'Thận trọng',
      krokuRustu: 'bậc',
      ktereSeTuNezapocitava: ', phần này không được tính ở đây.',
      let: 'năm',
      mesice: 'tháng',
      mesicne: 'Hằng tháng',
      mesicniRentaKlienta: 'Thu nhập thụ động hằng tháng của khách hàng',
      mimoradnyPrijem: 'thu nhập bất thường',
      navrh: 'đề xuất',
      nbsAkontace: 'NBS: thông thường 20 % vốn tự có (LTV 80 %), 10 % chỉ là ngoại lệ. Tài trợ 100 % là quyết định của cố vấn — 10 % giá trị được bù bằng khoản vay từ tiết kiệm xây dựng. Khoản trả góp chỉ xuất hiện trong dòng tiền từ khi giải ngân khoản vay',
      neresiSe: 'không dùng',
      nominalne: 'danh nghĩa',
      nominalneMinusInflace: 'danh nghĩa − lạm phát',
      nominalneNeprekonaInflaci: 'danh nghĩa không vượt lạm phát',
      oboji: 'Cả hai',
      od: 'từ',
      odR: 'từ năm',
      odebratPritok: 'Xóa dòng tiền vào',
      planSlibujeVicNez: '— kế hoạch hứa hẹn nhiều hơn khả năng hiện tại của khách hàng.',
      pocetKroku: 'Số bậc',
      pocitaSeJakoSporeni: 'Đang tính là TIẾT KIỆM: khách hàng phải tích đủ toàn bộ số tiền {castka}. Nếu vay thì chỉ cần tích phần trả trước.',
      polovina: 'giữa kỳ',
      posledni: 'cuối',
      posledniRok100Hotovost: '— năm cuối 100 % tiền mặt: không còn rủi ro thị trường',
      pravidelnaInvestice: 'Đầu tư định kỳ',
      pridat: 'Thêm',
      pridatBudouciPritok: 'Thêm dòng tiền vào tương lai',
      pripadnyKoncikiNajem: '; tiền thuê nhà kết thúc sẽ bù một phần khoản trả góp.',
      realneNadInflaci: 'thực (trên lạm phát)',
      realneTempoDoKroku: 'theo giá trị thực — nhịp này đi vào các bước tăng lương.',
      renta: 'thu nhập thụ động',
      rentaDrziRentierskePortfolio: '— thu nhập thụ động giữ danh mục hưu trí 50/35/15 ngay cả khi rút vốn',
      rentaVCerpaniPortfolio: '— khi rút vốn, thu nhập thụ động giữ danh mục {a}/{d}/{c}',
      posledniRokTabulka: '— năm cuối {c} % tiền mặt và {d} % trái phiếu',
      rentierskePortfolio: 'danh mục hưu trí',
      resiSeUverem: 'Chỉ tích phần trả trước, phần còn lại do khoản vay lo — tiền trả nợ bắt đầu từ khi giải ngân.',
      resimeJenZeZdroju: 'Chỉ giải quyết từ các nguồn và theo tháng.',
      rocniRustPct: 'Mức tăng (%)',
      rok: 'năm',
      rustMzdy: 'tăng lương',
      rustVkladuNastaveni: 'Tăng khoản góp — thiết lập',
      sablonaNicNepredvyplni: 'Hiện mẫu không điền gì.',
      sablonaPredvyplniPritoky: 'Mẫu điền sẵn dòng tiền lương tương lai cho cả kế hoạch — cố vấn sẽ điều chỉnh.',
      splatka: 'khoản trả',
      splatnost: 'thời hạn',
      splatnostHypotekyLet: 'Thời hạn vay thế chấp tính bằng năm',
      typ: 'Loại',
      urok: 'lãi suất',
      urokHypotekyPa: 'Lãi suất vay thế chấp tính bằng % mỗi năm',
      uverZeStavebka: 'khoản vay từ tiết kiệm xây dựng',
      uverem: 'bằng khoản vay',
      vR: 'vào năm',
      vkladNadRamecZdroju: 'Khoản nộp ngoài các nguồn — khoản trả hằng tháng sẽ được tính.',
      vlastniZdroje: 'vốn tự có',
      vlozenoCelkem: '— đã nộp tổng cộng',
      vybrano: 'đã chọn',
      vychazi: 'khả thi',
      vychozi: 'mặc định',
      vychoziHodnoty: 'giá trị mặc định',
      vychoziParametryHypo: 'Bỏ trống = kế hoạch dùng giá trị mặc định {sazba} % mỗi năm trong {roky} năm, không phải chào giá của ngân hàng. Khoản vay từ tiết kiệm nhà ở trong phương án 100 % có lãi suất riêng và các ô này không làm thay đổi nó.',
      vyvazeny: 'Cân bằng',
      zAnalyzy: 'từ phân tích',
      zTohoVlastni: 'trong đó vốn tự có',
      zTohoVyjde: 'Kết quả là',
      zVlastnichPenez: 'bằng tiền của mình',
      za: 'sau',
      zaLet: 'Sau (năm)',
      zadanePctJe: '% đã nhập là',
      zadano: 'đã nhập',
      zadat: 'nhập',
      zadneCilSeResi: 'Không có — mục tiêu được giải quyết bằng đầu tư định kỳ từ thặng dư.',
      zadnyRealnyRust: 'mức tăng thực bằng không, mẫu không điền gì.',
      zahoditKroky: 'Bỏ các bước tăng lương',
      zpetNaHodnotuZ: 'Quay lại giá trị từ phân tích',
      zpetNaVychozi: 'về mặc định',
      zpetNaVychoziRust: 'về mặc định',
      zrusit: 'Hủy',
    },
    rezerva: {
      poznKlientuvCilNezbytne: 'Phương pháp khuyến nghị 6× chi phí thiết yếu cộng các khoản trả nợ, tức là {metodika}. Mục tiêu của bạn là {nasobek}× mức nền đó.',
      poznKlientuvCilObvykle: 'Phương pháp khuyến nghị 6× chi phí thiết yếu cộng các khoản trả nợ. Phân tích chưa có chi phí thiết yếu, nên tính từ chi phí thông thường cộng trả nợ ra {metodika} — mục tiêu của bạn là {nasobek}× mức nền đó.',
      poznNeznamy: 'Chưa có dữ liệu để tính mục tiêu quỹ dự phòng — thiếu chi phí.',
      poznObvykle: 'Chi phí thiết yếu chưa được nhập trong phân tích — đã tính từ chi phí thông thường. Hãy bổ sung để số tiền chính xác hơn.',
      titulKlientuvCil: 'Quỹ dự phòng — mục tiêu của bạn',
      titulNezbytne: 'Quỹ dự phòng (6× chi phí thiết yếu + trả nợ)',
      titulNeznamy: 'Quỹ dự phòng',
      titulObvykle: 'Quỹ dự phòng (6× chi phí thông thường + trả nợ)',
    },
    rozpocetPlanu: {
      aniTakToAleNa: 'Dù vậy vẫn không đủ cho tất cả mục tiêu —',
      cekaNaCil: ' đang chờ một mục tiêu.',
      chybiCelkem: 'còn thiếu tổng cộng',
      doraziAzPoCilovem: 'chỉ đến SAU ngày mục tiêu — không ảnh hưởng tới số tiền mục tiêu',
      financniMajetekJednorazove: 'Tài sản tài chính — một lần',
      hned: 'ngay lập tức',
      jePenzijniSporeniDps: ' là tiết kiệm hưu trí (DPS/DIP) — đây là tài sản của khách hàng và kế hoạch tính toàn bộ vào thu nhập thụ động, chỉ là nó đến mục tiêu ',
      jePenzijniSporeniDps2: ' là tiết kiệm hưu trí (DPS/DIP). Đây là tài sản của khách hàng, nhưng chưa mục tiêu nào rút từ đó — nó thuộc về thu nhập thụ động và khách hàng chưa có mục tiêu tự do tài chính. Khoản này nằm ở mục „còn lại“.',
      jednorazove: 'một lần',
      jednorazoveA: ' một lần và ',
      jednorazoveO: 'một lần vượt',
      jesteNeniRozdelenoVsechno: 'Vẫn chưa phân bổ hết: ',
      kolikZbyvaPoKazdem: 'Còn lại bao nhiêu sau mỗi mục tiêu',
      let: 'năm',
      letech: 'tuổi',
      mesicneO: 'hằng tháng vượt',
      mesicniPrebytekPravidelne: 'Thặng dư hằng tháng — định kỳ',
      mesicu: 'tháng',
      miraUspor: 'Tỷ lệ tiết kiệm',
      necerpaZRozpoctu: 'không rút từ ngân sách',
      planJeHotovy: ' Kế hoạch đã hoàn tất.',
      planJednorazovePrerozdeluje: 'Kế hoạch phân bổ lại một lần các tài khoản thanh khoản, tiết kiệm xây dựng và quỹ hưu trí. Nằm ngoài là ',
      planNemaZCeho: 'kế hoạch không có nguồn để chi. Trước hết là ngân sách hộ gia đình.',
      podiloveFondyKzpOstatni: ' (quỹ mở, bảo hiểm nhân thọ tích lũy, các tài khoản khác) — toàn bộ tài sản tài chính ',
      povinneVydaje: 'Chi phí bắt buộc',
      pravidelne: 'định kỳ',
      prebytek: 'Thặng dư',
      prebytekJeVAnalyze: 'Thặng dư được nhập tay trong phân tích — không khớp chính xác với thu nhập trừ chi phí.',
      prebytekNesediNaRozpad: 'Thặng dư không khớp với thu nhập trừ chi phí và các khoản trả nợ — hãy kiểm tra ngân sách trong phân tích.',
      prebytekNulaKlientskyVystup: 'Thặng dư hằng tháng bằng không — kế hoạch cho khách hàng sẽ không được lập từ số không. Hãy điền vào phân tích số tiền bạn đã thống nhất với khách hàng.',
      precerpano: 'Vượt mức',
      precerpanoPlanNevychazi: 'Vượt mức — kế hoạch không khả thi',
      prideleno: 'Đã phân bổ',
      prijmy: 'Thu nhập',
      rozpocetPlanu: 'Ngân sách kế hoạch',
      tolikKlientNema: ' — khách hàng không có nhiều như vậy.',
      v: 'khi',
      vydajeASplatkyPrevysuji: 'Chi phí và khoản trả nợ vượt thu nhập ',
      vyrovnanoVsePrideleno: 'Cân bằng — đã phân bổ hết',
      zBudoucihoPritoku: 'từ dòng tiền vào tương lai (ngoài ngân sách)',
      zPenzijkaDpsDip: 'từ quỹ hưu trí (DPS/DIP) · sẽ đến ',
      zToho: 'Trong đó ',
      za: 'sau',
      zatimNeniCoRozdelovat: 'Hiện chưa có gì để phân bổ — khách hàng không có tài sản tài chính khả dụng lẫn thặng dư hằng tháng. Kế hoạch bắt đầu từ ngân sách hộ gia đình, không phải từ sản phẩm.',
      zatimZadnyCilRozpocet: 'Chưa có mục tiêu nào — ngân sách sẽ hiện ra ngay khi bạn thêm mục tiêu đầu tiên.',
      zbyva: 'Còn lại',
      zbyva0A0: 'Còn lại 0 và 0 — từng đồng và từng thặng dư hằng tháng đều có nhiệm vụ riêng.',
    },
    sekceCinema: {
      dalsi: 'Tiếp',
      prehrat: 'Phát',
      tvojeVeta: 'Câu của bạn ',
      zavrit: 'Đóng',
      zpet: 'Quay lại',
    },
    spolecne: {
      aiGeneraceSelhala: 'AI tạo nội dung thất bại',
      chybaPrepisu: 'Lỗi nhận dạng giọng nói',
      chybaSite: 'Lỗi mạng',
      cil: 'Mục tiêu',
      jedMes: '/tháng',
      klient: 'khách hàng',
      klientu: 'khách hàng',
      let: ' năm',
      mikrofonNeniDostupny: 'Micrô không khả dụng',
      n1HlasovyNeboTextovy: '1. Lệnh bằng giọng nói hoặc văn bản',
      napisNeboNahrajPrikaz: 'Nhập hoặc ghi âm lệnh',
      napsatEMail: 'Viết email',
      nevimeCile: 'Bản phân tích chưa có mục tiêu nào kèm số tiền — vì vậy chưa có phần trăm.',
      nevimeHorizont: 'Mục tiêu thiếu mốc thời gian — hãy bổ sung sau bao nhiêu năm.',
      nevimeRenta: 'Chưa đặt mục tiêu thu nhập thụ động — hãy điền mỗi tháng bao nhiêu và từ khi nào.',
      nevimeRezerva: 'Chưa biết mục tiêu quỹ dự phòng — bản phân tích thiếu chi tiêu hộ gia đình.',
      nevimeSkore: 'Không tính được điểm — bản phân tích thiếu dữ liệu cơ bản.',
      nevimeVydaje: 'Chưa nhập chi tiêu hộ gia đình — không thể tính dòng tiền tự do.',
      odesilam: 'Đang gửi…',
      odeslaniSelhalo: 'Gửi không thành công',
      poradce: 'cố vấn',
      poslatKlientovi: 'Gửi cho khách hàng',
      prazdnaAnalyzaText: 'Bản phân tích chưa có thu nhập, chi tiêu, tài sản hay mục tiêu. Hãy bổ sung để kế hoạch được tính từ dữ liệu của khách — con số bịa đặt không thuộc về tài liệu cho khách.',
      prazdnaAnalyzaTitul: 'Không thể lập kế hoạch từ bản phân tích này',
      prebytekChybiTextDopocet: 'Thu nhập trừ chi phí và các khoản trả nợ cho ra thặng dư hằng tháng bằng không. Chúng tôi không lập kế hoạch từ số không. Hãy kiểm tra ngân sách gia đình trong phân tích — hoặc điền thặng dư bạn đã thống nhất với khách hàng.',
      prebytekChybiTextNezadano: 'Chưa biết thặng dư hằng tháng — phân tích còn thiếu các chi phí để tính. Hãy bổ sung, hoặc nhập luôn số tiền bạn đã thống nhất với khách hàng.',
      prebytekChybiTextNula: 'Thặng dư hằng tháng đã thống nhất bằng không. Chúng tôi không lập kế hoạch từ số không — không vẽ biểu đồ từ số tiền không tồn tại, và không nói với khách hàng rằng giải pháp hằng tháng vừa với thặng dư của họ. Hãy điền số tiền bạn đã thống nhất với khách hàng, hoặc trước tiên hãy xem lại ngân sách gia đình.',
      prebytekChybiTitul: 'Mỗi tháng chúng ta đã thống nhất bao nhiêu?',
      predmet: 'Tiêu đề:',
      prepisSeNezdarilNapis: 'Không nhận dạng được giọng nói — hãy nhập lệnh thủ công',
      rentaOdvozena: 'Chưa đặt mục tiêu thu nhập thụ động — tạm tính theo chi tiêu hiện tại.',
      ukladam: 'Đang lưu…',
      ulozit: 'Lưu',
      vytisknoutUlozitPdf: 'In / lưu PDF',
      zavrit: 'Đóng',
      zkusitZnovu: 'Thử lại',
      zmenitPrikaz: 'Đổi lệnh',
      zrusitFiltr: 'Bỏ bộ lọc',
    },
    srovnavacFonduPage: {
      horizont: 'Tầm nhìn: {roky} {rok}',
      jednorazoveKc: 'Một lần ({mena})',
      mesicneKc: 'Hằng tháng ({mena})',
      rozdilVeProspech: 'Chênh lệch sau {roky} {rok} nghiêng về:',
      srovnavacFondu: 'So sánh quỹ',
      vlastniA: 'Tự chọn A',
      vlastniB: 'Tự chọn B',
    },
    tokPenez: {
      beznyUcet: 'Tài khoản thanh toán',
      budouciPritok: 'Dòng tiền vào tương lai',
      chybi: 'còn thiếu',
      chybiPrecerpano: 'còn thiếu / vượt mức',
      coKlientDnesNema: 'những gì khách hàng chưa có hôm nay',
      dnesniMajetek: 'tài sản hiện có',
      doraziAzPoCilovem: 'chỉ đến SAU ngày mục tiêu',
      doraziAzPoCilovem2: 'chỉ đến SAU ngày mục tiêu — không ảnh hưởng tới số tiền mục tiêu',
      doraziV: 'sẽ đến khi',
      hotovost: 'Tiền mặt',
      jednorazoveZFinancniho: 'Một lần — từ tài sản tài chính',
      klikniZnovuZpetNa: 'Nhấn lại = quay về đề xuất của hệ thống',
      letech: 'tuổi',
      mesicneZPrebytku: 'Hằng tháng — từ thặng dư',
      mesicniPrebytek: 'Thặng dư hằng tháng',
      mesicniPrebytek2: 'thặng dư hằng tháng',
      najedteNaProudUkaze: 'Di chuột lên một dòng — sẽ hiện từ đâu, đến đâu và bao nhiêu.',
      nezarazenyZdroj: 'Nguồn chưa phân loại',
      odkudKamTecouVase: 'Tiền của bạn chảy từ đâu đến đâu',
      penzijkoAzPozdeji: 'quỹ hưu trí — chỉ sau này',
      penzijkoDpsDip: 'Quỹ hưu trí DPS/DIP',
      posliCelyTenhleZdroj: 'Đưa toàn bộ nguồn này vào mục tiêu này',
      posliSem: 'đưa vào đây',
      precerpanoTolikKlient: 'Vượt mức — khách hàng không có nhiều như vậy',
      splneno: 'đã đạt',
      sporiciUcet: 'Tài khoản tiết kiệm',
      stavebniSporeni: 'Tiết kiệm xây dựng',
      tokPenez: 'Dòng tiền',
      uvolnenePenizeARustMzdy: 'Tiền được giải phóng và tăng lương',
      vkladNavic: 'Khoản nộp thêm',
      zatimNeniCoRozdelovat: 'Hiện chưa có gì để phân bổ — khách hàng không có tài sản tài chính khả dụng lẫn thặng dư hằng tháng.',
    },
    whatsAppSender: {
      klientNemaTelefonDopln: 'Khách hàng chưa có số điện thoại — hãy bổ sung trong thông tin liên hệ.',
      navrhDleFazeKlienta: 'Gợi ý theo giai đoạn của khách',
      otevreWhatsappSTimto: 'Sẽ mở WhatsApp với nội dung này — bạn vẫn phải bấm gửi thủ công (miễn phí, không cần API).',
      otevritWhatsapp: 'Mở WhatsApp',
      sablona: 'Mẫu tin',
      zpravaUpravPodlePotreby: 'Tin nhắn (chỉnh sửa nếu cần)',
      zrusit: 'Hủy',
    },
  },
  /* BLOK:auto END */
  /* === /AUTO === */
  /* Phần TẠI SAO dành cho khách hàng (bảo hiểm nhân thọ) — xem cs.js. */
  /* VEŘEJNÁ SDÍLENÁ MODELACE /m/:token — čte to KLIENT, ne poradce.
   * Snapshot je uložený natrvalo, ale texty jsou KLÍČE, takže se přeloží do
   * jazyka toho, KDO SE DÍVÁ — ne toho, kdo modelaci vytvořil. */
  modelace: {
    nacitam: 'Đang tải bản tính toán…',
    neplatnyOdkaz: 'Liên kết này không hợp lệ hoặc đã hết hạn.',
    proVas: 'Bản tính toán dành cho bạn',
    vaseModelace: 'Bản tính toán của bạn',
    pripravenoPro: 'Chuẩn bị cho',
    jakRozumet: 'Cách đọc bản này',
    vasPoradce: 'Chuyên viên của bạn',
    paticka: 'Chỉ là mô phỏng tham khảo. Lợi nhuận quá khứ không bảo đảm cho tương lai.',
    ctaSchuzka: 'Hẹn gặp',
    ctaWhatsApp: 'Nhắn qua WhatsApp',
    ctaSpojit: 'Liên hệ',
    chybaNacteni: 'Hiện không tải được bản tính toán. Vui lòng kiểm tra kết nối và thử lại.',
    zkusitZnovu: 'Thử lại',
    prehrat: 'Phát',
    zastavit: 'Dừng',
    nahledKlient: 'Khách hàng sẽ thấy gì',
  },
  /* Popisky snapshotu životní kalkulačky pro /m/:token (a PDF).
   * ⚠️ Placeholder {castka} musí být ve všech pěti jazycích STEJNÝ. */
  zivotkoModelace: {
    heroSmrt: 'Gia đình cần bao nhiêu (trụ cột qua đời)',
    pocetOsob: 'Số người',
    nezbytneVydaje: 'Chi phí thiết yếu',
    zaMesic: '{castka}/tháng',
    zaDen: '{castka}/ngày',
    variantaKryti: 'Phương án bảo vệ',
    varianta_narocna: 'Bảo vệ đầy đủ',
    varianta_stredni: 'Mức trung dung',
    varianta_uskromnit: 'Thắt lưng buộc bụng',
    varianta_cena: 'Ưu tiên giá',
    krytiSmrt: 'Bảo vệ cho trường hợp tử vong',
    krytiInvalidita: 'Bảo vệ cho trường hợp mất sức lao động',
    pnRodina: 'Nghỉ ốm dài ngày (gia đình)',
    narativ1: 'Các con số cho biết gia đình sẽ nhận được bao nhiêu nếu điều tệ nhất xảy ra — để vẫn giữ được chỗ ở, giữ mức sống và các con học xong.',
    narativ2: 'Mất sức lao động ra số cao hơn tử vong, vì người bệnh ở nhà còn cần chăm sóc và sửa sang nhà cửa. Quyền lợi nghỉ ốm bù phần thu nhập hụt khi ốm hoặc bị thương ngắn ngày.',
    narativ3: 'Đề xuất tham khảo, không ràng buộc. Điều kiện và giá cụ thể chúng ta sẽ thống nhất cùng nhau.',
  },
  zivotkoProc: {
    nadpis: 'Vì sao mất sức lao động là quan trọng nhất',
    podnadpis: 'Từng bước một, từ chính các con số của bạn',
    osloveni: '{kdo}, đây là bản tính toán của bạn — và quan trọng nhất là LÝ DO tại sao lại là những con số này.',
    proOsobu: 'Tính cho: {kdo}.',
    proOsobuVice: 'Tính cho {kdo} — người có thu nhập cao nhất trong gia đình. Những người khác có phần tính riêng.',
    proOsobuViceBezJmena: 'Tính cho người có thu nhập cao nhất trong gia đình. Những người khác có phần tính riêng.',
    k1Nadpis: 'Hôm nay',
    k1Popis: 'Gia đình có {prijem} mỗi tháng và cần {vydaje} cho những khoản thiết yếu.',
    k1PopisBezVydaju: 'Hiện gia đình có {prijem} mỗi tháng.',
    k2Nadpis: 'Thu nhập mất đi',
    k2Popis: '{kdo} không thể đi làm nữa. Gia đình chỉ còn {zbytek} mỗi tháng.',
    k2PopisBezJmena: 'Khoản thu nhập này không còn nữa. Gia đình chỉ còn {zbytek} mỗi tháng.',
    k2PopisNic: '{kdo} không thể đi làm nữa. Gia đình không còn khoản thu nhập lao động nào khác.',
    k2PopisNicBezJmena: 'Khoản thu nhập này không còn nữa. Gia đình không còn khoản thu nhập lao động nào khác.',
    k3Nadpis: 'Nhưng chi phí lại TĂNG LÊN',
    k3Popis: 'Các hóa đơn không biến mất — ngược lại còn thêm chi phí chăm sóc, thuốc men, đi khám và sửa nhà cho phù hợp. Mô hình tính mức tăng {pct} %, tức {vydaje} mỗi tháng. Đây chính là điểm khác với trường hợp tử vong: người đó vẫn sống, và cuộc sống thì tốn tiền.',
    k3PopisBezNarustu: 'Các hóa đơn không biến mất. Gia đình vẫn cần {vydaje} mỗi tháng.',
    k4Nadpis: 'Nhà nước chỉ bù được một phần',
    k4Popis: 'Lương hưu mất sức lao động là {duchod} mỗi tháng. Sau khi cộng hết các khoản thu nhập và trợ cấp còn lại, mỗi tháng vẫn thiếu {chybi}.',
    k4PopisBezDiry: 'Lương hưu mất sức lao động là {duchod} mỗi tháng. Chi phí thường ngày gia đình vẫn lo được từ thu nhập và trợ cấp còn lại — khoảng trống chỉ xuất hiện ở phần nợ và mục tiêu.',
    k5Nadpis: 'Và thiếu như vậy mỗi tháng, suốt {roky} năm',
    k5Popis: 'Để bù kín khoảng trống đó trọn {roky} năm, cần số vốn {kapital}. Đây không phải phép cộng đơn giản thành {naivne} — trong thời gian đó tiền vẫn sinh lời, nên cần ít hơn. Phép tính dùng mức {sazba} % mỗi năm trên lạm phát.',
    k5PopisBezSazby: 'Để bù kín khoảng trống đó trọn {roky} năm, cần số vốn {kapital}.',
    k6Nadpis: 'Cộng thêm nợ và mục tiêu',
    k6NadpisDluhy: 'Cộng thêm nợ',
    k6NadpisCile: 'Cộng thêm mục tiêu của gia đình',
    k6Popis: 'Vốn cho chi phí sinh hoạt mới là một phần. Phần còn lại là nghĩa vụ nợ và các kế hoạch. Nợ thì không bao giờ được cắt giảm — không thể trả 80 % một khoản vay mua nhà.',
    k6PopisBezDluhu: 'Vốn cho chi phí sinh hoạt mới là một phần. Phần còn lại là những kế hoạch của gia đình, vốn không nên dừng lại.',
    k6Dluhy: 'Nợ phải trả: {castka}',
    k6Cile: 'Mục tiêu của gia đình: {castka}',
    souhrnNadpis: 'Tổng cho mất sức lao động',
    souhrnNadpisOsoba: 'Cho mất sức lao động — {kdo}',
    souhrnNadpisJedna: 'Cho mất sức lao động — riêng người này',
    souhrnPopis: 'Đây là số tiền cần có trong hợp đồng để gia đình sống tiếp thêm {roky} năm mà không mất chỗ ở.',
    souhrnPopisBezLet: 'Đây là số tiền cần có trong hợp đồng để gia đình sống tiếp mà không mất chỗ ở.',
    srovnaniVyssi: 'Với trường hợp tử vong, con số là {smrt}. Mất sức lao động cao hơn {rozdil} — và đó chính là lý do nó đứng đầu. Người đã mất không ăn, không cần chỗ ở và không cần chăm sóc. Người còn sống thì có.',
    srovnaniStejne: 'Với trường hợp tử vong, con số là {smrt}. Ở trường hợp của bạn hai con số khá gần nhau — khi đó điều gì xảy ra trước sẽ quyết định.',
    pausalNadpis: 'Vì sao không dùng quy tắc năm lần thu nhập năm',
    pausalMene: 'Quy tắc trong sách vở — năm lần thu nhập một năm — sẽ cho ra {pausal}. Con số đó thấp hơn {rozdil} so với kết quả tính từ chính chi phí, trợ cấp và số năm của bạn. Quy tắc chung không biết khoản vay mua nhà hay các con của bạn, nên ở đây không dùng nó.',
    pausalVice: 'Quy tắc trong sách vở — năm lần thu nhập một năm — sẽ cho ra {pausal}, tức cao hơn {rozdil} so với kết quả tính từ chính các con số của bạn. Quy tắc chung không biết chi phí hay trợ cấp của bạn, nên ở đây không dùng nó.',
    rizikaNadpis: 'Các rủi ro còn lại — và chúng lo được gì',
    rizikaNadpisOsoba: 'Các rủi ro còn lại — và chúng lo được gì cho {kdo}',
    rizikaNadpisJedna: 'Các rủi ro còn lại — và chúng lo được gì cho cùng người đó',
    coJe: 'Đó là gì',
    bez: 'Điều gì xảy ra nếu không có bảo hiểm',
    resi: 'Lo được bao nhiêu',
    smrtNazev: 'Tử vong',
    smrtCoJe: 'Trụ cột gia đình qua đời — do tai nạn hoặc bệnh tật.',
    smrtBez: 'Chi phí và nợ vẫn còn, một nguồn thu nhập biến mất. Gia đình phải bán nhà đúng vào năm họ ít sức lực nhất.',
    trvNazev: 'Di chứng vĩnh viễn do tai nạn',
    trvCoJe: 'Tai nạn để lại hạn chế vĩnh viễn — tay, chân, thị lực, cột sống.',
    trvBez: 'Các khoản chi một lần (phục hồi chức năng, cải tạo nhà không rào cản, đổi xe) lấy từ tiền dự phòng. Khi không đủ thì phải vay.',
    trvResiPopisek: 'Chi trả lũy tiến: di chứng càng nặng, mức chi trả càng cao — trong mô hình của chúng tôi tối đa {nasobek}× số tiền đã thỏa thuận, tùy công ty bảo hiểm.',
    pnNazev: 'Nghỉ ốm dài ngày',
    pnCoJe: 'Bệnh hoặc tai nạn kéo dài vài tuần đến vài tháng. Sau đó người bệnh trở lại làm việc.',
    pnBez: 'Thu nhập tụt xuống mức trợ cấp ốm đau, chi phí vẫn như cũ. Tiền dự phòng cạn trong vài tháng.',
    pnBezOsvc: 'Người tự kinh doanh không tham gia bảo hiểm ốm đau sẽ không nhận được gì từ nhà nước. Chi phí vẫn chạy và tiền dự phòng cạn trong vài tháng.',
    pnResiDen: '{castka} / ngày',
    pnKarenceOd: 'Tiền dự phòng lo được những tháng đầu, nên khoản chi trả được đề xuất từ tháng thứ {od}.',
    pnKarenceHned: 'Đề xuất ngay từ ngày đầu tiên.',
    zavNazev: 'Bệnh hiểm nghèo',
    zavCoJe: 'Ung thư, nhồi máu cơ tim, đột quỵ và các chẩn đoán khác trong danh mục của công ty bảo hiểm.',
    zavBez: 'Điều trị và hồi phục kéo dài hàng tháng đến hàng năm. Người bệnh làm việc ít đi, chi nhiều hơn — và không còn thời gian lo chuyện tiền bạc.',
    zavResiPopisek: 'Chi trả một lần, bằng {nasobek} lần thu nhập một năm.',
    ditNazev: 'Sự cố nghiêm trọng với con',
    ditCoJe: 'Sau tai nạn hoặc bệnh tật, đứa trẻ phụ thuộc vĩnh viễn vào sự chăm sóc.',
    ditBez: 'Khoảng trống lớn nhất không phải chi phí chữa trị — mà là người bố hoặc mẹ phải nghỉ việc hẳn để chăm con.',
    ditResiPopisek: 'Số tiền trên hợp đồng của mỗi đứa trẻ. Được tính từ phần thu nhập mất đi của người bố hoặc mẹ sẽ chăm sóc con.',
    ditResiStrop: 'Số tiền trên hợp đồng của mỗi đứa trẻ. Một phần nhu cầu ({castka}) không công ty bảo hiểm nào nhận cho trẻ em — phần đó thuộc về tiền dự phòng và đầu tư.',
    cenaNadpis: 'Giá',
    cenaZadana: 'Mức bảo vệ này là {cena} mỗi tháng. Đây là con số từ bản chào mà chuyên viên tư vấn nhập vào — giá cuối cùng do công ty bảo hiểm xác nhận trong hợp đồng, sau khi thẩm định sức khỏe. Trước đó nó chỉ là ước tính, không phải lời chào.',
    cenaChybi: 'Tài liệu này cố ý không ghi giá. Chuyên viên tư vấn sẽ bổ sung theo từng công ty bảo hiểm — khi hợp đồng chưa ký, không con số nào ở đây là lời chào.',
    cenaDen: 'Tính theo ngày là {denne}.',
    cenaPct: 'Bằng {pct} % thu nhập ròng của gia đình.',
    poznamkaModelace: 'Đây là bản tính toán minh họa, không phải hợp đồng bảo hiểm và cũng không phải khuyến nghị cá nhân. Các con số dựa trên những gì bạn cung cấp — nếu thu nhập, chi phí hay mục tiêu thay đổi thì kết quả cũng thay đổi.',
    poznamkaSablona: 'Số tiền cho di chứng vĩnh viễn, bệnh hiểm nghèo và rủi ro của trẻ là mẫu tham khảo từ thực tế tư vấn. Hạn mức, điều khoản loại trừ và thời gian chờ cụ thể do công ty bảo hiểm quy định.',
    poznamkaDavky: 'Lương hưu mất sức lao động và trợ cấp ốm đau là ước tính theo quy định của Séc. Mức thực tế do cơ quan bảo hiểm xã hội quyết định.',
    poznamkaMetodika: 'Phương pháp {verze}.',
  },

  /* Klientské formuláře (/f/:token) — JEDINÁ obrazovka appky, kterou otvírá
   * klient, ne poradce. Otevře ji v telefonu, bez přihlášení, a může to být
   * Vietnamec nebo Ukrajinec — proto tu nesmí být ani jeden dvoujazyčný ternár.
   *
   * ZNĚNÍ OTÁZEK TU NENÍ. Popisky polí, nápovědy i texty souhlasu chodí ze
   * serveru přeložené (backend/lib/formulare/*). Backend je jediný zdroj pravdy
   * o tom, jaká pole formulář má a která z nich jsou citlivá; kdyby si seznam
   * držel frontend, stačila by jedna překlepnutá klíčovka a rodné číslo by
   * skončilo v nešifrované části dokumentu.
   */
  formKlient: {
    castZ: "Phần {n} / {celkem}",
    /* Příjmy a výdaje — obrazovka skupiny výdajů a „Váš přehled“ (26. 10. 2026). */
    pv: {
      prehledNadpis: "Tổng quan của bạn",
      prehledPodnadpis: "Kiểm tra các con số và gửi cho cố vấn. Điều gì chưa đúng, hãy chỉnh lại.",
      prijmy: "Thu nhập",
      vydaje: "Chi tiêu",
      mesicne: "mỗi tháng",
      zbyva: "Còn lại mỗi tháng",
      zbyvaPopis: "thu nhập − chi tiêu − trả nợ",
      zbyvaZaporne: "Chi tiêu và trả nợ cao hơn thu nhập.",
      bezPrijmu: "Không có thu nhập thì không tính được số còn lại.",
      rozpad: "Tiền đi đâu",
      rozpadPrazdno: "Bạn chưa điền chi tiêu.",
      rozpadAria: "Chi tiêu hàng tháng theo nhóm, lớn nhất là {skupina}: {castka}",
      porovnaniAria: "Thu nhập {prijmy}, chi tiêu {vydaje}",
      splatky: "Trả nợ vay",
      sporeni: "Tiết kiệm và đầu tư",
      neniVydaj: "không tính là chi tiêu",
      firma: "Kinh doanh (tính riêng, ngoài gia đình)",
      minimum: "mức tối thiểu cần thiết",
      minimumCelkem: "Tổng mức tối thiểu cần thiết",
      osoba1: "Bạn",
      osoba2: "Vợ / chồng / bạn đời",
      dalsiPrijmy: "Tiền thuê, lợi tức, thưởng",
      pravidlo: "Quy tắc tham khảo 50 / 30 / 20",
      pravidloPopis: "Chi tiêu bắt buộc và trả nợ 50–60 %, cuộc sống 20–30 %, tương lai lý tưởng 20 % thu nhập. Chỉ để tham khảo, không phải đánh giá.",
      povinne: "Bắt buộc",
      zivot: "Cuộc sống",
      budoucnost: "Tương lai",
      cil: "mục tiêu {rozsah}",
      skupinaCelkem: "Tổng nhóm",
      vydajeZatim: "Chi tiêu đến giờ",
      podrobnosti: "Chi tiết: mức tối thiểu cần thiết",
      podrobnostiSkryt: "Ẩn chi tiết",
      minimumPopis: "Trong đó mức tối thiểu cần thiết là bao nhiêu — khoản không thể thiếu trong một tháng không có thu nhập.",
    },
    nacitam: "Đang tải biểu mẫu…",
    neplatnyNadpis: "Liên kết không còn hiệu lực",
    neplatnyText: "Liên kết biểu mẫu có thời hạn giới hạn. Hãy nhắn cho cố vấn của bạn để nhận liên kết mới.",
    chybaNadpis: "Không tải được biểu mẫu",
    chybaText: "Hãy thử tải lại trang. Nếu vẫn không được, hãy liên hệ cố vấn của bạn.",
    hotovoNadpis: "Đã gửi, cảm ơn bạn",
    hotovoText: "{poradce} sẽ liên hệ với bạn. Phần bạn chưa điền sẽ cùng nhau bổ sung.",
    hotovoTextBezJmena: "Cố vấn của bạn sẽ liên hệ. Phần bạn chưa điền sẽ cùng nhau bổ sung.",
    jazyk: "Ngôn ngữ",
    krokZ: "Câu hỏi {n} trên {celkem}",
    sekceOtazek: "Số câu hỏi trong phần này: {n}",
    zacit: "Bắt đầu",
    pokracovat: "Tiếp tục",
    zpet: "Quay lại",
    dale: "Tiếp",
    preskocit: "Bỏ qua",
    nepovinne: "Không bắt buộc",
    ukladam: "Đang lưu…",
    ulozeno: "Đã lưu — bạn có thể đóng và quay lại sau.",
    chybaUlozeni: "Không lưu được các thay đổi gần nhất. Chúng tôi sẽ thử lại ở lần chỉnh sửa tiếp theo.",
    chybaUlozeniOdkaz: "Liên kết không còn hiệu lực — vui lòng liên hệ cố vấn của bạn.",
    zamek: "Được lưu ở dạng mã hóa",
    ulozenoZasifrovane: "Đã lưu mã hóa: {maska}. Để trống nếu không cần thay đổi.",
    platiDo: "Liên kết có hiệu lực đến {datum}.",
    vyberte: "Hãy chọn",
    nevyplneno: "Chưa điền",
    pridatRadek: "Thêm dòng",
    smazatRadek: "Xóa dòng",
    zvlastniKategorie: "Dữ liệu thuộc loại đặc biệt",
    souhlasNadpis: "Trước khi bắt đầu",
    souhlasPokracovat: "Tôi đồng ý và muốn tiếp tục",
    souhlasOdmitnout: "Tôi không đồng ý",
    souhlasNutny: "Không có sự đồng ý thì không thể điền biểu mẫu.",
    souhlasOdmitnutoNadpis: "Chúng tôi hiểu",
    souhlasOdmitnutoText: "Chúng tôi không lưu gì cả và đã đóng liên kết. Nếu bạn đổi ý, cố vấn sẽ gửi liên kết mới.",
    odvolatSouhlas: "Rút lại sự đồng ý và đóng liên kết",
    rekapitulaceNadpis: "Kiểm tra và gửi",
    rekapitulacePodnadpis: "Phần bạn chưa điền sẽ bổ sung cùng cố vấn. Không nhất thiết phải đầy đủ.",
    upravit: "Sửa",
    prazdno: "Bạn chưa điền gì cả.",
    odeslat: "Gửi cho cố vấn",
    odesilam: "Đang gửi…",
    chybiPovinne: "Còn thiếu trước khi gửi: {pole}.",
    chybaOdeslani: "Gửi không thành công. Vui lòng thử lại một lần nữa.",
    poradce: {
      /* Příjmy a výdaje — banner v analýze a složka (26. 10. 2026). */
      pv: {
        banner: "Khách hàng đã gửi thu nhập và chi tiêu ({datum})",
        prevzit: "Chuyển vào phân tích",
        prevzato: "Đã chuyển vào phân tích",
        zobrazit: "Hiện",
        skryt: "Ẩn",
        coSeZapise: "Những gì sẽ được ghi vào phân tích",
        drivTed: "trước {pred} → nay {po}",
        partnerChybi: "Khách hàng điền cả bạn đời, nhưng trong phân tích chưa có người thứ hai. Chỉ ghi người 1 — hãy thêm bạn đời rồi chuyển lại.",
        splatkySporeni: "Trả nợ và tiết kiệm khách hàng chỉ ghi để tổng quan — không ghi vào chi tiêu (thuộc Nghĩa vụ và Nguồn lực).",
        nicKPrevzeti: "Biểu mẫu trống — không có gì để chuyển.",
        hotovo: "Thu nhập và chi tiêu đã được chuyển vào phân tích.",
        chybaRazitka: "Các con số đã vào phân tích, nhưng dấu „đã chuyển“ chưa lưu được — thông báo có thể hiện lại.",
        chyba: "Chuyển không thành công.",
        chybaNacteni: "Không tải được câu trả lời của khách hàng.",
        pole: {
          prokaz1: "Người 1 — thu nhập chứng minh được",
          ostatni1: "Người 1 — kinh doanh / khác",
          prokaz2: "Người 2 — thu nhập chứng minh được",
          ostatni2: "Người 2 — kinh doanh / khác",
          pasivni: "Thu nhập thụ động",
          bonusyRok: "Thưởng cả năm",
          obvykle: "Chi tiêu thông thường (gồm bảo hiểm từ phân tích)",
          minimalni: "Chi tiêu cần thiết",
          rozpis: "Số mục trong bảng chi tiêu",
        },
      },
      nadpis: "Biểu mẫu cho khách hàng",
      popis: "Chọn loại, tạo liên kết và gửi cho khách hàng qua kênh của bạn. Ứng dụng không tự gửi bất cứ thứ gì.",
      typ: "Loại biểu mẫu",
      platnost: "Thời hạn liên kết",
      dnu: "{n} ngày",
      vytvorit: "Tạo liên kết",
      vytvarim: "Đang tạo…",
      zkopirovat: "Sao chép liên kết",
      zkopirovano: "Đã sao chép",
      zkopirovatZpravu: "Sao chép tin nhắn cho khách hàng",
      zneplatnit: "Hủy hiệu lực",
      zneplatnitPotvrzeni: "Thực sự hủy? Khách hàng sẽ không mở được liên kết nữa.",
      stavCeka: "Đang chờ khách hàng",
      stavRozpracovano: "Đang điền",
      stavVyplneno: "Đã điền xong",
      stavVyprselo: "Liên kết đã hết hạn",
      stavZneplatneno: "Đã hủy hiệu lực",
      stavOdvolano: "Khách hàng đã rút lại sự đồng ý",
      zobrazit: "Xem câu trả lời",
      skryt: "Ẩn câu trả lời",
      zvlastniKategorie: "Loại đặc biệt — dữ liệu sức khỏe",
      zvlastniHint: "Câu trả lời được mã hóa toàn bộ và không hiển thị ở phần xem trước. Mỗi lần mở đều được ghi vào nhật ký kiểm toán.",
      kUklidu: "Dữ liệu đã nằm ở đây hơn {n} ngày. Hãy cân nhắc xem bạn còn cần nó không.",
      bezFormularu: "Bạn chưa gửi cho khách hàng này biểu mẫu nào.",
      chybaNacteni: "Không tải được danh sách biểu mẫu.",
      chybaVytvoreni: "Không tạo được liên kết.",
      chybaOdpovedi: "Không tải được câu trả lời.",
      odhalit: "Hiện",
      platiDo: "Có hiệu lực đến {datum}",
      vyplneno: "Đã điền {n} trên {celkem} trường",
      jazykOdkazu: "Ngôn ngữ cho khách hàng",
      nicNeodesilame: "Liên kết chỉ được tạo ra. Hãy gửi tin nhắn qua kênh của bạn để biết ai nhận được.",
    },
  },
  /* Porovnávač tří způsobů čerpání renty (/renta-porovnavac).
   * 🔴 PRÁVNÍ: „poučené Nobelovou nadací“ NIKDY ne „portfolio Nobelovy nadace“;
   * modelace ≠ investiční doporučení; historie ≠ příslib budoucího výnosu. */
  /* Kdy budeš volný (KFP 20) — peníze přeložené na čas.
   * 🔴 PRÁVNÍ: modelace ≠ investiční doporučení; výnos je NAD inflací,
   * takže renta je v dnešních penězích. Nesmí se to podat jako příslib. */
  /* Hypotéka — čtyři rozhodnutí (KFP 02, 10, 11, 13).
   * 🔴 PRÁVNÍ: modelace, NE úvěrová ani investiční nabídka. Sazby zadává
   * poradce. Porovnává se celé měsíční zatížení, ne jen splátka. */
  hypoR: {
    zalRefixace: 'Hết kỳ cố định',
    zalSplatnost: '20 hay 30 năm',
    zalVyse: 'Bao nhiêu tiền tự có',
    zalCas: 'Thời gian làm gì',
    vyseMeneVlastnich: 'Ít tiền tự có hơn, đầu tư phần còn lại',
    vyseVicVlastnich: 'Nhiều tiền tự có hơn, vay ít hơn',
    chybiVstupy: 'Hãy điền các ô bên trái. Khi chưa điền thì không tính gì cả — ô trống không phải là số không.',
    zpet: 'Công cụ',
    nadpis: 'Vay mua nhà — bốn quyết định',
    podnadpis: 'Bốn câu hỏi khách hàng thực sự đặt ra về khoản vay mua nhà. Mỗi câu kết thúc bằng một câu nói, không phải một bảng. So sánh toàn bộ gánh nặng hằng tháng — nếu không thì là so táo với lê.',
    vstupyLabel: 'Khoản vay của khách hàng',
    cena: 'Giá bất động sản',
    vlastniA: 'Phương án A — tiền tự có',
    sazbaA: 'Phương án A — lãi suất',
    vlastniB: 'Phương án B — tiền tự có',
    sazbaB: 'Phương án B — lãi suất',
    sazbaBHint: 'Ngân hàng cho lãi suất tốt hơn khi LTV thấp hơn. Chính khác biệt đó là trọng tâm ở đây — không có nó thì phép tính vô nghĩa.',
    jistina: 'Số tiền vay',
    sazba: 'Lãi suất',
    splatnost: 'Thời hạn',
    let: 'năm',
    fixace: 'Kỳ cố định',
    kratsi: 'Phương án ngắn hơn',
    kratsiHint: 'Phương án dài hơn là ô Thời hạn ở trên. Ở đó, phần chênh lệch trả góp được đầu tư ngay từ tháng đầu tiên.',
    prijem: 'Thu nhập ròng hằng tháng',
    vydaje: 'Chi phí khác hằng tháng',
    zaLet: 'Nhìn trước',
    rustPrijmu: 'Tăng trưởng thu nhập',
    vynos: 'Lợi nhuận đầu tư',
    inflace: 'Lạm phát',
    inflaceHint: 'Mỗi khác biệt được hiển thị hai lần: theo tiền tương lai (con số lớn) và theo tiền hôm nay (thứ thực sự mua được).',
    refVerdiktLabel: 'Khi hết kỳ cố định',
    refVerdiktVeta: 'mỗi tháng nhiều hơn, nếu lãi suất tăng 1 điểm phần trăm. Trong {roky} năm còn lại là {celkem}.',
    refTabulka: 'Khoản trả theo lãi suất mới',
    refDnes: 'Hôm nay',
    refPoznamka: 'Trong {roky} năm cố định, khách hàng trả được {splaceno} tiền gốc ({pct} %). Phần còn lại được tái cấp vốn theo lãi suất mới — vì thế khoản trả nhảy vọt.',
    splVerdiktLabel: 'Với cùng gánh nặng hằng tháng, phần thắng thuộc về',
    splRemiza: 'hòa',
    splRemizaVeta: 'Cả hai phương án ra kết quả gần như nhau. Quyết định là ở chỗ khách hàng thấy thoải mái hơn với phương án nào.',
    splVerdiktVeta: 'Hơn {rozdil} theo tiền tương lai — tức {dnes} theo tiền hôm nay. Cả hai phương án đều tốn của khách hàng {zatizeni} mỗi tháng.',
    splMajetek: 'Tài sản cuối kỳ',
    splRadek: '{let} năm · trả góp {splatka}',
    splPoznamka: 'Ở phương án dài hơn, phần chênh lệch trả góp ({rozdil} mỗi tháng) được đầu tư từ tháng đầu tiên. Ở phương án ngắn hơn, sau khi trả hết thì toàn bộ khoản trả góp được đem đầu tư. Vì vậy cả hai tốn như nhau và chỉ khác ở kết quả.',
    vyseVerdiktLabel: 'Sau {roky} năm, phương án tốt hơn là',
    vyseVerdiktVeta: 'Hơn {rozdil}, tức {dnes} theo tiền hôm nay.',
    vyseTabulka: 'Hai phương án cạnh nhau',
    vyseVlastni: 'Tiền tự có',
    vyseUver: 'Khoản vay',
    vyseSazba: 'Lãi suất',
    vyseSplatka: 'Trả góp',
    vyseVolne: 'Còn dư để đầu tư',
    vyseMajetek: 'Tài sản cuối kỳ',
    casVerdiktLabel: 'Khoản trả góp không đổi, mọi thứ khác thì có',
    casVerdiktVeta: 'Tỷ lệ khoản trả góp trên thu nhập sau {roky} năm. Riêng lạm phát xóa đi {umazala} của khoản nợ — không cần trả thêm đồng nào.',
    casRozpocet: 'Ngân sách hằng tháng',
    casDnes: 'Hôm nay',
    casPozdeji: 'Sau {roky} năm',
    casPrijem: 'Thu nhập',
    casSplatka: 'Trả góp',
    casVydaje: 'Chi phí khác',
    casZbyva: 'Còn lại',
    casZatizeni: 'Khoản trả góp chiếm phần này của thu nhập',
    casPoznamka: 'Nợ còn lại sau {roky} năm: {nom} theo danh nghĩa, nhưng chỉ {real} theo tiền hôm nay. Khoản chênh {umazala} là công của lạm phát, không phải của khách hàng.',
    disclaimer: 'Đây là mô hình, không phải đề nghị cho vay hay đầu tư. Lãi suất do chuyên viên nhập — ứng dụng không khẳng định khách hàng sẽ nhận được mức đó. Lợi nhuận đầu tư không được bảo đảm và kết quả thực tế phụ thuộc vào thị trường, thuế và phí.',
  },

  svoboda: {
    rok: 'năm',
    roky: 'năm',
    let: 'năm',
    mesic: 'tháng',
    mesice: 'tháng',
    mesicu: 'tháng',
    hned: 'ngay bây giờ',
    zpet: 'Công cụ',
    nadpis: 'Khi nào bạn được tự do',
    podnadpis: 'Tiền được quy đổi thành thời gian. Thêm bất cứ khoản nào và xem tài sản bắt đầu trả hóa đơn thay cho công việc sớm hơn bao nhiêu.',
    nedosazitelneNadpis: 'Cách này sẽ không tới được.',
    zNedosazitelnehoNadpis: 'Bây giờ thì tới được rồi.',
    nedosazitelneText: 'Với số tiền để dành hiện nay, mục tiêu sẽ không đạt được kể cả sau cả đời. Đây không phải lỗi tính toán — đây là câu trả lời. Hãy thử tăng số tiền hằng tháng hoặc giảm mức thu nhập mục tiêu.',
    zNedosazitelnehoText: 'Trước đây mục tiêu hoàn toàn không đạt được. Sau khi tăng thì đã đạt được — nhưng không thể nói sớm hơn bao nhiêu, vì trước đó không có mốc thời gian nào.',
    ziskLabel: 'Khoản tăng này mang lại cho bạn',
    zatimNic: 'chưa có gì',
    ziskDovetek: 'sớm hơn so với khi mọi thứ giữ nguyên',
    ziskVyzva: 'kéo các thanh trượt bên dưới và xem điều gì xảy ra',
    dnesPlan: 'Kế hoạch hiện tại',
    sNavysenim: 'Sau khi tăng',
    osaLabel: 'Con đường tới độc lập',
    zaStropem: 'Mốc nằm ngoài cuối trục — dấu đứng ở mép.',
    dnes: 'hôm nay',
    cilKapital: 'Mục tiêu',
    cilVysvetleni: '= {renta} mỗi tháng theo giá trị tiền hôm nay',
    vstupyLabel: 'Hiện tại ra sao',
    renta: 'Thu nhập mong muốn mỗi tháng',
    rentaHint: 'Theo giá trị tiền hôm nay. Cần nhận bao nhiêu để việc đi làm trở thành lựa chọn.',
    majetek: 'Đã có sẵn cho mục tiêu này',
    majetekHint: 'Các khoản đầu tư và tiết kiệm thực sự dành cho mục tiêu này — không phải quỹ dự phòng và không phải tiền mua xe.',
    mesicne: 'Để dành mỗi tháng',
    vynos: 'Lợi nhuận trên lạm phát',
    vynosHint: 'TRÊN lạm phát, không phải tổng. Vì vậy con số thấp hơn khách hàng mong đợi — và vì vậy mức thu nhập tính theo tiền hôm nay.',
    coKdyby: 'Nếu thêm vào thì sao',
    jednorazove: 'Một lần, ngay bây giờ',
    skokNula: 'không',
    navic: 'Thêm mỗi tháng',
    pomerLabel: 'Đổi lại được gì',
    pomerText: 'Với {penize} thêm vào, họ nhận được {cas} cuộc sống không bắt buộc phải làm.',
    cokdybyPrazdno: 'Cả hai thanh trượt đang ở mức 0. Kéo một thanh lên và xem dấu nhấn trượt sang trái trên trục.',
    cekaniLabel: 'Cái giá của việc chờ đợi',
    cekaniText: 'Nếu bắt đầu muộn hơn. Trong lúc đó tiền nằm trong tài khoản — danh nghĩa không đổi, thực tế bị lạm phát bào mòn. Chính vì vậy mất mát lớn hơn thời gian chờ.',
    inflace: 'Lạm phát',
    cekaniOdklad: 'Bắt đầu muộn hơn {doba}',
    cekaniNedosazitelne: 'không còn đạt được',
    cekaniDovetek: 'lâu hơn hôm nay',
    disclaimer: 'Đây là mô hình, không phải tư vấn đầu tư và không phải cam kết lợi nhuận. Tính theo giá trị tiền hôm nay (lợi nhuận nhập ở mức trên lạm phát). Kết quả thực tế phụ thuộc vào thị trường, thuế và phí.',
  },

  rentaPorov: {
    zPlanuOdkaz: "So sánh ba cách rút tiền",
    zaMesic: "/tháng",
    zpusobPevne: "Tỷ lệ cố định",
    zpusobKlouzavy: "Trung bình trượt",
    zpusobMantinely: "Lan can an toàn",
    jakPevne: "{pct} của giá trị hiện tại",
    jakKlouzavy: "{pct} của trung bình {let} năm",
    jakMantinely: "bắt đầu {pct}, sau đó điều chỉnh theo quy tắc",
    vyhodaPevne: "Về lý thuyết vốn không bao giờ cạn — luôn chỉ rút một phần.",
    vyhodaKlouzavy: "Thu nhập ổn định hơn; một năm xấu không kéo tụt toàn bộ.",
    vyhodaMantinely: "Thu nhập cao nhất lúc bắt đầu.",
    presetPoucene: "Học theo Nobel",
    presetOpatrne: "Thận trọng",
    presetDynamicke: "Năng động",
    cenaPevne: "Thu nhập dao động theo thị trường, ngay lập tức và trọn vẹn.",
    cenaKlouzavy: "Sau khi thị trường sụt giảm, nó chi trả nhiều hơn giá trị thực của danh mục.",
    cenaMantinely: "Cắt giảm khi thị trường không thuận. Đây không phải quy tắc tốt hơn — mà là rủi ro khác.",
    rok: "Năm",
    mil: "tr.",
    tis: "nghìn",
    zpet: "Quay lại Công cụ",
    kicker: "Rút thu nhập hưu trí",
    title: "Ba cách rút tiền đặt cạnh nhau",
    subtitle: "Cùng một số vốn, ba quy tắc rút. Khách hàng nhận bao nhiêu mỗi tháng, còn lại bao nhiêu — và cái giá phải trả.",
    zPlanu: "Vốn lấy từ kế hoạch của khách hàng",
    pouceneTitul: "Danh mục học hỏi từ Quỹ Nobel",
    pouceneText: "Quỹ Nobel đặt mục tiêu 3 % lợi nhuận thực mỗi năm và ngoài cổ phiếu, trái phiếu, tiền mặt còn nắm khoảng một phần năm ở tài sản thay thế và một phần mười ở bất động sản và hạ tầng. Chúng tôi không mô hình hóa những phần đó. Phân bổ bên dưới là bản đơn giản hóa của chúng tôi cho khách hàng không có chúng — đây không phải danh mục của Quỹ Nobel.",
    jenModelace: "Đây là mô phỏng, không phải khuyến nghị đầu tư.",
    vstupyTitul: "Rút từ đâu",
    vstupyPopis: "Mọi số tiền đều là giá trị thực, theo giá hôm nay — lợi nhuận đã trên lạm phát và thu nhập không được điều chỉnh theo lạm phát.",
    kapital: "Vốn để rút",
    roky: "Rút trong bao lâu",
    letPocet: "{n} năm",
    alokace: "Phân bổ danh mục",
    vynosPortfolia: "Lợi nhuận thực của danh mục",
    paNadInflaci: "mỗi năm trên lạm phát",
    akcie: "Cổ phiếu",
    dluhopisy: "Trái phiếu",
    penezniTrh: "Thị trường tiền tệ",
    scenar: "Kịch bản lợi nhuận",
    scenarModel: "Lợi nhuận mô hình",
    scenarHistorie: "Lịch sử thực tế",
    scenarPoradi: "Cùng những năm đó nhưng đảo ngược",
    scenarModelHint: "Mỗi năm như nhau: {pct}. Nó cho thấy nguyên lý, không phải thực tế — thị trường không bao giờ đi như vậy.",
    scenarHistorieHint: "Các năm {od}–{do} đúng như đã diễn ra. Giá trị thực, sau lạm phát. Đây không phải dự báo, chỉ là câu trả lời cho câu hỏi „nếu điều đó lặp lại thì sao“.",
    scenarPoradiHint: "Cùng tập lợi nhuận, cùng mức trung bình — chỉ đảo thứ tự. Cho thấy rủi ro thứ tự lợi nhuận.",
    startRok: "Năm bắt đầu",
    historieKratsi: "Từ năm {rok} lịch sử chỉ có {let} năm. Chỉ tính chu kỳ ngắn hơn — không có gì được mô hình bù vào.",
    cpiNespolehliva: "Dữ liệu lạm phát giai đoạn 1927–1946 bị phẳng. Vì vậy lợi nhuận thực từ mốc khởi đầu cũ như vậy là không đáng tin.",
    pokrocile: "Cài đặt nâng cao",
    sazbaCerpani: "Tỷ lệ rút",
    startMantinelu: "Tỷ lệ khởi đầu của lan can",
    oknoLet: "Cửa sổ trung bình trượt",
    naStartuMes: "Hằng tháng lúc bắt đầu",
    rozpetiRenty: "Khoảng thu nhập",
    zbudePo: "Còn lại sau {let} năm",
    celkemVyplaceno: "Tổng đã chi trả",
    nejhlubsiPropad: "Mức sụt giảm thu nhập sâu nhất",
    vRoce: "năm thứ {rok}",
    bezPropadu: "thu nhập không giảm",
    kapitalDosel: "Vốn cạn ở năm thứ {rok}",
    pocetSkrtu: "{n} lần cắt giảm",
    pocetZvyseni: "{n} lần tăng",
    nadvyplata: "Trên toàn bộ chu kỳ, đó là {castka} nhiều hơn so với tỷ lệ cố định.",
    cenaTitul: "Cái giá của thu nhập cao hơn lúc đầu",
    cenaPopis: "Lan can an toàn không phải là „quy tắc 4 % tốt hơn“. Bạn đánh đổi rủi ro nhỏ là hết tiền lấy rủi ro vừa phải của những đợt cắt giảm sâu kéo dài nhiều năm.",
    cenaPridano: "Thêm lúc bắt đầu",
    cenaOprotiPevnemu: "so với tỷ lệ cố định",
    cenaSkrtStitek: "Cái giá của nó",
    cenaSkrtVeta: "Ở năm thứ {rok}, thu nhập sẽ phải giảm {pct}",
    cenaSkrtZNa: "từ {z} xuống {na} mỗi tháng",
    cenaSkrtuCelkem: "{n} lần cắt giảm trong toàn bộ chu kỳ",
    cenaDno: "Điểm sâu nhất: {pct} dưới mức thu nhập cao nhất (năm thứ {rok}) — {castka} mỗi tháng",
    cenaBezSkrtuStitek: "Không có cắt giảm trong kịch bản này",
    cenaBezSkrtu: "Điều đó không có nghĩa là sẽ không bao giờ phải cắt giảm. Hãy xem các năm được dẫn chứng bên dưới — ở đó thì có.",
    cenaVycerpano: "Trong kịch bản này, vốn sẽ cạn ở năm thứ {rok}.",
    dolozenoTitul: "Dẫn chứng bằng các năm có thật",
    dolozenoKdo: "Người bắt đầu rút vào năm {rok}",
    dolozenoKratsi: "đó là toàn bộ dữ liệu lịch sử có được",
    dolozenoDno: "đáy thu nhập −{pct}",
    dolozenoSkrty: "{n} lần cắt, lần đầu ở năm thứ {rok}, đáy −{pct}",
    dolozenoBezSkrtu: "không cắt giảm",
    dolozeno1966: "Trong thập niên 1970 không chỉ cổ phiếu thua lỗ — lạm phát ăn mòn cả trái phiếu lẫn thị trường tiền tệ. Đa dạng hóa khi đó không giúp được.",
    dolozeno2000: "Năm 2000 là vấn đề của cổ phiếu. Trái phiếu và thị trường tiền tệ khi đó vẫn sinh lời, nên danh mục có tỷ trọng của chúng trụ tốt hơn.",
    dolozenoObecne: "Chuỗi lịch sử từ mốc này, giá trị thực sau lạm phát.",
    grafRenta: "Thu nhập hằng tháng theo thời gian",
    grafRentaPopis: "Đây là số tiền khách hàng thực sự nhận vào tài khoản. Theo giá hôm nay.",
    grafKapital: "Vốn theo thời gian",
    grafKapitalPopis: "Số còn lại trong tài khoản. Bằng không nghĩa là đã hết tiền.",
    poradiTitul: "Rủi ro thứ tự lợi nhuận",
    poradiPopis: "Cùng những năm đó, cùng mức lợi nhuận trung bình — chỉ khác thứ tự. Sụt giảm ở giai đoạn đầu rút tiền là chí mạng, vì bạn bán ở đáy.",
    poradiVpred: "Các năm {od}–{do} đã thực sự diễn ra thế nào",
    poradiVzad: "Cùng những năm đó nhưng đảo ngược",
    poradiVyplaceno: "Khách hàng nhận tổng cộng",
    poradiKapital: "Còn lại lúc kết thúc",
    poradiDno: "Đáy thu nhập",
    poradiSkrtu: "Số lần cắt của lan can",
    poradiZaverShoda: "Vốn cuối kỳ ra hoàn toàn giống nhau, nhưng số tiền khách hàng thực nhận chênh {pomer}× lần. Toàn bộ rủi ro nằm ở thu nhập, không phải ở sao kê tài khoản.",
    poradiZaverObecne: "Thứ tự các năm làm thay đổi số chi trả {pomer}×.",
    prehledTitul: "Tất cả các mốc khởi đầu lịch sử",
    prehledPopis: "{n} chu kỳ dài {let} năm, các năm {od}–{do}. Giá trị thực, sau lạm phát.",
    prehledSelhani: "Kết thúc mà hết tiền",
    prehledSelhaniPocet: "{n} trong {celkem}",
    prehledZadne: "không có",
    prehledMedianDno: "Mức sụt thu nhập thường gặp",
    prehledNejhorsiDno: "Mức sụt sâu nhất",
    prehledNejhorsiStart: "Mốc khởi đầu tệ nhất",
    prehledDoslo: "{rok} — cạn ở năm thứ {kdy}",
    prehledPozor: "Không có lần thất bại nào không phải là bằng chứng an toàn. Với tỷ lệ cố định, bạn luôn chỉ rút một phần số còn lại — tài khoản không bao giờ cạn, kể cả khi thu nhập giảm gần về không. Vì vậy hãy đọc mức sụt thu nhập bên cạnh số lần thất bại.",
    pravniTitul: "Trang này là gì và không là gì",
    pravni1: "Đây là mô phỏng, không phải khuyến nghị đầu tư. Nó không đánh giá hoàn cảnh, hiểu biết hay mục tiêu của khách hàng cụ thể.",
    pravni2: "Dữ liệu lịch sử không phải là lời hứa về lợi nhuận tương lai. Thị trường có thể giảm, và sẽ giảm.",
    pravni3: "Danh mục học hỏi từ Quỹ Nobel — không phải danh mục của Quỹ Nobel. Nobel còn nắm tài sản thay thế (~20 %) và bất động sản (~9 %) vốn không có ở đây, và đặt mục tiêu 3 % thực.",
    pravni4: "Mọi số tiền đều là giá trị thực, theo giá hôm nay. Lợi nhuận đã trên lạm phát và thu nhập không được điều chỉnh.",
    pravni5: "Chuỗi lịch sử là dữ liệu Mỹ (cổ phiếu, trái phiếu chính phủ, tín phiếu kho bạc) được quy đổi sang lợi nhuận thực bằng lạm phát Mỹ. Danh mục của Séc hành xử khác.",
  },
  manazerUi: {
    obnovit: 'Làm mới',
    pozvankyDole: 'Các lời mời đã tạo nằm ở phía dưới, giữa các thẻ cố vấn — kèm liên kết và nội dung tin nhắn soạn sẵn.',
    pridatPoradce: 'Thêm cố vấn vào nhóm',
    pridatPoradceHint: 'Nhập e-mail của cố vấn. Một lời mời sẽ được tạo và người đó phải tự chấp nhận trong phần Cài đặt — chỉ khi đó bạn mới thấy khách hàng, quy trình bán hàng, lịch và mục tiêu của họ. Chúng tôi chưa gửi e-mail, hãy báo cho người đó.',
    vytvoritPozvanku: 'Tạo lời mời',
    zadnyTym: 'Chưa có nhóm nào',
    zadnyTymHint: 'Hãy mời cố vấn bằng nút ở trên. Người đó sẽ xuất hiện ở đây ngay khi chấp nhận lời mời trong phần Cài đặt của họ — trước đó bạn không thấy dữ liệu của họ. Sau đó bạn sẽ thấy kết quả làm việc và có thể giao nhiệm vụ cho họ.',
  },
  naborUi: {
    hledatKandidata: 'Tìm ứng viên…',
    nikdoSeNenasel: 'Không tìm thấy ai',
    klikniAUvidis: 'Nhấn để xem đây là ai',
    coJeNabor: '📣 Tuyển dụng là gì:',
    coJeNaborText: 'bạn thu hút những cố vấn giàu kinh nghiệm từ đối thủ.',
    eyebrow: 'Quy trình tuyển dụng',
    inProc: 'đang xử lý',
    kpiPipe: 'Đang tuyển',
    krok1: 'thêm ứng viên',
    krok2: 'điền các con số của họ (doanh số, mạng lưới, tệp khách hàng) — chúng tôi tính điểm 🔥',
    krok3: 'bạn gửi cho họ một đề nghị không thể từ chối, dựa trên chính các con số của họ',
    krok4: 'bạn kéo thẻ qua quy trình cho tới „đang hoạt động“.',
    prvniKandidat: 'Thêm ứng viên đầu tiên',
    sub: 'Tuyển cố vấn từ đối thủ · điểm = doanh số × mạng lưới × tệp khách hàng · kéo thẻ giữa các giai đoạn',
    title: 'Tuyển dụng',
    zadnyKandidat: 'Chưa có ứng viên nào',
    zadnyKandidatHint: 'Hãy bắt đầu với một cái tên từ đối thủ — người bạn muốn có trong nhóm. Thêm họ vào, điền các con số và chúng tôi sẽ tính xem họ được lợi bao nhiêu khi về với bạn.',
  },
  motivApp: {
    aktivni: 'Đang dùng',
    midnight: 'Tối — cho công việc buổi tối',
    violet: 'Nổi bật, trẻ trung, khác biệt',
    lime: 'Kỹ thuật, tương phản cao, sắc nét',
    cobalt: 'Điểm nhấn lạnh trên nền ấm',
    indigo: 'Sạch sẽ, thiên về dữ liệu, fintech',
    legenda: 'Giao diện ứng dụng',
    sage: 'Ấm áp, mộc mạc, vững chãi',
    vybrat: 'Chuyển giao diện ứng dụng sang',
  },
  pojVar: {
    cena: 'Chỉ quan tâm giá',
    cenaPopis: 'chi phí thiết yếu, mục tiêu −60 %',
    narocna: 'Cho người yêu cầu cao',
    narocnaPopis: 'mục tiêu và chi phí ở mức đầy đủ',
    sablonaUpozorneni: 'Số tiền mẫu từ thực tế tư vấn — chỉ mang tính tham khảo, không phải chào bán hay cam kết. Cố vấn sẽ xác nhận hạn mức và giá cụ thể với công ty bảo hiểm.',
    stredni: 'Mức trung dung',
    stredniPopis: 'mục tiêu −30 %, chi phí giữ nguyên',
    uskromnit: 'Thắt lưng buộc bụng',
    uskromnitPopis: 'chi phí thiết yếu, mục tiêu −50 %',
    variantaBezKratceni: 'phương án cắt giảm MỤC TIÊU, không cắt mức sống. Nợ thì không bao giờ bị cắt giảm.',
  },
  davkyUi: {
    invalidI: 'Trợ cấp mất sức lao động mức I',
    invalidIHint: 'hạn chế một phần khả năng làm việc',
    invalidII: 'Trợ cấp mất sức lao động mức II',
    invalidIIHint: 'hạn chế nặng khả năng làm việc',
    invalidIII: 'Trợ cấp mất sức lao động mức III',
    invalidIIIHint: 'mất sức lao động hoàn toàn — không thể đi làm',
    nemocenska: 'Trợ cấp ốm đau (từ ngày thứ 15)',
    nemocenskaHint: 'ốm ngắn ngày / tai nạn — 60 % mức cơ sở đã giảm trừ',
    poznamka: 'Ước tính tham khảo theo quy định có hiệu lực từ 1. 1. 2025. Các mức thay đổi vào mỗi tháng Một — cố vấn sẽ kiểm tra số liệu bảo hiểm xã hội hiện hành. Không phải cam kết hay chào bán.',
    starobni: 'Lương hưu tuổi già',
    starobniHint: 'ước tính nếu bạn nghỉ hưu với thu nhập hiện tại (chưa tính trượt giá)',
  },
  duchodCil: {
    nazev: 'Về hưu — giữ nguyên mức sống',
  },
  zdrojAnalyza: {
    naposledy: 'Cập nhật lần cuối',
    vysvetleni: 'Được chuyển sang từ bản phân tích tài chính. Số tiền và tên do bản phân tích ghi đè; ghi chú và địa chỉ do cố vấn giữ.',
    zaklad: 'từ bản phân tích',
  },
  osaObchodu: {
    bezData: 'không có ngày',
    bezDataHlavicka: 'Không có ngày',
    diar: 'lịch',
    dnes: 'Hôm nay',
    faze: 'giai đoạn',
    naplanovano: 'đã lên lịch',
    poznamkaChyba: 'Không lưu được thay đổi',
    poznamkaDlouha: 'Ghi chú quá dài ({delka} trên tối đa {max} ký tự).',
    poznamkaPrazdna: 'Ghi chú không được để trống.',
    poznamkaUlozena: 'Đã sửa ghi chú',
    prazdna: 'Chưa có hoạt động nào. Hãy thêm ghi chú đầu tiên bên dưới.',
    stav: { deleted: 'đã hủy', detached: 'đã tách', done: 'đã xong', planned: 'đang chờ' },
    typ: { call: 'cuộc gọi', email: 'e-mail', note: 'ghi chú', sms: 'SMS', system: 'hệ thống' },
    ulozit: 'Lưu',
    upraveno: 'đã sửa',
    upravenoTitul: 'Đã sửa',
    upravitPoznamku: 'Sửa ghi chú',
    zaznamu: 'bản ghi',
    zeZalozeni: 'từ lúc tạo',
    zobrazitStarsi: 'Xem cũ hơn ({pocet})',
    zrusit: 'Hủy',
  },
  /* M13 · rizika samotného dítěte v Návrhu řešení — components/plan/DetskaRizikaBlok.js */
  /* BLOK:detiRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  detiRizika: {
    deti: 'Các con ({n}×)',
    dite: 'Con',
    hlavicka: 'hợp đồng trẻ em',
    hlavickaKazde: 'số tiền cho mỗi con',
    hospitalizace: 'Nằm viện',
    hospitalizacePozn: 'cho mỗi đêm nằm viện — cha mẹ ở cạnh con thay vì đi làm, trợ cấp nhà nước chỉ bù một phần',
    kojenec: 'dưới 1 tuổi',
    naDite: ' / con',
    nadpis: 'Bảo vệ cho con ({n}×)',
    odskodne: 'Trợ cấp ngày trong thời gian điều trị tai nạn',
    odskodnePozn: 'từ ngày điều trị đầu tiên, không có thời gian chờ — hồi phục tại nhà lấy thêm nhiều ngày công của cha mẹ',
    odskodneStrop: 'Các khoản trợ cấp ngày vượt thu nhập ròng mỗi ngày của người chăm con ({strop}) — vượt hạn mức thẩm định, hãy kiểm tra với công ty bảo hiểm.',
    pc: 'Số tiền bảo hiểm trên hợp đồng của con',
    pcPozn: 'tổng hai mục ở trên, giới hạn ở mức công ty bảo hiểm nhận',
    radekTrvale: 'Thương tật vĩnh viễn và chăm sóc',
    rodic: 'cha hoặc mẹ',
    sablona: 'MẪU THAM KHẢO',
    sablonaPozn: 'Các con số là mẫu từ thực tế tư vấn, không phải chào phí hay cam kết. Hạn mức, điều khoản loại trừ và giá cụ thể sẽ do chuyên viên xác nhận với công ty bảo hiểm.',
    sekceTrvale: 'Khi con phải phụ thuộc vào chăm sóc lâu dài',
    sekceVlastni: 'Rủi ro của chính đứa trẻ — các quyền lợi bổ sung riêng',
    stitekNadStropem: 'vượt hạn mức',
    stitekSablona: 'mẫu tham khảo',
    strop: 'Nhu cầu đầy đủ là {potreba}; trên hợp đồng cho trẻ, công ty bảo hiểm thường chỉ nhận tới khoảng {strop}. Phần còn lại {zbytek} thuộc về quỹ dự phòng và kế hoạch đầu tư, không thuộc về hợp đồng bảo hiểm.',
    tnu: 'Thương tật vĩnh viễn do tai nạn của con',
    tnuPozn: 'chi trả lũy tiến theo bậc — trong mô hình của chúng tôi tối đa 2,8× số tiền bảo hiểm, tùy công ty bảo hiểm',
    uvod: 'Trẻ chưa có thu nhập để bảo hiểm. Cái được bảo hiểm là thứ thực sự tốn tiền của gia đình: cha hoặc mẹ phải nghỉ làm để chăm con, và chi phí điều trị.',
    vekFew: '{n} tuổi',
    vekMany: '{n} tuổi',
    vekOne: '{n} tuổi',
    vypadekRodice: 'Thu nhập bị mất của người trực tiếp chăm con',
    vypadl: '{kdo} sẽ phải nghỉ làm',
    vypadlAuto: '{kdo} sẽ phải nghỉ làm — giả định, tính người có thu nhập thấp hơn',
    zaDen: '/ngày',
    zaNoc: '/đêm',
    zavazne: 'Bệnh hiểm nghèo',
    zavazneBezZakladu: 'Người chăm con chưa có thu nhập trong phân tích — số tiền sẽ do chuyên viên điền, hệ thống không tự nghĩ ra.',
    zavaznePozn: 'bạch cầu, khối u, tiểu đường tuýp 1, động kinh — chi trả một lần cho điều trị và để cha mẹ có thể ở nhà với con',
    zavazneStrop: 'Nhu cầu tính từ thu nhập của người chăm con là {potreba}; hợp đồng cho trẻ chi trả tới khoảng {strop}. Phần còn lại {zbytek} thuộc về quỹ dự phòng.',
  },
  /* BLOK:detiRizika END */

  /* BLOK:zivotkoKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoKalk: {
    celkemMesicne: 'Tổng mỗi tháng',
    cenaNadpis: 'Chi phí bảo vệ (phí bảo hiểm)',
    cenaPopis: 'Nhập phí bảo hiểm hằng tháng thực tế của công ty bảo hiểm đã chọn — tổng chi phí bảo vệ sẽ được tính.',
    cil: 'Mục tiêu',
    cilBydleni: 'Trả hết tiền nhà',
    cilDuchod: 'Hưu trí',
    cilVzdelani: 'Học vấn cho con',
    cileMale: 'mục tiêu',
    cilePlanNadpis: 'Mục tiêu — mỗi tháng cần đầu tư bao nhiêu',
    cilePlanPopis: 'Với lợi suất {vynos} % mỗi năm. Thu nhập thụ động quy đổi thành vốn theo hệ số ×{nasobek} — tương ứng {pct} % rút an toàn mỗi năm (1 triệu = {koef}).',
    cilePripocet: 'Số tiền này được cộng vào mức bảo vệ (tử vong/mất sức lao động). Tự do tài chính = thu nhập thụ động → kế hoạch đầu tư bên dưới (mỗi tháng cần đầu tư bao nhiêu).',
    cileRodiny: 'Mục tiêu của gia đình',
    cileZadanych: 'Mục tiêu: đã nhập',
    cilovaCastka: 'Số tiền mục tiêu',
    cistyPrijem: 'Thu nhập ròng hằng tháng',
    cistyPrijemMaly: 'thu nhập ròng',
    davkyNadpis: 'Tổng quan trợ cấp nhà nước và phần thu nhập bị hụt',
    davkyPopis: 'Khách hàng thực sự nhận được bao nhiêu từ nhà nước — và mỗi tháng còn thiếu bao nhiêu. Ước tính tham khảo dựa trên thu nhập và tuổi.',
    davkyPoznamka: 'Ước tính tham khảo (số liệu thực tế của cơ quan bảo hiểm xã hội có thể khác). Hãy điền tuổi của người đó để ước tính sát hơn.',
    davkyPoznamkaKratka: 'Ước tính tham khảo (số liệu thực tế của cơ quan bảo hiểm xã hội có thể khác).',
    den: 'ngày',
    denNaHlavu: 'ngày cho mỗi người',
    denniDavkyPn: 'Trợ cấp theo ngày (PN)',
    dluhy: 'Nợ (còn phải trả)',
    dluhyMale: 'nợ',
    dnesniHodnota: 'giá trị hiện tại',
    do1Roku: 'trong vòng 1 năm',
    grafNadpis: 'Còn lại gì khi thu nhập giảm',
    grafPopis: 'Phần màu xanh là khoản đệm — số còn lại sau khi đã trả những gì bắt buộc phải trả.',
    hned: 'ngay lập tức',
    invDuchodPodleZakona: 'theo luật',
    invalidita: 'Mất sức lao động',
    invalidniDuchodMaly: 'trợ cấp mất sức lao động',
    invalidniDuchodMes: 'Trợ cấp mất sức lao động / tháng',
    jehoPodil: 'phần của người này',
    klient: 'Khách hàng',
    likvidniRezerva: 'Quỹ dự phòng thanh khoản',
    mesTecka: 'tháng',
    mesZkratka: 'tháng',
    mesicneInvestovat: 'Đầu tư hằng tháng',
    naXLet: 'trong {roky} năm',
    navrhOchrany: 'Đề xuất bảo vệ gia đình',
    nazevCile: 'Tên mục tiêu',
    nejvetsiDopad: 'Tác động lớn nhất',
    nemocenska: 'trợ cấp ốm đau',
    nezbytneVydaje: 'Chi phí thiết yếu / tháng',
    odMesice: 'từ tháng thứ {n}',
    odPrvnihoDne: 'từ ngày đầu tiên',
    odkazTitle: 'Gửi khách hàng đường dẫn tới bản mô phỏng này',
    osoba: 'Người',
    osobaN: 'Người {n}',
    osobaPlaceholder: 'Người {n} — họ tên',
    osvc: 'Tự kinh doanh',
    osvcPlne: 'Tự kinh doanh (không có trợ cấp ốm đau)',
    osvcVarovani: 'Khi nghỉ ốm sẽ không nhận được gì từ nhà nước → nhu cầu bảo hiểm ốm đau cao hơn.',
    paramKoefRenty: 'Hệ số thu nhập thụ động',
    paramKoefRentyHint: '= {pct} % rút an toàn mỗi năm · thu nhập thụ động → vốn ×{nasobek} (số tiền thấp hơn = hệ số cao hơn)',
    paramNarust: 'Mức tăng chi phí khi mất sức lao động',
    paramNarustHint: 'chăm sóc, cải tạo nhà, thuốc men',
    paramPokles: 'Mức giảm chi phí sau khi qua đời',
    paramPoklesHint: 'gia đình chi tiêu ít hơn sau khi mất một thành viên',
    paramTnPrah: 'Ngưỡng di chứng vĩnh viễn (chi trả từ %)',
    paramTnPrahHint: 'dưới ngưỡng thì không chi trả; mức bảo vệ đầy đủ vào khoảng 60 %',
    paramVynos: 'Lợi suất đầu tư (p. a.)',
    paramVynosHint: 'để tính khoản đầu tư hằng tháng cho các mục tiêu',
    parametryMetodiky: 'Tham số phương pháp tính',
    patickaDavky: 'Các khoản trợ cấp xã hội (trợ cấp tuất cho vợ/chồng {vdovsky}{sirotci}, trợ cấp mất sức lao động) chỉ là ƯỚC TÍNH THAM KHẢO từ thu nhập — không phải cam kết của nhà nước. Cố vấn sẽ xác minh mức thực tế.',
    patickaMetodika: 'Mức bảo vệ khuyến nghị mang tính tham khảo theo phương pháp beplan (phương pháp {verze}): mất sức lao động/tử vong tính theo phương pháp vốn hóa @ 4 % thực — chi phí hộ gia đình sau sự kiện trừ đi thu nhập gia đình vẫn còn, trừ trợ cấp nhà nước. PN = thu nhập ròng − trợ cấp ốm đau. Phí và điều kiện cụ thể tùy công ty bảo hiểm đã chọn. Cố vấn là người quyết định cuối cùng.',
    patickaSirotci: ', trợ cấp tuất cho con tổng cộng {castka}',
    pdfInvaliditaPopis: 'khi bạn không còn khả năng đi làm',
    pdfJakRozumet: '<b>Cách hiểu các con số:</b> Chúng cho biết gia đình sẽ nhận được bao nhiêu nếu điều tồi tệ nhất xảy ra — để vẫn giữ được chỗ ở, giữ mức sống và các con học xong. <b>Mất sức lao động</b> có số tiền cao hơn tử vong, vì người bệnh ở nhà còn cần chăm sóc và cải tạo nhà cửa. <b>Nghỉ ốm</b> bù vào phần thu nhập bị hụt khi ốm ngắn ngày hoặc gặp tai nạn.',
    pdfPaticka: 'Đề xuất tham khảo, không ràng buộc. Điều kiện và giá cụ thể chúng ta sẽ thống nhất cùng nhau.',
    pdfPnPopis: 'ốm ngắn ngày hoặc tai nạn',
    pdfSmrtPopis: 'để gia đình không phải lo sợ điều gì',
    pdfTitle: 'Tải xuống / in bản PDF cho khách hàng',
    pdfTnuPopis: 'tai nạn càng nặng = chi trả càng cao',
    pdfZavaznePopis: 'ung thư, nhồi máu cơ tim, đột quỵ…',
    perex: 'Nhập thu nhập và chi phí của gia đình → tôi sẽ tính mức bảo vệ khuyến nghị: mất sức lao động, tử vong, nghỉ ốm, di chứng vĩnh viễn do tai nạn và bệnh hiểm nghèo.',
    pnCelkem: 'Gia đình cần trợ cấp nghỉ ốm tổng cộng',
    pnUraz: 'Nghỉ ốm / tai nạn',
    pocetDeti: 'Số con',
    podPrahem: '→ dưới ngưỡng',
    podilDluhu: 'phần nợ',
    podilNezbytnych: 'phần chi phí thiết yếu',
    pojistnaCastka: 'Số tiền bảo hiểm:',
    poskozeni: 'tổn thương',
    poslatKlientovi: 'Gửi cho khách hàng',
    potrebnyKapital: 'Vốn cần có',
    pozustalostniDavky: 'trợ cấp cho thân nhân',
    pracNeschopnost: 'Nghỉ ốm',
    pracovniNeschopnost: 'Nghỉ ốm',
    prezentovat: 'Trình bày',
    pridatCil: 'Thêm mục tiêu',
    pridatOsobu: 'Thêm người',
    prijemMaly: 'thu nhập',
    prijmyOstatnich: 'thu nhập của những người còn lại',
    procInvalidita: 'Thu nhập mất hẳn còn chi phí lại TĂNG LÊN (người chăm sóc, cải tạo nhà). Điều này thường phá vỡ gia đình nhanh hơn cả cái chết — vì vậy nó đứng số 1.',
    procNadpis: 'Vì sao lớp bảo vệ này quan trọng',
    procPn: 'Ốm hoặc tai nạn vài tháng: nhà nước hỗ trợ rất ít (người tự kinh doanh thì không có gì). Trợ cấp theo ngày bù vào phần hụt — ở nhà bạn lo hồi phục, không lo hóa đơn.',
    procSmrt: 'Để người trụ cột ra đi mà gia đình còn lại sự yên tâm, không phải nợ nần và khoản vay mua nhà. Con cái học xong, người bạn đời không phải thay đổi cuộc sống.',
    procTnu: 'Tai nạn nghiêm trọng để lại hạn chế vĩnh viễn. Chi trả lũy tiến: thương tật càng nặng, khoản chi trả một lần cho cải tạo và sinh hoạt càng cao.',
    progresivni: 'lũy tiến',
    renta: 'thu nhập thụ động',
    rentaMes: 'Thu nhập thụ động / tháng',
    rezervaHint: 'đủ dùng khoảng {mes} tháng',
    rezervaPokryje: 'quỹ dự phòng lo được {mes} tháng đầu, trợ cấp được đề xuất từ tháng thứ {odMes}',
    rodina: 'Gia đình',
    sloupecChybi: 'Còn thiếu /tháng',
    sloupecChybiMes: 'Còn thiếu / tháng',
    sloupecDokryt: 'Bù bằng bảo hiểm',
    sloupecDostane: 'Nhận từ nhà nước',
    sloupecSituace: 'Tình huống',
    sloupecStat: 'Nhà nước /tháng',
    sloupecStupen: 'Mức',
    smrt: 'Tử vong',
    stupneNadpis: 'Mất sức lao động theo từng mức',
    stupneNota: 'Cột bù bằng bảo hiểm là số vốn để lấp phần hụt trong {roky} năm.',
    stupnePopis: 'Mức càng cao thì trợ cấp nhà nước càng lớn, nhưng phần thu nhập mất đi cũng lớn hơn → cần bảo hiểm bù nhiều hơn. Mức III = mất sức lao động hoàn toàn (không thể đi làm), mức I = hạn chế một phần.',
    tela: 'cơ thể',
    titul: 'Máy tính bảo hiểm nhân thọ',
    tnuNadpis: 'Di chứng vĩnh viễn — chi trả lũy tiến',
    tnuPrah: 'Chi trả từ mức tổn thương {prah} %, mức bảo vệ cần thiết đầy đủ vào khoảng 60 %.',
    tnuVzorec: 'Chi trả = số tiền × hệ số × %.',
    tnuZeCastky: 'Từ số tiền bảo hiểm',
    toJePctPrijmu: 'tương đương {pct} % thu nhập ròng của gia đình',
    trvaleNasledky: 'Di chứng vĩnh viễn',
    trvaleNasledkyUrazu: 'Di chứng vĩnh viễn do tai nạn',
    typCastka: 'Số tiền',
    typRenta: 'Tự do tài chính',
    uvodniZprava: 'Xin chào, tôi gửi anh/chị đề xuất bảo vệ gia đình — gia đình sẽ cần bao nhiêu nếu có chuyện xảy ra. Anh/chị xem qua và cứ liên hệ với tôi nhé.',
    variantaKryti: 'Phương án bảo vệ (tử vong + mất sức lao động)',
    variantaKrytiKratce: 'Phương án bảo vệ',
    variantaSlovo: 'phương án',
    vek: 'Tuổi (năm)',
    vekHint: 'để xem tổng quan trợ cấp nhà nước',
    vekPrijem: '{vek} tuổi · thu nhập {castka}',
    vydajeRodiny: 'chi phí gia đình',
    vyssiVydaje: 'chi phí cao hơn {pct} % (chăm sóc, cải tạo)',
    waTitle: 'Gửi đề xuất cho khách hàng qua WhatsApp',
    xLet: '{n} năm',
    xOsob: '{n} người',
    xRocniPrijem: '{n}× thu nhập một năm',
    zaKolikLet: 'Sau bao nhiêu năm',
    zadejPrijem: 'Hãy nhập ít nhất một khoản thu nhập.',
    zajistitNa: 'Bảo vệ trong (năm)',
    zamestnanec: 'Người làm công ăn lương',
    zavazneOnemocneni: 'Bệnh hiểm nghèo',
  },
  /* BLOK:zivotkoKalk END */
  rozvahaGraf: {
    bezOceneni: 'Còn {pocet} {polozka} chưa được định giá — không được tính vào tổng.',
    cisteJmeni: 'Tài sản ròng',
    cisteJmeniPod: 'những gì sở hữu trừ đi những gì đang nợ',
    coDluzi: 'Đang nợ',
    coVlastni: 'Đang sở hữu',
    financni: 'Tài sản tài chính',
    nefinancni: 'Bất động sản và đồ đạc',
    podilDluhu: 'Nợ chiếm {pct} % tài sản — phần còn lại thực sự là của khách hàng.',
    vecnyMajetek: 'Trong đó tài sản hiện vật',
    zavazky: 'Khoản nợ',
  },
  menaAnalyzy: {
    bezRazitka: 'Bản phân tích này từ thời chưa lưu tiền tệ vào dữ liệu — chúng tôi đọc nó là {mena}. Tài khoản hôm nay làm việc bằng {ucet}.',
    neprepocitava: 'Số tiền KHÔNG được quy đổi — vẫn giữ nguyên như lúc nhập, ứng dụng không biết tỷ giá. Nhãn bên dưới hiển thị {symbol}. Hãy kiểm tra lại các con số trước khi đưa cho khách hàng.',
    pozor: 'Chú ý tiền tệ.',
    ulozena: 'Bản phân tích được lưu bằng {mena}, tài khoản hôm nay làm việc bằng {ucet}.',
  },
  zivotkoGraf: {
    celyPrijem: '— toàn bộ thu nhập',
    cenaDenne: '{castka} mỗi ngày cho từng người trong {hlav} thành viên gia đình.',
    cenaInvalidita: 'mất sức lao động',
    cenaPctPrijmu: 'Tương đương {pct} % thu nhập của bạn.',
    cenaPresahuje: 'Vượt quá mức đó — và điều này sẽ không bị giấu đi.',
    cenaSablona: 'Ước lượng sơ bộ từ bảng phí mẫu của chúng tôi — chỉ là MẪU, không phải chào bán. Giá chính xác do công ty bảo hiểm quyết định theo tuổi và bảng khai sức khỏe.',
    cenaSmrt: 'tử vong',
    cenaStrop: 'Trần {pct} % thu nhập = {castka}.',
    cenaVejde: 'Nằm gọn trong mức đó.',
    cenaZavira: 'Khoản này lấp đúng lỗ hổng bạn vừa thấy:',
    davkaInvalidIII: 'Trợ cấp mất sức lao động',
    davkaNemocenska: 'Trợ cấp ốm đau',
    davkaObecna: 'Trợ cấp',
    davkaPozustalostni: 'Trợ cấp tuất cho vợ/chồng và con',
    mesZkr: 'tháng',
    mesZkratka: 'tháng',
    nazevDnes: 'Hôm nay',
    nazevInvalidita3: 'Mất sức lao động mức III',
    nazevMzda5: 'Sếp cắt 5 % lương',
    nazevPn: 'Ốm dài ngày',
    nazevSmrt: 'Người trụ cột qua đời',
    popisChybi: 'Tháng nào cũng thiếu.',
    popisDnes: 'Đây là phần còn lại khi mọi thứ vẫn ổn.',
    popisDnesNapjato: 'Ngân sách đã căng ngay từ hôm nay — không có khoản đệm nào.',
    popisNastve: 'Bạn sẽ bực mình. Nhưng bạn vẫn tự xoay xở được.',
    popisRezervaMesice: 'Quỹ dự phòng gánh được {mes} tháng.',
    popisRezervaZadna: 'Hoàn toàn không có quỹ dự phòng cho việc này.',
    popisZvladnete: 'Bạn vẫn trụ được. Nhưng phải dừng tiết kiệm và du lịch.',
    proporceNecerpa: 'Không phải động tới quỹ dự phòng — thu nhập và trợ cấp đã đủ trả chi phí.',
    proporceRezerva: 'Quỹ dự phòng của bạn',
    proporceSchodek: 'Với mức hụt {castka} mỗi tháng, quỹ dự phòng lo được {pct} % khoảng thời gian đó.',
    proporceStat: 'Nhà nước khi ốm — thời gian được hỗ trợ',
    proporceStrop: 'Trợ cấp ốm đau tối đa {dni} ngày.',
    proporceTrvani: 'Còn bao lâu tới tuổi hưu',
    proporceVek: '{vek} tuổi, còn {roky} năm nữa tới tuổi hưu ({duchodVek}).',
    vynechanoCena: 'Bước về giá bị bỏ qua: chi phí bảo vệ chưa được nhập và cũng không ước tính được.',
    vynechanoHlavy: 'Phần chia giá theo ngày không hiển thị: không có dữ liệu để tính số thành viên trong gia đình.',
    vynechanoMena: 'Biểu đồ không hiển thị: ứng dụng mới chỉ tính được trợ cấp nhà nước của Séc. Trợ cấp Séc chia cho tỷ giá không phải là trợ cấp của Slovakia.',
    vynechanoPoDuchodu: 'Bước „kéo dài bao lâu“ bị bỏ qua: người chính đã đến tuổi nghỉ hưu.',
    vynechanoPrijem: 'Biểu đồ không hiển thị: chưa nhập khoản thu nhập nào. Không có thu nhập thì mọi bậc đều bằng không.',
    vynechanoVek: 'Bước „kéo dài bao lâu“ bị bỏ qua: người chính chưa có tuổi.',
    vynechanoVydaje: 'Biểu đồ không hiển thị: chưa nhập chi phí thiết yếu. Không có chúng thì không có gì để so với thu nhập.',
  },
  navrhVystupy: {
    jednaStrana: '1 trang',
    jednaStranaTitul: 'Kế hoạch một trang',
    plnyPlan: 'Kế hoạch đầy đủ',
    plnyPlanTitul: 'Kế hoạch tài chính đầy đủ',
    poznamka: 'Ghi chú cho đề xuất',
  },
  slozkaKlienta: {
    adresyKontakty: 'Địa chỉ và liên hệ',
    aktivita: 'Hoạt động',
    analyza: 'Phân tích',
    kraj: 'Tỉnh / vùng',
    mobil: 'di động',
    nabor: 'TUYỂN DỤNG',
    odhadPotencialu: 'Ước tính tiềm năng khách hàng',
    prijmeniPriklad: 'Nguyễn',
    sidloKlienta: 'Địa chỉ khách hàng',
    stitky: 'Nhãn',
    vlastnik: 'Người phụ trách',
    vztahKlient: 'Khách hàng',
    vztahPartner: 'Đối tác',
    zalozkyKlienta: 'Các tab của khách hàng',
    zdrojKontaktu: 'Nguồn liên hệ',
    zdrojLeadovac: 'Leadovač',
    zdrojReklama: 'Quảng cáo',
  },
  duchodKarta: {
    aktualizovatCil: 'Cập nhật mục tiêu',
    bezVeku: 'hãy điền tuổi, nếu không thì không tính được khoảng thời gian tích lũy (và chúng tôi sẽ không đoán).',
    chceMitMesicne: 'Muốn có mỗi tháng',
    chybi: 'Còn thiếu',
    cilovyStandard: 'Mức sống mục tiêu khi nghỉ hưu',
    daStat: 'Nhà nước chi trả',
    disclaimer: 'Lương hưu nhà nước chỉ là ƯỚC TÍNH THAM KHẢO từ thu nhập và tuổi, chưa tính trượt giá — không phải cam kết của nhà nước. Mức sống mục tiêu là lựa chọn của cố vấn, không phải số đo. Các số tiền tính theo giá trị hiện tại.',
    doDuchodu: '· còn {roky} năm tới tuổi hưu',
    duchodovyVek: 'Tuổi nghỉ hưu',
    kapitalRadek: 'vốn {castka} · {roky} năm · {vynos} % p. a.',
    mesicneOdkladat: 'Tích lũy mỗi tháng',
    nadpis: 'Tới tuổi hưu — giữ nguyên mức sống',
    nahradiPct: 'bù được {pct} % thu nhập ròng',
    odPoradce: 'do cố vấn nhập',
    osoba: 'Người',
    poDuchodovemVeku: 'Tuổi đã qua mốc nghỉ hưu — không còn thời gian tích lũy, cần số tiền này ngay.',
    popis: 'Nhà nước bù được bao nhiêu phần thu nhập và khách hàng phải tự lo bao nhiêu. Bấm nút để biến việc này thành mục tiêu tự do tài chính.',
    prepsatDuchod: 'Ghi đè mức lương hưu nhà nước',
    pridatJakoCil: 'Thêm thành mục tiêu',
    radekVek: '{vek} tuổi · {castka}/tháng',
    sablona: 'Mẫu tham khảo',
    standardHint: '% thu nhập ròng hiện tại. Thấp hơn 100 %, vì khi nghỉ hưu sẽ không còn những khoản khách hàng phải chi CHÍNH VÌ đang đi làm và đang tiết kiệm cho hưu trí.',
    statNeodhadujeme: 'Ở đây chúng tôi không ước tính lương hưu nhà nước',
    statNeodhadujemeHint: 'ước tính chỉ áp dụng cho Séc. Hãy nhập số tiền và tôi sẽ tính phần còn lại.',
    statPokryjeCely: 'nhà nước lo được toàn bộ mục tiêu',
    statPokryvaPct: 'nhà nước lo được {pct} % mục tiêu',
    vekHint: 'ước tính, có thể sửa lại',
  },
  /* Srovnávač fondů (/srovnavac-fondu). Doplněno 23. 8. 2026 — klíče se
     volaly, ale nebyly v žádném slovníku, takže vietnamský i ukrajinský
     poradce viděl český fallback. */
  fondy: {
    export: {
      chyba: "Không thể chuẩn bị biểu đồ.",
      hotovo: "Đã tải xuống.",
      pngChyba: "Không tạo được PNG. Hãy thử SVG — tệp này mở được trong trình duyệt.",
      nese: "Hình ảnh có kèm nguồn, ngày tháng và lưu ý.",
      csvSrovnani: "Tải CSV so sánh",
      csvRady: "Tải CSV chuỗi dữ liệu",
    },
    tabulka: {
      popisek: "Sáu tiêu chí đặt cạnh nhau. Ứng dụng không xếp hạng quỹ theo chất lượng và không khuyến nghị quỹ nào — lựa chọn thuộc về chuyên viên tư vấn.",
    },
    prazdno: {
      nadpis: "Danh mục chưa có dữ liệu về quỹ",
      veta: "Công cụ so sánh đã sẵn sàng — chỉ chờ dữ liệu. Giá trị lịch sử không được chép vào đây từ biểu đồ mà được nạp bằng cách nhập ba tệp CSV theo hướng dẫn trong docs/penze/JAK-DODAT-DATA.md. Màn hình trống còn trung thực hơn những con số bịa ra.",
      demo: "Xem với dữ liệu demo",
    },
    srovnavac: {
      nadpis: "Công cụ so sánh quỹ theo lịch sử",
      kotva: "Khoảng thời gian được tính ngược từ ngày cuối cùng của dữ liệu đã nạp, không phải từ hôm nay — nếu không, cửa sổ năm năm sẽ chỉ có bốn năm.",
    },
    filtr: {
      obdobi: "Khoảng thời gian",
      zobrazeni: "Hiển thị",
      jednotlive: "Từng quỹ riêng lẻ",
      prumeryNapoveda: "Giá trị trung bình chỉ tính từ những quỹ có dữ liệu cho toàn bộ khoảng thời gian.",
      prumery: "Trung bình theo chiến lược",
      strategie: "Chiến lược",
      skupiny: "Nhóm đầu tư",
      spolecnost: "Công ty hưu trí",
      historie: "Lịch sử ngắn hơn",
      jenPlna: "Loại các quỹ không có đủ lịch sử",
      zrusit: "Xóa bộ lọc",
      prazdno: {
        nadpis: "Không có quỹ nào khớp với bộ lọc",
        veta: "Hãy thử bỏ bớt một số điều kiện — hoặc danh mục hiện chưa có quỹ như vậy.",
      },
    },
    vyloucene: "Bạn đã loại khỏi so sánh:",
    varianty: {
      metrika: "SO SÁNH THEO",
    },
    vyber: {
      nadpis: "Cách chọn quỹ",
      veta: "Lợi nhuận lịch sử cao nhất không phải là tiêu chí. Cần đặt cạnh nhau: thời hạn của khách hàng, mức biến động, quỹ thực sự có lịch sử dài bao lâu, quy mô của quỹ, chỉ số rủi ro SRI theo luật và chi phí. Ứng dụng đưa ra con số; chỉ chuyên viên tư vấn mới đánh giá được điều nào phù hợp với từng khách hàng cụ thể.",
    },
    prumery: {
      nadpis: "Giá trị trung bình được tính từ đâu",
    },
    demo: {
      odznak: "DỮ LIỆU DEMO",
      veta: "Số liệu mẫu được bịa ra. Không dùng với khách hàng.",
      vysvetleni: "Không ai công bố các chuỗi này — chúng được bịa ra để có thể phát triển giao diện. Mỗi năm chúng tăng cùng một tỷ lệ phần trăm, điều không xảy ra trong thực tế. Dữ liệu thật được cung cấp bằng cách nhập tệp, hướng dẫn nằm trong docs/penze/JAK-DODAT-DATA.md.",
    },
  },

  penzeUi: {
    zaklad: { nominalne: "Danh nghĩa", dnesniCeny: "Theo giá hôm nay", nominalneKratce: "danh nghĩa", dnesniCenyKratce: "theo giá hôm nay" },
    rada: { vlastni: "Khoản bạn đóng", zamestnavatel: "Người sử dụng lao động", stat: "Trợ cấp nhà nước", zhodnoceni: "Lợi nhuận đầu tư" },
    most: { vklad: "Khoản bạn đóng", zamestnavatel: "Người sử dụng lao động", strategie: "Chiến lược" },
    strategie: { konzervativni: "Thận trọng", vyvazena: "Cân bằng", dynamicka: "Năng động", stare: "Quỹ hưu trí cũ" },
    cesta: { dnes: "Hiện trạng", kombinace: "Kết hợp DPS + DIP", zamestnavatel: "Có người sử dụng lao động" },
  },
  /* Bảo hiểm cá nhân (Đề xuất giải pháp + trình bày kế hoạch). */
  /* BLOK:pojisteniOsob START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniOsob: {
    bezPrijmu: 'Không có thu nhập từ công việc — phần hụt do thặng dư gia đình bù.',
    cena: '≈ Phí bảo hiểm tham khảo',
    cenaCelkem: '≈ Phí bảo hiểm tham khảo, tổng các thành viên',
    denni: '/ngày',
    diteRozporText: 'Trong phân tích có một dòng trẻ em thiếu cả tên lẫn ngày sinh. Trợ cấp mồ côi cho một đứa trẻ không có trong phân tích sẽ làm giảm số tiền bảo hiểm — vì vậy dòng đó không được tính. Hãy bổ sung trẻ vào phân tích, hoặc xóa dòng trống.',
    diteRozporTitul: 'Trẻ không có tên thì không được tính',
    doplnitNarozeni: 'Bổ sung ngày sinh',
    invalidita: 'Mất sức lao động (mức II–III)',
    klient1: 'Khách hàng 1',
    klient2: 'Khách hàng 2',
    mesicni: '/tháng',
    metodika: 'Phương pháp vốn @ 4 % thực: chi tiêu gia đình sau sự kiện − thu nhập gia đình vẫn giữ được − trợ cấp nhà nước, trong {roky} năm + nợ ({dluhy}) + mục tiêu − tài sản thanh khoản. Phương án {varianta} tính mục tiêu ×{kCile} và {vydaje}; nợ thì không bao giờ cắt. Các con số là đề xuất — người tư vấn có tiếng nói cuối cùng.',
    odskodne: 'Trợ cấp tai nạn theo ngày',
    osvc: 'tự doanh',
    partnerNespocteno: '{jmeno}: chưa tính bảo hiểm — thiếu ngày sinh',
    partnerNespoctenoText: 'Kế hoạch không bảo hiểm cho vợ/chồng và không tính phí bảo hiểm.',
    pn: 'Nghỉ ốm',
    pnPozn: 'từ tháng thứ {mesic} — trước đó quỹ dự phòng gánh',
    pnPoznNic: 'quỹ dự phòng và trợ cấp ốm đủ bù phần hụt',
    pnPoznOsvc: 'từ tháng thứ {mesic} — trước đó quỹ dự phòng gánh',
    popisInvalidita: 'Mất sức lao động là mất thu nhập dài hạn mà quỹ dự phòng không gánh nổi — trong khi chi phí lại tăng thêm (chăm sóc, sửa nhà). Về tài chính, rủi ro này lớn hơn tử vong.',
    popisOdskodne: 'Tai nạn cắt thu nhập ngay từ ngày đầu — không có thời gian chờ. Khoản chi trả theo ngày bù phần thu nhập mất đi trong suốt quá trình điều trị.',
    popisPn: 'Mất thu nhập ngắn hạn vượt quá quỹ dự phòng: trợ cấp ốm chỉ bù một phần thu nhập ròng, khoản chi trả bù nốt ngân sách. Vài tháng đầu do quỹ dự phòng gánh, nên thời gian chờ dài hơn thì phí thấp hơn.',
    popisSmrt: 'Thay thế thu nhập cho gia đình: bù chi tiêu thường ngày, các khoản trả nợ và những mục tiêu đang dở, để gia đình không phải đổi nếp sống chỉ sau một đêm. Chỉ tới lúc độc lập tài chính; số tiền giảm dần nên rẻ hơn.',
    popisTnu: 'Tổn thương vĩnh viễn sau tai nạn nghĩa là chi phí cao hơn mãi mãi. Chi trả lũy tiến theo bậc: hậu quả càng nặng thì tiền chi trả càng cao (trong mô hình của chúng tôi tối đa 2,8× số tiền bảo hiểm — tùy công ty bảo hiểm).',
    popisZavazne: 'Ung thư, nhồi máu cơ tim, đột quỵ: điều trị kéo dài nhiều tháng, thu nhập giảm và chi phí tăng. Khoản chi trả một lần giúp khách hàng ngừng làm việc để điều trị mà gia đình không phải dùng tới quỹ dự phòng hay các khoản đầu tư.',
    prijem: 'thu nhập',
    rozporText: 'Người thứ hai đã được điền thu nhập {castka}, nhưng thiếu cả họ tên lẫn ngày sinh. Mức bảo hiểm cho người không có trong phân tích sẽ không thuyết phục được khách hàng. Hãy bổ sung người bạn đời vào phân tích, hoặc sửa lại thu nhập.',
    rozporTitul: 'Người thứ hai không được tính — không có trong phân tích',
    smrt: 'Tử vong',
    titul: 'Bảo hiểm con người — đủ lớn để hoàn thành mọi mục tiêu',
    tnu: 'Thương tật vĩnh viễn',
    tnuPozn: 'chi trả lũy tiến theo bậc — trong mô hình của chúng tôi tối đa 2,8× số tiền bảo hiểm, tùy công ty bảo hiểm',
    tnuPrilepek: ' có lũy tiến',
    zavazne: 'Bệnh hiểm nghèo',
    zavaznePozn: '{nasobek}× thu nhập năm',
    zavaznePoznVyplata: 'Chi trả một lần cho việc điều trị và cho thời gian khách hàng không thể làm việc.',
  },
  /* BLOK:pojisteniOsob END */
  /* GIÁ TRỊ NHẬP TAY CỦA TƯ VẤN VIÊN — ghi đè số tiền bảo hiểm và giá trong đề xuất. */
  rucniPojisteni: {
    chip: "nhập tay",
    upravit: "Sửa thủ công",
    hotovo: "Xong",
    vratit: "Trở lại giá trị tính toán",
    system: "Hệ thống tính {castka}",
    titul: "Ghi đè giá và số tiền theo báo giá thực tế",
    vysvetleni: "Bấm vào biểu tượng bút chì bên cạnh bất kỳ số tiền hay mức phí nào và nhập đúng những gì khách hàng thực sự đã ký. Giá trị nhập tay được đánh dấu, còn giá trị tính toán vẫn nằm bên cạnh, nên lúc nào cũng có thể xem chênh lệch hoặc hoàn tác.",
    pocet: "{n} lần nhập tay",
    vratitVse: "Hoàn tác tất cả về giá trị tính toán",
    cenaOsoby: "Phí bảo hiểm tham khảo",
    nezadanaVarianta: "Chưa nhập giá cho phương án này",
    perVarianta: "Mức bảo hiểm và giá được lưu RIÊNG CHO TỪNG PHƯƠNG ÁN (hiện tại {varianta}). Hãy mô phỏng các phương án tại công ty bảo hiểm và nhập mức bảo hiểm cùng giá cho từng phương án — khi gặp khách bạn chuyển qua lại và cho thấy mức bảo hiểm cạnh mức phí.",
    odhadSablona: "ước tính theo bảng phí mẫu, không phải báo giá của công ty bảo hiểm",
    ukladam: "Đang lưu giá trị nhập tay…",
    ulozeno: "Đã lưu giá trị nhập tay",
    chyba: "Không lưu được giá trị nhập tay — hãy thử nút Lưu đề xuất",
  },
  /* BLOK:srovnaniPojisteni START — generuje scratchpad/slovnik.py, ručně needitovat */
  srovnaniPojisteni: {
    aspon: 'tối thiểu',
    celkem: 'Tổng',
    chybi: {
      cena: '{kdo}: chưa nhập giá cho phương án {varianta}. Hãy mô phỏng tại công ty bảo hiểm và ghi bằng biểu tượng bút chì trên thẻ Bảo hiểm con người — giá được lưu riêng cho từng phương án.',
      cenaBezVarianty: '{kdo}: chưa nhập giá cho phương án đã chọn. Hãy mô phỏng tại công ty bảo hiểm và ghi bằng biểu tượng bút chì trên thẻ Bảo hiểm con người — giá được lưu riêng cho từng phương án.',
      cenaCastecna: 'Giá chỉ được nhập cho một phần số người, nên tổng là con số ước tính một phần. Hãy ghi thêm bằng biểu tượng bút chì cho những người còn lại trên thẻ Bảo hiểm con người.',
      cenaDetske: 'Đề xuất còn có hợp đồng cho trẻ và ứng dụng chỉ có thể ước tính mức phí của nó — vì vậy tổng của người lớn không phải là giá của toàn bộ đề xuất. Hãy nhập tổng giá từ báo giá của công ty bảo hiểm.',
      limitRizika: '{kdo}: hợp đồng hiện có thiếu số tiền bảo hiểm — {riziko}. Hãy nhập vào phân tích ở hợp đồng.',
      platba: '{kdo}: hợp đồng hiện có thiếu mức phí hằng tháng — không có nó thì không thể nói hôm nay khách trả bao nhiêu.',
      platbaCastecna: '{kdo}: các hợp đồng {smlouvy} thiếu mức phí hằng tháng, nên „đang trả“ thấp hơn thực tế.',
      prirazeni: 'Các hợp đồng {smlouvy} có rủi ro ghi chưa gắn người nên được tính cho trụ cột gia đình. Sẽ tách theo từng người khi bạn chọn rủi ro thuộc về ai trong phân tích (Hợp đồng bảo hiểm → Rủi ro trong hợp đồng).',
      smlouvaPartnera: 'Các hợp đồng {smlouvy} được gán cho người bạn đời không có trong phân tích — nên không tính vào so sánh.',
      smlouvaPartneraNespocteno: 'Các hợp đồng {smlouvy} thuộc về vợ/chồng mà kế hoạch chưa tính bảo hiểm (thiếu ngày sinh) — không tính vào so sánh và kế hoạch không hủy chúng.',
      smlouvaSpolecnaBezPartnera: 'Trong các hợp đồng chung {smlouvy}, chỉ tính phần của khách hàng — vợ/chồng không có trong phân tích.',
      smlouvaSpolecnaNespocteno: 'Các hợp đồng {smlouvy} có thể bảo hiểm cả vợ/chồng, người mà kế hoạch chưa tính bảo hiểm (thiếu ngày sinh) — vì vậy kế hoạch không hủy chúng. Hãy nhập ngày sinh của vợ/chồng trong phân tích.',
      zadneSmlouvy: 'Phân tích không có hợp đồng bảo hiểm nào kèm số tiền bảo hiểm.',
    },
    dnesNekryty: 'hôm nay chưa được bảo hiểm',
    dnesNeplati: 'hôm nay không trả gì',
    domacnost: 'Hộ gia đình (cả hai người)',
    doplnKde: 'Hãy nhập vào phân tích: Nghĩa vụ và hợp đồng → Hợp đồng bảo hiểm → Rủi ro trong hợp đồng → mất sức lao động / tử vong của từng người. Chỉ khi đó mới cho khách thấy mức bảo hiểm mới cao gấp nhiều lần mà giá thì không.',
    doplnTitul: 'Thiếu số tiền bảo hiểm của hợp đồng cũ thì đây không phải so sánh, mà là tăng giá',
    doplnTlacitko: 'Nhập vào phân tích',
    hlavicka: {
      budePlatit: 'Sẽ trả',
      nasobekCeny: 'Giá',
      nasobekKryti: 'Bảo hiểm',
      novy: 'Mức bảo hiểm mới',
      platil: 'Đang trả',
      puvodni: 'Mức bảo hiểm hiện tại',
      riziko: 'Rủi ro',
    },
    nezadano: 'chưa nhập',
    novyNula: 'không đề xuất bảo hiểm',
    podtitul: 'phương án {varianta}',
    poznamka: '„Sẽ trả“ là mức phí từ báo giá của công ty bảo hiểm mà bạn đã nhập tay cho phương án này — ứng dụng không tự điền từ bảng phí mẫu. Ô trống nghĩa là chưa nhập, không phải bằng không.',
    prirazenoZiviteli: 'rủi ro chưa gắn người — tạm tính cho trụ cột gia đình, hãy chọn người trong phân tích',
    riziko: {
      invalidita: 'Mất sức lao động',
      smrt: 'Tử vong',
    },
    titul: 'Trước và sau — hôm nay có gì và sẽ có gì',
    vyhra: '{kdo}: mức bảo hiểm tăng nhanh hơn giá {pomer}×.',
    zivitel: 'trụ cột gia đình',
  },
  /* BLOK:srovnaniPojisteni END */
  /* POJIŠTĚNÍ MAJETKU A ODPOVĚDNOSTI (karta v Návrhu řešení).
     Násobek u odpovědnosti vůči zaměstnavateli je ZÁKONNÝ STROP a v každé zemi
     jiný (CZ 4,5× / SK 4×) — do vět chodí parametrem `{nasobek}`, NIKDY ho sem
     nepiš natvrdo. Zdroj předpisu drží lib/odpovednostZamestnavateli.js. */
  pojisteniMajetku: {
    titul: "Bảo hiểm tài sản và trách nhiệm",
    nemovitost: "Bất động sản",
    nemovitostPopis: "Theo toàn bộ giá trị từ phân tích — số tiền bảo hiểm bằng chi phí xây lại từ đầu (coi chừng bảo hiểm dưới giá trị).",
    domacnost: "Tài sản trong nhà",
    domacnostPopis: "Nội thất, đồ điện tử, đồ có giá trị. Ước tính theo những gì khách có rồi chỉnh lại cùng khách.",
    odpovednost: "Trách nhiệm dân sự",
    odpovednostPopis: "Thiệt hại gây ra cho người khác không có mức trần (sức khỏe, ngập nước, đâm phải người đi xe đạp) — hãy chọn hạn mức cao nhất có thể.",
    zamestnavatel: "Trách nhiệm với người sử dụng lao động",
    zamestnavatelOsoba: "Trách nhiệm với người sử dụng lao động — {jmeno}",
    zamestnavatelPopis: "Người sử dụng lao động có thể đòi bồi thường tới {nasobek} lần thu nhập bình quân tháng — hạn mức tính từ lương gộp. Mức trần này không áp dụng khi thiệt hại do cố ý hoặc do say rượu.",
    zamestnavatelPopis2: "Hợp đồng riêng cho người thứ hai — hạn mức tính từ lương gộp CỦA NGƯỜI ĐÓ, không phải từ thu nhập hộ gia đình. Ở đây cũng áp dụng {nasobek} lần thu nhập bình quân tháng.",
    hrubaMzda: "Lương gộp",
    limit: "Hạn mức {nasobek}×",
    zdrojLimitu: "Hệ số này là mức trần luật định, không phải ước tính của chúng tôi: {predpis}. Đã kiểm chứng {datum}. Cơ sở là thu nhập bình quân tháng — kèm thưởng thường cao hơn lương gộp, nên hãy coi hạn mức là mức sàn.",
    pravni: "Bảo vệ pháp lý",
    pravniPopis: "Luật sư và án phí trong tranh chấp — lao động, hàng xóm, tiêu dùng.",
    nabidnout: "đề xuất",
    nenabizet: "không đề xuất",
    osvcTitul: "Kinh doanh — hộ kinh doanh và công ty",
    osvcPodtitul: "Trong phân tích có thu nhập kinh doanh hoặc công ty trong tài sản. Hãy cùng khách rà soát khách thực sự có gì và điều gì có thể quật ngã khách.",
    podnikatelske: "Bảo hiểm kinh doanh",
    podnikatelskePopis: "Trách nhiệm nghề nghiệp, tài sản công ty, gián đoạn kinh doanh. Hợp đồng bảo hiểm nhà ở không bao gồm phần này — thiệt hại trong đơn hàng không được chi trả từ đó.",
    resit: "xử lý",
    neresit: "bỏ qua",
    zasoby: "Hàng tồn kho",
    zasobyPopis: "Vật tư, hàng hóa và đơn hàng đang làm dở trong kho và trên xe. Nếu kho cháy, thiếu mục này khách sẽ không nhận được đồng nào.",
    moviteVeci: "Động sản và thiết bị",
    moviteVeciPopis: "Dụng cụ, máy móc, thiết bị, đồ dùng của cơ sở. Hãy cộng lại những gì khách phải mua lại để ngày mai còn làm việc được.",
    odpovednostPodnikatele: "Trách nhiệm của người kinh doanh",
    odpovednostPodnikatelePopis: "Thiệt hại gây ra cho khách hàng hoặc bên thứ ba khi kinh doanh. Mức tối thiểu khuyến nghị {limit} — một cơ sở bị ngập hoặc một khách hàng bị thương dễ dàng vượt quá một triệu.",
    bezLimitu: "bỏ qua",
    mil: "triệu",
    odhadTitul: "Tổng phí bảo hiểm tài sản ước tính",
    disclaimer: "Ước tính tham khảo theo bảng phí mẫu — không phải chào giá và không bảo đảm giá. Phí cụ thể do cố vấn xác nhận theo tuổi, tình trạng sức khỏe, biểu phí, mức miễn thường và các điểm loại trừ của hãng bảo hiểm đã chọn.",
    mesic: "/tháng",
    patka: "Luôn có mức miễn thường — thiệt hại nhỏ do quỹ dự phòng chi trả nên hợp đồng rẻ hơn. Biểu phí và điểm loại trừ cụ thể do cố vấn lựa chọn.",
  },
  /* Khuyến nghị cho từng mục tiêu — đề xuất của hệ thống + văn bản của cố vấn. */
  /* HORIZONT CILE — jedno misto pro "hned" a pro sklonovani let (audit R13).
   * Do 25. 8. 2026 si horizont dopocitavalo osm mist a kazde jinak: rezerva
   * "hned" (roky = 0) byla na karte "za 1 let", v tisku "—" a na slajdu
   * "za 0 let". Sklonovani dela t.plural (Intl.PluralRules podle jazyka),
   * ne ceske pravidlo 1 / 2-4 / 5+ — jinak ukrajinstina cte "za 21 rokiv".
   * Trojice One/Few/Many musi byt ve vsech peti slovnicich. */
  /* SHRNUTI — ROZDELOVNIK PLANU (predloha majitele, obrazovka „Shrnutí“ z FIP).
   * Tri pocitadla nahore, radek na cil. Texty NIKDY netvrdi nulu tam, kde je
   * neznamo: „bez vkladu“ / „doplň termín cíle“ misto „0“ a misto „0 %“.
   * Presplneny cil se rika slovem („splněno · přebývá X“), ne minusem —
   * predloha psala −749 471 a majitel si to sam vytkl. */
  /* BLOK:shrnutiPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  shrnutiPlan: {
    azPoCilovemDatu: 'sau ngày đến hạn của mục tiêu — không tính vào số tiền mục tiêu',
    bezCiluKde: 'Hãy bổ sung trong phân tích ở phần Mục tiêu — không có số tiền mục tiêu thì mục tiêu không vào kế hoạch.',
    bezCiluTitul: 'Kế hoạch chưa có mục tiêu nào.',
    bezVkladu: 'không có khoản góp',
    dnesPosle: 'hôm nay khách hàng góp {kc}',
    doplnCastku: 'hãy bổ sung số tiền mục tiêu',
    doplnTermin: 'hãy bổ sung thời hạn của mục tiêu',
    doplnenoEnginem: 'do hệ thống bổ sung',
    doraziPozdeji: 'trong đó {kc} về muộn hơn',
    doraziVeVeku: 'trong đó {kc} về khi {vek} tuổi',
    dorovnat: 'bù cho đủ',
    dorovnatJednJak: 'Ghim khoản nộp hằng tháng và để hệ thống tính khoản nộp một lần cần thiết để mục tiêu đạt đủ.',
    dorovnatPravJak: 'Ghim khoản nộp một lần và để hệ thống tính khoản nộp hằng tháng cần thiết để mục tiêu đạt đủ.',
    editaceJak: 'Các số ở cột “Nộp một lần” và “Nộp định kỳ” có thể sửa ngay trong dòng — số bạn nhập sẽ bị trừ khỏi hũ tiền ở trên và hệ thống sẽ tính số còn lại. ↺ trả về đề xuất của hệ thống.',
    financni: 'Tài sản tài chính',
    kapital: 'vốn',
    mesicne: '/tháng',
    nadKapacitu: 'vượt khả năng của hộ gia đình',
    neboJednorazove: 'hoặc {kc} một lần',
    neboPravidelne: 'hoặc {kc} hằng tháng',
    nedosazitelne: 'không thể bù đủ mục tiêu',
    nefinancni: 'Tài sản phi tài chính',
    nefinancniJak: 'Bất động sản và doanh nghiệp. Tài sản thừa kế không được cộng vào con số này — được ghi riêng là tài sản tương lai. Chúng chỉ vào được mục tiêu dưới dạng dòng tiền tương lai (bán) — nhập ở Đề xuất giải pháp, phần Cách đạt mục tiêu.',
    nelzeInvestovat: 'Không thể dùng để đầu tư.',
    nezapojeno: 'Chưa đưa vào',
    nezapojenoJak: 'Quỹ mở, bảo hiểm liên kết đầu tư, tiền gửi có kỳ hạn và ngoại tệ. Kế hoạch không phân bổ lại chúng một lần, nên chúng không nằm trong “Đã phân bổ” cũng không trong “Còn lại”.',
    nicNeni: 'không cần thêm',
    plusKroky: '+ tăng theo bậc ({n})',
    pocitam: 'Đang tính phần tổng hợp…',
    podtitul: 'Ba hũ tiền ở trên, mỗi mục tiêu một dòng. Cứ phân bổ cho đến khi cả hai đều hiện “Còn lại 0”. Các con số giống hệt trong Đề xuất giải pháp — màn hình này là góc nhìn thứ hai và bạn phân bổ ngay ở đây.',
    poradce: 'Tư vấn viên',
    poznPlaceholder: 'Ghi chú về mục tiêu này cho khách hàng…',
    poznPrebiji: 'ghi đè đề xuất của hệ thống trong các bản xuất',
    poznZpet: 'trở lại đề xuất',
    prebytek: 'Thặng dư hằng tháng',
    prebytekNeznamy: 'Chưa biết thặng dư — hãy bổ sung chi phí trong phân tích',
    prebyva: 'dư {kc}',
    precerpano: 'Vượt quá — khách hàng không có nhiều như vậy',
    pridatJenJedn: '← giải quyết một lần',
    pridatJenPrav: 'giải quyết hằng tháng →',
    prideleno: 'Đã phân bổ',
    rezervaJednNelze: 'Quỹ dự phòng được kế hoạch giải quyết từ nguồn lực và phần dư — không gắn khoản nộp một lần vào nó.',
    rezimJednorazove: 'Một lần',
    rezimMesicne: 'Hằng tháng',
    rezimOboji: 'Cả hai',
    rezimZpet: 'đề xuất của hệ thống',
    rozdano: 'Đã phân bổ hết — còn 0',
    schodek: 'Chi phí và các khoản trả nợ vượt thu nhập — kế hoạch không có gì để chi trả',
    splneno: 'đã đạt',
    systemBezVkladu: 'Hệ thống tự nó không tính thêm khoản nộp một lần nào.',
    thCil: 'Mục tiêu (việc gì?)',
    thDosazeno: 'Giá trị đạt được',
    thJedn: 'Khoản một lần',
    thKdy: 'Sau bao nhiêu năm? (khi nào?)',
    thKolik: 'Số tiền (bao nhiêu?)',
    thPozn: 'Ghi chú',
    thPrav: 'Khoản định kỳ',
    thPridatJedn: 'Thêm một lần',
    thPridatPrav: 'Thêm hằng tháng',
    titul: 'Bảng — phân bổ kế hoạch',
    tlacitko: 'Bảng',
    uklada: 'Đang lưu…',
    ulozeniJak: 'Các con số tự lưu — một lúc sau khi bạn ngừng nhập và khi bạn rời trang. “Đã lưu” chỉ sáng khi máy chủ đã nhận. Đề xuất giải pháp vẫn còn bên cạnh: cùng một kế hoạch, chỉ khác là ở dạng thẻ.',
    ulozeniSelhalo: 'Lưu không thành công — thay đổi chỉ còn trên màn hình.',
    ulozeno: 'Đã lưu',
    vkladNavic: 'thêm ngoài nguồn lực',
    vysvetlivka: '“Thêm” = cần thêm bao nhiêu nữa để mục tiêu đạt đủ, ngoài phần kế hoạch đã phân bổ. Đây không phải khoản phải trả, mà là phần còn thiếu. Mục tiêu đã đạt thì ở đây là một từ, không phải con số.',
    vysvetlivkaRezim: '“Thêm” chỉ hiện ở cột tương ứng với cách mục tiêu được giải quyết: khoản nộp một lần, hoặc khoản nộp hằng tháng. Khi giải quyết bằng cả hai, hai con số là PHƯƠNG ÁN THAY THẾ — hoặc một lần, HOẶC hằng tháng. Đừng cộng chúng lại: mỗi con số chỉ đúng nếu khoản nộp kia giữ nguyên.',
    zPritoku: '+ {kc} từ dòng tiền tương lai',
    zadneZdroje: 'Không có gì để phân bổ — khách hàng không có tài sản tài chính khả dụng',
    zbyva: 'Còn lại',
    zdrojeDoRentyJak: 'Quỹ hưu trí hoặc DIP có thể huỷ, nhưng thường được đầu tư cho mục tiêu dài hạn. “Vào quỹ hưu trí” sẽ chuyển nó sang mục tiêu hưu trí — và nếu khách hàng không có mục tiêu đó, sang mục tiêu có thời hạn dài nhất.',
    zdrojeDoRentyTitul: 'Tiết kiệm nhà ở và hưu trí',
    zdrojeDoRentyVyp: 'vào mục tiêu gần nhất',
    zdrojeDoRentyZap: 'vào quỹ hưu trí',
    zpetNaNavrh: 'Quay lại đề xuất giải pháp',
  },
  /* BLOK:shrnutiPlan END */
  /* POŘADÍ KROKŮ — JEDNO PRO CELOU APPKU (diktát majitele 24. 9. 2026).
     Kroky i jejich stavy drží lib/poradiKroku.js; tady jsou jen jejich názvy
     a věty. Čísla kroků se do textů NEPÍŠÍ — dopočítá je `poradiKroku(id)`,
     jinak by text po přeskládání lhal. Věty `chybi*` vidí JEN PORADCE na své
     obrazovce: je to jeho domácí úkol, ne text pro klienta. */
  /* BLOK:poradiKroku START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiKroku: {
    chybiMajetkove: 'Bước {cislo} — bảo hiểm tài sản: hãy điền và lưu thẻ Bảo hiểm tài sản ở trên.',
    chybiRezerva: 'Bước {cislo} — quỹ dự phòng: hãy điền chi phí thiết yếu trong phần phân tích. Không có chúng thì không có mục tiêu quỹ, và dòng này sẽ nói dối bằng số không.',
    chybiTitulek: 'Các bước không vào được bảng vì thiếu dữ liệu:',
    chybiZivotni: 'Bước {cislo} — bảo hiểm nhân thọ: không có thu nhập và chi phí trong phần phân tích thì không có dữ liệu để tính số tiền bảo hiểm.',
    cile: 'Mục tiêu',
    cilePozn: 'đầu tư đều đặn phần tiền rảnh cho mục tiêu và thu nhập thụ động',
    dluhy: 'Xóa các khoản nợ xấu',
    dluhyPozn: 'trả trước các khoản vay đắt và thẻ tín dụng — tiền lãi chắc chắn phải trả, còn lợi nhuận đầu tư thì không chắc',
    majetkove: 'Bảo hiểm tài sản',
    majetkovePozn: 'nhà, nội thất, xe, trách nhiệm dân sự — và tài sản doanh nghiệp với người tự kinh doanh',
    na90Dni: 'Các bước cho 90 ngày tới',
    rezerva: 'Lập quỹ dự phòng',
    rezervaPozn: '3–6 tháng chi phí thiết yếu sẵn trong tay, để lần sửa chữa bất ngờ đầu tiên không làm kế hoạch dừng lại',
    slideZaver: '„Những bước sau dẫn tới thu nhập thụ động và độc lập tài chính của bạn — đúng theo thứ tự này.“',
    tabMajetekCo: 'Bảo hiểm tài sản và trách nhiệm ({kryti}) — khoảng {cena} mỗi tháng.',
    tabMajetekKdy: 'Ngay lập tức',
    tabMajetekProc: 'Một thiệt hại về nhà, hoặc gây ra cho người khác, đủ để kéo cả kế hoạch xuống đáy.',
    tabRezervaCo: 'Nâng quỹ dự phòng thanh khoản lên {cil} — hôm nay còn thiếu {gap}.',
    tabRezervaCoFondy: 'Nâng quỹ dự phòng thanh khoản lên {cil} — hôm nay còn thiếu {gap}, trong đó {fondy} được bổ sung từ quỹ đầu tư (bán chứng chỉ quỹ, ETF hoặc cổ phiếu).',
    tabRezervaHotovo: 'Giữ quỹ dự phòng {cil} luôn đủ — đã xong.',
    tabRezervaKdy: 'Trước khi đầu tư',
    tabRezervaProc: 'Đệm cho những chi phí bất ngờ. Không có nó, sự cố đầu tiên phải trả bằng nợ hoặc bằng cách bán khoản đầu tư.',
    ukolCile: 'Bắt đầu đầu tư định kỳ {castka} cho mục tiêu và thu nhập thụ động',
    ukolDluhy: 'Xóa các khoản nợ xấu — hôm nay {castka}',
    ukolMajetkove: 'Thu xếp bảo hiểm tài sản và trách nhiệm — khoảng {cena}',
    ukolOsoba: '{jmeno}: mất sức lao động {invalidita}, tử vong {smrt}',
    ukolOsobaBezInvalidity: '{jmeno}: tử vong {smrt}',
    ukolRezerva: 'Nâng quỹ dự phòng lên {cil} (còn thiếu {gap})',
    ukolRezervaFondy: 'Nâng quỹ dự phòng lên {cil} (còn thiếu {gap} — {fondy} bổ sung từ quỹ đầu tư)',
    ukolRezervaHotovo: 'Quỹ dự phòng {cil} đã đủ — giữ nguyên',
    ukolZivotni: 'Thu xếp bảo hiểm rủi ro — mất sức lao động {invalidita}, tử vong {smrt}',
    ukolZivotniBezInvalidity: 'Thu xếp bảo hiểm rủi ro — tử vong {smrt}; chưa ai trong gia đình có thu nhập từ công việc nên chưa tính bảo hiểm mất sức lao động',
    ukolZivotniOsoby: 'Thu xếp bảo hiểm rủi ro — {osoby}',
    ukolZivotniOsobyBezInvalidity: 'Thu xếp bảo hiểm rủi ro — {osoby}; chưa ai trong gia đình có thu nhập từ công việc nên chưa tính bảo hiểm mất sức lao động',
    uvod: '…nhưng cần phải làm gì đó. Theo thứ tự này:',
    zivotni: 'Bảo hiểm nhân thọ',
    zivotniPozn: 'bảo hiểm mất sức lao động và tử vong vừa tốt vừa rẻ — mất thu nhập không được đánh sập gia đình',
  },
  /* BLOK:poradiKroku END */
  cilHorizont: {
    hned: "ngay bây giờ",
    bezTerminu: "chưa đặt thời hạn",
    zaOne: "sau {n} năm",
    zaFew: "sau {n} năm",
    zaMany: "sau {n} năm",
    rokOne: "năm",
    rokFew: "năm",
    rokMany: "năm",
  },
  /* NAVRH — TABULKY „NASE DOPORUCENI" A „PRODUKTY" (audit R11).
   * Skladaji se ZIVE z aktualnich cisel planu; ukladaji se jen prepisy poradce.
   * Radky jednotlivych cilu tu nejsou schvalne — ty ma plan ve vlastni, taky
   * zive pocitane sekci (dopCil.*). Viz lib/navrhTabulky.js. */
  /* BLOK:navrhTabulky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhTabulky: {
    alokaceCo: 'Đầu tư theo hồ sơ: cổ phiếu {akcie} %, trái phiếu {dluhopisy} %, tiền mặt {penize} %.',
    alokaceKdy: 'Ngay lập tức',
    alokaceProc: 'Phân bổ quyết định khoảng 92 % kết quả; lấy cảm hứng từ quỹ Na Uy và quỹ Nobel.',
    alokaceZProfilu: 'Tỷ trọng lúc khởi đầu theo hồ sơ đã chọn ở phần Giải bài toán mục tiêu. Khi tới gần mục tiêu, tỷ trọng sẽ tự chuyển dần sang mức an toàn.',
    davkyOdhadPodlePrijmu: 'Ước tính tham khảo theo thu nhập — chính con số mà số tiền bảo hiểm dựa vào.',
    diverzifikaceCo: 'Đa dạng hóa theo tiền tệ và khu vực (chỉ số thế giới khoảng 72 % là Hoa Kỳ).',
    diverzifikaceKdy: 'Ngay lập tức',
    diverzifikaceProc: 'Danh mục ổn định hơn, được bảo vệ trước cú sốc của một thị trường.',
    dluhyCo: 'Trả hết các khoản nợ đắt đỏ (hiện tại {castka}).',
    dluhyKdy: 'Càng sớm càng tốt',
    dluhyProc: 'Tiền lãi chắc chắn phải trả, còn lợi nhuận đầu tư thì không chắc.',
    pojisteniCo: 'Bảo vệ thu nhập bằng bảo hiểm — mất sức lao động {invalidita}, tử vong {smrt} (số tiền giảm dần).',
    pojisteniCoBezInvalidity: 'Bảo vệ bằng bảo hiểm — tử vong {smrt} (số tiền giảm dần). Chưa ai trong gia đình có thu nhập từ công việc nên chưa tính bảo hiểm mất sức lao động — hãy nhập thu nhập.',
    pojisteniCoOsoby: 'Bảo vệ thu nhập bằng bảo hiểm — {osoby} (số tiền giảm dần).',
    pojisteniCoOsobyBezInvalidity: 'Bảo vệ bằng bảo hiểm — {osoby} (số tiền giảm dần). Chưa ai trong gia đình có thu nhập từ công việc nên chưa tính bảo hiểm mất sức lao động — hãy nhập thu nhập.',
    pojisteniKdy: 'Ngay lập tức',
    pojisteniProc: 'Khi thu nhập mất đi, gia đình không được tụt mức sống hay mất các mục tiêu.',
    produktAkcie: 'ETF cổ phiếu (toàn cầu, MSCI World)',
    produktDluhopisy: 'ETF trái phiếu (toàn cầu)',
    produktPenize: 'Thị trường tiền tệ / tài khoản tiết kiệm (quỹ dự phòng + tiền mặt)',
    upravenoPoradcem: 'do cố vấn chỉnh sửa',
    zivyNavrh: 'đề xuất của hệ thống — được tính lại từ số liệu hiện tại của kế hoạch',
    zpetNaNavrh: 'Quay lại đề xuất của hệ thống',
  },
  /* BLOK:navrhTabulky END */
  /* RESENI U POJISTKY — navrh systemu + text poradce (lib/doporuceniPojisteni.js).
   * Sklada se ZIVE z cisel srovnani „pred a po“; uklada se jen prepis poradce
   * (navrh.solver.doporuceniPojisteni). Zadny produkt ani pojistovna — je to
   * regulovany vystup (IDD), navrh rika CO chybi, ne u koho to sjednat. */
  dopPoj: {
    titul: "Giải pháp cho hợp đồng bảo hiểm",
    podtitul: "Hệ thống soạn từ các con số so sánh, tư vấn viên có tiếng nói cuối cùng.",
    domacnost: "Cả gia đình",
    titulVystup: "Chúng tôi khuyến nghị gì về bảo hiểm",
    odSystemu: "đề xuất của hệ thống",
    odPoradce: "văn bản của cố vấn",
    upravit: "Sửa văn bản",
    zpetNaNavrh: "Quay lại đề xuất của hệ thống",
    placeholder: "Chúng tôi khuyến nghị gì cho khách hàng về bảo hiểm…",
    hint: "Đề xuất của hệ thống được ghép từ các con số của bảng so sánh này. Cố vấn có tiếng nói cuối cùng — văn bản của cố vấn được in vào kế hoạch và bản trình bày cho khách hàng.",
    prazdneVarovani: "Khuyến nghị để trống sẽ không được in cho khách hàng. Hãy quay lại đề xuất của hệ thống, hoặc viết văn bản riêng.",
    nicKRict: "Chưa có gì để ghép thành khuyến nghị — hãy bổ sung số tiền bảo hiểm hiện tại và giá của phương án.",
    rizikoSmrt: "Tử vong",
    rizikoInvalidita: "Mất sức lao động",
    bezSmlouvy: "Hiện khách hàng không có hợp đồng nào có số tiền bảo hiểm — việc bảo vệ thu nhập phải xây từ đầu.",
    nekrytyRiziko: "{riziko}: hiện không có bảo hiểm, cần {novy}.",
    nekrytyRizikoBezCastky: "{riziko}: hiện không có bảo hiểm.",
    nizkyLimit: "{riziko}: mức {puvodni} hiện tại thấp hơn mức cần {novy} — thiếu {rozdil}.",
    pokrytoRiziko: "{riziko}: mức {puvodni} hiện tại đã đủ cho mức cần {novy}.",
    argument: "Bảo hiểm tăng ×{kryti}, giá tăng ×{cena}.",
    argumentVyhra: "Bảo hiểm tăng ×{kryti}, giá chỉ tăng ×{cena} — nhiều bảo hiểm hơn hẳn với ít tiền hơn hẳn.",
    brzdaLimit: "{riziko}: hãy bổ sung số tiền bảo hiểm hiện tại vào phân tích — không có nó thì không thể nói khách hàng đang thiếu gì.",
    brzdaNovy: "{riziko}: phương án đã chọn chưa có số tiền bảo hiểm được tính.",
    brzdaPlatba: "Hãy bổ sung số tiền khách hàng đang trả cho các hợp đồng hiện tại — không có nó thì không so sánh được giá.",
    brzdaPlatbaCastecna: "Một hợp đồng hiện tại chưa có số tiền phí — nên việc so sánh giá chỉ là một phần.",
    brzdaCena: "Hãy bổ sung giá của phương án đã chọn — không có nó thì không thể nói khách hàng sẽ trả bao nhiêu.",
  },
  /* REZERVA — na kolik mesicu (majitel 25. 9. 2026: „rezerva bud 3 - 6 - 12
   * mesicu, no to je jedno“). Jeden prepinac, tri volby: pocet mesicu plati na
   * CELY zaklad, tedy nezbytne vydaje i splatky. Prepinac stoji u cile rezervy,
   * ne v nastaveni; volby 18 / 24 / 36 se zrusily i s rozdelenym zakladem. */
  rezervaMesicu: {
    titul: "Quỹ dự phòng cho",
    m3: "3 tháng",
    m6: "6 tháng",
    m12: "12 tháng",
    hint: "Quỹ dự phòng đủ cho bao nhiêu tháng. Tính từ chi phí thiết yếu và tiền trả nợ — khi khủng hoảng cả hai vẫn tiếp tục.",
  },
  /* ZTRATA Z PREDCASNEHO ZRUSENI PENZIJKA (planSolver, ztrata.kody).
   * ZADNE CISLO — engine nezna sazbu ani kolik uz klient dostal, takze veta
   * mluvi o tom, CO se vraci, nikdy o kolik. */
  ztrataPenzijka: {
    titul: "Lấy ra sớm thì mất gì",
    statniPrispevek: "Hủy sớm có nghĩa là phải trả lại các khoản hỗ trợ của nhà nước.",
    danovaVyhoda: "Hủy sớm có nghĩa là phải hoàn lại phần ưu đãi thuế đã được hưởng.",
    druhNeznamy: "Một hợp đồng chưa chọn loại sản phẩm (DPS / DIP) — hãy bổ sung để rõ khách hàng mất chính xác những gì.",
  },
  /* BLOK:dopCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  dopCil: {
    brzdaBezCastky: 'Mục tiêu chưa có số tiền — hãy điền trong phần phân tích.',
    brzdaBezHorizontu: 'Mục tiêu chưa có thời hạn — hãy điền khách hàng muốn đạt sau bao nhiêu năm. Thiếu nó thì không thể tính toán hay đưa vào kế hoạch.',
    brzdaKapacita: 'Lưu ý: {prav} mỗi tháng vượt quá phần dư tự do của gia đình ({kapacita} mỗi tháng) — cần thời hạn dài hơn, mục tiêu thấp hơn, hoặc chỗ trong ngân sách.',
    brzdaNedosazitelne: 'Với thiết lập này mục tiêu không đạt được ngay cả khi góp tối đa — cần thời hạn dài hơn hoặc số tiền thấp hơn.',
    hint: 'Đề xuất của hệ thống được ghép từ các con số của kế hoạch này. Cố vấn có tiếng nói cuối cùng — văn bản của cố vấn được in vào kế hoạch, kế hoạch một trang và bản trình bày cho khách hàng.',
    jakGlide: 'Đầu tư: năm đầu {start}, năm cuối {konec} (cổ phiếu/trái phiếu/tiền mặt) — rủi ro được tắt dần về cuối.',
    jakJedn: 'Giải pháp: {jedn} một lần, không cần thêm hằng tháng.',
    jakNic: 'Giải pháp: số tiền bạn đang có đủ cho mục tiêu mà không cần góp thêm.',
    jakNicNevychazi: 'Giải pháp: hiện chưa có nguồn nào cho mục tiêu này — kế hoạch chưa phân bổ khoản một lần hay khoản hằng tháng.',
    jakOboji: 'Giải pháp: {jedn} một lần và {prav} mỗi tháng.',
    jakPrav: 'Giải pháp: {prav} mỗi tháng.',
    jakRenta: 'Danh mục hưu trí {alokace} (cổ phiếu/trái phiếu/tiền mặt) được giữ cả khi rút — thu nhập đến từ lợi nhuận.',
    jakRezerva: 'Quỹ dự phòng không đem đầu tư — nó thuộc về tài khoản tiết kiệm để luôn sẵn sàng.',
    jakStabilni: 'Đầu tư {start} (cổ phiếu/trái phiếu/tiền mặt) trong suốt thời hạn.',
    nicKRict: 'Chưa có gì để ghép thành khuyến nghị — hãy điền số tiền và thời hạn của mục tiêu.',
    odPoradce: 'văn bản của cố vấn',
    odSystemu: 'đề xuất của hệ thống',
    placeholder: 'Chúng tôi khuyến nghị gì cho khách hàng ở mục tiêu này…',
    prazdneVarovani: 'Khuyến nghị để trống sẽ không được in cho khách hàng. Hãy quay lại đề xuất của hệ thống hoặc viết văn bản riêng.',
    titul: 'Khuyến nghị cho mục tiêu',
    titulVystup: 'Chúng tôi khuyến nghị gì cho từng mục tiêu',
    upravit: 'Sửa văn bản',
    vysledekChybi: 'Sau {roky} năm sẽ có {konec} — còn thiếu {chybi} ({pct} % mục tiêu).',
    vysledekChybiHned: 'Trong vòng một năm sẽ có {konec} — còn thiếu {chybi} ({pct} % mục tiêu).',
    vysledekOk: 'Sau {roky} năm sẽ có {konec} — mục tiêu đạt {pct} %.',
    vysledekOkHned: 'Trong vòng một năm sẽ có {konec} — mục tiêu đạt {pct} %.',
    zadaniBezne: 'Mục tiêu {cil} trong {roky} năm.',
    zadaniBezneBezLet: 'Mục tiêu {cil}.',
    zadaniHypo: 'Vốn tự có {cil} trong {roky} năm (phương án {varianta}). Khoản trả sau đó là {splatka} mỗi tháng.',
    zadaniHypoBezLet: 'Vốn tự có {cil} (phương án {varianta}). Khoản trả sau đó là {splatka} mỗi tháng.',
    zadaniRenta: 'Thu nhập {renta} mỗi tháng nghĩa là cần vốn {cil} — mỗi năm có thể rút 4 % lâu dài. Thời hạn {roky} năm.',
    zadaniRentaBezLet: 'Thu nhập {renta} mỗi tháng nghĩa là cần vốn {cil} — mỗi năm có thể rút 4 % lâu dài.',
    zadaniRezerva: 'Quỹ dự phòng thanh khoản {cil} — đệm cho chi phí bất ngờ. Ưu tiên trước khi đầu tư.',
    zdroje: 'Một lần từ: {zdroje}.',
    zdrojeFondyRezerva: 'Phần còn thiếu {fondy} được bổ sung từ quỹ đầu tư — bán chứng chỉ quỹ, ETF hoặc cổ phiếu mà khách hàng đã có.',
    zpetNaNavrh: 'Quay lại đề xuất của hệ thống',
  },
  /* BLOK:dopCil END */
  /* ── boLab — NÁHLED MOTIVU „beplan“ (design-lab/beplan-orange) ───────────
   * Texty interní náhledové stránky /design-lab/beplan-orange. NENÍ v produkční
   * navigaci a NEPŘEBARVUJE aplikaci — tokeny motivu jsou zavřené v `.bo-scope`
   * (frontend/src/design-lab/brand-orange/motiv.css).
   * Klíč po klíči shodné ve všech pěti jazycích (214 klíčů) — hlídá
   * design-lab/brand-orange/__tests__/klicePetJazyku.test.js.
   * ⚠️ Barva se jmenuje neutrálně „brand oranžová“. Pracovní název ze zadání se
   * nepoužívá: koliduje s historickým pojmem z války ve Vietnamu a aplikaci
   * používají vietnamští poradci i klienti.
   * ──────────────────────────────────────────────────────────────────────── */
  boLab: {
    boLab: {
      cil: {
        brzda: "Phanh kế hoạch",
        brzdaText: "Các mục tiêu cần",
        brzdaText2: "nhưng phần dư tự do chỉ có",
        brzdaText3: "Thiếu",
        bydleniText: "Ngân hàng Trung ương Séc: dưới 36 tuổi chỉ cần 10 % vốn tự có (LTV 90 %). Với giá 4 500 000 Kč thì đó là 450 000 Kč.",
        chybi: "Thiếu",
        cilova: "Số tiền mục tiêu",
        cilu: "mục tiêu",
        dnes: "Hôm nay",
        historie: "Lịch sử thay đổi",
        hned: "ngay",
        let: "năm",
        mesicne: "Hằng tháng",
        plneni: "Mức hoàn thành",
        prebytek: "Phần dư tự do",
        prepocitat: "Tính lại kế hoạch",
        prijem: "Thu nhập ròng",
        rezervaText: "Quỹ dự phòng chỉ đủ chưa tới 2 tháng chi tiêu thay vì 6 tháng như khuyến nghị. Chưa có quỹ này thì tăng đầu tư là vô nghĩa.",
        rozdeleno: "Đã phân bổ",
        srovnat: "Cân lại ưu tiên",
        stavNevime: "Chưa rõ",
        stavNevychazi: "Không đạt",
        stavSplneno: "Đạt",
        stavTesne: "Sát nút",
        titul: "Kế hoạch — mục tiêu",
        upravit: "Sửa mục tiêu",
        zaHorizont: "Tại kỳ hạn",
        zbyva: "Còn lại",
      },
      jedMes: "/tháng",
      klient: {
        bezneVydaje: "Chi tiêu thường xuyên",
        chybiPrijemPartnera: "Thiếu thu nhập của bạn đời",
        chybiUdaje: "Thiếu 3 thông tin",
        cistyPrijem: "Thu nhập ròng",
        deti: "Con",
        domacnost: "Hộ gia đình",
        dopad: "Điều này nghĩa là gì",
        dopadHorniOdhad: "ước tính cận trên, chưa ai tra cứu trợ cấp của nhà nước.",
        dopadText: "Khi mất sức lao động cấp 3, toàn bộ thu nhập biến mất. Bảo hiểm còn thiếu khoảng",
        dps: "Tiết kiệm hưu trí",
        fazeRealizace: "Giai đoạn: Triển khai",
        hotovo: "Xong",
        invalidita: "Mất sức lao động cấp 3",
        investice: "Đầu tư",
        jmeno: "Họ tên",
        kOvereni: "Cần xác minh",
        klientOd: "khách hàng từ",
        let: "tuổi",
        majetekZavazky: "Tài sản và nợ",
        mezera: "Khoảng trống",
        narozeni: "Ngày sinh",
        nekryto: "chưa có bảo hiểm",
        overeno: "đã xác minh",
        partner: "Bạn đời",
        pn: "Nghỉ ốm",
        pojisteni: "Bảo hiểm",
        prijemPartnera: "Thu nhập của bạn đời",
        prijmyVydaje: "Thu nhập và chi tiêu",
        rezerva: "Quỹ dự phòng",
        roky: "tuổi",
        sdeleno: "khách tự khai",
        sekce: "Các mục của khách hàng",
        servis: "Bảo trì 14. 11. 2026",
        smrt: "Tử vong",
        splatkyUveru: "Trả nợ vay",
        spotrebitelsky: "Vay tiêu dùng",
        statniDavka: "Trợ cấp mất sức từ nhà nước",
        stavSmlouva: "Đã ký hợp đồng",
        telefon: "Điện thoại",
        telefonPartner: "Điện thoại của bạn đời",
        tisk: "In",
        ulozit: "Lưu",
        zalozkaAnalyza: "Phân tích",
        zalozkaDokumenty: "Tài liệu",
        zalozkaHistorie: "Lịch sử",
        zalozkaObchody: "Hợp đồng",
        zalozkaPlan: "Kế hoạch",
      },
      lab: {
        coJeVidet: "Màn hình này cho thấy điều gì",
        dnes: "Hiện tại",
        dnesBezTmave: "Giao diện hiện tại KHÔNG có bản tối — ứng dụng không có bản nào, nên bên trái vẫn là bản sáng. Đây không phải lỗi của bản xem trước.",
        dnesPopis: "Sage & Clay — điều tư vấn viên đang thấy",
        jenDnes: "Chỉ hiện tại",
        jenNavrh: "Chỉ đề xuất",
        miraTitul: "Chiều rộng nội dung so với khung. Khi nội dung tràn ra, trang phải cuộn ngang.",
        motiv: "Giao diện",
        navrh: "Đề xuất",
        navrhPopis: "cam thương hiệu + navy — bản sáng",
        navrhPopisTmava: "cam thương hiệu + navy — bản tối",
        notebook: "Laptop 1440",
        obrazovky: "Màn hình",
        odznak: "Xem trước — ứng dụng không đổi",
        preteka: "tràn",
        sedi: "vừa",
        sirka: "Chiều rộng",
        svetla: "Sáng",
        telefon: "Điện thoại 390",
        titul: "Design Lab · giao diện beplan",
        tmava: "Tối",
        vedleSebe: "Cạnh nhau",
        zobrazeni: "Hiển thị",
        zpet: "Quay lại",
      },
      login: {
        claim: "Kế hoạch tài chính mà khách hàng thật sự hiểu.",
        claimSub: "Phân tích, kế hoạch và bảo trì ở một nơi — cho tư vấn viên và cho khách hàng.",
        email: "E-mail",
        heslo: "Mật khẩu",
        prihlasit: "Đăng nhập",
        sso: "hoặc bằng tài khoản công ty",
        zalozkaPrihlaseni: "Đăng nhập",
        zalozkaRegistrace: "Đăng ký",
        zapomenute: "Quên mật khẩu",
        zpusob: "Cách đăng nhập",
      },
      mesic: {
        cerven: "6",
        cervenec: "7",
        kveten: "5",
        rijen: "10",
        srpen: "8",
        zari: "9",
      },
      nastenka: {
        bj: "Điểm (BJ)",
        bjZPlanu: "BJ trong kế hoạch tháng",
        diar: "Lịch — hôm nay",
        dnesUkoly: "hôm nay 5 việc",
        kpi: "Các con số chính của tháng",
        mezera: "Khoảng trống",
        mezeraText: "Hájek — mất sức cấp 3 chưa có bảo hiểm.",
        mezeraText2: "Dvořáková — quỹ dự phòng dưới 2 tháng chi tiêu.",
        nadKapacitu: "Kế hoạch vượt khả năng của hộ gia đình.",
        novyKlient: "Khách hàng mới",
        obchodu: "9 hợp đồng",
        pipeline: "Đường ống",
        plneniPlanu: "Mức hoàn thành kế hoạch",
        poTerminu: "quá hạn 11 ngày",
        podtitul: "Thứ Ba 25 tháng 8 · 3 cuộc hẹn · 2 việc quá hạn",
        prebytek: "Kế hoạch đang làm — Hájek",
        prilezitosti: "Ra-đa cơ hội",
        provize: "Hoa hồng",
        radar: "Ra-đa bảo trì",
        rozdeleno: "Phân bổ vào mục tiêu",
        rust: "+18 %",
        titul: "Chào buổi sáng, ông Chung",
        typPlan: "Kế hoạch",
        typPrvni: "Cuộc hẹn đầu",
        typServis: "Bảo trì",
        ukoly: "Quá hạn",
        vejdeSe: "Nằm gọn trong phần dư.",
        volnyPrebytek: "Phần dư tự do",
        vyplaceno: "đã trả 15. 8.",
        vyvoj: "Diễn biến hợp đồng",
        zPlanu: "68 % kế hoạch",
        za2mesice: "bảo trì sau 2 tháng",
        za3tydny: "bảo trì sau 3 tuần",
        zbyva: "Còn 6 ngày làm việc đến cuối tháng.",
      },
      nav: {
        diar: "Lịch",
        hlavni: "Điều hướng chính",
        klienti: "Khách hàng",
        nastenka: "Bảng điều khiển",
        nastroje: "Công cụ",
        obchody: "Hợp đồng",
        plan: "Kế hoạch",
        poradce: "Ông Chung",
      },
      nevyplneno: "chưa điền",
      neznamo: "chưa rõ",
      obrazovka: {
        cil: "Thẻ mục tiêu",
        klient: "Thẻ khách hàng",
        nastenka: "Bảng điều khiển",
        prihlaseni: "Đăng nhập",
        verejna: "Trang công khai",
        vystup: "Bản in cho khách",
      },
      pozn: {
        cil: "Màn hình phức tạp nhất. Bốn mục tiêu của khách hàng mẫu, phanh khả năng ở trên (kế hoạch vượt khả năng hộ gia đình 5 300 Kč mỗi tháng) và vấn đề, hệ quả, bước tiếp theo nằm dưới các con số.",
        cilSazba: "Nơi duy nhất trong bản xem trước mà cả cách dàn trang cũng khác, không chỉ màu sắc. Chuyển chiều rộng sang Điện thoại 390 và so sánh thước đo phía trên các khung.",
        klient: "Mật độ biểu mẫu. Đường viền ô, độ đọc được của nhãn nhỏ và nhất là khác biệt giữa chưa điền và số không: ô trống có viền đứt và màu hổ phách, không phải số không.",
        nastenka: "Màn hình chịu được bao nhiêu màu cam. Quy tắc: một mảng cam đậm trên mỗi màn hình (nút Khách hàng mới). Các trạng thái là xanh lá, hổ phách, đỏ và xanh dương dạng chữ đậm trên nền nhạt — nhờ vậy hành động và trạng thái khác nhau ngay ở hình dạng.",
        prihlaseni: "Ấn tượng đầu tiên. Logo, nút cam, tab đang chọn được gạch chân. Ảnh bãi biển trong mẫu được thay bằng mảng navy với mũi tên từ logo — chữ đặt trên ảnh nằm trên độ sáng không xác định nên không thể bảo đảm độ tương phản.",
        verejna: "Thứ khách hàng nhìn thấy đầu tiên. Màn hình duy nhất mà màu cam được phép lớn — đó là mảng thương hiệu, không phải nút bấm. Chữ trên đó là navy, không phải trắng.",
        vystup: "Nơi khắt khe nhất của giao diện. Giấy vẫn trắng kể cả ở chế độ tối, màu cam trên giấy luôn là sắc đậm hơn, và mỗi thanh đều có con số cùng chữ bên cạnh để bản in đen trắng không mất thông tin.",
      },
      vystup: {
        castka: "Số tiền",
        chybi: "thiếu",
        cil: "Mục tiêu",
        disclaimer: "Khuyến nghị dựa trên dữ liệu do khách hàng cung cấp tại ngày lập. Đây không phải khuyến nghị đầu tư và cũng không hứa hẹn lợi nhuận. Các mô hình nêu ra chỉ mang tính tham khảo.",
        eyebrow: "Kế hoạch tài chính",
        kdeJsteDnes: "Hiện tại bạn đang ở đâu",
        mesice: "tháng",
        mesicneCelkem: "Tổng hằng tháng",
        pokryto: "đã phủ",
        poslat: "Gửi cho khách hàng",
        prebytek: "Phần dư tự do",
        prijem: "Thu nhập ròng",
        prvniKrok: "Bước đầu tiên",
        prvniKrokText: "Bù quỹ dự phòng lên 168 000 Kč. Cho tới lúc đó quỹ dự phòng được ưu tiên hơn đầu tư — thiếu nó thì mọi khoản chi bất ngờ sẽ phá vỡ phần còn lại của kế hoạch.",
        rezervaMa: "Quỹ dự phòng đủ dùng",
        splneniCilu: "Mức hoàn thành các mục tiêu của bạn",
        tisk: "In / lưu PDF",
        vaseCile: "Mục tiêu của bạn",
        vytvoreno: "Do ông Chung lập · 25 tháng 8 năm 2026",
      },
      web: {
        claim: "Hãy để tiền của bạn có kế hoạch, không phải may rủi.",
        claimSub: "Cuộc hẹn đầu tiên miễn phí và không ràng buộc. Kéo dài khoảng 30 phút, trực tuyến qua Google Meet.",
        oMne: "Về tôi",
        online: "Trực tuyến, 30 phút",
        otazky: "Câu hỏi",
        reference: "Nhận xét",
        referenceSablona: "Chỗ dành cho nhận xét mà tư vấn viên tự điền. Bản xem trước cố ý để trống — nhận xét bịa kèm tên là rủi ro pháp lý.",
        rezervace: "Đặt lịch",
        rezervovat: "Hẹn gặp",
        role: "Tư vấn viên tài chính của bạn",
        sCimPomuzu: "Tôi có thể giúp bạn những gì",
        sluzba1: "Quỹ dự phòng và ngân sách",
        sluzba1Sub: "Để một khoản chi bất ngờ không quật ngã bạn.",
        sluzba2: "Nhà riêng",
        sluzba2Sub: "Cần bao nhiêu và khi nào thì đủ.",
        sluzba3: "Thu nhập thụ động và tự chủ",
        sluzba3Sub: "Cần để dành bao nhiêu để một ngày là đủ.",
        sluzby: "Dịch vụ",
        volneTerminy: "Khung giờ trống tuần này",
        vyberTermin: "Chọn giờ hẹn",
        vybratTermin: "Chọn giờ",
        zdarma: "Miễn phí",
      },
    },
  },
  rezSmlouva: {
    nazev: 'Hợp đồng giữ chỗ',
    podnadpis: 'Điền phần đầu, giá bán và tiền cọc. Phần còn lại hệ thống tự điền và kiểm tra hợp đồng trước khi in.',
    zpetNaZakazku: 'Quay lại hồ sơ',
    jizRozepsane: 'Bất động sản này đã có hợp đồng đang soạn:',
    bezKupujiciho: 'chưa có người mua',
    vzorLabel: 'Mẫu hợp đồng',
    pracovniVzor: 'Mẫu thử — luật sư chưa duyệt. Chưa dùng với khách hàng.',
    skupina_penize: 'Tiền và thời hạn',
    skupina_hlavicka: 'Phần đầu',
    skupina_strany: 'Các bên',
    skupina_nemovitost: 'Bất động sản',
    skupina_kancelar: 'Công ty môi giới',
    skupina_ostatni: 'Thông tin khác',
    doplneno: 'đã điền sẵn',
    vyber: '— chọn —',
    ano: 'Có',
    ne: 'Không',
    neniVyplneno: 'chưa điền',
    odvozeneNadpis: 'Hệ thống tự tính',
    slovyPopis: 'Số tiền bằng chữ, số còn lại và ngày hết hạn do hệ thống viết, nên không thể lệch với con số.',
    odvozene_kupni_cena_slovy: 'Giá mua bằng chữ',
    odvozene_blokacni_poplatek_slovy: 'Tiền cọc bằng chữ',
    odvozene_doplatek: 'Số tiền còn lại',
    odvozene_doplatek_slovy: 'Số còn lại bằng chữ',
    odvozene_rezervace_do: 'Giữ chỗ đến ngày',
    kontrolaNadpis: 'Kiểm tra trước khi in',
    kontrolaCisto: 'Không có lỗi. Bạn có thể in.',
    kontrolaBlokuje: 'Chưa sửa xong thì chưa in được.',
    pocitam: 'Đang tính…',
    nahledNadpis: 'Xem trước hợp đồng',
    ulozit: 'Lưu',
    ulozeno: 'Đã lưu',
    vytisknout: 'In',
    podepsano: 'Đánh dấu đã ký',
    jePodepsana: 'Đã ký',
    podepsanaZamek: 'hợp đồng đã ký thì không sửa được nữa',
    advokat: 'E-mail cho luật sư',
    advokatHotovo: 'Thư mới chỉ được soạn sẵn. Hãy gửi từ hộp thư của bạn kèm tệp đính kèm.',
    zkopirovat: 'Sao chép',
    zkopirovano: 'Đã sao chép',
    nejdrivUloz: 'Hãy lưu hợp đồng trước.',
    tiskZablokovan: 'Trình duyệt đã chặn cửa sổ in. Hãy cho phép cửa sổ bật lên rồi thử lại.',
    chybaNacteni: 'Không tải được. Hãy thử lại.',
    chybaUlozeni: 'Chưa lưu được.',
    chybaKopie: 'Sao chép không thành công.',
  },

  /* BLOK:izp START — generuje scratchpad/slovnik.py, ručně needitovat */
  izp: {
    argumenty: {
      jak1: 'Anh/chị trả một khoản mỗi tháng. Một phần dùng để bảo vệ khi gặp rủi ro, phần còn lại đi vào phần đầu tư.',
      jak2: 'Phạm vi bảo vệ có thể thay đổi sau này — thêm một rủi ro, tăng hoặc giảm số tiền.',
      jak3: 'Phần đầu tư thường có thể rút ra hoặc giảm bớt. Thời hạn và điều kiện thì mỗi hợp đồng một khác.',
      jak4: 'Hợp đồng có thể chấm dứt. Khi đó được chi trả bao nhiêu là do điều kiện của hợp đồng quy định.',
      jak5: 'Khi thu nhập thay đổi, có thể điều chỉnh lại bao nhiêu dành cho bảo vệ và bao nhiêu cho đầu tư.',
      jakNadpis: 'Nói chung nó hoạt động thế nào',
      nadpis: 'Vì sao nên có và nói chung nó hoạt động thế nào',
      nasobekCeny: 'giá ×{x}',
      nasobekKryti: 'mức bảo vệ ×{x}',
      oci: 'Lý lẽ',
      pomerChybi: 'Ở từng rủi ro, xin điền những gì khách hàng đang có hôm nay — mức bảo vệ và giá. Thiếu hai số đó thì không tính được tỷ lệ giữa bảo vệ và giá.',
      pomerNadpis: 'Mức bảo vệ so với giá',
      pomerNejslabsi: 'Lấy rủi ro yếu nhất trong số các rủi ro được so sánh (số lượng: {pocet}).',
      pomerVyhra: 'Mức bảo vệ tăng nhanh hơn giá.',
      pomerZdroj: 'Tính từ những rủi ro đã điền cả mức bảo vệ hiện tại lẫn mức mới (số lượng: {pocet}). Lấy rủi ro yếu nhất, không lấy cái tốt nhất.',
      popis: 'Nguyên tắc chung, không phải điều kiện của một hợp đồng cụ thể.',
      potvrdiKratce: 'Đây là nguyên tắc chung, không phải điều kiện của một hợp đồng cụ thể. Hợp đồng cho phép những gì sẽ do người tư vấn xác nhận theo bản chào.',
      potvrdiText: 'Đây là nguyên tắc chung, không phải điều kiện của một hợp đồng cụ thể. Hợp đồng cho phép chính xác những gì — thay đổi, rút tiền, chấm dứt và điều kiện kèm theo — sẽ do người tư vấn xác nhận theo bản chào cụ thể.',
      potvrdiTuk: 'Điều người tư vấn xác nhận',
      proc1: 'Thu nhập là động cơ của cả gia đình. Khi nó mất đi, các khoản chi vẫn còn, có khoản còn tăng thêm.',
      proc2: 'Nhà nước chỉ hỗ trợ một phần, và không có ngay. Phần còn lại gia đình phải tự lo.',
      proc3: 'Nợ không trả được bằng quyết tâm, chỉ trả được bằng tiền. Khoản vay mua nhà (hypotéka) vẫn phải trả tiếp, dù thu nhập đã dừng.',
      proc4: 'Bảo vệ và để dành nằm trong cùng một khoản tiền, anh/chị tự chia bao nhiêu cho mỗi phần.',
      procNadpis: 'Vì sao nên có',
    },
    davka: {
      pozustalostni: 'Trợ cấp cho người ở lại — cho vợ/chồng và cho con (tử tuất)',
    },
    diagnoza: {
      detskeChronicke: 'Bệnh kéo dài (bệnh mạn tính) bắt đầu từ khi còn nhỏ, ví dụ tiểu đường tuýp 1 hoặc động kinh',
      detskeNadory: 'Bệnh ung thư ở trẻ em, ví dụ ung thư máu (bệnh bạch cầu)',
      infarkt: 'Cơn đau tim (nhồi máu cơ tim)',
      mozkovaPrihoda: 'Đột quỵ (tai biến mạch máu não)',
      nadory: 'Bệnh ung thư',
      neurologicka: 'Bệnh của hệ thần kinh — xơ cứng rải rác, bệnh Parkinson và bệnh Alzheimer',
      ochrnuti: 'Bị liệt, không cử động được, sau tai nạn hoặc sau khi bị bệnh',
      operaceSrdce: 'Mổ tim và các động mạch lớn',
      selhaniOrganu: 'Cơ quan trong người ngừng hoạt động (suy) — thận, gan, đường hô hấp',
      smysly: 'Mất khả năng nhìn, nghe hoặc nói',
      transplantace: 'Ghép cơ quan quan trọng cho sự sống',
      zenska: 'Những bệnh chỉ phụ nữ mới mắc và các vấn đề khi mang thai (biến chứng thai kỳ)',
    },
    diagnozy: {
      deti: 'Ở hợp đồng cho trẻ em, danh sách lại khác — trong đó là những bệnh (chẩn đoán) thường xuất hiện ở tuổi nhỏ.',
      nadpis: 'Những bệnh nào được bảo hiểm',
      smlouva: 'Danh sách bệnh chính xác, định nghĩa từng bệnh, giai đoạn bệnh và thời gian chờ đều do hợp đồng bảo hiểm quy định, và mỗi công ty bảo hiểm lại một khác. Anh/chị được bảo hiểm những gì thì chúng ta cùng đọc trong điều khoản bảo hiểm (pojistné podmínky).',
      uvod: 'Đây là những nhóm bệnh hay được nhắc đến nhất khi nói về bệnh nặng, bệnh hiểm nghèo (závažná onemocnění).',
    },
    graf: {
      aria: 'Biểu đồ: tổng đóng {zaplaceno}, trong đó cho đầu tư {investice}. Giá trị đầu tư theo mô hình sau {roky}: {hodnota}. Chỉ là mô hình, không phải bảo đảm.',
      celkemVlozeno: 'Tổng số đã đóng',
      dnesnimiOcima: 'Theo giá hôm nay là {hodnota} (lạm phát {inflace})',
      hodnotaVModelu: 'Giá trị đầu tư theo mô hình',
      horizonty: {
        d: {
          hodnota: 'Giá trị theo mô hình',
          nasobek: 'Bội số tiền đóng',
          vlozeno: 'Đã đóng',
          vlozenoPoplatek: 'trong đó phí {poplatek}',
          vynos: 'Trong đó lợi nhuận',
        },
        detailNadpis: 'Sau {roky}',
        maStitek: 'có',
        nadpis: 'Càng để lâu, càng có nhiều',
        oci: 'Thời gian',
        poPoplatkuStitek: 'đã đóng sau phí',
        predpoklad: 'Với lợi nhuận mô hình {vynos} mỗi năm',
        sloupec: '{roky}: giá trị theo mô hình {hodnota}, đã đóng {vlozeno}',
        vlozenoStitek: 'đã đóng',
        vrstvy: {
          nadpis: 'Sức mạnh lãi kép',
          vklady: 'Tiền đóng',
          vkladyPoPoplatku: 'Tiền đóng sau phí',
          zVkladu: 'Lãi từ tiền đóng',
          zVynosu: 'Lãi từ lãi',
        },
        vyber: 'Chọn số năm',
      },
      konec: {
        hodnota: 'Mô hình',
        investice: 'Đầu tư',
        zaplaceno: 'Đã đóng',
      },
      krivka: {
        hodnota: 'Giá trị theo mô hình',
        investice: 'Cho đầu tư',
        ochrana: 'Bảo vệ (không hoàn lại)',
        zaplaceno: 'Tổng đã đóng',
      },
      legendaHodnota: 'Giá trị theo mô hình',
      legendaVlozeno: 'Đã đóng vào',
      milnik: {
        kratce: {
          plnoletost: '18',
          vysoka: 'ĐH',
        },
        plnoletost: '{jmeno}: 18 tuổi',
        vysoka: '{jmeno}: vào đại học',
      },
      modelText: 'Biểu đồ là phép tính thử (mô hình) từ số tiền đã nhập và mức lợi nhuận đã chọn. Lợi nhuận sau này không được bảo đảm, thực tế có thể thấp hơn mà cũng có thể cao hơn. Phương án cụ thể do chuyên viên xác nhận.',
      modelTuk: 'Chỉ là mô hình, không phải bảo đảm',
      modelovaHodnota: 'Giá trị theo mô hình',
      modeloveZhodnoceni: 'Phần lãi theo mô hình',
      nadpis: 'Phần đầu tư sẽ ra sao đến tuổi đã chọn',
      oci: 'Biểu đồ',
      osaRok: 'Năm {rok}',
      osaVekKonec: '{vek} tuổi',
      popis: 'Anh chị chọn tuổi và mức lợi nhuận mong đợi. Biểu đồ cho thấy diễn biến theo mô hình, không phải kết quả chắc chắn.',
      poplatek: {
        naKonci: 'Đến cuối kỳ',
        naKorunu: 'Mỗi 1 {symbol} đã đóng thành',
        nadpis: 'Ba cách trả phí ban đầu',
        navic: 'trong đó {poplatek} là phí trả thêm ngay từ đầu',
        oci: 'Phí ban đầu',
        pole: 'Phí ban đầu (% của số tiền mục tiêu)',
        poleHint: 'thường từ {min} đến {max} %',
        poslano: 'Tổng tiền đã đóng',
        radek: {
          expres: 'Phí {poplatek} · trừ vào tiền đóng ({mesicu} tháng)',
          expresHned: 'Phí {poplatek} · đóng thêm ngay',
          pulNaPul: 'Phí {poplatek} · trừ một nửa tiền đóng ({mesicu} tháng)',
        },
        souhrn: '{pct} của số tiền mục tiêu {cilova} là {poplatek}',
        varianta: {
          expres: {
            nazev: 'Trừ hết vào tiền đóng',
            popis: 'Toàn bộ tiền đóng dùng để trả phí cho đến khi trả xong ({mesicu} tháng).',
          },
          expresHned: {
            nazev: 'Trả phí ngay',
            popis: 'Trả phí riêng, toàn bộ tiền đóng được đầu tư ngay từ tháng đầu.',
          },
          pulNaPul: {
            nazev: 'Chia đôi 50/50',
            popis: 'Một nửa tiền đóng để trả phí, một nửa được đầu tư ngay ({mesicu} tháng).',
          },
        },
        zToho: 'trong đó {poplatek} để trả phí',
      },
      poradcePozn: 'Hãy đổi tuổi và mức lợi nhuận ngay trước mặt khách hàng — để khách thấy con số thay đổi thế nào.',
      priVynosu: 'Với lợi nhuận {vynos}',
      rizika: {
        deti: 'Các con',
        doplnte: 'bổ sung ở phần Rủi ro',
        doporucene: 'Mức bảo vệ đề xuất, tính từ số liệu của gia đình. Chuyên viên sẽ điều chỉnh các rủi ro và số tiền cụ thể ở phần Rủi ro.',
        klient: 'Khách hàng',
        nadpis: 'Với {cena} mỗi tháng cho bảo vệ, gia đình nhận được khi có chuyện xảy ra',
        nadpisBezCeny: 'Gia đình nhận được gì khi có chuyện xảy ra',
        podminky: 'Chi trả theo điều kiện bảo hiểm. Các khoản không cộng dồn.',
        zadna: 'Chưa chọn rủi ro nào — bổ sung ở phần Rủi ro.',
      },
      tooltip: {
        dnes: 'Hôm nay · {vek} tuổi',
        vek: '{vek} tuổi · sau {roky}',
        vynos: 'Lợi nhuận mô hình {castka}',
      },
      vek60: '60 tuổi',
      vek65: '65 tuổi',
      vek70: '70 tuổi',
      vekLabel: 'Đến bao nhiêu tuổi',
      vekVlastni: 'đến {vek} tuổi',
      vekVlastniLabel: 'Hoặc nhập tuổi',
      vynos4: '4 % mỗi năm',
      vynos7: '7 % mỗi năm',
      vynos9: '9 % mỗi năm',
      vynosLabel: 'Lợi nhuận mong đợi',
      vynosProti: 'so với {investice} đã đầu tư · {vynos} mỗi năm',
      vynosVModelu: 'Lợi nhuận theo mô hình',
      zaplaceno: {
        investice: 'Trong đó cho đầu tư',
        investicePopis: '{mesicne} mỗi tháng',
        ochrana: 'Trong đó cho bảo vệ',
        ochranaPopis: 'phí bảo vệ, không hoàn lại',
        popis: '{mesicne} mỗi tháng × 12 × {roky}',
        popisPoplatek: '{mesicne} mỗi tháng × 12 × {roky} + phí {poplatek}',
        stitek: 'Tổng số tiền đóng',
      },
    },
    hadani: {
      odkryt: 'Xem con số thật',
      pole: 'Anh/chị đoán (mỗi tháng)',
      rozdil: 'Chênh lệch so với con số anh/chị đoán',
      skutecnost: 'Nhà nước trả mỗi tháng',
      vyzva: 'Anh/chị nghĩ nhà nước sẽ trả cho mình bao nhiêu mỗi tháng? Hãy đoán thử trước khi xem con số thật.',
    },
    hranice: {
      davkyOdhad: 'Trợ cấp nhà nước ở đây chỉ là con số tham khảo. Mức thực tế do cơ quan nhà nước quyết định.',
      modelace: 'Đây là tính toán mẫu, không phải hợp đồng bảo hiểm, cũng không phải khuyến nghị riêng cho anh chị.',
      odhadKlienta: 'Con số anh chị đoán chỉ để so sánh. Nó không vào phép tính, cũng không in ra giấy.',
      potvrdiPoradce: 'Giải pháp cụ thể, hạn mức và giá sẽ do tư vấn viên xác nhận với công ty bảo hiểm.',
      sablona: 'Các số tiền được đánh dấu là mẫu tham khảo theo kinh nghiệm của tư vấn viên, không phải bản chào, cũng không phải bảo đảm.',
      vynosNeniGarantovan: 'Lợi nhuận trong tương lai không được bảo đảm. Diễn biến thật có thể khác, thậm chí khác nhiều.',
    },
    jednotka: {
      denni: 'tiền trả mỗi ngày',
      jednorazova: 'tiền trả một lần',
      renta: 'tiền trả hằng tháng',
      zaDen: 'mỗi ngày',
      zaMesic: 'mỗi tháng',
    },
    karta: {
      cenaHint: 'Ghi lại theo bảng tính của công ty bảo hiểm (modelace). Nếu chưa có, hãy để trống.',
      cenaNezadana: 'Chưa nhập giá — rủi ro này không được tính vào tổng.',
      cenaPole: 'Giá mỗi tháng',
      dnesCenaPole: 'Hiện nay đang trả',
      dnesHint: 'Ghi lại từ hợp đồng hiện tại của khách. Không có số này thì không tính được tỷ lệ.',
      dnesKrytiPole: 'Mức bảo vệ hiện nay',
      dnesNadpis: 'Hiện nay đang có gì',
      formaNezadana: 'Chưa chọn hình thức thu nhập — trợ cấp ốm đau đang được tính như người làm thuê.',
      jakSePocita: 'Cách tính',
      jenZeny: 'chỉ nữ giới',
      krytiPole: 'Số tiền bảo hiểm (krytí)',
      nezadano: 'chưa nhập',
      osvcBezNemocenske: 'Là người tự kinh doanh (OSVČ) không đóng bảo hiểm ốm đau tự nguyện, anh/chị không nhận được trợ cấp ốm đau.',
      otazka: 'Câu hỏi cho khách',
      oznacProbrano: 'Đánh dấu đã trao đổi',
      poOsobach: 'Theo từng người',
      pomerCena: 'giá',
      pomerKryti: 'số tiền bảo hiểm',
      pomerNadpis: 'So với hợp đồng hiện nay',
      potreba: 'Cần bao nhiêu tiền',
      preskoceno: 'Đã bỏ qua',
      preskocit: 'Bỏ qua',
      proDeti: 'cả cho trẻ em',
      probrano: 'Đã trao đổi',
      radekPotreba: 'cần',
      sbalit: 'Thu gọn',
      statDa: 'Nhà nước trả bao nhiêu',
      tvar: 'Dạng số tiền chi trả',
      vCene: 'đã tính vào giá',
      varianty: 'Các phương án bảo hiểm',
      vratit: 'Hoàn tác',
      vyradit: 'Loại bỏ',
      zapsat: 'Điền số',
      zaradit: 'Thêm vào',
    },
    neznamo: 'Chưa nhập',
    poznamka: {
      cenaOdPoradce: 'Mức phí và giải pháp cụ thể sẽ do cố vấn xác nhận theo báo giá của công ty bảo hiểm.',
      hodnotaDnesnimaOcima: 'Tính theo giá hôm nay, với lạm phát {inflace} % mỗi năm thì đó là',
      investiceVynesla: 'Phần đầu tư theo mô hình đã mang lại',
      modelovyScenar: 'Kịch bản tính toán minh họa, không phải hợp đồng bảo hiểm và cũng không phải khuyến nghị cá nhân.',
      nezbytneJsouCeleVydaje: 'Nhu cầu bảo vệ được tính từ toàn bộ chi phí gia đình. Chi phí thiết yếu thường thấp hơn — con số chính xác do máy tính bảo hiểm nhân thọ đầy đủ tính.',
      odhadKlientaNeniUdaj: 'Con số anh/chị đoán chỉ để so sánh — không vào phép tính và cũng không lên bản in.',
      vlozenoDoOchrany: 'Trong {roky} năm, anh/chị đã bỏ vào phần bảo vệ',
      vynosNeniGarantovan: 'Lợi nhuận trong tương lai không được đảm bảo. Giá trị khoản đầu tư có thể giảm cũng có thể tăng.',
    },
    prehled: {
      balicekVysvetleni: 'Gói được tính theo phần trăm thu nhập, không phải theo phần tiền còn lại. Nhờ vậy thấy ngay là nó có vừa với số tiền còn dư hay không. Đây chỉ là ví dụ mô phỏng, giải pháp cụ thể do cố vấn xác nhận.',
      balicky: 'Có thể để ra bao nhiêu',
      balickyPodnadpis: 'Anh/chị bấm vào một gói. Một phần đi vào bảo vệ, phần còn lại đem đầu tư — tỷ lệ chia đặt ngay bên dưới.',
      chybi: 'Còn thiếu',
      doporuceno: 'Mức cao nhất còn vừa',
      nadVolnymi: 'Đây không phải là điều cấm — khách hàng vẫn được chọn mức cao hơn. Chỉ có nghĩa là chúng ta phải cùng tìm xem lấy số tiền đó từ đâu.',
      nadpis: 'Bao nhiêu tiền đi qua tay',
      podnadpis: 'Hai con số mà khách hàng biết về mình. Và một con số mà thường thì chưa biết.',
      prijem: 'Thu nhập ròng cả nhà',
      prijemNotePar: 'Cả hai vợ chồng cộng lại.',
      vejdeSe: 'Vừa với số tiền còn dư.',
      vlastni: 'Số tiền tự nhập',
      vlastniHint: 'Ghi lại con số mà khách hàng đã nói.',
      vlastniLabel: 'Muốn để ra bao nhiêu',
      vlastniPopis: 'con số khách hàng nói',
      vlastniPrazdna: 'Hãy nhập số tiền khách hàng đã nói — không có số thì không tính được gì.',
      volne: 'Còn dư lại',
      volneKratce: 'Thu nhập trừ chi tiêu.',
      volneNote: 'Thu nhập trừ chi tiêu. Phần này là phần có thể để ra.',
      volneZaporne: 'Hộ gia đình chi nhiều hơn số kiếm được. Trước khi nói đến bảo hiểm, chúng ta phải tìm ra tiền đang chảy đi đâu.',
      vybrano: 'Đã chọn',
      vydaje: 'Chi tiêu cả nhà',
      vydajeNote: 'Tính cả tiền trả nợ vay hằng tháng.',
      zPrijmu: 'của thu nhập',
      zTohoRodine: 'trong đó gửi về bố mẹ / gia đình {castka}',
    },
    prezentace: {
      dal: 'Tiếp theo: {nazev}',
      krok: {
        cas: {
          nadpis: 'Cách trả phí và sức mạnh của thời gian',
          otazka: 'Nếu để tiền làm việc lâu hơn thì sao?',
          say: 'Anh/chị chọn một cột. Sẽ thấy mình đã đóng bao nhiêu và thời gian làm ra bao nhiêu.',
          stitek: 'Phí và thời gian',
          tip: 'Để khách tự bấm. Đây là mô phỏng, không phải lời hứa.',
        },
        cisla: {
          nadpis: 'Con số của gia đình',
          otazka: 'Mỗi tháng nhà mình có bao nhiêu tiền vào, và bao nhiêu tiền ra?',
          say: 'Không cần chính xác, số gần đúng là được — mình sẽ chỉnh cùng nhau.',
          stitek: 'Con số',
          tip: 'Khách thường không biết mình còn dư bao nhiêu — để khách tự đọc con số đó.',
        },
        investice: {
          nadpis: 'Phần còn lại làm việc cho anh/chị',
          otazka: 'Số tiền này có thể làm việc cho anh/chị trong bao nhiêu năm?',
          say: 'Biểu đồ là mô hình, không phải lời hứa. Nó cho thấy thời gian làm được gì.',
          stitek: 'Đầu tư',
          tip: 'Để khách tự chọn độ tuổi.',
        },
        konecne: {
          brana: 'Hãy ghi lại quyết định của khách trước: Đồng ý, Điều chỉnh hoặc Chưa muốn.',
          nadpis: 'Quyết định cuối cùng',
          otazka: 'Giờ anh/chị đã biết giá và điều kiện. Anh/chị có muốn mức bảo vệ này không?',
          say: 'Đồng ý, điều chỉnh hay chưa muốn — câu trả lời nào cũng được.',
          stitek: 'Xác nhận',
          tip: 'Nếu khách chọn Điều chỉnh, hãy hỏi muốn đổi gì.',
          volba: {
            ano: 'Đồng ý',
            upravit: 'Điều chỉnh',
            zatimNe: 'Chưa muốn',
          },
        },
        potvrzeni: {
          celkem: 'Tổng phí bảo hiểm',
          cena: 'Phí bảo hiểm',
          cenaUTemat: 'Hiện mới có phí cho {n}/{celkem} chủ đề.',
          kryti: 'Số tiền bảo hiểm',
          nadpis: 'Mức bảo vệ của anh/chị',
          otazka: 'Mức bảo vệ này có phù hợp với anh/chị không, hay mình cần chỉnh gì?',
          riziko: 'Rủi ro',
          rucne: 'Trong phần chia gói, phần bảo vệ đã được chỉnh tay thành {castka}.',
          say: 'Số tiền bảo hiểm và phí bảo hiểm sẽ được công ty bảo hiểm xác nhận trong bản chào.',
          stitek: 'Bảo vệ',
          tip: 'Nếu thấy đắt, hạ số tiền bảo hiểm và nói rõ khách sẽ mất phần bảo vệ nào.',
        },
        predstaveni: {
          say: 'Em giới thiệu bản thân và cách em làm việc.',
          tip: 'Khách có thể kiểm tra sổ đăng ký ngay trên điện thoại.',
        },
        rizika: {
          dalsi: 'Rủi ro tiếp theo',
          nadpis: 'Chuyện gì có thể xảy ra',
          otazkaSmrtBezUveru: 'Nếu một ngày anh/chị không về nhà nữa, gia đình sẽ sống bằng gì?',
          otazkaZavazkyBezCastky: 'Anh/chị có khoản vay nào mà người nhà sẽ phải trả tiếp không?',
          poradi: 'Rủi ro {n} / {celkem}',
          predchozi: 'Rủi ro trước',
          say: 'Anh/chị thử đoán xem, rồi mình cùng xem thực tế thế nào.',
          smysl: 'Anh/chị thấy như vậy có hợp lý không?',
          stitek: 'Rủi ro',
          tip: 'Sau khi mở kết quả, hỏi khách xem có hợp lý không.',
          vsePreskoceno: 'Không còn rủi ro nào để trao đổi — tất cả đã được bỏ qua.',
        },
        smlouva: {
          nadpis: 'Hợp đồng hoạt động thế nào',
          otazka: 'Trước khi quyết định, anh/chị muốn biết gì về hợp đồng?',
          say: 'Em nói trước để sau này anh/chị không bất ngờ.',
          stitek: 'Hợp đồng',
          tip: 'Đọc tờ khai sức khỏe cùng khách từng câu một.',
        },
        souhlas: {
          brana: 'Hãy ghi lại câu trả lời của khách trước: Có, Để sau hoặc Không.',
          nadpis: 'Quyết định là của anh/chị',
          otazka: 'Anh/chị có muốn bảo vệ thu nhập của gia đình không?',
          say: 'Có, để sau hay không — câu trả lời nào cũng được.',
          stitek: 'Quyết định',
          tip: 'Hỏi xong thì im lặng, để khách tự trả lời.',
        },
        svoleni: {
          nadpis: 'Hôm nay mình sẽ cùng xem gì',
          otazka: 'Em xin hỏi anh/chị vài câu để cho anh/chị thấy gia đình mình đang thế nào, được không ạ?',
          say: 'Chỉ mất vài phút, và quyết định luôn là của anh/chị.',
          stitek: 'Mở đầu',
          tip: 'Chờ khách trả lời, đừng vội.',
        },
        zaver: {
          balicek: 'Mỗi tháng bao nhiêu',
          dalsiKrok: 'Bước tiếp theo',
          dalsiKrokText: {
            ano: 'Em sẽ chuẩn bị đề xuất phù hợp và mình cùng xem lại. Số tiền bảo hiểm và phí do công ty bảo hiểm xác nhận.',
            ne: 'Quyết định là của anh/chị. Lúc nào cần, mình có thể quay lại.',
            nezadano: 'Bước tiếp theo mình cùng thống nhất.',
            pozdeji: 'Mình hẹn thời gian để quay lại chuyện này.',
            upravit: 'Em sẽ điều chỉnh đề xuất theo ý anh/chị và mình cùng xem lại. Số tiền bảo hiểm và phí do công ty bảo hiểm xác nhận.',
            zatimNe: 'Quyết định là của anh/chị. Lúc nào cần, mình có thể quay lại.',
          },
          nadpis: 'Kết thúc buổi trao đổi',
          otazka: 'Bước tiếp theo nào hợp lý với anh/chị?',
          poznamka: 'Ghi chú',
          rozhodnuti: 'Câu trả lời của anh/chị',
          say: 'Đây là hai con số. Kết luận là của anh/chị.',
          sayBez: 'Cảm ơn anh/chị đã dành thời gian. Quyết định là của anh/chị, và em tôn trọng.',
          stitek: 'Kết luận',
          termin: 'Ngày giờ hẹn',
          terminKlient: 'Lịch hẹn: {kdy}',
          tip: 'Đừng nối hai con số thành một câu.',
          tipBez: 'Đừng thuyết phục thêm — chỉ hẹn khi nào liên lạc lại.',
        },
      },
      predstaveni: {
        jakText: 'Em sẽ cho anh/chị thấy gia đình mình đang thế nào. Có tham gia bảo hiểm hay không và tham gia thế nào là do anh/chị quyết định.',
        odmenaText: 'Em được trả thù lao thế nào cho công việc này, em sẽ nói rõ, và anh/chị sẽ nhận thông tin đó bằng văn bản trước khi ký.',
      },
      uvod: {
        nadpis: 'Gia đình mình đang thế nào',
        rodina: 'Gia đình anh/chị',
        slib: 'Mình cùng xem, anh/chị cứ hỏi, rồi tự quyết định.',
      },
    },
    rizika: {
      nadpis: 'Các rủi ro',
    },
    riziko: {
      bezmocnost: {
        coJe: 'Tình trạng anh/chị không tự lo được cho mình — không tự ăn, tự rửa, tự đi lại được. Ngày nào cũng phải có người bên cạnh.',
        nazev: 'Phụ thuộc hoàn toàn vào người chăm sóc',
        pozn: 'Trong các bảng tính, mục này gọi là mức cao nhất. Khi nào được chi trả thì do hợp đồng bảo hiểm quy định.',
      },
      denniOdskodne: {
        coJe: 'Tiền trả cho từng ngày điều trị sau tai nạn. Nó bù đúng khoảng thời gian mà tiền nghỉ ốm chưa được trả.',
        nazev: 'Tiền theo ngày trong thời gian điều trị tai nạn',
      },
      detiHospitalizace: {
        coJe: 'Tiền trả cho mỗi đêm con nằm viện. Bố mẹ ở với con nên không đi làm được.',
        nazev: 'Con nằm viện',
      },
      detiOdskodne: {
        coJe: 'Tiền trả cho từng ngày con điều trị sau tai nạn — bố mẹ vẫn mất thu nhập, chỉ là ở nhà.',
        nazev: 'Tiền theo ngày khi con điều trị',
      },
      detiPeceRodice: {
        coJe: 'Sau tai nạn hoặc bệnh, con phải có người chăm suốt đời. Khoản hụt lớn nhất không phải tiền chữa bệnh — mà là bố mẹ phải nghỉ việc lâu dài để chăm con.',
        nazev: 'Chuyện nặng xảy ra với con — bố mẹ mất thu nhập',
        pozn: 'Số tiền này nằm trong hợp đồng của từng đứa con. Một phần nhu cầu cho con thì không công ty bảo hiểm nào nhận — phần đó phải để dành và đầu tư.',
      },
      detiTrvale: {
        coJe: 'Một khoản trả một lần cho phục hồi chức năng, dụng cụ hỗ trợ và sửa nhà, khi sau tai nạn con bị hạn chế vĩnh viễn.',
        nazev: 'Di chứng vĩnh viễn sau tai nạn ở con',
      },
      detiZavazne: {
        coJe: 'Trả một lần khi con bị một trong các bệnh có tên trong hợp đồng — để chữa bệnh và để bố mẹ có thể ở nhà với con.',
        nazev: 'Bệnh nặng ở con',
        pozn: 'Mức mà công ty bảo hiểm nhận cho con có giới hạn. Phần nhu cầu còn lại phải để dành và đầu tư.',
      },
      hospitalizace: {
        coJe: 'Tiền trả cho mỗi đêm nằm viện. Chuyện ngắn ngày — với người lớn thì tiền dự phòng thường lo được.',
        nazev: 'Nằm viện',
      },
      invalidita1Klesajici: {
        coJe: 'Hạn chế lao động một phần, với số tiền đã thỏa thuận giảm dần theo thời gian.',
        nazev: 'Mất sức lao động mức I — số tiền giảm dần',
      },
      invalidita1Konstantni: {
        coJe: 'Hạn chế lao động một phần (mất sức lao động mức I). Thu nhập giảm, chi phí vẫn y nguyên.',
        nazev: 'Mất sức lao động mức I — số tiền giữ nguyên',
      },
      invalidita2Klesajici: {
        coJe: 'Hạn chế lao động nặng, với số tiền đã thỏa thuận giảm dần theo thời gian.',
        nazev: 'Mất sức lao động mức II — số tiền giảm dần',
      },
      invalidita2Konstantni: {
        coJe: 'Hạn chế lao động nặng: anh/chị làm được vài việc, nhưng không làm nghề của mình cả ngày được nữa.',
        nazev: 'Mất sức lao động mức II — số tiền giữ nguyên',
      },
      invalidita3Klesajici: {
        coJe: 'Mất hoàn toàn khả năng lao động, nhưng số tiền bảo hiểm giảm dần từng năm.',
        nazev: 'Mất sức lao động mức III — số tiền giảm dần',
        pozn: 'Phương án rẻ hơn. Chỉ hợp lý nếu anh/chị thật sự đầu tư và tài sản dần lấp được khoảng hụt — nếu không thì mức bảo vệ giảm mà nhu cầu thì không.',
      },
      invalidita3Konstantni: {
        coJe: 'Mất hoàn toàn khả năng lao động (mất sức lao động mức III): không làm việc được nữa. Số tiền đã thỏa thuận giữ nguyên suốt thời hạn.',
        nazev: 'Mất sức lao động mức III — số tiền giữ nguyên',
      },
      pece12: {
        coJe: 'Tiền theo ngày cho giai đoạn anh/chị tự làm được phần lớn việc, nhưng vài việc vẫn cần người giúp.',
        nazev: 'Chăm sóc dài hạn — mức phụ thuộc thấp',
      },
      pece34: {
        coJe: 'Khoản tiền hàng tháng suốt thời gian anh/chị cần người khác chăm sóc mỗi ngày.',
        nazev: 'Chăm sóc dài hạn — mức phụ thuộc cao',
        pozn: 'Ứng dụng này không tính mức tiền hàng tháng cần thiết — người tư vấn sẽ điền số từ bảng tính.',
      },
      pnOd29: {
        coJe: 'Tiền theo ngày, bắt đầu trả sau bốn tuần nghỉ ốm (mất khả năng làm việc tạm thời). Tháng đầu thì tiền dự phòng lo.',
        nazev: 'Nghỉ ốm — trả từ ngày thứ 29',
      },
      pnOd61: {
        coJe: 'Tiền theo ngày chỉ trả sau hai tháng. Phương án rẻ nhất — hợp lý khi tiền dự phòng gánh được hai tháng.',
        nazev: 'Nghỉ ốm — trả từ ngày thứ 61',
      },
      pnPlus: {
        coJe: 'Tiền theo ngày với điều kiện dễ hơn — trả cả trong những trường hợp mà phương án cơ bản loại trừ.',
        nazev: 'Nghỉ ốm — phạm vi chi trả mở rộng',
        pozn: 'Cái gì được tính và cái gì bị loại trừ đều ghi trong điều khoản hợp đồng. Anh/chị hãy đọc kỹ cùng người tư vấn.',
      },
      smrtInvaliditaKombinace: {
        coJe: 'Một số tiền bảo hiểm duy nhất, trả theo việc nào xảy ra trước — qua đời, hay mất sức lao động.',
        nazev: 'Qua đời hoặc mất sức lao động — chung một số tiền',
        pozn: 'Gói kết hợp chỉ trả một lần. Ai muốn lo đủ cả hai trường hợp thì cần hai số tiền riêng, không phải một.',
      },
      smrtKlesajici: {
        coJe: 'Số tiền bảo hiểm giảm dần từng năm, vì dư nợ vay mua nhà cũng giảm và tài sản của anh/chị thì tăng.',
        nazev: 'Qua đời — số tiền giảm dần',
        pozn: 'Phương án rẻ hơn. Nó khớp với khoản nợ đang trả — chứ không khớp với mức sống của gia đình, cái đó không giảm.',
      },
      smrtKonstantni: {
        coJe: 'Số tiền bảo hiểm giữ nguyên suốt thời hạn. Gia đình nhận như nhau, dù là năm đầu hay năm cuối.',
        nazev: 'Qua đời — số tiền giữ nguyên',
      },
      smrtKratsiDoba: {
        coJe: 'Bảo vệ trong thời gian ngắn hơn cả hợp đồng. Thường là đến khi trả hết khoản vay hoặc đến khi con trưởng thành.',
        nazev: 'Qua đời — chỉ bảo vệ vài năm',
        pozn: 'Ứng dụng không tính riêng thời gian ngắn hơn — cả bản phân tích chạy theo một thời hạn duy nhất. Số tiền và thời gian sẽ do người tư vấn điền.',
      },
      smrtUraz: {
        coJe: 'Chỉ chi trả khi nguyên nhân là tai nạn. Vì vậy nó rẻ — và vì vậy không được dùng làm bảo vệ chính: qua đời do bệnh thì gói này không trả gì cả.',
        nazev: 'Qua đời do tai nạn',
      },
      trvaleOd1: {
        coJe: 'Chi trả cả khi di chứng nhỏ. Phương án đắt hơn, nhưng phạm vi chi trả rộng nhất.',
        nazev: 'Di chứng vĩnh viễn — trả từ mức phần trăm thấp nhất',
      },
      trvaleOd10: {
        coJe: 'Bỏ qua tổn thương nhỏ, chỉ trả khi tổn thương thật sự làm thay đổi cuộc sống của anh/chị.',
        nazev: 'Di chứng vĩnh viễn — trả từ mười phần trăm',
      },
      trvalePremium: {
        coJe: 'Di chứng càng nặng thì tiền trả càng cao — với tổn thương nặng có thể gấp nhiều lần số tiền đã thỏa thuận.',
        nazev: 'Di chứng vĩnh viễn — hệ số tăng theo mức độ nặng',
        pozn: 'Hệ số tăng nhanh đến đâu và chạm mức trần ở đâu là do hợp đồng bảo hiểm quy định.',
      },
      zavazkyDluh: {
        coJe: 'Phần anh/chị gánh trong khoản vay mua nhà và các khoản trả góp khác — chúng không tự biến mất. Đây là một thành phần của số tiền khi qua đời và khi mất sức lao động, không phải gói bảo vệ thêm.',
        nazev: 'Nợ và trả góp — ai sẽ trả nốt',
        pozn: 'Nợ thì không cắt bớt ở bất kỳ phương án bảo vệ nào. Khoản vay mua nhà không thể trả nốt tám mươi phần trăm.',
      },
      zavazneKlesajici: {
        coJe: 'Vẫn là bảo vệ đó, nhưng số tiền giảm dần từng năm. Rẻ hơn, nếu cùng lúc tài sản của anh/chị tăng lên.',
        nazev: 'Bệnh nặng — số tiền giảm dần',
      },
      zavazneOpakovane: {
        coJe: 'Chi trả nhiều hơn một lần — nếu sau khi khỏi bệnh lại mắc một bệnh khác có tên trong hợp đồng, công ty bảo hiểm chi trả thêm một lần nữa.',
        nazev: 'Bệnh nặng — được trả nhiều lần',
        pozn: 'Mức trần tổng cộng của việc trả nhiều lần do hợp đồng bảo hiểm quy định.',
      },
      zavazneRozsirene: {
        coJe: 'Vẫn là bảo vệ đó, chỉ là danh sách bệnh dài hơn và điều kiện chi trả dễ hơn. Cụ thể gồm những gì thì ghi trong hợp đồng.',
        nazev: 'Bệnh nặng — phạm vi mở rộng',
      },
      zavazneZakladni: {
        coJe: 'Trả một lần khi được chẩn đoán một bệnh nặng (bệnh hiểm nghèo) có trong danh sách của hợp đồng. Tiền đó không phải để trả hóa đơn — mà để anh/chị có thể ngừng làm việc và đi chữa bệnh.',
        nazev: 'Bệnh nặng — phạm vi cơ bản',
      },
      zavazneZeny: {
        coJe: 'Phần bổ sung cho những bệnh chỉ xảy ra ở phụ nữ và cho biến chứng khi mang thai.',
        nazev: 'Bệnh nặng dành cho phụ nữ',
      },
    },
    rokFew: '{n} năm',
    rokMany: '{n} năm',
    rokOne: '{n} năm',
    rozdeleni: {
      balicek: 'Gói hàng tháng:',
      chybiBalicekTuk: 'Chưa chọn gói hàng tháng',
      investice: 'Đầu tư',
      nadpis: 'Bao nhiêu cho bảo vệ (bảo hiểm), bao nhiêu cho đầu tư',
      ochrana: 'Bảo vệ',
      podilOchrany: 'Bảo vệ chiếm {pct} của gói',
      popis: 'Gói được chia thành hai phần. Anh/chị có thể tự kéo thanh trượt để thử.',
      posuvnik: 'Bao nhiêu trong gói dành cho bảo vệ',
      prekrocenoText: 'Sẽ không còn gì cho đầu tư và gói còn thiếu {chybi}. Hoặc giảm mức bảo hiểm, hoặc tăng số tiền khách hàng dành ra mỗi tháng.',
      prekrocenoTuk: 'Bảo vệ đắt hơn cả gói',
      skript: 'Anh/chị có {balicek} mỗi tháng. Bao nhiêu trong đó anh/chị muốn dành để bảo vệ gia đình, và bao nhiêu để tiền làm việc cho anh/chị? Anh/chị thử tự kéo xem.',
      skriptNadpis: 'Câu nói cho buổi gặp',
      zdrojNeznamy: 'Chưa có rủi ro nào được nhập giá bảo vệ.',
      zdrojPosuvnik: 'Anh/chị đã đặt số tiền bằng thanh trượt.',
      zdrojSoucet: 'Từ tổng giá ở các rủi ro: {soucet} · số rủi ro có giá: {pocet}',
      zpetNaSoucet: 'Quay lại tổng giá',
    },
    rozpad: {
      cile: 'Mục tiêu',
      deficitMes: 'Thiếu mỗi tháng',
      detiCelkem: 'Gia đình cần',
      detiNepojistitelne: 'Trong đó không bảo hiểm được',
      detiSoucet: 'Tổng các hợp đồng',
      detiZavazne: 'Bệnh hiểm nghèo của con',
      diskont: 'Quy về tiền hôm nay theo mức',
      dluhy: 'Nợ',
      karence: 'Quỹ dự phòng lo được (tháng)',
      naDite: 'Cho một con',
      nasobekPrijmu: 'Số lần thu nhập một năm',
      prijem: 'Thu nhập',
      statniDavka: 'Trợ cấp nhà nước',
      tnuSablona: 'Di chứng vĩnh viễn — mẫu',
      vydaje: 'Vốn cho chi tiêu đến hết mốc thời gian',
      vydajePoUdalosti: 'Chi phí sau biến cố',
    },
    skupina: {
      deti: {
        nazev: 'Con cái',
        otazka: 'Nếu con ốm cả năm, ai trong hai anh chị sẽ ở nhà trông con?',
        podtitul: 'Con ốm là bố hoặc mẹ mất thu nhập',
      },
      invalidita: {
        nazev: 'Mất sức lao động',
        otazka: 'Anh/chị đoán xem: nếu không còn làm việc được nữa, nhà nước trả bao nhiêu một tháng?',
        podtitul: 'Khi không còn làm việc được nữa — mà vẫn phải sống tiếp',
      },
      neschopnost: {
        nazev: 'Nghỉ ốm dài ngày',
        otazka: 'Khi nghỉ ốm, nhà nước trả anh/chị bao nhiêu một tháng? Anh/chị thử đoán xem.',
        podtitul: 'Nằm nhà nhiều tháng, chi phí vẫn chạy',
      },
      pece: {
        nazev: 'Chăm sóc dài hạn',
        otazka: 'Ai sẽ chăm anh/chị — và lấy tiền đâu để trả cho người chăm?',
        podtitul: 'Khi tự mình không lo được việc hằng ngày',
      },
      smrt: {
        nazev: 'Qua đời',
        otazka: 'Nếu một ngày anh/chị không về nhà nữa, ai trả tiếp khoản vay mua nhà?',
        podtitul: 'Gia đình còn lại gì, và ngân hàng còn lại gì',
      },
      uraz: {
        nazev: 'Tai nạn',
        otazka: 'Nếu sau tai nạn anh/chị không làm được công việc như trước nữa, ở nhà sẽ thay đổi những gì?',
        podtitul: 'Di chứng vĩnh viễn và số ngày điều trị',
      },
      zavazky: {
        nazev: 'Các khoản nợ',
        otazka: 'Ai sẽ trả tiếp {castka} đó?',
        podtitul: 'Những khoản trả góp không tự mất đi',
      },
      zavazne: {
        nazev: 'Bệnh hiểm nghèo',
        otazka: 'Nếu mai bác sĩ đưa ra chẩn đoán — cả năm chỉ muốn tập trung điều trị thì anh/chị sống bằng gì?',
        podtitul: 'Chẩn đoán mà sau đó phải điều trị hàng tháng đến hàng năm',
      },
    },
    smlouva: {
      dlouhodoba: {
        nadpis: 'Bảo hiểm là chuyện lâu dài',
        odstoupeni: 'Rút khỏi hợp đồng ngay sau khi ký',
        odstoupeniText: 'Trong thời gian ngắn sau khi ký, anh/chị có quyền rút khỏi hợp đồng mà không cần nêu lý do. Thời hạn do luật quy định và được ghi trong hợp đồng.',
        preruseni: 'Nếu ngừng đóng tiền',
        preruseniText: 'Chuyện gì xảy ra là do điều khoản bảo hiểm quy định.',
        text: 'Bảo hiểm có ý nghĩa khi giữ nhiều năm, không phải vài tháng.',
        ukonceni: 'Nếu chấm dứt hợp đồng',
        ukonceniDusledek: 'Trong những năm đầu, khi phí ban đầu còn đang được trả dần, nếu chấm dứt hợp đồng anh/chị có thể nhận lại rất ít hoặc không nhận lại gì.',
        ukonceniText: 'Anh/chị có quyền làm vậy. Mức bảo vệ mất ngay từ ngày đó. Nhận lại được bao nhiêu là do điều khoản bảo hiểm quy định.',
        znovu: 'Làm hợp đồng mới sau này thì phải khai báo sức khỏe lại — theo tuổi và sức khỏe lúc đó.',
      },
      dotaznik: {
        nadpis: 'Tờ khai sức khỏe: khai đúng và khai đủ',
        podpis: 'Đừng ký bất cứ điều gì anh/chị chưa hiểu.',
        spolu: 'Chúng ta sẽ cùng đọc từng câu một. Câu nào chưa hiểu — kể cả vì chưa rành tiếng — anh/chị cứ hỏi.',
        text: 'Khai sai hoặc khai thiếu có thể khiến công ty bảo hiểm không trả, hoặc trả ít hơn — kể cả khi anh/chị đã đóng tiền nhiều năm.',
      },
      investice: {
        dny: 'thường trong vòng {dny} ngày',
        dnyPodleSmlouvy: 'Thời hạn chính xác được ghi trong hợp đồng.',
        dostupne: 'Nhận được tiền',
        nadpis: 'Phần đầu tư có thể thay đổi',
        pozastavit: 'Tạm dừng',
        pozastavitText: 'tạm ngừng đầu tư một thời gian',
        pridat: 'Đóng thêm',
        pridatText: 'tăng mức đóng hoặc nộp thêm một khoản',
        ubrat: 'Rút bớt',
        ubratText: 'rút ra một phần tiền',
      },
      nadpis: 'Hợp đồng hoạt động thế nào',
      oci: 'Hợp đồng',
      platba: {
        investice: 'Phần đầu tư',
        investiceText: 'Phần này có giá trị và có thể rút ra. Khi nào và như thế nào là do hợp đồng quy định.',
        nadpis: 'Tiền đóng gồm hai phần',
        ochrana: 'Phần bảo vệ',
        ochranaText: 'Là tiền mua mức bảo vệ. Phần này không quay lại — giống như bảo hiểm xe bắt buộc.',
      },
      vyluky: {
        nadpis: 'Khi nào công ty bảo hiểm không trả',
        text: 'Hợp đồng nào cũng có điều khoản loại trừ — những trường hợp công ty không trả. Các trường hợp này ghi trong điều khoản bảo hiểm, chúng ta sẽ cùng đọc kỹ.',
      },
    },
    souhrn: {
      cenaMesic: 'Giá mỗi tháng',
      cenaNezadana: 'Cố vấn nhập giá từ bản tính của công ty bảo hiểm',
      cenaUTemat: 'Hiện mới có phí cho {s}/{z} chủ đề.',
      nadpis: 'Tổng kết',
      osoba: 'Người',
      pozn: 'Giá và cách làm cụ thể sẽ do người tư vấn xác nhận theo báo giá của công ty bảo hiểm.',
      preskoceno: 'Đã bỏ qua',
      probrano: 'Đã trao đổi',
      sCenou: 'Đã có giá',
      vybrano: 'Đã chọn',
      zbyva: 'Còn lại',
    },
    spolecne: {
      let: 'tuổi',
      nezadano: 'chưa nhập',
      podtitulek: 'Từ thu nhập, qua từng rủi ro, đến hai con số: gia đình nhận được bao nhiêu nếu có chuyện — và còn lại bao nhiêu nếu không có chuyện gì.',
      rezimKlient: 'Cho khách xem',
      rezimPoradce: 'Quay lại chế độ tư vấn',
      sekce: 'Bảo hiểm nhân thọ',
      titulek: 'Phân tích cho người Việt',
      ukazka: 'Khách hàng mẫu',
      ukazkaJmeno: 'Mẫu',
      ukazkaZnacka: 'Số liệu mẫu để tập buổi gặp — không phải dữ liệu của khách đang ngồi đây.',
      vycistit: 'Khách hàng mới',
      zaDen: '/ ngày',
      zaMesic: '/ tháng',
      zpet: 'Quay lại công cụ',
    },
    stav: {
      doplniPoradce: 'Thiếu số liệu. Người tư vấn sẽ điền — chúng tôi không tự đoán.',
      jeSlozka: 'Khoản này nằm trong số tiền chi trả khi qua đời và khi mất sức lao động, không phải phần bảo vệ thêm.',
      kombinace: 'Gói kết hợp chỉ chi trả một lần. Gồm: {rizika}',
      neumimeSpocitat: 'Phần bảo vệ này ứng dụng không tính — số tiền do người tư vấn điền từ bản mô phỏng.',
    },
    stop: {
      bezBalicku: 'Hãy chọn một gói, hoặc ghi số tiền tự chọn.',
      bezCastky: 'Hãy điền số tiền.',
      bezCenyOchrany: 'Chưa biết giá của phần bảo vệ — anh/chị hãy điền giá ở từng rủi ro, hoặc đặt bằng thanh trượt.',
      bezHorizontu: 'Hãy chọn tính đến bao nhiêu năm.',
      bezKapitalu: 'Chưa có giá trị mô phỏng của phần đầu tư thì không tính được khoản tiền hàng tháng (renta).',
      bezKatalogu: 'Không tải được danh mục rủi ro.',
      bezPoplatku: 'Chưa điền phí ban đầu của phần đầu tư.',
      bezPrijmu: 'Hãy điền thu nhập thực nhận mỗi tháng — không có số đó thì không tính được các gói.',
      bezRizik: 'Chưa chọn rủi ro nào.',
      bezVeku: 'Hãy điền tuổi khách hàng và tuổi mục tiêu.',
      bezVydaju: 'Hãy điền chi phí hàng tháng — nếu không, ta không biết thật sự còn lại bao nhiêu.',
      cilovyVekNizsi: 'Tuổi mục tiêu {vekCilovy} nhỏ hơn tuổi hiện nay {vekDnes} — hãy chọn tuổi muộn hơn.',
      pctMimoRozsah: 'Chỉ có thể dành ra từ {min} đến {max} phần trăm thu nhập.',
      poplatekMimoRozsah: 'Phí ban đầu nằm ngoài khoảng cho phép — thường là {min} đến {max} % của số tiền mục tiêu.',
      rokyMimoRozsah: 'Chỉ tính được cho {min} đến {max} năm.',
      vynosMimoRozsah: 'Lợi nhuận dự kiến phải nằm trong khoảng từ 0 đến {max} phần trăm mỗi năm.',
    },
    tvar: {
      klesajici: 'giảm dần',
      konstantni: 'giữ nguyên',
    },
    varovani: {
      balicekNadVolne: 'Gói {pct} % cao hơn {chybi} so với số tiền hôm nay còn dư. Đây không phải lệnh cấm — tìm ra tiền là việc của chuyên viên.',
      cenaChybiUNekterych: '{pocet} rủi ro đã chọn chưa có giá — nên tổng cộng còn thiếu.',
      denniCenaJenPodPrahem: 'Giá một ngày cho mỗi người cao hơn {prah} — không dùng làm câu chào bán, chỉ hiện để tham khảo.',
      ochranaNadBalicek: 'Phần bảo vệ đắt hơn toàn bộ gói {chybi} — không còn đồng nào cho đầu tư.',
      poplatekNadObvykly: 'Phí {pct} % nằm ngoài khoảng thường gặp {min}–{max} % của số tiền mục tiêu.',
      poplatekNesplacenyVHorizontu: 'Trong khoảng thời gian đã nhập, phí vẫn chưa trả hết.',
      poplatekNezadan: 'Chưa nhập phí ban đầu — con số là thô, chưa trừ phí.',
      splatkyNadPolovinu: 'Tiền trả nợ đã vượt một nửa thu nhập — cần chỉnh các con số bằng tay.',
      splatkyNadRozpocet: 'Tiền trả nợ ngốn nhiều hơn số còn lại sau khi để dành — quy tắc này không khớp với gia đình này.',
      vlastniNadPrijem: 'Số tiền đã nhập cao hơn cả thu nhập một tháng — có phải nhập sai không?',
      vynosMimoScenare: 'Lợi nhuận {vynos} % không thuộc ba phương án mẫu (4 / 7 / 9 %).',
      zadnaCenaZadana: 'Chưa có giá ở bất kỳ rủi ro nào đã chọn — chuyên viên sẽ điền giá.',
    },
    vstupy: {
      bezJmena: 'Khách hàng',
      bezPartnera: 'Không có vợ/chồng',
      deti: 'Số con',
      detiHint: 'Những con mà gia đình đang nuôi.',
      diteJmeno: 'Tên con',
      diteN: 'Con thứ {n}',
      diteVek: 'Tuổi của con',
      domacnost: 'Gia đình',
      dvojice: '{a} và {b}',
      forma: 'Hình thức thu nhập',
      formaOsvc: 'Tự kinh doanh (OSVČ)',
      formaZamestnanec: 'Làm thuê (zaměstnanec)',
      jistina: 'Số nợ còn phải trả (gốc)',
      jistinaHint: 'Còn phải trả bao nhiêu — vay mua nhà cộng tất cả các khoản vay khác.',
      jistinaZbyva: 'Tổng nợ gốc còn lại của mọi khoản vay',
      jmenoOsoby: 'Tên',
      klient: 'Khách hàng',
      klientka: 'Khách hàng',
      manzel: 'Chồng',
      manzelka: 'Vợ',
      muz: 'Nam',
      nadpis: 'Chúng ta tính cho ai',
      oci: 'Thông tin nhập',
      partnerHint: 'Phải điền tên thì mới tính là vợ/chồng. Không có tên thì thu nhập của người đó không được tính vào.',
      podnadpis: 'Tám thông tin là bắt đầu được. Những thứ còn lại điền sau, khi nào cần đến.',
      podporaRodine: 'Tiền gửi về cho bố mẹ / gia đình mỗi tháng',
      pohlavi: 'Giới tính',
      pohlaviHint: 'Ảnh hưởng đến giá bảo hiểm (phí theo mức rủi ro), không phải cách gọi anh/chị.',
      prijem: 'Thu nhập ròng hằng tháng',
      prijemHint: 'Số tiền thật sự về đến tài khoản.',
      souhrnNadpis: 'Bản tính cho',
      vek: 'Tuổi',
      vekCil: 'Tuổi tự do tài chính',
      vekCilHint: 'Tích lũy tiền đến tuổi này. Từ đó nguồn sống là số tiền đã đầu tư, không phải công việc của anh/chị.',
      vydaje: 'Chi tiêu gia đình hằng tháng',
      vydajeHint: 'Tính cả tiền trả nợ vay — tất cả những gì rời khỏi tài khoản.',
      vydajeVcSplatek: 'Chi tiêu gia đình hằng tháng (tính cả tiền trả nợ vay)',
      zena: 'Nữ',
    },
    vysledek: {
      bezKrytiStitek: 'Chưa nhập mức bảo vệ: {pocet}',
      chybiKryti: 'Ở một số rủi ro vừa xem còn thiếu số tiền bảo hiểm (số lượng: {pocet}). Chưa điền số tiền thì rủi ro đó không hiện ra trong phần chi trả.',
      hodnotaInvestice: 'Giá trị phần đầu tư theo mô phỏng',
      hodnotaPopis: 'đã đóng vào đầu tư {castka}',
      iddKratce: 'Kết quả mô phỏng không được bảo đảm và không phải lời hứa rằng tiền phí đã đóng sẽ quay trở lại.',
      iddText: 'Bên trái là số tiền bảo hiểm mà tư vấn viên đã điền, bên phải là diễn biến mô phỏng của phần đầu tư. Hai con số này đứng riêng nhau: kết quả mô phỏng không được bảo đảm và không phải lời hứa rằng tiền phí đã đóng sẽ quay trở lại. Kết luận là việc của khách hàng, giải pháp cụ thể do tư vấn viên xác nhận.',
      iddTuk: 'Hai con số riêng biệt',
      nescitajiSe: 'Các rủi ro không được chi trả cùng một lúc, nên không cộng các số tiền lại với nhau.',
      nestaloNadpis: 'Cuối cùng còn lại gì',
      nestaloOci: 'Nếu không có gì xảy ra',
      ochranaZaplatite: 'Số tiền trả cho bảo vệ trong {roky}',
      ochranaZaplatiteBezRoku: 'Tổng số tiền trả cho bảo vệ',
      poradceNadpis: 'Dành cho tư vấn viên',
      poradcePozn: 'Đừng gộp hai con số vào cùng một câu. Hãy để khách hàng tự rút ra kết luận.',
      renta: 'Tiền hàng tháng (mô phỏng) từ số tiền này',
      rentaPozn: 'Tính khi mỗi năm chỉ rút ra an toàn {sazba}. Đây là tính toán mô phỏng, không phải khoản chi trả được bảo đảm.',
      rizikoBezNazvu: 'Rủi ro chưa có tên',
      staloNadpis: 'Gia đình sẽ nhận được gì',
      staloOci: 'Nếu có chuyện gì xảy ra',
      staloPodnadpis: 'Theo từng rủi ro mà anh/chị đã chọn:',
      staloZdroj: 'Các số tiền lấy từ mức bảo hiểm mà anh/chị đã điền ở từng rủi ro. Các rủi ro không được chi trả cùng một lúc, nên không cộng chúng lại với nhau.',
      zadnaRizika: 'Hiện chưa chọn rủi ro nào có điền số tiền bảo hiểm.',
    },
    zaRokFew: 'trong {n} năm',
    zaRokMany: 'trong {n} năm',
    zaRokOne: 'trong {n} năm',
  },
  /* BLOK:izp END */
  /* BLOK:prodejKit START — generuje scratchpad/slovnik.py, ručně needitovat */
  prodejKit: {
    namitky: {
      analyza: {
        mamPoradce: {
          n: 'Tôi đã có người tư vấn rồi.',
          o: 'Vậy thì tốt, anh/chị không cần thay đổi gì. Bản phân tích cho anh/chị thấy tình hình hiện nay, và anh/chị cứ mang kết quả đến cho người tư vấn của mình xem.',
        },
        nechciNicKupovat: {
          n: 'Tôi không muốn mua gì cả.',
          o: 'Em hiểu. Hôm nay anh/chị không ký gì cả — em chỉ cho anh/chị xem các con số, còn có làm gì với chúng hay không là do anh/chị quyết định.',
        },
        nemamCas: {
          n: 'Tôi không có thời gian.',
          o: 'Em hiểu, thời gian của anh/chị rất quý — hôm nay anh/chị có bao nhiêu thời gian? Mình chỉ xem phần quan trọng nhất, phần còn lại hẹn hôm khác.',
        },
        partner: {
          n: 'Tôi phải bàn với vợ/chồng đã.',
          o: 'Dạ đúng, việc này liên quan đến cả hai người. Lần sau mình gặp cả hai anh chị nhé, để vợ/chồng anh/chị cũng nghe đúng những gì anh/chị nghe hôm nay?',
        },
        prijmyNereknu: {
          n: 'Thu nhập thì tôi không nói đâu.',
          o: 'Em hiểu, đó là quyền của anh/chị. Chỉ cần con số khoảng chừng — phần nào không điền thì để trống, em không tự đoán.',
        },
        procToChcete: {
          n: 'Sao phải biết hết mấy chuyện này?',
          o: 'Không có con số của anh/chị thì em chỉ đoán mò thôi. Câu nào anh/chị không muốn trả lời thì mình bỏ qua.',
        },
      },
      jenPoradce: 'chỉ tư vấn viên thấy',
      kontext: {
        analyza: 'Phân tích',
        pojisteni: 'Bảo hiểm',
      },
      pojisteni: {
        drahe: {
          n: 'Đắt quá.',
          o: 'Em hiểu, ngân sách thì anh/chị rõ nhất. Mình có thể giảm số tiền bảo hiểm ở phần anh/chị tự lo được bằng tiền dự phòng — và em sẽ nói rõ anh/chị mất phần bảo vệ nào.',
        },
        mamPojisteni: {
          n: 'Tôi có bảo hiểm rồi.',
          o: 'Vậy thì tốt — mình sẽ tính phần đó vào để anh/chị không phải trả hai lần cho cùng một thứ. Mình xem hợp đồng nhé: được chi trả bao nhiêu, và có bảo vệ cả khi mất sức lao động chứ không chỉ khi qua đời không?',
        },
        manzel: {
          n: 'Tôi phải hỏi ý kiến vợ/chồng đã.',
          o: 'Dạ đúng, đây là quyết định của cả hai người. Lần sau mình gặp cả hai anh chị nhé, để vợ/chồng anh/chị thấy đúng những con số này — lúc nào thì tiện cho anh chị?',
        },
        nechciSeVazat: {
          n: 'Tôi không muốn bị ràng buộc lâu dài.',
          o: 'Em hiểu — anh/chị có quyền chấm dứt hợp đồng, nhưng trong những năm đầu, khi phí ban đầu còn đang được trả dần, anh/chị có thể nhận lại rất ít hoặc không nhận lại gì. Giữ lâu dài có lợi vì phí và việc được nhận bảo hiểm tính theo tuổi và sức khỏe lúc ký, mà sức khỏe thì không mua lại được về quá khứ.',
        },
        nicSeMiNestane: {
          n: 'Tôi sẽ không sao đâu.',
          o: 'Em cũng mong vậy, và rất có thể anh/chị đúng. Bảo hiểm không dành cho chuyện hay xảy ra mà cho chuyện không thể quay lại — nếu lỡ xảy ra, gia đình anh/chị cầm cự được mấy tháng?',
        },
        rozmyslim: {
          n: 'Để tôi suy nghĩ thêm.',
          o: 'Dạ được, đây là quyết định cho nhiều năm, mình không vội. Để em biết gửi gì cho anh/chị: anh/chị muốn cân nhắc có nên lo cho rủi ro này không, hay nên dành bao nhiêu tiền cho nó?',
        },
      },
      titul: 'Băn khoăn thường gặp',
    },
    ram: {
      brana: 'Bước này chưa xong.',
      dalsi: 'Tiếp',
      hotovo: 'Xong',
      hotovyKrok: 'đã xong',
      klavesy: '→ hoặc phím cách: tiếp · ←: quay lại · Esc: kết thúc',
      klient: 'Khách hàng',
      krok: 'Bước {n} / {celkem}',
      poradce: 'Tư vấn viên',
      prejitNa: 'Bước {n}: {nazev}',
      prezentace: 'Trình bày',
      rozbalit: 'Mở ra',
      skryt: 'Ẩn',
      tahak: 'Gợi ý',
      tip: 'Mẹo',
      zavrit: 'Đóng phần trình bày',
      zpet: 'Quay lại',
    },
    souhlas: {
      ano: 'Có',
      ne: 'Không',
      nezadano: 'Chưa trả lời',
      pozdeji: 'Để sau',
      poznamka: 'Ghi chú (không bắt buộc)',
      vymazat: 'Xóa câu trả lời',
      zapsano: 'Đã ghi lúc {kdy}',
    },
  },
  /* BLOK:prodejKit END */
  /* BLOK:planPojistne START — generuje scratchpad/slovnik.py, ručně needitovat */
  planPojistne: {
    budouci: 'trong tương lai {castka} — hiện chưa tính',
    driveNe: 'Trước đây khách hàng nói không muốn bảo vệ thu nhập — kế hoạch không trừ phí bảo hiểm.',
    nadPrebytek: 'Phí bảo hiểm {cena} cao hơn thặng dư hằng tháng {prebytek} — không còn tiền cho mục tiêu.',
    nezadana: 'Chưa có phí bảo hiểm — kế hoạch chưa trừ khoản này.',
    nula: 'Phí bảo hiểm 0 — không trừ gì từ thặng dư.',
    odmitnuto: 'Khách hàng hiện chưa muốn bảo vệ thu nhập.',
    prebytekBezPrijmu: 'Chưa biết thặng dư hằng tháng — phân tích còn thiếu thu nhập. Hãy bổ sung, hoặc nhập luôn số tiền bạn đã thống nhất với khách hàng.',
    segment: 'Phí bảo hiểm',
    tokPrebytek: 'Thặng dư sau phí bảo hiểm',
    zToho: 'trong đó phí bảo hiểm {pojisteni} · còn cho mục tiêu {naCile}',
  },
  /* BLOK:planPojistne END */
  /* BLOK:analyzaProdej START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaProdej: {
    cas: {
      ano: 'Có, khách có thời gian',
      drivejsiZapis: 'Ghi chú trước đây',
      potvrzeno: 'Khách hàng đã xác nhận 45 phút',
    },
    cesta: {
      dnes: 'HÔM NAY',
      popis: 'Các mục tiêu lần lượt hiện ra theo dòng thời gian',
      prehrat: 'Phát',
      preskocit: 'Bỏ qua',
      vek: '{n} tuổi',
      za: '{n} năm nữa',
      znovu: 'Phát lại',
    },
    dedictvi: {
      druh: 'Loại',
      druhJine: 'Khác',
      druhNemovitost: 'Nhà đất thừa kế từ bố mẹ',
      nadpis: 'Tài sản trong tương lai (thừa kế)',
      nepocita: 'trong tương lai — hiện chưa tính',
      panel: 'Tài sản tương lai',
    },
    forma: {
      jiny: 'Nguồn khác',
      majitel: 'Chủ công ty',
      osvc: 'Tự kinh doanh (OSVČ)',
      zamestnanec: 'Người làm công ăn lương',
    },
    majetek: {
      nefinPod: 'bất động sản, doanh nghiệp',
    },
    oceneni: {
      do: 'đến',
      ebitda: 'Lợi nhuận hoạt động mỗi năm (EBITDA)',
      ebitdaPopis: 'Lợi nhuận trước lãi vay, thuế và khấu hao — không phải lợi nhuận trước thuế.',
      horni: 'Mức cao',
      majetkove: 'Theo tài sản',
      nasobek: 'Hệ số',
      nezadano: 'chưa nhập',
      od: 'từ',
      otevrit: 'Ước tính giá trị doanh nghiệp',
      pouzit: 'Dùng làm giá trị',
      spodni: 'Mức thấp',
      stred: 'Mức giữa',
      substance: 'Chi phí để trang bị lại toàn bộ doanh nghiệp',
      upozorneni: 'Chỉ là ước tính tham khảo, không phải thẩm định giá chuyên môn.',
      vynosove: 'Theo lợi nhuận',
      ztrata: 'Khi lợi nhuận bằng 0 hoặc lỗ, không ước tính theo lợi nhuận.',
    },
    podklady: {
      dotaznik: 'Bảng câu hỏi đầu tư',
      investicni: 'Hợp đồng đầu tư',
      pojistne: 'Hợp đồng bảo hiểm',
      uverove: 'Hợp đồng vay',
      vypisy: 'Sao kê tài khoản ngân hàng',
    },
    prebytek: {
      nicNezbyva: 'Hiện thu nhập không còn dư — dòng tiền tự do là {castka}.',
    },
    predstaveni: {
      jakText: 'Hôm nay em chỉ tìm hiểu tình hình và mục tiêu của anh/chị. Lần sau em mới mang đề xuất đến — quyết định luôn là của anh/chị.',
      jakTitul: 'Em làm việc thế nào',
      kdoText: 'Anh/chị có thể tự kiểm tra đăng ký hành nghề của em trong sổ đăng ký công khai của {dohled}.',
      kdoTitul: 'Em là ai',
      kicker: 'Trước khi bắt đầu',
      odmenaText: 'Khi hợp đồng được ký, công ty tài chính trả hoa hồng cho em. Anh/chị sẽ nhận chi tiết bằng văn bản trước khi ký.',
      odmenaTitul: 'Em được trả công thế nào',
    },
    prez: {
      dialog: 'Trình chiếu phân tích',
      predstaveni: {
        q: 'Trước khi bắt đầu: em là ai và em làm việc thế nào',
        tab: 'Giới thiệu',
        tahak: 'Anh/chị muốn biết điều gì về cách em làm việc?',
        tip: 'Khách có thể kiểm tra sổ đăng ký ngay trên điện thoại.',
      },
    },
    reference: {
      gdprPotvrzeno: '✓ Đã xác nhận {datum}',
      gdprText: 'Khách hàng xác nhận đã được những người được giới thiệu đồng ý cho chia sẻ liên lạc, hoặc biết rằng khi liên hệ lần đầu, tư vấn viên sẽ thông báo cho họ về nguồn và việc xử lý dữ liệu cá nhân theo Điều 14 GDPR.',
      gdprTitul: 'Đồng ý GDPR:',
      tahak: '“Em có một lời nhờ. Nếu buổi gặp hôm nay có ích cho anh/chị, anh/chị giới thiệu giúp em hai ba người đang có việc cần lo: nhà ở, gia đình, công việc nhé? Anh/chị không cần thuyết phục họ. Chỉ cần tên và số điện thoại, em sẽ gọi một lần thôi.”',
    },
    rizika: {
      chybi: 'Còn thiếu',
      chybiHorizont: 'số năm của mục tiêu',
      chybiPozustalostni: 'trợ cấp cho người thân còn lại ở quốc gia này',
      chybiPrijem: 'thu nhập',
      chybiUdaje: 'Còn thiếu để tính',
      chybiVydaje: 'chi tiêu thiết yếu',
      kicker: 'Nếu không còn đi làm được nữa',
      krytiInvalidita: 'Số tiền bảo hiểm khi mất sức lao động',
      krytiSmrt: 'Số tiền bảo hiểm khi qua đời',
      mesicne: 'mỗi tháng',
      potrebujete: 'Anh/chị cần',
      poznamka: 'Đây là mô hình từ số liệu của anh/chị, không phải bảo đảm. Trợ cấp nhà nước chỉ là ước tính.',
      statDa: 'Nhà nước trả',
      stavajici: 'Hợp đồng đang có · mất sức lao động',
      zustane: 'Thu nhập còn lại',
    },
    tabulky: {
      budouciPrijmyPopis: 'Thu nhập sẽ tăng thêm sau hai, ba hoặc năm năm. Kế hoạch tính khoản này vào lương hưu.',
      zatimNic: 'Chưa có gì.',
    },
    tisk: {
      dalsiSchuzka: 'Buổi gặp tiếp theo',
      nadpis: 'Tóm tắt buổi gặp',
      nezadano: 'chưa nhập',
      podklady: 'Giấy tờ cần gửi thêm',
      prebytek: 'Số tiền dư hằng tháng đã thống nhất',
      shrnutiJenJmeni: 'Tóm tắt phân tích của chúng ta: giá trị tài sản ròng {jmeni}.',
    },
    vydaje: {
      podpora: 'Tiền gửi về cho bố mẹ / gia đình',
    },
    zastava: {
      popis: 'Nhà đất từ bố mẹ có thể dùng để bảo đảm khoản vay — chỉ khi chủ sở hữu đồng ý. Không có con số nào được tính lại.',
      titul: 'Có thể dùng thế chấp khoản vay',
      zvoleno: 'đã chọn làm tài sản thế chấp',
      zvolit: 'chọn làm tài sản thế chấp',
    },
    zaver: {
      bezDat: 'Khi có đủ con số, ở đây sẽ hiện những việc cần giải quyết.',
      diarPoPrezentaci: 'Ghi cuộc hẹn vào Lịch sau buổi trình chiếu',
      diarPoPrezentaciAno: '✓ Lịch sẽ mở sau khi kết thúc trình chiếu',
      model: 'Đây là mô hình từ số liệu của anh/chị, không phải bảo đảm.',
      nadpis: 'Những việc mình cùng giải quyết',
      rizikaNadpis: 'Bảo vệ thu nhập',
      rizikaText: '{jmeno}: khi mất sức lao động, mỗi tháng còn thiếu {castka}.',
      terminOtevrit: 'Mở cuộc hẹn trong Lịch',
      terminRadek: 'Buổi gặp tiếp theo: {kdy}',
      terminVAnalyze: 'đã ghi trong phân tích',
      terminVDiari: 'đã có trong Lịch',
      vseOk: 'Theo các con số, hiện chưa có việc gì cần giải quyết.',
    },
  },
  /* BLOK:analyzaProdej END */
  /* BLOK:nastenkaGrafy START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastenkaGrafy: {
    trychtyr: {
      otevrenychFew: 'đang mở',
      otevrenychMany: 'đang mở',
      otevrenychOne: 'đang mở',
      prumerDniFew: 'TB {n} ngày ở giai đoạn',
      prumerDniMany: 'TB {n} ngày ở giai đoạn',
      prumerDniOne: 'TB {n} ngày ở giai đoạn',
    },
    vyvoj: {
      mesiceFew: '{n} tháng',
      mesiceMany: '{n} tháng',
      mesiceOne: '{n} tháng',
      obchodyFew: '{n} giao dịch',
      obchodyMany: '{n} giao dịch',
      obchodyOne: '{n} giao dịch',
      popisGrafu: 'Diễn biến giao dịch: trong {obdobi} có {obchody}, {bj}, nhiều nhất vào {mesic}',
      slovoObchoduFew: 'giao dịch',
      slovoObchoduMany: 'giao dịch',
      slovoObchoduOne: 'giao dịch',
    },
  },
  /* BLOK:nastenkaGrafy END */
  /* BLOK:analyzaPrezentace START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrezentace: {
    chip: {
      bydleni: 'Nhà ở',
      deti: 'Con cái',
      dluhy: 'Nợ',
      duchod: 'Hưu trí',
      investice: 'Đầu tư',
      plan: 'Kế hoạch tổng thể',
      pojisteni: 'Bảo hiểm',
      rezerva: 'Quỹ dự phòng',
    },
    chybi: {
      a: 'và',
      castka: 'số tiền',
      castka4: 'số tiền',
      horizont: 'thời hạn',
      horizont4: 'thời hạn',
      limity4: 'hạn mức bảo hiểm',
      platba4: 'phí hằng tháng',
      pojistovna4: 'công ty bảo hiểm',
    },
    cislo: {
      mil: '{n} triệu',
      tis: '{n} nghìn',
    },
    hlaska: {
      cashflowIncomplete: 'Chưa thể tính dòng tiền tự do.',
      cashflowNic: 'Chưa nhập thu nhập lẫn chi tiêu.',
      cashflowPrijmy: 'Hãy nhập thu nhập của gia đình.',
      cashflowVydaje: 'Hãy bổ sung chi tiêu thường ngày để tính được dòng tiền tự do.',
      cilIncomplete: 'Mục tiêu chưa hoàn chỉnh. Hãy bổ sung {chybi}.',
      hypotekaIncomplete: 'Khoản vay mua nhà đã được ghi nhận. Hãy bổ sung dư nợ còn lại và số tiền trả hằng tháng.',
      investiceIncomplete: 'Hợp đồng đã được ghi nhận. Hãy bổ sung giá trị hiện tại hoặc khoản góp định kỳ.',
      investiceIncompleteVice: 'Các hợp đồng đã được ghi nhận. Hãy bổ sung giá trị hiện tại hoặc khoản góp định kỳ.',
      majetekNeuplny: 'Chưa nhập: {chybi}. Vì vậy giá trị tài sản ròng chỉ mang tính tham khảo và chưa đầy đủ.',
      pojistkaIncomplete: 'Hợp đồng bảo hiểm đã được ghi nhận. Hãy bổ sung {chybi}.',
      pojistkaIncompleteVice: 'Các hợp đồng bảo hiểm đã được ghi nhận. Hãy bổ sung {chybi}.',
      rezervaIncomplete: 'Để tính quỹ dự phòng, hãy bổ sung: {chybi}.',
      rizikoOrientacni: 'Chênh lệch ước tính mỗi tháng giữa chi tiêu của gia đình và thu nhập còn lại sau khi mất nguồn thu. Đây chưa phải nhu cầu bảo hiểm — con số đó sẽ tính sau khi tính đến quỹ dự phòng, trợ cấp xã hội và bảo hiểm hiện có.',
      zavazkyEmpty: 'Chưa ghi nhận khoản nợ nào.',
      zavazkyIncomplete: 'Khoản nợ đã được ghi nhận. Hãy bổ sung dư nợ còn lại và số tiền trả hằng tháng.',
      zavazkyIncompleteVice: 'Các khoản nợ đã được ghi nhận. Hãy bổ sung dư nợ còn lại và số tiền trả hằng tháng.',
    },
    horizont: {
      bezTerminu: 'Chưa đặt thời hạn',
    },
    krok: {
      cile: {
        q: 'Anh/chị muốn đạt được điều gì? CÁI GÌ / KHI NÀO / BAO NHIÊU',
        tab: 'Mục tiêu',
      },
      hodnoty: {
        q: 'Vì sao tiền bạc quan trọng với anh/chị?',
        tab: 'Giá trị',
      },
      ocekavani: {
        q: 'Anh/chị mong đợi gì từ buổi gặp hôm nay?',
        tab: 'Kỳ vọng',
      },
      prijmy: {
        q: 'Anh/chị kiếm được bao nhiêu và còn dư bao nhiêu?',
        tab: 'Thu nhập và chi tiêu',
      },
      rizika: {
        q: 'Điều gì có thể đe dọa kế hoạch?',
        tab: 'Rủi ro',
      },
      rodina: {
        q: 'Hôm nay mình lập kế hoạch cho ai?',
        tab: 'Gia đình',
      },
      zavazky: {
        q: 'Hiện anh/chị đang trả những khoản nợ nào và có những hợp đồng gì?',
        tab: 'Nợ và hợp đồng',
      },
      zaver: {
        q: 'Mình cùng tóm tắt lại nhé.',
        tab: 'Kết luận',
      },
      zdroje: {
        q: 'Anh/chị có những nguồn lực nào cho mục tiêu của mình?',
        tab: 'Nguồn lực',
      },
    },
    pasmo: {
      dlouhodoby: 'Dài hạn',
      kratkodoby: 'Ngắn hạn',
      strednedoby: 'Trung hạn',
    },
    pasmoPopis: {
      dlouhodoby: 'từ 10 năm trở lên',
      kratkodoby: 'đến 3 năm',
      strednedoby: '4–9 năm',
    },
    platno: {
      cesta: {
        nadpis: 'Hành trình cuộc đời',
        orientacniPozn: 'Tự do tài chính được quy đổi ra vốn theo quy tắc 4 % — phương pháp chưa được phê duyệt, con số chỉ để tham khảo.',
        orientacniTitul: 'Việc quy đổi dòng tiền hưu trí ra vốn (quy tắc 4 %) chưa phải phương pháp được phê duyệt — con số chỉ để tham khảo.',
      },
      citat: '“{text}”',
      hodnoty: {
        nadpis: 'Điều gì quan trọng với anh/chị',
        prazdno: 'Ghi ở bên trái tiền bạc có ý nghĩa gì với khách…',
      },
      ocekavani: {
        cil: 'Mục tiêu của em là xem **anh/chị đang làm tốt điều gì**, chỗ nào có thể **đang mất tiền** và điều gì **có thể làm tốt hơn**.',
        nadpis: 'Anh/chị mong đợi gì từ hôm nay',
        prazdno: 'Ghi lời của khách ở bên trái…',
      },
      prijmy: {
        poznamka503020: '50 / 30 / 20 là mốc tham khảo, không phải quy tắc bắt buộc — cách chia thực tế tùy cuộc sống gia đình.',
        rozdilNezadano: 'Phần chênh lệch sẽ hiện khi có cả số dư tính được và số tiền khách đã đồng ý.',
      },
      rizika: {
        kino: 'Chiếu phim: Bảo vệ trước rủi ro',
      },
      rodina: {
        cilKicker: 'Mục tiêu hôm nay',
        cilText: 'Mình cùng **xem anh/chị đang làm tốt điều gì** — và tài chính chỗ nào **có thể cải thiện**. Không bán hàng, chỉ có bức tranh rõ ràng và lời khuyên.',
        nadpis: 'Gia đình mà mình lập kế hoạch',
        prazdno: 'Điền tên khách hàng và các con ở bên trái…',
      },
      zavazky: {
        dodaPozdeji: 'khách sẽ gửi sau: {n}',
        fixace: 'kỳ cố định lãi suất gần nhất {datum}',
        konec: 'kết thúc trả nợ {datum}',
        splatka: 'trả góp {castka}',
      },
      zdroje: {
        bezKurzu: 'Tổng hợp chưa gồm {n} khoản bằng ngoại tệ — chưa có tỷ giá dùng được. Thà không đưa vào còn hơn nói ra một con số chưa ai kiểm tra.',
        bezKurzuKat: '{n}× ngoại tệ chưa có tỷ giá — chưa tính',
      },
    },
    pole: {
      bonusy: 'Thưởng hằng năm',
      cas: 'Giờ',
      cilCo: 'CÁI GÌ — mô tả mục tiêu',
      cilCoPh: 'VD: nhà rộng hơn',
      cilKdy: 'KHI NÀO — sau bao nhiêu năm',
      cilKolik: 'BAO NHIÊU — số tiền mục tiêu',
      cilTyp: 'Loại mục tiêu',
      coDodat: 'Khách cần gửi gì',
      dalsiSchuzka: 'Buổi gặp tiếp theo',
      datum: 'Ngày',
      doslovne: 'Ghi nguyên văn…',
      formaKlient: 'Hình thức thu nhập — khách hàng {n}',
      katOpf: 'Đầu tư (quỹ / ETF / cổ phiếu)',
      klientEmail: 'Khách hàng {n} — email',
      klientJmeno: 'Khách hàng {n} — tên',
      klientN: 'Khách hàng {n}',
      klientTelefon: 'Khách hàng {n} — điện thoại',
      mamDnes: 'Hiện có',
      navrh: 'Đề xuất',
      nezbytne: 'Chi tiêu thiết yếu mỗi tháng',
      obvykle: 'Chi tiêu thường ngày mỗi tháng',
      ocekavani: 'Khách mong đợi gì (nguyên lời khách)',
      pasivni: 'Thu nhập thụ động',
      penize: 'Tiền bạc có ý nghĩa gì với khách? (nguyên lời khách)',
      penizePh: 'tự do, an tâm, bình yên, thời gian cho gia đình…',
      poznPrijmy: 'Ghi chú về thu nhập',
      predvyplnitZCrm: 'Nhấn để điền sẵn thông tin từ thẻ trong CRM',
      refTelefon: 'Điện thoại / liên lạc',
      refVztah: 'Quan hệ / ghi chú',
      vlastniPh: 'VD: sao kê quỹ hưu trí',
      vlastniPolozka: 'Mục khác',
      vydajePozn: 'Khoản trả nợ đã ở phần nợ — đừng tính lại. Chi tiêu thiết yếu là mức tối thiểu khi mất thu nhập.',
      zDomacnosti: 'Từ hộ gia đình:',
    },
    riziko: {
      evidovano: 'Đã ghi nhận',
      nezadano: 'Chưa nhập',
      proverit: 'Cần kiểm tra',
      vyreseno: 'Đã xử lý',
    },
    role: {
      dite: {
        m: 'Con trai',
        z: 'Con gái',
      },
      klient: {
        m: 'Khách hàng',
        z: 'Khách hàng',
      },
      manzel: {
        m: 'Chồng',
        z: 'Vợ',
      },
      partner: {
        m: 'Bạn đời',
        z: 'Bạn đời',
      },
    },
    sablona: {
      c1: 'Quỹ dự phòng thanh khoản bắt buộc',
      c2: 'Nhà ở / sửa chữa nhà',
      c3: 'Học vấn cho con / hành trang vào đời',
      c4: 'Tự do tài chính',
      d1: 'Thừa kế',
      f1: 'Công ty / kinh doanh',
      kz1: 'Bảo hiểm nhân thọ tích lũy',
      kz2: 'Bảo hiểm nhân thọ liên kết đầu tư',
      n1: 'Căn hộ / nhà ở',
      n2: 'Mặt bằng kinh doanh',
      n3: 'Đất / rừng / ruộng',
      n4: 'Ô tô / phương tiện',
      n5: 'Đồ có giá trị (đồng hồ, tranh, bộ sưu tập…)',
      n6: 'Vàng và kim loại quý',
      o1: 'Quỹ/ETF cổ phiếu',
      o2: 'Quỹ/ETF trái phiếu',
      o3: 'Quỹ/ETF thị trường tiền tệ',
      o4: 'Quỹ/ETF bất động sản và khác',
      o5: 'Cổ phiếu riêng lẻ',
      o6: 'Trái phiếu doanh nghiệp',
      o8: 'Tiền mã hóa',
      pj1: 'Bảo hiểm nhân thọ rủi ro',
      pj2: 'Bảo hiểm tai nạn',
      pj3: 'Bảo hiểm nhà / tài sản trong nhà',
      pj4: 'Bảo hiểm trách nhiệm',
      pj5: 'Bảo hiểm trách nhiệm / vật chất xe',
      pj6: 'Bảo hiểm chi phí pháp lý',
      pz1: 'Bảo hiểm hưu trí bổ sung kiểu cũ',
      pz2: 'Tiết kiệm hưu trí bổ sung',
      pz3: 'Sản phẩm đầu tư dài hạn',
      r1: 'Bảo hiểm nhà / công trình',
      r2: 'Bảo hiểm tài sản trong nhà',
      r3: 'Bảo hiểm trách nhiệm',
      r4: 'Bảo hiểm trách nhiệm xe cơ giới',
      r5: 'Bảo hiểm vật chất xe',
      s1: 'Tiết kiệm nhà ở',
      u1: 'Tiền gửi có kỳ hạn',
      u2: 'Tài khoản tiết kiệm',
      u3: 'Tài khoản thanh toán',
      u4: 'Tiền mặt để ở nhà',
      u5: 'Ngoại tệ',
      zb1: 'Vay mua nhà / vay nhà ở',
      zb2: 'Vay tiêu dùng',
      zb3: 'Thuê tài chính',
      zb4: 'Thẻ tín dụng',
      zo1: 'Vay kinh doanh',
      zo2: 'Vay tuần hoàn',
    },
    smluvFew: '{n} hợp đồng',
    smluvMany: '{n} hợp đồng',
    smluvOne: '{n} hợp đồng',
    tab: {
      bydleni: {
        celkem: 'Tổng nợ',
        konec: 'Kết thúc trả nợ',
        mesicne: 'Trả nợ hằng tháng',
        nadpis: 'Nhà ở',
        nejblizsi: 'Kỳ cố định lãi suất gần nhất',
        pocet: 'Khoản vay',
      },
      investicni: {
        celkem: 'Giá trị hiện tại',
        mesicne: 'Khoản góp định kỳ',
        nadpis: 'Hợp đồng đầu tư',
        nejblizsi: 'Ngày kỷ niệm hợp đồng gần nhất',
        pocet: 'Sản phẩm',
      },
      ostatni: {
        celkem: 'Các khoản vay khác',
        mesicne: 'Trả nợ hằng tháng',
        nadpis: 'Các khoản vay khác',
        nejblizsi: 'Hạn thanh toán gần nhất',
        pocet: 'Khoản vay',
      },
      pojistky: {
        mesicne: 'Phí bảo hiểm hằng tháng',
        nadpis: 'Hợp đồng bảo hiểm',
        nejblizsi: 'Ngày kỷ niệm hợp đồng gần nhất',
        pocet: 'Hợp đồng',
      },
    },
    tahak: {
      cile: {
        say1: 'Mình cùng xem các mục tiêu chiến lược của anh/chị theo cấu trúc CÁI GÌ – KHI NÀO – BAO NHIÊU.',
        say2: 'Anh/chị sẽ cần tiền cho việc gì? Khi nào cần đến tiền? Mục tiêu sẽ tốn bao nhiêu?',
        say3: 'Nếu khách không tự nhắc đến, luôn hỏi về: nhà ở, tương lai của con cái và tự do tài chính.',
        tip: 'Với mục tiêu mà khách đánh giá thấp, hãy mở Phim — con số sẽ nói thay cho việc thuyết phục.',
      },
      hodnoty: {
        say1: 'Nếu khách nói chẳng hạn là tự do, hãy hỏi: Tự do có ý nghĩa gì với anh/chị?',
        say2: 'Anh/chị còn nghĩ đến điều gì nữa? Vì sao điều đó quan trọng với anh/chị ngay lúc này?',
        say3: 'Câu nối: Nếu kế hoạch tài chính mang lại cho anh/chị {slovaKlienta}, đó có phải là giải pháp đúng cho anh/chị không?',
        tip: 'Đừng hỏi về số tiền. Ở đây quan trọng là lý do, không phải con số.',
      },
      ocekavani: {
        say1: 'Anh/chị mong đợi gì từ buổi gặp hôm nay?',
        say2: 'Nhắc lại lời của khách rồi nói tiếp: Mục tiêu của em là xem anh/chị đang làm tốt điều gì, chỗ nào có thể đang mất tiền và điều gì có thể làm tốt hơn.',
        tip: 'Ghi lại nguyên văn. Chính lời của khách sẽ dùng ở phần kết luận và trong buổi gặp sau.',
      },
      prijmy: {
        say1: 'Một nguồn lực quan trọng khác để đạt mục tiêu là thu nhập của anh/chị.',
        say2: 'Theo các con số đã nhập, anh/chị còn dư khoảng {castka}. Anh/chị thực sự sẵn sàng dành bao nhiêu lâu dài cho kế hoạch tài chính của mình?',
        tip: 'Số tiền dư đã thống nhất là con số của khách, không phải của tư vấn viên. Thà thấp hơn nhưng duy trì được lâu dài.',
      },
      rizika: {
        say1: 'Trong kế hoạch tài chính, mình cũng sẽ xem phần bảo vệ của anh/chị — đang có gì, bảo vệ được gì và chưa bảo vệ được gì.',
        say2: 'Mình kiểm tra xem có thể tiết kiệm hay mua bảo hiểm hợp lý hơn không, và cho anh/chị thấy phần bảo vệ nằm thế nào trong cả kế hoạch: gia đình, mục tiêu, quỹ dự phòng.',
        tip: 'Đừng đánh giá, đừng dọa. Chỉ ghi lại hiện trạng và những gì cần kiểm tra thêm.',
      },
      rodina: {
        say1: 'Qua điện thoại mình đã hẹn buổi gặp khoảng 45 phút. Phía em không có gì thay đổi. Em chỉ muốn hỏi lại, anh/chị cũng dành khoảng 45 phút phải không ạ?',
        say2: 'Trước hết em xin kiểm tra lại vài thông tin cơ bản về anh/chị và gia đình.',
        tip: 'Xác nhận thời gian ngay từ đầu — như vậy không ai phải nhìn đồng hồ.',
      },
      zavazky: {
        say1: 'Một thông tin quan trọng để đạt mục tiêu là các khoản nợ và hợp đồng anh/chị đang có.',
        say2: 'Trước hết mình xem các khoản vay mua nhà và các khoản vay khác, sau đó đến các hợp đồng đầu tư, hưu trí và bảo hiểm hiện có.',
        tip: 'Ngày hết kỳ lãi suất cố định và ngày kỷ niệm hợp đồng là thông tin quý nhất của cả buổi gặp — thiếu chúng thì không canh được thời điểm cho đề xuất.',
      },
      zaver: {
        say1: 'Anh/chị có nghĩ ra điều gì quan trọng mà em quên hỏi không?',
        say2: 'Giờ mình đã có đủ thông tin để xây dựng chiến lược tài chính và kế hoạch tài chính cho anh/chị.',
        say3: 'Ở buổi gặp sau, em sẽ trình bày: em đề xuất gì, chi phí bao nhiêu, các bước làm theo thứ tự nào và kế hoạch sẽ đưa anh/chị đến mục tiêu ra sao.',
        tip: 'Đừng đi vào giải pháp cụ thể. Hôm nay chỉ hẹn lịch và giấy tờ cần chuẩn bị.',
      },
      zdroje: {
        say1: 'Giờ mình đã biết các mục tiêu của anh/chị. Mình cùng xem anh/chị đang có những nguồn lực nào để đạt được chúng.',
        tip: 'Hỏi theo từng nhóm, đừng hỏi chung chung — nếu không khách sẽ quên mất một nửa.',
      },
    },
    typCile: {
      auto: 'Ô tô',
      bydleni: 'Nhà ở',
      deti: 'Tương lai của con',
      investice: 'Đầu tư',
      nezavislost: 'Tự do tài chính',
      ostatni: 'Mục tiêu khác',
      podnikani: 'Kinh doanh',
      podnikatelsky: 'Vay kinh doanh',
      rekonstrukce: 'Sửa chữa nhà',
      rezerva: 'Quỹ dự phòng',
      spotrebitelsky: 'Vay tiêu dùng',
      uver: 'Khoản vay',
    },
    vydajKat: {
      bydleni: 'Nhà ở (tiền thuê / phí chung cư / quỹ sửa chữa)',
      deti: 'Con cái, trường học, lớp năng khiếu',
      doprava: 'Đi lại / ô tô / phương tiện công cộng',
      dovolena: 'Du lịch nghỉ dưỡng (trung bình tháng)',
      energie: 'Năng lượng (điện, gas, nước)',
      jidlo: 'Ăn uống và sinh hoạt',
      ostatni: 'Khác',
      pojisteni: 'Bảo hiểm (ngoài các khoản trả nợ)',
      predplatne: 'Gói đăng ký và dịch vụ',
      telekom: 'Điện thoại, internet, TV',
      volnyCas: 'Giải trí, sở thích, nhà hàng',
      zdravi: 'Sức khỏe, thuốc men, đồ vệ sinh',
    },
    zaver: {
      bezTerminu: 'Mình chưa hẹn ngày cho buổi gặp tiếp theo. Khi đã hẹn, mình sẽ cùng xem kế hoạch đã chuẩn bị.',
      sTerminem: 'Em sẽ chuẩn bị kế hoạch và mình cùng xem lại ở buổi gặp tiếp theo vào {kdy}.',
      vHodin: '{cas} ngày {datum}',
    },
  },
  /* BLOK:analyzaPrezentace END */
  /* BLOK:planKlient START — generuje scratchpad/slovnik.py, ručně needitovat */
  planKlient: {
    letFew: '{n} năm',
    letMany: '{n} năm',
    letOne: '{n} năm',
    metodika: 'Cách đạt mục tiêu: lợi suất thực trên lạm phát theo loại tài sản (cổ phiếu {akcie} / trái phiếu {dluhopisy} / tiền mặt {cash} %/năm, giảm rủi ro dần khi gần đến mục tiêu). Số tiền bảo hiểm: phương pháp vốn @ 4 % thực. Trợ cấp xã hội (trợ cấp cho người góa, trợ cấp mồ côi tính chung cho cả gia đình, lương hưu mất sức lao động) chỉ là ƯỚC TÍNH THAM KHẢO theo mẫu — không phải cam kết của nhà nước; tư vấn viên sẽ kiểm tra lại. Tư vấn viên là người quyết định cuối cùng.',
    shrnuti: {
      podtitul: 'Ba nguồn tiền ở trên, mỗi mục tiêu một dòng. Các con số giống hệt trong Đề xuất giải pháp.',
      rozdavej: 'Phân bổ nguồn tiền ngay trong bảng cho đến khi cả hai nguồn đều hiện „Còn lại 0“.',
    },
    tahak: 'Ghi chú cho tư vấn viên',
    uvod: {
      dobraCile: 'Tin thứ nhất là tin tốt: [[các mục tiêu của bạn sẽ đạt được.]]',
      dobraPlan: 'Tin tốt: [[bạn đã có kế hoạch.]]',
      lepsiCesta: 'Tin còn tốt hơn: bạn đến đó [[bằng con đường an toàn hơn]].',
      lepsiDrive: 'Tin còn tốt hơn: bạn có thể sống bằng dòng tiền từ vốn [[chỉ sau {za}]] — sớm hơn {o}.',
      rentaNa: 'Dòng tiền hưu trí hiện đạt [[{pct} %]] — và chúng ta thấy rõ cần làm gì.',
      rentaNezadana: 'Mục tiêu dòng tiền hưu trí chưa được đặt.',
    },
  },
  /* BLOK:planKlient END */
  /* BLOK:denniCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  denniCrm: {
    chybaPopis: 'Dữ liệu vẫn còn — chỉ là hiện chưa kết nối được với máy chủ.',
    klientiNenacteno: 'Không tải được danh sách khách hàng',
    nacitam: 'Đang tải…',
    obchodyNenacteno: 'Không tải được danh sách giao dịch',
    offlineKopie: 'bản sao ngoại tuyến lúc {cas}',
    offlineKopieBezCasu: 'bản sao ngoại tuyến',
    zavritZalozku: 'Đóng thẻ {nazev}',
    zkusitZnovu: 'Thử lại',
  },
  /* BLOK:denniCrm END */
  /* BLOK:nastrojeBezSlibu START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastrojeBezSlibu: {
    namitkaRizikoOdpoved: 'Tôi hoàn toàn hiểu. Rủi ro có thể giảm, nhưng không ai có thể hứa trước với anh/chị mức sinh lời cao hơn lạm phát. Tôi sẽ giới thiệu các lựa chọn thận trọng — tài khoản tiết kiệm, quỹ trái phiếu, quỹ hưu trí thận trọng — và với mỗi lựa chọn, thực tế có thể kỳ vọng đến đâu. Anh/chị tự chọn điều phù hợp.',
    pojisteniVkladu: 'Bảo hiểm tiền gửi',
  },
  /* BLOK:nastrojeBezSlibu END */
  /* BLOK:penzeBezKavy START — generuje scratchpad/slovnik.py, ručně needitovat */
  penzeBezKavy: {
    aRentu: 'và khoản lương hưu hằng tháng',
    podleModeluVDuchodu: 'Theo mô hình, khi nghỉ hưu anh/chị tích lũy được',
  },
  /* BLOK:penzeBezKavy END */
  /* BLOK:funnelReference START — generuje scratchpad/slovnik.py, ručně needitovat */
  funnelReference: {
    sablona: '[Chèn lời chứng thực thật của khách hàng vào đây, khi có sự đồng ý của họ]',
    titul: 'Lời chứng thực (chỉ dùng lời thật, có sự đồng ý của khách hàng)',
  },
  /* BLOK:funnelReference END */
  /* BLOK:ikony START — generuje scratchpad/slovnik.py, ručně needitovat */
  ikony: {
    aktivita: {
      cesta: 'Lộ trình',
      dopis: 'Thư',
      email: 'Email',
      hotovo: 'Hoàn thành',
      misto: 'Địa điểm',
      narozeniny: 'Sinh nhật',
      obchod: 'Giao dịch',
      pripominka: 'Lời nhắc',
      radar: 'Radar cơ hội',
      schuzka: 'Cuộc hẹn',
      servis: 'Mốc chăm sóc hợp đồng',
      sms: 'SMS',
      telefonat: 'Cuộc gọi',
      udalost: 'Sự kiện',
      ukol: 'Nhiệm vụ',
      whatsapp: 'WhatsApp',
    },
    cil: {
      auto: 'Ô tô',
      budoucnostDeti: 'Tương lai của con',
      bydleni: 'Nhà ở',
      investice: 'Đầu tư',
      nezavislost: 'Tự do tài chính',
      obecny: 'Mục tiêu',
      ostatni: 'Mục tiêu khác',
      podnikani: 'Kinh doanh',
      podnikatelskyUver: 'Vay kinh doanh',
      rekonstrukce: 'Cải tạo nhà',
      rezerva: 'Quỹ dự phòng',
      spotrebitelskyUver: 'Vay tiêu dùng',
      uver: 'Khoản vay',
    },
    produkt: {
      analyza: 'Phân tích',
      hypoteka: 'Vay thế chấp',
      investice: 'Đầu tư',
      jine: 'Khác',
      penzijko: 'Tiết kiệm hưu trí',
      pojisteni_auta: 'Bảo hiểm ô tô',
      pojisteni_majetek: 'Bảo hiểm tài sản',
      pojisteni_odpovednost: 'Bảo hiểm trách nhiệm',
      pojisteni_ostatni: 'Bảo hiểm khác',
      pojisteni_zivot: 'Bảo hiểm nhân thọ',
      rezerva: 'Quỹ dự phòng',
      stavebni: 'Tiết kiệm xây dựng',
      uver: 'Khoản vay',
      zdravotni: 'Bảo hiểm sức khỏe',
    },
    profil: {
      dynamicky: 'Năng động',
      konzervativni: 'Thận trọng',
      vyvazeny: 'Cân bằng',
    },
    riziko: {
      dite: 'Bảo hiểm cho con',
      hospitalizace: 'Nằm viện',
      invalidita: 'Mất sức lao động',
      odskodne: 'Trợ cấp tai nạn theo ngày',
      pn: 'Nghỉ ốm dài ngày',
      rodicovska: 'Nghỉ thai sản',
      smrt: 'Tử vong',
      stari: 'Tuổi già',
      tnu: 'Di chứng vĩnh viễn do tai nạn',
      zavazne: 'Bệnh hiểm nghèo',
    },
    stav: {
      chyba: 'Lỗi',
      info: 'Thông tin',
      ok: 'Ổn',
      pozor: 'Lưu ý',
    },
  },
  /* BLOK:ikony END */
  /* BLOK:vzorkovna START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzorkovna: {
    ikony: {
      doplnky: 'Hình vẽ bổ sung',
      doplnkyPopis: 'Những gì lucide không có. Lấy kèm giấy phép.',
      mena: 'Tiền tệ theo quốc gia của tài khoản',
      velikosti: 'Kích thước và trạng thái đã chọn',
      vybrany: 'Đã chọn',
    },
    motivNahledu: 'Xem trước theo giao diện',
    motivy: {
      kino: 'Màn hình trình chiếu',
      popis: 'Tổng quan mục tiêu và quỹ dự phòng',
      titulek: 'Kế hoạch tài chính',
      tlacitko: 'Lưu',
    },
    nadpis: 'Mẫu giao diện',
    obsah: 'Nội dung',
    pismo: {
      cisla: 'Số thẳng hàng',
      jazyky: 'Năm ngôn ngữ, một phông chữ',
      nadpisUkazka: 'Kế hoạch tài chính gia đình',
      nadpisy: 'Tiêu đề',
      stupnice: 'Thang cỡ chữ',
      ukazka: 'Quỹ dự phòng đủ cho sáu tháng chi tiêu của gia đình.',
    },
    prazdny: {
      akce: 'Lên lịch cuộc hẹn',
      kratky: 'Chưa có nhiệm vụ nào.',
      text: 'Hôm nay bạn chưa có cuộc hẹn nào.',
    },
    sekce: {
      ikony: 'Biểu tượng trong nhãn',
      motivy: 'Sáu giao diện',
      pismo: 'Phông chữ',
      prazdny: 'Trạng thái trống',
      stavy: 'Trạng thái',
      tokeny: 'Màu sắc',
      vystup: 'Bộ biểu đồ đầu ra',
    },
    skupina: {
      aktivity: 'Hoạt động',
      cile: 'Mục tiêu',
      produkty: 'Sản phẩm',
      profily: 'Hồ sơ đầu tư',
      rizika: 'Rủi ro',
      stavy: 'Trạng thái',
    },
    stavy: {
      bezTextu: 'Không có chữ',
      chyba: 'Không lưu được thay đổi',
      ikona: 'Biểu tượng',
      info: 'Dữ liệu từ buổi gặp trước',
      ok: 'Quỹ dự phòng đủ cho 6 tháng chi tiêu',
      pozor: 'Thiếu bảo hiểm mất sức lao động',
      stitek: 'Nhãn',
      tecka: 'Chấm',
    },
    stitek: 'Design lab · xem trước nội bộ',
    tokeny: {
      akcent: 'Màu nhấn',
      kategorie: 'Danh mục',
      plochy: 'Nền',
      stavy: 'Trạng thái',
      text: 'Chữ',
    },
    uvod: 'Phông chữ, màu sắc, biểu tượng và trạng thái ở một nơi. Các màn hình chỉ dùng những gì có ở đây.',
    zpet: 'Quay lại',
  },
  /* BLOK:vzorkovna END */
  /* BLOK:novyCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  novyCrm: {
    akce: {
      otevrit: 'Mở: {nazev}',
      otevritVAppce: 'Mở trong CRM hiện tại',
      vPrototypu: 'Chưa có trong bản thử',
      zkusitZnovu: 'Thử lại',
      zobrazitDalsi: 'Hiện thêm {n}',
      zrusitFiltr: 'Bỏ bộ lọc',
    },
    aktivita: {
      dopis: 'Thư',
      email: 'Email',
      schuzka: 'Cuộc hẹn',
      telefonat: 'Cuộc gọi',
      udalost: 'Sự kiện',
      ukol: 'Việc cần làm',
    },
    analyza: {
      bezAnalyzy: 'Chưa có bản phân tích. Hãy tạo trong ứng dụng hiện tại, sau đó toàn bộ sẽ hiện ở đây.',
      chybaBloku: 'Không tính được phần này của bản phân tích',
      chybi: {
        cil: 'Mục tiêu “{nazev}”: bổ sung {co}',
        dalsiNaRade: 'tiếp theo',
        dalsichFew: 'và {n} mục khác trong ứng dụng',
        dalsichMany: 'và {n} mục khác trong ứng dụng',
        dalsichOne: 'và {n} mục khác trong ứng dụng',
        deti: 'Dòng thông tin con không có tên và ngày sinh sẽ không được tính',
        faze: 'Các phần của bản phân tích',
        fazeSouhrn: 'Đã xong {n}/{celkem} phần của bản phân tích',
        hotovo: 'Bản phân tích đã đầy đủ, không thiếu gì',
        nadpis: 'Còn thiếu gì',
        nezbytne: 'Chi tiêu thiết yếu — thiếu thì không có phân bổ 50 / 30 / 20 và nhu cầu bảo vệ',
        partner: 'Đã điền thu nhập của vợ/chồng nhưng người này chưa có trong bản phân tích (thiếu tên hoặc ngày sinh)',
        rezerva: 'Tài khoản và tiền mặt — thiếu thì không tính được quỹ dự phòng',
        zadnaPolozka: 'Không thiếu mục cụ thể nào — hãy hoàn thành các phần còn lại',
        zajisteni: 'Chưa tính được bảo vệ thu nhập — thiếu: {co}',
        zavaznost: {
          nizka: 'Chi tiết nhỏ',
          stredni: 'Cần bổ sung',
          vysoka: 'Quan trọng',
        },
      },
      chybiUdajuFew: 'Thiếu {n} mục',
      chybiUdajuMany: 'Thiếu {n} mục',
      chybiUdajuOne: 'Thiếu {n} mục',
      cile: {
        chybi: 'thiếu {co}',
        mesicne: '{mena}/tháng',
        pocetFew: '{n} mục tiêu theo thời hạn',
        pocetMany: '{n} mục tiêu theo thời hạn',
        pocetOne: '{n} mục tiêu theo thời hạn',
        uverem: 'bằng khoản vay',
      },
      doplnitVAppce: 'Bổ sung trong ứng dụng',
      faze: {
        cile: 'Mục tiêu',
        hodnoty: 'Giá trị',
        prijmy: 'Thu nhập và chi tiêu',
        rizika: 'Rủi ro',
        uvod: 'Giới thiệu',
        zavazky: 'Nghĩa vụ',
        zdroje: 'Nguồn lực',
      },
      majetek: {
        budouci: 'Thừa kế và tài sản tương lai',
        budouciStitek: 'trong tương lai · chưa tính',
        cisteJmeni: 'tài sản ròng (tài sản hiện nay − nợ)',
        dluhy: 'nợ (dư nợ)',
        dnes: 'tài sản hiện nay',
        dsti: 'tiền trả nợ chiếm {pct} % thu nhập',
        fixace: 'kỳ cố định lãi suất gần nhất {datum}',
        nadpis: 'Tài sản và nợ',
        prazdno: 'Chưa ghi nhận tài sản hay khoản nợ nào',
        splatky: 'trả nợ {castka} mỗi tháng',
        uveruFew: '{n} khoản vay',
        uveruMany: '{n} khoản vay',
        uveruOne: '{n} khoản vay',
        vysokeZadluzeni: 'Nợ cao (trên 40 % thu nhập)',
      },
      menaJina: 'Bản phân tích được lập bằng {mena}',
      menaStara: 'Bản phân tích cũ không có tiền tệ — số liệu tính bằng {mena}',
      nadpis: 'Phân tích',
      penize: {
        chybiDo20: 'Còn thiếu {castka} mỗi tháng để đạt mức lý tưởng 20 %',
        nadpis: 'Thu nhập và chi tiêu',
        odklada: 'Để dành {pct} % thu nhập · lý tưởng 20 % = {castka}',
        rozpadBezNezbytnych: 'Phân bổ 50 / 30 / 20 sẽ hiện khi đã nhập chi tiêu thiết yếu.',
        splneno: 'Để dành mức lý tưởng 20 % thu nhập trở lên',
      },
      rezerva: {
        bezVydaju: 'Chưa có chi tiêu thiết yếu nên không tính được quỹ dự phòng đủ bao nhiêu tháng',
        castkaPopisek: 'trong tài khoản và tiền mặt',
        dnes: 'Quỹ dự phòng hiện nay',
        doporuceno: 'Khuyến nghị {n} tháng',
        grafPopis: 'Quỹ dự phòng đủ cho {n} tháng trên mức khuyến nghị {cil}',
        jednotka: 'tháng',
        mesicuPopisek: 'số tháng chi tiêu thiết yếu và trả nợ mà quỹ đủ trang trải',
        nadpis: 'Quỹ dự phòng',
        nezapsana: 'Chưa ghi nhận tài khoản và tiền mặt',
        stav: {
          reserve_low: 'Dưới 3 tháng',
          reserve_mid: 'Bổ sung lên 6 tháng',
          reserve_ok: 'Ít nhất 6 tháng',
        },
      },
      rodina: {
        bezDeti: 'chưa có con',
        detiFew: '{n} con',
        detiMany: '{n} con',
        detiOne: '{n} con',
        dospelychFew: '{n} người lớn',
        dospelychMany: '{n} người lớn',
        dospelychOne: '{n} người lớn',
        nadpis: 'Gia đình và hồ sơ',
        prazdno: 'Chưa điền thông tin gia đình trong bản phân tích',
        prijem: 'thu nhập {castka} mỗi tháng',
        vekNezadany: 'chưa nhập tuổi',
      },
      upraveno: 'Cập nhật {datum}',
      upravitVAppce: 'Sửa trong ứng dụng',
      zacit: 'Bắt đầu phân tích trong ứng dụng',
      zajisteni: {
        bezDiry: 'Thu nhập hằng tháng đã được bảo vệ',
        dira: 'Mỗi tháng thiếu {castka}',
        domacnost: 'Bảo vệ cho cả gia đình',
        mesicne: 'Khi mất sức lao động: gia đình cần {potreba} mỗi tháng · còn lại {zustane} · nhà nước chi {stat}',
      },
      zpetNaKlienta: 'Quay lại khách hàng',
    },
    cas: {
      dnes: 'hôm nay',
      predFew: '{n} ngày trước',
      predMany: '{n} ngày trước',
      predOne: '{n} ngày trước',
      vcera: 'hôm qua',
    },
    cesta: {
      hotovo: 'xong',
      krokZ: '{n}/{celkem}',
      kroky: {
        analyza: 'Phân tích',
        plan: 'Kế hoạch',
        predstaveni: 'Giới thiệu',
        realizace: 'Triển khai',
        servis: 'Chăm sóc',
      },
      nadpis: 'Hành trình khách hàng',
      vseHotovo: 'Đã xong tất cả các bước',
      ziskani: 'Tiếp cận · trước buổi gặp đầu tiên',
      ztraceno: 'Đã mất',
    },
    chyba: {
      aktivity: 'Không tải được ghi chú và công việc',
      analyza: 'Không tải được phân tích',
      analyzaTvar: 'Dữ liệu phân tích có định dạng không mong đợi',
      cile: 'Không tải được kế hoạch',
      fixace: 'Không tải được kỳ cố định lãi suất',
      klient: 'Không tải được khách hàng',
      klienti: 'Không tải được danh sách khách hàng',
      obchody: 'Không tải được giao dịch',
      obecne: 'Không tải được dữ liệu',
      pipeline: 'Không tải được tổng hợp giao dịch',
      plan: 'Không tải được đề xuất giải pháp',
      radar: 'Không tải được radar cơ hội',
      rizika: 'Không tính được nhu cầu bảo vệ',
      ukoly: 'Không tải được lịch',
    },
    diar: {
      aDalsichFew: 'và {n} việc khác',
      aDalsichMany: 'và {n} việc khác',
      aDalsichOne: 'và {n} việc khác',
      agenda: 'Lịch trong ngày',
      akciFew: '{n} hoạt động',
      akciMany: '{n} hoạt động',
      akciOne: '{n} hoạt động',
      bezCasu: 'Không có giờ',
      celyDen: 'cả ngày',
      dalsiTyden: 'Tuần sau',
      drive: 'Sớm hơn',
      drivePocet: 'Sớm hơn: {n}',
      hodiny: 'Các giờ trong ngày',
      hotovo: 'đã xong',
      minut: '{n} phút',
      naDnes: 'Hôm nay',
      naplanovat: 'Lên lịch trong lịch',
      nejblizsi: 'sắp tới',
      nicPoTerminu: 'Không có việc quá hạn',
      odskrtnout: 'Đánh dấu đã xong',
      otevrit: 'Mở trong lịch',
      otevritPolozku: 'Mở trong lịch',
      poTerminu: 'Quá hạn',
      poTerminuPocetFew: '{n} quá hạn',
      poTerminuPocetMany: '{n} quá hạn',
      poTerminuPocetOne: '{n} quá hạn',
      pozdeji: 'Muộn hơn',
      pozdejiPocet: 'Muộn hơn: {n}',
      prazdnoDen: 'Ngày này chưa có lịch',
      prazdnoDnes: 'Hôm nay chưa có lịch',
      predchoziTyden: 'Tuần trước',
      schuzekFew: '{n} cuộc hẹn',
      schuzekMany: '{n} cuộc hẹn',
      schuzekOne: '{n} cuộc hẹn',
      souhrn: 'Tóm tắt ngày',
      souhrnPoTerminu: 'quá hạn của mọi ngày',
      souhrnSchuzky: 'cuộc hẹn',
      souhrnUkoly: 'công việc, cuộc gọi và e-mail',
      tyden: 'Tuần',
      typ: {
        dopis: 'Thư',
        email: 'E-mail',
        poznamka: 'Ghi chú',
        schuzka: 'Cuộc hẹn',
        telefonat: 'Cuộc gọi',
        udalost: 'Sự kiện',
        ukol: 'Công việc',
      },
      ukoluFew: '{n} công việc',
      ukoluMany: '{n} công việc',
      ukoluOne: '{n} công việc',
    },
    faze: {
      a1: 'Giới thiệu',
      a2: 'Phân tích',
      calling: 'Gọi điện',
      done: 'Hoàn tất',
      lead: 'Khách tiềm năng',
      lost: 'Đã mất',
      p1: 'Kế hoạch tài chính',
      p2: 'Trình bày',
      servis: 'Chăm sóc',
      signed: 'Đã ký',
    },
    fazeObchodu: {
      analyza: 'Phân tích',
      cerpani: 'Giải ngân',
      podpis: 'Ký kết',
      proces: 'Đang xử lý',
    },
    graf: {
      oblouk: {
        nastavit: 'Đặt kế hoạch trong ứng dụng',
        nenastaveno: 'Chưa đặt kế hoạch',
        popisek: 'Tiến độ kế hoạch BJ',
        zPlanu: '{bj}/{plan} BJ',
      },
      rozpad: {
        cile: 'Mục tiêu',
        nezbytne: 'Thiết yếu',
        zivotniStyl: 'Lối sống',
      },
      trychtyr: {
        popis: 'Giao dịch đang mở theo giai đoạn',
      },
    },
    hlavicka: {
      hledat: 'Tìm khách hàng ({zkratka})',
    },
    klient: {
      aktivity: {
        bezDalsiho: 'Chưa lên lịch bước tiếp theo',
        dalsiKrok: 'Bước tiếp theo',
        diar: 'Mở lịch',
        nadpis: 'Ghi chú và bước tiếp theo',
        naplanovat: 'Lên lịch trong lịch',
        napsat: 'Viết ghi chú',
        posledni: 'Hoạt động gần đây',
        zadne: 'Chưa có ghi chú hay hoạt động',
      },
      analyza: 'Phân tích',
      bezAnalyzy: 'Chưa có phân tích. Cân đối, mục tiêu và tài sản sẽ hiện khi bạn điền phân tích.',
      bezUdaju: 'Chưa nhập tuổi và thành phố',
      bilance: 'Cân đối thu chi',
      bilancePrazdna: 'Chưa điền thu nhập và chi tiêu',
      cile: {
        bezCastkyFew: '{n} mục tiêu chưa có số tiền',
        bezCastkyMany: '{n} mục tiêu chưa có số tiền',
        bezCastkyOne: '{n} mục tiêu chưa có số tiền',
        bezNazvu: 'Mục tiêu chưa đặt tên',
        bezTerminu: 'chưa có thời hạn',
        chybi: 'Còn thiếu',
        cil: 'Mục tiêu',
        cilKlienta: 'mục tiêu {castka}',
        dalsichFew: 'và {n} mục tiêu khác trong đề xuất',
        dalsichMany: 'và {n} mục tiêu khác trong đề xuất',
        dalsichOne: 'và {n} mục tiêu khác trong đề xuất',
        definice: 'Đã có = tiền hiện có tính đến thời hạn mục tiêu.',
        dnes: 'ngay',
        grafPopis: '{nazev}: đã có {uzMa} trên {cil}',
        jenBezCastkyFew: 'Mục tiêu chưa có số tiền ({n})',
        jenBezCastkyMany: 'Mục tiêu chưa có số tiền ({n})',
        jenBezCastkyOne: 'Mục tiêu chưa có số tiền ({n})',
        nadpis: 'Mục tiêu',
        prazdno: 'Chưa nhập mục tiêu',
        regulace: 'Tổng quan tham khảo theo kế hoạch, không phải chào bán.',
        renta: 'thu nhập thụ động {castka} mỗi tháng',
        uverem: 'vốn tự có cho khoản vay',
        uzMa: 'Đã có',
        vlastniZdroje: 'Vốn tự có',
        zaFew: 'sau {n} năm',
        zaMany: 'sau {n} năm',
        zaOne: 'sau {n} năm',
      },
      doplnitVAnalyze: 'Bổ sung trong phân tích',
      kategorie: 'Hạng {k}',
      kontaktNezadany: 'Chưa nhập điện thoại và e-mail',
      krok: {
        analyza: 'Phân tích',
        navrh: 'Đề xuất giải pháp',
        plan: 'Kế hoạch',
        prezentace: 'Trình bày',
      },
      majetek: {
        celkem: 'tổng cộng',
        dluhy: 'Nợ: {castka}',
        grafPopis: 'Tổng tài sản {celkem}: {dily}',
        kategorie: {
          firma: 'Doanh nghiệp',
          kzp: 'Bảo hiểm nhân thọ có tích lũy',
          nemovitosti: 'Bất động sản và ô tô',
          opf: 'Quỹ và cổ phiếu',
          ostatni: 'Khác',
          penzijko: 'Tiết kiệm hưu trí',
          stavebko: 'Tiết kiệm xây dựng',
          ucty: 'Tài khoản và tiền mặt',
        },
        nadpis: 'Tài sản',
        prazdno: 'Chưa ghi nhận tài sản',
      },
      nadpis: 'Khách hàng',
      napsat: 'Gửi e-mail: {email}',
      nenalezen: 'Không tìm thấy khách hàng trong CRM — có thể đã bị xóa.',
      neuplnaData: 'Một phần dữ liệu phân tích có định dạng không mong đợi',
      obchody: {
        bezBj: 'Chưa nhập BJ',
        nadpis: 'Giao dịch của khách hàng',
        novy: 'Giao dịch mới trong ứng dụng',
        prazdno: 'Khách hàng chưa có giao dịch đang mở',
        vsechny: 'Tất cả giao dịch',
      },
      otevritAnalyzu: 'Mở phân tích',
      otevritNavrh: 'Mở đề xuất giải pháp',
      otevritPlan: 'Mở kế hoạch',
      pokracovat: 'Tiếp tục: {krok}',
      prijmy: 'thu nhập mỗi tháng',
      profil: 'Hồ sơ',
      regulace: 'Tổng quan tham khảo từ phân tích, không phải chào bán.',
      rizika: {
        chybi: {
          horizont: 'thời hạn bảo vệ',
          pozustalostni: 'trợ cấp cho người thân',
          prijem: 'thu nhập',
          vydaje: 'chi tiêu thiết yếu',
        },
        chybiCastka: 'còn thiếu {castka} so với mức bảo vệ khuyến nghị',
        domacnost: 'hộ gia đình',
        grafPopis: '{riziko}, {kdo}: hợp đồng hiện có {kryti} trên mức bảo vệ khuyến nghị {potreba}',
        invalidita: 'Mất sức lao động',
        klient1: 'Khách hàng',
        klient2: 'Vợ/chồng',
        kryti: 'Hợp đồng hiện có',
        krytiSpolecne: 'hợp đồng chưa gắn người — trong phân tích, ở phần Rủi ro trong hợp đồng, hãy chọn thuộc về ai',
        model: 'Mức bảo vệ khuyến nghị do công cụ tính của bản phân tích đưa ra (phương pháp vốn) — mô hình, không phải chào bán. Kế hoạch hiển thị số tiền bảo hiểm của phương án đã chọn trong Đề xuất, nên có thể khác.',
        nadpis: 'Bảo vệ thu nhập',
        nelzeSpocitat: 'Chưa thể tính nhu cầu bảo vệ. Còn thiếu: {co}.',
        pokryto: 'đã đủ',
        potreba: 'Mức bảo vệ khuyến nghị',
        prazdno: 'Phân tích chưa có nhu cầu bảo vệ và hợp đồng hiện có',
        radek: 'Mức bảo vệ khuyến nghị {potreba} · hợp đồng hiện có {kryti}',
        smrt: 'Tử vong',
      },
      splatky: 'trả nợ mỗi tháng',
      vekFew: '{n} tuổi',
      vekMany: '{n} tuổi',
      vekOne: '{n} tuổi',
      volneCf: 'dòng tiền tự do mỗi tháng',
      vydaje: 'chi tiêu mỗi tháng',
      zacitAnalyzu: 'Bắt đầu phân tích',
      zavolat: 'Gọi: {cislo}',
      zpet: 'Quay lại danh sách khách hàng',
    },
    klienti: {
      bezJmena: 'Không có tên',
      filtr: {
        faze: 'Giai đoạn',
        kategorie: 'Hạng',
        produkt: 'Sản phẩm',
        vse: 'Tất cả',
      },
      hledat: 'Tìm tên, điện thoại, email…',
      hledatPopisek: 'Tìm khách hàng',
      kpi: {
        bezKontaktu: 'Chưa liên hệ trên 90 ngày',
        celkem: 'Tổng cộng',
        podepsano: 'Đã ký tháng này',
        skupina: 'Bộ lọc nhanh',
        vBehu: 'Đang xử lý',
      },
      nalezenoFew: 'Tìm thấy {n} khách hàng',
      nalezenoMany: 'Tìm thấy {n} khách hàng',
      nalezenoOne: 'Tìm thấy {n} khách hàng',
      odebratFiltr: 'Bỏ lọc: {nazev}',
      odhad: 'ước tính',
      otevrit: 'Mở khách hàng: {jmeno}',
      popis: 'Danh sách khách hàng',
      prazdno: 'Chưa có khách hàng nào',
      pridat: 'Thêm trong ứng dụng',
      seznam: 'Tất cả khách hàng',
      skupina: {
        klient: 'Khách hàng',
        proces: 'Đang xử lý',
        ziskani: 'Tìm kiếm',
        ztraceno: 'Đã mất',
      },
      sloupec: {
        akce: 'Mở',
        bj: 'BJ',
        dalsiKrok: 'Bước tiếp theo',
        faze: 'Giai đoạn',
        klient: 'Khách hàng',
        kontakt: 'Liên hệ gần nhất',
        produkty: 'Sản phẩm',
      },
      vymazat: 'Xóa tìm kiếm',
      zrusitVse: 'Bỏ tất cả',
    },
    legendaObchodu: {
      plna: 'Đang giải ngân',
      srafa: 'Đang xử lý',
      tecky: 'Quan tâm',
    },
    nastroje: {
      cekani: {
        cenaPopisek: 'số tiền ít hơn khi đến mục tiêu nếu bắt đầu muộn {roky}',
        dohnat: 'Để bắt kịp cần để dành',
        grafPopis: 'Mô hình: bắt đầu ngay sẽ có {hned} sau {roky}; nếu chờ sẽ có {pozdeji}.',
        hned: 'Bắt đầu ngay',
        horizont: 'Mục tiêu sau',
        legendaModel: 'Nét chấm = phép tính mô hình',
        letFew: '{n} năm',
        letMany: '{n} năm',
        letOne: '{n} năm',
        mesicne: 'Đầu tư mỗi tháng',
        mesicnePole: 'Số tiền mỗi tháng',
        model: 'Mô hình với lợi nhuận cố định {pct} % mỗi năm, chưa gồm phí và thuế — không phải cam kết. Với lợi nhuận {od}–{do} %, cái giá là {nizsi} đến {vyssi}.',
        nadpis: 'Cái giá của sự chờ đợi',
        neplatne: 'Thời gian chờ phải ngắn hơn thời gian đến mục tiêu.',
        neposlano: 'Khoản chưa góp',
        nominalne: 'Số tiền danh nghĩa, chưa tính lạm phát',
        odklad: 'Bắt đầu muộn hơn',
        otazka: 'Khách hàng mất bao nhiêu nếu chờ rồi mới đầu tư định kỳ?',
        pasmo: 'Khoảng: lợi nhuận {od}–{do} %',
        pozdeji: 'Bắt đầu sau {roky}',
        ukazka: 'Bản mẫu',
        uslyVynos: 'Lợi nhuận bị mất',
        vynos: 'Lợi nhuận kỳ vọng',
        vynosText: '{pct} % mỗi năm',
        zaLetFew: 'sau {n} năm',
        zaLetMany: 'sau {n} năm',
        zaLetOne: 'sau {n} năm',
        zaMesic: 'mỗi tháng',
      },
      dlazdice: {
        finMatematika: {
          nazev: 'Toán tài chính',
          popis: 'Khoản vay, đầu tư và niên kim — tính bất kỳ giá trị nào.',
        },
        funnely: {
          nazev: 'Thư viện phễu',
          popis: 'Các phễu có sẵn và công cụ soạn yêu cầu.',
        },
        historicka: {
          nazev: 'Máy tính lịch sử',
          popis: 'Tiền của khách hàng sẽ tăng thế nào trên thị trường thực từ năm 1926.',
        },
        hypoteky: {
          nazev: 'Vay mua nhà',
          popis: 'Các hồ sơ vay mua nhà đang xử lý ở một nơi.',
        },
        investicniStrategie: {
          nazev: 'Chiến lược đầu tư',
          popis: 'Các chiến lược nổi tiếng và sức mạnh lãi kép.',
        },
        investicniStudio: {
          nazev: 'Phòng đầu tư',
          popis: 'Danh mục hiện tại và sau đề xuất, khủng hoảng và chi phí.',
        },
        kalkulacky: {
          nazev: 'Máy tính',
          popis: 'Vay mua nhà, đầu tư và các phép tính nhanh khác.',
        },
        mapa: {
          nazev: 'Bản đồ khách hàng',
          popis: 'Khách hàng trên bản đồ và đường đến cuộc hẹn.',
        },
        penze: {
          nazev: 'Máy tính hưu trí',
          popis: 'Khách hàng tích lũy được bao nhiêu cho hưu trí và nhà nước hỗ trợ bao nhiêu.',
        },
        provize: {
          nazev: 'Hoa hồng',
          popis: 'Giao dịch mang lại bao nhiêu BJ và tiền.',
        },
        radar: {
          nazev: 'Radar cơ hội',
          popis: 'Khách hàng còn thiếu bảo vệ hoặc tài chính.',
        },
      },
      novyStyl: 'Máy tính theo phong cách mới',
      proMe: 'Cho tôi',
      uStolu: 'Dùng với khách hàng',
    },
    nav: {
      diar: 'Lịch',
      hlavni: 'Điều hướng CRM mới',
      klienti: 'Khách hàng',
      nastroje: 'Công cụ',
      obchody: 'Giao dịch',
      poradce: 'Tư vấn viên đang đăng nhập: {jmeno}',
      prehled: 'Tổng quan',
      preskocit: 'Chuyển đến nội dung',
      rezimSvetly: 'Chuyển sang chế độ sáng',
      rezimTmavy: 'Chuyển sang chế độ tối',
      znacka: 'CRM mới – tổng quan',
      zpet: 'Quay lại CRM hiện tại',
      zpetKratce: 'Về CRM',
    },
    nazev: 'CRM mới',
    nenalezeno: {
      akce: 'Về tổng quan',
      nadpis: 'Không tìm thấy trang',
      text: 'Địa chỉ này không có trong CRM mới.',
    },
    obchody: {
      bezKlienta: 'Chưa có khách hàng',
      bezNazvu: 'Giao dịch chưa đặt tên',
      dnyFew: '{n} ngày ở giai đoạn này',
      dnyMany: '{n} ngày ở giai đoạn này',
      dnyOne: '{n} ngày ở giai đoạn này',
      dnyZkratka: '{n} ngày',
      fazeVyber: 'Giai đoạn giao dịch',
      kpi: {
        bjVBehu: 'BJ đang xử lý',
        cekaPodpis: 'Chờ ký',
        pocetFew: '{n} giao dịch',
        pocetMany: '{n} giao dịch',
        pocetOne: '{n} giao dịch',
        uzavreno: 'Đã chốt tháng này',
      },
      nicVeFazi: 'Không có gì ở giai đoạn này',
      novy: 'Giao dịch mới trong ứng dụng',
      otevrit: 'Mở giao dịch: {nazev}',
      prazdno: 'Chưa có giao dịch nào đang xử lý',
      trychtyr: 'Giao dịch theo giai đoạn',
    },
    plan: {
      bezAnalyzy: 'Chưa có phân tích. Kế hoạch được lập từ phân tích.',
      bezNavrhu: 'Đề xuất giải pháp chưa được lưu. Khi bạn lưu trong ứng dụng, nó sẽ hiện ở đây.',
      chybaBloku: 'Không tính được phần này của kế hoạch',
      chybaVypoctu: 'Không tính được kế hoạch',
      cile: {
        bezCastky: 'Chưa đặt số tiền mục tiêu — không tính được tiến độ',
        bezHorizontu: 'Chưa đặt thời hạn mục tiêu — không tính được tiến độ',
        chybi: 'còn thiếu {castka}',
        dalsichFew: 'và thêm {n} mục tiêu trong đề xuất',
        dalsichMany: 'và thêm {n} mục tiêu trong đề xuất',
        dalsichOne: 'và thêm {n} mục tiêu trong đề xuất',
        dnes: 'hôm nay {pct}',
        grafPopis: '{nazev}: hôm nay {dnes}, có kế hoạch {po} của mục tiêu {cil}',
        jednorazove: '{castka} một lần',
        legendaChybi: 'vẫn còn thiếu',
        legendaMa: 'đã có hôm nay',
        legendaPlan: 'kế hoạch bổ sung',
        mesicne: '{castka} mỗi tháng',
        nadpis: 'Tiến độ mục tiêu',
        prazdno: 'Đề xuất chưa có mục tiêu nào',
        prepocetProfil: 'Hồ sơ riêng của mục tiêu — tiến độ với hồ sơ này tính trong Đề xuất',
        prepocetRucni: 'Số tiền hằng tháng nhập tay — tiến độ với số này tính trong Đề xuất',
        sPlanem: 'có kế hoạch {pct}',
        souhrn: 'Đạt được với kế hoạch: {n}/{m}',
        splneno: 'đạt được với kế hoạch',
        vlastniZdroje: 'trong đó vốn tự có {castka}',
        zAnalyzy: 'đã sửa trong Đề xuất · theo phân tích {castka} · {termin}',
      },
      kroky: {
        chybi: {
          majetkove: 'Bảo hiểm tài sản — hãy điền và lưu thẻ Bảo hiểm tài sản trong đề xuất',
          rezerva: 'Quỹ dự phòng — phân tích thiếu chi tiêu thiết yếu, nên chưa có mục tiêu dự phòng',
          zivotni: 'Bảo hiểm nhân thọ — không tính được số tiền bảo hiểm khi phân tích thiếu thu nhập và chi tiêu',
        },
        chybiTitulek: 'Các bước còn thiếu dữ liệu:',
        hotovo: 'Xong',
        naRade: 'Tiếp theo',
        nadpis: 'Các bước thực hiện tiếp theo',
        prazdno: 'Kế hoạch chưa có bước thực hiện',
      },
      majetek: {
        grafPopis: 'Tích lũy cho mục tiêu theo kế hoạch, theo giá hôm nay: cao nhất {castka} vào năm {rok}. Mô hình, không phải cam kết.',
        legenda: 'chấm và nét đứt = mô hình theo kế hoạch',
        model: 'Tổng tích lũy cho mục tiêu theo kế hoạch với lợi nhuận {vynos}, theo giá hôm nay (lợi nhuận đã trừ lạm phát) — mô hình, không phải cam kết, lợi nhuận không được cam kết. Khi mục tiêu đến hạn, tiền được chi ra và đường cong đi xuống.',
        nadpis: 'Tài sản theo thời gian',
        nula: 'Theo kế hoạch, hiện chưa tích lũy gì cho các mục tiêu có thời hạn',
        prazdno: 'Kế hoạch chưa có mục tiêu có thời hạn',
        rada: 'Đã tích lũy cho mục tiêu',
        rokVek: '{rok} · {vek}',
        vrchol: 'Cao nhất {castka} vào năm {rok}',
      },
      nadpis: 'Kế hoạch',
      navrh: 'Đề xuất giải pháp',
      ochrana: {
        bezCastek: 'Chưa tính được số tiền bảo hiểm — thiếu thu nhập hoặc chi tiêu',
        castky: 'mất sức lao động {invalidita} · tử vong {smrt}',
        cenaDoplni: 'mỗi tháng cho cả hộ — tư vấn viên sẽ nhập giá',
        cenaNeznama: 'Chưa biết giá bảo vệ',
        cenaNula: 'Giá do tư vấn viên nhập là 0 — không trừ gì từ thặng dư',
        cenaPoradce: 'mỗi tháng cho cả hộ, giá do tư vấn viên nhập',
        cenaPoradceCast: 'mỗi tháng, giá do tư vấn viên nhập — mới chỉ là một phần phí',
        nadpis: 'Bảo vệ gia đình',
        odhadOrientacne: '≈ {castka} mỗi tháng — chỉ là ước tính tham khảo',
        odmitnuto: 'Khách hàng chưa muốn bảo vệ thu nhập',
        rozdil: 'Hiện trả {stara} → mới {nova} ({rozdil}). Hợp đồng cũ bị hủy, kế hoạch chỉ trừ phần chênh lệch.',
        rucne: 'tư vấn viên đã chỉnh',
        staraNeznama: 'Hợp đồng bị hủy chưa có số phí — chưa được trừ trong phần chênh lệch.',
        varianta: 'Phương án bảo hiểm trong đề xuất',
        zdroj: 'Số tiền bảo hiểm của phương án {varianta} trong Đề xuất. Mức bảo vệ khuyến nghị trong Phân tích do công cụ tính của phân tích đưa ra, nên có thể khác.',
      },
      otevritNavrh: 'Mở đề xuất trong ứng dụng',
      prazdnaAnalyza: 'Phân tích đang trống — kế hoạch không có dữ liệu để tính.',
      prezentace: 'Bản trình bày',
      profil: 'Hồ sơ: {nazev}',
      regulace: 'Kế hoạch mô phỏng từ đề xuất giải pháp, không phải chào bán. Lợi nhuận không được cam kết.',
      rezerva: {
        bezCile: 'Không tính được mục tiêu quỹ dự phòng — thiếu chi tiêu',
        dopocetNezbytneFew: 'mục tiêu dự phòng · {n} tháng chi tiêu thiết yếu và trả nợ',
        dopocetNezbytneMany: 'mục tiêu dự phòng · {n} tháng chi tiêu thiết yếu và trả nợ',
        dopocetNezbytneOne: 'mục tiêu dự phòng · {n} tháng chi tiêu thiết yếu và trả nợ',
        dopocetObvykleFew: 'mục tiêu dự phòng · {n} tháng chi tiêu thông thường và trả nợ',
        dopocetObvykleMany: 'mục tiêu dự phòng · {n} tháng chi tiêu thông thường và trả nợ',
        dopocetObvykleOne: 'mục tiêu dự phòng · {n} tháng chi tiêu thông thường và trả nợ',
        jednorazove: 'bổ sung một lần',
        mesicne: 'bổ sung hằng tháng',
        nadpis: 'Quỹ dự phòng',
        plnaDnes: 'Đã đủ ngay hôm nay',
        plnaSPlanem: 'Đủ khi có kế hoạch',
        zadana: 'mục tiêu dự phòng đặt trong phân tích',
      },
      rozpocet: {
        cile: 'Mục tiêu',
        jednorazove: 'Từ tiền tiết kiệm một lần {prideleno} trên {celkem}',
        legendaPlan: 'kế hoạch phân bổ',
        nadPrebytek: 'Phần phí bảo hiểm tăng thêm vượt thặng dư — thiếu {castka} mỗi tháng',
        nadpis: 'Ngân sách hằng tháng của kế hoạch',
        ochranaNeznama: 'Tư vấn viên chưa nhập giá bảo vệ — kế hoạch chưa tính khoản này',
        ochranaNula: 'Giá bảo vệ do tư vấn viên nhập là 0 — không trừ gì',
        ochranaOdmitnuta: 'Khách hàng chưa muốn bảo vệ thu nhập — không trừ',
        pojistneNove: 'Phí bảo hiểm {nova} nằm trong các khoản chi bắt buộc',
        pojistneZmena: 'Phí bảo hiểm trong các khoản chi bắt buộc: hiện tại {stara} → mới {nova} ({rozdil})',
        prebytek: 'thặng dư hằng tháng — đi đâu',
        prebytekNejisty: 'Từ thu nhập, chi tiêu và trả nợ sẽ ra {castka} mỗi tháng — hãy kiểm tra thặng dư đã thống nhất trong ứng dụng.',
        prebytekNezadany: 'Chưa nhập thặng dư',
        prebytekNula: 'Thặng dư bằng 0',
        prebytekPoPojistnem: 'thặng dư hằng tháng sau phí bảo hiểm — đi đâu',
        precerpano: 'Kế hoạch phân bổ nhiều hơn thặng dư',
        renta: 'Đầu tư cho dòng tiền hưu trí',
        rezerva: 'Quỹ dự phòng',
        vyrovnano: 'Toàn bộ tiền đều đã có nhiệm vụ',
        zadneZdroje: 'Kế hoạch không có gì để phân bổ — không có thặng dư lẫn tiền tiết kiệm.',
        zbyva: 'Chưa được phân bổ',
      },
      ulozeno: 'Đã lưu {datum}',
      vynos: {
        optimisticky: 'Lợi nhuận lạc quan',
        pesimisticky: 'Lợi nhuận bi quan',
        realisticky: 'Lợi nhuận thực tế',
      },
      vynosVeVete: {
        optimisticky: 'lạc quan',
        pesimisticky: 'bi quan',
        realisticky: 'thực tế',
      },
    },
    prehled: {
      dnes: {
        bezCasuFew: '{n} việc chưa có giờ',
        bezCasuMany: '{n} việc chưa có giờ',
        bezCasuOne: '{n} việc chưa có giờ',
        dalsichFew: 'Và thêm {n} hoạt động hôm nay',
        dalsichMany: 'Và thêm {n} hoạt động hôm nay',
        dalsichOne: 'Và thêm {n} hoạt động hôm nay',
        nadpis: 'Hôm nay',
        nejblizsiCas: 'Hoạt động tiếp theo lúc {cas}',
        nejblizsiNadpis: 'Sắp tới trong lịch',
        nicDnes: 'Hôm nay lịch không còn gì',
        otevritDiar: 'Mở lịch',
        poTerminuFew: '{n} quá hạn',
        poTerminuMany: '{n} quá hạn',
        poTerminuOne: '{n} quá hạn',
        seznam: 'Các hoạt động khác hôm nay',
      },
      klienti: {
        nadpis: 'Khách hàng gần đây',
      },
      obchody: {
        bjVBehu: 'Tổng BJ đang xử lý',
        nadpis: 'Giao dịch đang xử lý',
        prazdno: 'Không có giao dịch đang xử lý',
      },
      pece: {
        bezKontaktu: 'Chưa liên hệ',
        dalsichFew: 'và {n} khác',
        dalsichMany: 'và {n} khác',
        dalsichOne: 'và {n} khác',
        dniFew: '{n} ngày',
        dniMany: '{n} ngày',
        dniOne: '{n} ngày',
        fixace: 'Hết kỳ cố định lãi suất',
        konecSmlouvy: 'Hết hạn hợp đồng',
        nadpis: 'Khách hàng cần chăm sóc',
        prazdno: 'Không có kỳ cố định nào trong 120 ngày và không ai quá 90 ngày chưa liên hệ',
        vyroci: 'Kỷ niệm hợp đồng',
      },
      plan: {
        nadpis: 'Kế hoạch tháng',
      },
      provize: {
        bezPozice: 'Chưa đặt vị trí',
        koef: '{koef} {mena} mỗi BJ · vị trí {pozice}',
        koefVychozi: '{koef} {mena} mỗi BJ (mặc định)',
        nadpis: 'Hoa hồng ước tính',
      },
      radar: {
        dalsiMezeryFew: '+{n} khoảng trống khác',
        dalsiMezeryMany: '+{n} khoảng trống khác',
        dalsiMezeryOne: '+{n} khoảng trống khác',
        dalsichKlientuFew: 'và {n} khách hàng khác có khoảng trống',
        dalsichKlientuMany: 'và {n} khách hàng khác có khoảng trống',
        dalsichKlientuOne: 'và {n} khách hàng khác có khoảng trống',
        kriticka: 'Khoảng trống nghiêm trọng',
        krok: 'Bước đề xuất',
        nadpis: 'Radar cơ hội',
        otevrit: 'Mở radar trong CRM hiện tại',
        prazdno: 'Không có cơ hội đang mở',
        skore: 'điểm {n}',
      },
    },
    produkt: {
      hypoteka: 'Vay thế chấp',
      investice: 'Đầu tư',
      majetek: 'Tài sản',
      penze: 'Hưu trí',
      uver: 'Khoản vay',
      zp: 'Bảo hiểm nhân thọ',
    },
    produktObchodu: {
      hypoteka: 'Vay thế chấp',
      investice: 'Đầu tư',
      jine: 'Khác',
      koupe_nemovitosti: 'Mua bất động sản',
      penzijko: 'Tiết kiệm hưu trí',
      podnikatelsky_uver: 'Vay kinh doanh',
      pojisteni_auta: 'Bảo hiểm ô tô',
      pojisteni_majetek: 'Bảo hiểm tài sản',
      pojisteni_zivot: 'Bảo hiểm nhân thọ',
      prodej_nemovitosti: 'Bán bất động sản',
      refinancovani: 'Tái cấp vốn',
      spotrebitelsky_uver: 'Vay tiêu dùng',
      stavebni: 'Tiết kiệm xây dựng',
      uver: 'Khoản vay',
    },
    prototyp: 'Bản thử · chỉ xem',
    pruvodce: {
      nadpis: 'Đây là bản phác thảo CRM mới',
      rozumim: 'Đã hiểu',
      text: 'Dữ liệu là thật và chỉ để xem. Giao diện và thứ tự màn hình vẫn có thể thay đổi.',
      zapis: 'Bạn vẫn chỉnh sửa và ghi dữ liệu trong CRM hiện tại.',
    },
    stav: {
      fazeNezadana: 'Chưa có giai đoạn',
      nacitam: 'Đang tải…',
      nezadano: 'chưa nhập',
      nicNeodpovida: 'Không có kết quả phù hợp bộ lọc',
      prazdno: 'Chưa có gì ở đây',
      starsiData: 'Dữ liệu cũ · {cas}',
    },
    termin: {
      dnes: 'hôm nay',
      poFew: 'quá hạn {n} ngày',
      poMany: 'quá hạn {n} ngày',
      poOne: 'quá hạn {n} ngày',
      zaFew: 'còn {n} ngày',
      zaMany: 'còn {n} ngày',
      zaOne: 'còn {n} ngày',
      zitra: 'ngày mai',
    },
    zalozky: {
      analyza: 'Phân tích',
      klient: 'Khách hàng',
      nadpis: 'Các mục của khách hàng',
      plan: 'Kế hoạch',
      prezentace: 'Bản trình bày',
      vAppce: 'mở CRM hiện tại',
    },
    zastupny: {
      nadpis: 'Màn hình đang được chuẩn bị',
      text: 'Phần này của CRM mới đang được xây dựng. Hiện bạn hãy dùng CRM hiện tại.',
    },
  },
  /* BLOK:novyCrm END */
  /* BLOK:vystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  vystup: {
    bullet: {
      aria: {
        chybi: '{popisek}: nhu cầu {potreba}, đã có {kryto}, còn thiếu {chybi}.',
        kryto: '{popisek}: nhu cầu {potreba}, đã có {kryto}. Đã đủ.',
        nezadano: '{popisek}: chưa nhập nhu cầu.',
        neznameKryti: '{popisek}: nhu cầu {potreba}, chưa nhập mức bảo vệ đã ký.',
      },
      chybi: 'Còn thiếu {castka}',
      krytiNezadane: 'Chưa nhập mức bảo vệ',
      kryto: 'Đã đủ',
      nadRamec: 'Đã đủ, dư {castka}',
      potreba: 'Nhu cầu {castka}',
      potrebaNezadana: 'Chưa nhập nhu cầu',
      sjednano: 'Đã ký {castka}',
      stat: 'Nhà nước {castka}',
    },
    cara: {
      aria: 'Dự phóng {roky}: kịch bản trung bình {stred}, khoảng từ {od} đến {do}.',
      ariaSrovnani: 'Để so sánh, {popisek}: {hodnota}.',
      pasmo: 'Kịch bản xấu đến tốt',
      prazdno: 'Chưa nhập dự phóng',
      stred: 'Kịch bản trung bình',
    },
    kobliha: {
      aria: 'Phân bổ {celkem}: {dily}.',
      celkem: 'Tổng',
      nezadano: 'Chưa có số tiền: {polozky}',
      ostatni: 'Khác',
      prazdno: 'Không có gì để phân bổ',
    },
    kroky: {
      aktivni: 'đang ở đây',
      aria: 'Tiến trình: bước {n} trên {celkem}, {popisek}',
      ceka: 'chưa tới',
      hotovo: 'đã xong',
    },
    letFew: '{n} năm',
    letMany: '{n} năm',
    letOne: '{n} năm',
    mesicne: 'mỗi tháng',
    modelNeniGarance: 'Đây là mô hình, không phải cam kết. Kết quả thực tế có thể cao hơn hoặc thấp hơn.',
    nezadano: 'chưa nhập',
    rezim: {
      nazev: 'Chế độ xem',
      obrazovka: 'Màn hình',
      papir: 'Bản in',
      prezentace: 'Trình chiếu',
    },
    splatka: {
      aria: 'Trả góp {splatka} mỗi tháng, {roky}. Tổng cộng {celkem}, trong đó lãi {urok}.',
      ariaUrokNejdriv: 'Lúc đầu phần lớn khoản trả là lãi, về cuối chủ yếu là gốc.',
      jistina: 'Tiền gốc',
      popisek: 'Khoản trả góp',
      prazdno: 'Chưa nhập khoản vay',
      rok: 'Năm thứ {n}',
      souhrn: 'Tổng cộng bạn trả {celkem}, trong đó lãi {urok}.',
      urok: 'Tiền lãi',
    },
    tok: {
      aria: 'Tiền đi đâu: {toky}.',
      krok: '{z} → {do}: {castka}',
      krokKam: '{z} → {do}: {castka}, {kam}',
      nezadano: 'Chưa có số tiền: {toky}',
      ostatni: 'Khác',
      prazdno: 'Không có dòng tiền',
    },
    ukazka: {
      bullet: 'Nhu cầu vs. đã ký',
      cara: 'Dự phóng có khoảng',
      d: {
        akcie: 'Cổ phiếu',
        analyza: 'Phân tích',
        bezPlanu: 'Không có kế hoạch',
        deti: 'Đầu tư cho con',
        dluhopisy: 'Trái phiếu',
        dps: 'tiết kiệm hưu trí bổ sung',
        fondy: 'quỹ đầu tư',
        hotovost: 'Tiền mặt',
        hotovostTrida: 'Tiền mặt',
        hypoteka: 'Trả góp vay mua nhà',
        invalidita: 'Mất sức lao động',
        jednorazove: 'Một lần',
        mesicne: 'Hằng tháng',
        nemovitosti: 'Quỹ bất động sản',
        nezbytne: 'Chi tiêu thiết yếu',
        plan: 'Kế hoạch',
        pn: 'Nghỉ ốm',
        podminkyUveru: '{castka} · {roky} · lãi {sazba}',
        pojisteni: 'Bảo hiểm',
        prebytek: 'Thặng dư hằng tháng',
        predstaveni: 'Giới thiệu',
        prijem: 'Thu nhập ròng',
        realizace: 'Thực hiện',
        renta: 'Lương hưu tự tạo',
        rezerva: 'Quỹ dự phòng',
        sPlanem: 'Có kế hoạch',
        servis: 'Chăm sóc',
        smrt: 'Tử vong',
        sporiciUcet: 'tài khoản tiết kiệm',
        stavebko: 'Trả góp vay tiết kiệm xây dựng',
        styl: 'Phong cách sống',
        volne: 'Tiền còn lại',
        zlato: 'Vàng',
      },
      kdeBullet: 'Rủi ro và quỹ dự phòng trong bài trình bày kế hoạch',
      kdeCara: 'Có kế hoạch vs. không có kế hoạch',
      kdeKobliha: 'Danh mục tối đa năm loại tài sản',
      kdeKroky: 'Hành trình khách hàng',
      kdeSplatka: 'Mục tiêu vay mua nhà — thay cho máy tính Lịch sử',
      kdeStavebko: 'Phần còn lại của mục tiêu là khoản vay tiết kiệm xây dựng',
      kdeTok: 'Tiền đi đâu — một lần và hằng tháng tách riêng',
      kdeVelkeCislo: 'Con số chính của máy tính hoặc trang chiếu',
      kdeVlozeno: 'Đầu tư cho con: một lần và định kỳ, sau đó rút dần',
      kdeVodopad: 'Thu nhập → chi tiêu → tiền còn lại',
      kobliha: 'Biểu đồ vành khuyên',
      kroky: 'Thanh tiến trình',
      navrh: 'Bản xem trước để duyệt — trong kế hoạch, bài trình chiếu và bản in chưa thay gì.',
      prehrat: 'Phát lại',
      splatka: 'Trả góp và lãi',
      tok: 'Dòng tiền',
      ucebniCisla: 'Số liệu mẫu, không có khách hàng.',
      velkeCislo: 'Con số chính',
      vlozeno: 'Đã góp vs. tăng trưởng',
      vodopad: 'Biểu đồ thác nước',
    },
    vlozeno: {
      aria: 'Sau {roky} bạn tích lũy {hodnota}: đã góp {vlozeno}, tăng trưởng {zhodnoceni}.',
      ariaCerpani: 'Sau đó rút {castka} mỗi tháng trong {roky}.',
      cerpani: 'Rút tiền',
      cerpaniVeta: 'Sau đó rút {castka} mỗi tháng trong {roky}',
      pasmo: 'Khoảng kịch bản',
      pasmoVeta: 'Kịch bản xấu đến tốt: {od} – {do}',
      popisek: 'Sau {roky}',
      prazdno: 'Chưa nhập khoản góp',
      vlozeno: 'Đã góp',
      zhodnoceni: 'Tăng trưởng',
    },
    vodopad: {
      aria: '{kroky}. Kết quả {vysledek}.',
      ariaNelze: '{kroky}. Không thể tính kết quả.',
      nelze: 'Không thể tính kết quả, còn thiếu: {polozky}',
      vysledek: 'Kết quả',
    },
    zaMesic: '/ tháng',
  },
  /* BLOK:vystup END */
  /* BLOK:vnRodina START — generuje scratchpad/slovnik.py, ručně needitovat */
  vnRodina: {
    cile: {
      bydleni: {
        akontace: 'Tiền đối ứng {pct} %:',
        akontaceHned: 'Cần tiền đối ứng ngay',
        cena: 'Nhà giá',
        cenaPole: 'Giá nhà',
        doRoku: 'đến năm {rok}',
        dopocteno: 'khoản trả là ước tính',
        letPole: 'Còn trả bao nhiêu năm',
        na: 'trong',
        nadpis: 'Nhà ở',
        odkladatNaAkontaci: 'Để dành tiền đối ứng mỗi tháng',
        otazka: 'Anh chị đang trả nợ vay, hay định mua nhà?',
        pakSplatka: 'sau đó trả góp khoảng',
        platite: 'Hiện mỗi tháng đã trả',
        rezimDluh: 'Đang trả nợ vay',
        rezimKoupit: 'Muốn mua nhà',
        rezimNic: 'Đã có nhà',
        uver: 'Khoản vay',
        vyreseno: 'Gia đình đã có nhà ổn định.',
        za: 'sau',
        zaPole: 'Bao nhiêu năm nữa định mua',
        zbytekPole: 'Số nợ còn lại',
        zbyva: 'Còn phải trả',
      },
      deti: {
        bezDeti: 'Không có con dưới 23 tuổi.',
        naDiteMesicne: 'cho một con mỗi tháng',
        nadpis: 'Con đến 23 tuổi',
        nakladPole: 'Nuôi một con mỗi tháng tốn bao nhiêu',
        radek: 'Con thứ {n} · {mesicu} tháng',
        samostatne: 'Con đã tự lập không tính: {pocet}',
        stoji: 'Nuôi con đến 23 tuổi tốn',
        zVyplaty: 'Hiện trả từ lương mỗi tháng',
      },
      duchod: {
        aria: 'Nghỉ hưu: nhà nước trả bao nhiêu và còn thiếu bao nhiêu: {radky}',
        ariaRadek: '{kdo}: nhà nước {stat}, thiếu {chybi}',
        chybi: 'còn thiếu',
        chybiRadek: 'thiếu',
        cilPole: 'Mỗi người muốn có bao nhiêu mỗi tháng khi nghỉ hưu',
        naOsobu: 'mỗi tháng cho mỗi người',
        nadpis: 'Nghỉ hưu',
        odchodV: 'Nghỉ hưu ở tuổi',
        odkladat: 'cần để dành mỗi tháng',
        rezimAria: 'Cách đặt mục tiêu nghỉ hưu',
        rezimCastka: 'Số tiền',
        rezimStandard: 'Giữ mức sống',
        standardText: 'Giữ mức sống như hiện nay: 80 % thu nhập ròng hiện tại của mỗi người.',
        stat: 'nhà nước (ước tính)',
        statRadek: 'nhà nước ước tính',
        uzVDuchodu: 'đã đến tuổi nghỉ hưu',
        vekPole: 'Tuổi nghỉ hưu',
      },
      nadpis: 'Mục tiêu của gia đình',
      odkladatCelkem: 'Mỗi tháng cần để dành cho mục tiêu',
      odkladatModelove: '(mô phỏng, lợi nhuận không chắc chắn)',
      prijemRodiny: 'Thu nhập gia đình',
      uvod: 'Nhà ở, con cái đến 23 tuổi và lúc nghỉ hưu.',
    },
    hlavicka: {
      navAria: 'Các phần của bản phân tích',
      podtitul: 'Câu chuyện gia đình: mục tiêu và điều giữ vững mục tiêu',
      poradce: 'Cho người tư vấn',
      priklad: 'Điền ví dụ',
      promitani: 'Trình chiếu cho khách',
      promitaniKonec: 'Dừng trình chiếu',
      zpet: 'Quay lại Phân tích cho người Việt',
    },
    investice: {
      ariaRozdeleni: 'Từ gói {balicek}, {ochrana} dành cho bảo vệ và {investice} cho đầu tư.',
      cenaOdPoradce: 'Phí bảo vệ do người tư vấn nhập',
      dnesnimaOcima: 'theo giá trị tiền hôm nay {castka}',
      doInvestic: 'đóng vào đầu tư',
      doVeku: 'Đến tuổi',
      dopadPoplatku: 'Hai loại phí cộng lại làm giá trị mô phỏng giảm {castka}.',
      grafAria: 'Đến {vek} tuổi anh chị đóng tổng cộng {zaplaceno}, trong đó {ochrana} cho bảo vệ và khoản này không hoàn lại. Giá trị đầu tư mô phỏng với {vynos} % là {hodnota}, trong khoảng từ {od} đến {do}. Đây là mô phỏng, không phải lời hứa.',
      hodnotaModel: 'giá trị · mô phỏng {vynos} %',
      hodnotaPri: 'giá trị với {vynos} %',
      hodnotaVeVeku: 'Giá trị lúc {vek} tuổi · mô phỏng {vynos} %',
      investuje: 'được đầu tư',
      naOchranu: 'đóng cho bảo vệ (không hoàn lại)',
      nadpis: 'Nếu bình an',
      nakladyNaKonci: 'lúc {vek} tuổi',
      nakladyNadpis: 'Chi phí theo thời gian',
      nakladyPoLetechFew: 'sau {n} năm',
      nakladyPoLetechMany: 'sau {n} năm',
      nakladyPoLetechOne: 'sau {n} năm',
      nezadano: 'chưa nhập',
      ochranaPopisek: 'trong đó phí bảo vệ {castka}, không hoàn lại',
      pasmo: 'khoảng mô phỏng',
      pasmoOdDo: 'với {od}–{do} %: từ {hodnotaOd} đến {hodnotaDo}',
      poplatkyDosud: 'phí đến thời điểm đó',
      poplatkyNadpis: 'Các loại phí hết bao nhiêu',
      protiCili: 'Theo mục tiêu của anh chị, tuổi già còn thiếu {potreba} theo giá trị tiền hôm nay. Mô phỏng đầu tư bằng {pct} % số tiền này.',
      prubezny: 'Phí quản lý',
      prubeznyRadek: '{pct} mỗi năm trên số dư đầu tư, tổng cộng trong {roky}',
      uvod: 'Từ gói tiền, trước hết trả phí bảo vệ, phần còn lại được đầu tư đến tuổi đã chọn.',
      vekTooltip: '{vek} tuổi',
      vstupni: 'Phí ban đầu',
      vynos: 'Lợi nhuận mô phỏng mỗi năm',
      zBalicku: 'Từ gói {balicek} mỗi tháng:',
      zTohoOchrana: 'trong đó cho bảo vệ',
      zaplaceno: 'Tổng số tiền đã đóng',
      zaplacenoJak: 'cả gói {balicek} × 12 tháng × {roky}',
    },
    jednotka: {
      rokFew: 'năm',
      rokMany: 'năm',
      rokOne: 'năm',
      vekFew: 'tuổi',
      vekMany: 'tuổi',
      vekOne: 'tuổi',
    },
    nav: {
      cile: 'Mục tiêu',
      investice: 'Đầu tư',
      ochrana: 'Bảo vệ',
      odkladat: 'Để dành',
      otazky: 'Câu hỏi',
      prijmy: 'Thu nhập',
      rodina: 'Gia đình',
      srovnani: 'So sánh',
      vypadek: 'Nếu mất thu nhập',
      zaver: 'Tóm lại',
    },
    neuplne: {
      cilBydleni: 'giá hoặc thời điểm mua nhà',
      nadpis: 'Chưa đủ, còn thiếu:',
      uver: 'dư nợ hoặc số năm vay',
      vekDitete: 'tuổi của con thứ {n}',
    },
    ochrana: {
      bezMesicne: 'Mỗi tháng thiếu {castka}. Phần này không có nguồn tiền nào bù vào.',
      bezPn: 'Mỗi ngày ốm thiếu {castka}.',
      bezZo: 'Chữa bệnh kéo dài nhiều tháng, chi tiêu vẫn chạy mà thu nhập thì thiếu.',
      detiCastka: 'Mỗi con: {castka}.',
      dil: {
        bydleni: 'Nhà ở',
        deti: 'Con đến 23 tuổi',
        dluh: 'Phần khoản vay',
        duchod: 'Tuổi già',
        duchodPozustaleho: 'Tuổi già của vợ hoặc chồng',
        renta: 'Thu nhập cho gia đình',
        zivot: 'Sinh hoạt đến khi nghỉ hưu',
      },
      doplniPoradce: 'người tư vấn sẽ bổ sung',
      kazdeDite: 'Mỗi con',
      kdoAria: 'Xem cách tính của ai',
      krokMetodou: 'Theo tính toán (nhu cầu − nhà nước)',
      krokMinimum: 'Mức tối thiểu = số tiền bảo hiểm',
      naDen: '/ ngày',
      naDnesek: 'quy về giá trị tiền hôm nay (4 % mỗi năm)',
      naNoc: '/ đêm',
      nadpis: 'Bảo vệ gia đình theo từng rủi ro',
      nepojistujeSe: 'không bảo hiểm',
      pnBezPrijmu: 'Không có thu nhập. Người tư vấn sẽ bổ sung mức bảo vệ.',
      pnNicNechybi: 'Trợ cấp ốm đau của nhà nước đủ bù thu nhập.',
      pnPotreba: 'Thu nhập ròng mỗi ngày',
      pnStat: 'Trợ cấp ốm đau của nhà nước',
      podRiziko: {
        dou: 'cho mỗi ngày điều trị tai nạn',
        hosp: 'cho mỗi đêm nằm viện',
        invalidita: 'khi mất sức lao động hoàn toàn',
        pn: 'cho mỗi ngày ốm hoặc tai nạn',
        smrt: 'trả một lần cho gia đình',
        tnu: 'sau tai nạn, theo mức độ',
        zo: 'trả một lần khi được chẩn đoán',
      },
      popis: {
        dou: 'Trả cho mỗi ngày điều trị sau tai nạn. Một tai nạn được trả bao nhiêu ngày là theo bảng của công ty bảo hiểm.',
        hosp: 'Trả cho mỗi đêm nằm viện.',
        invalidita: 'Khi vì sức khỏe mà lâu dài không làm việc được. Nhà nước chia thành các mức theo mức suy giảm khả năng lao động.',
        pn: 'Khi vì ốm hoặc tai nạn mà một thời gian không làm việc được. Trợ cấp ốm đau của nhà nước chỉ bù một phần thu nhập.',
        smrt: 'Gia đình nhận một khoản một lần: trả phần khoản vay và phần chi phí nuôi con đến 23 tuổi mà thu nhập của người đó đang gánh, và bù phần thu nhập bị thiếu.',
      },
      riziko: {
        dou: 'Trợ cấp ngày điều trị tai nạn',
        hosp: 'Nằm viện',
        invalidita: 'Mất sức lao động',
        pn: 'Nghỉ ốm, không làm việc được',
        smrt: 'Qua đời',
        tnu: 'Thương tật vĩnh viễn do tai nạn',
        zo: 'Bệnh hiểm nghèo',
      },
      sJednorazove: 'Gia đình nhận {castka} và các mục tiêu vẫn giữ được.',
      sPn: 'Trợ cấp ngày {pn}, nếu tai nạn thêm {dou}.',
      sPnBezDou: 'Trợ cấp ngày {pn}.',
      sZo: 'Trả một lần {castka} khi được chẩn đoán bệnh có trong danh sách của hợp đồng.',
      stat: {
        invalidita: 'Lương hưu mất sức lao động (ước tính)',
        smrt: 'Lương hưu cho vợ hoặc chồng và con còn lại (ước tính)',
      },
      statStupen: 'nhà nước ước tính {castka} mỗi tháng',
      stupen: {
        I: 'Mức I · 35–49 %',
        II: 'Mức II · 50–69 %',
        III: 'Mức III · từ 70 % trở lên',
        nad40: 'suy giảm trên 40 %',
        nad70: 'suy giảm trên 70 %',
      },
      tabulkaAria: 'Bảo vệ theo từng rủi ro và từng người',
      tnuPasma: 'Chi trả theo từng bậc:',
      tnuPasmo: '{od}–{do} % ×{k}',
      tnuTabulka: 'Được trả bao nhiêu từ {castka} theo mức thương tật',
      uvod: 'Gia đình nhận được bao nhiêu với từng biến cố. Các rủi ro không được chi trả cùng lúc, nên các số tiền không cộng lại.',
      vodopadAria: 'Cần {potreba}, nhà nước ước tính {stat}, còn thiếu {chybi}.',
      zoRokyFew: '{n} năm thu nhập ròng',
      zoRokyMany: '{n} năm thu nhập ròng',
      zoRokyOne: '{n} năm thu nhập ròng',
      zoRucne: 'Số tiền do người tư vấn nhập',
    },
    odkladat: {
      ariaVolne: 'Sau chi tiêu và trả nợ còn {volne}, gói là {balicek}.',
      celyPlan: 'Gói này là toàn bộ kế hoạch của gia đình: bảo vệ và đầu tư. Phần bảo vệ tốn bao nhiêu, người tư vấn sẽ tính theo báo giá của công ty bảo hiểm.',
      doplnPrijmy: 'Các gói sẽ hiện khi nhập thu nhập.',
      doporuceno: 'đề xuất',
      nadpis: 'Gia đình có thể để dành bao nhiêu',
      nevejdeSe: 'vượt quá, còn thiếu',
      nevejdeSeKratce: 'vượt ngân sách',
      odkladate: 'để dành',
      rozdeleniInvestice: 'và cho đầu tư',
      rozdeleniOchrana: 'dành cho bảo vệ',
      rozdeleniZ: 'Trong',
      uvod: 'Cho mục tiêu gia đình: 10 đến 30 % thu nhập ròng.',
      uvodDoporuceni: 'Với {prijem} mỗi tháng, chúng tôi đề xuất để dành {pct} %.',
      vlastni: 'Số tiền tự chọn:',
      vyberAria: 'Để dành bao nhiêu phần trăm thu nhập',
      zVolnych: 'từ tiền còn dư',
      zbyvaVolne: 'vẫn còn dư',
      zpetNaDoporuceni: 'quay lại đề xuất',
    },
    osa: {
      ariaDite: 'con thứ {n} tự lập năm {rok}',
      ariaDospely: '{kdo} nghỉ hưu năm {rok}',
      ariaUver: 'khoản vay trả xong năm {rok}',
      diteZkratka: 'C{n}',
      dnes: 'hôm nay',
      duchod: 'nghỉ hưu {vek} tuổi · {rok}',
      prazdno: 'Dòng thời gian sẽ hiện khi nhập tuổi.',
      samostatne: 'đã tự lập',
      samostatneRok: '23 tuổi · {rok}',
      uver: 'Khoản vay',
      uverDo: 'trả xong {rok}',
    },
    otazky: {
      faq: {
        dlouho: {
          odpoved: 'Mấy năm đầu là trả phí ban đầu, nên nếu dừng sớm anh chị nhận lại rất ít hoặc không có gì. Theo hợp đồng có thể giảm mức đóng, tạm ngừng đầu tư một thời gian hoặc rút từ phần đầu tư. Trong vòng 30 ngày sau khi ký, anh chị có quyền hủy hợp đồng.',
          otazka: 'Sao phải lâu thế? Nếu cần tạm ngừng, điều chỉnh hoặc rút tiền thì sao?',
        },
        kamInvest: {
          odpoved: 'Vào các quỹ anh chị chọn trong danh sách của công ty bảo hiểm: quỹ cổ phiếu, trái phiếu hoặc cân bằng. Trong thời gian hợp đồng có thể đổi chiến lược. Giá trị có thể xuống dưới số tiền đã bỏ vào.',
          otazka: 'Tiền được đầu tư vào đâu?',
        },
        nemocny: {
          odpoved: 'Tùy bệnh và tùy công ty. Có thể được nhận với phí bình thường, tăng phí, loại trừ bệnh đó, hoặc bị từ chối. Hãy khai bệnh trung thực trong tờ khai sức khỏe, nếu không công ty có thể không chi trả.',
          otazka: 'Tôi đang bị bệnh. Có mua bảo hiểm được không?',
        },
        podvod: {
          odpoved: 'Công ty bảo hiểm và người tư vấn phải có giấy phép và có tên trong danh sách của ngân hàng trung ương — anh chị tự tra được theo tên. Trước khi ký, anh chị nhận bằng văn bản điều khoản, bảng chi phí và biên bản buổi tư vấn. Không cần ký ngay.',
          otazka: 'Cái này có phải lừa đảo không?',
        },
        poplatky: {
          odpoved: 'Phí ban đầu là phần trăm của số tiền mục tiêu, phí quản lý là phần trăm số dư mỗi năm. Cả hai được ghi bằng tiền cạnh biểu đồ, và mọi chi phí cũng có trong giấy tờ của công ty bảo hiểm.',
          odpovedCisla: 'Phí ban đầu {pct} của số tiền mục tiêu là {vstupni}. Phí quản lý {prubeznyPct} mỗi năm, cả thời gian là {prubezne}. Mọi chi phí cũng có trong giấy tờ của công ty bảo hiểm.',
          otazka: 'Phí hết bao nhiêu?',
        },
        vratiSe: {
          odpoved: 'Không phải toàn bộ. Phần trả cho bảo vệ là giá của việc gia đình được bảo vệ suốt thời gian đó — phần này không hoàn lại, giống như bảo hiểm bắt buộc cho xe. Tiền cho tuổi già chỉ đến từ phần đầu tư và số tiền không chắc chắn.',
          otazka: 'Nếu không có chuyện gì, tiền đã đóng có được trả lại không?',
        },
        vybrat: {
          odpoved: 'Từ phần đầu tư thường là được. Rút bao nhiêu, nhanh chậm và phí thế nào là do hợp đồng quy định. Phần bảo vệ không được hoàn lại, nên tiền cần gấp nên để dự phòng trong tài khoản, bên cạnh hợp đồng.',
          otazka: 'Khi không có tiền, tôi có rút ra được không?',
        },
        vynos: {
          odpoved: 'Vì tiền được đầu tư đều đặn và trong thời gian dài. 5, 7 và 9 % là mức lãi suất minh họa, không phải lời hứa — lợi nhuận thực tế có thể thấp hơn, thậm chí âm. Vì vậy biểu đồ luôn cho thấy cả tổng số tiền anh chị đã đóng.',
          otazka: 'Sao lãi được nhiều thế?',
        },
      },
      nadpis: 'Câu hỏi của anh chị',
      vedet: {
        dlouho: 'Đây là hợp đồng dài hạn. Nếu dừng trong mấy năm đầu, anh chị nhận lại rất ít hoặc không có gì.',
        nadpis: 'Ba điều anh chị cần biết',
        poplatky: 'Các loại phí được ghi bằng tiền ở phía trên, không chỉ bằng phần trăm.',
        vynos: 'Lợi nhuận không chắc chắn. Giá trị đầu tư có thể giảm.',
      },
    },
    pomocnik: {
      hledat: 'Tìm câu hỏi',
      nadpis: 'Người Việt ở Séc hay hỏi gì',
      nicNenalezeno: 'Không tìm thấy.',
      otevrit: 'Trợ giúp cho người tư vấn · {pocet} câu hỏi',
      pravo: 'Trả lời theo luật Séc, kiểm tra ngày 30/9/2026.',
      zdroj: 'Nguồn: {zdroj}',
    },
    prijmy: {
      ariaPrijem: 'Thu nhập gia đình {celkem}: {dily}',
      ariaVydaje: 'Thu nhập đi đâu: {dily}',
      chybi: 'thiếu',
      doDuchodu: 'đến khi nghỉ hưu',
      doplnPrijmy: 'Thanh thu nhập sẽ hiện khi nhập tuổi và thu nhập.',
      mesicne: 'mỗi tháng',
      nadpis: 'Tiền qua tay gia đình bao nhiêu',
      rocne: 'mỗi năm',
      splatky: 'trả nợ vay',
      uvod: 'Thu nhập của cả hai và tiền đi đâu.',
      volne: 'còn lại',
      vydaje: 'chi tiêu',
      vydajePole: 'Chi tiêu gia đình mỗi tháng (không tính trả nợ, có tính con cái)',
      vydajeUpresneni: 'không tính trả nợ vay, có tính con cái',
      vydajeVeta: 'Mỗi tháng gia đình tiêu',
    },
    rodina: {
      bezDeti: 'chưa có',
      bezPrijmu: 'không có thu nhập',
      bezPrijmuPrepinac: 'Hiện không có thu nhập (nghỉ nuôi con, ở nhà)',
      deti: 'Con',
      diteCislo: 'Con thứ {n}',
      mesicne: 'mỗi tháng',
      nadpis: 'Gia đình anh chị',
      odebratDite: 'Bỏ con thứ {n}',
      odebratPartnera: 'Bỏ người lớn thứ hai',
      osvc: 'tự kinh doanh (OSVČ)',
      pridatDite: 'Thêm con',
      pridatPartnera: 'Thêm vợ hoặc chồng',
      prijem: 'thu nhập ròng',
      prijemKoho: '{kdo} · thu nhập ròng mỗi tháng',
      uvod: 'Gia đình có những ai, mỗi người bao nhiêu tuổi và thu nhập bao nhiêu.',
      vek: 'năm nay',
      vekDitete: 'Con thứ {n} · tuổi',
      vekKoho: '{kdo} · tuổi',
    },
    role: {
      bo: 'Bố',
      boZkratka: 'B',
      me: 'Mẹ',
      meZkratka: 'M',
    },
    srovnani: {
      balicek: 'Gói',
      cimDriv: 'Nếu đến {vek} tuổi mới bắt đầu, anh chị đóng ít hơn {mene}, nhưng theo mô phỏng sẽ có ít hơn {cena} (theo giá trị tiền hôm nay).',
      legenda: 'Trong ô là giá trị mô phỏng, bên dưới là tổng số tiền đã đóng. Đơn vị {symbol}.',
      mesicne: '{castka} mỗi tháng',
      nadpis: 'Càng nhiều và càng sớm',
      ochranaStejna: 'phí bảo vệ {castka} mỗi tháng ở mọi gói',
      prazdno: 'Bảng so sánh sẽ hiện khi đã nhập thu nhập và phí bảo vệ.',
      startDnes: 'Bắt đầu hôm nay',
      startZa: 'Sau {roky} năm',
      tabulkaAria: 'Giá trị mô phỏng lúc {vek} tuổi với {vynos} % theo gói và thời điểm bắt đầu',
      uvod: 'Giá trị mô phỏng lúc {vek} tuổi với {vynos} %: tùy anh chị để dành bao nhiêu và bắt đầu khi nào.',
    },
    stitek: {
      bezNarokuInv: 'không có quyền hưởng lương hưu mất sức lao động',
      bezPrijmuDoplniPoradce: 'không có thu nhập, người tư vấn sẽ bổ sung mức bảo vệ',
      bezPrubeznehoPoplatku: 'chưa tính phí quản lý, thực tế sẽ thấp hơn',
      bezRustuMzdy: 'theo giá trị tiền hôm nay, chưa tính tăng lương',
      bezVstupnihoPoplatku: 'chưa tính phí ban đầu, thực tế sẽ thấp hơn',
      bezVynosuKratkyCil: 'mục tiêu ngắn hạn, tính không có lợi nhuận',
      dnesniPenize: 'theo giá trị tiền hôm nay (lạm phát 2,5 %)',
      duchodBezNaroku: 'không có quyền hưởng: dưới 5 năm bảo hiểm trong 10 năm',
      duchodMinimum: 'mức tối thiểu theo luật',
      duchodOsvcMinimalni: 'tự doanh: lương hưu theo mức đóng tối thiểu',
      duchodOveritNarok: 'chưa rõ quyền hưởng, tính là không có: kiểm tra bản trích lục ČSSZ',
      invaliditaBezPrijmuB: 'cha/mẹ không có thu nhập: bảo vệ phần chi tiêu tăng 20 % trừ lương hưu mất sức lao động',
      invaliditaPoOdchodu: 'sau tuổi nghỉ hưu không bảo hiểm mất sức lao động',
      modelovyVynos: 'lợi nhuận mô phỏng, không phải lời hứa; giá trị có thể giảm',
      narokNeovren: 'chưa xác minh quyền hưởng',
      ochranaJeNaklad: 'phí bảo vệ là chi phí cho sự bảo vệ, không được hoàn lại',
      osvcBezNemocenske: 'tự kinh doanh không đóng bảo hiểm ốm đau tự nguyện: nhà nước không trả',
      osvcNeodecteno: 'tự kinh doanh: chưa trừ lương hưu nhà nước, chỉ ČSSZ biết mức cụ thể',
      overitUPojistovny: 'cần xác nhận với công ty bảo hiểm (thường tối đa {strop})',
      podilNaPrijmu: 'phần mục tiêu theo tỷ lệ đóng góp vào thu nhập gia đình',
      podlePodminekPojistovny: 'theo điều khoản bảo hiểm',
      pozustalostniBezNaroku: 'chưa đủ thời gian đóng bảo hiểm: chưa trừ lương hưu cho vợ/chồng và con',
      pozustalostniBezPrijmu: 'không có thu nhập: chưa trừ lương hưu cho vợ/chồng và con, người tư vấn sẽ bổ sung',
      pozustalostniOsvc: 'tự kinh doanh: chưa trừ lương hưu cho vợ/chồng và con, chỉ cơ quan bảo hiểm xã hội biết quyền hưởng',
      sablona: 'số mẫu, người tư vấn sẽ kiểm tra',
      statOdhad: 'ước tính; chỉ có quyền hưởng khi đã đóng bảo hiểm 5 năm trong 10 năm gần nhất',
      statPoradce: 'do người tư vấn nhập',
      statSkDoplniPoradce: 'lương hưu tuổi già do người tư vấn bổ sung',
      statSkSablona: 'mức trung bình của Sociálna poisťovňa, người tư vấn sẽ kiểm tra',
      vdovskyJenManzelum: 'lương hưu cho vợ/chồng còn sống chỉ dành cho vợ chồng đã đăng ký kết hôn: chưa trừ',
      vdovskyNevime: 'chưa trừ lương hưu cho vợ/chồng còn sống: chưa nhập tình trạng hôn nhân',
      zoBezOdectuStatu: 'trợ cấp ốm đau chỉ bù cho thời gian nghỉ ốm, không trừ vào bảo hiểm bệnh hiểm nghèo',
    },
    stop: {
      bezBalicku: 'Hãy chọn gói hoặc nhập số tiền tự chọn.',
      bezCenyZajisteni: 'Phí bảo vệ do người tư vấn nhập theo bảng tính của công ty bảo hiểm.',
      bezCileDuchodu: 'Hãy nhập số tiền muốn có mỗi tháng khi nghỉ hưu.',
      bezHorizontu: 'Tuổi mục tiêu phải lớn hơn tuổi hiện tại.',
      bezNakladuNaDite: 'Hãy nhập chi phí nuôi một con mỗi tháng.',
      bezOsob: 'Hãy nhập ít nhất một người lớn.',
      bezPrijmu: 'Thiếu thu nhập ròng. Nếu đang ở nhà không có thu nhập, hãy bật “không có thu nhập”.',
      bezVeku: 'Thiếu tuổi.',
      bezVydaju: 'Thiếu chi tiêu hằng tháng của gia đình.',
      celyBalicekNaOchranu: 'Toàn bộ gói dùng để đóng phí bảo vệ. Từ gói này không tích lũy được gì cho tuổi già.',
      cilBydleniNeuplny: 'Mục nhà ở thiếu giá hoặc số năm.',
      dluhNeuplny: 'Khoản vay thiếu số dư hoặc số năm còn trả.',
      nejdrivRozpocet: 'Chi tiêu cao hơn thu nhập. Cần cân đối ngân sách trước, rồi mới chọn gói.',
      nejmensiNevejde: 'Ngay cả gói {pct} % ({balicek}) cũng lớn hơn số tiền còn dư {volne}. Hãy chọn số tiền riêng, hoặc cân đối ngân sách trước.',
      prubeznyMimoRozsah: 'Phí quản lý phải từ 0 đến {max} % mỗi năm.',
      vekMimoRozsah: 'Tuổi phải từ {min} đến {max}.',
      vekOdchoduMimoRozsah: 'Tuổi nghỉ hưu phải từ {min} đến {max}.',
      vynosMimoRozsah: 'Lợi nhuận sau phí nằm ngoài khoảng mà chúng tôi tính.',
    },
    suplik: {
      ano: 'Có',
      balicek: 'Gói',
      cenaOchrany: 'Phí bảo vệ mỗi tháng',
      cenaOchranyNapoveda: 'Theo bảng tính của công ty bảo hiểm. Ứng dụng không tự ước tính phí.',
      davkyNapoveda: 'Để trống = ước tính của ứng dụng theo luật.',
      douDospely: 'Trợ cấp ngày điều trị tai nạn của người lớn, mỗi ngày',
      invPodilNad40: 'Suy giảm trên 40 %: bao nhiêu % số tiền bảo hiểm',
      invalidniDuchod: 'Lương hưu mất sức lao động khi mất sức hoàn toàn, theo bản kê, mỗi tháng',
      manzelstvi: 'Hôn nhân',
      nadpis: 'Dành cho người tư vấn',
      narok: 'Có quyền hưởng lương hưu mất sức lao động (đóng bảo hiểm 5 năm trong 10 năm gần nhất)',
      ne: 'Không',
      nevim: 'Không biết',
      ochranaInvestice: 'Bảo vệ và đầu tư',
      osvc: 'Tự kinh doanh (OSVČ)',
      prubeznyPoplatek: 'Phí quản lý (% mỗi năm)',
      role: 'Là ai',
      sazba: 'Lãi suất',
      sezdani: 'Đã đăng ký kết hôn chưa? Lương hưu cho vợ/chồng còn sống chỉ dành cho vợ chồng.',
      splatka: 'Tiền trả hằng tháng',
      splatkaNapoveda: 'Để trống = tự tính tiền trả.',
      statniDuchod: 'Lương hưu tuổi già theo bản kê, mỗi tháng',
      stavDat: 'Tình trạng số liệu',
      tnu: 'Thương tật vĩnh viễn: số tiền bảo hiểm',
      typ: 'Hình thức thu nhập',
      uver: 'Khoản vay theo hợp đồng',
      varianta: 'Cách trả phí ban đầu',
      vekCil: 'Đầu tư đến tuổi',
      vlastniBalicek: 'Số tiền tự chọn mỗi tháng (thay cho 10–30 %)',
      volbyOchrany: 'Tùy chọn bảo vệ',
      vseZadano: 'Không thiếu gì.',
      vstupniPoplatek: 'Phí ban đầu (% của số tiền mục tiêu)',
      vynos: 'Lợi nhuận mô phỏng mỗi năm',
      zamestnanec: 'Người làm thuê',
      zavrit: 'Đóng',
      zoRoky: 'Bệnh hiểm nghèo: bao nhiêu năm thu nhập',
      zoRokyVolbaFew: '{n} năm',
      zoRokyVolbaMany: '{n} năm',
      zoRokyVolbaOne: '{n} năm',
      zoRucne: 'Bệnh hiểm nghèo nhập tay · {kdo}',
    },
    trapeni: {
      cesky: {
        odpoved: 'Giấy tờ có thể bằng tiếng Séc hoặc ngôn ngữ khác đã thỏa thuận. Tôi giải thích mọi thứ bằng tiếng Việt, nhưng văn bản hợp đồng mới là bản ràng buộc, và anh chị nhận biên bản buổi tư vấn. Anh chị không cần ký hôm nay — mang giấy tờ về, đọc cùng người mình tin, và đừng ký điều gì mình chưa hiểu.',
        otazka: 'Hợp đồng toàn tiếng Séc, tôi đọc không hiểu thì ký thế nào? Có cần ký luôn hôm nay không?',
        otazkaVi: 'Hợp đồng toàn tiếng Séc, tôi đọc không hiểu thì ký thế nào? Có cần ký luôn hôm nay không?',
        zdroj: 'Điều 79, 90 Luật phân phối bảo hiểm Séc; Điều 2789 Bộ luật Dân sự Séc; KID (quy định PRIIPs của EU)',
      },
      dane: {
        odpoved: 'Phí đóng cho bảo hiểm nhân thọ được ưu đãi thuế có thể trừ vào thu nhập chịu thuế, tối đa 48 000 Kč mỗi năm, tính chung với quỹ hưu trí và DIP. Điều kiện là nhận tiền sớm nhất vào năm 60 tuổi (hợp đồng từ 2024 còn cần ít nhất 120 tháng); rút sớm thì phần đã trừ bị tính thuế lại tới 10 năm trước. Anh chị chỉ tiết kiệm được phần thuế của số đã trừ, với thuế suất 15 % tối đa 7 200 Kč mỗi năm; người đóng thuế khoán và người không cư trú ngoài EU không được trừ.',
        otazka: 'Mua cái này có được khấu trừ thuế không? Được bao nhiêu?',
        otazkaVi: 'Mua cái này có được khấu trừ thuế không? Được bao nhiêu?',
        zdroj: 'Điều 15, 15a, 15b Luật thuế thu nhập Séc; Cơ quan thuế Séc',
      },
      deti: {
        odpoved: 'Trước hết bảo vệ thu nhập của bố mẹ, vì con sống nhờ thu nhập đó. Bảo hiểm cho con chủ yếu lo khi con bị tai nạn hay bệnh nặng, bố mẹ phải ở nhà và chi phí tăng; mặc định là bệnh hiểm nghèo 2 triệu Kč, thương tật vĩnh viễn 2 triệu Kč, trợ cấp 500 Kč mỗi ngày điều trị và 1 000 Kč mỗi ngày nằm viện. Mốc 23 tuổi là lựa chọn của kế hoạch — nhà nước coi con đang đi học là người phụ thuộc tối đa đến 26 tuổi.',
        otazka: 'Con còn nhỏ, có nên mua cho con không? Con đi học đại học thì cần tiền đến bao giờ?',
        otazkaVi: 'Con còn nhỏ, có nên mua cho con không? Con đi học đại học thì cần tiền đến bao giờ?',
        zdroj: 'Điều 20, 52 Luật bảo hiểm hưu trí Séc; phương pháp của bản phân tích này',
      },
      dotaznik: {
        odpoved: 'Có — mỗi câu hỏi đều phải trả lời trung thực và đầy đủ, kể cả bệnh vặt mà công ty hỏi. Nếu phát hiện khai thiếu, công ty có thể rút khỏi hợp đồng hoặc từ chối chi trả đúng lúc gia đình cần. Khai thật có thể bị tăng phí hoặc loại trừ bệnh đó, nhưng hợp đồng khi ấy vững chắc.',
        otazka: 'Khai sức khỏe có phải khai hết không? Bệnh vặt không khai có sao không?',
        otazkaVi: 'Khai sức khỏe có phải khai hết không? Bệnh vặt không khai có sao không?',
        zdroj: 'Điều 2788, 2808, 2809 Bộ luật Dân sự Séc',
      },
      duchodOsvc: {
        odpoved: 'Lương hưu và lương mất sức đều tính theo mức anh chị đã đóng, nên đóng tối thiểu thì sẽ thấp. Lương mất sức còn cần đủ thời gian đóng (trên 28 tuổi là 5 năm trong 10 năm gần nhất). Bảng kê chính xác số năm và mức đóng thì xin ở cơ quan bảo hiểm xã hội Séc (tờ thông tin cá nhân trên ePortál).',
        otazka: 'Tôi chỉ đóng bảo hiểm xã hội mức thấp nhất, sau này lương hưu được bao nhiêu? Mất sức lao động thì nhà nước trả gì?',
        otazkaVi: 'Tôi chỉ đóng bảo hiểm xã hội mức thấp nhất, sau này lương hưu được bao nhiêu? Mất sức lao động thì nhà nước trả gì?',
        zdroj: 'Điều 16, 40 Luật bảo hiểm hưu trí Séc; Cơ quan bảo hiểm xã hội Séc',
      },
      invalidita: {
        odpoved: 'Mất sức lao động là khi vì sức khỏe mà khả năng làm việc giảm lâu dài; nhà nước chia làm ba mức: 35–49 %, 50–69 % và từ 70 % trở lên. Bảo hiểm trả theo điều khoản của mình — có nơi theo quyết định của cơ quan bảo hiểm xã hội, có nơi tự thẩm định, thường sau khi tình trạng sức khỏe đã ổn định. Vì vậy tôi luôn chỉ rõ trả từ mức nào và bao nhiêu.',
        otazka: 'Mất sức lao động là thế nào? Bao giờ thì được trả tiền?',
        otazkaVi: 'Mất sức lao động là thế nào? Bao giờ thì được trả tiền?',
        zdroj: 'Điều 39 Luật bảo hiểm hưu trí Séc; điều khoản bảo hiểm',
      },
      kamInvest: {
        odpoved: 'Phần đầu tư mua chứng chỉ quỹ mà anh chị chọn trong danh sách của công ty — quỹ cổ phiếu, trái phiếu, cân bằng hoặc tiền tệ. Càng nhiều cổ phiếu thì lợi nhuận có thể cao hơn nhưng dao động cũng lớn hơn, và giá trị có thể xuống dưới số tiền đã bỏ vào. Thường có thể đổi chiến lược, điều kiện và phí có trong biểu phí.',
        otazka: 'Tiền này đầu tư vào đâu? Có bị mất trắng không?',
        otazkaVi: 'Tiền này đầu tư vào đâu? Có bị mất trắng không?',
        zdroj: 'Điều 86 Luật phân phối bảo hiểm Séc; KID (quy định PRIIPs của EU)',
      },
      kolikStoji: {
        odpoved: 'Phí bảo vệ thì chỉ công ty bảo hiểm mới tính được — tùy tuổi, sức khỏe, nghề nghiệp và số tiền bảo hiểm, nên trong bản phân tích chỉ có con số lấy từ bảng tính của họ, không ước đoán. Trước khi ký, công ty bảo hiểm phải cho biết bao nhiêu tiền đóng dùng cho rủi ro (khoản này tiêu hết), bao nhiêu cho chi phí và bao nhiêu được đầu tư. Gói 10–30 % thu nhập là khung ngân sách, không phải giá.',
        otazka: 'Mỗi tháng phải đóng bao nhiêu? Trong đó bao nhiêu là tiền bảo hiểm, bao nhiêu được đầu tư?',
        otazkaVi: 'Mỗi tháng phải đóng bao nhiêu? Trong đó bao nhiêu là tiền bảo hiểm, bao nhiêu được đầu tư?',
        zdroj: 'Điều 84, 86 Luật phân phối bảo hiểm Séc; KID (quy định PRIIPs của EU); phương pháp của bản phân tích này',
      },
      komu: {
        odpoved: 'Người được anh chị ghi vào hợp đồng là người thụ hưởng — có thể là bố mẹ ở Việt Nam (họ tên, ngày sinh, liên lạc). Nếu không chỉ định ai, luật ưu tiên vợ hoặc chồng, rồi đến con, bố mẹ và người thừa kế. Người thụ hưởng có thể đổi bất cứ lúc nào bằng văn bản; việc trả tiền ra nước ngoài chúng ta kiểm tra trong điều khoản.',
        otazka: 'Nếu tôi mất thì ai nhận tiền? Bố mẹ tôi ở Việt Nam có nhận được không?',
        otazkaVi: 'Nếu tôi mất thì ai nhận tiền? Bố mẹ tôi ở Việt Nam có nhận được không?',
        zdroj: 'Điều 2829, 2831, 2832 Bộ luật Dân sự Séc',
      },
      krach: {
        odpoved: 'Công ty bảo hiểm ở Séc chịu sự giám sát của Ngân hàng Quốc gia Séc và phải giữ vốn cùng dự phòng nghiệp vụ; khi giải thể, tài sản dùng để bù các nghĩa vụ được ưu tiên trả cho quyền lợi bảo hiểm. Bảo hiểm tiền gửi như ở ngân hàng không áp dụng cho bảo hiểm nhân thọ. Phần đầu tư còn lên xuống theo giá trị quỹ, không phụ thuộc vào công ty.',
        otazka: 'Nếu công ty bảo hiểm phá sản thì tiền của tôi thế nào?',
        otazkaVi: 'Nếu công ty bảo hiểm phá sản thì tiền của tôi thế nào?',
        zdroj: 'Điều 123 Luật kinh doanh bảo hiểm Séc',
      },
      nemocny: {
        odpoved: 'Tùy bệnh, cách điều trị và công ty bảo hiểm: nhận với phí bình thường, tăng phí, loại trừ riêng bệnh đó, hoãn lại hoặc từ chối. Công ty quyết định sau khi xem tờ khai sức khỏe, có khi cả giấy bác sĩ, và một số quyền lợi bổ sung có thời gian chờ. Vì vậy hãy khai bệnh ngay — trước đó không ai hứa trước được.',
        otazka: 'Tôi đang bị cao huyết áp, tiểu đường… thì có mua bảo hiểm được không?',
        otazkaVi: 'Tôi đang bị cao huyết áp, tiểu đường… thì có mua bảo hiểm được không?',
        zdroj: 'Điều 2788 Bộ luật Dân sự Séc; Điều 84 Luật phân phối bảo hiểm Séc; điều khoản bảo hiểm',
      },
      nesezdani: {
        odpoved: 'Lương hưu cho người vợ hoặc chồng còn sống chỉ dành cho vợ chồng đã đăng ký kết hôn. Nhưng trong hợp đồng bảo hiểm, ai cũng có thể là người thụ hưởng, nên hãy ghi tên người ấy vào hợp đồng. Nếu không chỉ định, luật trao tiền cho vợ hoặc chồng, con, bố mẹ và người thừa kế — người sống chung chưa kết hôn không nằm trong số đó.',
        otazka: 'Chúng tôi sống với nhau nhưng chưa đăng ký kết hôn. Nếu tôi mất thì người kia có được gì không?',
        otazkaVi: 'Chúng tôi sống với nhau nhưng chưa đăng ký kết hôn. Nếu tôi mất thì người kia có được gì không?',
        zdroj: 'Điều 49, 50 Luật bảo hiểm hưu trí Séc; Điều 2829, 2831 Bộ luật Dân sự Séc',
      },
      osvcPn: {
        odpoved: 'Người tự kinh doanh chỉ nhận trợ cấp ốm đau khi đã tự nguyện đóng bảo hiểm ốm đau ít nhất 3 tháng trước khi ốm — và cả khi đó cũng chỉ từ ngày thứ 15, tính trên mức đóng thấp. Không đóng thì không có trợ cấp ốm đau của nhà nước, trong khi chi tiêu vẫn chạy. Vì vậy với người tự kinh doanh chúng ta tính bảo hiểm mất khả năng làm việc tạm thời; trả từ ngày thứ mấy thì theo điều khoản.',
        otazka: 'Tôi tự kinh doanh, nếu ốm phải nghỉ mấy tháng thì nhà nước có trả gì không?',
        otazkaVi: 'Tôi tự kinh doanh, nếu ốm phải nghỉ mấy tháng thì nhà nước có trả gì không?',
        zdroj: 'Điều 24, 26, 29 Luật bảo hiểm ốm đau Séc; Cơ quan bảo hiểm xã hội Séc',
      },
      podvod: {
        odpoved: 'Công ty bảo hiểm phải có giấy phép của Ngân hàng Quốc gia Séc và người tư vấn phải có tên trong danh sách của họ — anh chị tự tra được theo tên. Trước khi ký, anh chị nhận bằng văn bản điều khoản bảo hiểm, bản thông tin chính (KID) có chi phí và biên bản buổi tư vấn, kể cả rủi ro. Không cần ký ngay, và khi có tranh chấp có thể nhờ trọng tài tài chính mà không mất phí.',
        otazka: 'Cái này có phải lừa đảo không? Ở Việt Nam người ta mua bảo hiểm qua ngân hàng rồi mất tiền đấy.',
        otazkaVi: 'Cái này có phải lừa đảo không? Ở Việt Nam người ta mua bảo hiểm qua ngân hàng rồi mất tiền đấy.',
        zdroj: 'danh sách của Ngân hàng Quốc gia Séc; Điều 79, 88 Luật phân phối bảo hiểm Séc; Điều 18 Luật trọng tài tài chính Séc',
      },
      poplatky: {
        odpoved: 'Mọi chi phí đều có trong giấy tờ: cơ cấu phí trước khi ký, chi phí theo thời gian trong KID và từng loại phí trong biểu phí. Một phần chi phí trả trong mấy năm đầu, nên lúc đó tài khoản đầu tư tăng chậm; phí ban đầu tính trên số tiền mục tiêu thì anh chị thấy riêng bằng tiền trong bản phân tích. Mỗi năm công ty gửi bản sao kê có giá trị tài khoản, giá trị hoàn lại và chi phí.',
        otazka: 'Phí gì mà nhiều thế? Mấy năm đầu tiền của tôi đi đâu?',
        otazkaVi: 'Phí gì mà nhiều thế? Mấy năm đầu tiền của tôi đi đâu?',
        zdroj: 'Điều 84, 86, 89 Luật phân phối bảo hiểm Séc; KID (quy định PRIIPs của EU)',
      },
      provize: {
        odpoved: 'Tôi nhận thù lao từ công ty bảo hiểm; loại thù lao phải được thông báo cho anh chị và có trong thông tin trước khi ký. Luật chia thù lao đó ra 5 năm — nếu hợp đồng dừng sớm, tôi phải trả lại một phần. Vì vậy tôi cần một hợp đồng mà anh chị đóng được lâu dài.',
        otazka: 'Anh/chị bán cái này được hoa hồng bao nhiêu?',
        otazkaVi: 'Anh/chị bán cái này được hoa hồng bao nhiêu?',
        zdroj: 'Điều 50, 88 Luật phân phối bảo hiểm Séc',
      },
      rodice: {
        odpoved: 'Tiền gửi bố mẹ chúng ta đưa vào chi tiêu của gia đình, để cả phần tính bảo vệ cũng tính đến. Nếu ốm hay tai nạn làm mất thu nhập, tiền bảo hiểm giúp tiếp tục khoản này. Phòng khi mất, anh chị có thể ghi bố mẹ là người thụ hưởng; việc trả tiền về Việt Nam chúng ta kiểm tra trong điều khoản.',
        otazka: 'Tháng nào tôi cũng gửi tiền về cho bố mẹ. Nếu tôi ốm hay có chuyện gì thì ai gửi?',
        otazkaVi: 'Tháng nào tôi cũng gửi tiền về cho bố mẹ. Nếu tôi ốm hay có chuyện gì thì ai gửi?',
        zdroj: 'Điều 2829 Bộ luật Dân sự Séc; phương pháp của bản phân tích này',
      },
      rozvod: {
        odpoved: 'Sau ly hôn hãy kiểm tra người thụ hưởng: vợ hoặc chồng cũ đã ghi tên vẫn là người thụ hưởng cho đến khi anh chị đổi bằng văn bản. Bên mua bảo hiểm quản lý hợp đồng, và nếu người được bảo hiểm là người khác thì đổi người thụ hưởng hay rút giá trị hoàn lại cần cả sự đồng ý của họ. Phần đầu tư chia thế nào là việc phân chia tài sản — việc đó nên hỏi luật sư.',
        otazka: 'Nếu sau này ly hôn thì hợp đồng và tiền trong đó thuộc về ai?',
        otazkaVi: 'Nếu sau này ly hôn thì hợp đồng và tiền trong đó thuộc về ai?',
        zdroj: 'Điều 2826, 2829, 2830, 2832 Bộ luật Dân sự Séc',
      },
      sezona: {
        odpoved: 'Chỉ khi hợp đồng cho phép rõ ràng — sản phẩm cụ thể cho làm gì (giảm phí, tạm ngừng đóng, trừ phí bảo vệ từ tài khoản đầu tư), tôi sẽ chỉ trong điều khoản. Nếu không đóng, công ty sẽ gửi nhắc nhở với thời hạn thêm ít nhất một tháng, sau đó bảo hiểm có thể chấm dứt. Vì vậy mức đóng nên tính theo những tháng làm ăn kém, không theo tháng tốt nhất.',
        otazka: 'Làm ăn lúc được lúc không, mùa ế thì có tạm ngừng hoặc đóng ít đi được không?',
        otazkaVi: 'Làm ăn lúc được lúc không, mùa ế thì có tạm ngừng hoặc đóng ít đi được không?',
        zdroj: 'Điều 2804, 2838 Bộ luật Dân sự Séc; điều khoản bảo hiểm',
      },
      skoncit: {
        odpoved: 'Chi phí ban đầu thường được trừ trong mấy năm đầu, nên hợp đồng ngắn thì đắt và giá trị hoàn lại lúc đầu thường thấp. Chúng ta lập hợp đồng theo mục tiêu — cho tuổi già và cho những năm con còn đi học. Nhưng vẫn có thể dừng: trong 30 ngày kể từ khi nhận xác nhận hợp đồng thì có quyền hủy, trong 2 tháng đầu có thể chấm dứt, về sau chấm dứt và nhận giá trị hoàn lại.',
        otazka: 'Sao phải đóng lâu thế? Nếu muốn dừng giữa chừng thì sao?',
        otazkaVi: 'Sao phải đóng lâu thế? Nếu muốn dừng giữa chừng thì sao?',
        zdroj: 'Điều 2805, 2808, 2842 Bộ luật Dân sự Séc; Điều 86 Luật phân phối bảo hiểm Séc',
      },
      staraSmlouva: {
        odpoved: 'Đừng hủy hợp đồng cũ vì hợp đồng mới khi chưa so sánh bằng văn bản: sẽ phải trả lại chi phí ban đầu, tờ khai mới xét theo tuổi và sức khỏe hiện tại, và hợp đồng có khấu trừ thuế có thể bị truy thu thuế. Ngân hàng Quốc gia Séc đã cảnh báo rõ về việc hủy hợp đồng không cần thiết. Nhiều khi chỉ cần điều chỉnh hợp đồng cũ hoặc bổ sung phần còn thiếu.',
        otazka: 'Tôi có hợp đồng cũ với người khác rồi, có nên hủy để làm cái mới không?',
        otazkaVi: 'Tôi có hợp đồng cũ với người khác rồi, có nên hủy để làm cái mới không?',
        zdroj: 'cảnh báo của Ngân hàng Quốc gia Séc về việc hủy hợp đồng; Điều 15b Luật thuế thu nhập Séc',
      },
      stari: {
        odpoved: 'Con cái giúp đỡ là điều quý, và mục tiêu là để đó là tấm lòng, không phải điều bắt buộc. Có tiền riêng cho tuổi già thì bố mẹ được tự chọn: sống ở đâu, có về Việt Nam không, giúp cháu thế nào. Số tiền trên biểu đồ là mô phỏng và không chắc chắn.',
        otazka: 'Có con rồi, về già con nó lo, cần gì phải mua cái này?',
        otazkaVi: 'Có con rồi, về già con nó lo, cần gì phải mua cái này?',
        zdroj: 'phương pháp của bản phân tích này; Điều 86 Luật phân phối bảo hiểm Séc',
      },
      vietnam: {
        odpoved: 'Hợp đồng có tiếp tục sau khi chuyển về không, có hiệu lực ngoài nước Séc không, đóng và nhận tiền ở nước ngoài thế nào — đều do điều khoản quy định, nên trước khi ký chúng ta hỏi công ty bằng văn bản và anh chị giữ lại câu trả lời. Chuyển đi rồi thì thuế cũng thay đổi (người không cư trú ngoài EU không được khấu trừ). Lương hưu Séc có thể nhận ở Việt Nam, điều kiện hỏi Cơ quan bảo hiểm xã hội Séc.',
        otazka: 'Sau này cả nhà về Việt Nam thì hợp đồng thế nào? Có đóng tiếp được không, tiền có chuyển về Việt Nam được không?',
        otazkaVi: 'Sau này cả nhà về Việt Nam thì hợp đồng thế nào? Có đóng tiếp được không, tiền có chuyển về Việt Nam được không?',
        zdroj: 'Điều 2789 Bộ luật Dân sự Séc; Điều 84 Luật phân phối bảo hiểm Séc; Điều 15 Luật thuế thu nhập Séc; Cơ quan bảo hiểm xã hội Séc',
      },
      vratiSe: {
        odpoved: 'Không được trả lại toàn bộ. Phần dùng để trả cho bảo vệ là giá của việc cả nhà được bảo vệ suốt thời gian đó, và không được hoàn lại — giống như bảo hiểm xe. Tiền cho tuổi già chỉ đến từ phần đầu tư, sau khi trừ chi phí, và lợi nhuận không chắc chắn.',
        otazka: 'Nếu không có chuyện gì thì tiền đóng bảo hiểm có được trả lại không?',
        otazkaVi: 'Nếu không có chuyện gì thì tiền đóng bảo hiểm có được trả lại không?',
        zdroj: 'Điều 86 Luật phân phối bảo hiểm Séc',
      },
      vybrat: {
        odpoved: 'Từ phần đầu tư thường có thể rút tiền bất thường; số dư tối thiểu, phí và thời hạn do điều khoản quy định. Khi chấm dứt cả hợp đồng thì có quyền nhận giá trị hoàn lại (sau khi đã đóng ít nhất hai năm, nếu hợp đồng không loại trừ) và công ty trả trong vòng ba tháng. Vì vậy tiền cần gấp nên để dự phòng trong tài khoản, bên cạnh hợp đồng.',
        otazka: 'Lúc cần tiền gấp thì có rút ra được không? Bao lâu thì nhận được tiền?',
        otazkaVi: 'Lúc cần tiền gấp thì có rút ra được không? Bao lâu thì nhận được tiền?',
        zdroj: 'Điều 2842 Bộ luật Dân sự Séc; Điều 86 Luật phân phối bảo hiểm Séc; KID (quy định PRIIPs của EU)',
      },
      vyluky: {
        odpoved: 'Mỗi rủi ro có định nghĩa và điều khoản loại trừ riêng — tôi sẽ cho anh chị xem trước khi ký. Thương tật vĩnh viễn và trợ cấp ngày chỉ trả cho tai nạn; mất sức lao động, bệnh hiểm nghèo và nghỉ ốm thì tùy điều khoản cả khi bị bệnh. Mất việc hay đóng cửa hàng thường không phải là sự kiện bảo hiểm.',
        otazka: 'Trường hợp nào thì bảo hiểm không trả? Ốm có được trả không hay chỉ tai nạn?',
        otazkaVi: 'Trường hợp nào thì bảo hiểm không trả? Ốm có được trả không hay chỉ tai nạn?',
        zdroj: 'Điều 84 Luật phân phối bảo hiểm Séc; Điều 2837 Bộ luật Dân sự Séc; điều khoản bảo hiểm',
      },
      vynos: {
        odpoved: '5, 7 và 9 % là mức lãi suất minh họa, không phải lời hứa. Khoản đầu tư có thể lỗ và rủi ro là của khách hàng — vì vậy KID còn có cả kịch bản xấu và kịch bản căng thẳng. Thời gian dài làm giảm dao động nhưng không xóa được, nên biểu đồ luôn cho thấy tổng số tiền anh chị đã đóng.',
        otazka: 'Sao lãi được nhiều thế? Có chắc được 7 % một năm không?',
        otazkaVi: 'Sao lãi được nhiều thế? Có chắc được 7 % một năm không?',
        zdroj: 'Điều 86 Luật phân phối bảo hiểm Séc; KID (quy định PRIIPs của EU)',
      },
      zavazneOnem: {
        odpoved: 'Trả một lần khi bác sĩ xác nhận một bệnh có trong danh sách của điều khoản; danh sách, định nghĩa và giai đoạn bệnh mỗi công ty một khác. Tiền này dùng vào việc gì cũng được — bù thu nhập, chăm sóc, đi lại chữa bệnh. Trong bản phân tích của chúng ta, mức mặc định là một năm thu nhập ròng (có thể chọn hai hoặc ba năm).',
        otazka: 'Bảo hiểm bệnh hiểm nghèo là gì? Bị ung thư thì có được trả không?',
        otazkaVi: 'Bảo hiểm bệnh hiểm nghèo là gì? Bị ung thư thì có được trả không?',
        zdroj: 'Điều 84 Luật phân phối bảo hiểm Séc; điều khoản bảo hiểm; phương pháp của bản phân tích này',
      },
      zdravotniCizinec: {
        odpoved: 'Bảo hiểm y tế thương mại trả tiền chữa bệnh, nhưng không bù thu nhập khi anh chị không làm việc được, và không chi trả cho gia đình khi mất hay mất sức lao động. Bảo hiểm y tế công chủ yếu dành cho người có thường trú hoặc người làm thuê cho chủ Séc. Chữ „bảo hiểm“ có cả hai nghĩa, nên tôi luôn nói rõ đang nói về loại nào.',
        otazka: 'Tôi có bảo hiểm y tế thương mại cho người nước ngoài rồi, thế chưa đủ à?',
        otazkaVi: 'Tôi có bảo hiểm y tế thương mại cho người nước ngoài rồi, thế chưa đủ à?',
        zdroj: 'Điều 2 Luật bảo hiểm y tế công Séc',
      },
      zvlast: {
        odpoved: 'Cũng được: mua bảo hiểm nhân thọ rủi ro chỉ để bảo vệ và đầu tư riêng. Điều quyết định là cách nào sau mọi chi phí có lợi hơn và cách nào anh chị thật sự duy trì được — tôi có thể tính cả hai cách cạnh nhau từ KID và biểu phí. Quyết định là của anh chị và tôi ghi vào biên bản tư vấn.',
        otazka: 'Sao không mua bảo hiểm rủi ro cho rẻ, còn tiền thì tự đầu tư riêng?',
        otazkaVi: 'Sao không mua bảo hiểm rủi ro cho rẻ, còn tiền thì tự đầu tư riêng?',
        zdroj: 'Điều 78, 79 Luật phân phối bảo hiểm Séc; KID (quy định PRIIPs của EU)',
      },
    },
    ui: {
      chybaVypoctu: 'Không tính được. Hãy kiểm tra lại số liệu đã nhập.',
      hotovo: 'Xong',
      metodika: 'Phương pháp tính phiên bản {verze}.',
      vymazat: 'Xóa',
    },
    varovani: {
      balicekNadVolne: 'Gói {pct} % vượt ngân sách, thiếu {chybi} mỗi tháng.',
      detiSamostatne: 'Con từ {vek} tuổi không tính: {pocet}.',
      duchodNadBalicek: 'Để dành cho tuổi già cần {odkladat} mỗi tháng, nhiều hơn cả gói {balicek}.',
      ochranaNadBalicek: 'Phí bảo vệ cao hơn cả gói, không còn tiền để đầu tư.',
      poVekuOdchodu: 'Đã đến hoặc quá tuổi nghỉ hưu.',
      splatkaDopocitana: 'Tiền trả hằng tháng là ước tính ({splatka} với lãi {sazbaPct} % mỗi năm). Hãy chép số chính xác từ hợp đồng.',
      vydajeNadPrijmy: 'Chi tiêu và tiền trả nợ vượt thu nhập {chybi}.',
      vynosMimoScenare: 'Lợi nhuận {vynos} % không thuộc các kịch bản 5 / 7 / 9 %.',
    },
    vypadek: {
      bez: 'Không có bảo hiểm',
      bezZdroje: 'Phần này không có nguồn tiền nào bù vào.',
      chybiCastka: 'thiếu {castka} mỗi tháng',
      chybiJednorazove: 'Hằng tháng không thiếu, nhưng các mục tiêu sẽ thiếu {castka}.',
      chybiMesicne: 'Mỗi tháng thiếu',
      cip: {
        infarkt: 'Nhồi máu cơ tim',
        ledviny: 'Suy thận',
        mrtvice: 'Đột quỵ',
        ochrnuti: 'Bị liệt',
        rakovina: 'Ung thư',
        roztrousena: 'Xơ cứng rải rác',
        srdce: 'Phẫu thuật tim',
        uraz: 'Tai nạn nghiêm trọng',
      },
      cipyAria: 'Ví dụ về bệnh tật và biến cố',
      cipyPoznamka: 'Chỉ là ví dụ. Hợp đồng bảo vệ những gì là do điều khoản hợp đồng quy định.',
      jakSpocitano: 'Số tiền này được tính thế nào',
      kdoAria: 'Thu nhập của ai bị mất',
      krokChybi: 'Phần còn thiếu = số tiền bảo hiểm',
      krokPotreba: 'Gia đình cần bao nhiêu (theo mục tiêu của anh chị)',
      krokStat: 'Nhà nước hỗ trợ',
      krytoCastka: 'được bù {castka} mỗi tháng',
      legendaChybi: 'thiếu, không có nguồn bù',
      legendaKryto: 'bảo hiểm lo',
      legendaPartner: '{kdo} vẫn gánh',
      nadpis: 'Nếu chẳng may mất một nguồn thu nhập',
      nesePartner: '{kdo} vẫn gánh {pct} % mục tiêu bằng thu nhập của mình.',
      nicNechybi: 'Thu nhập của người còn lại đủ lo trường hợp này.',
      nicNechybiSam: 'Không mục tiêu nào anh chị đã nhập bị thiếu nguồn tiền.',
      pojistnaCastka: 'Số tiền bảo hiểm',
      prazdno: 'Sẽ tính khi đã nhập tuổi, thu nhập và chi tiêu của gia đình.',
      radek: {
        bydleni: 'Trả nợ nhà',
        deti: 'Con đến 23 tuổi',
        duchod: 'Để dành cho tuổi già',
        zivot: 'Chi tiêu hằng ngày của gia đình',
      },
      s: 'Có bảo hiểm',
      sZdrojem: 'Khoảng thiếu được bù, mục tiêu của gia đình vẫn giữ được.',
      udalost: {
        invalidita: 'Mất sức lao động',
        smrt: 'Qua đời',
      },
      udalostAria: 'Chuyện gì xảy ra',
      uvod: 'Bệnh tật hay tai nạn có thể đến bất ngờ. Khi đó mục tiêu của gia đình sẽ ra sao, và điều gì giữ vững gia đình.',
      veta: {
        invalidita: {
          bo: 'Nếu chẳng may bố không thể đi làm lâu dài, thu nhập của bố sẽ dừng lại.',
          me: 'Nếu chẳng may mẹ không thể đi làm lâu dài, thu nhập của mẹ sẽ dừng lại.',
        },
        smrt: {
          bo: 'Nếu chẳng may bố không còn nữa, gia đình mất hẳn thu nhập của bố.',
          me: 'Nếu chẳng may mẹ không còn nữa, gia đình mất hẳn thu nhập của mẹ.',
        },
      },
    },
    zaver: {
      nadpis: 'Hai con đường',
      nestane: 'Nếu bình an — có tiền cho tuổi già, không phải trông chờ vào con cái.',
      nestanePuvod: 'Chỉ đến từ phần đầu tư: {investice} mỗi tháng trong {roky}, tổng cộng {zaplaceno}. Lợi nhuận không chắc chắn.',
      nestaneVek: 'lúc {vek} tuổi · mô phỏng {vynos} %',
      stane: 'Nếu chẳng may có chuyện gì — cả gia đình được bảo vệ.',
      stanePuvod: 'Trả từ gói {balicek}: mỗi tháng {ochrana} dành cho bảo vệ. Đó là giá của sự bảo vệ và không hoàn lại.',
      staneRiziko: {
        invalidita: '{kdo} · mất sức lao động',
        smrt: '{kdo} · qua đời',
      },
    },
  },
  /* BLOK:vnRodina END */
  /* BLOK:kalkLista START — generuje scratchpad/slovnik.py, ručně needitovat */
  kalkLista: {
    cekani: {
      aria: 'Ngay bây giờ {hned}, nếu trì hoãn {pozdeji}, giá của chờ đợi {cena}. Mỗi cột là 5 năm, mỗi lớp là một đợt góp.',
      blok: 'Khoản góp năm {od}–{do}',
      budeMit: 'Sẽ có sau {roky}',
      hned: 'Ngay',
      horizont: 'Kỳ hạn',
      mesicne: 'Hàng tháng',
      otazkaHned: 'Nếu bắt đầu ngay, sau {roky} sẽ có',
      otazkaPozde: 'Nếu bắt đầu muộn {roky}, sẽ mất',
      pracuji: 'Tiền đang sinh lời',
      vetaHned: 'Mỗi 5 năm góp là một lớp — lớp dưới cùng sinh lời lâu nhất.',
      vetaPozde: 'Đó là số tiền mà {roky} góp đầu tiên sẽ đạt được — chúng sinh lời lâu nhất.',
      vlozi: 'Góp vào',
      vynos: 'Lợi suất năm',
      zacne: 'Bắt đầu sau',
      ztrata: 'Mất do chờ đợi',
    },
    dopl: {
      aria: 'Dư nợ {dluh} giảm dần, danh mục sau thuế tăng lên. Hai đường gặp nhau sau {doba}, khi còn phải trả {castka}. Lợi suất hòa vốn {hranice}.',
      ariaNikdy: 'Dư nợ {dluh} giảm dần, danh mục sau thuế không đuổi kịp trong {roky}.',
      bublinaMim: 'Dư nợ khi trả trước',
      chybiDo: 'Còn thiếu để trả hết',
      hranice: 'Lợi suất hòa vốn',
      hraniceNad: 'trên 30 %',
      hraniceZnacka: 'hòa vốn {pct}',
      investice: 'Đầu tư',
      investiceMes: 'Đầu tư mỗi tháng',
      jistina: 'Còn phải trả',
      konecSplatnosti: 'hết kỳ hạn',
      lzeDoplatit: 'có thể trả hết',
      mimBezDluhu: 'Trả trước: hết nợ sau',
      mimoradne: 'Trả trước',
      nadInflaci: 'Trên lạm phát',
      nastejno: 'Ngang nhau',
      nelze: 'Không thể tính với các giá trị này — hãy kiểm tra lãi suất và kỳ hạn.',
      nesplati: 'Với khoản trả góp này, khoản vay không trả hết kể cả sau 80 năm.',
      nevyslo: 'Sau {roky}, danh mục không đủ để trả hết nợ — sau khi bán và nộp thuế còn thiếu {castka}.',
      nominalne: 'Danh nghĩa',
      nominalnePct: 'danh nghĩa {pct}',
      otazka: 'Với lợi suất {vynos}, đầu tư {castka} mỗi tháng sẽ trả hết khoản vay mua nhà sau',
      otazkaRealne: 'Với lợi suất {vynos} trên lạm phát, đầu tư {castka} mỗi tháng sẽ trả hết khoản vay mua nhà sau',
      poDani: 'sau thuế và phí',
      podleVynosu: 'Theo lợi suất',
      poznamka: 'Lợi suất đầu tư không được đảm bảo, tiền trả góp thì có. Thuế khi bán theo luật hiện hành.',
      poznamkaSk: 'Lợi suất đầu tư không được đảm bảo, tiền trả góp thì có. Chưa tính thuế khi bán khoản đầu tư (trước thuế) — ứng dụng chưa tính theo quy định của Slovakia.',
      propad: 'Giảm 35 %',
      radaDluh: 'Dư nợ còn lại',
      radaMim: 'Trả trước',
      radaPortfolio: 'Danh mục sau thuế',
      realne: 'thực {pct}',
      rezim: 'Cách nhập lợi suất',
      riziko: 'Rủi ro',
      sazba: 'Lãi suất vay',
      slRozdil: 'Danh mục − dư nợ',
      srovnatZa: 'So sánh sau',
      tabulkaPopis: 'Số tiền tính bằng {mena} cuối năm · danh mục sau thuế và phí (tổng {naklady})',
      ter: 'Phí hằng năm (TER)',
      trh: 'Thị trường năm so sánh',
      trhNic: 'Thị trường không sinh lời',
      vetaChybi: 'còn nợ {dluh}, danh mục sau thuế {portfolio}, còn thiếu {chybi} để trả hết.',
      vetaDnes: 'còn nợ {dluh}, khoản đầu tư bắt đầu từ 0.',
      vetaSplaceno: 'đã trả hết nợ, danh mục sau thuế {portfolio}.',
      vetaZbylo: 'còn nợ {dluh}, danh mục sau thuế {portfolio} — trả hết nợ vẫn còn {zbylo}.',
      vicNez: 'hơn {roky}',
      vstupni: 'Phí đầu vào',
      vyhodnejsi: 'Có lợi hơn sau {roky}',
      vyhravaInvestice: 'đầu tư có lợi hơn',
      vyhravaSplaceni: 'trả nợ có lợi hơn',
      vynos: 'Lợi suất mỗi năm',
      vynosPodUrokem: 'Lợi suất {vynos} không vượt lãi suất vay {sazba} — trả nợ có lợi hơn.',
      zbyloBy: 'Trả hết nợ vẫn còn',
      zbyvaLet: 'Thời gian còn lại',
    },
    historie: {
      aria: 'Diễn biến thực tế từ {od} đến {do}: đã góp {vlozeno}, hôm nay {hodnota}.',
      dynamicky: 'Năng động',
      hodnota: 'Giá trị',
      jednorazove: 'Một lần',
      konzervativni: 'Thận trọng',
      mesicne: 'Hàng tháng',
      otazka: 'Nếu bắt đầu từ năm {rok}, hôm nay sẽ có',
      otazkaObecna: 'Hôm nay sẽ có bao nhiêu',
      portfolio: 'Danh mục',
      roky: 'Bao nhiêu năm trước',
      veta: 'Diễn biến thực tế của thị trường {od}–{do}. Quá khứ không đảm bảo tương lai.',
      vklad: 'khoản góp',
      vlozeno: 'Đã góp',
      vlozil: 'Đã góp',
      vydelal: 'Sinh lời',
      vyvazeny: 'Cân bằng',
      zdroj: 'Nguồn dữ liệu: SBBI/Ibbotson (Mỹ)',
    },
    hypo: {
      aria: 'Dư nợ gốc {uver} giảm về 0 sau {roky}; tổng lãi phải trả {urok}.',
      bezJinychUveru: 'không có khoản vay khác',
      bezPrijmu: 'chưa nhập thu nhập',
      bezUveru: 'Vốn tự có đủ trả toàn bộ giá — không cần vay.',
      bezVeku: 'chưa nhập tuổi',
      bezZavazku: 'chưa nhập khoản nợ',
      bublinaJistina: 'Dư nợ gốc cuối năm',
      bublinaUroky: 'Tổng lãi đã trả',
      celkem: 'Tổng số tiền phải trả',
      cena: 'Giá bất động sản',
      doporuceniNad: 'vượt khuyến nghị {limit} của ČNB',
      doporuceniV: 'trong khuyến nghị {limit} của ČNB',
      dstiCo: 'Khoản trả so với thu nhập ròng, khuyến nghị của ČNB',
      dstiCoBez: 'Khoản trả so với thu nhập ròng',
      dtiCo: 'Nợ so với thu nhập năm, khuyến nghị của ČNB',
      dtiCoBez: 'Nợ so với thu nhập năm',
      dtiCoNbs: 'Tổng các khoản vay so với thu nhập ròng hằng năm, hạn mức bắt buộc của NBS',
      jineNevyplneno: 'Chưa nhập',
      jineUvery: 'Các khoản vay khác của khách hàng',
      jineZadne: 'Không có',
      ltvCo: 'Khoản vay so với giá bất động sản, hạn mức bắt buộc của {regulator}',
      ltvNad: 'vượt hạn mức {limit}',
      ltvV: 'trong hạn mức {limit}',
      minVlastni: 'tối thiểu {castka} (LTV {limit})',
      minVlastniRok: 'tối thiểu {castka} (LTV {limit} khi mua năm {rok})',
      nbsLimit: 'hạn mức NBS {limit}',
      nbsLimitNejvys: 'hạn mức NBS tối đa {limit}',
      nbsMaxUver: 'vay tối đa {castka}',
      nbsMaxUverNejvys: 'vay tối đa không quá {castka}',
      nbsNad: 'vượt hạn mức NBS {limit}',
      nbsV: 'trong hạn mức NBS {limit}',
      otazka: 'Khoản trả hàng tháng',
      poznamkaCz: 'LTV là hạn mức bắt buộc của ČNB; DSTI và DTI chỉ là khuyến nghị của ČNB.',
      poznamkaSk: 'LTV là hạn mức bắt buộc của NBS.',
      poznamkaSkNbs: 'LTV và DTI là hạn mức bắt buộc của NBS.',
      radaJistina: 'Dư nợ gốc',
      radaUroky: 'Lãi đã trả',
      sazba: 'Lãi suất',
      slUmor: 'Gốc đã trả',
      slUrok: 'Lãi đã trả',
      splatkaNevyplnena: 'chưa nhập khoản trả góp',
      splatkyNadPrijem: 'Tiền trả góp vượt thu nhập ròng {castka} mỗi tháng.',
      splatnost: 'Thời hạn',
      ukazatele: 'Chỉ số khoản vay',
      ukazateleCnb: 'Chỉ số ČNB',
      vetaDnes: 'còn nợ {jistina}, trả góp {splatka} mỗi tháng.',
      vetaRoku: 'còn nợ {jistina}, đã trả lãi tổng cộng {uroky}.',
      vlastni: 'Vốn tự có',
      zTohoJistina: 'Trong đó tiền gốc',
      zTohoUrok: 'Trong đó tiền lãi',
      zustatekNevyplnen: 'chưa nhập dư nợ',
    },
    jakoVPlanu: 'như trong kế hoạch',
    kostra: {
      celkem: 'Tổng',
      dnes: 'Hôm nay',
      grafOvladani: 'Dùng phím mũi tên để chọn năm; Home và End chuyển đến đầu và cuối.',
      grafRole: 'biểu đồ tương tác',
      rok: 'Năm {n}',
      sloupecRok: 'Năm',
      tabulka: 'Bảng theo từng năm',
      tabulkaPopis: 'Số tiền tính bằng {mena}, số liệu cuối năm',
      zaRoky: 'Trong {roky}',
    },
    letFew: '{n} năm',
    letMany: '{n} năm',
    letOne: '{n} năm',
    mesFew: '{n} tháng',
    mesMany: '{n} tháng',
    mesOne: '{n} tháng',
    mesicne: 'mỗi tháng',
    modelova: 'giá trị mẫu',
    nezadano: 'chưa nhập',
    paticka: 'Tính toán tham khảo, không phải chào bán hay cam kết. Không lưu gì vào phân tích.',
    prebytek: 'dòng tiền rảnh {castka}',
    prumerTrhu: 'trung bình thị trường',
    refi: {
      aria: 'Tổng phải trả hiện tại {dnes}, sau tái cấp vốn {nove}.',
      dnes: 'Hiện tại',
      jistina: 'Dư nợ còn lại',
      naklady: 'Chi phí chuyển đổi',
      nakladyPopisek: '+ {castka} chi phí chuyển đổi',
      nakladySerie: 'Chi phí chuyển đổi',
      novaSazba: 'Lãi suất mới',
      nove: 'Sau chuyển đổi',
      otazka: 'Sau khi tái cấp vốn tiết kiệm',
      otazkaHorsi: 'Lãi suất mới không thấp hơn — khoản trả tăng thêm',
      splatkaDnes: 'Khoản trả hiện tại',
      splatkaNova: 'Khoản trả mới',
      staraSazba: 'Lãi suất hiện tại',
      veta: 'Trong {roky} tiết kiệm tổng cộng {castka}; chi phí hoàn vốn sau {mesice}.',
      vetaBezNakladu: 'Trong {roky} tiết kiệm tổng cộng {castka}.',
      vetaHorsi: 'Trong {roky} phải trả thêm {castka}.',
      zbyvaLet: 'Thời gian còn lại',
    },
    renta: {
      aria: 'Vốn {kapital} cho thu nhập {renta} mỗi tháng. Trong {roky} sẽ chi trả {vyplaceno}, cuối kỳ còn lại {zbude}.',
      bublinaKapital: 'Vốn cuối năm',
      bublinaVyplaceno: 'Tổng đã chi trả',
      cerpani: 'Rút trong',
      cerpaniNavzdy: 'Rút mãi mãi',
      cerpaniRoky: 'Rút trong {roky}',
      navzdy: 'Mãi mãi',
      otazka: 'Để có {castka} mỗi tháng cần',
      poznamka: 'Lợi suất trên lạm phát, thu nhập tính theo giá trị tiền hôm nay. Lợi suất không được đảm bảo.',
      renta: 'Thu nhập hàng tháng',
      slKapital: 'Vốn',
      slVyplaceno: 'Tổng đã chi trả',
      vetaDnes: 'vốn {kapital}, thu nhập {renta} mỗi tháng.',
      vetaNavzdy: 'Thu nhập chỉ lấy từ lợi suất — vốn gốc giữ nguyên.',
      vetaRoku: 'vốn {kapital}, tổng đã chi trả {vyplaceno}.',
      vetaRoky: 'Sau {roky} vốn sẽ cạn.',
      vynos: 'Lợi suất trên lạm phát',
      vyplaceno: 'Đã chi trả trong {roky}',
      vyplacenoRada: 'Thu nhập đã nhận',
      zbude: 'Còn lại cuối kỳ',
      zustatek: 'Vốn',
    },
    splac: {
      aria: 'Dư nợ theo thời gian: ban đầu đến năm {puvodni}, có trả thêm đến năm {novy}.',
      driv: 'Hết nợ sớm hơn',
      mimoradna: 'Khoản trả thêm',
      nad25: 'Trả trên 25% dư nợ gốc mỗi năm, ngân hàng có thể thu phí.',
      nove: 'Có trả thêm',
      otazka: 'Khoản trả thêm giúp tiết kiệm tiền lãi',
      puvodne: 'Ban đầu',
      rezim: 'Sau khoản trả thêm',
      snizit: 'Giảm khoản trả',
      splatkaZustava: 'Khoản trả giữ nguyên',
      veta: 'Khoản nợ hết vào năm {novy} thay vì {puvodni}.',
      vetaDoplaceno: 'Khoản trả thêm đủ trả hết nợ.',
      vetaSnizit: 'Khoản trả giảm {castka} mỗi tháng đến hết hạn.',
      zkratit: 'Rút ngắn thời hạn',
    },
    tab: {
      cekani: 'Giá của chờ đợi',
      doplaceni: 'Vay mua nhà và đầu tư',
      historie: 'Lịch sử',
      hypoteka: 'Vay mua nhà',
      refinanc: 'Tái cấp vốn',
      renta: 'Thu nhập hưu trí',
      splaceni: 'Trả nợ sớm',
    },
    upravit: '{popisek}: {hodnota}. Nhập chính xác',
    vratitVychozi: 'Khôi phục giá trị mặc định',
    zAnalyzy: 'từ phân tích',
    zmensitKlavesa: 'Thu nhỏ (phím Z)',
    zvetsit: 'Phóng to công cụ tính',
    zvetsitKlavesa: 'Phóng to (phím Z)',
  },
  /* BLOK:kalkLista END */
  /* BLOK:brifink START — generuje scratchpad/slovnik.py, ručně needitovat */
  brifink: {
    poTerminu: 'Quá hạn ({datum})',
  },
  /* BLOK:brifink END */
  /* BLOK:planVek START — generuje scratchpad/slovnik.py, ručně needitovat */
  planVek: {
    doplnte: 'Hãy bổ sung tuổi của khách hàng',
    proc: 'Không có ngày sinh thì không thể xác minh ngoại lệ cho người dưới 36 tuổi, vì vậy khoản trả trước 10 % không được đề xuất.',
  },
  /* BLOK:planVek END */
  /* BLOK:pojisteniPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniPlan: {
    castCeny: 'mới chỉ là một phần phí',
    cenaCelkemNadpis: 'Tổng phí bảo hiểm',
    cenaCelkemPopis: 'Kế hoạch chỉ tính theo giá trong báo giá của công ty bảo hiểm.',
    cenaChybiDeti: 'Thiếu giá hợp đồng của trẻ em — kế hoạch chỉ trừ phần người lớn.',
    cenaChybiOsoba: 'Thiếu giá của {jmeno} — kế hoạch chỉ trừ phần đã nhập.',
    cenaDeti: 'Giá hợp đồng trẻ em',
    cenaDoplnte: 'Nhập giá từ công ty bảo hiểm',
    cenaOdPojistovny: 'Giá theo báo giá của công ty bảo hiểm',
    chybiCena: 'chưa có phí',
    detiZavazneNadStropem: 'Vượt hạn mức thẩm định {strop} — hãy kiểm tra với công ty bảo hiểm.',
    jakProgrese: 'Cách tính lũy tiến',
    kalkCenyVarianta: 'Giá cho phương án {varianta} — mỗi phương án có báo giá riêng.',
    mesicneProCilePoPojistnem: 'Hằng tháng cho mục tiêu (sau phí bảo hiểm)',
    naCile: 'Cho mục tiêu',
    nulaZdrojeKryji: 'Số tiền 0 = nguồn lực của gia đình (thu nhập của vợ/chồng, tài sản) đã đủ cho nhu cầu này.',
    orientacne: 'tham khảo ≈ {castka} — kế hoạch không tính khoản này',
    platbaNezadana: 'chưa nhập phí',
    pojistneZmena: 'Phí bảo hiểm — thay đổi',
    pouzitProVsechny: 'Áp dụng cho mọi phương án',
    prebytekPoPojistnem: 'Thặng dư sau phí bảo hiểm',
    prezBezCenyPozn: 'Các số tiền là đề xuất mức bảo vệ, không phải báo giá của công ty bảo hiểm. Phí và phạm vi chi trả, kể cả điều khoản loại trừ, do công ty bảo hiểm quy định trong hợp đồng và quy tắc bảo hiểm.',
    prezCenaPozn: 'Mức phí theo báo giá do tư vấn viên nhập — công ty bảo hiểm sẽ xác nhận phí cuối cùng trong hợp đồng sau khi thẩm định sức khỏe. Phạm vi chi trả và các điều khoản loại trừ do quy tắc bảo hiểm quy định.',
    prezZavazneProc: 'chi trả một lần cho điều trị — có thể nghỉ làm để chữa bệnh',
    rozpocetPojistne: 'Phí: hiện tại {stara} → mới {nova} ({rozdil})',
    rozpocetPojistneNove: 'Phí mới {nova} — đã tính vào chi phí bắt buộc',
    rucne: 'nhập tay',
    rusiSe: 'hủy',
    skrytProgresi: 'Ẩn cách tính lũy tiến',
    staraZustava: 'hợp đồng cũ được giữ lại',
    stareBezCeny: 'Phần chênh lệch sẽ được tính khi bạn nhập giá hợp đồng mới.',
    stareBezKrytiZivota: 'Không trừ — hợp đồng mới không bảo hiểm tử vong hay mất sức lao động cho người này, nên hợp đồng cũ được giữ lại.',
    stareBezNahrady: 'Chưa có phí — không trừ, hợp đồng mới chưa bảo vệ người này.',
    stareIdd: 'Chỉ hủy hợp đồng cũ sau khi hợp đồng mới được chấp nhận, vào ngày kỷ niệm hợp đồng, và ghi lý do vào biên bản buổi gặp.',
    stareMajetekBezCeny: 'Sẽ được giải phóng sau khi nhập giá hợp đồng mới.',
    stareMajetekBezNahrady: 'Không có hợp đồng mới nào thay thế — kế hoạch vẫn tiếp tục trả khoản này.',
    stareNadpis: 'Hợp đồng hiện có',
    stareNespoctenoPartner: 'Không trừ — kế hoạch chưa tính bảo hiểm cho vợ/chồng (thiếu ngày sinh), nên hợp đồng được giữ lại.',
    stareNeznama: 'Nhập phí của hợp đồng hiện có {nazev} — tạm thời trừ toàn bộ giá mới.',
    stareNic: 'Phí mới {nova} — không hủy hợp đồng hiện có nào, trừ toàn bộ.',
    stareRozdil: 'Phí: hiện tại {stara} → mới {nova} · chỉ trừ phần chênh lệch {rozdil}',
    tnuAria: 'Chi trả thương tật vĩnh viễn từ {castka}: ở mức {pct} % chi trả {vyplata}, ở mức 100 % tối đa {max}.',
    tnuOrientacne: 'Chỉ mang tính tham khảo — các bậc và hệ số khác nhau tùy công ty bảo hiểm, bảng chi trả chính xác do công ty bảo hiểm cung cấp.',
    tnuPasmo: 'bậc ×{n}',
    tnuPoskozeni: 'Mức thương tật {pct} %',
    tnuPri: 'ở mức {pct} %',
    tnuVolby: 'Số tiền bảo hiểm thương tật vĩnh viễn',
    tnuVyplati: 'chi trả',
    tnuVysvetleni: 'Trong mô hình của chúng tôi, mỗi bậc được nhân riêng: đến 20 % ×1, 20–40 % ×2, 40–60 % ×3, trên 60 % ×4. Ở mức 100 % tối đa {max}× số tiền.',
    vetaNad: 'Phần phí tăng thêm {rozdil} lớn hơn thặng dư hàng tháng {prebytek} — không còn gì cho mục tiêu.',
    vetaNove: 'Phí {nova} · cho mục tiêu {naCile}',
    vetaZmena: 'Phí: hiện tại {stara} → mới {nova} ({rozdil}) · cho mục tiêu {naCile}',
    vydajeNezbytne: 'chi phí thiết yếu',
    vydajeObvykle: 'chi phí thông thường',
    vydajeSplatkyPojistne: 'Chi phí + trả nợ + phí bảo hiểm',
    vydajeZObvyklych: 'Chưa nhập chi phí thiết yếu — phương án {varianta} tính theo 90 % chi phí thông thường.',
    zadanaCast: 'phần đã nhập',
    zaverOchranaPovinne: 'bảo vệ {nova} — nằm trong chi phí bắt buộc',
    zaverOchranaZmenaPovinne: 'bảo vệ hiện nay {stara} → mới {nova} — nằm trong chi phí bắt buộc',
    zaverZVolnehoCf: 'Phần chi từ dòng tiền tự do',
    zoVolby: 'Bao nhiêu năm thu nhập ròng',
    zustava: 'giữ lại',
  },
  /* BLOK:pojisteniPlan END */
  /* BLOK:minimumSmrti START — generuje scratchpad/slovnik.py, ručně needitovat */
  minimumSmrti: {
    ariaHodnotaNaklad: '{castka} mỗi tháng',
    ariaNaklad: 'Chi phí hằng tháng cho con {jmeno}',
    ariaPruh: 'Mức tối thiểu {castka}: {casti}',
    ariaVek: 'Gia đình nuôi con {jmeno} đến bao nhiêu tuổi',
    bezPrijmu: 'không có thu nhập',
    bezPrijmuText: 'Không có thu nhập — bảo hiểm tử vong ít nhất trả hết nợ của gia đình.',
    dluhy: 'nợ',
    doVekuFew: '{n}',
    doVekuMany: '{n}',
    doVekuOne: '{n}',
    kalkVeta: 'Mức tối thiểu {castka} = nợ {dluhy} + 1 năm thu nhập gia đình {prijem} + con cái {deti}',
    kalkVetaBezDeti: 'Mức tối thiểu {castka} = nợ {dluhy} + 1 năm thu nhập gia đình {prijem}',
    kalkVetaSablona: 'Mức tối thiểu {castka} = nợ {dluhy} + 1 năm thu nhập gia đình {prijem} + con cái {deti} — phần con cái là ước tính theo mẫu ({naklad} mỗi tháng cho mỗi con đến {vek} tuổi), không phải số liệu từ phân tích',
    klientSrovnani: 'Với trường hợp tử vong, con số là {smrt}, cao hơn {rozdil} so với mất sức lao động. Đây là mức tối thiểu mà bảo hiểm tử vong không được thấp hơn: các khoản nợ, một năm thu nhập gia đình và nuôi con đến khi tự lập.',
    klientSrovnaniBezDeti: 'Với trường hợp tử vong, con số là {smrt}, cao hơn {rozdil} so với mất sức lao động. Đây là mức tối thiểu mà bảo hiểm tử vong không được thấp hơn: các khoản nợ và một năm thu nhập gia đình.',
    klientSrovnaniSmrtVyssi: 'Với trường hợp tử vong, con số là {smrt}, cao hơn {rozdil} so với mất sức lao động. Cả hai số tiền đều cần có trong hợp đồng — mỗi khoản bảo vệ một tình huống khác nhau.',
    letFew: '{n} năm',
    letMany: '{n} năm',
    letOne: '{n} năm',
    metodou: 'Theo phương pháp tính ra {castka} — áp dụng mức tối thiểu:',
    nakladChybi: 'thiếu chi phí cho con — hãy bổ sung vào chi tiêu (mục Con cái)',
    nakladDite: 'Chi phí mỗi con / tháng',
    nakladHint: 'để trống = mẫu {castka}',
    nakladHintBez: 'hãy điền — chưa có mẫu cho quốc gia này',
    podMinimem: 'Thấp hơn mức tối thiểu {castka} (nợ + 1 năm thu nhập gia đình + con cái) — nhập tay, có chủ ý.',
    podMinimemBezPrijmu: 'Thấp hơn mức tối thiểu {castka} (trả hết nợ) — nhập tay, có chủ ý.',
    posuvnikNaklad: 'Mỗi tháng',
    posuvnikVek: 'Đến tuổi',
    pozn: 'Mức tối thiểu: các khoản nợ + 1 năm thu nhập gia đình + nuôi con đến khi tự lập',
    poznBezPrijmu: 'Mức tối thiểu: trả hết nợ (không có thu nhập)',
    prezProc: 'Ít nhất bằng: nợ {dluhy} + 1 năm thu nhập gia đình {prijem} + nuôi con đến khi tự lập {deti}.',
    prezProcBezDeti: 'Ít nhất bằng: nợ {dluhy} + 1 năm thu nhập gia đình {prijem}.',
    prezProcBezPrijmu: 'Ít nhất bằng: trả hết nợ {dluhy}.',
    prezProcSablona: 'Ít nhất bằng: nợ {dluhy} + 1 năm thu nhập gia đình {prijem} + nuôi con đến khi tự lập {deti} — phần con cái là ước tính theo mẫu ({naklad} mỗi tháng cho mỗi con đến {vek} tuổi), không phải số liệu từ phân tích.',
    prijemRok: '1 năm thu nhập gia đình',
    radekDite: '{jmeno}, {vek}: {naklad} × {roky} =',
    radekDiteBezVeku: '{jmeno}, chưa nhập tuổi: {naklad} × {roky} =',
    radekDluhy: 'Trả hết nợ',
    radekPrijem: '1 năm thu nhập gia đình: {mes} × 12 =',
    sablona: 'mẫu {castka} mỗi tháng cho mỗi con',
    stavMetoda: 'Theo phương pháp tính ra nhiều hơn ({castka}) — áp dụng số cao hơn.',
    stavMinimum: 'Theo phương pháp tính ra {castka} — áp dụng mức tối thiểu.',
    stitek: 'mức tối thiểu',
    titul: 'Mức bảo hiểm tử vong tối thiểu',
    vekDeti: 'Tuổi các con (năm)',
    vekDitete: 'Con thứ {n}',
    vekFew: '{n} tuổi',
    vekHint: 'để trống = từ khi sinh',
    vekMany: '{n} tuổi',
    vekNeznamy: 'chưa nhập tuổi con — tính từ khi sinh',
    vekOne: '{n} tuổi',
    vetaBezPrijmu: 'Mức tối thiểu {castka} = trả hết nợ — người không có thu nhập thì không tính 1 năm thu nhập và tiền nuôi con',
    vratit: 'Đặt lại',
    vratitAria: 'Đặt lại {jmeno} về giá trị trong phân tích',
    vystupMetodika: 'Với trường hợp tử vong, áp dụng mức tối thiểu khi phương pháp vốn cho ra số thấp hơn.',
    zCeho: 'Mức tối thiểu gồm những gì',
    zCehoSkryt: 'Ẩn chi tiết',
    zadano: '{castka} mỗi tháng cho mỗi con',
    zdrojAnalyza: 'từ phân tích',
    zdrojSablona: 'mẫu',
    zdrojUpraveno: 'đã chỉnh',
  },
  /* BLOK:minimumSmrti END */
  /* BLOK:analyzaCisla START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaCisla: {
    auto: {
      chybiCil: 'Mục tiêu đổi xe còn thiếu. Xe của anh/chị hiện trị giá {castka} — vài năm nữa anh/chị sẽ quay lại mức đó.',
      maCil: 'Anh/chị đã có mục tiêu mua xe. Hãy giữ ở mức khoảng {castka} — đúng tầm giá xe anh/chị đang đi.',
      nadpis: 'Đổi xe',
    },
    bydleni: {
      bezStropu: 'Mục tiêu nhà ở {cil} bằng {nasobek}× thu nhập năm của anh/chị.',
      limitNbs: 'Để mua nhà, anh/chị cần khoản vay {uver}. Hạn mức của NBS cho tất cả các khoản vay là {limit} ({max} lần thu nhập ròng hằng năm).',
      limitNbsSDluhy: 'Để mua nhà, anh/chị cần khoản vay {uver}. Hạn mức của NBS cho tất cả các khoản vay là {limit} ({max} lần thu nhập ròng hằng năm), sau các khoản vay khác ({dluhy}) còn lại {strop}.',
      limitNbsVek: 'Tùy theo tuổi, hạn mức có thể thấp hơn.',
      nadpis: 'Giá nhà ở',
      strop: 'Mục tiêu nhà ở {cil} bằng {nasobek}× thu nhập năm của anh/chị. Mức trần là {max}×, tức {strop}.',
    },
    jednotky: {
      mil: 'triệu',
    },
    odkladani: {
      chybi: 'Còn thiếu {chybi} mỗi tháng để đạt mức tối thiểu {min} %.',
      dnes: 'Hiện {pct} % thu nhập được để dành.',
      dohodnuto: 'Với khoản {castka} mỗi tháng đã thống nhất, {pct} % thu nhập sẽ được để dành.',
      dohodnutoVklady: 'Với khoản {castka} mỗi tháng đã thống nhất và khoản góp định kỳ {vklady}, {pct} % thu nhập sẽ được để dành.',
      ideal: 'Đó là mức lý tưởng {ideal} %. Ở mức {rychle} % mục tiêu đạt rất nhanh.',
      minimum: 'Đã đạt mức tối thiểu {min} %; lý tưởng là {ideal} %.',
      nadCilem: 'Đó là từ {rychle} % trở lên — mục tiêu đạt rất nhanh.',
      nadpis: 'Để dành được bao nhiêu',
      schodek: 'Chi tiêu và tiền trả nợ cao hơn thu nhập, hiện chưa để dành được gì.',
    },
    panel: {
      cerpani: 'tỷ lệ rút',
      kProjednani: '{n} điểm cần trao đổi',
      kapital: 'Vốn cần có',
      nadpis: 'Các con số cho thấy',
      orientacni: 'ước tính',
      orientacniTitle: 'Ước tính, không phải giá trị được bảo đảm',
      vseOk: 'mọi thứ đều ổn',
    },
    renta: {
      bezHypoteky: 'Khoản vay mua nhà trả xong vào năm {rok}, không tính vào thu nhập hưu trí.',
      bezSplatek: 'Không tính các khoản trả nợ sẽ xong trước khi nghỉ hưu.',
      bezSplatekISporeni: 'Không tính các khoản trả nợ sẽ xong trước khi nghỉ hưu và không tính khoản tiết kiệm hiện nay.',
      bezSporeni: 'Không tính khoản tiết kiệm hiện nay.',
      chybiCil: 'Mục tiêu thu nhập hưu trí còn thiếu. Hiện anh/chị chi {vydaje} mỗi tháng — thu nhập hưu trí cần đủ mức đó.',
      chybiCilSplatky: 'Mục tiêu thu nhập hưu trí còn thiếu. Hiện anh/chị chi {vydaje} và trả nợ {splatky} mỗi tháng — thu nhập hưu trí cần đủ {potreba}.',
      doplnUrokHypoteky: 'Hãy bổ sung lãi suất khoản vay mua nhà — khi đó sẽ tính được khoản vay có kết thúc trước khi nghỉ hưu hay không.',
      doplnUrokUveru: 'Hãy bổ sung lãi suất khoản vay — khi đó sẽ tính được khoản vay có kết thúc trước khi nghỉ hưu hay không.',
      doplnZustatekHypoteky: 'Hãy bổ sung dư nợ và lãi suất khoản vay mua nhà — khi đó sẽ tính được khoản vay có kết thúc trước khi nghỉ hưu hay không.',
      doplnZustatekUveru: 'Hãy bổ sung dư nợ và lãi suất khoản vay — khi đó sẽ tính được khoản vay có kết thúc trước khi nghỉ hưu hay không.',
      nadpis: 'Mục tiêu thu nhập hưu trí so với chi tiêu',
      nesedi: 'Mục tiêu thu nhập hưu trí là {zadano}, nhưng hiện anh/chị chi {vydaje} mỗi tháng. Còn thiếu {rozdil}.',
      nesediSplatky: 'Mục tiêu thu nhập hưu trí là {zadano}, nhưng chi tiêu cùng tiền trả nợ là {potreba} mỗi tháng. Còn thiếu {rozdil}.',
      odvozena: 'Chưa đặt mục tiêu thu nhập thụ động — tạm tính theo chi tiêu và tiền trả nợ hiện tại, không tính khoản nợ trả xong trước khi nghỉ hưu và khoản tiết kiệm hiện nay.',
      sedi: 'Mục tiêu thu nhập hưu trí {zadano} đủ cho mức chi {vydaje} hiện nay.',
      sediSplatky: 'Mục tiêu thu nhập hưu trí {zadano} đủ cho mức chi cùng tiền trả nợ {potreba} hiện nay.',
    },
    rezerva: {
      doplnit: 'Mình sẽ bổ sung chi tiêu thiết yếu và tính quỹ dự phòng từ đó.',
      nadpis: 'Quỹ dự phòng',
      poRuce: 'Anh/chị đang có sẵn {likvidni}, đủ cho {mesicu} tháng.',
      poRuceBezMesicu: 'Anh/chị đang có sẵn {likvidni}.',
      pravidlo: 'Quỹ dự phòng ({m}× chi tiêu thiết yếu và tiền trả nợ) là {potreba}.',
      vlastniCil: 'Mục tiêu quỹ dự phòng của anh/chị là {cil}.',
      vlastniCilPravidlo: 'Theo quy tắc {m}× chi tiêu thiết yếu và tiền trả nợ thì sẽ là {potreba}.',
    },
    stav: {
      chybi: 'Cần giải quyết',
      info: 'Để tham khảo',
      ok: 'Đã đạt',
      pozor: 'Vượt giới hạn',
    },
    zivotni: {
      nadpis: 'Bảo hiểm nhân thọ',
      platba: 'Anh/chị đang trả {castka} mỗi tháng cho bảo vệ thu nhập.',
      platbaPodil: 'Anh/chị đang trả {castka} mỗi tháng cho bảo vệ thu nhập, tức {podil} % thu nhập.',
    },
  },
  /* BLOK:analyzaCisla END */
  /* BLOK:analyzaStranka START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaStranka: {
    cesta: {
      orientacniKlient: 'Mô hình tham khảo, không phải cam kết.',
    },
    coBudeLabel: 'Các điểm tiếp theo',
    detiFew: '{n} con',
    detiMany: '{n} con',
    detiOne: '{n} con',
    firmaNema: 'Khách hàng không có công ty hay hoạt động kinh doanh',
    jmenoKlienta: 'Tên (Khách hàng {n})',
    kompletnostChybi: 'Để có kế hoạch chính xác, còn thiếu: {seznam}.',
    mostek: '“Nếu kế hoạch tài chính đạt được **những mục tiêu này**, đó có phải là giải pháp đúng cho anh/chị không?”',
    napoveda: {
      auto: 'Chỉ cần để dành phần chênh lệch: giá xe tiếp theo trừ số tiền bán được xe hiện tại. Khi anh/chị có nhiều hơn, chúng ta sẽ điều chỉnh mục tiêu.',
      bydleni: '{prijem} ròng × 12 × {nasobek} = {castka} (mức trần của CNB). Thực tế — từ nhà hiện tại sang nhà tương tự, không phải cung điện.',
      bydleniBezRegulatora: 'Giá nhà nên tương xứng với thu nhập ròng của hộ gia đình. Thực tế — từ nhà hiện tại sang nhà tương tự, không phải cung điện.',
      bydleniChybi: 'Giá nhà hợp lý ≈ {nasobek} lần thu nhập ròng hằng năm. Còn thiếu thu nhập để tính mức trần.',
      bydleniNad: 'Vượt mức khuyến nghị của CNB ({strop}) — khoản vay thế chấp có thể không được duyệt.',
      bydleniNadNbs: 'Khoản vay {uver} vượt hạn mức của NBS ({strop}) — ngân hàng chỉ cho vay như một ngoại lệ.',
      bydleniNadNbsVycerpano: 'Hạn mức NBS không còn gì cho khoản vay mới {uver} — ngân hàng chỉ cho vay như một ngoại lệ.',
      bydleniNadNbsZbyva: 'Khoản vay {uver} lớn hơn phần còn lại của hạn mức NBS ({strop}) — ngân hàng chỉ cho vay như một ngoại lệ.',
      bydleniNbs: 'Hạn mức của NBS: tổng các khoản vay tối đa {max} lần thu nhập ròng hằng năm = {limit}.',
      bydleniNbsBezDluhu: 'Đã tính khi chưa có các khoản vay khác.',
      bydleniNbsChybiPrijem: 'Hạn mức của NBS chỉ tính từ thu nhập chứng minh được và thu nhập khác của khách hàng — hãy bổ sung.',
      bydleniNbsDluhyChybi: 'Hạn mức của NBS áp dụng cho tổng các khoản vay — hãy bổ sung dư nợ các khoản vay khác.',
      bydleniNbsPravidlo: 'Hạn mức của NBS: tổng các khoản vay tối đa {max} lần thu nhập ròng hằng năm.',
      bydleniNbsSDluhy: 'Hạn mức của NBS: tổng các khoản vay tối đa {max} lần thu nhập ròng hằng năm = {limit}. Sau khi trừ các khoản vay khác ({dluhy}), còn lại {strop} cho khoản vay mới.',
      bydleniNbsVek: 'Từ 41 tuổi, hạn mức thấp hơn nếu khoản vay kết thúc sau tuổi 65 — hãy bổ sung ngày sinh.',
      bydleniNbsVycerpano: 'Các khoản vay khác ({dluhy}) đã dùng hết hạn mức của NBS ({max} lần thu nhập năm).',
      bydleniOrientacni: 'Giá nhà hợp lý ≈ {nasobek} × 12 × {prijem} = {castka}.',
      bydleniPravidlo: 'Giá nhà hợp lý ≈ {nasobek} lần thu nhập ròng hằng năm.',
      doporucit: 'Đề xuất {castka}',
      naHistorii: 'Xem trên lịch sử',
      naHistoriiTitul: 'Xem trên dữ liệu thực 1928–2025',
      orientacniPrijem: 'Thu nhập ròng ước tính của hộ gia đình',
      ostatni: 'Cái gì – khi nào – bao nhiêu, theo giá hôm nay.',
      renta: '{vydaje} chi tiêu + {splatky} trả nợ = {castka} mỗi tháng. Dòng tiền hưu trí phải nuôi được cuộc sống như hiện nay — không chỉ phần thiết yếu.',
      rentaBezHypoteky: '{vydaje} chi tiêu + {splatky} trả nợ = {castka} mỗi tháng — khoản vay mua nhà trả xong vào năm {rok}, không tính vào dòng tiền hưu trí. Dòng tiền hưu trí phải nuôi được cuộc sống như hiện nay.',
      rentaBezHypotekyBezSplatek: '{vydaje} chi tiêu = {castka} mỗi tháng — khoản vay mua nhà trả xong vào năm {rok}, không tính vào dòng tiền hưu trí. Dòng tiền hưu trí phải nuôi được cuộc sống như hiện nay.',
      rentaBezSplatek: '{vydaje} chi tiêu = {castka} mỗi tháng. Dòng tiền hưu trí phải nuôi được cuộc sống như hiện nay — không chỉ phần thiết yếu.',
      rentaChybi: 'Dòng tiền hưu trí = toàn bộ chi tiêu hiện nay, gồm cả trả nợ và lối sống. Còn thiếu chi tiêu để tính.',
      rentaNizka: 'Chi tiêu cùng tiền trả nợ chỉ bằng {pct} % thu nhập — có lẽ còn thiếu khoản chi nào đó.',
      rentaVysoka: 'Chi tiêu cùng tiền trả nợ bằng {pct} % thu nhập — vượt quá thu nhập.',
      rezerva: '({nezbytne} chi tiêu thiết yếu + {splatky} trả nợ) × {mesicu} = {castka}. Khoảng {min}–{castka} tùy thu nhập của anh/chị ổn định đến đâu.',
      rezervaBezSplatek: '{nezbytne} chi tiêu thiết yếu × {mesicu} = {castka}. Khoảng {min}–{castka} tùy thu nhập của anh/chị ổn định đến đâu.',
      rezervaChybi: 'Quỹ dự phòng = 3–6 lần chi tiêu thiết yếu + trả nợ. Còn thiếu chi tiêu thiết yếu để tính.',
      vzdelani: '{mesicne} mỗi tháng × {mesicu} tháng × {let} = {castka}. Học tại Séc {od}–{do}, ở nước ngoài khoảng gấp hai lần rưỡi.',
      vzdelaniDeti: '{mesicne} mỗi tháng × {mesicu} tháng × {let} × {deti} = {castka}. Học tại Séc {od}–{do}, ở nước ngoài khoảng gấp hai lần rưỡi.',
      vzdelaniJednoDite: '{mesicne} mỗi tháng × {mesicu} tháng × {let} = {castka} cho một con. Học tại Séc {od}–{do}, ở nước ngoài khoảng gấp hai lần rưỡi.',
      vzdelaniJinaMena: 'Chi phí học của con: chi phí mỗi tháng × số tháng trong năm × số năm học. Học ở nước ngoài tốn khoảng gấp hai lần rưỡi.',
    },
    penzijko: {
      dpsDip: '(DPS {dps} + DIP {dip})',
      jenDip: '(DIP — từ đồng đầu tiên)',
      jenDps: '(phần đóng trên {hranice} mỗi tháng)',
      nadLimit: 'vượt mức trần hằng năm {limit}: {castka} không được khấu trừ',
      odpocet: 'Được khấu trừ thuế',
      statni: 'Trợ cấp nhà nước (DPS)',
      zaMesic: '{castka}/tháng',
      zaRok: '{castka}/năm',
    },
    prebytekSouhlas: '“Anh/chị có đồng ý dùng {castka} mỗi tháng cho các mục tiêu của mình không?”',
    skript: {
      cas: 'Qua điện thoại chúng ta đã hẹn buổi gặp **45 phút**. Phía tôi không có gì thay đổi — tôi chỉ muốn chắc rằng anh/chị cũng dành khoảng 45 phút.',
      cile: '“Chúng ta cùng xem các mục tiêu chiến lược theo cấu trúc **CÁI GÌ – KHI NÀO – BAO NHIÊU**. Anh/chị nghĩ đến điều gì đầu tiên?” Nếu khách hàng không nhắc tới, hãy hỏi về **nhà ở**, **việc học của con** và **tự do tài chính**.',
      ocekavani: '“Anh/chị kỳ vọng gì ở buổi gặp hôm nay?” → nhắc lại lời khách hàng và nói thêm: “Mục tiêu của tôi là xem **anh/chị đang làm tốt điều gì**, **có thể đang mất tiền ở đâu** và **có thể làm tốt hơn điều gì**.”',
      penize: '“Tôi xin bắt đầu bằng một câu hỏi hơi lạ: **Vì sao tiền bạc quan trọng với anh/chị?**” → nhắc lại từ đó (“tự do… với anh/chị nghĩa là gì?”) và hỏi tiếp: “Anh/chị còn nghĩ đến điều gì nữa?”',
      pojistky: '“Hiện anh/chị có những **hợp đồng bảo hiểm** nào — nhân thọ, tai nạn, tài sản, xe? Với mỗi hợp đồng tôi cần công ty bảo hiểm, số hợp đồng, phí hằng tháng và ngày kỷ niệm.” Sau khi lưu, các hợp đồng sẽ hiện trong hồ sơ khách hàng và có thể tạo thư chấm dứt ngay từ đó.',
      prijmy: '“Một nguồn rất quan trọng khác để đạt mục tiêu là **thu nhập của anh/chị**. Mỗi tháng anh/chị nhận bao nhiêu từ công việc?” (thưởng = trung bình 2–3 năm)',
      rizika: '“Trong kế hoạch tài chính, mình cũng sẽ xem phần **bảo vệ** của anh/chị. Mình xem anh/chị đang có gì — **bảo vệ được gì và chưa bảo vệ được gì**. Mình kiểm tra xem có thể **tiết kiệm** hay mua bảo hiểm hợp lý hơn không. Và tôi sẽ cho anh/chị thấy phần bảo vệ nằm thế nào trong **cả kế hoạch**: gia đình, mục tiêu, quỹ dự phòng.”',
      vydaje: '“Theo anh/chị, mỗi tháng có thể **để dành** được bao nhiêu?” — đừng mổ xẻ chi tiêu quá chi tiết. Kiểm tra: chi tiêu ≈ dòng tiền hưu trí mong muốn; thu nhập − chi tiêu = dòng tiền tự do.',
      zavazky: '“Thông tin quan trọng để đạt mục tiêu là **các khoản nợ**. Trước tiên là vay thế chấp — vay mua nhà, sau đó đến các khoản khác.”',
      zaver: '“Còn điều gì quan trọng mà tôi quên hỏi không? {veta}”',
      zdroje: '“**Một nguồn khác** để đạt các mục tiêu là **số tiền anh/chị đã có**: tiết kiệm nhà ở, quỹ hưu trí, đầu tư, tài khoản và tài sản. Mình cùng xem từng khoản — bắt đầu với tiết kiệm nhà ở. Anh/chị có dùng không?”',
    },
    smazatDite: 'Xóa con',
  },
  /* BLOK:analyzaStranka END */
  /* BLOK:kinoMetodika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoMetodika: {
    APPROVED: 'Từ dữ liệu của khách hàng',
    CANDIDATE: 'Đang chờ duyệt phương pháp',
    PROVISIONAL: 'Nhận định tạm thời — chưa có nguồn xác thực',
  },
  /* BLOK:kinoMetodika END */
  /* BLOK:analyzaPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrijmy: {
    bonusy: 'Thưởng / lương tháng 13 (mỗi năm)',
    chybiJmeno: 'thiếu tên',
    domacnost: 'Chung cho cả gia đình',
    forma: 'Hình thức thu nhập',
    jinaForma: 'đã nhập trước đó — thuộc hình thức khác, hãy chuyển hoặc xóa',
    klient: 'Khách hàng {n}',
    osobaCelkem: 'Thu nhập tháng của người này',
    pasivni: 'Thu nhập thụ động (cho thuê…)',
    pole: {
      davky: 'Lương hưu, trợ cấp nuôi con, trợ cấp khác',
      mzdaFirma: 'Lương ròng từ công ty riêng',
      ostatniJiny: 'Việc làm thêm, tiền cấp dưỡng và khác',
      osvcOstatni: 'Kinh doanh (OSVČ) và khác',
      podilyFirma: 'Chia lợi nhuận và khác',
      podnikani: 'Thu nhập ròng từ kinh doanh',
      vedlejsiOsvc: 'Thu nhập phụ (lương, lương hưu, trợ cấp nuôi con)',
      vedlejsiZam: 'Thu nhập phụ (việc làm thêm, cấp dưỡng, kinh doanh)',
      zamestnani: 'Thu nhập ròng từ làm công',
    },
    poleKlient: '{pole} — khách hàng {n}',
    prace: 'Nghề nghiệp',
    pracePh: 'vd. tài xế, kế toán, nhà hàng riêng',
    pridatDruhou: 'Người thứ hai',
    pridatVedlejsi: 'Thu nhập phụ',
  },
  /* BLOK:analyzaPrijmy END */
  /* BLOK:prebytekModel START — generuje scratchpad/slovnik.py, ručně needitovat */
  prebytekModel: {
    mesicneProCile: 'Hằng tháng cho mục tiêu',
    neodsouhlaseno: 'khách hàng chưa đồng ý',
    planNespocita: 'Không có thu nhập thì không tính được kế hoạch — hãy nhập thu nhập hoặc số tiền đã thống nhất.',
    planPocita: 'Kế hoạch tạm tính với {castka}',
    pravidloNula: 'Các khoản trả nợ chiếm hết thu nhập, nên kế hoạch không thể lấy dù chỉ 20% thu nhập. Hãy bổ sung chi tiêu trong phân tích, hoặc số tiền bạn đã thống nhất với khách hàng.',
    zdrojDopocet: 'mô hình: thu nhập − chi tiêu − trả nợ',
    zdrojPravidlo: 'mô hình: 20% thu nhập ròng',
  },
  /* BLOK:prebytekModel END */
  /* BLOK:vysvetleniInfo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vysvetleniInfo: {
    aria: 'Giải thích: {nazev}',
    cipVyberteOsobu: 'chọn người trên hợp đồng',
    jakCistPredAPo: 'Cách đọc bảng so sánh',
    jakSeCastkyPocitaji: 'Cách tính các số tiền',
    rucniKratce: 'Sửa giá và số tiền bằng bút chì',
  },
  /* BLOK:vysvetleniInfo END */
  /* BLOK:cilDeti START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilDeti: {
    doAnalyzy: 'Nhập vào phân tích',
    pridat: 'Thêm con',
    upozorneni: 'Có mục tiêu cho con nhưng chưa nhập con nào — hãy bổ sung (tên, ngày sinh).',
  },
  /* BLOK:cilDeti END */
  /* BLOK:cilHned START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHned: {
    badgeNavrh: 'đề xuất',
    bezMesicniInvestice: 'không đầu tư hàng tháng',
    bezMesicniInvesticeVelke: 'Không đầu tư hàng tháng',
    brzdaChybi: 'Phần còn lại {chybi} các nguồn hiện có không đủ — chọn nguồn khác, dời thời hạn hoặc tiết kiệm bù từ thặng dư.',
    coSTim: 'Cách xử lý:',
    dalsiZdroj: 'bổ sung nguồn khác trong phân tích (tài khoản, tiền gửi có kỳ hạn, tiết kiệm xây dựng)',
    doMesKDispozici: 'Có trong ~{mesicu} tháng:',
    dosporeni: 'Tiết kiệm bù từ thặng dư',
    dosporitNabidka: 'tiết kiệm bù {castka} mỗi tháng trong {mesicu} tháng',
    hnedKDispozici: 'Có ngay:',
    jakBezMesicni: 'Giải pháp: tạm thời chưa đầu tư hằng tháng.',
    jakDosporit: 'Giải pháp: {jedn} một lần từ các nguồn và {prav} mỗi tháng trong {mesicu} tháng.',
    jakDosporitBezZdroju: 'Giải pháp: {prav} mỗi tháng trong {mesicu} tháng.',
    krytoJenZeZdroju: 'mục tiêu “ngay” chỉ được trang trải từ tiền khách hàng đang có.',
    mesicu: 'tháng',
    nulaRespektovana: 'Không đầu tư hàng tháng — quyết định của tư vấn viên, đề xuất không quay lại.',
    odebratZdroj: 'Không dùng nguồn này cho mục tiêu này',
    poDobu: 'trong',
    poMesicich: 'Sau {mesicu} tháng tiết kiệm bù:',
    pocetMesicu: 'Số tháng',
    posunoutNaRok: 'dời thời hạn sang 1 năm',
    povinnaRezerva: 'Quỹ dự phòng thanh khoản bắt buộc',
    prebytekNestaci: 'không có thặng dư để tiết kiệm bù',
    pridatZdroj: 'Thêm nguồn:',
    rozdelovnikHned: 'Mục tiêu “ngay” chỉ được trang trải từ các nguồn — tiết kiệm bù từ thặng dư được chọn trong thẻ mục tiêu ở Đề xuất giải pháp.',
    terminSankce: 'rút trước hạn có thể bị phạt',
    vychaziDoMes: '— từ các nguồn trong ~{mesicu} tháng.',
    vychaziHned: '— ngay từ các nguồn.',
    vychaziSDosporenim: '— từ các nguồn và khoản tiết kiệm bù.',
    vysledekChybi: 'Có ngay {konec} — còn thiếu {chybi} ({pct} % mục tiêu).',
    vysledekChybiDoMes: 'Có trong ~{doMes} tháng {konec} — còn thiếu {chybi} ({pct} % mục tiêu).',
    vysledekDosporitChybi: 'Ngay {hned}, sau {mesicu} tháng tiết kiệm bù {konec} — còn thiếu {chybi} ({pct} % mục tiêu).',
    vysledekDosporitChybiDoMes: 'Trong ~{doMes} tháng {hned}, sau {mesicu} tháng tiết kiệm bù {konec} — còn thiếu {chybi} ({pct} % mục tiêu).',
    vysledekDosporitOk: 'Ngay {hned}, sau {mesicu} tháng tiết kiệm bù {konec} — mục tiêu đạt {pct} %.',
    vysledekDosporitOkDoMes: 'Trong ~{doMes} tháng {hned}, sau {mesicu} tháng tiết kiệm bù {konec} — mục tiêu đạt {pct} %.',
    vysledekOk: 'Có ngay {konec} — mục tiêu đạt {pct} %.',
    vysledekOkDoMes: 'Có trong ~{doMes} tháng {konec} — mục tiêu đạt {pct} %.',
    zVasichPenez: 'từ tiền của bạn',
    zadneZdroje: 'Không có — khách hàng không có tiền dùng được ngay.',
    zdrojTermin: 'Tiền gửi có kỳ hạn',
  },
  /* BLOK:cilHned END */
  /* BLOK:zdrojNazev START — generuje scratchpad/slovnik.py, ručně needitovat */
  zdrojNazev: {
    bezny: 'tài khoản thanh toán',
    fondy: 'quỹ đầu tư và bảo hiểm nhân thọ liên kết đầu tư',
    fondyRezerva: 'bổ sung từ quỹ đầu tư',
    fondyUzel: 'Quỹ đầu tư và bảo hiểm nhân thọ liên kết đầu tư',
    fondyZbytek: 'phần còn lại sau khi bổ sung quỹ dự phòng',
    hotovost: 'tiền mặt',
    penzijko: 'quỹ hưu trí (DPS — rút được từ {vek} tuổi)',
    sporici: 'tài khoản tiết kiệm',
    stavebko: 'tiết kiệm xây dựng',
    stavebkoZruseni: 'hủy hợp đồng mất ~{mesicu} tháng',
    termin: 'tiền gửi có kỳ hạn',
  },
  /* BLOK:zdrojNazev END */
  /* BLOK:navrhC9 START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhC9: {
    krokyUvodBezPlanu: 'Cần làm gì, theo thứ tự này:',
  },
  /* BLOK:navrhC9 END */
  /* BLOK:metodikaPlanu START — generuje scratchpad/slovnik.py, ručně needitovat */
  metodikaPlanu: {
    bezZmeny: 'Các con số của khách hàng này không thay đổi.',
    coJeJinak: 'Phương pháp mới khác ở chỗ:',
    coSeZmeni: 'Những gì thay đổi sau khi tính lại với khách hàng này:',
    coSeZmenilo: 'Những gì đã thay đổi sau khi tính lại với khách hàng này:',
    dalsiCile: 'Các mục tiêu khác:',
    dalsiZmeny: 'Các thay đổi khác và điểm khác của phương pháp mới',
    mesicne: 'hằng tháng',
    prepocitano: 'Đã tính lại theo phương pháp mới.',
    prepocitat: 'Tính lại theo phương pháp mới',
    pruhStary: 'Kế hoạch được tính theo phương pháp trước ngày {datum}.',
    vraceno: 'Kế hoạch lại tính theo phương pháp trước ngày {datum}.',
    vratit: 'Khôi phục cách tính ban đầu',
    vratitTitulek: 'Có thể khôi phục cho đến khi bạn rời trang đề xuất.',
    zmenaAkontaceSK: 'Slovakia: khoản trả trước theo NBS — nếu mua trước cuối năm 2026, chắc chắn LTV 80 %; từ năm 2027, 10 % chỉ đủ khi mua nhà ở đầu tiên: mỗi người vay tối đa 35 tuổi (khách hàng thứ hai chưa có ngày sinh thì không đáp ứng), không có căn hộ hay nhà để ở hoặc cho thuê và không có khoản vay mua nhà trong các nghĩa vụ.',
    zmenaAkontaceVek: 'Khoản trả trước 10 % (ngoại lệ cho người trẻ) được xét theo tuổi vào năm mua (tuổi hiện tại + số năm đến mục tiêu), không theo tuổi hiện tại.',
    zmenaCilBezTerminu: 'Mục tiêu chưa có thời hạn không nhận tiền từ tài khoản và không có khoản hằng tháng — các bản xuất ghi “hãy bổ sung thời hạn” và tiền dành cho các mục tiêu đã có thời hạn.',
    zmenaCilHned: 'Mục tiêu „ngay“ (0 năm) chỉ được đáp ứng từ số tiền khách hàng đang có — hệ thống không tự thêm khoản đầu tư hằng tháng, chỉ đề xuất.',
    zmenaDosporeniStupne: 'Sau khi bù đủ quỹ dự phòng trong số tháng đã chọn, các mục tiêu khác nhận số tiền được giải phóng từ khi kết thúc việc bù — theo từng bậc, không phải khoản nhỏ nhất cho cả thời gian. Mức tăng và năm bắt đầu áp dụng được in trong Kế hoạch đầy đủ và trên bản 1 trang.',
    zmenaFondyDoRenty: 'Quỹ đầu tư, cổ phiếu và bảo hiểm nhân thọ có giá trị hoàn lại mà khách hàng đã có được đưa vào mục tiêu thu nhập thụ động đầu tiên — chỉ một lần, kể cả khi có hai mục tiêu — và tăng trưởng đến khi bắt đầu theo hồ sơ rủi ro của mục tiêu đó. Tư vấn viên có thể chuyển chúng sang mục tiêu khác trong dòng tiền. Trước đây kế hoạch không gán chúng cho mục tiêu nào.',
    zmenaFondyDoRezervy: 'Khi khách hàng còn thiếu quỹ dự phòng và có chứng chỉ quỹ, ETF hoặc cổ phiếu, kế hoạch trước hết dùng chúng để bổ sung phần dự phòng còn thiếu (chỉ phần đó, không hơn) và chỉ phần quỹ còn lại mới đưa vào mục tiêu thu nhập thụ động. Bảo hiểm nhân thọ liên kết đầu tư không dùng cho quỹ dự phòng — giá trị hoàn lại chỉ nhận được sau khi chấm dứt hợp đồng. Trước đây toàn bộ quỹ đưa vào mục tiêu thu nhập thụ động và quỹ dự phòng phải chờ tích lũy từ thặng dư.',
    zmenaHrubaZCiste: 'Trợ cấp ốm đau (mất khả năng làm việc tạm thời) được tính từ lương gộp suy ra từ lương ròng theo thuế và bảo hiểm năm 2026 (theo bậc), không phải lương ròng × 1,39. Người có thu nhập dưới 22 tuổi có quyền hưởng lương hưu mất sức lao động.',
    zmenaInvaliditaBezPrijmu: 'Cha/mẹ không có thu nhập chỉ được bảo vệ mất sức lao động cho phần chi tiêu gia đình tăng 20 % trừ lương hưu mất sức lao động nếu có quyền hưởng — như nhau cho người thứ nhất và thứ hai.',
    zmenaInvaliditaNikdoNevydelava: 'Khi trong gia đình không ai có thu nhập, bảo hiểm mất sức lao động không được tính và kế hoạch ghi “chưa ai trong gia đình có thu nhập từ công việc nên chưa tính bảo hiểm mất sức lao động — hãy nhập thu nhập”.',
    zmenaInvaliditaNulaTisk: 'Cha/mẹ không có thu nhập mà lương hưu mất sức lao động bù được phần chi tiêu gia đình tăng 20 % sẽ có 0 Kč kèm lý do ở mục mất sức lao động trong kế hoạch đầy đủ và bản 1 trang (trước đây “—”).',
    zmenaInvalidniDuchod: 'Lương hưu mất sức lao động từ nhà nước: người có thu nhập được tính mức trung bình (ở Séc 13 000 Kč mỗi tháng), chuyên viên tư vấn có thể sửa trên thẻ — không tính theo lương. Không có quyền hưởng thì 0, không có thu nhập thì mức tối thiểu theo luật.',
    zmenaMajetekMzda: 'Trách nhiệm của người lao động chỉ được in với hạn mức từ lương gộp mà tư vấn viên đã nhập hoặc xác nhận — ước tính từ lương ròng chỉ hiển thị trên màn hình của tư vấn viên và trong kế hoạch ghi “hạn mức sau khi nhập lương”. Sau khi số tiền bảo hiểm thay đổi, giá bảo hiểm tài sản không được tính vào tổng và không được in cho đến khi tư vấn viên xác nhận lại.',
    zmenaMajetekNahrada: 'Bảo hiểm tài sản hiện có (tài sản trong nhà, bất động sản, trách nhiệm) chỉ được giải phóng trong kế hoạch khi hợp đồng tài sản mới đã có giá từ tư vấn viên — khi đó kế hoạch tính trọn việc thay thế: giải phóng khoản phí cũ và trừ giá hợp đồng mới. Trước đây việc hủy được tính là tiền giải phóng cùng với hợp đồng nhân thọ, kể cả khi chưa có giá hợp đồng mới.',
    zmenaMajetekSmlouvy: 'Bảo hiểm tài sản được in trong kế hoạch theo từng hợp đồng và chỉ với giá theo báo giá của công ty bảo hiểm; ước tính sơ bộ chỉ hiển thị trên màn hình của tư vấn viên.',
    zmenaMiraOdkladani: 'Tỷ lệ tiết kiệm trong Đề xuất, trong ngân sách kế hoạch và trong bài trình bày là cùng một con số như trong phân tích: số tiền đã thống nhất (nếu chưa có thì là tiền dư từ thu nhập và chi tiêu) cộng các khoản gửi định kỳ vào tiết kiệm và đầu tư, chia cho thu nhập ròng. Trước đây chỉ là phần dư sau phí bảo hiểm chia cho thu nhập, không tính các khoản gửi.',
    zmenaOchranaNadPrebytek: 'Khi phí bảo vệ cao hơn thặng dư, khoản còn thiếu hiển thị trong biểu đồ «Dòng tiền theo thời gian», trong dòng thông báo thiếu hụt, trong ngân sách kế hoạch, trong Tổng quan liên tục, trong bài trình bày và trong Tóm tắt. Trước đây phí bảo hiểm bị cắt bằng mức thặng dư và khoản thiếu bị mất đi.',
    zmenaPartnerBezNarozeni: 'Vợ/chồng chưa có ngày sinh: kế hoạch không tính bảo hiểm cho người này (tử vong, mất sức lao động, bệnh tật, tai nạn và cả phí) và các tài liệu ghi “chưa tính — thiếu ngày sinh”. Kế hoạch không hủy các hợp đồng hiện có của người này. Trước đây bảo hiểm của vợ/chồng vẫn được tính dù không có ngày sinh.',
    zmenaDveCesty: 'Biểu đồ “Không có kế hoạch và có kế hoạch” so sánh cùng một khoản tiền của kế hoạch khi đầu tư và khi để trong tài khoản tiết kiệm, kèm dải kịch bản xấu hơn và tốt hơn cùng đường sau phí; kế hoạch bị thiếu hụt thì không vẽ biểu đồ. Trước đây biểu đồ đầu tư toàn bộ tài sản mà không rút tiền cho các mục tiêu.',
    zmenaAlokaceFichtner: 'Cách chia tiền của mục tiêu (cổ phiếu, trái phiếu, tiền mặt) theo bảng dựa trên hồ sơ rủi ro và số năm đến mục tiêu, không còn bán dần cổ phiếu đều đặn. Năm cuối trước mục tiêu giữ 97 % tiền mặt và 3 % trái phiếu (hồ sơ năng động 71 % và 29 %). Trước khi rút, khoản lương hưu giữ tỷ lệ cổ phiếu theo hồ sơ và số năm đến lúc bắt đầu rút (hồ sơ cân bằng, từ 15 năm trở lên: 88 %); trước đây tiến dần về 50 % cổ phiếu. Vì vậy số tiền hằng tháng của các mục tiêu sẽ thay đổi: với hồ sơ thận trọng và cân bằng, mục tiêu ngắn hạn đắt hơn một chút, khoản lương hưu với hồ sơ cân bằng và năng động sẽ rẻ hơn.',
    zmenaPenzijkoDoRenty: 'Quỹ hưu trí không bị hủy: nếu thu nhập thụ động bắt đầu trước khi quỹ hưu trí được chi trả (ở Séc là 60 tuổi), thu nhập đến lúc đó lấy từ tiền khác, và từ lúc chi trả sẽ tăng thêm theo quỹ hưu trí (4 % mỗi năm trên giá trị của quỹ) — không mất hỗ trợ của nhà nước. Trước đây quỹ hưu trí chi trả sau khi bắt đầu nhận thu nhập hoàn toàn không được tính.',
    zmenaPojistneMajetku: 'Giá bảo hiểm tài sản mới (nhà ở, đồ dùng gia đình, trách nhiệm) do tư vấn viên nhập là khoản chi bắt buộc và được trừ toàn bộ vào thặng dư, giống như bảo hiểm nhân thọ. Hợp đồng tài sản cũ bị hủy vẫn được tính là khoản tiết kiệm. Trước đây chỉ trừ phần chênh lệch khi thay thế hợp đồng bị hủy.',
    zmenaNizsiVarianty: 'Các phương án “Thắt lưng buộc bụng” và “Chỉ quan tâm giá” nay cũng giảm mức nghỉ ốm và bệnh hiểm nghèo: tiền trợ cấp hằng ngày chỉ bù chi tiêu thiết yếu và khoản trả nợ (thay vì toàn bộ thu nhập), bệnh hiểm nghèo giảm cùng tỷ lệ với mất sức lao động. Trước đây hai mục này giữ nguyên như phương án “Cho người yêu cầu cao”.',
    zmenaPenzijkoJednou: 'Quỹ hưu trí và khoản thu nhập một lần chưa gán mục tiêu chỉ được đưa vào mục tiêu thu nhập thụ động đầu tiên theo thứ tự — hai mục tiêu không còn chia cùng một khoản tiền hai lần.',
    zmenaPotrebaRenty: 'Thu nhập hưu trí khi chưa đặt mục tiêu được tính như trong phân tích: chi tiêu hiện nay trừ khoản tự gửi tiết kiệm, cộng tiền trả các khoản vay vẫn còn khi nghỉ hưu. Khoản vay mua nhà trả xong trước khi nghỉ hưu (theo ngày kết thúc, nếu không thì ước tính từ dư nợ, lãi suất và tiền trả hằng tháng) không được tính, các khoản vay khác vẫn giữ. Trước đây: toàn bộ chi tiêu hiện nay, không tính tiền trả nợ.',
    zmenaProfilCile: 'Hồ sơ rủi ro riêng của mục tiêu cũng được áp dụng khi tính — thẻ mục tiêu và mọi bản xuất đều hiển thị cùng một tỷ lệ phần trăm.',
    zmenaRenta13: 'Cách tính cũ chỉ chuyển tiền cho thu nhập thụ động từ tháng thứ 13 — năm đầu toàn bộ phần dư dùng để bù quỹ dự phòng.',
    zmenaRentaNavyseni: 'Mức tăng cho thu nhập thụ động từ số tiền được giải phóng sau khi hoàn thành các mục tiêu trước được in trong Kế hoạch đầy đủ và trên bản 1 trang, kèm năm bắt đầu áp dụng — giống các mục tiêu khác.',
    zmenaRezervaJednoCislo: 'Quỹ dự phòng có một con số duy nhất trong toàn bộ kế hoạch: mục tiêu đúng theo công thức trong phân tích (không làm tròn theo 10 000), còn số tiền khách hàng đang có, phần còn thiếu và tỷ lệ đã đạt đều do một hàm tính — kể cả tiết kiệm xây dựng nhận được trong khoảng ~4 tháng.',
    zmenaRucniCastka: 'Khoản hằng tháng nhập tay ở một mục tiêu cũng được áp dụng khi tính — được in vào kế hoạch đầy đủ, bản 1 trang, phần tóm tắt và bài trình bày, các mục tiêu khác nhận phần còn lại.',
    zmenaRucniNula: 'Khoản hằng tháng đã xóa ở một mục tiêu cũng được áp dụng khi tính — số tiền được giải phóng chuyển sang các mục tiêu khác.',
    zmenaRustMzdySchodek: 'Nếu hiện nay gia đình chi tiêu nhiều hơn thu nhập, phần lương tăng sẽ bù khoản thiếu hụt này trước — các mục tiêu và tiền trả góp chỉ nhận phần còn lại. Trước đây toàn bộ phần lương tăng được dành cho các mục tiêu.',
    zmenaSkoreZajisteni: 'Điểm sức khỏe tài chính không còn tính các dòng rủi ro tài sản để trống là đã có bảo vệ — khi chưa nhập số tiền, phần điểm này không được tính (trước đây được 20 điểm cho mẫu trống).',
    zmenaSmrtBezMinima: 'Bảo hiểm tử vong trong phân tích lớn chỉ tính theo phương pháp vốn, không có mức tối thiểu (mức tối thiểu chỉ còn trong Phân tích cho người Việt).',
    zmenaSpatneDluhy: 'Bước „Xóa các khoản nợ xấu“ chỉ tính các khoản vay ở thẻ Vay cá nhân — vay tiêu dùng, thẻ tín dụng, thấu chi, vay tuần hoàn, thuê tài chính cá nhân và các dòng cũ chưa chọn loại. Vay mua nhà và các khoản vay ở thẻ Vay doanh nghiệp không phải là nợ xấu.',
    zmenaSplatkaUveru: 'Sau khi giải ngân khoản vay, tiền trả góp được trừ khỏi số tiền dành cho các mục tiêu khác và thu nhập thụ động (với nhà ở, cộng lại tiền thuê nhà ghi trong bảng chi tiêu, khoản không còn phải trả sau khi mua). Nếu tiền trả góp vượt quá ngân sách, kế hoạch ghi rõ từ khi nào và thiếu bao nhiêu.',
    zmenaSrovnaniStejnyZaklad: 'Biểu đồ „không có kế hoạch và có kế hoạch“ trong bài trình bày bắt đầu cả hai đường từ cùng một tài sản tài chính; tài sản chưa phân bổ tăng như tài sản đã phân bổ và lạm phát là 2,5 % theo phương pháp (trước đây đường xanh chỉ bắt đầu từ tiền đã phân cho mục tiêu và đường đỏ tính 2,7 %).',
    zmenaUverSpotrebitelsky: 'Ô tô và các mục tiêu vay khác ngoài nhà ở tính khoản trả góp của khoản vay tiêu dùng hoặc vay tiết kiệm xây dựng (thời hạn tối đa 12 năm, lãi suất ước tính), không phải vay thế chấp 30 năm.',
    zmenaZajisteniVzdy: 'Kế hoạch luôn tính đến bảo vệ thu nhập — câu trả lời “Không” trước đây của khách hàng trong phân tích không còn loại phí bảo hiểm khỏi phần dư.',
    zmenaZamestnavatel: 'Đóng góp của chủ lao động được tính cả vào khoản để dành lẫn vào thu nhập: tỷ lệ tiết kiệm = (số tiền đã thống nhất hoặc tiền dư + khoản tự gửi + đóng góp của chủ lao động) chia cho (thu nhập ròng + đóng góp của chủ lao động). Trước đây chỉ tính vào khoản để dành, nên tỷ lệ ra cao hơn một chút.',
    zmenaZdrojeHned: 'Quỹ dự phòng và mục tiêu có thời hạn „ngay“ (0 năm) lấy từ tài khoản thanh toán, tài khoản tiết kiệm, tiền mặt, tiền gửi có kỳ hạn và tiết kiệm nhà ở (theo thứ tự này).',
  },
  /* BLOK:metodikaPlanu END */
  /* BLOK:prahyOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  prahyOdkladani: {
    flagPodMinimem: 'Đang để dành ~{pct} % thu nhập — tối thiểu {min} %, lý tưởng {ideal} %',
    hladina: {
      ideal: 'lý tưởng',
      minimum: 'tối thiểu',
      pod: 'dưới mức tối thiểu',
      rychle: 'nhanh tới mục tiêu',
    },
    novyCrm: {
      chybiDoMinima: 'Còn thiếu {castka} mỗi tháng để đạt mức tối thiểu {min} %',
      minimumDoIdealu: 'Đã đạt tối thiểu {min} % · còn thiếu {castka} để đạt mức lý tưởng {ideal} %',
    },
    plan: {
      cileIdeal: 'MỤC TIÊU — lý tưởng {ideal} %',
      pravidlo503020: 'Quy tắc 50/30/20: ~50 % chi tiêu thiết yếu, 30 % lối sống, 20 % để dành cho mục tiêu và thu nhập thụ động. Tối thiểu {min} %, ở mức {rychle} % mục tiêu đạt rất nhanh. Bảng chi tiêu chi tiết sẽ được xem lại trong buổi gặp dịch vụ.',
    },
    rozpocet: {
      ideal: '✓ đạt mức lý tưởng {ideal} %',
      minimum: '✓ đạt tối thiểu {min} % · lý tưởng {ideal} %',
      nezname: 'chưa biết thu nhập · tối thiểu {min} %',
      pod: '▲ dưới mức tối thiểu {min} %',
      rychle: '✓ từ {rychle} % — mục tiêu đạt nhanh',
      vcVkladu: 'gồm khoản gửi {castka}',
    },
  },
  /* BLOK:prahyOdkladani END */
  /* BLOK:rozpisPanel START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisPanel: {
    hotovo: 'Xong',
    kicker: 'Chi tiết · từng khoản một',
    prijmy: {
      nadpis: 'Thu nhập của hộ gia đình',
    },
    vydaje: {
      nadpis: 'Chi tiêu của gia đình',
    },
    zavrit: 'Đóng',
  },
  /* BLOK:rozpisPanel END */
  /* BLOK:planCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  /* BLOK:rustMzdyEfekt START — generuje scratchpad/slovnik.py, ručně needitovat */
  rustMzdyEfekt: {
    klikNedosahne: 'Bấm “{tlacitko}” sẽ không làm thay đổi thu nhập thụ động — tiền từ các bước được dùng cho mục tiêu khác hoặc chỉ đến sau khi bắt đầu nhận.',
    klikUver: 'Bấm “{tlacitko}” sẽ không làm thay đổi thu nhập thụ động — khoản trả góp khoản vay dùng hết mức tăng lương: từ năm {rok}, kể cả khi tăng lương, vẫn thiếu {chybi} mỗi tháng để trả góp.',
    konec: '{horizont}: {bez} → {ted}',
    krokRocne: 'Mỗi bước = +{pct} % thu nhập, mỗi {obdobi} một lần (≈ {rocne} % mỗi năm).',
    nepocitaBezMesicni: 'Thu nhập thụ động không có khoản đầu tư hằng tháng — các bước tăng lương không được tính vào.',
    nepocitaBezTerminu: 'Thu nhập thụ động chưa có thời hạn — không được đưa vào phân bổ tiền, kể cả với mức tăng lương.',
    nepocitaHned: 'Thu nhập thụ động có thời hạn ngay bây giờ không sinh lời — mức tăng lương không làm thay đổi.',
    nepocitaNedosahne: 'Mức tăng lương hiện có trong kế hoạch không đến được khoản thu nhập thụ động này — tiền được dùng cho mục tiêu khác hoặc chỉ đến sau khi bắt đầu nhận.',
    nepocitaRezim: 'Thu nhập thụ động đang dùng chế độ giải pháp tự chọn — các bước tăng lương không được tính vào. Muốn tính, hãy bấm „quay lại đề xuất ban đầu“ ở mục tiêu hưu trí.',
    nepocitaSplneno: 'Thu nhập thụ động đã đạt kể cả khi không tăng lương ({bez} %).',
    nepocitaUver: 'Mức tăng lương hiện có trong kế hoạch không đến được thu nhập thụ động — khoản trả góp khoản vay đã dùng hết: từ năm {rok}, kể cả khi tăng lương, vẫn thiếu {chybi} mỗi tháng để trả góp.',
    poHorizontu: 'Các bước từ năm {roky} chỉ bắt đầu khi bắt đầu nhận thu nhập thụ động — không được tính vào.',
    poKliku: 'Sau khi bấm “{tlacitko}”: thu nhập thụ động từ {pred} % lên {po} %',
    poKlikuBezZmeny: 'Bấm “{tlacitko}” sẽ không làm thay đổi thu nhập thụ động.',
    radekNepocita: 'trong kế hoạch ({n} bước), nhưng không được tính vào thu nhập thụ động',
    toastNepocita: 'Đã điền sẵn {pocet} bước tăng lương — thu nhập thụ động không thay đổi; lý do ghi trên thẻ thu nhập thụ động, cạnh dòng Tăng lương.',
    toastPredvyplneno: 'Đã điền sẵn {pocet} bước tăng lương — thu nhập thụ động {pred} % → {po} %.',
    toastPredvyplnenoBezRenty: 'Đã điền sẵn {pocet} bước tăng lương — hãy điều chỉnh theo khách hàng.',
    toastPredvyplnenoVice: 'Đã điền sẵn {pocet} bước tăng lương — {zmeny}.',
    toastUzVPlanu: 'Các bước tăng lương đã có trong kế hoạch và khớp với thiết lập — không có gì thay đổi. Thu nhập thụ động đang tính với chúng: {ted} % (không có chúng {bez} %).',
    toastUzVPlanuBezCisel: 'Các bước tăng lương đã có trong kế hoạch và khớp với thiết lập — không có gì thay đổi.',
    toastUzVPlanuNepocita: 'Các bước tăng lương đã có trong kế hoạch — không có gì thay đổi. Nhưng chúng không được tính vào thu nhập thụ động; lý do ghi trên thẻ thu nhập thụ động, cạnh dòng Tăng lương.',
    toastUzVPlanuVice: 'Các bước tăng lương đã có trong kế hoạch và khớp với thiết lập — không có gì thay đổi. Không có → có chúng: {renty}.',
    vPlanu: 'Mức tăng lương trong kế hoạch nâng thu nhập thụ động từ {bez} % lên {ted} %',
  },
  /* BLOK:rustMzdyEfekt END */
  planCil: {
    akontaceDo2026: 'Nếu mua vào năm {rok}, tại Slovakia chắc chắn được vay 80 % (20 % vốn tự có) — tuổi hay nhà ở đầu tiên đều không ảnh hưởng.',
    akontaceK2BezVeku: 'Khách hàng thứ hai chưa có ngày sinh — mọi người vay đều phải đáp ứng điều kiện 10 %, nên tính 20 %. Hãy bổ sung ngày sinh trong phân tích.',
    akontaceNemovitost: 'Theo phân tích, khách hàng có căn hộ hoặc nhà (để ở hay cho thuê) hoặc đang trả vay mua nhà — tại Slovakia từ năm 2027, 10 % chỉ đủ khi mua nhà ở đầu tiên, vì vậy 20 %.',
    doplnenoAutomaticky: 'tự động bổ sung',
    jakJednZatim: 'Giải pháp: {jedn} một lần, tạm thời chưa cần thêm hằng tháng.',
    jakZatimNic: 'Giải pháp: tạm thời chưa cần thêm hằng tháng.',
    krokNavyseni: 'Từ tháng thứ {mesic} (năm {rok}) tăng thêm {o} lên {celkem} mỗi tháng.',
    krokRadek: 'từ năm {rok} +{o}',
    krokZacatek: 'Từ tháng thứ {mesic} (năm {rok}) chuyển {celkem} mỗi tháng.',
    nbsAkontace2027: 'NBS: nếu mua trước cuối năm 2026, chắc chắn được vay 80 % (20 % vốn tự có), 90 % chỉ trong hạn mức của ngân hàng. Từ năm 2027, 10 % chỉ đủ khi mua nhà ở đầu tiên, người vay tối đa 35 tuổi và không sở hữu bất động sản nhà ở khác (để ở hay cho thuê). Tài trợ 100 % là quyết định của tư vấn viên — 10 % giá được bù bằng khoản vay tiết kiệm xây dựng. Khoản trả góp chỉ xuất hiện trong dòng tiền từ khi giải ngân khoản vay',
    profilMimoVypocet: 'Phép tính và bản in hiện vẫn dùng hồ sơ của kế hoạch — hồ sơ riêng của mục tiêu sẽ có hiệu lực sau khi tính lại theo phương pháp mới.',
    rucniMimoVypocet: 'Phép tính và bản in hiện vẫn dùng {castka} — khoản nhập tay sẽ có hiệu lực sau khi tính lại theo phương pháp mới.',
    varianta100: 'Tài trợ 100 %',
    variantaAkontace: 'Trả trước {pct} %',
    vekVRoceKoupe: 'Vào năm mua ({rok}), khách hàng sẽ {vek} tuổi — khoản trả trước 10 % được xét theo tuổi này.',
    vekVRoceKoupeK2: 'Vào năm mua ({rok}), khách hàng sẽ {vek} tuổi và khách hàng thứ hai {vek2} tuổi — 10 % chỉ đủ khi cả hai tối đa 35 tuổi.',
    vyrazenBezTerminu: 'Không có thời hạn thì mục tiêu không được tính khi phân chia tiền — hãy bổ sung thời hạn.',
  },
  /* BLOK:planCil END */
  /* BLOK:kinoOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoOdkladani: {
    a1: {
      aria: 'Không xem từng khoản chi, chỉ theo dõi số tiền để dành',
      kicker: 'Chi tiêu',
      radek1: 'Chúng ta không xem chi tiêu đến từng khoản.',
      radek2: 'Chỉ theo dõi một con số: để dành được bao nhiêu.',
      stranou: 'Để dành',
      stranouPopis: 'con số duy nhất cần theo dõi',
      tahak: '“Chúng ta không đếm từng đồng. Tôi chỉ cần một con số — mỗi tháng anh/chị để dành được bao nhiêu.”',
      titulek: 'Không phải từng đồng một',
      velkePopis: 'Thu nhập ròng của gia đình',
    },
    a2: {
      aria: 'Ba mức để dành',
      dnes: 'Hiện anh/chị để dành {pct} %.',
      dnesDohoda: 'Với số tiền đã thống nhất, anh/chị để dành {pct} %.',
      kicker: 'Để dành bao nhiêu',
      radek: 'Ở mức {rychle} % mục tiêu đạt rất nhanh.',
      tahak: '“Mười phần trăm là tối thiểu. Hai mươi là lý tưởng. Ba mươi — mục tiêu đạt rất nhanh.”',
      titulek: '{min} % tối thiểu, {ideal} % lý tưởng',
      velkePopis: '{pct} % của {prijem}',
    },
    a3: {
      aria: 'Ở mức {pct} % ({castka} mỗi tháng), theo mô phỏng sau 30 năm đạt {fv}, trong đó đã góp {vlozeno}.',
      kicker: 'Con số của anh/chị',
      nejistota: 'Mô phỏng theo hồ sơ của kế hoạch ({profil}), theo giá trị tiền hôm nay, chưa trừ phí và thuế. Mức sinh lời không chắc chắn — có thể cao hơn hoặc thấp hơn.',
      radekCas: 'Phần còn lại là nhờ thời gian — mô phỏng, không phải lời hứa.',
      radekNula: 'Không để dành thì không có gì tăng lên.',
      radekVlozite: 'Anh/chị góp {castka}.',
      tahak: '“Đây là mô phỏng, không phải lời hứa. Nhưng nó cho thấy thời gian và sự đều đặn làm được gì.”',
      titulek: 'Có thể tăng lên bao nhiêu',
      velkePopis: 'sau 30 năm · mô phỏng',
      vlozeno: 'đã góp',
      vynos: 'sinh lời',
    },
    a4: {
      aria: 'Ở mức {pct} %: {popis}.',
      cilBezNazvu: 'Mục tiêu',
      cilRenta: 'Thu nhập hưu trí',
      cilRezerva: 'Quỹ dự phòng',
      dalsiCile: '+ mục tiêu khác: {n}, đúng hạn {splneno}',
      dnes: 'hôm nay',
      hned: 'ngay',
      kTerminu: 'đến hạn chỉ đạt {pct} %',
      kTerminuSplneno: 'đúng hạn',
      kicker: 'Mục tiêu của anh/chị',
      nejistota: 'Cùng cách tính với Đề xuất giải pháp: sinh lời theo hồ sơ kế hoạch, thứ tự mục tiêu theo kế hoạch. Mô phỏng, không phải lời hứa.',
      radekHladina: '{pct} % → {n}/{celkem} mục tiêu đúng hạn',
      radekHladinaVse: '{pct} % → mọi mục tiêu đúng hạn ✓',
      rezervaZUspor: 'từ tiền tiết kiệm, hiện {pct} %',
      tahak: '“Hãy xem khi tỷ lệ thay đổi thì thời điểm có quỹ dự phòng, nhà ở và thu nhập hưu trí dịch chuyển thế nào.”',
      titulek: 'Điều gì đạt được và khi nào',
      velke: '{n} / {celkem}',
      velkePopis: 'mục tiêu đạt đúng hạn',
    },
    a5: {
      aria: 'Từ lương {prijem}, ngày hôm sau {stranou} được để dành, còn {zivot} để chi tiêu.',
      denPo: 'ngày sau khi nhận lương',
      kicker: 'Bắt đầu',
      naZivot: 'Chi tiêu',
      radek: 'Phần còn lại cứ yên tâm chi tiêu.',
      stranou: 'Để dành',
      tahak: '“Cách tốt nhất là tự động — lệnh chuyển định kỳ ngay ngày sau khi nhận lương, rồi không phải nghĩ nữa.”',
      titulek: 'Trả cho mình trước, rồi mới đến hóa đơn',
      velkePopis: 'bằng lệnh chuyển tiền định kỳ ngay ngày sau khi nhận lương',
      vyplata: 'Lương',
    },
    doplnPrijmy: 'Hãy điền thu nhập để tính',
    jezdec: {
      aria: 'Để dành bao nhiêu phần trăm thu nhập',
      dnes: 'hiện nay',
      mesicne: 'mỗi tháng',
      odkladate: 'Anh/chị để dành',
      valuetext: '{pct} %, {castka} mỗi tháng',
    },
    nazev: 'Chi tiêu và để dành',
    prezTlacitko: 'Chiếu phim: Chi tiêu và để dành',
    prijmy: {
      a2Tahak: '“Quy tắc đã được kiểm chứng: một nửa cho thiết yếu, ba phần mười cho cuộc sống và một phần năm để dành cho tương lai. Tối thiểu là một phần mười.”',
      a3BezVydaju: 'Hãy điền chi tiêu để tính anh/chị thực sự để dành bao nhiêu.',
      a3Ideal: 'Hiện anh/chị để dành ~{pct} % — đó là mức lý tưởng. ✓',
      a3Minimum: 'Hiện anh/chị để dành ~{pct} % — đã đạt tối thiểu, còn thiếu {chybi} mỗi tháng để đạt mức lý tưởng {ideal} %.',
      a3Pod: 'Hiện anh/chị để dành ~{pct} % — còn thiếu {chybi} mỗi tháng để đạt mức tối thiểu {min} %.',
      a3Rychle: 'Hiện anh/chị để dành ~{pct} % — mục tiêu sẽ đạt rất nhanh. ✓',
      a3Tahak: '“Chi tiêu chi tiết chúng ta sẽ xem ở buổi gặp chăm sóc. Bây giờ chỉ một điều quan trọng — để dành ít nhất mười phần trăm, lý tưởng là hai mươi.”',
      a3VelkePopis: 'Lý tưởng là để dành chừng này mỗi tháng',
      a6Radek3: 'Tối thiểu {min} %, lý tưởng {ideal} % — quan trọng là bắt đầu.',
    },
    profil: {
      dynamicky: 'năng động',
      konzervativni: 'thận trọng',
      vychozi: '{profil}, mặc định',
      vyvazeny: 'cân bằng',
    },
    rokyFew: '{n} năm',
    rokyMany: '{n} năm',
    rokyOne: '{n} năm',
    tlacitko: 'Phim để dành',
    tlacitkoTitle: 'Chiếu phim: Chi tiêu và để dành',
    utraty: {
      bydleni: 'Nhà ở',
      deti: 'Con cái',
      doprava: 'Đi lại',
      dovolena: 'Du lịch',
      energie: 'Điện nước',
      jidlo: 'Ăn uống',
      obleceni: 'Quần áo',
      restaurace: 'Nhà hàng',
    },
    zaRokyFew: 'sau {n} năm',
    zaRokyMany: 'sau {n} năm',
    zaRokyOne: 'sau {n} năm',
  },
  /* BLOK:kinoOdkladani END */
  /* BLOK:vodopad START — generuje scratchpad/slovnik.py, ručně needitovat */
  vodopad: {
    coKdyby: {
      naBudoucnost: 'Cho tương lai',
      presah: 'Nhiều hơn phần còn lại {castka} — phải cắt từ chi tiêu sinh hoạt.',
      prijmu: 'thu nhập',
      startDnes: 'hôm nay',
      startDohoda: 'đã thống nhất',
      tlacitko: 'Nếu dành nhiều hơn cho tương lai thì sao',
      valuetext: '{pct} % thu nhập, {castka} mỗi tháng',
      zVolnych: 'Từ tiền dư',
      zbyva: 'Còn dư',
      zpetDnes: 'Về hôm nay',
      zpetDohoda: 'Về mức đã thống nhất',
    },
    grafSelhal: 'Không vẽ được biểu đồ — số liệu có trong phần tổng quan.',
    klikRadek: 'Chạm vào dòng = chi tiết',
    klikSloupec: 'Bấm vào cột = chi tiết',
    majetek: {
      celkem: '= Tổng tài sản',
      celkemPod: 'cộng cả hai',
      ciste: '= Giá trị ròng',
      cistePod: 'thuộc về gia đình',
      cisteZapPod: 'nợ vượt tài sản',
      dedictvi: 'Thừa kế',
      fin: '+ Tài chính',
      finPod: 'tiết kiệm, đầu tư, tài khoản',
      kat: {
        dedictvi: 'Thừa kế',
        firma: 'Doanh nghiệp',
        kzp: 'Bảo hiểm nhân thọ tích lũy',
        nemovitosti: 'Bất động sản',
        opf: 'Quỹ và ETF',
        penzijko: 'Tiết kiệm hưu trí',
        stavebko: 'Tiết kiệm xây dựng',
        ucty: 'Tài khoản',
        zavazkyB: 'Vay mua nhà',
        zavazkyO: 'Khoản vay',
      },
      nadpis: 'Tổng quan tài sản',
      nefin: 'Phi tài chính',
      nepocita: 'chưa được tính',
      podily: '{rodina} % tài sản thuộc về gia đình, {banka} % thuộc về ngân hàng.',
      pointa: 'Sau khi trừ nợ, tài sản còn lại của bạn là {castka}.',
      pointaBezJistiny: 'Các khoản nợ chưa có dư nợ gốc — chưa biết chúng làm giảm tài sản bao nhiêu.',
      pointaBezZavazku: 'Tổng tài sản {castka} — chưa nhập các khoản nợ.',
      pointaPrazdne: 'Chưa nhập tài sản hay khoản nợ nào.',
      pointaZaporne: 'Nợ vượt tài sản {castka}.',
      zavazky: '− Nợ',
      zavazkyPod: 'dư nợ gốc các khoản vay',
    },
    navic: 'Các khoản vượt cột {castka}',
    nerozepsano: 'Chưa chia theo khoản',
    penize: {
      bonusy: 'Thưởng (theo tháng)',
      chybiPrijmy: 'Hãy nhập thu nhập — chưa có thì không hiển thị tiền dư.',
      chybiVydaje: 'Hãy nhập chi tiêu — chưa có thì không hiển thị tiền dư.',
      dilNaBudoucnost: 'cho tương lai {castka}',
      dilPrebytek: 'thặng dư {castka}',
      dilZbyva: 'còn lại {castka}',
      hrdina: 'Tiền dư',
      hrdinaSchodek: 'Thâm hụt',
      jdeVam: 'của bạn',
      jenUkazka: 'Chỉ minh họa — không ghi vào kế hoạch.',
      kazdyMesic: 'mỗi tháng',
      kicker: 'Thu nhập và chi tiêu · hằng tháng',
      klient: 'Khách hàng {n}',
      mesicne: 'mỗi tháng',
      nadVolneCastka: 'vượt tiền dư {castka}',
      nezadano: 'chưa nhập',
      nezbytne: '− Chi tiêu thiết yếu',
      nezbytnePod: 'nhà ở, ăn uống, đi lại',
      nezbytnePrehled: 'Chi tiêu thiết yếu',
      odkladDnes: 'Hiện để dành {castka} = {pct} % thu nhập (khoản gửi {vklady} + tiền dư {volne}).',
      odkladDohoda: 'Để dành {castka} = {pct} % thu nhập (khoản gửi {vklady} + số tiền đã thống nhất {dohoda}).',
      ostatni: '− Chi tiêu khác',
      ostatniPod: 'giải trí, du lịch, tiết kiệm',
      ostatniPrehled: 'Chi tiêu khác',
      pasivni: 'Thu nhập thụ động',
      pointa: 'Từ {prijmy} thu nhập, sau chi tiêu và trả nợ còn lại {volne}.',
      pointaSchodek: 'Chi tiêu và trả nợ cao hơn thu nhập {castka}.',
      pokryto: 'Các khoản gửi đang chạy ({castka}) đã đủ mục tiêu — không cần thêm từ tiền dư.',
      posuvnikNeni: 'Hiện không có gì để dành: mỗi tháng thiếu {castka}. Trước hết cần cân đối chi tiêu.',
      prehrat: 'Phát lại',
      prijmy: 'Thu nhập',
      prijmyPod: 'thực nhận, cả hộ',
      prijmyPrehled: 'Thu nhập',
      schodek: '= Thâm hụt',
      schodekPod: 'thiếu mỗi tháng',
      schodekPrehled: 'Thâm hụt',
      splatky: '− Trả nợ',
      splatkyPod: 'các khoản vay',
      splatkyPrehled: 'Trả nợ',
      sporeni: 'Khoản tiết kiệm đang chạy',
      sporeniNesedi: 'tiết kiệm không khớp',
      sporeniProuzek: 'trong đó tiết kiệm {castka}',
      stranouDnes: 'hiện để dành {pct} % thu nhập',
      stranouDohoda: 'với số tiền đã thống nhất, để dành {pct} % thu nhập',
      volne: '= Tiền dư',
      volnePod: 'còn lại cho bạn',
      volnePrehled: 'Tiền dư',
      vydaje: '− Chi tiêu',
      vydajePod: 'chưa nhập chi tiêu thiết yếu',
      vydajePrehled: 'Chi tiêu',
      zivotniStyl: 'Phong cách sống',
    },
    prehled: 'Tổng quan',
    rozkliknuto: 'Đang mở',
    sedi: 'Tổng các khoản khớp: {castka}',
    stovka: {
      kopieChyba: 'Không sao chép được câu.',
      kopirovano: 'Đã sao chép',
      kopirovat: 'Sao chép',
      mesicne: '{castka} mỗi tháng',
      nadpis: 'Trong mỗi 100 {sym} thu nhập',
      nazev: {
        budoucnost: 'Tương lai',
        povinne: 'Bắt buộc',
        vydaje: 'Chi tiêu và trả nợ',
        zbyva: 'Còn dư',
        zivot: 'Cuộc sống',
      },
      nesedi: {
        dohoda: 'Số tiền đã thống nhất {castka} cao hơn tiền dư {nad}, nhiều hơn phần còn lại cho cuộc sống. Hãy kiểm tra thỏa thuận.',
        sporeniOstatni: 'Khoản tiết kiệm {castka} mỗi tháng cao hơn chi tiêu khác {ostatni}. Hãy kiểm tra xem tiết kiệm đã được ghi trong chi tiêu chưa.',
        sporeniVydaje: 'Khoản tiết kiệm {castka} mỗi tháng cao hơn chi tiêu {ostatni}. Hãy kiểm tra xem tiết kiệm đã được ghi trong chi tiêu chưa.',
        titul: 'Chưa thể chia 100.',
        ukazka: 'Không thể dành nhiều như vậy cho tương lai — kể cả toàn bộ chi tiêu sinh hoạt cũng không đủ.',
      },
      podNadPrijem: '{pct} vượt thu nhập',
      podNadVolne: '{pct} vượt tiền dư',
      podPrijem: 'thu nhập',
      podZbyva: 'còn dư {pct}',
      pravidlo: 'Nguyên tắc: bắt buộc 50–60 · tương lai ít nhất 20 · phần còn lại cho cuộc sống',
      schodekPozn: '{pct} vượt thu nhập · mỗi tháng thiếu {castka}',
      slozeni: {
        nadVolne: 'vượt tiền dư {castka}',
        nezbytne: 'thiết yếu {castka}',
        nic: 'chưa có gì',
        prebytek: 'thặng dư {castka}',
        schodek: 'tiết kiệm hiện đang trả bằng nợ hoặc tiền dự trữ',
        splatky: 'trả nợ {castka}',
        sporeni: 'tiết kiệm {castka}',
        volne: 'tiền dư {castka} (chưa thống nhất)',
        vydajeBez: 'chi tiêu không gồm tiết kiệm {castka}',
        zVolnych: 'từ tiền dư {castka}',
        zamestnavatel: 'từ chủ lao động {castka}',
        zivot: 'chi tiêu khác không gồm tiết kiệm',
        zivotSchodek: 'chi tiêu khác gồm tiết kiệm {castka}',
      },
      stav: {
        bezDohodyLatka: '{latka}, nếu để dành toàn bộ tiền dư',
        bezDohodyPod: 'dưới 10 dù để dành toàn bộ tiền dư',
        idealSplneno: 'đạt ít nhất 20',
        latkaIdeal: 'ít nhất 20',
        latkaMinimum: 'tối thiểu 10',
        minimumSplneno: 'đạt tối thiểu 10 · còn thiếu {castka} để đạt 20',
        nadVolneLatka: '{latka} chỉ khi cắt {castka} từ cuộc sống',
        nadVolnePod: 'dưới 10 dù đã cắt từ cuộc sống',
        neniZCeho: 'hiện không có gì để dành',
        nezbytneNezadane: 'chưa nhập chi tiêu thiết yếu',
        pod: 'dưới 10 · còn thiếu {castka} để đạt 10',
        povinneNad: 'vượt mức khuyến nghị 60 là {n}',
        povinnePod: 'dưới 50',
        povinneV: 'trong mức khuyến nghị 50–60',
        zivotMene: 'ít hơn hiện nay {castka}',
      },
      ukazka: 'minh họa',
      veta: {
        bezDohody: '{zac}, còn {b} còn lại anh/chị có thể để dành cho tương lai.',
        bud: '{zac}, còn {b} anh/chị để dành cho tương lai của mình.',
        budZbyvaFew: '{zac}, {b} anh/chị để dành cho tương lai của mình và {zb} hiện vẫn còn dư.',
        budZbyvaMany: '{zac}, {b} anh/chị để dành cho tương lai của mình và {zb} hiện vẫn còn dư.',
        budZbyvaOne: '{zac}, {b} anh/chị để dành cho tương lai của mình và {zb} hiện vẫn còn dư.',
        domluvime: 'Bây giờ chúng ta thống nhất anh/chị thực sự để dành bao nhiêu từ tiền dư.',
        konecDobre: 'anh/chị đạt cả hai, nên tình hình tốt.',
        konecDobreBez: 'anh/chị đã dành ít nhất 20 cho tương lai, nên tình hình tốt.',
        konecMinimum: 'anh/chị đạt tối thiểu 10, để đạt mức lý tưởng 20 còn thiếu {castka} mỗi tháng.',
        konecMinimumZbytek: 'anh/chị đạt tối thiểu 10, để đạt mức lý tưởng 20 còn thiếu {castka} mỗi tháng — phần này lấy từ tiền còn dư là đủ.',
        konecNadVolne: 'như vậy đạt {latka}, chỉ là anh/chị sẽ chi cho cuộc sống ít hơn hiện nay {castka} mỗi tháng.',
        konecNadVolnePod: 'dù vậy vẫn dưới 10 và anh/chị sẽ chi cho cuộc sống ít hơn hiện nay {castka} mỗi tháng.',
        konecPod: 'hiện anh/chị dưới 10, vậy chúng ta cùng tìm {castka} mỗi tháng.',
        konecPodZbytek: 'hiện anh/chị dưới 10, còn thiếu {castka} mỗi tháng, và phần này lấy từ tiền còn dư là đủ.',
        konecPovinnePod: 'khoản bắt buộc của anh/chị thậm chí dưới 50 và tương lai trên 20, nên tình hình tốt.',
        pravidlo: 'Tôi khuyên dành 50 đến 60 cho khoản bắt buộc và ít nhất 20 cho tương lai, phần còn lại cho cuộc sống',
        pravidloNad: 'Tôi khuyên dành tối đa 60 cho khoản bắt buộc và ít nhất 20 cho tương lai, phần còn lại cho cuộc sống — hiện khoản bắt buộc chiếm nhiều hơn, nên cho tương lai chỉ còn {b}.',
        schodek: 'Trong mỗi 100 {sym} anh/chị kiếm được, hiện anh/chị chi {celkem} — mỗi tháng thiếu {castka}, nên trước hết chúng ta cùng sắp xếp lại chi tiêu.',
        zac: 'Trong mỗi 100 {sym} anh/chị kiếm được, {povinne} dành cho các khoản bắt buộc, {zivot} cho cuộc sống',
        zacBez: 'Trong mỗi 100 {sym} anh/chị kiếm được, {vydaje} dành cho chi tiêu và trả nợ',
      },
      vetaTitul: 'Câu nói cho khách hàng',
      zbyvaPozn: '{castka} mỗi tháng, chưa phân bổ',
      znackaBudoucnost: 'tương lai 20+',
      znackaPovinne: 'bắt buộc 50–60',
    },
    zadnePolozky: 'Chưa có chi tiết từng khoản.',
    zpetAria: 'Quay lại tổng quan',
  },
  /* BLOK:vodopad END */
  /* BLOK:majetekSmlouvy START — generuje scratchpad/slovnik.py, ručně needitovat */
  majetekSmlouvy: {
    bezMzdaPozn: 'Phân tích không có thu nhập từ làm thuê. Chỉ nhập lương khi người đó có chủ lao động.',
    castkaSeZmenila: 'số tiền bảo hiểm đã thay đổi — kiểm tra lại giá',
    cenaNecitelna: 'Nhập giá bằng số, ví dụ 420.',
    cenaPlati: 'Giá vẫn đúng',
    cenaPoNabidce: 'giá theo báo giá của công ty bảo hiểm',
    cenaSmlouvy: 'Giá hợp đồng',
    cenaZNabidky: 'Giá theo báo giá',
    chybiCenaFew: 'thiếu giá ở {n} hợp đồng',
    chybiCenaMany: 'thiếu giá ở {n} hợp đồng',
    chybiCenaOne: 'thiếu giá ở {n} hợp đồng',
    cipLimit: 'hạn mức {limit}',
    cipNenabizet: 'không đề xuất',
    cipPripojisteni: 'bảo hiểm bổ sung',
    coKryje_domacnost: 'Đồ đạc trong nhà.',
    coKryje_dum: 'Ngôi nhà — phần công trình.',
    coKryje_dumDomacnost: 'Ngôi nhà và đồ đạc bên trong.',
    coKryje_dumOdpovednost: 'Ngôi nhà và thiệt hại bạn vô tình gây ra cho người khác.',
    coKryje_majetek: 'Đồ đạc trong nhà và thiệt hại bạn vô tình gây ra cho người khác.',
    coKryje_majetekDum: 'Ngôi nhà, đồ đạc bên trong và thiệt hại bạn vô tình gây ra cho người khác.',
    coKryje_odpovednost: 'Thiệt hại bạn vô tình gây ra cho người khác.',
    coKryje_podnik: 'Doanh nghiệp, hàng tồn kho, thiết bị và thiệt hại cho khách hàng.',
    coKryje_pravni: 'Luật sư và tòa án khi xảy ra tranh chấp.',
    coKryje_zam: 'Thiệt hại bạn gây ra do sơ suất trong công việc.',
    doplnteCenu: 'Nhập giá từ công ty bảo hiểm',
    infoMajetek: 'Một hợp đồng, một giá theo báo giá của công ty bảo hiểm.',
    infoVlastni: 'Hợp đồng riêng — mục này được ký riêng (công ty bảo hiểm khác hoặc sản phẩm khác), vì vậy có giá riêng.',
    infoZamJedna: 'Một hay hai hợp đồng? Theo báo giá của công ty bảo hiểm: một số hợp đồng và một giá = một hợp đồng. Hai giá = mỗi người một hợp đồng. Mỗi người có hạn mức riêng theo lương gộp của mình.',
    kazdaSvouCenu: 'mỗi hợp đồng có giá riêng',
    kinoBezCenFew: 'chưa gồm {n} hợp đồng, giá sẽ có theo báo giá',
    kinoBezCenMany: 'chưa gồm {n} hợp đồng, giá sẽ có theo báo giá',
    kinoBezCenOne: 'chưa gồm {n} hợp đồng, giá sẽ có theo báo giá',
    kinoBezKraceni: 'Đủ giá trị — không bị giảm',
    kinoBlok: '1 khối = lương gộp {mzda}',
    kinoBlokyAria: '{nasobek} lần lương gộp {mzda} là ít nhất {limit}',
    kinoCelkem: 'Tổng cộng',
    kinoCenuDoplnime: 'giá sẽ bổ sung theo báo giá',
    kinoChybiHodnota: 'Chúng tôi sẽ bổ sung số tiền khi biết giá trị — tạm thời tính theo phần trăm thiệt hại.',
    kinoCyklista: 'Đi xe đạp, bạn vô tình đâm phải một người đi xe đạp khác',
    kinoDalsi: 'Tiếp',
    kinoHotovo: 'Xong',
    kinoJezdecPct: '{pct} phần trăm giá trị',
    kinoJezdecText: '{castka}, {pct} phần trăm giá trị',
    kinoKraceni: 'Công ty bảo hiểm chỉ trả {pct} % mỗi thiệt hại',
    kinoKrok: 'Giải thích cho khách hàng · {i} / {n}',
    kinoMisto_doma: 'ở nhà',
    kinoMisto_firma: 'trong doanh nghiệp',
    kinoMisto_prace: 'trong công việc',
    kinoMisto_spor: 'khi tranh chấp',
    kinoNazev_odpovednost: 'Vì sao trách nhiệm cần hạn mức cao',
    kinoNazev_plna: 'Vì sao bảo hiểm đủ giá trị',
    kinoNazev_prace: 'Trách nhiệm trong công việc',
    kinoNazev_shrnuti: 'Chúng ta sẽ ký gì',
    kinoNazev_smlouvy: 'Mỗi hợp đồng bảo hiểm gì',
    kinoOdpPozn: 'Minh họa không có số tiền. Làm ngập nhà hàng xóm hay làm vỡ hàng trong cửa hàng cũng thuộc về đây. Bằng ô tô? Việc đó do bảo hiểm trách nhiệm bắt buộc của chủ xe chi trả, không phải hợp đồng này.',
    kinoOdpVeta: 'Ai gây thiệt hại sức khỏe thì người đó trả. Không phải một hóa đơn — có những khoản phải trả nhiều năm.',
    kinoOsa1: '1 năm',
    kinoOsa10: '10 năm',
    kinoOsa20: '20 năm +',
    kinoOsaAria: 'Minh họa không có số tiền: điều trị và đau đớn được trả ngay, chăm sóc có thể nhiều năm, mất thu nhập mỗi tháng thậm chí hàng chục năm.',
    kinoOsaBolest: 'Đau đớn và suy giảm khả năng sống bình thường',
    kinoOsaLecba: 'Chi phí điều trị',
    kinoOsaNehoda: 'tai nạn',
    kinoOsaPece: 'Chăm sóc người bị thương',
    kinoOsaVydelek: 'Mất thu nhập — mỗi tháng',
    kinoOsobaMzda: '{jmeno} · {mzda}',
    kinoOsobaPodnika: '{jmeno} · tự kinh doanh, không áp dụng',
    kinoPlnaDum: 'Xây lại ngôi nhà sẽ tốn {castka}',
    kinoPlnaDumBez: 'Ngôi nhà · chi phí xây lại sẽ bổ sung',
    kinoPlnaVeta: 'Khi số tiền bảo hiểm thấp hơn chi phí mua lại, công ty bảo hiểm giảm mọi khoản bồi thường theo cùng tỷ lệ — kể cả khoản nhỏ.',
    kinoPlnaVybaveni: 'Mua lại đồ đạc sẽ tốn {castka}',
    kinoPlnaVybaveniBez: 'Đồ đạc · giá trị sẽ bổ sung',
    kinoPlnaVyska: 'chiều cao đầy đủ = toàn bộ giá trị',
    kinoPojistenoCastka: '{castka} ({pct} %)',
    kinoPojistenoNa: 'Được bảo hiểm',
    kinoPojistenoPct: '{pct} % giá trị',
    kinoPojistovna: 'Công ty bảo hiểm',
    kinoPoznPodpojisteni: 'Minh họa theo quy tắc chung về bảo hiểm dưới giá trị, không có mức khấu trừ. Hợp đồng cụ thể có thể được ký khác.',
    kinoPoznPodpojisteniCZ: 'Minh họa theo quy tắc chung về bảo hiểm dưới giá trị (§ 2854 Bộ luật Dân sự Séc), không có mức khấu trừ. Hợp đồng cụ thể có thể được ký khác.',
    kinoPraceKde: '{jmeno} · lương gộp {mzda}',
    kinoPraceSmlouva: 'Hợp đồng với hạn mức {nasobek}× lương dành cho việc này. Phạm vi và điều khoản loại trừ do công ty bảo hiểm quy định.',
    kinoPraceVeta: 'Do sơ suất, người đó làm hỏng máy móc hoặc thiết bị đang dùng để làm việc. Chủ lao động được phép đòi bồi thường. Với lỗi sơ suất, luật giới hạn ở mức {nasobek} lần thu nhập bình quân hằng tháng.',
    kinoPraceVyjimky: 'Mức trần không áp dụng cho thiệt hại gây ra cố ý, khi say rượu hoặc dùng chất gây nghiện, cũng như thiếu hụt và mất tài sản được giao — khi đó phải bồi thường toàn bộ. Căn cứ: {predpis}.',
    kinoProtoLimit: 'Vì vậy hạn mức tính bằng triệu:',
    kinoShrnPozn: 'Các số tiền là đề xuất mức bảo hiểm, không phải báo giá. Giá, phạm vi chi trả và điều khoản loại trừ do công ty bảo hiểm quy định trong hợp đồng.',
    kinoSkoda: 'Thiệt hại',
    kinoStropNejmene: 'Mức trần theo luật cho lỗi sơ suất ít nhất',
    kinoStropPozn: '— tính từ thu nhập bình quân, có thưởng thì cao hơn.',
    kinoTeckaAria: 'Bước {i}: {nazev}',
    kinoVetaJedna: '{mista} — một hợp đồng với một giá lo việc này.',
    kinoVetaKazde: '{mista} — mỗi việc do một hợp đồng khác lo. Mỗi hợp đồng có giá riêng.',
    kinoVetaVicFew: '{mista} — {n} hợp đồng, mỗi hợp đồng có giá riêng.',
    kinoVetaVicMany: '{mista} — {n} hợp đồng, mỗi hợp đồng có giá riêng.',
    kinoVetaVicOne: '{mista} — {n} hợp đồng, mỗi hợp đồng có giá riêng.',
    kinoVetaZadna: 'Chúng ta chưa chọn hợp đồng nào.',
    kinoZavrit: 'Đóng phần giải thích',
    kinoZeSveho: 'Tự chi trả',
    kinoZpet: 'Quay lại',
    kratceOdpovednost: 'Trách nhiệm',
    kratcePodnik: 'Doanh nghiệp và hoạt động',
    kratceVybaveni: 'Thiết bị',
    krytiNemovitostChybi: 'bất động sản — giá trị sẽ bổ sung',
    krytiPolozka: '{nazev} {castka}',
    krytiZam: 'hạn mức {limit}',
    krytiZamChybi: 'hạn mức sau khi nhập lương',
    krytiZamChybiOsoba: '{jmeno} — hạn mức sau khi nhập lương',
    krytiZamOsoba: '{jmeno} — hạn mức {limit}',
    limitDoplnte: 'nhập lương',
    limitNetyka: 'không áp dụng',
    mzdaOdZamestnavatele: 'Lương từ chủ lao động — {jmeno}',
    mzdaOsoby: 'Lương gộp — {jmeno}',
    mzdaPlati: 'Lương đúng',
    mzdaPlatiAria: 'Lương gộp của {jmeno} {mzda} là đúng',
    nabidnoutV: 'Đề xuất',
    nabizetV: 'Đề xuất',
    nazevDomacnost: 'Đồ dùng gia đình',
    nazevDomacnostOdpovednost: 'Đồ dùng gia đình và trách nhiệm',
    nazevMajetek: 'Tài sản',
    nazevMajetekDomacnost: 'Tài sản và đồ dùng gia đình',
    nazevNemovitost: 'Bất động sản',
    nazevNemovitostOdpovednost: 'Bất động sản và trách nhiệm',
    nazevOdpovednost: 'Trách nhiệm dân sự',
    nazevPodnik: 'Bảo hiểm doanh nghiệp',
    nazevPravni: 'Bảo vệ pháp lý',
    nazevVlastni: '{polozky} — riêng',
    nazevZam: 'Trách nhiệm người lao động — {jmeno}',
    nazevZamDva: 'Trách nhiệm người lao động — {jmeno1} và {jmeno2}',
    nenabizetV: 'Không đề xuất',
    neresitV: 'Bỏ qua',
    netykaSe: 'không áp dụng',
    nezadanoPlaceholder: 'chưa nhập',
    obsahSeZmenil: 'nội dung đã thay đổi — kiểm tra lại giá',
    orientacne: 'ước tính ≈ {cena}, không phải báo giá',
    osvcMzdaPozn: 'Thu nhập trong phân tích là từ kinh doanh. Chỉ nhập lương khi người đó cũng có chủ lao động.',
    overitCenuFew: 'kiểm tra giá ở {n} hợp đồng',
    overitCenuMany: 'kiểm tra giá ở {n} hợp đồng',
    overitCenuOne: 'kiểm tra giá ở {n} hợp đồng',
    podepiseFew: 'Khách hàng ký {n} hợp đồng',
    podepiseMany: 'Khách hàng ký {n} hợp đồng',
    podepiseOne: 'Khách hàng ký {n} hợp đồng',
    podnikNeresit: 'Bảo hiểm tài sản gia đình không bảo hiểm doanh nghiệp, hàng tồn kho và thiết bị.',
    podtitulJedna: 'Một hợp đồng · một giá',
    podtitulNenabizime: 'Không đề xuất',
    podtitulNeresime: 'Bỏ qua',
    podtitulNetyka: '{jmeno} tự kinh doanh — không có chủ lao động.',
    podtitulNetykaBez: '{jmeno} không có thu nhập từ làm thuê trong phân tích.',
    podtitulPrazdna: 'Chưa có gì được bảo hiểm — hãy bổ sung các mục',
    podtitulSamostatna: 'Hợp đồng riêng',
    podtitulZam: 'Hạn mức {nasobek}× lương gộp · một giá',
    pojistneCelkem: 'Tổng phí bảo hiểm',
    popisekCastka: 'Số tiền bảo hiểm',
    popisekLimit: 'Hạn mức',
    popisekVybaveni: 'Giá trị thiết bị',
    popisekZasoby: 'Giá trị hàng tồn kho',
    pravniNabidka: 'Bảo vệ pháp lý: đề xuất hay không',
    pravniPripojisteni: 'Bảo hiểm bổ sung cho hợp đồng Tài sản',
    pravniSamostatna: 'Hợp đồng riêng',
    pravniUmisteni: 'Bảo vệ pháp lý được ký thế nào',
    prepinacAria: '{nazev}: đề xuất hay bỏ qua',
    presunAria: '{nazev}: thuộc hợp đồng',
    presunNova: '+ Hợp đồng riêng mới',
    presunPopisek: 'Ký theo cách khác? Thuộc hợp đồng',
    prezSmlouvyFew: '{n} hợp đồng',
    prezSmlouvyMany: '{n} hợp đồng',
    prezSmlouvyOne: '{n} hợp đồng',
    prezSouhrnBezCen: '{smlouvy} · giá theo báo giá',
    prezSouhrnCast: '{smlouvy} · {cena} + các giá khác theo báo giá',
    prezSouhrnCena: '{smlouvy} · {cena}',
    proc_majetek: 'Một thiệt hại ở nhà hoặc gây cho người khác có thể kéo cả kế hoạch đi xuống.',
    proc_podnik: 'Bảo hiểm tài sản gia đình không bảo hiểm hoạt động kinh doanh.',
    proc_pravni: 'Tranh chấp về tiền hoặc công việc tốn chi phí luật sư và tòa án.',
    proc_vlastni: 'Ký riêng — hợp đồng riêng và giá riêng.',
    proc_zam: 'Chủ lao động có thể đòi người lao động bồi thường thiệt hại do sơ suất trong công việc; mức trần theo luật không phải lúc nào cũng áp dụng.',
    radekSmlouvy: '{nazev} ({kryti}) — {cena}',
    radekSmlouvyBezKryti: '{nazev} — {cena}',
    regul: 'Chỉ giá theo báo giá được cộng vào tổng. Các số tiền là đề xuất mức bảo hiểm, không phải báo giá — giá, phạm vi chi trả và điều khoản loại trừ do công ty bảo hiểm quy định trong hợp đồng.',
    resitV: 'Giải quyết',
    smlouvaAria: 'Hợp đồng {cislo}: {nazev}',
    staraMetodika: 'Kế hoạch dùng phương pháp cũ: bản in vẫn ghi một dòng như trước — ước tính {cena}. Hợp đồng, giá và “Bỏ qua” từ đây chỉ vào bản in sau khi bấm “{prepocitat}”.',
    staraMetodikaBezTisku: 'Kế hoạch dùng phương pháp cũ: bảo hiểm tài sản không có trong bản in. Hợp đồng và giá từ đây chỉ được chuyển sau khi bấm “{prepocitat}”.',
    stavChybiHodnota: 'thiếu giá trị',
    stavChybiMzda: 'thiếu lương gộp',
    stavNeresit: 'bỏ qua',
    stavNetyka: 'không áp dụng — tự kinh doanh',
    stavNetykaBez: 'không áp dụng — không đi làm thuê',
    stavNevlastni: 'không sở hữu',
    stavNezadano: 'chưa nhập',
    stavOdhadMzdy: 'ước tính từ lương ròng — hãy kiểm tra',
    ukolSmlouvyFew: 'Ký bảo hiểm tài sản — {n} hợp đồng:',
    ukolSmlouvyMany: 'Ký bảo hiểm tài sản — {n} hợp đồng:',
    ukolSmlouvyOne: 'Ký bảo hiểm tài sản — {n} hợp đồng:',
    ulozit: 'Lưu',
    upravitCenu: 'Sửa giá: {nazev}',
    vetaSjednat: 'Ký {nazev} ({kryti}) — {cena}',
    vetaSjednatBezKryti: 'Ký {nazev} — {cena}',
    vsechnyCeny: 'tất cả giá theo báo giá',
    vysvetlitKlientovi: 'Giải thích cho khách hàng',
    zNabidky: 'theo báo giá',
    zadatMzdu: 'Có cả công việc làm thuê? Nhập lương',
    zadnaKPodpisu: 'Chưa có hợp đồng nào để ký',
    zamJakPoznat: 'Cách nhận biết một hay hai hợp đồng',
    zamJakText: 'Xem báo giá của công ty bảo hiểm: một số hợp đồng và một giá = một hợp đồng cho cả hai. Hai giá = mỗi người một hợp đồng. Mỗi người có hạn mức riêng theo lương gộp của mình.',
    zamKazdy: 'Mỗi người một hợp đồng',
    zamSkupina: 'Trách nhiệm của người lao động',
    zamSpolecna: 'Một hợp đồng cho cả hai',
  },
  /* BLOK:majetekSmlouvy END */
  /* BLOK:duchodInvalidni START — generuje scratchpad/slovnik.py, ručně needitovat */
  duchodInvalidni: {
    ano: 'Có',
    bezPrijmuB: 'Cha/mẹ không có thu nhập: chi tiêu tăng 20 % ({narust}) trừ lương hưu mất sức lao động ({duchod}).',
    bezPrijmuDomacnosti: 'Chưa ai trong gia đình có thu nhập từ công việc nên chưa tính bảo hiểm mất sức lao động — hãy nhập thu nhập.',
    narok: 'Có quyền hưởng lương hưu mất sức lao động',
    narokPozn: 'Trên 28 tuổi: 5 năm bảo hiểm trong 10 năm gần nhất. Thời gian chăm con chỉ được tính khi có bảo hiểm y tế công. “Không biết” = tính là không có quyền hưởng.',
    ne: 'Không',
    nevim: 'Không biết',
    odStatu: 'Lương hưu mất sức lao động từ nhà nước {castka}',
    odStatuLabel: 'Lương hưu mất sức lao động từ nhà nước',
    stitek: {
      bezNaroku: 'không có quyền hưởng: dưới 5 năm bảo hiểm trong 10 năm',
      bezNarokuPoradce: 'không có quyền hưởng',
      chybiNarozeni: 'bổ sung ngày sinh',
      minimum: 'mức tối thiểu theo luật',
      osvcMinimalni: 'tự doanh, mức đóng tối thiểu',
      overitNarok: 'kiểm tra bản trích lục ČSSZ',
      prumer: 'mức trung bình',
    },
  },
  /* BLOK:duchodInvalidni END */
  /* BLOK:kinoCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoCile: {
    bydleni: {
      a1: {
        kicker: 'Thuê hay sở hữu',
        l1: 'Thuê nhà: chi phí ban đầu thấp hơn, dễ chuyển nhà, chủ nhà lo sửa chữa — nhưng bạn không tích lũy tài sản.',
        l2: 'Vay mua nhà: cần khoản trả trước và cam kết dài hạn, nhưng một phần mỗi kỳ trả góp trả dần nợ gốc — bạn dần sở hữu bất động sản.',
        l3: 'Điều quyết định là sự linh hoạt, dòng tiền hằng tháng và việc bạn có muốn tích lũy tài sản hay không.',
        nar: '„Tiền thuê không phải là tiền mất — bạn trả cho chỗ ở và sự linh hoạt. Khác biệt là với khoản vay mua nhà, một phần mỗi kỳ trả góp trả dần nợ gốc, nên bạn dần tích lũy tài sản. Hãy cùng xem các con số và giả định của mô hình.“',
        title: 'Thuê nhà và vay mua nhà: khác nhau ở đâu',
      },
      a5: {
        big: 'Số tiền chúng ta bắt đầu để dành',
        nar: '„Hãy bắt đầu kế hoạch ngay hôm nay — để chính bạn cầm chìa khóa, chứ không phải hợp đồng thuê nhà.“',
        title: 'Tổ ấm có kế hoạch riêng',
        titleVek: 'Tổ ấm sau {roky} năm, khi bạn {vek} tuổi',
      },
      cnb: {
        bigCena: 'Giá nhà ở thực tế',
        bigNad: '{nasobek}× thu nhập năm — vượt khuyến nghị',
        bigOk: '{nasobek}× thu nhập năm — trong mức khuyến nghị',
        kicker: 'Ngưỡng giá hợp lý',
        lBezCeny1: 'Hãy nhập giá THỰC của bất động sản — nếu không kế hoạch sẽ không khớp.',
        lBezCeny2: 'Từ chỗ ở hiện nay sang chỗ tương tự, không phải cung điện.',
        lBezPrijmu: 'Hãy nhập thu nhập để kiểm tra tỷ lệ giá so với thu nhập.',
        lCena: 'Giá bất động sản: {cena} (thực tế, để kế hoạch khớp).',
        lCenaHola: 'Giá bất động sản: {cena}.',
        lNad: 'Đó là {nasobek}× thu nhập năm của bạn — vượt ngưỡng hợp lý!',
        lOk: 'Đó là {nasobek}× thu nhập năm của bạn — ổn.',
        nar: '„Giá hợp lý là khoảng tối đa chín năm thu nhập. Chúng ta phải tính với giá thực tế, nếu không cả kế hoạch sẽ không khớp.“',
        title: 'Giá hợp lý ≈ 9× thu nhập năm',
      },
      nbs: {
        bigNad: 'Khoản vay vượt giới hạn NBS',
        bigOk: 'Khoản vay trong giới hạn NBS',
        bigUver: 'Khoản vay cần',
        kicker: 'Giới hạn NBS',
        lLimit: 'Giới hạn cho tất cả khoản vay của bạn: {limit}.',
        lLimitNejvys: 'Giới hạn cho tất cả khoản vay của bạn: tối đa {limit}.',
        lUver: 'Khoản vay cần: {uver}.',
        lUverNad: 'Khoản vay cần: {uver} — vượt giới hạn NBS!',
        lUverOk: 'Khoản vay cần: {uver} — ổn.',
        lVek: 'Tùy theo tuổi, giới hạn có thể thấp hơn.',
        lZbyva: 'Sau các khoản vay khác còn lại: {strop}.',
        nar: '„Ở Slovakia, NBS giám sát tất cả khoản vay của bạn cộng lại — tối đa tám lần thu nhập ròng hằng năm, từ 41 tuổi thấp hơn. Hãy xem bạn nằm ở đâu.“',
        title: 'Tất cả khoản vay ≤ {max}× thu nhập năm',
      },
      paka: {
        bigHotove: 'Tổng giá',
        bigUver: 'Khoản trả trước cần ({pct})',
        kicker: 'Đòn bẩy vay mua nhà',
        lAkontace: 'Trả trước {pct}: {castka}.',
        lHotove: 'Tiền mặt = toàn bộ số tiền ngay bây giờ.',
        lSHypotekou: 'Với khoản vay mua nhà, trả trước ~{pct} là đủ và bạn đầu tư phần tiền còn lại.',
        lZbytek: 'Khoản vay mua nhà bù phần còn lại — tiền của bạn sinh lời ở nơi khác.',
        narHotove: '„Hãy cân nhắc tiền mặt so với vay mua nhà. Đòn bẩy có thể là bạn của bạn.“',
        narUver: '„Với khoản vay mua nhà, bạn không cần toàn bộ số tiền — chỉ cần khoản trả trước. Phần tiền còn lại có thể tiếp tục sinh lời.“',
        titleHotove: 'Trả tiền mặt hay dùng đòn bẩy?',
        titleUver: 'Bạn chỉ cần đầu tư {pct} trả trước',
      },
    },
    ostatni: {
      a1: {
        big: 'Hãy cùng tính toán',
        kicker: 'Mục tiêu của bạn',
        l1: 'Mỗi ước mơ lớn đều cần kế hoạch và con số.',
        l2: 'Chúng ta sẽ xác định bao nhiêu và khi nào.',
        nar: '„Mỗi mục tiêu xứng đáng có một con số và thời hạn rõ ràng. Bắt tay vào thôi.“',
        title: 'Ước mơ của bạn',
      },
      a2: {
        big: 'Số tiền mục tiêu',
        kicker: 'Bao nhiêu và khi nào',
        lHorizont: 'Thời hạn {roky} năm.',
        lHorizontVek: 'Thời hạn {roky} năm — khi bạn {vek} tuổi.',
        nar: '„Đây là con số và thời hạn. Từ đó chúng ta tính được số tiền để dành hằng tháng.“',
        titleRoky: '{castka} sau {roky} năm',
      },
      a3: {
        big: 'Mục tiêu trong tầm tay',
        kicker: 'Ba đòn bẩy',
        l1: 'Bắt đầu càng sớm, càng phải để dành ít hơn.',
        l2: 'Sự đều đặn thắng những lần cố gắng một lần.',
        nar: '„Ba đòn bẩy phát huy tác dụng: thời gian, sự đều đặn và lợi suất. Chúng ta có thể bật cả ba.“',
        title: 'Thời gian × đều đặn × lợi suất',
      },
      a4: {
        big: 'Mục tiêu của bạn',
        l1: 'Chúng ta sẽ lên kế hoạch để dành hằng tháng ngay.',
        l2: 'Bước nhỏ hôm nay = mục tiêu lớn ngày mai.',
        nar: '„Ước mơ không có kế hoạch chỉ là mong muốn. Hãy biến nó thành kế hoạch.“',
        title: 'Kế hoạch trở thành hiện thực',
      },
    },
    renta: {
      a1: {
        big: 'Bao nhiêu là „đủ“ theo chi tiêu CỦA BẠN?',
        kicker: 'Đỉnh cao của kế hoạch',
        l1: 'Ngày mà công việc là lựa chọn, không phải nghĩa vụ.',
        l2: 'Thu nhập thụ động phải gánh được cả lối sống của bạn — suốt đời và vượt lạm phát.',
        nar: '„Đích đến: ngày bạn không phải làm việc vì tiền. Thu nhập thụ động phải trang trải toàn bộ cuộc sống hiện nay của bạn, không phải thắt lưng buộc bụng.“',
        title: 'Độc lập tài chính',
      },
      a2: {
        big: 'Thu nhập thụ động bạn cần (giá hiện nay)',
        kicker: 'Lối sống của bạn',
        lBez1: 'Thu nhập thụ động phải trang trải TỔNG chi tiêu hằng tháng (lối sống).',
        lBez2: 'Hãy bổ sung chi tiêu trong phân tích để số tiền khớp.',
        lRenta: 'Thu nhập thụ động nhập trong mục tiêu: {renta}.',
        lVydaje: 'Tổng chi tiêu hằng tháng của bạn theo phân tích: {vydaje}.',
        nar: '„Đây là chi tiêu hiện nay của bạn theo phân tích và khoản thu nhập thụ động bạn đã nhập cho mục tiêu. Mọi thứ khác đều dựa trên hai con số này.“',
        title: 'Chi tiêu hằng tháng hiện nay của bạn',
      },
      a3: {
        big: 'Số vốn cần (theo giá hiện nay)',
        kicker: 'Quy tắc 4 %',
        l2: '4 % là lợi suất thực TRÊN lạm phát — vốn gốc còn nguyên, bạn rút mãi mãi.',
        lRocne: '{renta}/tháng = {rocne} mỗi năm.',
        nar: '„Bạn có thể rút an toàn ~4 % tài sản mỗi năm trên lạm phát mãi mãi. Từ chi tiêu của bạn, chúng ta tính số vốn cần thiết.“',
        title: 'Thu nhập × 12 ÷ 4 % = vốn',
      },
      a4: {
        big: 'Số vốn mục tiêu cho tự do',
        l1: 'Đầu tư đều đặn + thời gian = quả cầu tuyết, thu nhập suốt đời.',
        lCil: 'Mục tiêu sau {roky} năm.',
        lCilVek: 'Mục tiêu sau {roky} năm, khi bạn {vek} tuổi.',
        lKazdy: 'Mỗi tháng để dành là thêm một tháng tự do.',
        nar: '„Sự độc lập không mua được bằng tiền một lần, mà bằng thời gian và sự đều đặn. Quả cầu tuyết lãi kép sẽ làm phần còn lại.“',
        title: 'Tự do được mua bằng thời gian',
      },
    },
    rezerva: {
      a1: {
        big: 'Bạn đang có bao nhiêu tháng yên tâm?',
        kicker: 'Nếu như…',
        l1: 'Xe hỏng, mất việc, ốm đau, tủ lạnh hỏng.',
        l2: 'Không có quỹ dự phòng thì sẽ mắc nợ — thẻ tín dụng, khoản vay, căng thẳng.',
        nar: '„Hãy tưởng tượng ngày mai thu nhập mất đi. Bạn giữ được cuộc sống bình thường như hiện nay trong bao lâu?“',
        title: 'Nếu ngày mai bạn mất thu nhập thì sao?',
      },
      a2: {
        big: 'người Séc không có quỹ dự phòng dù chỉ một tháng',
        kicker: 'Thực tế ở Séc',
        l1: '14 % hoàn toàn không có quỹ dự phòng.',
        l2: 'Gần một phần ba không để dành nổi một tháng thu nhập.',
        l3: 'Nguồn: STEM/MARK cho Home Credit, 2024.',
        nar: '„Bạn không đơn độc — nhưng chính vì vậy quỹ dự phòng là bước đầu tiên. 14 % người không có gì cả, một phần ba không trụ nổi một tháng.“',
        title: 'Gần một phần ba người Séc không trụ nổi một tháng',
      },
      a3: {
        bigCil: 'Quỹ dự phòng mục tiêu',
        bigMes: '= {mes} tháng yên tâm',
        kicker: 'Quy tắc',
        lBez1: 'Để dành chi phí 3–6 tháng = yên tâm.',
        lBez2: 'Hãy bổ sung chi phí thiết yếu để tính chính xác số tháng.',
        lCil: 'Mục tiêu {cil} = {mes} tháng yên tâm.',
        lNez: 'Chi phí thiết yếu của bạn: {nez}/tháng.',
        nar: '„Mục tiêu là 3 đến 6 tháng chi phí thiết yếu. Với bạn, con số đó là số tiền này.“',
        title: 'Quỹ dự phòng = 3–6× chi phí thiết yếu',
      },
      a4: {
        big: 'Lá chắn của bạn trước rủi ro',
        lDnes: 'Thời hạn: hôm nay — quỹ dự phòng được giải quyết đầu tiên.',
        lTermin: 'Thời hạn: sau {roky} năm.',
        nar: '„Bạn không cần có ngay. Chúng ta bắt đầu từng chút — quan trọng là bắt đầu. Quỹ dự phòng là nền tảng của cả kế hoạch.“',
        title: 'Tấm đệm được xây dần từng chút',
      },
    },
    spolecne: {
      cenaZadani: 'Giá theo dữ liệu đã nhập: {castka}.',
      cilovaCastka: 'Số tiền mục tiêu theo dữ liệu đã nhập: {castka}.',
      dejstvi: 'Phần {n}',
      hotovo: 'Xong ✓',
      modelNajmu: 'Mô hình: tiền thuê 0,35 % giá mỗi tháng, tăng 3 % mỗi năm; khoản vay mua nhà trả dần giá đều đặn, không tính lãi và chi phí bảo trì. Thực tế khác nhau tùy vị trí, lãi suất và tình trạng bất động sản.',
      osaDnes: 'HÔM NAY',
      osaVek: 'ở tuổi {vek}',
      osaZa: 'sau {n} năm',
      pauza: 'Tạm dừng',
      termin: 'Thời hạn: sau {roky} năm.',
      terminNeni: 'Chưa xác định thời hạn.',
      terminVek: 'Thời hạn: sau {roky} năm, khi bạn {vek} tuổi.',
      zacniDnes: 'Bắt đầu hôm nay',
    },
    vzdelani: {
      a1: {
        big: 'Việc học sẽ tốn bao nhiêu?',
        kicker: 'Món quà lớn nhất',
        l1: 'Bằng cấp, ngoại ngữ, du học, khởi đầu sự nghiệp.',
        l2: 'Điều tốt nhất bạn có thể cho con — và nó tốn tiền.',
        nar: '„Khoản đầu tư tốt nhất là vào chính con mình. Hãy xem điều gì đang chờ các con.“',
        title: 'Giáo dục = khởi đầu cuộc sống',
      },
      a2: {
        big: 'Mục tiêu của bạn cho {deti}',
        kicker: 'Chi phí giáo dục',
        l1: 'Học tại Séc ≈ 300–600 nghìn (chỗ ở, ăn uống, tài liệu).',
        l2: 'Đại học nước ngoài ≈ 1–3 triệu Kč.',
        nar: '„Học trong nước tốn hàng trăm nghìn, học ở nước ngoài có thể hàng triệu. Biết trước thì tốt hơn.“',
        title: 'Ở Séc hàng trăm nghìn, ở nước ngoài hàng triệu',
      },
      a3: {
        big: 'Số tiền mục tiêu',
        bigRoky: 'Bạn kịp trong {roky} năm',
        kicker: 'Thời gian đang trôi',
        nar: '„Thời gian đứng về phía bạn. Bắt đầu sớm nghĩa là để dành ít hơn nhiều.“',
        title: 'Thời gian là đồng minh của bạn',
        titleRoky: 'Cần sau {roky} năm',
      },
      a4: {
        big: 'Tương lai của các con',
        l1: 'Đầu tư đều đặn từ hôm nay = yên tâm khi đến lúc.',
        l2: 'Chúng ta sẽ lên kế hoạch để dành hằng tháng cho việc học.',
        nar: '„Vài trăm mỗi tháng hôm nay = cánh cửa rộng mở cho con bạn ngày mai.“',
        title: 'Số tiền nhỏ, tấm bằng lớn',
      },
      deti: 'các con',
      dite: 'con',
    },
    zdroj: {
      akontaceCZ: 'ČNB, biện pháp chung số I/2021 (LTV: dưới 36 tuổi 90 %, còn lại 80 %), kiểm tra ngày {datum}',
      akontaceSK: 'NBS, quy định số 10/2016 § 7 và § 9d (LTV: đến hết năm 2026 chắc chắn 80 %, từ 2027 nhà ở đầu tiên đến 35 tuổi 90 %), kiểm tra ngày {datum}',
      cnb: 'ČNB (Ngân hàng Quốc gia Séc) — khuyến nghị về các chỉ số tín dụng',
      ctyriProcenta: 'Quy tắc rút tiền an toàn 4 % (nghiên cứu Trinity)',
      klient: 'Dữ liệu từ phân tích của khách hàng',
      najemModel: 'So sánh mô hình giữa thuê nhà và vay mua nhà (giả định ở biểu đồ)',
      nbs: 'NBS — quy định số 10/2016 § 8a (giới hạn DTI)',
      rezervaPravidlo: 'Phương pháp nội bộ — quỹ dự phòng thanh khoản bằng 3–6× chi phí thiết yếu',
      stem: 'STEM/MARK cho Home Credit',
    },
  },
  /* BLOK:kinoCile END */
  /* BLOK:invaliditaVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  invaliditaVysvetleni: {
    aria: 'Sau khi mất sức cần {potreba}, nhận được {prijde}, còn thiếu {chybi}.',
    ariaPrebyva: 'Sau khi mất sức cần {potreba}, nhận được {prijde}, còn dư {prebyva}.',
    bezVydaju: 'Chưa tính được mức bảo hiểm mất sức lao động — phân tích còn thiếu chi tiêu.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} theo giá hôm nay. Chúng tôi giả định số tiền được chi trả sẽ được gửi với lợi suất mô hình 4 % trên lạm phát (mô hình, không phải cam kết). Vì vậy hôm nay chỉ cần {kapital}.',
    chybiVeta: 'thiếu {castka} mỗi tháng · {roky}',
    cilBezHorizontu: 'mục tiêu {nazev} chưa có thời hạn, chưa tính',
    duchod: 'lương hưu mất sức lao động của nhà nước',
    duchodSablona: 'lương hưu mất sức lao động (mẫu theo quốc gia)',
    jenUkazka: 'Chỉ minh họa — không ghi gì vào kế hoạch.',
    krok1: 'Chi tiêu sau khi mất sức',
    krok1B: 'Chi tiêu gia đình tăng thêm bao nhiêu',
    krok1BPod: '+20 % của {vydaje}',
    krok1Pod: 'chữa trị, chăm sóc, sửa nhà',
    krok2: 'Gia đình nhận được gì',
    krok2B: 'Nhà nước chi trả gì',
    krok3: 'Phần còn thiếu — đến khi có thu nhập thụ động ({roky})',
    krok3B: 'Phần còn thiếu — trong {roky}',
    krok4: 'Hạn mức mất sức lao động',
    krok4BPod: 'nợ, mục tiêu và thu nhập thụ động do bảo hiểm mất sức lao động của người trụ cột chi trả',
    krok4Pod: 'phần thiếu + nợ + mục tiêu + thu nhập thụ động − những gì đã có',
    model: 'Mô hình tham khảo, không phải cam kết: tính với lợi suất 4 % trên lạm phát, lợi suất thấp hơn thì hạn mức cao hơn. Lương hưu mất sức lao động tính cho mức III (mất sức hoàn toàn), mức I và II thấp hơn. Quyền lợi do điều kiện bảo hiểm quy định.',
    nepotreba: 'Gia đình vẫn còn đủ thu nhập — không cần bảo hiểm mất sức lao động.',
    nicNechybi: 'Thu nhập vừa đủ trang trải chi tiêu của gia đình.',
    odvozenaRenta: 'suy ra: thu nhập thụ động = chi tiêu hôm nay',
    odvozenaRentaPotreba: 'suy ra: lương hưu = chi tiêu và trả nợ hôm nay, không tính tiết kiệm và nợ trả xong trước khi nghỉ hưu',
    odvozeneRoky: 'suy ra: thời hạn đến thu nhập thụ động {roky} theo mẫu',
    orezano: 'Thu nhập và tài sản đủ cho gia đình — không cần bảo hiểm mất sức lao động.',
    partner: '{jmeno} vẫn tiếp tục đi làm',
    pasivniAria: 'Thu nhập thụ động {castka}, hạn mức mất sức lao động {limit}',
    pasivniTitul: 'Nếu hôm nay có thu nhập thụ động',
    pasivniVeta: 'Bảo hiểm là cái giá phải trả khi chúng ta chưa có thu nhập thụ động.',
    prahMezera: 'bù được phần thiếu',
    prahNula: 'không cần bảo hiểm',
    prebyvaVeta: 'Thu nhập đủ cho gia đình và còn dư {castka} — hạn mức giảm tương ứng.',
    rada: {
      chybi: 'còn thiếu',
      dnes: 'hôm nay',
      duchod: 'lương hưu mất sức lao động',
      narust: '+20 % sau khi mất sức',
      partner: 'thu nhập của vợ/chồng',
      pasivni: 'thu nhập thụ động',
    },
    radekChybi: 'Phần thiếu đến khi có thu nhập thụ động',
    radekCile: 'Đầu tư cho mục tiêu (giá trị hôm nay)',
    radekDluhy: 'Trả hết nợ',
    radekMajetek: 'Số tiền đã có trong tài khoản',
    radekPrebytek: 'Phần thu nhập gia đình còn dư — đến khi có thu nhập thụ động ({roky})',
    radekRenta: 'Đầu tư cho thu nhập thụ động (giá trị hôm nay)',
    radekRentaPod: '{castka} theo giá hôm nay sau {roky}, rút 4 %',
    rucne: 'Thẻ hiển thị {rucni} nhập tay, tính toán ra {spocitano}.',
    skryt: 'Ẩn cách tính',
    titul: 'Số tiền bảo hiểm mất sức lao động được tính thế nào',
    toggle: 'Cách tính bảo hiểm mất sức lao động',
    vysledek: 'Hạn mức mất sức lao động',
    zaokrouhleni: 'Các dòng được làm tròn, tổng có thể chênh lệch một chút.',
  },
  /* BLOK:invaliditaVysvetleni END */
  /* BLOK:staraZtrata START — generuje scratchpad/slovnik.py, ručně needitovat */
  staraZtrata: {
    invalidita: 'Hợp đồng cũ có bảo hiểm mất sức lao động {castka}, hợp đồng mới thì không.',
    jine: 'Hợp đồng cũ có {riziko} {castka}, hợp đồng mới thì không.',
    smrt: 'Hợp đồng cũ có bảo hiểm tử vong {castka}, hợp đồng mới thì không.',
  },
  /* BLOK:staraZtrata END */
  /* BLOK:schodPoSchodu START — generuje scratchpad/slovnik.py, ručně needitovat */
  schodPoSchodu: {
    bezDat: 'Chưa thể tính gì từ phân tích này.',
    bezPrijmu: 'Không có thu nhập và chi tiêu thì không tính được. Hãy bổ sung trong phân tích.',
    e: {
      doporucene: 'Thứ tự đề xuất',
      hlasDoporucene: 'Đã khôi phục thứ tự đề xuất.',
      hlasPosun: '{nazev} hiện ở vị trí {n}.',
      nadpis: 'Điều gì quan trọng nhất với anh chị?',
      niz: 'Đưa {nazev} xuống',
      podnadpis: 'Ở trên cùng là điều anh chị muốn có trước.',
      renta: 'Hưu trí · nhận phần còn lại',
      rovne: 'Với tôi mọi thứ đều quan trọng như nhau',
      seznam: 'Thứ tự mục tiêu',
      tahnout: 'Kéo: {nazev}',
      ulozit: 'Lưu thứ tự',
      vys: 'Đưa {nazev} lên',
      zaklad: 'Nền tảng: dự phòng và bảo vệ thu nhập · luôn đầu tiên',
      zakladRezerva: 'Nền tảng: dự phòng · luôn đầu tiên',
      zakladZajisteni: 'Nền tảng: bảo vệ thu nhập · luôn đầu tiên',
      zrusit: 'Hủy',
    },
    k: {
      cilCast: '{nazev}: đến năm {rok} tích lũy được {pct}, còn thiếu {chybi}.',
      cilHotovo: '{nazev}: đạt được vào năm {rok}, đúng hạn.',
      cileFew: '{vcas}/{celkem} mục tiêu đúng hạn',
      cileMany: '{vcas}/{celkem} mục tiêu đúng hạn',
      cileOne: '{vcas}/{celkem} mục tiêu đúng hạn',
      dalsiCast: 'Các mục tiêu khác ({n}): đến hạn tích lũy được {pct}, còn thiếu {chybi}.',
      dalsiHotovo: 'Các mục tiêu khác ({n}): đạt đúng hạn.',
      nezadaneFew: '{n} mục tiêu chưa có số tiền hoặc thời hạn.',
      nezadaneMany: '{n} mục tiêu chưa có số tiền hoặc thời hạn.',
      nezadaneOne: '{n} mục tiêu chưa có số tiền hoặc thời hạn.',
      renta: 'Thu nhập hưu trí từ năm {rok}: theo mô phỏng đã chuẩn bị {pct} (bi quan {pes}), còn thiếu {chybi}.',
      rentaHotovo: 'Thu nhập hưu trí từ năm {rok}: theo mô phỏng đã chuẩn bị {pct} (bi quan {pes}).',
      shrnuti: 'Với {castka} mỗi tháng: {cile}, hưu trí {renta}.',
      shrnutiBezRenty: 'Với {castka} mỗi tháng: {cile}.',
      shrnutiJenRenta: 'Với {castka} mỗi tháng: hưu trí {renta}.',
      srovnani: 'Với {castka} mỗi tháng: {cile} (trước đó {vcasDrive}), hưu trí {renta} thay vì {rentaDrive}.',
      srovnaniBezRenty: 'Với {castka} mỗi tháng: {cile} (trước đó {vcasDrive}).',
      srovnaniJenRenta: 'Với {castka} mỗi tháng: hưu trí {renta} thay vì {rentaDrive}.',
      uvod: 'Anh chị để dành {castka} mỗi tháng. Đến các mốc mong muốn sẽ có bao nhiêu?',
      zajisteni: 'Bảo vệ thu nhập sẽ thu xếp sau buổi gặp.',
      zaklad: 'Trước hết là nền tảng.',
      zakladCast: 'Trước hết là nền tảng: đến năm {rok} quỹ dự phòng đạt {pct}, còn thiếu {chybi}.',
      zakladHotovo: 'Trước hết là nền tảng: quỹ dự phòng đủ vào năm {rok}.',
      zakladMa: 'Trước hết là nền tảng: quỹ dự phòng anh chị đã có sẵn.',
    },
    nadpis: 'Từng bước một',
    neodsouhlaseno: 'khách hàng chưa đồng ý',
    o: {
      dal: 'Bước tiếp',
      dalsi: 'Khác',
      krok: 'Bước {n}: {nazev}',
      kroky: 'Các bước phát',
      otazka: 'Thứ tự',
      pauza: 'Tạm dừng',
      pokracovat: 'Tiếp tục',
      prehrat: 'Phát',
      preskocit: 'Bỏ qua',
      uvod: 'Bắt đầu',
      zaklad: 'Nền tảng',
      znovu: 'Phát lại',
      zpet: 'Lùi một bước',
    },
    odkladani: 'Để dành mỗi tháng',
    p: {
      bezPojistneho: 'Chưa nhập phí bảo hiểm, không trừ gì khỏi tiền dư.',
      dnes: '“Hiện tại” = số tiền anh chị đang để dành đều đặn (tiết kiệm, quỹ hưu trí, quỹ đầu tư).',
      model: 'Chỉ là mô phỏng, không phải cam kết. Cùng cách tính như Đề xuất giải pháp: mỗi mục tiêu chỉ nhận tiền đến hạn của nó và cho thấy đến hạn sẽ có bao nhiêu. Bi quan = lợi nhuận thấp hơn.',
      pojistne: 'Tiền dư sau phí bảo hiểm = tiền dư tự do trừ phí bảo hiểm do tư vấn viên báo.',
    },
    precerpano: 'Số tiền nhập tay ở các mục tiêu: vượt {castka} — chỉ tính với {dostupne} mỗi tháng.',
    prehravac: 'trình phát',
    q: {
      ano: 'Đồng ý',
      nemeniCisla: 'Các con số ở trên do Đề xuất giải pháp tính theo thời hạn. Thứ tự của khách hàng đã được ghi lại, nhưng chưa thay đổi kết quả tính.',
      otazka: 'Anh chị đồng ý với thứ tự này không?',
      popis: 'Nền tảng → {cile} → hưu trí',
      popisBezCilu: 'Nền tảng → hưu trí',
      popisBezRenty: 'Nền tảng → {cile}',
      popisRovne: 'Nền tảng, sau đó mọi thứ quan trọng như nhau: {cile}, phần còn lại cho hưu trí',
      popisRovneBezRenty: 'Nền tảng, sau đó mọi thứ quan trọng như nhau: {cile}',
      potvrzeno: 'Đã xác nhận thứ tự {datum}',
      upraveno: 'Đã ghi thứ tự của khách hàng {datum}',
      upravit: 'Điều chỉnh',
      zmenit: 'Thay đổi',
    },
    s: {
      bezUdaju: 'chưa có dữ liệu',
      castkaNezadana: 'chưa nhập số tiền',
      chybi: 'thiếu {castka}',
      cil: 'mục tiêu',
      cileFew: '{n} mục tiêu',
      cileMany: '{n} mục tiêu',
      cileOne: '{n} mục tiêu',
      dalsiFew: 'thêm {n}',
      dalsiMany: 'thêm {n}',
      dalsiOne: 'thêm {n}',
      doplneno: 'đã đủ',
      doplnit: 'cần bổ sung',
      drive: 'trước đó {pct}',
      kRoku: 'đến {rok}',
      maDnes: 'đã có',
      mesicne: '{castka}/tháng',
      nepocitaSe: 'không tính',
      pesimisticky: 'bi quan {pct}',
      poSchuzce: 'sau buổi gặp',
      pojisteni: 'Bảo hiểm',
      potreba: 'cần',
      pripraveno: 'đã chuẩn bị',
      renta: 'Hưu trí',
      rezerva: 'Dự phòng',
      sjednat: 'thu xếp',
      ted: 'bây giờ',
      terminNezadan: 'chưa nhập thời hạn',
      vcas: 'đúng hạn',
    },
    schodyAria: 'Các bậc mục tiêu. {shrnuti}',
    stitek: 'Mô phỏng',
    tlacitko: 'Phát',
    tlacitkoPopis: 'từng bước',
    tlacitkoTitul: 'Hoạt ảnh ngắn: đến hạn mỗi mục tiêu sẽ có bao nhiêu, theo thứ tự',
    vekFew: '{n} tuổi',
    vekMany: '{n} tuổi',
    vekOne: '{n} tuổi',
    volbaDnes: 'Hiện tại {castka}',
    volbaPlan: 'Tiền dư {castka}',
    volbaPlanPoPojistnem: 'Tiền dư sau phí bảo hiểm {castka}',
    zavrit: 'Đóng phần phát',
  },
  /* BLOK:schodPoSchodu END */
  /* BLOK:smlouvaEditor START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaEditor: {
    celkova: 'Tổng số tiền ({mena})',
    chybaPoli: 'Máy chủ không nhận dữ liệu — vui lòng kiểm tra các ô đã điền.',
    chybaServeru: {
      jenPojistne: 'Chỉ có thể tạo thư chấm dứt cho hợp đồng bảo hiểm',
      klientNenalezen: 'Không tìm thấy khách hàng',
      neplatneId: 'Liên kết không hợp lệ — hãy tải lại trang và thử lại.',
      smlouvaNenalezena: 'Không tìm thấy hợp đồng',
    },
    cislo: 'Số hợp đồng',
    fixace: 'Hết kỳ cố định',
    hodnota: 'Giá trị hiện tại ({mena})',
    instituce: 'Ngân hàng / công ty bảo hiểm',
    mazaniSelhalo: 'Xóa thất bại',
    mesicni: 'Số tiền hàng tháng ({mena})',
    nadpisEditace: 'Sửa hợp đồng',
    nadpisNova: 'Hợp đồng mới',
    napr: 'vd. {x}',
    nasporeno: 'Đã tiết kiệm ({mena})',
    poznamky: 'Ghi chú',
    poznamkyNapr: 'Điều quan trọng về hợp đồng này…',
    pridano: 'Đã thêm hợp đồng',
    pridat: 'Thêm hợp đồng',
    sazba: 'Lãi suất (%)',
    smazano: 'Đã xóa hợp đồng',
    smazat: 'Xóa',
    smazatPotvrzeni: 'Thật sự xóa hợp đồng này? Các việc liên quan trong nhật ký cũng sẽ bị xóa.',
    stav: 'Trạng thái',
    stavActive: 'Đang hiệu lực',
    stavCancelled: 'Đã hủy',
    stavExpired: 'Đã hết hạn',
    typChybi: 'Hãy chọn loại hợp đồng',
    typSmlouvy: 'Loại hợp đồng *',
    typy: {
      hypoteka: 'Vay thế chấp',
      investice: 'Đầu tư',
      jine: 'Khác',
      penzijko: 'Hưu trí (DPS/DIP)',
      pojisteni_auta: 'Bảo hiểm ô tô',
      pojisteni_majetek: 'Bảo hiểm tài sản',
      pojisteni_odpovednost: 'Bảo hiểm trách nhiệm',
      pojisteni_ostatni: 'Bảo hiểm khác (bảo vệ pháp lý, du lịch…)',
      pojisteni_zivot: 'Bảo hiểm nhân thọ',
      stavebni: 'Tiết kiệm xây dựng',
      uver: 'Khoản vay',
      zdravotni: 'Sức khỏe',
    },
    ukladaniSelhalo: 'Lưu thất bại',
    ulozeno: 'Đã lưu hợp đồng',
    ulozenoJakoJine: 'Đã lưu là “Khác” — máy chủ chưa biết loại hợp đồng này.',
    ulozitZmeny: 'Lưu thay đổi',
    vyber: '— Chọn —',
    vyroci: 'Ngày kỷ niệm hợp đồng',
    zacatek: 'Ngày bắt đầu hợp đồng',
    zavrit: 'Đóng',
    zbyva: 'Còn phải trả ({mena})',
    zrusit: 'Hủy',
  },
  /* BLOK:smlouvaEditor END */
  /* BLOK:cilHistorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHistorie: {
    cilCastka: 'mục tiêu {castka}',
    hero: 'các giai đoạn {roky} năm trong lịch sử (1946–2026) sẽ [[đạt mục tiêu]]',
    heroPozn: '{ok} trên {n} khung thời gian trượt. Tất cả theo giá trị thực, đã trừ lạm phát của từng thời kỳ.',
    jednotka: {
      milion: 'tr.',
      tisic: 'nghìn',
    },
    legenda: {
      median: 'trung vị',
      nejhorsi: 'khung tệ nhất',
      nejlepsi: 'khung tốt nhất',
      projekce: 'dự phóng ({varianta})',
    },
    nadpis: 'Máy tính lịch sử — nếu khách hàng đã đầu tư như vậy trong quá khứ',
    tip: {
      median: 'Trung vị',
      nejhorsi: 'Khung tệ nhất',
      nejlepsi: 'Khung tốt nhất',
      projekce: 'Dự phóng',
    },
    tipRok: 'Năm {rok} · +{n} năm',
  },
  /* BLOK:cilHistorie END */
  /* BLOK:smlouvaKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaKarta: {
    aktualniHodnota: 'Giá trị hiện tại',
    bezCisla: 'chưa nhập số',
    celkem: 'Tổng',
    cislo: 'Số {cislo}',
    druh: {
      hypoteka: 'Vay thế chấp',
      investice: 'Đầu tư',
      jine: 'Khác',
      penzijko: 'Tiết kiệm hưu trí (DPS)',
      pojisteni_auta: 'Bảo hiểm ô tô',
      pojisteni_majetek: 'Bảo hiểm tài sản',
      pojisteni_odpovednost: 'Bảo hiểm trách nhiệm',
      pojisteni_ostatni: 'Bảo hiểm khác',
      pojisteni_zivot: 'Bảo hiểm nhân thọ',
      stavebni: 'Tiết kiệm xây dựng',
      uver: 'Khoản vay',
      zdravotni: 'Sức khỏe',
    },
    fixaceDo: 'Cố định đến',
    generuji: 'Đang tạo…',
    kratce: {
      hypoteka: 'Thế chấp',
      investice: 'Đầu tư',
      jine: 'Khác',
      penzijko: 'Hưu trí',
      pojisteni_auta: 'BH ô tô',
      pojisteni_majetek: 'BH tài sản',
      pojisteni_odpovednost: 'Trách nhiệm',
      pojisteni_ostatni: 'BH khác',
      pojisteni_zivot: 'BH nhân thọ',
      stavebni: 'TK xây dựng',
      uver: 'Khoản vay',
      zdravotni: 'Sức khỏe',
    },
    mesicne: 'Hàng tháng',
    nasporeno: 'Đã tiết kiệm',
    okno: {
      datumMinulo: 'Ngày chấm dứt {datum} đã qua — hãy sửa trong thư thành ngày kết thúc kỳ bảo hiểm hiện tại.',
      jazyk: {
        cs: 'tiếng Séc',
        sk: 'tiếng Slovakia',
      },
      jazykDopisu: 'Thư được viết bằng ngôn ngữ của công ty bảo hiểm ({jazyk}).',
      kopirovat: 'Sao chép văn bản',
      lhutySK: 'Chấm dứt vào cuối kỳ bảo hiểm, chậm nhất 6 tuần trước (§ 800 khoản 1). Trong 2 tháng sau khi ký chỉ khi hợp đồng cho phép, báo trước 8 ngày (§ 800 khoản 2).',
      sablona: 'Mẫu — trước khi ký, hãy kiểm tra thông tin, thời hạn và địa chỉ công ty bảo hiểm trong hợp đồng và điều kiện.',
      staryServer: 'Máy chủ đã trả về mẫu của Séc. Bản tiếng Slovakia sẽ có sau khi cập nhật máy chủ — trước đó hãy sửa văn bản trước khi gửi.',
      tisk: 'In / lưu PDF',
      titulek: 'Chấm dứt — {pojistovna} / {klient}',
      zaklad: 'Cơ sở pháp lý: {zaklad}',
      zavrit: 'Đóng',
      zkopirovano: 'Đã sao chép vào bộ nhớ tạm',
    },
    pocetFew: '{n} hợp đồng',
    pocetMany: '{n} hợp đồng',
    pocetOne: '{n} hợp đồng',
    poznamkaZAnalyzy: 'Từ phân tích — hợp đồng có từ trước khi phân tích',
    prazdnoNadpis: 'Chưa có hợp đồng',
    prazdnoText: 'Thêm hợp đồng đầu tiên của khách hàng — vay thế chấp, bảo hiểm, đầu tư…',
    predAnalyzou: 'trước phân tích',
    predAnalyzouTitle: 'Hợp đồng chuyển từ phân tích tài chính — khách hàng đã có trước khi phân tích',
    prehled: {
      fixaceLet: 'cố định {n} năm',
      mesicne: '{castka} / tháng',
      smlouvy: 'Hợp đồng',
      smlouvyPocet: 'Hợp đồng ({n})',
      zadneSmlouvyZatim: 'Chưa có hợp đồng — hãy thêm trong thẻ hợp đồng.',
      zobrazitDalsi: '+ Xem thêm {n}',
    },
    pridat: 'Thêm hợp đồng',
    toastChyba: 'Không tạo được thư',
    toastHotovo: 'Đã tạo thư — in hoặc lưu thành PDF',
    toastPopup: 'Trình duyệt đã chặn cửa sổ — hãy cho phép cửa sổ bật lên.',
    toastStaryServer: 'Máy chủ hiện chỉ có mẫu của Séc — hãy sửa văn bản theo luật Slovakia trước khi gửi.',
    upravit: 'Sửa hợp đồng',
    vypoved: 'Thư chấm dứt gửi công ty bảo hiểm',
    vypovedTitle: 'Tạo mẫu thư chấm dứt hợp đồng theo {zakon} — in hoặc lưu thành PDF',
    vyroci: 'Ngày kỷ niệm HĐ',
    zAnalyzy: 'Từ phân tích: {popis}',
    zacatek: 'Bắt đầu',
    zakon: {
      CZ: '§ 2807 Bộ luật Dân sự Séc',
      SK: '§ 800 Bộ luật Dân sự Slovakia',
    },
    zbyvaSplatit: 'Còn phải trả',
  },
  /* BLOK:smlouvaKarta END */
  /* BLOK:navrhDavky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhDavky: {
    invalidniMes: 'Lương hưu mất sức lao động (tháng)',
    starobniMes: 'Lương hưu tuổi già (tháng)',
  },
  /* BLOK:navrhDavky END */
  /* BLOK:variantaVynosu START — generuje scratchpad/slovnik.py, ručně needitovat */
  variantaVynosu: {
    optimisticky: 'Lạc quan',
    pesimisticky: 'Bi quan',
    realisticky: 'Thực tế',
  },
  /* BLOK:variantaVynosu END */
  /* BLOK:penze2 START — generuje scratchpad/slovnik.py, ručně needitovat */
  penze2: {
    chyby: {
      bezData: 'Ngày sinh: hãy điền, hoặc bật nhập số năm tiết kiệm thủ công.',
      cele: '{pole}: hãy nhập số nguyên.',
      cislo: '{pole}: hãy nhập một số.',
      datum: 'Ngày sinh: không được ở tương lai hoặc không hợp lệ.',
      nadpis: 'Hãy sửa các ô được đánh dấu. Kết quả hiện vẫn theo lần nhập hợp lệ gần nhất.',
      prazdne: '{pole}: hãy nhập giá trị.',
      rozsah: '{pole}: hãy nhập giá trị từ {min} đến {max}.',
      vPenzi: 'Khách hàng đã đến tuổi nghỉ hưu. Hãy bật nhập số năm tiết kiệm thủ công.',
    },
    f: {
      bezDat: 'Không có dữ liệu cho lựa chọn này trong giai đoạn.',
      dataDo: 'dữ liệu chỉ đến {rok}',
      dataOd: 'dữ liệu từ {rok}',
      grafAria: 'Biểu đồ đường diễn biến 100 Kč trong các quỹ giai đoạn {obdobi}. Cao nhất {fond}: {hodnota}',
      grafNadpis: 'Diễn biến 100 Kč, {obdobi}',
      grafPopis: 'Chỉ số 100 = giá trị cuối năm {rok}',
      historie: 'Lịch sử',
      kontext: 'Các quỹ đã chọn khác màu xám ở nền',
      maxZvyr: 'Chỉ có thể làm nổi bật tối đa {max} quỹ. Hãy bỏ chọn một quỹ trước.',
      mimoVyber: 'ngoài lựa chọn',
      nic: 'Bỏ chọn',
      o10: '10 năm',
      o3: '3 năm',
      o5: '5 năm',
      oVse: 'Tất cả',
      obdobi: 'Giai đoạn',
      pocet: 'Quỹ: {n} · nổi bật {z} trên {max}',
      prumery: 'Trung bình chiến lược (nét đứt)',
      slAkce: 'Thao tác',
      slCelkem: 'Cả giai đoạn',
      slFond: 'Quỹ / trung bình',
      slPa: 'Lợi nhuận p. a.',
      slRust: 'Tăng trưởng 1 Kč',
      slStrategie: 'Chiến lược',
      slVolatilita: 'Biến động',
      spolecnost: 'Công ty hưu trí',
      strategie: 'Chiến lược',
      tabulka: 'Các quỹ',
      tabulkaInfo: 'Có thể làm nổi bật tối đa 5 quỹ bằng cách đánh dấu. Dấu sao = quỹ không có dữ liệu cả giai đoạn; lợi nhuận p. a. tính từ khi thành lập và đường bắt đầu từ năm thành lập.',
      uvod: '100 Kč đã tăng thế nào trong các quỹ của công ty hưu trí. Lợi nhuận năm sau phí (APS ČR, banky.cz).',
      vse: 'Chọn tất cả',
      vsechnySpolecnosti: 'tất cả công ty',
      vyber: 'Chọn quỹ',
      vyberteAspon: 'Hãy chọn ít nhất một chiến lược và một công ty hưu trí.',
      vysvetlivky: 'Cách đọc bảng',
      vysvetlivkyInfo: 'Lợi nhuận p. a. = lợi nhuận trung bình hằng năm trong giai đoạn (trung bình nhân). Cả giai đoạn = giá trị tăng bao nhiêu phần trăm. Biến động = độ lệch chuẩn của lợi nhuận năm. Quỹ chuyển đổi (quỹ hưu trí cũ) không có kết quả âm vì theo luật công ty hưu trí phải bù.',
      vznik: 'thành lập {datum}, năm đầu chỉ một phần',
      zadnyZvyr: 'Chưa có quỹ nào được làm nổi bật. Hãy đánh dấu trong bảng.',
      zrusitZvyr: 'Bỏ làm nổi bật: {fond}',
    },
    h: {
      chybaCastka: '{pole}: hãy nhập số từ 0 trở lên, ví dụ 1 000.',
      chybaObdobi: 'Thời điểm bắt đầu phải trước thời điểm kết thúc.',
      chybaRok: '{fond}: không có lợi nhuận cho năm {rok}. Dữ liệu có từ năm {od}.',
      danVyber: 'Thuế khi rút một lần (ước tính)',
      danVyberInfo: 'Khi rút một lần, nộp thuế 15 % trên lợi nhuận và khoản của người sử dụng lao động. Nhận niên kim từ 10 năm trở lên thì không phải nộp thuế.',
      dipFond: 'DIP đầu tư vào đâu',
      dipInfo: 'DIP có từ năm 2024. Các năm trước đó là mô phỏng cùng khoản đóng vào quỹ đã chọn, không có trợ cấp nhà nước. Tiết kiệm thuế (khấu trừ đến 48 000 Kč mỗi năm, 15 %) chỉ tính từ năm 2024.',
      dipPozn: 'Nhà nước không trợ cấp cho DIP.',
      dipPoznInfo: 'Khi rút sau 60 tuổi và sau 10 năm, lợi nhuận không bị đánh thuế.',
      doMesice: 'Đến tháng',
      doRoku: 'Đến năm',
      drive: 'trước đây {nazev}',
      duchod: 'Khách hàng đang nhận lương hưu tuổi già',
      fond: 'Quỹ hoặc trung bình',
      grafAria: 'Giá trị tài khoản {od}–{do}: cao nhất {fond} {castka}, khoản tự đóng {vklady}',
      grafNadpis: 'Giá trị tài khoản cuối năm',
      grafNadpisMesic: 'Giá trị tài khoản cuối năm (năm cuối tính đến tháng đã chọn)',
      kpiNasporeno: 'Đã tích lũy',
      kpiNove: 'Quỹ hưu trí mới',
      kpiRozdil: 'Chênh lệch',
      kpiStare: 'Quỹ hưu trí cũ',
      kpiStat: 'Tổng từ nhà nước',
      kpiUsporaDip: 'Tổng tiết kiệm thuế',
      kpiVDip: 'Tích lũy trong DIP',
      kpiVklady: 'Khoản tự đóng',
      kpiZhod: 'Lợi nhuận trên tiền tự đóng',
      mesicuStat: '{mesicu}, nhà nước {stat}',
      nove: 'Quỹ hưu trí mới (quỹ hoặc trung bình)',
      noveOd2013: 'Quỹ hưu trí mới có từ năm 2013.',
      od: 'từ {rok}',
      odMesice: 'Từ tháng',
      odRoku: 'Từ năm',
      pohled: {
        cmp: 'Quỹ cũ và quỹ mới',
        dip: 'DIP',
        fund: 'Quỹ cụ thể',
        str: 'So sánh chiến lược',
      },
      pohledy: 'Chế độ xem',
      pole: {
        emp: 'Khoản người sử dụng lao động đóng mỗi tháng',
        lump: 'Khoản đóng một lần lúc đầu',
        own: 'Khoản tự đóng mỗi tháng',
      },
      pravidlaInfo: 'Từ 7/2024 không có trợ cấp nhà nước. Trợ cấp nhà nước: 2000–2012 tối đa 150 Kč (thang ước tính), 2013–6/2024 tối đa 230 Kč (từ 1 000 Kč), từ 7/2024 20 % khoản đóng, tối đa 340 Kč. Tiết kiệm thuế tính từ năm 2013, mức 15 %.',
      skupinaNove: 'Quỹ hưu trí mới – {spolecnost}',
      skupinaPrumery: 'Trung bình',
      skupinaStare: 'Quỹ hưu trí cũ',
      slHodnota: '{fond} – giá trị',
      slVynos: '{fond} – lợi nhuận',
      slozeni: 'Gồm những gì',
      stare: 'Quỹ hưu trí cũ (quỹ chuyển đổi)',
      statSub: 'trợ cấp {stat} + tiết kiệm thuế {uspora}',
      tfZkratka: 'TF',
      transformovany: 'quỹ chuyển đổi',
      usporaDipSub: 'khấu trừ đến 48 000 Kč mỗi năm, từ năm 2024',
      usporaObdobi: 'Tiết kiệm thuế từ khấu trừ cả giai đoạn',
      vProspechNoveho: 'nghiêng về quỹ hưu trí mới',
      vProspechStareho: 'nghiêng về quỹ hưu trí cũ',
      vlastniVklady: 'Khoản tự đóng',
      vynosFondu: 'lợi nhuận quỹ {pct} mỗi năm',
      zadani: 'Dữ liệu nhập',
      zdroje: 'Nguồn: APS ČR, banky.cz. Lợi nhuận sau phí.',
      zdrojeInfo: 'APS ČR (quỹ thành viên 2017–2025, quỹ chuyển đổi 2013–2025, quỹ hưu trí 1995–2012), banky.cz (quỹ thành viên 2013–2016). Đóng vào đầu tháng, lợi nhuận năm chia đều cho các tháng, trợ cấp nhà nước trong cùng tháng. Lợi nhuận quá khứ không đảm bảo tương lai. Không phải chào bán hay khuyến nghị đầu tư.',
      ztrata: 'Lỗ',
    },
    m: {
      dalsi: 'Hợp đồng hiện có và các giả định khác',
      danZVynosu: 'Tính thuế trên lợi nhuận quỹ hưu trí',
      danZVynosuInfo: '15 % trên lợi nhuận (và khoản của người sử dụng lao động) khi rút một lần từ quỹ hưu trí. Không phải trả nếu nhận niên kim từ 10 năm trở lên. DIP miễn thuế khi đáp ứng điều kiện.',
      danZVynosuOdectena: 'Thuế trên lợi nhuận (đã trừ)',
      danZam: 'Đánh thuế cả khoản người sử dụng lao động đóng vào quỹ hưu trí',
      danZamInfo: 'Khi rút một lần, thuế 15 % áp dụng cho lợi nhuận và khoản người sử dụng lao động đóng vào quỹ hưu trí (theo đề bài của máy tính). Không áp dụng cho DIP.',
      dip: 'DIP',
      dip2: 'DIP 2',
      dipKratce: 'DIP',
      doMaxima: 'còn thiếu {castka} để đạt mức tối đa',
      dodaneni: 'Truy thu thuế khấu trừ khi không đáp ứng điều kiện',
      duchod: 'Khách hàng đang nhận lương hưu tuổi già',
      duchodInfo: 'Từ 7/2024 người nhận lương hưu tuổi già không được trợ cấp nhà nước.',
      duchodceNe: 'người nhận lương hưu: không được trợ cấp',
      grafAria: 'Biểu đồ cột chồng số tiền tích lũy theo năm, năm {rok} tổng cộng {castka}',
      grafNadpis: 'Tích lũy cuối mỗi năm',
      jednotkaLet: 'năm',
      jednotkaMesicu: 'tháng',
      jizInfo: 'Được tính vào điều kiện thời gian tiết kiệm tối thiểu. Hãy nhập số dư hợp đồng hiện có như khoản đóng một lần hoặc chuyển khoản.',
      kategorie: {
        dite: 'Trẻ em',
        dospely: 'Người lớn',
        senior: 'Người cao tuổi',
      },
      klient: 'Khách hàng',
      kpiNasporeno: 'Tổng tích lũy khi nghỉ hưu',
      kpiNavic: 'Nhận thêm',
      kpiRenta: 'Niên kim hằng tháng',
      kpiVynos: 'Lợi nhuận p. a.**',
      letFew: '{n} năm',
      letMany: '{n} năm',
      letOne: '{n} năm',
      maxVyuzito: 'đã dùng hết mức tối đa {castka}',
      mesicuFew: '{n} tháng',
      mesicuMany: '{n} tháng',
      mesicuOne: '{n} tháng',
      naKonci: 'khi kết thúc tiết kiệm',
      nadVklady: 'ngoài khoản tự đóng {castka}',
      narozeni: 'Ngày sinh',
      nelze: 'không áp dụng',
      nesplneno: 'Chưa đáp ứng',
      odStatu: 'Tổng từ nhà nước mỗi năm',
      odchod: 'Nghỉ hưu',
      odebratDip2: 'Bỏ chiến lược DIP thứ hai',
      odpocty: 'Khách hàng sử dụng khấu trừ thuế',
      odpoctyInfo: 'Từ khoản tự đóng vào quỹ hưu trí trên 1 700 Kč mỗi tháng và từ DIP, tổng cộng tối đa 48 000 Kč mỗi năm. Tiết kiệm = khấu trừ × 15 %; không cộng vào số tiền tích lũy.',
      odpoctyNe: 'chưa tính khấu trừ',
      penzeVRoce: 'Nghỉ hưu năm',
      penzijko: 'Quỹ hưu trí (DPS)',
      penzijkoKratce: 'Quỹ hưu trí',
      plnaPodpora: 'Hỗ trợ tối đa: {a} mỗi tháng vào quỹ hưu trí để nhận trợ cấp nhà nước và thêm {b} mỗi tháng vào quỹ hưu trí hoặc DIP để khấu trừ thuế.',
      poDani: 'sau thuế lợi nhuận {castka}',
      pocatek: 'Khoản đóng một lần hoặc chuyển khoản',
      pocatekInfo: 'Số dư của hợp đồng hiện có hoặc khoản đóng một lần. Lợi nhuận* tính như tiền tự đóng ngay từ đầu.',
      podminky: 'Điều kiện và thuế',
      podpora: 'Mức sử dụng hỗ trợ nhà nước',
      podporaInfo: 'Trợ cấp nhà nước: 20 % khoản tự đóng từ 500 Kč, tối đa 340 Kč mỗi tháng (khi đóng 1 700 Kč). Tiết kiệm thuế: 15 % khoản khấu trừ, tối đa 7 200 Kč mỗi năm. Tối đa từ nhà nước là 11 280 Kč mỗi năm.',
      pole: {
        dip2Vlastni: 'DIP 2 – khoản tự đóng',
        dip2Vynos: 'DIP 2 – lợi nhuận',
        dip2Zam: 'DIP 2 – người sử dụng lao động',
        dipVlastni: 'DIP – khoản tự đóng',
        dipVynos: 'DIP – lợi nhuận',
        dipZam: 'DIP – người sử dụng lao động',
        dpsPocatek: 'Quỹ hưu trí – khoản đóng một lần',
        dpsVlastni: 'Quỹ hưu trí – khoản tự đóng',
        dpsVynos: 'Quỹ hưu trí – lợi nhuận',
        dpsZam: 'Quỹ hưu trí – người sử dụng lao động',
        jizMesicu: 'Đã tiết kiệm trên hợp đồng hiện có',
        narozeni: 'Ngày sinh',
        rentaLet: 'Số năm nghỉ hưu',
        rentaVynos: 'Lợi nhuận khi nghỉ hưu',
        roky: 'Số năm tiết kiệm',
      },
      pravidlo: 'Quy tắc 60 tuổi + 120 (60) tháng',
      pravidloAno: 'Đã đáp ứng',
      pravidloAuto: 'Đánh giá theo tuổi và thời gian tiết kiệm',
      pravidloDetail: 'tuổi khi rút {vek}, tiết kiệm {mesicu} (tối thiểu {min} tháng)',
      pravidloInfo: 'Rút không phải hoàn hỗ trợ: đủ 60 tuổi và tiết kiệm ít nhất 120 tháng (hợp đồng đến 2023: 60 tháng). Nếu không đáp ứng, máy tính ước tính hoàn trợ cấp nhà nước, đánh thuế lợi nhuận và truy thu khấu trừ 10 năm gần nhất.',
      pravidloNe: 'Chưa đáp ứng (rút sớm)',
      pravidloPredpoklad: 'chưa nhập tuổi, giả định đã đáp ứng',
      pravidloRucne: 'nhập thủ công (tối thiểu {min} tháng)',
      predpoklady: 'Tính toán mô phỏng, không phải cam kết.',
      predpokladyInfo: 'Giả định lợi nhuận sau phí trong suốt thời gian tiết kiệm, tính lãi hằng tháng (lợi nhuận năm / 12), đóng vào đầu tháng. Niên kim chi trả vào đầu tháng. Quy định hỗ trợ nhà nước áp dụng từ 1/7/2024 không đổi trong suốt thời gian. Tiết kiệm thuế không cộng vào số tiền tích lũy. Lợi nhuận quá khứ không đảm bảo tương lai và đây không phải khuyến nghị đầu tư.',
      pridatDip2: 'Thêm chiến lược DIP thứ hai',
      priklad: 'Ví dụ',
      produkty: 'Kết quả theo sản phẩm',
      produktyInfo: 'Lợi nhuận* = lợi nhuận hằng năm của khoản tự đóng gồm cả trợ cấp nhà nước. Lợi nhuận** = gồm thêm khoản của người sử dụng lao động. Ở dòng sản phẩm tính trên số tiền trước thuế, ở dòng Tổng tính sau thuế.',
      renta: 'Niên kim khi nghỉ hưu',
      rentaBezZhod: '{roky}, không sinh lời thêm',
      rentaInfo: 'Niên kim được chi trả vào đầu mỗi tháng. Ở mức 0 % số tiền tích lũy chỉ được chia đều thành các khoản hằng tháng.',
      rentaSeZhod: '{roky}, lợi nhuận {pct} mỗi năm',
      rokyDoPenze: 'Số năm đến khi nghỉ hưu',
      rokyRucne: 'Nhập số năm tiết kiệm thủ công',
      rokyRucneInfo: 'Khi chưa biết ngày sinh hoặc khách hàng muốn tiết kiệm khác với đến tuổi 60 / 65.',
      slozeni: 'Số tiền tích lũy gồm những gì',
      smlouva2024: 'Hợp đồng ký sau 1/1/2024',
      smlouva2024Info: 'Hợp đồng ký từ 1/1/2024 cần ít nhất 120 tháng tiết kiệm để rút không bị phạt, hợp đồng cũ hơn cần 60 tháng.',
      splneno: 'Đã đáp ứng',
      statMes: 'Trợ cấp nhà nước mỗi tháng',
      strategie: 'Chiến lược',
      strategieInfo: 'Lựa chọn có sẵn điền lợi nhuận theo trung bình các quỹ của chiến lược đó giai đoạn {od}–{do} (sau phí). Chỉ hỗ trợ nhập liệu, không phải dự báo.',
      usporaCelkem: 'Tiết kiệm thuế cả giai đoạn (được hoàn qua thuế, không nằm trong tài khoản)',
      usporaRok: 'Tiết kiệm thuế mỗi năm',
      v60: 'ở tuổi 60',
      v65: 'ở tuổi 65',
      vRoce: 'vào năm {rok}',
      vek: 'Tuổi',
      vklady: 'Khoản đóng hằng tháng và lợi nhuận',
      vkladyInfo: 'Khoản đóng hằng tháng vào quỹ hưu trí (DPS) và DIP. Lợi nhuận là giả định sau phí, tính lãi hằng tháng (lợi nhuận năm / 12), đóng vào đầu tháng.',
      vlastni: 'Khoản tự đóng',
      vlastniVynos: 'Lợi nhuận tự nhập',
      vlastniZadani: 'Dữ liệu riêng',
      vynos: 'Lợi nhuận mỗi năm',
      vyuzitoAria: 'Đã dùng {pct} % mức tối đa',
      vzorPokrocily: 'Ví dụ: quỹ hưu trí + DIP',
      vzorZakladni: 'Ví dụ: 1 000 Kč vào quỹ hưu trí',
      zMaxima: 'trên tối đa {castka} · {pct}',
      zamestnavatel: 'Người sử dụng lao động',
      zhodVlastnich: 'lợi nhuận trên tiền tự đóng',
    },
    prumer: {
      dynamicky: 'Trung bình các quỹ năng động',
      jina: 'Trung bình',
      konzervativni: 'Trung bình các quỹ thận trọng',
      transformovany: 'Trung bình các quỹ chuyển đổi',
      vyvazeny: 'Trung bình các quỹ cân bằng',
    },
    prumerKratce: {
      dynamicky: 'Ø năng động',
      jina: 'Ø',
      konzervativni: 'Ø thận trọng',
      transformovany: 'Ø chuyển đổi',
      vyvazeny: 'Ø cân bằng',
    },
    r: {
      coPocitat: 'Tính gì',
      dan: 'Trừ 15 % thuế trên lợi nhuận',
      dostavat: 'Tôi sẽ nhận bao nhiêu',
      f: {
        castka: 'Tích lũy khi bắt đầu nghỉ hưu',
        let: 'Số năm rút tiền',
        letS: 'Số năm tiết kiệm',
        pocatek: 'Đã tích lũy',
        renta: 'Niên kim hằng tháng mong muốn',
        vynos: 'Lợi nhuận khi nghỉ hưu',
        vynosS: 'Lợi nhuận khi tiết kiệm',
        zam: 'Người sử dụng lao động mỗi tháng',
      },
      grafCerpani: 'Số dư trong thời gian rút',
      grafCerpaniAria: 'Biểu đồ vùng số dư trong {roky} rút niên kim {renta} mỗi tháng',
      grafSporeni: 'Tiết kiệm và rút niên kim',
      grafSporeniAria: 'Biểu đồ vùng: tiết kiệm {sporeni} đạt {castka}, sau đó {roky} rút niên kim {renta}',
      kpiNasporeno: 'Tích lũy với khoản đóng này',
      kpiPotreba: 'Số tiền cần khi nghỉ hưu',
      kpiRenta: 'Niên kim hằng tháng',
      kpiSporit: 'Tiết kiệm mỗi tháng',
      kpiStatZam: 'Nhà nước và người sử dụng lao động mỗi tháng',
      kpiVyplaceno: 'Tổng đã chi trả',
      kpiZUroku: 'Trong đó lợi nhuận khi nghỉ hưu',
      kpiZtrata: 'Lỗ khi nghỉ hưu',
      letRenty: '{roky} niên kim',
      letRentyPo: '{roky} niên kim mỗi tháng {renta}',
      nadCastku: 'ngoài số tiền tích lũy {castka}',
      nelze: {
        nedosazitelne: 'Không thể đạt được với lợi nhuận đã nhập. Hãy thử thời gian dài hơn hoặc lợi nhuận cao hơn.',
        nulovaDoba: 'Thời gian tiết kiệm là 0 tháng. Hãy thử thời gian dài hơn.',
      },
      nelzeSpocitat: 'không tính được',
      nicKPrevzeti: 'Mô phỏng chưa có kết quả hợp lệ.',
      odchod: 'Nghỉ hưu {rok}',
      osaRokPenze: 'Trục: năm nghỉ hưu (0 = bắt đầu nghỉ hưu)',
      pokryto: 'Khoản tích lũy và đóng góp của người sử dụng lao động đã đủ cho niên kim mong muốn. Không cần tự đóng hằng tháng.',
      pozn: 'Tính toán mô phỏng, không phải cam kết.',
      poznDostavatInfo: 'Niên kim chi trả vào đầu tháng: lãi suất tháng = lợi nhuận năm / 12, cuối thời gian rút số dư bằng 0. Ở mức 0 % số tiền chỉ được chia đều. Không tính lạm phát và thuế trên khoản chi trả.',
      poznSporitInfo: 'Khoản đóng hằng tháng là số tiền nguyên nhỏ nhất bằng Kč để số tích lũy đủ cho niên kim mong muốn. Tiết kiệm: tính lãi hằng tháng (lợi nhuận năm / 12), đóng đầu tháng, trợ cấp nhà nước theo quy định từ 7/2024. Niên kim chi trả vào đầu tháng. Không tính lạm phát.',
      prevzato: 'Đã lấy từ mô phỏng.',
      prevzit: 'Lấy từ mô phỏng',
      rentaMes: 'niên kim {renta} mỗi tháng',
      rokRenty: 'năm niên kim thứ {n}',
      rokSporeni: 'năm tiết kiệm thứ {n}',
      slCelkem: 'Tổng đã chi trả',
      slFaze: 'Giai đoạn',
      slRokPenze: 'Năm nghỉ hưu',
      slVklady: 'Khoản đóng mỗi năm',
      slVyplaty: 'Chi trả mỗi năm',
      slZaRok: 'Chi trả mỗi năm',
      slZustatek: 'Số dư cuối năm',
      sporit: 'Cần tiết kiệm bao nhiêu',
      staciUspory: 'khoản tích lũy và đóng góp đã nhập là đủ',
      stat: 'Tiết kiệm trong quỹ hưu trí có trợ cấp nhà nước',
      statInfo: '20 % khoản tự đóng từ 500 Kč, tối đa 340 Kč mỗi tháng.',
      statZamSub: 'nhà nước {stat}, người sử dụng lao động {zam}',
      uvod: 'Khách hàng sẽ nhận bao nhiêu từ số tiền tích lũy, hoặc cần tiết kiệm bao nhiêu cho niên kim mong muốn.',
      vyplatFew: '{n} khoản chi trả hằng tháng',
      vyplatMany: '{n} khoản chi trả hằng tháng',
      vyplatOne: '{n} khoản chi trả hằng tháng',
      zaokrouhleno: 'khoản tự đóng, làm tròn lên',
      zustatek: 'Số dư',
    },
    sdileni: {
      doba: 'Thời gian tiết kiệm',
      mesicne: '{castka} mỗi tháng',
      uvod: 'Xin chào, tôi gửi mô phỏng quỹ hưu trí và DIP — mỗi tháng đóng bao nhiêu và khi nghỉ hưu có thể được bao nhiêu. Anh/chị xem rồi phản hồi giúp tôi.',
      veta1: 'Hưu trí là chặng đường dài: bắt đầu càng sớm, lãi kép càng phát huy tác dụng.',
      veta2: 'Đây là tính toán mô phỏng với lợi nhuận giả định, không phải cam kết. Kết quả thực tế sẽ khác.',
    },
    sl: {
      celkem: 'Tổng',
      danPriVyberu: 'Thuế khi rút',
      danZVynosu: 'Thuế trên lợi nhuận',
      nasporeno: 'Đã tích lũy',
      predDani: 'Tích lũy trước thuế',
      produkt: 'Sản phẩm',
      rok: 'Năm',
      vek: 'Tuổi',
      vynos1: 'Lợi nhuận*',
      vynos2: 'Lợi nhuận**',
      vynosFondu: 'Lợi nhuận quỹ',
    },
    slozky: {
      stat: 'Nhà nước',
      vlastni: 'Khoản tự đóng',
      zamestnavatel: 'Người sử dụng lao động',
      zhodnoceni: 'Lợi nhuận',
      zhodnoceniPoDani: 'Lợi nhuận sau thuế',
    },
    stranka: {
      nadpis: 'Quỹ hưu trí và DIP',
      paticka1: 'Đây là mô phỏng, không phải cam kết. Lợi nhuận quá khứ không đảm bảo tương lai. Không phải khuyến nghị đầu tư.',
      paticka2: 'Lợi nhuận quỹ đã trừ phí (APS ČR, banky.cz). Quy định hỗ trợ của nhà nước áp dụng từ 1/7/2024, cập nhật tháng 10/2026. Kết quả tính không phải đề nghị ký hợp đồng.',
      podnadpis: 'Mô phỏng tương lai, lịch sử quỹ, so sánh quỹ và kế hoạch niên kim.',
      poslat: 'Gửi cho khách hàng',
      skVeta: 'Máy tính áp dụng cho quỹ hưu trí Séc (DPS) và DIP theo quy định của Séc, số tiền tính bằng Kč.',
      stitek: 'Máy tính hưu trí',
      tisk: 'In / PDF',
      zalozky: {
        fondy: 'So sánh quỹ',
        historie: 'Lịch sử',
        modelace: 'Mô phỏng DPS + DIP',
        renta: 'Kế hoạch niên kim',
      },
      zalozkyAria: 'Các máy tính hưu trí',
    },
    strategieNazev: {
      dynamicky: 'Năng động',
      jina: 'Khác',
      konzervativni: 'Thận trọng',
      transformovany: 'Quỹ chuyển đổi',
      vyvazeny: 'Cân bằng',
    },
    tabulkaPoLetech: 'Bảng theo năm',
    upozorneni: {
      duchodceBezStatu: 'Người đang nhận lương hưu tuổi già không được trợ cấp nhà nước (từ 7/2024).',
      pravidloNesplneno: 'Chưa đáp ứng quy tắc 60 tuổi + {min} tháng: trợ cấp nhà nước bị hoàn trả, lợi nhuận và khoản của người sử dụng lao động bị đánh thuế 15 %, khoản khấu trừ bị truy thu thuế (ước tính).',
      zamNadLimit: 'Khoản đóng của người sử dụng lao động {rocne} mỗi năm vượt hạn mức miễn thuế {limit} (DPS + DIP + bảo hiểm nhân thọ cộng lại).',
    },
  },
  /* BLOK:penze2 END */
  /* BLOK:vydajePravidlo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vydajePravidlo: {
    tip: 'Chi tiêu được điền theo quy tắc ({pct} %) — đây là ước tính từ thu nhập, không phải số liệu từ khách hàng. Bạn cứ sửa lại nếu cần.',
    tipNazev: 'Chi tiêu theo quy tắc',
  },
  /* BLOK:vydajePravidlo END */
  /* BLOK:rozpisKategorii START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisKategorii: {
    planPocita: 'kế hoạch đang tính theo số này',
    pouzit: 'Dùng làm chi tiêu thường ngày',
    prepis: 'Bảng theo hạng mục ({castka}) sẽ bị ghi đè bằng tổng từ bảng chi tiết — nếu không, kế hoạch lấy số lớn hơn.',
    radek: 'Từ bảng theo hạng mục',
    sedi: 'khớp với chi tiêu thường ngày',
    smazano: 'Đã xóa bảng theo hạng mục',
    smazat: 'Xóa bảng',
    vratit: 'Hoàn tác',
  },
  /* BLOK:rozpisKategorii END */
  /* BLOK:smrtVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  smrtVysvetleni: {
    aria: 'Sau khi mất, gia đình cần {potreba}, nhận được {prijde}, còn thiếu {chybi}.',
    ariaPrebyva: 'Sau khi mất, gia đình cần {potreba}, nhận được {prijde}, còn dư {prebyva}.',
    bezVydaju: 'Chưa tính được mức bảo hiểm tử vong — phân tích còn thiếu chi tiêu.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} theo giá hôm nay. Chúng tôi giả định số tiền được chi trả sẽ được gửi với lợi suất mô hình 4 % trên lạm phát (mô hình, không phải cam kết). Vì vậy hôm nay chỉ cần {kapital}.',
    chybiVeta: 'thiếu {castka} mỗi tháng · {roky}',
    cilBezHorizontu: 'mục tiêu {nazev} chưa có thời hạn, chưa tính',
    duchod: 'trợ cấp tuất cho vợ/chồng và con từ nhà nước',
    duchodBezDeti: 'trợ cấp tuất cho vợ/chồng từ nhà nước',
    duchodSablona: 'trợ cấp tuất (mẫu theo quốc gia)',
    jenUkazka: 'Chỉ minh họa — không ghi gì vào kế hoạch.',
    krok1: 'Chi tiêu của gia đình sau khi mất',
    krok1Pod: 'ít hơn hôm nay {pct} % ({vydaje})',
    krok2: 'Gia đình nhận được gì',
    krok3: 'Phần còn thiếu — trong {roky}',
    krok4: 'Hạn mức tử vong',
    krok4Metoda: 'Phương pháp vốn',
    krok4Pod: 'phần thiếu + nợ + mục tiêu − những gì đã có',
    krok5Minimum: 'Phương pháp cũ: tối thiểu nợ + thu nhập một năm + con đến khi tự lập',
    krok5MinimumBezPrijmu: 'Phương pháp cũ: tối thiểu trả hết nợ',
    mezisoucet: 'theo phương pháp vốn',
    minimumDite: '{jmeno} đến {vek} tuổi',
    minimumDiteBezJmena: 'con',
    minimumPrijem: 'Thu nhập một năm của gia đình',
    minimumVeta: 'Kết quả cao hơn phương pháp vốn, nên áp dụng mức này.',
    model: 'Mô hình tham khảo, không phải cam kết: tính với lợi suất 4 % trên lạm phát, lợi suất thấp hơn thì hạn mức cao hơn. Trợ cấp tuất cho vợ/chồng và con là mẫu tham khảo, mức thực tế do nhà nước quyết định. Thu nhập thụ động (độc lập tài chính) không tính vào bảo hiểm tử vong — sau khi mất không ai còn nhận; các mục tiêu chung vẫn giữ. Quyền lợi do điều kiện bảo hiểm quy định.',
    nepotreba: 'Gia đình vẫn còn đủ thu nhập — không cần bảo hiểm tử vong.',
    nicNechybi: 'Thu nhập vừa đủ trang trải chi tiêu của gia đình.',
    odvozeneRoky: 'suy ra: thời hạn {roky} theo mẫu',
    orezano: 'Thu nhập và tài sản đủ cho gia đình — không cần bảo hiểm tử vong.',
    partner: '{jmeno} vẫn tiếp tục đi làm',
    pasivniAria: 'Thu nhập thụ động {castka}, hạn mức tử vong {limit}',
    pasivniTitul: 'Nếu hôm nay có thu nhập thụ động',
    pasivniVeta: 'Bảo hiểm là cái giá phải trả khi chúng ta chưa có thu nhập thụ động.',
    poPrepoctu: 'Sau khi tính lại theo phương pháp mới, áp dụng phương pháp vốn ({castka}).',
    prahMezera: 'bù được khoản thiếu',
    prahNula: 'không cần bảo hiểm',
    prebyvaVeta: 'Thu nhập đủ cho gia đình và còn dư {castka} — hạn mức giảm tương ứng.',
    rada: {
      chybi: 'còn thiếu',
      dnes: 'chi tiêu sau khi mất',
      duchod: 'trợ cấp tuất từ nhà nước',
      partner: 'thu nhập của vợ/chồng',
      pasivni: 'thu nhập thụ động',
    },
    radekChybi: 'Phần còn thiếu trong {roky}',
    radekCile: 'Đầu tư cho mục tiêu (giá trị hôm nay)',
    radekDluhy: 'Trả hết nợ',
    radekMajetek: 'Số tiền đã có trong tài khoản',
    radekPrebytek: 'Phần thu nhập gia đình còn dư — trong {roky}',
    rucne: 'Thẻ hiển thị {rucni} nhập tay, tính toán ra {spocitano}.',
    skryt: 'Ẩn cách tính',
    staraMetodika: 'Phương pháp cũ — áp dụng mức tối thiểu.',
    titul: 'Số tiền bảo hiểm khi qua đời được tính thế nào',
    toggle: 'Cách tính bảo hiểm khi qua đời',
    vysledek: 'Hạn mức tử vong',
    zaokrouhleni: 'Các dòng được làm tròn, tổng có thể chênh lệch một chút.',
  },
  /* BLOK:smrtVysvetleni END */
  /* BLOK:poradiRizik START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiRizik: {
    invaliditaSmrt: 'mất sức lao động / tử vong',
  },
  /* BLOK:poradiRizik END */
  /* BLOK:splatkaUveru START — generuje scratchpad/slovnik.py, ručně needitovat */
  splatkaUveru: {
    infoNazev: 'Số tiền này gồm những gì',
    rozpad: 'Từ năm {rok}: tiền trả góp {uver}/tháng + các mục tiêu nhập thủ công vượt ngân sách {rucni}/tháng.',
    rozpadOchrana: 'Từ năm {rok}: tiền trả góp {uver}/tháng + phí bảo vệ vượt thặng dư {ochrana}/tháng.',
    rozpadOchranaRucni: 'Từ năm {rok}: tiền trả góp {uver}/tháng + phí bảo vệ vượt thặng dư {ochrana}/tháng + các mục tiêu nhập thủ công vượt ngân sách {rucni}/tháng.',
    schodek: 'Từ năm {rok} thiếu {castka}/tháng — tiền trả góp cao hơn mức ngân sách cho phép.',
    schodekNejvic: 'Thiếu nhiều nhất {castka}/tháng từ năm {rok}.',
  },
  /* BLOK:splatkaUveru END */
  /* BLOK:kartaCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kartaCile: {
    akontace: 'Trả trước',
    bezUveru: 'Bạn trả toàn bộ bằng tiền của mình — không cần vay.',
    cashflowBezNajmu: 'Từ năm {rok} trả góp {splatka} trong {roky}.',
    cashflowDvaUvery: 'Từ năm {rok}: trả góp {splatka} — trong đó vay tiết kiệm xây dựng {stavebko} chỉ {rokyStavebko}, vay mua nhà {roky}.',
    cashflowGraf: 'dòng tiền theo thời gian',
    cashflowKlesne: 'Từ năm {rok}: trả góp {splatka}, hết tiền thuê {najem} — thặng dư giảm {zmena}.',
    cashflowSNajmem: 'Từ năm {rok} trả góp {splatka}, tiền thuê {najem} không còn — khoản dư {zmena}.',
    cashflowStoupne: 'Từ năm {rok}: trả góp {splatka}, hết tiền thuê {najem} — thặng dư tăng {zmena}.',
    celkem: 'tổng',
    celkemZaplatite: 'Tổng cộng bạn trả',
    celyText: 'toàn văn',
    cerpani: 'giải ngân',
    cilCara: 'mục tiêu {castka}',
    cnbKratce: 'dưới 36 tuổi chỉ cần 10 % vốn tự có, nếu không thì 20 %',
    detailInvestice: 'Chi tiết đầu tư',
    detailInvesticePod: 'phân bổ theo thời gian, lịch sử',
    dofDopadProdej: 'Vốn tự có giảm {snizeni} — còn phải tích lũy {zbyva}.',
    dofDopadZastava: 'Ngân hàng xét khoản vay theo cả hai bất động sản: tối đa {uver} ({ltv} % của {zaklad}) → vốn tự có {vlastni}. Sự đồng ý của bên thế chấp, định giá và khả năng trả nợ cần xác minh tại ngân hàng.',
    dofHodnotaZastavy: 'giá trị thế chấp',
    dofJiny: 'tài sản khác',
    dofNe: 'không',
    dofOdebrat: 'gỡ bỏ',
    dofPouzitZastavu: 'dùng làm thế chấp',
    dofPouzitoU: 'đã dùng cho mục tiêu {cil}',
    dofProdej: 'bán bất động sản',
    dofStaraMetodika: 'Kế hoạch tính theo phương pháp cũ — phần bổ sung có hiệu lực sau khi tính lại theo phương pháp mới.',
    dofStitekOcekavane: 'dự kiến',
    dofStitekOverteDruh: 'kiểm tra loại',
    dofStitekStehovani: 'chỉ khi chuyển nhà',
    dofStitekZatizeni: 'kiểm tra khoản thế chấp hiện có (vay mua nhà {castka})',
    dofStitekZatizeniBez: 'kiểm tra khoản thế chấp hiện có',
    dofVynos: 'tiền thu từ bán',
    dofZAnalyzy: 'Trong phân tích đã chọn làm tài sản thế chấp: {nazev} · {hodnota}',
    dofZadnaZastava: 'Phân tích không có bất động sản — hãy nhập giá trị thủ công.',
    dofZadnyJiny: 'Phân tích không có gì để bán — hãy nhập số tiền thủ công.',
    dofZadnyProdej: 'Phân tích không có bất động sản để bán — hãy nhập số tiền thủ công.',
    dofZastava: 'thế chấp bất động sản (của mình hoặc bố mẹ)',
    dofZbyde: 'Từ việc bán còn lại {castka}.',
    dofZrusenoChybi: '“{nazev}” không còn trong phân tích — lựa chọn đã lưu không được tính.',
    dofZrusenoJiny: '“{nazev}” là bất động sản — thuộc mục bán hoặc thế chấp. Lựa chọn đã lưu không được tính.',
    dofZrusenoPouzito: '“{nazev}” đã được tính cho mục tiêu {cil} — mỗi tài sản chỉ tính một lần. Lựa chọn đã lưu không được tính.',
    dofZrusenoProdej: '“{nazev}” không phải bất động sản trong phân tích — việc bán đã lưu không được tính.',
    dofZrusenoUver: 'Không thể thế chấp với khoản vay tiêu dùng — lựa chọn đã lưu không được tính.',
    dofZrusenoZastava: '“{nazev}” không thể thế chấp — chỉ bất động sản mới thế chấp được. Lựa chọn đã lưu không được tính.',
    doporuceno: 'khuyến nghị',
    grafAriaModel: 'Bạn góp {vlozeno}, sau {roky} giá trị mô hình {hodnota}, lợi nhuận {vynos} — mô hình, không phải cam kết.',
    hotove: 'trả ngay',
    hotovePct: 'trả ngay {pct} %',
    hypoVychozi: 'Để trống = mặc định {sazba} % trong {roky} năm, không phải chào giá của ngân hàng.',
    hypotekaVyse: 'Vay thế chấp',
    hypotekaZaRoky: 'Vay mua nhà trong {roky}',
    jednorazoveDnes: 'Một lần hôm nay',
    jenHypotekaAria: 'Biểu đồ chỉ thể hiện khoản vay mua nhà, không gồm khoản vay tiết kiệm xây dựng.',
    kolikHotove: 'Bạn trả ngay bao nhiêu',
    kombinace: 'Tiền nhàn rỗi của bạn + phần còn lại hàng tháng',
    kombinacePod: '{jedn} một lần từ tiền của bạn, phần còn lại {mes} hàng tháng',
    kombinacePodNestaci: '{jedn} một lần từ tiền của bạn, phần còn lại {mes} mỗi tháng — nhiều hơn mức thặng dư dành cho mục tiêu',
    krok1: 'Tích lũy',
    krok1Hotove: 'Tích lũy phần trả ngay',
    krok1Rezerva: 'Lập quỹ dự phòng',
    rezervaBezVydaju: 'Không thể tính quỹ dự phòng — phân tích còn thiếu chi tiêu.',
    krok1Vlastni: 'Tích lũy vốn tự có',
    krok2Hypo: 'Vay thế chấp',
    krok2Uver: 'Vay bằng khoản vay',
    krok3: 'Bổ sung từ tài sản',
    krytoZeZdroju: 'Đã đủ từ tiền của bạn — không cần thêm gì.',
    mesNestaci: 'thặng dư góp {prideleno} — còn thiếu {chybi}',
    mesNestaciKroky: 'kế hoạch từ nay {prideleno}, sau đó nhiều hơn — xem theo thứ tự',
    mesPakVic: 'hôm nay, sau đó nhiều hơn — xem lần lượt',
    modelovaHodnota: 'Giá trị mô hình',
    modelove: 'theo mô hình',
    nadPrebytek: 'nhiều hơn khoản dư còn trống',
    nbsKratce: '20 % vốn tự có, 10 % chỉ ngoại lệ',
    neboMesicne: 'hoặc hàng tháng',
    neboMesicneRenta: 'hoặc hàng tháng',
    nejistota: 'Mô phỏng ({scenar}) theo giá hôm nay, không phải cam kết — lợi nhuận thực tế sẽ khác.',
    nicSporit: 'Không cần tiết kiệm.',
    nicSporitUver: 'Không cần tiết kiệm — khoản vay và tài sản trả toàn bộ giá (bước 2 và 3).',
    obaUvery: 'Cả hai khoản vay',
    obojiUlozene: 'Một lần và hàng tháng (đã lưu trong kế hoạch)',
    odRoku: 'từ {rok}',
    odTed: 'từ bây giờ',
    osaJednorazove: 'một lần — {zdroj}',
    osaJednorazovePoCili: 'một lần — {zdroj} · chỉ sau thời hạn mục tiêu, không tính',
    osaJednorazovePoRente: 'một lần — {zdroj} · chỉ sau khi bắt đầu nhận lương hưu, không tính',
    osaMzdaNedorazi: '{rust} — không đến được quỹ hưu',
    osaMzdaPoCili: '{rust} — chỉ sau thời hạn mục tiêu, không tính',
    osaMzdaPoRente: '{rust} — chỉ sau khi bắt đầu nhận lương hưu, không tính',
    osaMzdaSplatka: '{rust} — khoản trả nợ dùng hết, không đến được quỹ hưu',
    osaRustMzdy: 'tăng lương',
    osaRustMzdyPozde: '{rust} từ {rok} — đến lúc đó bị khoản trả nợ dùng hết',
    osaRustMzdyPozdeObecne: '{rust} từ {rok}',
    osaRustMzdySablona: 'tăng lương (ước tính)',
    osaUverSplacen: 'trả xong khoản vay cho {cil}',
    osaUvolneno: 'tiền được giải phóng từ khoản dư',
    osaZCile: 'được giải phóng từ mục tiêu {cil} (đã tích lũy xong)',
    osaZaklad: 'đầu tư định kỳ',
    osaZakladMzda: 'trong đó +{castka} nhờ tăng lương từ {rok}',
    pasmo: 'kịch bản xấu đến tốt',
    pasmoBublina: 'Kịch bản xấu – tốt',
    pasmoSouhrn: 'kịch bản xấu đến tốt {od} – {do}',
    pctZ: '{pct} % của {cena}',
    plneniZa: 'Mức hoàn thành mục tiêu {kdy} ({scenar})',
    plusStavebko: '+ khoản vay tiết kiệm xây dựng {castka} trong {roky} năm = {splatka}{mes} (lãi suất riêng)',
    poporade: 'Lần lượt',
    proVsechnyCile: 'Cho mọi mục tiêu:',
    pujcite: 'Bạn vay',
    puvodniNavrh: 'quay lại đề xuất ban đầu',
    realne: 'thực',
    resiSeUveremHotove: 'Chỉ tích lũy phần trả ngay, phần còn lại do khoản vay — trả góp bắt đầu từ khi giải ngân.',
    rezimBezSchodu: 'Cách đã chọn tính khoản trả đều — các mức tăng của đề xuất ban đầu',
    rokSplaceni: 'năm trả nợ thứ {n}',
    rustBez: 'không tăng',
    rustBezRustu: 'Kế hoạch không tính tăng khoản góp — và cài đặt cũng không quy định.',
    rustChybi: 'Tăng lương CHƯA được tính — kế hoạch chưa có bước nào. Bấm Tính tăng lương.',
    rustLisi: 'Các bước tăng lương trong kế hoạch KHÁC cài đặt — kế hoạch tính theo chúng. Đồng bộ bằng nút Tính tăng lương.',
    rustLisiKratce: 'kế hoạch có các bước khác',
    rustLisiZahod: 'Kế hoạch đang tính theo các bước tăng lương, nhưng cài đặt không cho ra mức tăng nào — hãy bỏ chúng để kế hoạch khớp cài đặt.',
    rustMzdy: 'Tăng lương',
    rustNepocita: 'chưa được tính',
    rustPopis: '{pct} {baze} mỗi {krok} năm',
    rustRealne: 'thực, trên lạm phát — kế hoạch tính theo giá hôm nay và không cộng lạm phát.',
    rustRucniPolozka: '+{castka} từ {rok}',
    rustSablonaNeRucniAno: 'mẫu chưa áp dụng · kế hoạch có mức nhập tay {rucni}',
    rustSedi: 'Kế hoạch tính theo nhịp này — các bước tăng lương trong kế hoạch khớp với cài đặt.',
    rustVPlanu: 'trong kế hoạch ({n} bước)',
    rustVPlanuPo: 'trong kế hoạch: {n} trước khi nhận lương hưu, {po} sau khi bắt đầu',
    schodyAria: 'Khoản góp hàng tháng tăng từ {od} lên {do}.',
    seZastavou: 'có thế chấp',
    sjednotit: 'đồng bộ với kế hoạch',
    skrytGraf: 'ẩn biểu đồ',
    splatkaMesicne: 'Trả góp hàng tháng',
    splatkaRozpis: 'vay mua nhà {hypo} + vay tiết kiệm xây dựng {stavebko} ({roky})',
    spotrVychozi: 'Để trống = khoảng {sazba} % trong {roky} năm (tối đa {max} năm) — xác minh tại ngân hàng.',
    srovnatRust: 'Đồng bộ với cài đặt',
    stavebkoZaRoky: 'Khoản vay tiết kiệm xây dựng {castka} trong {roky}',
    upravit: 'sửa',
    upravitRucne: 'sửa số tiền thủ công',
    uverSpotrebitelsky: 'khoản vay tiêu dùng',
    uverStavebko: 'khoản vay tiết kiệm xây dựng',
    uzMate: 'Bạn đã có',
    vPlanuNestaci: 'trong kế hoạch — chưa đủ',
    vRoce: 'năm {rok}',
    vetaRoku: 'đã góp {vlozeno} · giá trị {hodnota} · lợi nhuận {vynos}',
    vlastniProfil: 'hồ sơ riêng: {profil}',
    vlastniZdroje: 'vốn tự có',
    vlozeno: 'Đã góp',
    vlozite: 'Bạn góp',
    volitelne: 'tùy chọn',
    volnychJen: 'tiền nhàn rỗi: {volne}',
    vybrano: 'đã chọn',
    vynos: 'lợi nhuận',
    zPrebytku: 'từ khoản dư hàng tháng',
    zTohoHotove: 'trong đó trả ngay',
    zVolnych: 'từ tiền nhàn rỗi (bạn có {volne})',
    zahoditKrokyTitul: 'Xóa các bước tăng lương theo mẫu khỏi kế hoạch — sau đó kế hoạch tính không có chúng, đúng như cài đặt.',
    zapocitatRust: 'Tính tăng lương',
  },
  /* BLOK:kartaCile END */
  /* BLOK:klientEmail START — generuje scratchpad/slovnik.py, ručně needitovat */
  klientEmail: {
    chybaAdresa: 'Kiểm tra lại địa chỉ e-mail của khách hàng.',
    chybaPredmet: 'Hãy nhập tiêu đề.',
    chybaTelo: 'Hãy nhập nội dung thư.',
    crmBezEmailu: 'Khách hàng chưa có e-mail trong CRM — hãy nhập thủ công.',
    dalsiOdkaz: 'Tạo đường dẫn khác',
    introFixace: 'Kính chào anh/chị, tôi gửi bản mô phỏng thời hạn cố định lãi suất. Con số quan trọng là con số thứ hai — khoản trả góp sau khi hết thời hạn cố định. Nếu cần gì cứ liên hệ nhé.',
    introHistoricka: 'Kính chào anh/chị, tôi gửi bản mô phỏng diễn biến lịch sử của khoản đầu tư như đã hẹn. Anh/chị xem qua các con số — nếu cần gì cứ liên hệ nhé.',
    introModelace: 'Kính chào anh/chị, tôi gửi bản mô phỏng như đã hẹn. Anh/chị xem qua và nếu cần gì cứ liên hệ nhé.',
    klientNepovinne: 'Khách hàng (không bắt buộc)',
    komu: 'Gửi đến',
    kopirovaniChyba: 'Sao chép không thành công.',
    kopirovat: 'Sao chép',
    modelaceVPdf: 'Bản mô phỏng PDF',
    nadpis: 'Gửi cho khách hàng',
    najdiKlienta: 'Tìm khách hàng theo tên…',
    neniEmail: 'Đây không giống địa chỉ e-mail.',
    nepropojeny: 'E-mail chưa được kết nối trong ứng dụng. Chương trình thư của bạn sẽ mở với nội dung soạn sẵn — bạn xác nhận gửi ở đó. (Có thể kết nối trong phần Cài đặt.)',
    neznamyTransport: 'Không kiểm tra được e-mail đã được kết nối trong ứng dụng hay chưa. Chương trình thư của bạn sẽ mở với nội dung soạn sẵn — bạn xác nhận gửi ở đó.',
    odejdeGmail: 'Thư sẽ được gửi từ Gmail của bạn.',
    odejdeGmailAdresa: 'Thư sẽ được gửi từ Gmail {email} của bạn.',
    odejdeSmtp: 'Thư sẽ được gửi từ e-mail công ty của bạn.',
    odejdeSmtpAdresa: 'Thư sẽ được gửi từ e-mail công ty {email} của bạn.',
    odesilam: 'Đang gửi…',
    odeslanToast: 'Đã gửi e-mail cho khách hàng.',
    odeslanoKlientovi: 'Đã gửi cho khách hàng.',
    odeslatChyba: 'Không gửi được e-mail.',
    odeslatNa: 'Gửi đến {adresa}',
    odkazChyba: 'Hiện chưa tạo được đường dẫn. Vui lòng thử lại.',
    otevrete: 'Anh/chị có thể mở tại đây:',
    otevrit: 'Mở',
    otevritPostu: 'Mở chương trình thư',
    ozveteSe: 'Nếu có điều gì chưa rõ hoặc anh/chị có câu hỏi, hãy liên hệ — chúng ta sẽ cùng xem lại thong thả.',
    pdfChyba: 'Không tạo được PDF.',
    pdfStazenoToast: 'Đã tải PDF — hãy đính kèm vào e-mail.',
    pdfVeStazenych: 'PDF đã nằm trong thư mục Tải xuống của bạn.',
    popis: 'Chọn khách hàng, thêm lời nhắn mở đầu và tạo đường dẫn tới bản mô phỏng này.',
    popisHotovo: 'Đường dẫn đã sẵn sàng — hãy gửi cho khách hàng.',
    poslatEmailem: 'Gửi qua e-mail',
    postaOtevrena: 'Thư đã mở trong chương trình thư của bạn. Ứng dụng CHƯA GỬI — hãy gửi từ đó.',
    pozdrav: 'Kính chào anh/chị,',
    pozdravJmeno: 'Kính chào {osloveni},',
    predmet: 'Tiêu đề',
    predmetVychozi: 'Bản mô phỏng dành cho anh/chị',
    priloha: 'Tài liệu này cũng được đính kèm dưới dạng PDF.',
    prilohyNeumi: 'E-mail từ ứng dụng chưa hỗ trợ tệp đính kèm. PDF sẽ được tải về máy bạn — hãy đính kèm thủ công, hoặc khách hàng chỉ cần đường dẫn tới bản mô phỏng trong nội dung ở trên.',
    sPozdravem: 'Trân trọng',
    schuzka: 'Đặt lịch hẹn',
    spojitSe: 'Liên hệ',
    stahnoutPdf: 'Tải PDF',
    textPrecti: 'Nội dung — hãy đọc lại trước khi gửi',
    titulFixace: 'Thời hạn cố định lãi suất — điều gì xảy ra sau đó',
    titulHistoricka: 'Diễn biến lịch sử của khoản đầu tư',
    titulHypoteka: 'Mô phỏng khoản vay mua nhà',
    titulInvestice: 'Mô phỏng đầu tư',
    uvodVychozi: 'tôi gửi anh/chị bản mô phỏng mà chúng ta đã cùng xem.',
    uvodniPh: 'Kính chào anh/chị, tôi gửi bản mô phỏng như đã hẹn…',
    uvodniZprava: 'Lời nhắn mở đầu',
    vytvarim: 'Đang tạo…',
    vytvarimOdkaz: 'Đang tạo đường dẫn…',
    vytvoritOdkaz: 'Tạo đường dẫn',
    whatsapp: 'Nhắn tin qua WhatsApp',
    zavolejte: 'Hoặc gọi trực tiếp cho tôi: {tel}',
    zjistuji: 'Đang kiểm tra cách gửi e-mail…',
    zkopirovano: 'Đã sao chép',
  },
  /* BLOK:klientEmail END */
  /* BLOK:pdfVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  pdfVystup: {
    ctaVychozi: 'Đặt lịch hẹn với tư vấn viên',
    dalsiKrok: 'Bước tiếp theo',
    disclaimer: 'Mô phỏng chỉ mang tính tham khảo và dựa trên dữ liệu lịch sử. Lợi nhuận trong quá khứ không bảo đảm cho tương lai. Đầu tư trên thị trường vốn có rủi ro mất một phần hoặc toàn bộ số tiền đã đầu tư.',
    financniPoradenstvi: 'Tư vấn tài chính',
    inv: {
      hero: 'Giá trị kỳ vọng',
      projekce: 'Dự phóng theo năm',
      scenare: 'Các kịch bản cuối kỳ',
      thOcekavany: 'Kỳ vọng',
      thOptimisticky: 'Lạc quan',
      thPesimisticky: 'Bi quan',
      thRok: 'Năm',
      thVklady: 'Tiền nộp',
      titul: 'Mô phỏng đầu tư',
    },
    jakTomuRozumet: 'Hiểu kết quả thế nào',
    modelace: 'Bản mô phỏng',
    modelaceDisclaimer: 'Bản mô phỏng tham khảo, không ràng buộc. Điều kiện và mức phí cụ thể chúng ta sẽ cùng xác nhận.',
    platnaDo: 'Có hiệu lực đến',
    pripravenoPro: 'Chuẩn bị cho',
    qrAlt: 'Mã QR',
    qrNavod: 'Quét mã QR bằng camera điện thoại — đường dẫn liên hệ với tư vấn viên sẽ mở ra.',
    rozpis: 'Bảng chi tiết',
    souhrn: 'Tóm tắt',
    vstupy: 'Thông số đầu vào',
    vypracoval: 'Người lập',
  },
  /* BLOK:pdfVystup END */
  /* BLOK:zivotkoPdf START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoPdf: {
    cenaChybi: 'Tư vấn viên sẽ bổ sung mức phí cụ thể theo công ty bảo hiểm được chọn — vì vậy tài liệu này chưa có.',
    cenaDen: 'Tính theo ngày là {den}.',
    cenaHlava: 'Mỗi thành viên gia đình {hlava} mỗi ngày.',
    cenaPct: 'Tức là {pct} % thu nhập gia đình.',
    cenaStoji: 'Toàn bộ sự bảo vệ này có phí {cena} mỗi tháng.',
    cilMesicne: '{nazev} {castka}/tháng',
    cilVychozi: 'mục tiêu',
    disclaimer: 'Mức bảo vệ khuyến nghị mang tính tham khảo theo phương pháp beplan. Phí bảo hiểm và điều kiện cụ thể theo công ty bảo hiểm được chọn. Tư vấn viên là người quyết định cuối cùng.',
    heroLabel: 'Gia đình cần bao nhiêu nếu trụ cột qua đời',
    heroLabelInvalidita: 'Gia đình cần bao nhiêu nếu trụ cột không thể làm việc',
    inCena: 'Phí bảo vệ / tháng',
    inNezbytne: 'Chi phí thiết yếu / tháng',
    inOsob: 'Số người trong gia đình',
    inPrijem: 'Thu nhập gia đình / tháng',
    inVarianta: 'Phương án bảo vệ',
    inZajistitNa: 'Bảo vệ trong',
    metodika: 'Phương pháp {verze}.',
    naDen: '{castka}/ngày',
    nar1: 'Hiện nay gia đình có {prijem} mỗi tháng. Hãy hình dung gia đình mất đi một phần số tiền đó.',
    nar2: 'Nếu thu nhập giảm 5 % ({p5} mỗi tháng), sẽ hơi khó chịu — nhưng vẫn chịu được. Giảm 25 % ({p25}) vẫn xoay xở được, chỉ cần thắt lưng buộc bụng. Giảm 50 % ({p50}) thì ngân sách không còn cân đối được. Còn giảm 100 % ({p100}) là chấm dứt mọi kế hoạch, không chỉ là thắt lưng buộc bụng.',
    nar3: 'Đề xuất này giải quyết đúng hai nấc khó khăn nhất đó: {inval} khi mất sức lao động, {smrt} khi tử vong và {pn} cho mỗi ngày ốm hoặc tai nạn. Được tính cho {roky} tới, từ chính số liệu của gia đình — không phải từ bảng số liệu trung bình.',
    nar4: 'Ngoài ra còn {tnu} cho di chứng vĩnh viễn do tai nạn (càng nặng, chi trả càng cao) và {zav} khi mắc bệnh hiểm nghèo — ung thư, nhồi máu cơ tim, đột quỵ. Đó là tiền để chữa bệnh và có thời gian, không phải để trả hóa đơn.',
    nar5: 'Bảo vệ lo cho trường hợp có chuyện không may. Mục tiêu gia đình lo cho trường hợp mọi việc suôn sẻ: {cile}. Tổng cộng {suma} mỗi tháng.',
    narrativeTitle: 'Vì sao là con số này',
    rokyFew: '{n} năm',
    rokyMany: '{n} năm',
    rokyOne: '{n} năm',
    sumInval: 'Nếu không thể làm việc (mất sức lao động)',
    sumPn: 'Ốm ngắn ngày / tai nạn (nghỉ ốm)',
    sumSmrt: 'Khi tử vong',
    summaryTitle: 'Điều gì xảy ra nếu…',
    tableTitle: 'Bảo vệ theo từng người',
    thInvalidita: 'Mất sức lao động',
    thOsoba: 'Người',
    thPn: 'Nghỉ ốm/ngày',
    thSmrt: 'Tử vong',
    thTrvale: 'Di chứng vĩnh viễn',
    thVazna: 'Bệnh hiểm nghèo',
    titul: 'Đề xuất bảo vệ gia đình',
    vic10: 'Bảng hiển thị 5 người đầu và 5 người cuối trong tổng số {n} — các số tổng hợp ở trên tính cho cả gia đình.',
  },
  /* BLOK:zivotkoPdf END */
  /* BLOK:vzhledKontrola START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzhledKontrola: {
    ariaHistVyvoj: 'Giá trị khoản đầu tư {od}–{do}: đã góp {vlozeno}, giá trị {hodnota}, tài khoản tiết kiệm {sporeni}',
    ariaRozlozeni: 'Phân bổ danh mục',
    smazatCil: 'Xóa mục tiêu',
    smazatOsobu: 'Xóa người',
    snizit: 'Giảm',
    zrusitVyber: 'Bỏ chọn khoảng thời gian',
    zvysit: 'Tăng',
  },
  /* BLOK:vzhledKontrola END */
  /* BLOK:odkladaniZam START — generuje scratchpad/slovnik.py, ručně needitovat */
  odkladaniZam: {
    kino: {
      a5Zam: '+ {castka} do chủ lao động chuyển thẳng vào quỹ hưu trí bổ sung',
      prijem503020: 'Thu nhập ròng hằng tháng gồm cả đóng góp của chủ lao động',
      tokAria: 'Từ lương {prijem} và đóng góp của chủ lao động {zam}, {stranou} được để dành, còn {zivot} để chi tiêu.',
      vyplataPlus: '+ đóng góp của chủ lao động {castka}',
    },
    novyCrmOdklada: 'Để dành {pct} % thu nhập gồm cả đóng góp của chủ lao động · lý tưởng 20 % = {castka}',
    pochvala: 'Bạn để dành {pct} % thu nhập gồm cả đóng góp của chủ lao động ({castka})',
    vc: 'gồm cả đóng góp của chủ lao động',
    vodopad: {
      nejvys: 'Tối đa để dành được {castka} = {pct} % thu nhập gồm cả đóng góp của chủ lao động',
      odkladDnes: 'Hiện để dành {castka} = {pct} % thu nhập gồm cả đóng góp của chủ lao động (khoản tự gửi {vklady} + đóng góp của chủ lao động {zam} + tiền dư {volne}).',
      odkladDohoda: 'Để dành {castka} = {pct} % thu nhập gồm cả đóng góp của chủ lao động (khoản tự gửi {vklady} + đóng góp của chủ lao động {zam} + số tiền đã thống nhất {dohoda}).',
      posuvnikPct: '{pct} % thu nhập gồm cả đóng góp của chủ lao động =',
      posuvnikPrazdny: '{pct} % thu nhập gồm cả đóng góp của chủ lao động = —',
      stranouDnes: 'hiện để dành {pct} % thu nhập gồm cả đóng góp của chủ lao động',
      stranouDohoda: 'với số tiền đã thống nhất, để dành {pct} % thu nhập gồm cả đóng góp của chủ lao động',
      uzBezi: 'Đang chạy {castka} (khoản gửi tiết kiệm {vklady} + đóng góp của chủ lao động {zam})',
    },
    zaklad: 'trên {zaklad} gồm cả đóng góp của chủ lao động {zam}',
  },
  /* BLOK:odkladaniZam END */
  /* BLOK:fixaceVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  fixaceVystup: {
    disclaimer: 'Lịch sử lãi suất dựa trên số liệu thống kê hằng tháng của Ngân hàng Quốc gia Séc (khoản vay nhà ở mới theo thời hạn cố định, 2006–2026). Lãi suất sau khi hết cố định là giá trị MÔ PHỎNG, không phải dự báo — lãi suất thực tế do thị trường và ngân hàng quyết định vào thời điểm cố định lại.',
    dlouha: 'Cố định lãi suất dài hạn',
    fixaceZa: '{roky} với {sazba}',
    hero: 'Khoản trả góp sau {po} với lãi suất {sazba}',
    kratka: 'Cố định lãi suất ngắn hạn',
    nar1: 'Biểu đồ cho thấy khoản trả góp của anh/chị sẽ thay đổi thế nào trong suốt thời hạn vay — không chỉ trong những năm đầu cố định lãi suất. Cố định ngắn hạn hôm nay có khoản trả thấp hơn, nhưng khi hết thời hạn cố định, khoản trả sẽ được tính lại theo lãi suất lúc đó. Hôm nay không ai biết lãi suất đó.',
    nar2: 'Đường màu đỏ trên biểu đồ là ngân sách của anh/chị. Nếu khoản trả sau khi hết cố định vượt qua đường này thì sẽ có vấn đề — đó chính là rủi ro mà khoản trả thấp hôm nay che giấu.',
    nar3: 'Lịch sử lãi suất trong công cụ là số liệu thống kê hằng tháng thực tế của Ngân hàng Quốc gia Séc. Đây không phải dự báo: đó là bằng chứng lãi suất ở Séc đã biến động thường xuyên và mạnh đến mức nào.',
    pdfChyba: 'Không tạo được PDF',
    poLetechFew: '{n} năm',
    poLetechMany: '{n} năm',
    poLetechOne: '{n} năm',
    rokyFew: '{n} năm',
    rokyMany: '{n} năm',
    rokyOne: '{n} năm',
    sazbaPo: 'Lãi suất sau khi hết cố định (mô phỏng)',
    sazbaUnese: 'Mức lãi suất ngân sách còn chịu được',
    splatkaDlouha: 'Khoản trả góp khi cố định {roky}',
    splatkaPo: 'Khoản trả góp sau {po} với {sazba}',
    splatkaTed: 'Khoản trả góp hiện tại (cố định ngắn hạn)',
    splatnost: 'Thời hạn vay',
    unese: 'Khoản trả góp chịu được',
    unesePct: '{castka} ({pct} % thu nhập)',
    vyse: 'Số tiền vay mua nhà',
  },
  /* BLOK:fixaceVystup END */
  /* BLOK:kinoPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoPrijmy: {
    a1BigDoplnte: 'Hãy nhập thu nhập để chúng ta phân chia',
    a1BigPrijem: 'Thu nhập ròng hằng tháng của anh/chị',
    a1Kicker: 'Tiền đi đâu',
    a1L1: 'Phần lớn mọi người không biết mình tiêu bao nhiêu và vào đâu.',
    a1L2: 'Không có hệ thống thì cuối tháng chẳng còn lại gì.',
    a1Nar: '“Chúng ta cùng xem nên chia tiền thế nào để còn lại một phần cho ước mơ.”',
    a1Title: 'Mỗi tháng tiền trôi đi đâu?',
    a2Big: 'Một hệ thống đơn giản mà hiệu quả',
    a2Kicker: 'Quy tắc',
    a2L1: '50 % chi phí thiết yếu — nhà ở, ăn uống, điện nước, trả nợ.',
    a2L2: '30 % phong cách sống — niềm vui, sở thích, ăn ngoài.',
    a2L3: '20 % để dành cho mục tiêu — quỹ dự phòng, đầu tư, thu nhập thụ động.',
    a2Title: 'Quy tắc 50 / 30 / 20',
    a3Kicker: 'Với anh/chị là bao nhiêu',
    a3L2: '20 % = {castka} cho các mục tiêu dài hạn.',
    a3Title: '20 % là động lực cho sự tự do tài chính của anh/chị',
    a6Big: 'Con đường đến tự do của anh/chị',
    a6Kicker: 'Bắt đầu ngay hôm nay',
    a6L1: 'Theo thời gian, 20 % đó sẽ trở thành thu nhập thụ động của anh/chị.',
    a6L2: 'Đều đặn + thời gian = tiền bắt đầu làm việc cho anh/chị.',
    a6Nar: '“20 % hôm nay là sự tự do tài chính của ngày mai. Chúng ta bắt đầu thôi.”',
    a6Title: '20 % đều đặn = tự do tài chính',
    dejstviAria: 'Phần {n}',
    nazev: 'Thu nhập và chi tiêu',
  },
  /* BLOK:kinoPrijmy END */
  /* BLOK:kinoRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoRizika: {
    a1: {
      aria: 'Con đường tới mục tiêu: {cile}.',
      ariaBezCilu: 'Con đường tới các mục tiêu chúng ta sẽ bổ sung.',
      ariaDalsi: 'Con đường tới mục tiêu: {cile} và {n} mục tiêu khác.',
      cile: '{cile}.',
      cileADalsi: '{cile} và các mục tiêu khác.',
      dalsiCilFew: 'và {n} mục tiêu khác',
      dalsiCilMany: 'và {n} mục tiêu khác',
      dalsiCilOne: 'và {n} mục tiêu khác',
      kicker: 'Kế hoạch của anh/chị',
      radekBezCilu: 'Chúng ta sẽ cùng bổ sung mục tiêu.',
      radekKrok: 'Từng bước một, như chúng ta đã thống nhất.',
      rezie: 'Để khách hàng nhìn một lúc.',
      tahak: '“Đây là kế hoạch của anh/chị: {cile}. Từng bước một.”',
      tahakBezCilu: '“Trước khi lập kế hoạch, anh/chị hãy cho tôi biết mình muốn đạt được điều gì.”',
      tahakDalsi: '“Đây là kế hoạch của anh/chị: {cile} và các mục tiêu khác. Từng bước một.”',
      tahakHned: '{cil} ngay bây giờ',
      tahakVRoce: '{cil} vào năm {rok}',
      titulek: 'Đây là kế hoạch của anh/chị',
      titulekBezCilu: 'Kế hoạch được xây trên mục tiêu của anh/chị',
    },
    a1Big: 'Điều gì có thể đe dọa kế hoạch?',
    a1Kicker: 'Bảo vệ trước tiên',
    a1L1: 'Kế hoạch phải đứng trên nền móng vững chắc — đó là sự bảo vệ.',
    a1L2: 'Chỉ một lần mất thu nhập có thể làm sụp đổ mọi mục tiêu cùng lúc.',
    a1Nar: '“Trước khi xây ước mơ, chúng ta cần bảo vệ nền móng. Nếu không, chỉ một tai nạn có thể cuốn trôi cả kế hoạch.”',
    a1Title: 'Bảo vệ trước, xây dựng sau',
    a2: {
      aria: 'Phía trên con đường tới mục tiêu có ba đám mây: mất thu nhập (bệnh, tai nạn, mất sức lao động, tử vong) — lớn nhất, mất tài sản (hỏa hoạn, nước, trộm cắp) và trách nhiệm khi gây thiệt hại cho người khác.',
      invalidita: 'Mất sức lao động',
      kicker: 'Rủi ro',
      kradez: 'Trộm cắp',
      majetek: 'Mất tài sản',
      nejvetsi: 'Lớn nhất',
      nemoc: 'Bệnh',
      pozar: 'Hỏa hoạn',
      radek1: 'Có rất nhiều rủi ro.',
      radek2: 'Ba rủi ro chính: thu nhập, tài sản và trách nhiệm.',
      rezie: 'Đừng đánh giá và đừng làm khách hàng sợ.',
      skodaJinemu: 'Thiệt hại cho người khác',
      tahak: '“Kế hoạch giả định mọi thứ diễn ra như mong muốn. Nhưng đôi khi cuộc sống mang đến một đám mây. Có nhiều rủi ro — ba rủi ro chính là thu nhập, tài sản và trách nhiệm.”',
      titulek: 'Điều gì có thể đe dọa kế hoạch?',
      umrti: 'Tử vong',
      uraz: 'Tai nạn',
      voda: 'Nước',
    },
    a2BezDeti: 'Thu nhập của anh/chị nuôi cả gia đình.',
    a2BezHypo: 'Không có thu nhập, mọi thứ khác đều dừng lại.',
    a2Big: 'Thu nhập = động lực của cả kế hoạch',
    a2DetiFew: 'Anh/chị có {n} con — cả gia đình dựa vào thu nhập của anh/chị.',
    a2DetiMany: 'Anh/chị có {n} con — cả gia đình dựa vào thu nhập của anh/chị.',
    a2DetiOne: 'Anh/chị có {n} con — cả gia đình dựa vào thu nhập của anh/chị.',
    a2Hypo: 'Khoản vay mua nhà vẫn phải trả ngay cả khi mất thu nhập.',
    a2Kicker: 'Rủi ro số 1',
    a2L2: 'Mất sức lao động, bệnh dài ngày, tử vong — bảo hiểm thu nhập.',
    a2Nar: '“Rủi ro lớn nhất không phải thị trường — mà là mất khả năng kiếm tiền. Đó là điều chúng ta giải quyết đầu tiên.”',
    a3: {
      ariaBezPrijmu: 'Kế hoạch dựa trên thu nhập mà chúng ta chưa biết.',
      ariaDopad: 'Nếu {jmeno} không thể làm việc lâu dài: {dopad} ({pozn}).',
      ariaMensiDil: '{jmeno} gánh phần nhỏ hơn.',
      ariaNese: '{jmeno} gánh khoản này.',
      ariaNevime: 'Nếu {jmeno} không thể làm việc lâu dài, còn bao nhiêu cho mục tiêu, lần sau chúng ta sẽ tính kể cả trợ cấp nhà nước.',
      ariaVetsiDil: '{jmeno} gánh phần lớn hơn.',
      ariaZaklad: 'Kế hoạch dựa trên thu nhập {castka} mỗi tháng.',
      bezDavek: 'chưa tính trợ cấp của nhà nước',
      jede: 'Kế hoạch vẫn tiếp tục',
      kicker: 'Rủi ro lớn nhất',
      klient1: 'Khách hàng 1',
      klient2: 'Khách hàng 2',
      mene: 'Còn ít tiền hơn cho mục tiêu',
      nemuze: '{jmeno} không thể làm việc trong thời gian dài',
      nevime: 'Còn lại bao nhiêu, lần sau chúng ta sẽ tính',
      nevimePozn: 'kể cả trợ cấp của nhà nước',
      nezbyde: 'Không còn tiền cho mục tiêu',
      obaPracuji: 'Cả hai đều đi làm',
      pasivni: 'Thu nhập thụ động',
      pracuje: '{jmeno} đang đi làm',
      prijemDoplnime: 'Sẽ nhập thu nhập sau',
      radek: 'Cả kế hoạch dựa trên thu nhập của anh/chị.',
      radekBezPrijmu1: 'Cả kế hoạch dựa trên thu nhập.',
      radekBezPrijmu2: 'Chưa có thu nhập — chúng ta sẽ bổ sung.',
      rezie: 'Bấm các nút dưới hình. Hôm nay chưa tính mức bảo hiểm.',
      skupinaAria: 'Nếu như',
      tahakBezPrijmu: '“Cả kế hoạch dựa trên thu nhập. Chúng ta sẽ bổ sung và lần sau xem điều gì giữ vững nó.”',
      tahakJede: '“Cả kế hoạch dựa trên thu nhập của anh/chị. Nếu {jmeno} không thể làm việc lâu dài, kế hoạch vẫn tiếp tục. Nhà nước sẽ bù một phần — bao nhiêu, lần sau chúng ta sẽ tính.”',
      tahakMene: '“Cả kế hoạch dựa trên thu nhập của anh/chị. Nếu {jmeno} không thể làm việc lâu dài, tiền cho mục tiêu sẽ ít đi. Nhà nước sẽ bù một phần — bao nhiêu, lần sau chúng ta sẽ tính.”',
      tahakNevime: '“Cả kế hoạch dựa trên thu nhập của anh/chị. Nếu {jmeno} không thể làm việc lâu dài, thu nhập sẽ giảm. Còn lại bao nhiêu cho mục tiêu và nhà nước bù bao nhiêu, lần sau chúng ta sẽ tính.”',
      tahakNezbyde: '“Cả kế hoạch dựa trên thu nhập của anh/chị. Nếu {jmeno} không thể làm việc lâu dài, sẽ không còn tiền cho mục tiêu. Nhà nước sẽ bù một phần — bao nhiêu, lần sau chúng ta sẽ tính.”',
      vasPlan: 'KẾ HOẠCH',
      velkePopis: 'mỗi tháng gánh cả kế hoạch',
      vychoziBezPrijmu: 'Chưa có thu nhập nên chưa biết điều gì gánh kế hoạch',
      vychoziJede: 'Có thu nhập, kế hoạch vận hành',
      vychoziMene: 'Hiện còn ít tiền cho mục tiêu, sẽ bàn trong kế hoạch',
      vychoziNezbyva: 'Hiện chưa còn tiền cho mục tiêu, sẽ bàn trong kế hoạch',
    },
    a3Auto: 'Ô tô → bảo hiểm TNDS bắt buộc + bảo hiểm thân vỏ.',
    a3Big: 'Lá chắn toàn diện cho gia đình',
    a3Domacnost: 'Đồ đạc và thiết bị trong nhà — bảo hiểm tài sản.',
    a3Firma: 'Doanh nghiệp → bảo hiểm doanh nghiệp và gián đoạn kinh doanh.',
    a3Kicker: 'Tài sản & trách nhiệm',
    a3L2: 'Trách nhiệm dân sự (kể cả với chủ lao động), bảo vệ pháp lý.',
    a3Nar: '“Ngoài thu nhập, chúng ta còn bảo vệ tài sản, trách nhiệm dân sự, ô tô, bảo vệ pháp lý và với người kinh doanh là cả doanh nghiệp.”',
    a3Nemovitost: 'Bất động sản + tài sản trong nhà — bảo hiểm tài sản.',
    a3Title: 'Chúng ta bảo vệ những gì',
    a4: {
      aria: 'Các mục tiêu dưới tấm khiên nét đứt: phần bảo vệ sẽ được bổ sung ở buổi gặp sau.',
      coKryje: 'Bảo vệ được gì và chưa được gì',
      coMate: 'Anh/chị đang có gì',
      domluveno: '(đã hẹn)',
      jakZapadne: 'Khớp vào kế hoạch thế nào',
      kicker: 'Lần sau',
      naDalsiSchuzce: 'Buổi gặp sau',
      pojistneSmlouvy: 'hợp đồng bảo hiểm',
      radek: 'Hôm nay chưa cần quyết định gì.',
      rezie: 'Sau đó ở phần Kết luận, đánh dấu tài liệu Hợp đồng bảo hiểm.',
      rezieHotovo: 'Tài liệu Hợp đồng bảo hiểm đã được đánh dấu ở phần Kết luận.',
      sSebou: 'Mang theo:',
      tahak: '“Trong kế hoạch tài chính, chúng ta cũng sẽ xem phần bảo vệ của anh/chị — hiện có gì, bảo vệ được gì và chưa được gì. Chúng ta sẽ kiểm tra xem có thể tiết kiệm hoặc bảo hiểm khôn ngoan hơn không, và xem nó khớp vào cả kế hoạch thế nào.”',
      titulek: 'Buổi gặp sau chúng ta sẽ cùng xem',
    },
    a4Big: 'Bảo vệ = yên tâm cho cả kế hoạch',
    a4Kicker: 'Kết luận',
    a4L1: 'Chúng ta sẽ xem từng khoản bảo vệ — để gia đình không bị bỏ lại tay trắng.',
    a4L2: 'Chỉ kế hoạch được bảo vệ tốt mới đáng để xây dựng.',
    a4L3: 'Nghe thì nhàm chán, nhưng đó là nền tảng cơ bản nhất.',
    a4Nar: '“Đây có lẽ là phần quan trọng nhất. Chúng ta cùng xem anh/chị đã được bảo vệ những gì và còn thiếu ở đâu.”',
    a4Title: 'Chúng ta sẽ cùng xem kỹ phần này',
    cil: {
      auto: 'Ô tô',
      bydleni: 'Nhà ở',
      cil: 'Mục tiêu',
      deti: 'Con cái',
      dnes: 'hôm nay',
      investice: 'Đầu tư',
      podnikani: 'Kinh doanh',
      rekonstrukce: 'Sửa nhà',
      renta: 'Lương hưu tự lập',
      rezerva: 'Quỹ dự phòng',
    },
    iAuto: 'Ô tô (TNDS + thân vỏ)',
    iDomacnost: 'Tài sản trong nhà',
    iFirma: 'Doanh nghiệp / hoạt động',
    iInvalidita: 'Mất sức lao động / bệnh tật',
    iNemovitost: 'Bất động sản',
    iOdpovednost: 'Trách nhiệm dân sự',
    iPravni: 'Bảo vệ pháp lý',
    iUmrti: 'Tử vong (gia đình)',
    iVypadek: 'Mất thu nhập',
    iZamestnani: 'Việc làm',
    nazev: 'Bảo vệ trước rủi ro',
  },
  /* BLOK:kinoRizika END */
  /* BLOK:histKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  histKalk: {
    alokacePomery: 'Phân bổ · tỷ trọng',
    bezPoplatku: 'Không có phí. Hãy nhập phí để khách hàng thấy bao nhiêu tiền sẽ mất vào chi phí.',
    bezpecnaRenta: 'Thu nhập hằng tháng an toàn',
    brzdaBez: 'Không phanh',
    brzdaCil: 'Theo mục tiêu',
    brzdaNadpis: 'Phanh (giảm rủi ro dần)',
    brzdaPopisBez: 'Tỷ trọng giữ nguyên suốt thời gian.',
    brzdaPopisCil: 'Khoảng 10 năm cuối chuyển dần sang tiền mặt (mục tiêu một lần).',
    brzdaPopisRenta: 'Giảm rủi ro nhẹ, giữ nhiều cổ phiếu hơn (thu nhập thụ động).',
    brzdaRenta: 'Theo thu nhập thụ động',
    cilovaCastka: 'Số tiền mục tiêu trong khoảng thời gian',
    disclaimer: 'Mô phỏng dựa trên dữ liệu lịch sử thực tế 1926–2026. Lợi nhuận quá khứ không bảo đảm cho tương lai. Đầu tư có rủi ro thua lỗ.',
    doba: 'Thời gian',
    dobaInvestice: 'Thời gian đầu tư',
    dobaVyplaty: 'Thời gian chi trả (năm)',
    hodnotaDnes: 'Giá trị hôm nay',
    hodnotaRealne: 'Giá trị thực',
    jednorazove: 'Một lần',
    jednorazovyVklad: 'Khoản đầu tư một lần',
    koncova: 'Giá trị cuối kỳ của danh mục',
    krize: {
      k1929: 'Sụp đổ 1929',
      k1973: 'Khủng hoảng dầu mỏ',
      k1987: 'Thứ Hai Đen',
      k2000: 'Bong bóng dot-com',
      k2008: 'Khủng hoảng tài chính',
      k2011: 'Khủng hoảng nợ',
      k2020: 'Covid',
      k2022: 'Chiến sự Ukraina',
    },
    krizeKonec: 'Trong dữ liệu này, thị trường lần nào cũng phục hồi.',
    krizeVetaFew: 'Trong thời gian đó, khoản đầu tư đã trải qua {n} cuộc khủng hoảng — và vẫn đạt {castka}.',
    krizeVetaMany: 'Trong thời gian đó, khoản đầu tư đã trải qua {n} cuộc khủng hoảng — và vẫn đạt {castka}.',
    krizeVetaOne: 'Trong thời gian đó, khoản đầu tư đã trải qua {n} cuộc khủng hoảng — và vẫn đạt {castka}.',
    legInvestice: 'Khoản đầu tư',
    legSporici: 'Tài khoản tiết kiệm',
    legVlozeno: 'Đã nộp',
    letZkratka: 'năm',
    mesicne: 'Hằng tháng',
    mesicneHodnota: '{castka}/tháng',
    modCil: 'Mục tiêu',
    modRenta: 'Thu nhập thụ động',
    nar1: 'Biểu đồ cho thấy tiền của anh/chị sẽ thay đổi thế nào dựa trên dữ liệu lịch sử thực tế của thị trường, không phải lời hứa. Qua nhiều năm đã có khủng hoảng và sụt giảm — nhưng về dài hạn giá trị vẫn tăng. Điều quan trọng nhất là bắt đầu và kiên trì.',
    nar2: 'Lợi nhuận quá khứ không bảo đảm cho tương lai. Thị trường biến động trong ngắn hạn và giá trị khoản đầu tư cũng có thể giảm. Mô phỏng giúp hiểu nguyên tắc, không phải lời hứa về một mức lợi nhuận cụ thể.',
    nar3: 'Thời gian là đồng minh lớn nhất — nhờ lãi kép, mỗi năm trôi qua đều có lợi cho anh/chị. Vì vậy nên bắt đầu càng sớm càng tốt, dù chỉ với số tiền nhỏ.',
    nastroje: 'Công cụ',
    navicVeta: 'So với tài khoản tiết kiệm (thị trường tiền tệ), nhiều hơn {castka} — đó là cái giá của sự “an toàn” khi giữ tiền mặt.',
    nejhorsim: 'tệ nhất',
    nom: 'danh nghĩa',
    nominalne: 'danh nghĩa',
    obdobi: 'Giai đoạn',
    obdobiDvojtecka: 'Giai đoạn:',
    pdfChyba: 'Không tạo được PDF',
    poplatky: 'Phí',
    poplatkyCelkem: 'Tổng cộng phí sẽ lấy đi của anh/chị {castka} — bao gồm cả lợi nhuận mà số tiền đó không còn sinh ra.',
    portfolio: 'Danh mục',
    portfolioMix: 'Cơ cấu danh mục',
    potrebujeteMesicne: 'Cần đầu tư mỗi tháng',
    pouzit: 'Dùng cho phép tính',
    pravidelneMesicne: 'Đầu tư định kỳ hằng tháng',
    preset: {
      dynamicky: 'Năng động',
      konzervativni: 'Thận trọng',
      moderni: 'Hiện đại',
      vyvazeny: 'Cân bằng',
      zlaty: 'Có vàng',
    },
    priJednorazovem: 'Với khoản một lần {castka} và tỷ trọng {alokace}.',
    prubeznyPct: 'Phí định kỳ % (mỗi năm)',
    real: 'thực',
    realne: 'thực',
    realneOd: 'thực chỉ từ 8/1946 (dữ liệu lạm phát trước đó không có)',
    rentaMaloHistorie: 'Tỷ trọng này chưa đủ dữ liệu lịch sử để kiểm tra toàn bộ thời gian chi trả ({roky}) — hãy rút ngắn thời gian hoặc giảm các loại tài sản còn mới (BTC, REIT, MSCI).',
    rentaVydrzi: 'Từ {castka} đã tích lũy, khoản này đủ dùng trong {roky} ngay cả ở giai đoạn lịch sử {nejhorsim} (bình thường còn lâu hơn).',
    rokyFew: '{n} năm',
    rokyMany: '{n} năm',
    rokyOne: '{n} năm',
    souhrnReal: 'Mô phỏng trên lịch sử thực (8/1946–2026, {n} giai đoạn, sau lạm phát):',
    sporiciByDal: 'Tài khoản tiết kiệm sẽ cho',
    staciJednorazovy: '0 {mena} (khoản một lần là đủ)',
    titul: 'Máy tính lịch sử đầu tư',
    trida: {
      akcie: 'Cổ phiếu',
      btc: 'Bitcoin',
      dluhopisy: 'Trái phiếu',
      em: 'Thị trường mới nổi',
      msci: 'MSCI World',
      ndx: 'NASDAQ-100',
      pt: 'Thị trường tiền tệ',
      reit: 'Bất động sản',
      zlato: 'Vàng',
    },
    typ: 'Loại:',
    vlozenoCelkem: 'Tổng số tiền đã nộp',
    vstupniPct: 'Phí đầu vào %',
    vstupniPoplatek: 'Phí đầu vào: {castka} trên số tiền đã nộp {vlozeno}.',
    vynosPa: 'Lợi suất/năm',
    vyvojNadpis: 'Diễn biến giá trị khoản đầu tư',
    zdrojDat1: 'Dữ liệu: SBBI/Ibbotson Mỹ theo tháng 1926–2026 (Cổ phiếu = S&P 500 gồm cổ tức, Trái phiếu = trái phiếu chính phủ Mỹ dài hạn, Thị trường tiền tệ = T-Bills, Lạm phát = CPI Mỹ). Vàng = LBMA từ 1968 · MSCI World từ 1985 (gồm cổ tức ước tính 2 %/năm) · Bất động sản = chỉ số REIT từ 2004 · Bitcoin từ 2010.',
    zdrojDat2: 'Lợi suất/năm = tỷ suất hoàn vốn nội bộ của dòng tiền. Lợi nhuận quá khứ không bảo đảm cho tương lai.',
    zhodnoceni: 'Lợi nhuận',
    zkraceno: 'rút ngắn còn {roky} (loại tài sản còn mới)',
  },
  /* BLOK:histKalk END */
  /* BLOK:alokaceGraf START — generuje scratchpad/slovnik.py, ručně needitovat */
  alokaceGraf: {
    celkem: 'Tổng thể',
    faze: {
      drzeni: 'Nắm giữ. Thị trường biến động, kế hoạch thì không.',
      hotovost: 'Tiền đang ở dạng tiền mặt. Không có rủi ro thị trường.',
      odprodej: 'Bán bớt cổ phiếu và mua trái phiếu — mục tiêu đang đến gần.',
      start: 'Mua vào — tiền được đưa vào cổ phiếu.',
    },
    mesicuFew: '{n} tháng',
    mesicuMany: '{n} tháng',
    mesicuOne: '{n} tháng',
    nadpis: 'Dòng tiền chảy về đâu theo thời gian',
    pauza: 'Tạm dừng',
    prehrat: 'Phát',
    rok: 'Năm {n}',
    zpetNaCelek: 'Quay lại toàn bộ',
  },
  /* BLOK:alokaceGraf END */
  /* BLOK:fondyRenta START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondyRenta: {
    mimo: ' (các tài khoản khác và quỹ chưa gán cho mục tiêu nào) — tổng tài sản tài chính ',
    prehled: 'Quỹ → thu nhập thụ động',
    prehledRezerva: 'Quỹ → dự phòng',
    prerozdeluje: 'Kế hoạch phân bổ một lần các tài khoản thanh khoản, tiết kiệm xây dựng, quỹ hưu trí và quỹ đầu tư. Nằm ngoài: ',
    rozpocetDoRenty: ' là quỹ đầu tư và bảo hiểm nhân thọ liên kết đầu tư mà khách hàng đã có — kế hoạch tính chúng vào mục tiêu thu nhập thụ động.',
    rozpocetKCilum: ' là quỹ đầu tư và bảo hiểm nhân thọ liên kết đầu tư mà khách hàng đã có — kế hoạch đã gán chúng cho các mục tiêu theo dòng tiền.',
    rozpocetRezervaRenta: ' là quỹ đầu tư và bảo hiểm nhân thọ liên kết đầu tư mà khách hàng đã có — kế hoạch trước hết dùng chúng bổ sung quỹ dự phòng ({rezerva}), phần còn lại tính vào mục tiêu thu nhập thụ động.',
  },
  /* BLOK:fondyRenta END */
  /* BLOK:kinoZavazky START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZavazky: {
    a0: {
      radek: 'Trong phân tích không có khoản vay nào.',
      tahak: '“Anh/chị không trả khoản vay nào. Số tiền lẽ ra trả ngân hàng có thể làm việc cho anh/chị.”',
      titulek: 'Anh/chị không có khoản nợ nào',
    },
    a1: {
      ariaChybi: '{nazev}: {stav}.',
      ariaDluzite: 'Anh/chị đang nợ {castka}.',
      ariaUroky: 'Tiền lãi anh/chị còn phải trả: {castka}.',
      ariaUrokyCast: 'Tiền lãi còn phải trả ở các khoản vay đã biết lãi suất: {castka}.',
      ariaUver: '{nazev}: nợ {dluh}, tiền lãi {uroky}, trả xong năm {rok}.',
      dluh: 'nợ gốc',
      dluhNeklesa: 'Khoản nợ không giảm',
      dluhZnamy: 'nợ đã biết lãi suất',
      doplnteSplatku: 'Bổ sung khoản trả góp',
      doplnteUrok: 'Bổ sung lãi suất',
      doplnteZustatek: 'Bổ sung dư nợ',
      kicker: 'Khoản nợ của anh/chị',
      popisNespocitame: 'chưa thể tính tiền lãi',
      popisNikdy: 'khoản trả góp không đủ trả lãi',
      radekChybi: '{nazev}: {stav}, chưa có trong tổng.',
      radekChybiBez: '{nazev}: {stav}.',
      radekDluzite: 'Anh/chị đang nợ {castka}.',
      radekNaSto: 'Cứ mỗi {sto} nợ, anh/chị trả thêm cho ngân hàng {kolik}.',
      subDluh: 'nợ {castka}',
      tahak: '“Khoản nợ không chỉ tốn số tiền đã vay. Đây là số tiền anh/chị còn phải trả thêm cho ngân hàng.”',
      tahakDoplnte: '“Chúng ta xem lãi suất trong hợp đồng. Khi đó anh/chị sẽ thấy ngay phải trả thêm ngân hàng bao nhiêu.”',
      tip: 'Nhập lãi suất từ hợp đồng. Khi đó phim sẽ tính tiền lãi và thời điểm trả xong.',
      titulek: 'Khoản nợ tốn của anh/chị bao nhiêu',
      urokyBance: 'tiền lãi cho ngân hàng',
      velkePopis: 'anh/chị còn phải trả ngân hàng tiền lãi',
    },
    a2: {
      ariaDobry: 'Nợ tốt mua nhà {castka}.',
      ariaDobrySazba: 'Nợ tốt mua nhà {castka} với lãi suất {sazba}.',
      ariaJenBydleni: 'Chỉ có nợ mua nhà {castka}.',
      ariaPolozka: '{nazev} {sazba} mỗi năm',
      ariaPolozkaBez: '{nazev}, chưa nhập lãi suất',
      ariaSpatny: 'Nợ xấu {castka}: {seznam}.',
      ariaZadny: 'Anh/chị không có nợ xấu.',
      bydlite: 'Anh/chị đang ở · bất động sản {castka}',
      dobry: 'Nợ tốt',
      dobryProc: 'nhà ở',
      firemni: 'Vay kinh doanh',
      firemniProc: 'kinh doanh · không thuộc bước này',
      kicker: 'Nợ tốt và nợ xấu',
      radekChybiUrok: 'Nợ xấu chưa có lãi suất.',
      radekHypo: 'Vay mua nhà {sazba}.',
      radekJenBydleni: 'Anh/chị chỉ có khoản nợ mua nhà.',
      radekNetyka: 'Bước “Trả hết nợ xấu” không áp dụng cho anh/chị.',
      radekPrvni: 'Nợ xấu được trả trước.',
      radekSazba: '{druh} tốn {sazba} mỗi năm.',
      radekZadnaSpotreba: 'Không có khoản vay tiêu dùng.',
      spatny: 'Nợ xấu',
      spatnyProc: 'tiêu dùng',
      spatnyZadnyProc: 'vay tiêu dùng, thẻ tín dụng, thấu chi',
      tahak: '“Chúng ta trả hết khoản vay đắt và thẻ tín dụng trước. Tiền lãi chắc chắn phải trả, còn lợi nhuận đầu tư thì không chắc.”',
      tahakZadny: '“Vay mua nhà là khoản nợ mà anh/chị đang ở trong đó. Anh/chị không có vay tiêu dùng hay thẻ tín dụng, đó là tin tốt.”',
      titulek: 'Không phải khoản nợ nào cũng như nhau',
      titulekZadny: 'Anh/chị không có nợ xấu',
      velkePopis: 'nợ xấu · {druhy}',
      velkePopisZadny: 'nợ xấu',
      zadny: 'Không có',
    },
    a3: {
      ariaBez: 'Không trả thêm: nợ xấu trả xong sau {za}, tiền lãi {urok}.',
      ariaNavic: 'Trả thêm {castka} mỗi tháng: hết nợ xấu sau {za} thay vì {puvodne}, tiết kiệm {usetreno} tiền lãi.',
      ariaNesplati: 'Dù trả thêm {castka} mỗi tháng, nợ xấu vẫn không trả hết.',
      jezdecAria: 'Mỗi tháng trả thêm bao nhiêu cho nợ xấu',
      kicker: 'Nếu như',
      mesZkr: '{n} th.',
      navicMesicne: 'Trả thêm mỗi tháng',
      navicNejdrivSem: 'trả thêm vào đây trước',
      nic: 'Không',
      nikdy: 'không bao giờ',
      nikdyPopis: 'trả góp thấp hơn lãi · nợ tăng',
      popisPosunte: 'kéo để chọn số tiền trả thêm',
      popisRoste: 'dù trả thêm như vậy khoản nợ vẫn không giảm',
      popisSplaceno: 'trả xong sau {za}',
      popisUsetrite: 'tiết kiệm tiền lãi',
      pozn: 'Tính từ khoản trả góp và lãi suất trong hợp đồng. Khoản trả góp của khoản vay đã trả xong được giải phóng cho anh/chị, tiền trả thêm chuyển sang khoản nợ tiếp theo.',
      radekDnes: 'Hiện tại hết nợ xấu sau {za}.',
      radekDriv: 'Sớm hơn {kolik}.',
      radekNejdrazsi: 'Tiền trả thêm đi vào khoản nợ đắt nhất trước.',
      radekNikdy: '{nazev}: khoản trả góp không đủ trả lãi.',
      radekZa: 'Hết nợ xấu sau {za} thay vì {puvodne}.',
      rychlaVolba: 'Chọn nhanh',
      tahak: '“Mỗi đồng trả thêm đều đi vào khoản nợ đắt nhất. Những gì không phải trả ngân hàng sẽ ở lại với anh/chị.”',
      titulek: 'Trả nợ xấu sớm hơn',
      valuetext: '{castka} mỗi tháng',
      velkeRoste: 'Vẫn tăng',
      velkeZastavi: 'Khoản nợ ngừng tăng',
      volne: 'Tiền dư {castka}',
      zCilu: '{castka} trong số này sẽ lấy từ tiền dành cho mục tiêu cho tới khi trả hết nợ.',
    },
    a4: {
      aria: 'Sau kỳ cố định, với lãi suất {sazba}, khoản trả góp sẽ là {po} thay vì {pred}.',
      dnes: 'Hiện nay · {sazba}',
      jakoDnes: 'như hiện nay',
      jezdecAria: 'Lãi suất vay mua nhà sau khi hết kỳ cố định',
      kicker: 'Vay mua nhà',
      oDvaBody: 'cao hơn 2 điểm',
      po: 'Sau kỳ cố định · {sazba}',
      pozn: 'Hôm nay không ai biết lãi suất sau kỳ cố định. Thời hạn vay giữ nguyên, khoản trả góp thay đổi.',
      poznTrh: 'Trung bình thị trường hôm nay: Swiss Life Hypoindex {obdobi}.',
      prumerTrhu: 'trung bình thị trường hôm nay',
      radekSplatka: 'Khoản trả góp được tính lại: {pred} → {po}.',
      radekZustatek: 'Khi hết kỳ cố định còn lại {castka} nợ.',
      sazbaPoFixaci: 'Lãi suất sau kỳ cố định',
      tahak: '“Kỳ cố định rồi sẽ kết thúc. Giờ chúng ta biết khoản trả góp sẽ thế nào nếu lãi suất tăng.”',
      titulek: 'Hết kỳ cố định lãi suất: {kdy}',
      velkePopis: 'trả góp mỗi tháng với lãi suất {sazba}',
    },
    a5: {
      ariaDnes: 'Hiện nay {castka} mỗi tháng cho mục tiêu.',
      ariaOd: 'Từ năm {rok}: {castka}.',
      ariaRenta: 'Lương hưu tự lập từ năm {rok}.',
      dnes: 'hôm nay',
      kicker: 'Sau khi trả xong',
      naCile: 'cho mục tiêu mỗi tháng',
      navicNaDluhy: '{castka} trả thêm cho nợ',
      poRenteFew: 'Vay mua nhà trả xong {n} năm sau khi bắt đầu lương hưu tự lập.',
      poRenteMany: 'Vay mua nhà trả xong {n} năm sau khi bắt đầu lương hưu tự lập.',
      poRenteOne: 'Vay mua nhà trả xong {n} năm sau khi bắt đầu lương hưu tự lập.',
      popisDoplnte: 'thiếu chúng thì chưa biết khi nào trả xong nợ',
      poznModel: 'Hiện nay {castka} mỗi tháng cho mục tiêu từ tiền dư, chưa được thống nhất. Khoản trả góp được giải phóng lấy từ hợp đồng. Thu nhập và chi tiêu khác tính như hiện nay.',
      poznOdsouhlaseno: 'Hiện nay {castka} mỗi tháng cho mục tiêu, như đã thống nhất trong phân tích. Khoản trả góp được giải phóng lấy từ hợp đồng. Thu nhập và chi tiêu khác tính như hiện nay.',
      predRentouFew: 'Trả xong {n} năm trước khi nhận lương hưu tự lập.',
      predRentouMany: 'Trả xong {n} năm trước khi nhận lương hưu tự lập.',
      predRentouOne: 'Trả xong {n} năm trước khi nhận lương hưu tự lập.',
      radekHypo: 'Năm {rok} trả xong vay mua nhà. Thêm {castka}.',
      radekUsetreno: 'Tiền lãi tiết kiệm được {castka} ở lại với anh/chị.',
      splaceno: '{nazev}: đã trả xong',
      startRenty: 'bắt đầu lương hưu tự lập',
      tahak: '“Khi trả xong nợ, số tiền này sẽ làm việc cho anh/chị.”',
      tip: 'Nhập ngày trả xong vay mua nhà từ hợp đồng.',
      titulek: 'Số tiền sẽ được giải phóng',
      velkeDoplnte: 'Bổ sung khoản trả góp',
      velkePopis: 'thêm mỗi tháng cho mục tiêu · từ năm {rok}',
    },
    mesiceFew: '{n} tháng',
    mesiceMany: '{n} tháng',
    mesiceOne: '{n} tháng',
    nazev: 'Khoản nợ',
    prezTlacitko: 'Mở phim: Khoản nợ tốn bao nhiêu',
    splacenoVRoce: 'trả xong năm {rok}',
    stav: {
      bezJistiny: 'chưa nhập dư nợ',
      bezSplatky: 'chưa nhập khoản trả góp',
      bezUroku: 'chưa nhập lãi suất',
      nikdy: 'khoản trả góp không đủ trả lãi',
    },
    tlacitko: 'Phim về khoản nợ',
    uver: 'Khoản vay',
  },
  /* BLOK:kinoZavazky END */
  /* BLOK:rizikoVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  rizikoVysvetleni: {
    dite: {
      potreba: 'toàn bộ nhu cầu',
      sablonaKrok: 'Mẫu cho hợp đồng của con',
      sablonaTitul: 'Mẫu: vì sao là số tiền này',
      sablonaToggle: 'Vì sao là số tiền này',
      sablonaVeta: 'Đây là mẫu từ thực tế tư vấn, không phải tính từ số liệu của khách hàng — hãy sửa bằng bút chì theo báo giá của công ty bảo hiểm.',
      strop: 'Mức trần có thể bảo hiểm',
      stropPod: 'hợp đồng cho trẻ em thường chỉ nhận đến khoảng {strop}, phần còn lại {zbytek} thuộc về quỹ dự phòng',
      trvaleTitul: 'Số tiền bảo hiểm của con được tính thế nào',
      trvaleToggle: 'Cách tính số tiền bảo hiểm của con',
      vypadekPod: '{kdo}: {prijem} trong {roky}, giá trị hôm nay với lợi suất 4 % trên lạm phát',
      zavazneKrok1: 'Thu nhập một năm của cha mẹ chăm con',
      zavazneKrok1Pod: '{kdo}: {prijem} × 12',
      zavazneStropPod: 'hợp đồng cho trẻ em chỉ bảo vệ đến khoảng {strop}, phần còn lại {zbytek} thuộc về quỹ dự phòng',
    },
    odskodne: {
      krok1: 'Phần hụt không gì bù',
      krok1PodOdZacatku: 'quỹ dự phòng không đủ dù một tháng: {prijem} − trợ cấp ốm {stat}',
      krok1PodRezerva: 'những tháng đầu do quỹ dự phòng gánh, sau đó bảo hiểm nghỉ ốm chi trả — trợ cấp này sẽ trùng lặp',
      krok1PodVypnuto: 'trợ cấp này đã tắt',
      krok2: 'Mức trần: tổng trợ cấp tối đa bằng thu nhập ròng',
      krok2Pod: '{prijem} − trợ cấp ốm {stat} − nghỉ ốm {pn}',
      model: 'Trợ cấp này bù những ngày bảo hiểm nghỉ ốm chưa chi trả và quỹ dự phòng không đủ. Tổng các khoản trợ cấp không được vượt thu nhập ròng — không công ty bảo hiểm nào nhận như vậy.',
      titul: 'Trợ cấp tai nạn theo ngày được tính thế nào',
      toggle: 'Cách tính trợ cấp tai nạn theo ngày',
      vysledek: 'Hạn mức trợ cấp tai nạn theo ngày',
      vysledekPod: 'lấy số nhỏ hơn, làm tròn đến hàng chục',
    },
    pn: {
      krok1: 'Thu nhập ròng',
      krok1Vydaje: 'Phần chi phí thiết yếu',
      krok1VydajeSplatky: 'Phần chi phí thiết yếu và khoản trả nợ',
      krok2: 'Nhà nước trả gì',
      krok3: 'Phần thu nhập bị hụt',
      krok3Pod: '{prijem} − {stat}',
      krok4: 'Trợ cấp theo ngày',
      krok4Pod: '{vypadek} ÷ {dni} ngày',
      krok5: 'Bảo hiểm bắt đầu trả từ khi nào',
      krok5Hodnota: 'từ tháng thứ {mesic}',
      krok5Info: 'Thời gian chờ = quỹ dự phòng đủ cho bao nhiêu tháng trọn, tối đa 3. Thời gian chờ dài hơn = phí bảo hiểm rẻ hơn.',
      krok5Pod: 'quỹ dự phòng {rezerva} = {nasobek}× chi phí thiết yếu ({vydaje}) — trước đó quỹ này gánh',
      krok5PodNula: 'quỹ dự phòng {rezerva} không đủ dù chỉ một tháng chi phí thiết yếu ({vydaje})',
      model: 'Mô hình tham khảo, không phải cam kết: trợ cấp ốm theo quy định năm 2026, mức thực tế do nhà nước quyết định. Thời gian chờ và chi trả theo điều khoản bảo hiểm.',
      odDneOsvc: 'chi trả từ ngày thứ {den}',
      odDneZam: 'chi trả từ ngày thứ {den}, trước đó chủ lao động trả bù lương',
      omezeno: 'tối đa bằng thu nhập ròng',
      predpoklad: 'giả định có bảo hiểm ốm đau bắt buộc',
      sazbaInfo: 'Chúng tôi tính 60 % — mức của 30 ngày đầu. Từ ngày 31 nhà nước trả 66 %, từ ngày 61 là 72 %, nên mô hình thận trọng.',
      statBez: 'Không đóng bảo hiểm ốm đau — không được nhận trợ cấp ốm.',
      statOsvc: 'Người tự doanh không đóng bảo hiểm ốm đau — không được nhận trợ cấp ốm.',
      statRozpad: 'lương gộp ≈ {hruba} → cơ sở theo ngày {dvz} → sau giảm trừ {rdvz} → {sazba} % = {den} × 30 ngày',
      statRozpadSK: 'lương gộp ≈ {hruba} → cơ sở theo ngày {dvz} → {sazba} % = {den} × 30 ngày',
      strop: 'mức trần: tối đa {strop} — phần cơ sở theo ngày trên {hranice} không được tính',
      stropSK: 'mức trần: cơ sở theo ngày tối đa {hranice}',
      titul: 'Trợ cấp theo ngày được tính thế nào',
      toggle: 'Cách tính nghỉ ốm',
      varianty: 'Như nhau ở mọi phương án bảo vệ — khoản hụt ngắn hạn không bị cắt giảm.',
      vysledek: 'Hạn mức nghỉ ốm',
    },
    rucne: 'Thẻ hiển thị {rucni} nhập tay, tính toán ra {spocitano}.',
    skryt: 'Ẩn cách tính',
    zaokrouhleni: 'Các dòng được làm tròn, tổng có thể chênh lệch một chút.',
    zavazne: {
      krok1: 'Thu nhập ròng một năm',
      krok1Pod: '{prijem} × 12',
      krok2: 'Cho bao nhiêu năm',
      krok2Hodnota: '× {roky}',
      krok2Pod: 'chọn 1 / 2 / 3 năm bên dưới dòng',
      titul: 'Số tiền bệnh hiểm nghèo được tính thế nào',
      toggle: 'Cách tính bệnh hiểm nghèo',
      vysledek: 'Hạn mức bệnh hiểm nghèo',
    },
  },
  /* BLOK:rizikoVysvetleni END */
  /* BLOK:fondKategorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondKategorie: {
    'akcie-em': 'Cổ phiếu – thị trường mới nổi',
    'akcie-eu': 'Cổ phiếu – châu Âu',
    'akcie-svet': 'Cổ phiếu – toàn cầu',
    'akcie-tech': 'Cổ phiếu – công nghệ',
    'akcie-usa': 'Cổ phiếu – Mỹ',
    dluhopisy: 'Trái phiếu',
    fond: 'Quỹ',
    fondA: 'Quỹ A',
    fondB: 'Quỹ B',
    krypto: 'Tiền mã hóa (ETP)',
    nemovitosti: 'Quỹ bất động sản',
    penizni: 'Thị trường tiền tệ / thận trọng',
    smisene: 'Hỗn hợp',
    zlato: 'Vàng / hàng hóa',
  },
  /* BLOK:fondKategorie END */
  /* BLOK:kino503020 START — generuje scratchpad/slovnik.py, ručně needitovat */
  kino503020: {
    a1: {
      aria: 'Quy tắc 50/30/20: từ thu nhập {prijem}, để dành {stranou}, cho cuộc sống {styl}, cho thiết yếu gồm trả nợ {nezbytne}.',
      bezPrijmu: 'Không có thu nhập thì chưa chia theo quy tắc được.',
      kat: {
        bonusy: 'tiền thưởng',
        pasivni: 'thu nhập thụ động',
      },
      kicker: 'Quy tắc',
      osoba: 'Người {n}',
      prijem: 'thu nhập ròng',
      prijemDomacnosti: 'thu nhập ròng của gia đình',
      radek1: 'Một nửa cho thiết yếu.',
      radek2: 'Gần một phần ba cho cuộc sống.',
      radek3: 'Một phần năm để dành.',
      splatkyNadRozpocet: 'Trả nợ hiện chiếm nhiều hơn phần quy tắc dành cho chi tiêu.',
      tahak: '“Quy tắc đã được kiểm chứng: từ {prijem}, một nửa cho thiết yếu, gần một phần ba cho cuộc sống và một phần năm để dành cho tương lai. Tối thiểu là một phần mười.”',
      titulek: '50 / 30 / 20',
      zamestnavatel: 'chủ lao động {castka}',
    },
    a2: {
      aria: 'Hôm nay để dành {pct}% ({stranou}). {radek} {dily}.',
      ariaPravidlo: 'Quy tắc: để dành 20%, cuộc sống 30%, thiết yếu và trả nợ 50%.',
      ariaSchodek: 'Hôm nay mỗi tháng thiếu {chybi}: chi tiêu và trả nợ vượt thu nhập. Không để dành được gì, khoản góp tiết kiệm nằm trong chi tiêu.',
      bezVydaju: 'Hãy nhập chi tiêu, chúng tôi sẽ tính bạn thực sự để dành bao nhiêu.',
      bezVydajuVizual: 'Chưa có chi tiêu thì chưa nêu tỷ lệ.',
      dohodaNad: 'Khoản đã thống nhất cao hơn tiền dư {castka}.',
      kicker: 'Bạn hôm nay',
      nesoulad: 'Khoản góp cao hơn chi tiêu, hãy kiểm tra bảng chi tiêu.',
      poznVklady: 'gồm khoản góp tiết kiệm',
      poznZam: 'gồm {castka} từ chủ lao động',
      pravidlo: 'Quy tắc',
      prepinacAria: 'Hiển thị gì',
      radekIdeal: 'Đó là mức lý tưởng. ✓',
      radekMinimum: 'Bạn đã đạt tối thiểu. Còn thiếu {chybi} để đạt mức lý tưởng.',
      radekPod: 'Còn thiếu {chybi} mỗi tháng để đạt mức tối thiểu.',
      radekRychle: 'Mục tiêu hoàn thành rất nhanh. ✓',
      radekSchodek: 'Trước khi để dành, cần bù khoản chênh lệch này.',
      tahakBezVydaju: '“Trước khi nói tỷ lệ, chúng ta cùng nhập chi tiêu.”',
      tahakCastVolne: 'Trong đó {zbyva} bạn có trong tiền dư, phần còn lại ta sẽ tìm trong chi tiêu.',
      tahakIdeal: '“Bạn để dành {pct}% thu nhập. Đó là mức lý tưởng. Giờ là chuyện ta sẽ gửi số tiền đó vào đâu.”',
      tahakMinimum: 'Bạn để dành {pct}% thu nhập. Đã đạt tối thiểu, còn thiếu {chybi} để đạt lý tưởng.',
      tahakPod: 'Bạn để dành {pct}% thu nhập. Còn thiếu {chybi} để đạt tối thiểu.',
      tahakRychle: '“Bạn để dành {pct}% thu nhập nên mục tiêu hoàn thành rất nhanh. Hãy đảm bảo vẫn đủ cho cuộc sống.”',
      tahakSchodek: '“Hôm nay mỗi tháng thiếu {chybi}. Trước khi để dành, chúng ta cần bù khoản này.”',
      tahakVolne: 'Số đó bạn có trong tiền dư, không cần cắt giảm.',
      tahakVydaje: 'Hôm nay chưa có tiền dư cho việc này, ta sẽ tìm trong chi tiêu.',
      titulek: 'Bạn đang ở đâu hôm nay',
      velkeBezVydaju: 'chưa nhập chi tiêu',
      velkePopis: 'thu nhập được để dành · {castka}',
      velkeSchodek: 'thiếu mỗi tháng',
      vyDnes: 'Bạn hôm nay',
      zbyvaPred: 'Còn dư',
    },
    a3: {
      aria: 'Ở mức {pct}%, để dành {stranou}, còn dư {zbyva}. Thiết yếu và trả nợ không đổi.',
      ariaStyl: 'Ở mức {pct}%, để dành {stranou}, trong đó {styl} từ chi tiêu lối sống. Thiết yếu và trả nợ không đổi.',
      kicker: 'Nếu như',
      pct: {
        necelych: 'gần {pct}%',
        pres: 'hơn {pct}%',
        presne: '{pct}%',
      },
      pokryto: 'Các khoản góp đang chạy đã đủ ({vklady}).',
      radekSchodek: 'Khi thâm hụt, xử lý chi tiêu trước, rồi mới đến tỷ lệ.',
      staci: 'Tiền dư là đủ.',
      tahak: '“Bạn thử xem. Từ khoản góp và tiền dư tối đa được {max} mỗi tháng, tức {pct}. Vượt hơn thì ta phải lấy từ cuộc sống của bạn.”',
      tahakSchodek: '“Để dành bằng tiền nợ là vô nghĩa. Trước hết ta tìm ra {chybi} đó, rồi quay lại tỷ lệ.”',
      titulek: 'Lấy tiền từ đâu',
      velkePopis: 'để dành mỗi tháng',
      velkeSchodek: 'không có gì để dành',
      zbyva: 'Còn {castka}.',
      zeStylu: 'Cắt {castka} mỗi tháng từ chi tiêu lối sống.',
    },
    a4: {
      ariaBezCile: 'Mục tiêu chưa có khoản này.',
      ariaChybi: 'Còn thiếu {chybi} mỗi tháng để đủ nuôi gia đình.',
      ariaPotreba: 'Gia đình cần {potreba} mỗi tháng.',
      ariaSedi: 'Khoản trong mục tiêu {zadano} đủ nuôi gia đình.',
      ariaSplatky: 'Trong đó {nazev} {splatky} ({proc}).',
      bezSporeni: 'Không tính khoản tiết kiệm hiện nay {castka}, khi sống bằng tài sản bạn không còn tiết kiệm.',
      bezUveru: 'Không tính các khoản vay trả xong trước đó.',
      bezUveruRok: 'Không tính các khoản vay trả xong trước năm {rok}.',
      chybiMesicne: 'thiếu {chybi} mỗi tháng',
      kapital: 'Để có {potreba} theo giá hôm nay cần vốn khoảng',
      kicker: 'Sống bằng tài sản',
      potrebuje: 'Gia đình cần',
      pravni: 'Mô hình theo tỷ lệ rút khoảng {sazba} mỗi năm (hồ sơ {profil}). Đây không phải lợi nhuận hay cam kết, thực tế có thể khác.',
      radekPotreba: 'Gia đình cần {potreba} mỗi tháng.',
      radekSoucet: 'Chi tiêu {vydaje} + {nazev} {splatky} = {potreba} mỗi tháng.',
      splatky: 'trả nợ',
      splatkyBezi: 'vẫn còn khi sống bằng tài sản',
      splatkyNeznamyKonec: 'chưa tính được ngày kết thúc, hãy nhập lãi suất',
      tahak: '“Sống bằng tài sản không phải là kiếm nhiều tiền. Đó là khi tài sản trả các hóa đơn thay bạn.”',
      tahakUrok: '(Hãy nhập lãi suất hoặc dư nợ, ứng dụng sẽ tính xem khoản vay có kết thúc trước đó không.)',
      titulek: 'Khoản thu nhập thụ động phải gánh bao nhiêu?',
      vCilech: 'Trong mục tiêu',
      vCilechJe: 'Trong mục tiêu có {zadano}.',
      vCilechNeni: 'Mục tiêu chưa có khoản này.',
      velkeBezCile: 'mỗi tháng nên có',
      velkeChybi: 'mỗi tháng còn thiếu để đủ nuôi gia đình',
      velkeSedi: 'khoản trong mục tiêu đủ nuôi gia đình ✓',
      zTohoSplatky: 'trong đó {nazev}',
    },
    ctverecek: '1 ô vuông = 1% thu nhập ({castka} mỗi tháng)',
    dil: {
      nad: 'Trong đó vượt thu nhập',
      nezbytne: 'Thiết yếu',
      nezbytneVse: 'Thiết yếu gồm trả nợ',
      splatky: 'Trả nợ',
      stranou: 'Để dành',
      styl: 'Lối sống',
      volne: 'Còn dư',
      vydaje: 'Chi tiêu (chưa chia)',
      zVkladu: 'Từ khoản góp và tiền dư',
      zestylu: 'Từ chi tiêu lối sống',
    },
    doplnPrijmy: 'Hãy nhập thu nhập',
    nazev: 'Thu nhập · 50/30/20',
    prah: {
      ideal: '{pct}% lý tưởng',
      minimum: '{pct}% tối thiểu',
      rychle: '{pct}% nhanh',
    },
    prahPrijem: 'thu nhập',
    profil: {
      dynamicky: 'năng động',
      konzervativni: 'thận trọng',
      vyvazeny: 'cân bằng',
    },
    uvozovky: '“{text}”',
  },
  /* BLOK:kino503020 END */
  /* BLOK:portfolioKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  portfolioKarta: {
    investice: 'Đầu tư',
    odhadBj: '* ước tính từ BJ đã ký',
    penze: 'Hưu trí',
    pojisteni: 'Bảo hiểm',
    proviceYtd: 'Hoa hồng từ đầu năm',
    rezerva: 'Quỹ dự phòng',
    rocniVynos: 'Lợi suất hằng năm',
    titul: 'Danh mục của khách hàng',
    zadnyProdukt: 'Chưa có sản phẩm đầu tư',
  },
  /* BLOK:portfolioKarta END */
  /* BLOK:kinoZdroje START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZdroje: {
    a1: {
      ariaFin: 'Tài sản tài chính {castka}.',
      ariaKapsa: '{nazev} {castka}, {kdy}.',
      ariaNefin: '{nazev} {castka}: không tính vào mục tiêu.',
      ariaPrazdna: '{nazev}: chưa nhập gì.',
      doplnte: 'Hãy nhập tài sản',
      kicker: 'Tiền của bạn',
      nefinPopis: 'không tính vào mục tiêu',
      nemovitost: 'Bất động sản',
      nevime: 'Chưa biết tiền đang nằm ở đâu.',
      podil: '{pct}% nằm {misto}.',
      polovina: 'Một nửa nằm {misto}.',
      radek2: 'Không phải khoản nào cũng rút nhanh như nhau.',
      tahak: '“Trước khi tiết kiệm tiền mới, hãy xem bạn đã có gì. Thường nhiều hơn mọi người nghĩ.”',
      titulek: 'Số tiền bạn đã có',
      velkePopis: 'tài sản tài chính',
      vse: 'Tất cả nằm {misto}.',
    },
    a2: {
      ariaZisk: 'Sau 10 năm, {castka} trong tài khoản mua được bằng {za} hôm nay; lãi suất cao hơn lạm phát {inflace}.',
      ariaZtrata: 'Sau 10 năm, {castka} trong tài khoản chỉ mua được bằng {za} hôm nay, với lạm phát {inflace} mỗi năm.',
      bezUroku: 'Tài khoản không có lãi.',
      dnes: 'hôm nay {castka}',
      kicker: 'Lạm phát',
      pilulkyAria: 'Mức lạm phát nào',
      radekZisk: 'Sau 10 năm, {castka} mua được bằng {za} hôm nay.',
      radekZtrata: 'Sau 10 năm, {castka} chỉ mua được bằng {za} hôm nay.',
      tahak: '“Lạm phát là kẻ trộm thầm lặng. Con số trên sao kê không mất, nhưng mua được ngày càng ít.”',
      titulek: 'Tiền trong tài khoản âm thầm mất giá',
      titulekStaci: 'Lãi suất hiện vẫn theo kịp lạm phát',
      urok: 'Lãi suất tài khoản {urok}.',
      urokNezadan: 'Chưa nhập lãi suất tài khoản, tính là 0%.',
      velkePopis: 'sức mua sau 10 năm · lạm phát {inflace}',
      volba: {
        cil: {
          cnb: 'mục tiêu CNB',
          ecb: 'mục tiêu ECB',
        },
        historie: 'như {od}–{do}',
        plan: 'giả định của kế hoạch',
      },
      zdrojCZK: 'Kế hoạch giả định {plan}. Cục Thống kê Séc: {rok} {posledni}, trung bình 2016–2025 {prumer}. Mục tiêu CNB 2%.',
      zdrojEUR: 'Kế hoạch giả định {plan}. Mục tiêu ECB 2%.',
      zdrojJiny: 'Kế hoạch giả định lạm phát {plan}.',
    },
    a3: {
      ariaNic: 'Chưa có gì sinh lời.',
      ariaPodRezervou: '{rezerva}: trong tài khoản {ucet}, thiếu {chybi}.',
      ariaSrovnani: 'Triển vọng {roky}: nếu {x} để trong tài khoản, sẽ mua được bằng {ucet} hôm nay. Nếu sinh lời theo hồ sơ kế hoạch, theo mô hình là {model}, kịch bản xấu {horsi}, tốt {lepsi}. Lợi nhuận không được đảm bảo.',
      chybi: 'thiếu {castka}',
      dlouhyCil: 'mục tiêu dài hạn (hưu trí)',
      jenNad: 'Chỉ phần vượt dự phòng',
      jezdecAria: 'Bao nhiêu tiền trong tài khoản có thể sinh lời',
      kicker: 'Nếu như',
      model: 'Mô hình: {roky} như mục tiêu {cil}, hồ sơ {profil}, theo giá trị tiền hôm nay, chưa gồm phí và thuế. Lợi nhuận không được đảm bảo, ngoặc trên thanh = kịch bản xấu và tốt của kế hoạch. Tài khoản: lãi {urok}, lạm phát {inflace}.',
      naUctu: 'trong tài khoản {castka}',
      nadRezervu: 'vượt dự phòng {castka}',
      nic: 'Không',
      pasmo: 'kịch bản xấu {horsi} · tốt {lepsi}',
      pracuje: 'Sinh lời',
      pracujeModel: 'Sinh lời · mô hình',
      radekJenNad: 'Phần vượt chỉ có {castka}.',
      radekKlesla: 'Quỹ dự phòng sẽ giảm còn {castka}.',
      radekNaUctu: 'Trong tài khoản có {castka}.',
      radekNad: 'Phần vượt là {castka}.',
      radekRezerva: 'Quỹ dự phòng là {castka}.',
      radekRezervaNa: 'Quỹ dự phòng {n} tháng là {castka}.',
      radekRezervaZustava: 'Quỹ dự phòng {castka} vẫn nằm trong tài khoản.',
      rezerva: 'dự phòng · {castka}',
      rezervaNa: 'dự phòng {n} tháng · {castka}',
      sniInflace: 'bị lạm phát ăn mòn',
      tahak: '“Quỹ dự phòng để nguyên trong tài khoản, không động tới. Phần vượt có thể sinh lời.”',
      titulek: 'Giữ quỹ dự phòng, phần còn lại có thể sinh lời',
      titulekPodRezervou: 'Trước hết đủ quỹ dự phòng',
      titulekRezerva: 'Một phần quỹ dự phòng sẽ bị dùng',
      urokNad: 'từ lãi vượt lạm phát',
      valuetextRezerva: '{x}, trong đó {rezerva} từ quỹ dự phòng',
      varovani: '{castka} sẽ lấy từ quỹ dự phòng. Khi đó quỹ sẽ không còn đủ.',
      velkeChybiRezerva: 'còn thiếu cho quỹ dự phòng',
      velkeNic: 'chưa có gì sinh lời',
      velkePasmo: 'kịch bản xấu {horsi} · tốt {lepsi}',
      velkePopis: 'thêm {roky} · mô hình, lợi nhuận không được đảm bảo',
      velkeZRezervy: 'sẽ thiếu trong quỹ dự phòng',
      vlozenoVynos: 'góp {x} + lợi nhuận mô hình {vynos}',
      zUctu: 'từ tài khoản',
      zustaneNaUctu: 'Để trong tài khoản',
    },
    a4: {
      ariaBez: 'Không có số tiền bạn đang có: {popis}.',
      ariaS: 'Có số tiền bạn đang có: {popis}.',
      bezNich: 'Không có',
      cil: 'Mục tiêu',
      dnesPct: 'hôm nay {pct}%',
      hotovaDoMes: 'đủ trong {n} tháng',
      hotovaHned: 'đủ ngay',
      hotovaZaMes: 'đủ sau {n} tháng',
      kTerminu: 'đúng hạn',
      kTerminuPct: 'đến hạn {pct}%',
      kicker: 'Mục tiêu của bạn',
      mesicne: '{castka}/tháng',
      nepriradeno: {
        investice: 'Đầu tư',
        stavebko: 'Phần còn lại của tiết kiệm nhà ở',
        ucty: 'Phần còn lại trong tài khoản',
      },
      nepriradenoPopis: 'kế hoạch chưa phân bổ cho mục tiêu nào',
      plusOdkladani: '+ để dành',
      plusVynos: '+ lợi nhuận (mô hình)',
      poMesicne: '{castka} mỗi tháng',
      pozn: 'Cùng cách tính với Đề xuất giải pháp, theo giá trị tiền hôm nay. Lợi nhuận là mô hình, không phải lời hứa.',
      radekBez: '{cil} đến hạn chỉ đạt {bez}% thay vì {s}%.',
      radekS: '{cil} đến hạn đạt {s}% thay vì {bez}%.',
      radekStejne: 'Không có số tiền đó, kế hoạch vẫn như vậy.',
      renta: 'Hưu trí',
      rezerva: 'Quỹ dự phòng',
      sPenezi: 'Có số tiền bạn đang có',
      segmentAria: 'So sánh',
      tahak: '“Một nguồn khác để đạt mục tiêu là số tiền bạn đã có.”',
      titulek: 'Thêm nguồn cho mục tiêu của bạn',
      vVeku: 'lúc {vek} tuổi',
      vVekuPoStartu: 'lúc {vek} tuổi · sau khi bắt đầu hưu',
      velkeNic: 'Chưa có gì',
      velkeNicPopis: 'không có gì từ tài sản đến kịp hạn mục tiêu',
      velkePopis: 'kế hoạch phân bổ cho mục tiêu trước hạn',
      vetaRezervaBez: 'Nếu không có, quỹ dự phòng phải tiết kiệm {n} tháng.',
      vetaRezervaDoMes: 'Quỹ dự phòng đủ trong {n} tháng.',
      vetaRezervaHned: 'Quỹ dự phòng đủ ngay.',
      vetaRezervaPct: 'Quỹ dự phòng hôm nay đạt {pct}%.',
      vetaRezervaZa: 'Quỹ dự phòng sẽ đủ sau {n} tháng.',
      vlastniZdroje: 'vốn tự có {castka}',
      zaMes: 'sau {n} tháng',
      zatimNic: 'chưa có gì',
      zdrojPenzijko: 'tiết kiệm hưu trí',
    },
    kapsa: {
      investice: 'Đầu tư',
      nezapsano: 'chưa nhập gì',
      penzijko: 'Tiết kiệm hưu trí',
      stavebko: 'Tiết kiệm nhà ở',
      ucty: {
        bezny: 'Tài khoản thanh toán',
        hotovost: 'Tiền mặt',
        sporici: 'Tài khoản tiết kiệm',
        ucty: 'Tài khoản',
      },
    },
    kdy: {
      castHned: 'một phần ngay',
      hned: 'ngay',
      investice: 'sau vài ngày',
      penzijko: 'lúc {vek} tuổi',
      stavebko: 'trong {n} tháng',
    },
    misto: {
      investice: 'trong đầu tư',
      penzijko: 'trong tiết kiệm hưu trí',
      stavebko: 'trong tiết kiệm nhà ở',
      ucty: {
        bezny: 'trong tài khoản thanh toán',
        hotovost: 'bằng tiền mặt',
        sporici: 'trong tài khoản tiết kiệm',
        ucty: 'trong các tài khoản',
      },
    },
    nazev: 'Nguồn lực',
    osa: {
      dnes: 'hôm nay',
      zaRokyFew: 'sau {n} năm',
      zaRokyMany: 'sau {n} năm',
      zaRokyOne: 'sau {n} năm',
    },
    prezTlacitko: 'Bắt đầu phim: Số tiền bạn đã có',
    rokyFew: '{n} năm',
    rokyMany: '{n} năm',
    rokyOne: '{n} năm',
    tlacitko: 'Phim Nguồn lực',
    tlacitkoTitle: 'Phát phim: Số tiền bạn đã có',
    zaRokyFew: 'sau {n} năm',
    zaRokyMany: 'sau {n} năm',
    zaRokyOne: 'sau {n} năm',
  },
  /* BLOK:kinoZdroje END */
  /* BLOK:predAPo START — generuje scratchpad/slovnik.py, ručně needitovat */
  predAPo: {
    cena: 'Phí',
    hlavicka: {
      dnes: 'Hiện tại',
      kryti: 'Bảo vệ ×',
      nove: 'Mới',
    },
    infoDalsiRizika: 'Số tiền bảo hiểm của mọi rủi ro (mất sức lao động, tử vong, nghỉ ốm, bệnh hiểm nghèo, thương tật vĩnh viễn, trợ cấp ngày) nhập theo từng người trong phân tích: Hợp đồng bảo hiểm → Rủi ro trong hợp đồng.',
    infoNema: '„không có“ = không hợp đồng nào đã ghi bảo hiểm rủi ro này. „chưa nhập“ = có hợp đồng nhưng thiếu số tiền bảo hiểm.',
    infoRozsah: 'Với hộ gia đình chưa chọn người được bảo hiểm, chúng tôi không hiển thị hệ số bảo vệ — sẽ so hợp đồng của một người với bảo vệ mới của cả hai.',
    mene: 'ít hơn',
    nema: 'không có',
    spolecna: 'gồm hợp đồng chung',
    spolecnaU: 'hợp đồng chung · phí tính ở {kdo}',
    stitekNove: 'mới',
    ztrata: 'mất',
  },
  /* BLOK:predAPo END */
  /* BLOK:podkladyKlienta START — generuje scratchpad/slovnik.py, ručně needitovat */
  podkladyKlienta: {
    dny: {
      '0': 'vào Chủ nhật',
      '1': 'vào Thứ Hai',
      '2': 'vào Thứ Ba',
      '3': 'vào Thứ Tư',
      '4': 'vào Thứ Năm',
      '5': 'vào Thứ Sáu',
      '6': 'vào Thứ Bảy',
    },
    dok: {
      leasing: 'hợp đồng thuê tài chính',
      naSchuzce: 'chúng ta sẽ cùng điền tại buổi gặp',
      pojistna: 'hợp đồng bảo hiểm',
      portfolio: 'sao kê danh mục đầu tư',
      smlouvaVypis: 'hợp đồng và sao kê gần nhất',
      triMesice: 'trong 3 tháng gần nhất',
      uverova: 'hợp đồng vay và sao kê dư nợ',
      vypis: 'sao kê gần nhất',
      vypisUctu: 'sao kê tài khoản',
      zustatek: 'số dư hiện tại',
    },
    nazev: {
      akcie: 'Cổ phiếu',
      cennosti: 'Bảo hiểm đồ quý giá',
      cizimena: 'Tài khoản ngoại tệ',
      danove: 'Tờ khai thuế năm {rok}',
      dip: 'Sản phẩm đầu tư dài hạn (DIP)',
      dluhopisy: 'Trái phiếu',
      dps: 'Tiết kiệm hưu trí (DPS)',
      fondy: 'Quỹ / ETF',
      investice: 'Đầu tư',
      krypto: 'Tiền mã hóa',
      kzp: 'Bảo hiểm nhân thọ tích lũy',
      pojistka: 'Hợp đồng bảo hiểm',
      pripojisteni: 'Bảo hiểm hưu trí bổ sung',
      sporici: 'Tài khoản tiết kiệm',
      stavebko: 'Tiết kiệm nhà ở',
      terminovany: 'Tiền gửi có kỳ hạn',
      uver: 'Khoản vay',
      vypisy: 'Sao kê tài khoản thanh toán',
    },
    platno: {
      emailem: 'Tôi cũng sẽ gửi danh sách qua e-mail',
      idealne: 'Tốt nhất là trước buổi gặp',
      kicker: 'Kết thúc',
      papiry: 'Anh/chị cũng có thể mang giấy tờ đến buổi gặp',
      pod: 'Chỉ cần bản scan hoặc ảnh chụp bằng điện thoại.',
      posleteNa: 'Gửi về',
      prazdne: 'Chưa có gì — chúng ta sẽ bổ sung ở buổi gặp sau.',
      titul: 'Những gì tôi cần từ anh/chị',
      zpravou: 'Tôi cũng sẽ gửi danh sách qua tin nhắn',
    },
    pocetSmluvFew: '{n} hợp đồng',
    pocetSmluvMany: '{n} hợp đồng',
    pocetSmluvOne: '{n} hợp đồng',
    ui: {
      bezEmailu: '{kdo} chưa có e-mail.',
      bezKontaktu: 'không có liên hệ',
      bezTelefonu: '{kdo} chưa có số điện thoại.',
      chybaRada: 'Hãy thử lại hoặc mở tin nhắn trong ứng dụng thư của bạn.',
      chybaTitul: 'Gửi không thành công — chưa có gì được gửi',
      chybiMujEmail: 'Tin nhắn thiếu e-mail của bạn, khách sẽ không biết gửi bản scan về đâu.',
      cisloVarovani: 'có vẻ là số hợp đồng — tốt hơn đừng ghi vào tin nhắn',
      detailEmail: 'Đã gửi {kdy} qua e-mail · {komu}',
      detailMailto: 'Đã mở trong ứng dụng thư {kdy} · {komu} · hãy gửi từ đó',
      detailWa: 'Đã mở trong WhatsApp {kdy} · {komu} · hãy gửi từ đó',
      dokumentFew: 'tài liệu',
      dokumentMany: 'tài liệu',
      dokumentOne: 'tài liệu',
      doplnitEmail: 'Thêm e-mail ở phần Giới thiệu',
      doplnitNastaveni: 'Thêm e-mail công khai trong Cài đặt',
      doplnitTelefon: 'Thêm số điện thoại ở phần Giới thiệu',
      emailUctu: 'Tin nhắn dùng e-mail của tài khoản đã kết nối',
      instituceChybi: 'chưa điền tổ chức',
      jazyk: 'Ngôn ngữ tin nhắn',
      jen: 'chỉ {kanal}',
      kanalEmail: 'e-mail',
      kanalEmailSpatny: 'e-mail sai định dạng',
      kanalTelefon: 'điện thoại',
      kdyCas: '{den} lúc {cas}',
      klient: 'Khách hàng',
      komu: 'Gửi cho',
      kopirovaniChyba: 'Không sao chép được — hãy chọn văn bản và sao chép thủ công.',
      kopirovat: 'Sao chép',
      neodeslano: 'Chưa gửi',
      nicVybrano: 'Chưa chọn gì — tin nhắn sẽ không được gửi',
      odebrat: 'Xóa: {nazev}',
      odesilam: 'Đang gửi…',
      odeslanoEmail: 'Đã gửi {den} qua e-mail',
      odeslanoToast: 'Đã gửi e-mail cho khách.',
      odeslatChyba: 'Gửi thất bại.',
      opravitEmail: 'Sửa e-mail ở phần Giới thiệu',
      otevritPostu: 'Mở trong ứng dụng thư',
      plusDotaznik: '+ bảng câu hỏi tại buổi gặp',
      pocetPred: 'Tin nhắn sẽ gồm',
      pod: 'Lập từ nguồn lực, nghĩa vụ và tài sản trong phân tích',
      podleMajetku: 'theo tài sản: {nazev}',
      polozkaMajetku: 'mục tài sản',
      poslatEmail: 'Gửi qua e-mail',
      poslatWa: 'Gửi qua WhatsApp',
      pozdeji: 'sẽ gửi sau',
      poznGmail: 'Sẽ gửi từ Gmail của bạn {email}',
      poznGmailBez: 'Sẽ gửi từ Gmail của bạn',
      poznMailto: 'Mở ứng dụng thư của bạn — gửi từ đó',
      poznSmtp: 'Sẽ gửi từ e-mail công ty của bạn {email}',
      poznSmtpBez: 'Sẽ gửi từ e-mail công ty của bạn',
      poznWa: 'Mở WhatsApp với nội dung có sẵn — gửi từ đó',
      poznZjistuji: 'Đang kiểm tra cách gửi e-mail…',
      predanoWa: 'Đã chuyển sang WhatsApp {den}',
      predmet: 'Tiêu đề',
      pridat: 'Thêm',
      pridatLabel: 'Mục tự thêm',
      pridatPh: 'vd. hợp đồng mua căn hộ',
      pripravenoEmail: 'Đã soạn trong e-mail {den}',
      rozbalit: 'Xem toàn bộ tin nhắn',
      sbalit: 'Thu gọn tin nhắn',
      skupina: {
        dalsi: 'Khác',
        pojisteni: 'Bảo hiểm',
        sporeni: 'Tiết kiệm và đầu tư',
        uvery: 'Khoản vay',
      },
      spatnyEmail: 'E-mail của {kdo} sai định dạng ({email}).',
      terminAnalyza: 'Ngày ghi trong phân tích: {kdy}',
      terminDiar: 'Lịch hẹn từ nhật ký: {kdy}',
      terminProbehl: 'Ngày trong phân tích ({kdy}) đã qua — không có trong tin nhắn',
      terminZadny: 'Nhật ký chưa có buổi gặp tiếp theo — tin nhắn không có ngày hẹn',
      titul: 'Khách cần gửi gì',
      vlastni: 'mục tự thêm',
      waBezEmailu: 'Không có e-mail của bạn, khách sẽ gửi bản scan qua WhatsApp.',
      zkopirovano: 'Đã sao chép nội dung tin nhắn.',
      zkusitZnovu: 'Thử lại',
      zmena: 'Tin nhắn đã thay đổi kể từ khi gửi — hãy gửi lại.',
      znovuEmail: 'Gửi lại qua e-mail',
      znovuWa: 'Gửi lại qua WhatsApp',
      zpravaPod: 'Khách sẽ gửi bản scan về e-mail của bạn',
      zpravaTitul: 'Tin nhắn cho khách',
    },
    viceFew: '{n} hợp đồng: {dok} cho mỗi hợp đồng',
    viceMany: '{n} hợp đồng: {dok} cho mỗi hợp đồng',
    viceOne: '{n} hợp đồng: {dok}',
    zprava: {
      dotaznik: 'Bảng câu hỏi đầu tư chúng ta sẽ cùng điền tại buổi gặp.',
      fotka: 'Chỉ cần chụp bằng điện thoại, miễn là đọc rõ.',
      kamEmail: 'Anh/chị vui lòng gửi về e-mail của tôi {email} khi có thời gian.',
      kamEmailTermin: 'Anh/chị vui lòng gửi về e-mail của tôi {email}, tốt nhất là trước buổi gặp tiếp theo {den}',
      kamOdpoved: 'Anh/chị vui lòng gửi bằng cách trả lời e-mail này khi có thời gian.',
      kamOdpovedTermin: 'Anh/chị vui lòng gửi bằng cách trả lời e-mail này, tốt nhất là trước buổi gặp tiếp theo {den}',
      nevadi: 'Nếu không tìm thấy giấy tờ nào cũng không sao — chúng ta sẽ cùng xem lại. Anh/chị cũng có thể mang giấy tờ đến buổi gặp.',
      pozdrav: 'Kính chào anh/chị,',
      pozdravJmeno: 'Kính chào {osloveni},',
      predmet: 'Giấy tờ để chuẩn bị đề xuất',
      predmetTermin: 'Giấy tờ cho buổi gặp tiếp theo',
      uvod: 'cảm ơn anh/chị về buổi gặp của chúng ta. Để chuẩn bị đề xuất, anh/chị vui lòng gửi cho tôi bản scan hoặc ảnh chụp các giấy tờ sau:',
    },
  },
  /* BLOK:podkladyKlienta END */
  /* BLOK:vykonTymu START — generuje scratchpad/slovnik.py, ručně needitovat */
  vykonTymu: {
    aktivita: {
      aria: '{metrika} trong {tydnu} tuần qua: đã đánh dấu xong tổng {soucet}, mục tiêu tuần {cil}, dưới mục tiêu {pod}/{ukoncenych} tuần đã kết thúc.',
      ariaBezCile: '{metrika} trong {tydnu} tuần qua: đã đánh dấu xong tổng {soucet}, chưa đặt mục tiêu tuần.',
      ariaCast: '{metrika} trong {tydnu} tuần qua: đã đánh dấu xong tổng {soucet}. Chỉ {s}/{celkem} người có mục tiêu tuần, nên không đánh giá cả nhóm.',
      ariaNovyCil: '{metrika} trong {tydnu} tuần qua: đã đánh dấu xong tổng {soucet}, mục tiêu tuần {cil}, chưa có tuần nào kết thúc với mục tiêu.',
      cil: 'mục tiêu {n}',
      cilCast: 'chỉ {s}/{celkem} người có mục tiêu, nên không vẽ mục tiêu nhóm',
      cilDrive: 'trước đây mục tiêu {n}',
      hovory: 'Cuộc gọi',
      nadpis: 'Hoạt động theo tuần',
      neodskrtnuto: 'Chưa đánh dấu xong trong nhật ký, không tính vào cột và mục tiêu: {n}',
      prazdno: 'Trong {tydnu} tuần qua chưa có cuộc gọi hay cuộc hẹn nào với khách hàng được đánh dấu xong.',
      probiha: 'đang diễn ra',
      radekZalohy: '{datum}: {n}',
      schuzky: 'Cuộc hẹn',
      typNeznamy: 'Không có loại, không tính: {n}',
    },
    bezJmena: 'Chưa có tên',
    cil: {
      chyba: 'Không lưu được mục tiêu.',
      hodnoty: 'Cuộc gọi mỗi tuần: {hovory} · cuộc hẹn mỗi tuần: {schuzky}',
      hovory: 'Cuộc gọi mỗi tuần',
      jenPrimy: 'Mục tiêu do quản lý trực tiếp đặt.',
      nadpis: 'Mục tiêu hoạt động hằng tuần',
      nastavil: 'Do {jmeno} đặt, {datum}',
      neplatny: 'Nhập số nguyên từ 0 đến 200.',
      prazdne: 'Để trống nghĩa là không có mục tiêu.',
      schuzky: 'Cuộc hẹn mỗi tuần',
      ukladam: 'Đang lưu…',
      ulozeno: 'Đã lưu mục tiêu tuần.',
      ulozit: 'Lưu mục tiêu',
      zpet: 'Quay lại',
      zrusit: 'Bỏ mục tiêu',
      zrusitPotvrdit: 'Thật sự bỏ mục tiêu tuần?',
    },
    detail: {
      chyba: 'Không tải được hiệu suất tư vấn viên.',
      hlubsi: 'Khách hàng và giao dịch do quản lý trực tiếp của người này mở.',
      koucink: 'Huấn luyện',
      nacitam: 'Đang tải hiệu suất tư vấn viên…',
      nadpis: 'Hiệu suất: {jmeno}',
      pipelineObchody: 'Khách hàng và giao dịch',
      zavrit: 'Đóng',
    },
    drobecky: {
      aria: 'Các cấp trong nhóm',
      ja: 'Tôi',
      zpet: 'Quay lại nhóm của tôi',
    },
    faze: {
      a1: 'Giới thiệu',
      a2: 'Phân tích',
      p1: 'Kế hoạch tài chính',
      p2: 'Trình bày',
      volani: 'Gọi điện',
    },
    informace: {
      odpojeni: 'Chỉ quản lý mới có thể ngắt kết nối bạn — họ xóa bạn trong Nhóm của tôi. Bạn không thể tự ngắt kết nối.',
      potvrzeno: 'Quản lý của bạn và các quản lý cấp trên thấy khách hàng, pipeline, mục tiêu và hiệu suất của bạn (cuộc gọi và cuộc hẹn với khách hàng theo tuần). Không bao giờ thấy các mục riêng tư trong nhật ký; toàn bộ nhật ký chỉ khi bạn đồng ý. Quản lý có thể đặt cho bạn mục tiêu cuộc gọi và cuộc hẹn hằng tuần.',
      pozvat: 'Nhập email của họ. Một lời mời sẽ được tạo và họ phải tự chấp nhận trong Cài đặt — chỉ khi đó bạn mới thấy khách hàng, giao dịch, mục tiêu và hiệu suất của họ (cuộc gọi và cuộc hẹn với khách hàng theo tuần). Toàn bộ nhật ký chỉ khi họ đồng ý, không bao giờ thấy mục riêng tư. Chúng tôi không gửi email; hãy tự gửi đường link cho họ.',
      prijeti: 'Khi chấp nhận, quản lý của bạn và các quản lý cấp trên sẽ thấy khách hàng, pipeline, mục tiêu và hiệu suất của bạn: mỗi tuần bạn có bao nhiêu cuộc gọi và cuộc hẹn với khách hàng, và lần cuối bạn liên hệ với khách hàng là khi nào. Không bao giờ thấy các mục riêng tư trong nhật ký; toàn bộ nhật ký chỉ khi bạn đồng ý.',
      rozumim: 'Tôi đã hiểu',
      vzdy: 'Dù bạn chọn gì, quản lý vẫn thấy hiệu suất: mỗi tuần bạn có bao nhiêu cuộc gọi và cuộc hẹn với khách hàng, và lần cuối bạn liên hệ với khách hàng là khi nào. Không có tiêu đề, thời gian hay địa điểm. Không bao giờ thấy mục riêng tư.',
      zvonecek: 'Quản lý của bạn và các quản lý cấp trên thấy khách hàng, pipeline, mục tiêu và hiệu suất của bạn: mỗi tuần bạn có bao nhiêu cuộc gọi và cuộc hẹn với khách hàng, và lần cuối bạn liên hệ với khách hàng là khi nào. Không bao giờ thấy các mục riêng tư trong nhật ký; toàn bộ nhật ký chỉ khi bạn đồng ý.',
      zvonecekNadpis: 'Quản lý của bạn thấy gì',
    },
    kontrola: {
      dniBezFew: '{n} ngày không có hoạt động được ghi',
      dniBezMany: '{n} ngày không có hoạt động được ghi',
      dniBezOne: '{n} ngày không có hoạt động được ghi',
      krokAno: 'Đã lên lịch',
      krokNe: 'Chưa có',
      krokPoTerminu: 'Quá hạn',
      mene: 'Thu gọn',
      nadpis: 'Cần kiểm tra',
      nicZaOkno: 'Không có gì trong {dni} ngày qua',
      nicZapsano: 'Chưa ghi gì',
      oriznuto: 'Đang hiện {zobrazeno}/{celkem}.',
      popis: 'Khách hàng đang theo không có hoạt động nào được ghi trong {prah} ngày trở lên.',
      prazdno: 'Không ai phải chờ quá {prah} ngày.',
      sloupecFaze: 'Giai đoạn',
      sloupecKlient: 'Khách hàng',
      sloupecKrok: 'Bước tiếp theo',
      sloupecPoradce: 'Tư vấn viên',
      sloupecPosledni: 'Hoạt động ghi gần nhất',
      sloupecVeFazi: 'Trong giai đoạn',
      veFaziFew: '{n} ngày',
      veFaziMany: '{n} ngày',
      veFaziNevime: 'theo dõi từ {datum}',
      veFaziOne: '{n} ngày',
      vice: 'Hiện tất cả {n}',
    },
    kpi: {
      bezKroku: 'Chưa có bước tiếp theo',
      bezKrokuPod: 'khách hàng đang theo chưa có hoạt động nào được lên lịch',
      pipelineBj: 'BJ trong pipeline',
      pipelineBjPod: 'Từ Giới thiệu đến Trình bày',
      schuzkyTyden: 'Cuộc hẹn tuần này',
      schuzkyTydenPod: 'với khách hàng, đã đánh dấu xong trong nhật ký',
      vAktivite: 'Khách hàng đang theo',
      vAktivitePod: 'Từ Gọi điện đến Trình bày',
    },
    nadpis: 'Hiệu suất nhóm',
    pipeline: {
      aria: 'Pipeline theo tư vấn viên: {jmeno} có nhiều khách hàng đang theo nhất ({pocet}).',
      detail: 'Chi tiết',
      klientuFew: '{n} khách hàng',
      klientuMany: '{n} khách hàng',
      klientuOne: '{n} khách hàng',
      nadpis: 'Pipeline theo từng tư vấn viên',
      prazdny: 'Không có khách hàng đang theo',
      radekAria: '{jmeno}: {pocet} khách hàng đang theo, pipeline {bj} BJ. {rozpad}',
      segment: '{faze} {pocet}',
      tym: 'Nhóm · {pocet}',
    },
    poznamka: {
      kratce: 'Chỉ tính hoạt động công việc đã ghi.',
      cyklus: 'Trong nhóm có vòng quan hệ khép kín, mỗi người chỉ hiển thị một lần.',
      faze: 'Từ {datum}, chúng tôi theo dõi việc chuyển giai đoạn.',
      hloubka: 'Nhóm có hơn 5 cấp, các cấp sâu hơn không được hiển thị.',
      oriznuto: 'Dữ liệu nhiều hơn mức có thể tính một lần, các số chỉ là ước tính tối thiểu.',
      patra: 'Các số ở trên tính cho cả nhóm, gồm cả các cấp bên dưới; mỗi dòng tư vấn viên chỉ tính khách hàng của chính họ.',
      zdroj: 'Chúng tôi chỉ tính các hoạt động công việc được ghi cho khách hàng trong nhật ký và trên dòng thời gian của khách hàng. Cuộc gọi, cuộc hẹn và mức hoàn thành mục tiêu chỉ tính khi đã đánh dấu xong. Không bao giờ tính mục riêng tư. Những gì tư vấn viên chưa ghi thì chúng tôi không thấy, và điều đó không có nghĩa là họ không làm việc.',
    },
    stav: {
      bezCile: 'Chưa đặt mục tiêu',
      chyba: 'Thấp hơn nhiều so với mục tiêu',
      minulyChyba: 'Tuần trước: thấp hơn nhiều so với mục tiêu',
      minulyOk: 'Tuần trước: đạt mục tiêu',
      minulyPozor: 'Tuần trước: dưới mục tiêu',
      ok: 'Đạt mục tiêu tuần',
      pozor: 'Dưới mục tiêu',
    },
    stavy: {
      bezPristupu: 'Bạn không còn quyền xem nhóm này.',
      chyba: 'Không tải được hiệu suất nhóm.',
      nacitam: 'Đang tải hiệu suất nhóm…',
      nedostupne: 'Hiệu suất nhóm sẽ bật sau khi cập nhật máy chủ.',
      prazdnyTym: 'Hiện chưa có ai trực tiếp dưới bạn — bảng xếp hạng bên dưới hiển thị toàn bộ mạng lưới.',
      vrcholy: 'Các nhóm trong hệ thống',
      vrcholyPopis: 'Chọn nhóm bạn muốn xem.',
      znovu: 'Thử lại',
    },
    zebricek: {
      jenObsazenost: 'Lịch chỉ chia sẻ thời gian bận — không thể biết các cuộc gặp với khách hàng từ đó.',
    },
  },
  /* BLOK:vykonTymu END */
  /* BLOK:pruvodce START — generuje scratchpad/slovnik.py, ručně needitovat */
  pruvodce: {
    akce: {
      domluvitTermin: 'Hẹn buổi gặp tiếp',
      jeToSpravne: 'Đúng rồi',
      kinoRizik: 'Chiếu phim về rủi ro',
      nemaMajetek: 'Không có tài sản',
      nemaZavazky: 'Không có khoản vay hay bảo hiểm',
      opraveno: 'Đã sửa thành {hodnota}',
      opravit: 'Sửa thành {hodnota}',
      oznaceno: 'Đã đánh dấu là đúng',
      prejit: 'Đi tới',
      prejitNezbytne: 'Đi tới chi tiêu thiết yếu',
      prejitObvykle: 'Đi tới chi tiêu thường',
      prejitPrijmy: 'Đi tới thu nhập',
      prejitVydaje: 'Đi tới chi tiêu',
      prohodit: 'Đổi chỗ',
      prohozeno: 'Đã đổi chỗ',
      vratit: 'Hoàn tác',
    },
    brana: {
      dalsi: 'và {n} mục khác',
      duvod: {
        dalsiSchuzka: 'Bổ sung ở buổi gặp sau',
        jiny: 'Lý do khác',
        nechce: 'Để trống theo mong muốn của khách',
        podklady: 'Khách sẽ gửi giấy tờ',
      },
      min: {
        cil: 'Mục tiêu có số tiền và thời hạn',
        osoby: 'Người và ngày sinh',
        prijmy: 'Thu nhập',
        vydaje: 'Chi tiêu',
      },
      minimum: 'Mức tối thiểu bắt buộc',
      minimumSplneno: 'Đã đủ mức tối thiểu',
      nadpis: 'Sẵn sàng lập kế hoạch?',
      planOrientacni: 'Kế hoạch chỉ mang tính tham khảo — còn thiếu:',
      podezrele: 'Số liệu đáng ngờ',
      pokracovat: 'Tiếp tục tới kế hoạch',
      poradiNezapsano: 'Khách đồng ý thứ tự mục tiêu: chưa ghi',
      poradiZapsano: 'Khách đồng ý thứ tự mục tiêu: đã ghi {datum}',
      pozdeji: 'Còn thiếu nhưng vẫn tiếp tục được',
      poznamka: 'Ghi chú (không bắt buộc)',
      proc: 'Vì sao anh chị tiếp tục? (không bắt buộc)',
      slozka: 'Cho hồ sơ khách hàng: {n}',
      zaznamy: 'Ghi chép buổi gặp',
      zbyvaFew: 'Còn thiếu {n} mục — kế hoạch vẫn được tính, nhưng các con số chỉ mang tính tham khảo. Hãy bổ sung khi có thể.',
      zbyvaMany: 'Còn thiếu {n} mục — kế hoạch vẫn được tính, nhưng các con số chỉ mang tính tham khảo. Hãy bổ sung khi có thể.',
      zbyvaOne: 'Còn thiếu {n} mục — kế hoạch vẫn được tính, nhưng các con số chỉ mang tính tham khảo. Hãy bổ sung khi có thể.',
      zbyvaSeznamFew: 'Còn {n} mục: {seznam}',
      zbyvaSeznamMany: 'Còn {n} mục: {seznam}',
      zbyvaSeznamOne: 'Còn {n} mục: {seznam}',
      zpet: 'Quay lại phân tích',
    },
    chybi: {
      castka: 'số tiền',
      cil: '{nazev}: {co}',
      cilBezNazvu: 'Mục tiêu chưa đặt tên',
      diteKCili: 'Mục tiêu cho con nhưng chưa có con',
      dodaPozdeji: '{smlouva}: khách sẽ gửi sau',
      doplnRizika: 'Bổ sung rủi ro: {smlouva}',
      jmenoK1: 'Họ tên khách hàng',
      komuPatri: 'Rủi ro của ai: {smlouva}',
      narozeniDite: 'Ngày sinh của con {jmeno}',
      narozeniK1: 'Ngày sinh khách hàng',
      narozeniPartner: 'Ngày sinh của vợ/chồng — thiếu thì không tính được bảo hiểm cho vợ/chồng',
      nezbytne: 'Chi tiêu thiết yếu',
      prazdneDite: 'Dòng con để trống',
      prijemBezOsoby: 'Thu nhập người thứ 2 nhưng chưa có người',
      smlouva: 'Hợp đồng',
      termin: 'thời hạn',
      titul: 'Còn thiếu:',
    },
    jednotka: {
      letFew: '{n} năm',
      letMany: '{n} năm',
      letOne: '{n} năm',
    },
    kontrola: {
      V1: {
        hlaska: 'Chi tiêu {V} cao hơn 5 lần thu nhập {P}.',
        hlaskaBezOpravy: 'Chi tiêu {V} cao hơn 5 lần thu nhập {P}. Cả hai số đều đúng?',
        kratce: 'Chi tiêu vượt xa thu nhập',
        otazka: 'Một tháng bình thường anh chị tiêu bao nhiêu, không tính trả nợ?',
      },
      V10: {
        hlaska: 'Ngày sinh {datum} nằm trong tương lai.',
        kratce: 'Ngày sinh trong tương lai',
        otazka: 'Anh chị có thể nhắc lại ngày sinh không?',
      },
      V11: {
        hlaska: 'Tuổi tính ra là {n}. Năm sinh có đúng không?',
        kratce: 'Tuổi không hợp lý',
        otazka: 'Anh chị có thể nhắc lại ngày sinh không?',
      },
      V12: {
        hlaska: 'Ngày sinh của con {datum} không khớp với cha mẹ.',
        kratce: 'Con lớn tuổi hơn cha mẹ',
        otazka: 'Ngày sinh của con là ngày nào?',
      },
      V13: {
        hlaska: 'Thu nhập còn dư {Z}, anh chị để dành {X}. Chi tiêu có đúng không?',
        kratce: 'Phần dư không rõ',
        otazka: 'Số tiền còn dư đi đâu?',
      },
      V14: {
        hlaska: 'Chi tiêu {V} cao hơn 2,5 lần thu nhập {P}. Cả hai số đều đúng?',
        kratce: 'Chi tiêu vượt thu nhập',
        otazka: 'Một tháng bình thường anh chị tiêu bao nhiêu, không tính trả nợ?',
      },
      V15: {
        hlaska: 'Chi tiêu {V} chỉ bằng {x} % thu nhập {P}. Chi tiêu có đúng không?',
        kratce: 'Chi tiêu thấp xa so với thu nhập',
        otazka: 'Một tháng bình thường anh chị tiêu bao nhiêu, không tính trả nợ?',
      },
      V2: {
        hlaska: 'Chi tiêu thiết yếu {N} cao hơn chi tiêu thường {V}.',
        hlaskaBezOpravy: 'Chi tiêu thiết yếu {N} cao hơn chi tiêu thường {V}. Cả hai số đều đúng?',
        hlaskaObvykle: 'Chi tiêu thường {V} thấp hơn chi tiêu thiết yếu {N}.',
        kratce: 'Chi thiết yếu cao hơn chi thường',
        otazka: 'Nếu phải tiết kiệm, mỗi tháng anh chị cần tối thiểu bao nhiêu?',
      },
      V3: {
        hlaska: 'Thu nhập {X} cao hơn 10 lần chi tiêu {V}.',
        hlaskaBezOpravy: 'Thu nhập {X} cao hơn 10 lần chi tiêu {V}. Có phải theo năm? Theo tháng là {mesicne}.',
        hlaskaNejiste: 'Thu nhập {X} cao hơn 10 lần chi tiêu {V}. Cả hai số đều đúng?',
        kratce: 'Thu nhập có lẽ theo năm',
        otazka: 'Đây là thu nhập ròng theo tháng hay theo năm?',
      },
      V4: {
        hlaska: 'Khoản dư đã thống nhất {X} cao hơn thu nhập {P}.',
        hlaskaBezOpravy: 'Khoản dư đã thống nhất {X} cao hơn thu nhập {P}. Khoản dư có đúng không?',
        kratce: 'Khoản dư cao hơn thu nhập',
        otazka: 'Mỗi tháng anh chị có thể để dành bao nhiêu mà không bị thiếu?',
      },
      V5: {
        hlaska: 'Thời hạn {roky} năm trông giống năm dương lịch.',
        hlaskaBezOpravy: 'Thời hạn {roky} năm trông giống năm dương lịch. Là sau bao nhiêu năm?',
        kratce: 'Thời hạn ghi thành năm',
        otazka: 'Anh chị muốn đạt được sau bao nhiêu năm?',
      },
      V6: {
        hlaska: 'Khoản nhận hàng tháng {X} cao hơn 20 lần thu nhập. Có phải là tổng số tiền?',
        kratce: 'Khoản hàng tháng giống vốn',
        otazka: 'Anh chị muốn nhận bao nhiêu mỗi tháng?',
      },
      V7: {
        hlaska: 'Lãi suất {u} % trông như số thập phân.',
        hlaskaBezOpravy: 'Lãi suất {u} % thấp bất thường. Có đúng không?',
        kratce: 'Lãi suất ghi dạng thập phân',
        otazka: 'Lãi suất trong hợp đồng là bao nhiêu?',
      },
      V8: {
        hlaska: 'Lãi suất {u} % cho khoản vay nhà ở cao bất thường.',
        hlaskaBezOpravy: 'Lãi suất {u} % cho khoản vay nhà ở cao bất thường. Có đúng không?',
        kratce: 'Lãi vay nhà ở cao',
        otazka: 'Lãi suất trong hợp đồng là bao nhiêu?',
      },
      V9: {
        hlaska: 'Khoản trả {s} cao hơn 20 lần dư nợ {j}.',
        hlaskaBezOpravy: 'Khoản trả {s} cao hơn 20 lần dư nợ {j}. Có bị đổi chỗ không?',
        kratce: 'Khoản trả và dư nợ bị đổi chỗ',
        otazka: 'Anh chị còn phải trả bao nhiêu và mỗi tháng trả bao nhiêu?',
      },
    },
    kratce: {
      bezNazvu: 'Chưa đặt tên',
      cislo: 'số hợp đồng',
      instituce: 'tổ chức',
      investiceUdaje: '{nazev}: {co}',
      menaDatum: '{nazev}: ngày tỷ giá {mena}',
      menaKurz: '{nazev}: tỷ giá {mena}',
      menaStary: '{nazev}: tỷ giá {mena} cũ',
      nemovitostPojisteni: '{nazev}: bảo hiểm bất động sản',
      obe: 'tổ chức và số hợp đồng',
      obecne: 'Bổ sung thông tin',
      vozidloPojistka: '{nazev}: bảo hiểm bắt buộc xe',
      vozidloVyroci: '{nazev}: ngày gia hạn bảo hiểm',
      zavazekCisla: '{nazev}: dư nợ và khoản trả',
    },
    krok: {
      cile: 'Mục tiêu',
      hodnoty: 'Kỳ vọng và giá trị',
      majetek: 'Tài sản',
      predstaveni: 'Thời gian',
      prijmy: 'Thu nhập và chi tiêu',
      rizika: 'Rủi ro',
      rodina: 'Gia đình',
      zavazky: 'Nợ phải trả',
      zaver: 'Kết thúc',
    },
    nav: 'Các bước phân tích',
    otazka: {
      prepinac: 'Câu hỏi cho khách hàng',
      skryt: 'Ẩn câu hỏi',
      titul: 'Câu hỏi cho khách hàng',
      zobrazit: 'Hiện câu hỏi',
    },
    otevrit: 'Hiện các bước phân tích',
    souhrn: 'Xong {hotovo}/{celkem}',
    stav: {
      chybiFew: 'thiếu {n}',
      chybiMany: 'thiếu {n}',
      chybiOne: 'thiếu {n}',
      hotovo: 'xong',
      keKontroleFew: '{n} cần kiểm tra',
      keKontroleMany: '{n} cần kiểm tra',
      keKontroleOne: '{n} cần kiểm tra',
      nezacato: 'chưa bắt đầu',
    },
    zde: 'bạn đang ở đây',
  },
  /* BLOK:pruvodce END */
  /* BẢN KẾ HOẠCH CHO KHÁCH HÀNG (25. 10. 2026, N1) — xem cs.js */
  planVystup: {
    financniPlan: 'Kế hoạch tài chính',
    obsah: 'Mục lục',
    upozorneniNadpis: 'Lưu ý quan trọng',
    upozorneni1: 'Kế hoạch tài chính này phân tích tiền tiết kiệm và các khoản đầu tư của bạn, làm rõ các mục tiêu tài chính và đề xuất con đường đạt tới chúng với mức chấp nhận rủi ro của bạn.',
    upozorneni2: 'Mọi khuyến nghị đều dựa trên dữ liệu bạn đã cung cấp. Các phép tính hiệu suất đầu tư chỉ mang tính minh họa — hiệu suất quá khứ không bảo đảm cho tương lai.',
    upozorneni3: 'Kế hoạch được lập từ dữ liệu biết được tại ngày tạo và cần được cập nhật định kỳ, nhất là khi hoàn cảnh làm nên kế hoạch thay đổi.',
    upozorneni4: 'Quyết định cuối cùng về việc thực hiện các khuyến nghị luôn thuộc về bạn. Các giao dịch có thể có hệ quả về thuế — chúng tôi khuyên bạn trao đổi với tư vấn thuế.',
    bezZmenNadpis: 'Mức hoàn thành mục tiêu nếu bạn không thay đổi gì',
    bezZmenPopis: 'Số tiền bạn đang có sẽ chi trả được bao nhiêu phần trăm mỗi mục tiêu — không có khoản gửi mới. Mục tiêu cần đạt 100 %.',
    bezZmenCoUkazuje: 'Biểu đồ cho thấy: 1. quỹ dự phòng thanh khoản cho tình huống bất ngờ đã đầy bao nhiêu, 2. bạn có thể tài trợ bao nhiêu phần trăm các mục tiêu chiến lược cần tiền, 3. bạn đạt được bao nhiêu phần trăm mức sống mong muốn từ thời điểm độc lập tài chính.',
    vychazimeNadpis: 'Kế hoạch dựa trên những thông tin sau',
    vychazimePopis: 'Cũng như các lĩnh vực khác của cuộc sống, trong tài chính cá nhân điều quan trọng là biết vì sao. Vì vậy trước hết là các giá trị và những mục tiêu chiến lược lớn của bạn — chỉ với chúng mỗi bước của kế hoạch mới có ý nghĩa.',
    cileNadpis: 'Các mục tiêu chiến lược của bạn cần đến tiền',
    popisCile: 'Mục tiêu',
    majetek: 'Tài sản',
    hodnota: 'Giá trị',
    cisteJmeni: 'Tài sản ròng (tài sản − nợ)',
    rozpisNadpis: 'Bảng chi tiết thu nhập và chi tiêu',
    prijmy: 'Thu nhập',
    vydaje: 'Chi tiêu',
    rocniCastka: 'Số tiền hằng năm',
    mesicniPrumer: 'Trung bình tháng',
    procentoZCelku: 'Tỷ lệ trên tổng',
    procentoZPrijmu: 'Tỷ lệ trên thu nhập',
    cistyPrijem: 'Thu nhập ròng — {jmeno}',
    ostatniPrijem: 'Thu nhập khác — {jmeno}',
    pasivniPrijem: 'Thu nhập thụ động (cho thuê, lợi tức)',
    bonusy: 'Thưởng và phụ cấp (năm ÷ 12)',
    vydajeCelkem: 'Tổng chi tiêu và trả nợ',
    prebytekDeficit: 'Thặng dư / thâm hụt',
    mesicne: 'hằng tháng',
    zajisteniNadpis: 'Bảo hiểm — bảo đảm nhu cầu khi có sự kiện bất ngờ',
    investiceNadpis: 'Đầu tư — gắn với việc bảo đảm các mục tiêu cá nhân',
    alokaceSouhrn: 'Phân bổ danh mục — tổng quan',
    tridaAktiv: 'Lớp tài sản',
    aktualne: 'Hiện tại',
    zmena: 'Thay đổi',
    doporuceno: 'Khuyến nghị',
    celkem: 'Tổng cộng',
    nezarazeno: 'Chưa phân loại (sản phẩm hưu trí, bảo hiểm và thay thế)',
    nezarazenoPozn: 'Tỷ lệ của ba lớp chỉ tính trên thị trường tiền tệ, trái phiếu và cổ phiếu. Các sản phẩm chưa phân loại được kế hoạch xử lý tại từng mục tiêu theo thời điểm tiền khả dụng.',
    alokaceDleCilu: 'Phân bổ theo mục tiêu',
    alokaceDleCiluPopis: 'Phân bổ chiến lược số tiền dành cho từng mục tiêu theo thời hạn của nó. Tổng các dòng là phân bổ của toàn bộ kế hoạch; không tính đến thanh khoản của sản phẩm hay định giá thị trường hiện tại.',
    penezniTrh: 'Thị trường tiền tệ',
    penezniTrhKratce: 'Tiền tệ',
    dluhopisy: 'Trái phiếu',
    akcie: 'Cổ phiếu',
    zdrojeCilu: 'Nguồn tiền cho các mục tiêu',
    zdrojeCiluPopis: 'Kế hoạch gán tài khoản và sản phẩm nào cho mục tiêu nào và mỗi tháng dành ra bao nhiêu. Khoản gửi một lần = số tiền còn phải bổ sung cho mục tiêu.',
    dumNadpis: 'Kế hoạch của bạn trong một hình',
    dumPopis: 'Nền móng (quỹ dự phòng và bảo vệ) đỡ các tầng là mục tiêu của bạn, xếp theo thời hạn; trên cùng là độc lập tài chính. Màu xanh = phần mục tiêu kế hoạch sẽ đáp ứng sau khi thực hiện.',
    dumAria: 'Ngôi nhà kế hoạch: {pointa}.',
    dumZaklady: 'Nền móng',
    dumRezerva: 'Quỹ dự phòng {castka}',
    dumRezervaRadek: 'Quỹ dự phòng',
    dumRenta: 'thu nhập {castka}',
    dumVlastniZdroje: 'trong đó vốn tự có {castka}',
    dumZajisteniVse: 'bảo vệ theo đề xuất: đã đủ',
    dumZajisteniChybi: 'còn thiếu bảo vệ: {seznam}',
    dumZajisteniChybiVeta: 'Bảo vệ theo đề xuất chưa bao phủ: {seznam}.',
    dumZdrojMajetek: 'Tài sản · một lần',
    dumZdrojPrebytek: 'Thặng dư · hằng tháng',
    dumZbyva: 'còn lại {castka}',
    dumPrecerpano: 'vượt quá {castka}',
    dumLegMate: 'đã có / đạt',
    dumLegChybi: 'còn thiếu',
    dumLegNezname: 'không tính được',
    dumLegTok: 'dòng tiền từ tài sản và thặng dư',
    dumLegVyska: 'chiều cao tầng theo số tiền, cao hơn = muộn hơn',
    dumHotoveNadpis: 'Đã xong',
    dumHotove: 'Sau khi thực hiện, kế hoạch đáp ứng trọn vẹn: {seznam}.',
    dumHotoveNic: 'Hiện kế hoạch chưa đáp ứng trọn vẹn mục tiêu nào.',
    dumVolne: 'Còn dư {castka}.',
    dumChybiNadpis: 'Còn thiếu',
    dumChybi: 'Kế hoạch chưa đáp ứng trọn vẹn: {seznam}.',
    dumChybiNic: 'Không thiếu gì, sau khi thực hiện kế hoạch đáp ứng mọi mục tiêu.',
    dumNezname: 'Không tính được: {seznam}.',
    dumKrokNadpis: 'Bước tiếp theo',
    dumKrokRealizace: 'Thực hiện kế hoạch: {jednorazove} một lần từ tài sản hiện có và {mesicne} từ thặng dư cho các mục tiêu.',
    dumKrokCil: 'Sau đó điều chỉnh số tiền, thời hạn hoặc khoản góp hằng tháng của mục tiêu {nazev} ({pct}) để kế hoạch đáp ứng trọn vẹn.',
    dumKrokPrecerpano: 'Kế hoạch dùng nhiều tiền hơn số hiện có (vượt quá {castka}). Hãy giảm một mục tiêu hoặc lùi thời hạn.',
    dumCil: 'Mục tiêu',
    dumKdy: 'Khi nào',
    dumCastka: 'Số tiền',
    dumJednorazove: 'Một lần',
    dumMesicne: 'Hằng tháng',
    dumSplneno: 'Đạt',
    tokyJednorazove: 'Dòng tiền: một lần từ tài sản',
    tokyMesicne: 'Dòng tiền: hằng tháng từ thặng dư',
    tokyAria: '{druh}: {seznam}.',
    pravidelneMesicne: 'đầu tư định kỳ',
    pritok: 'dòng tiền tương lai',
    diverzifikace: 'Đa dạng hóa',
    diverzifikacePopis: 'Danh mục được phân tán theo càng nhiều góc nhìn (tiền tệ, nhà quản lý, tổ chức phát hành) thì càng được bảo vệ tốt hơn trước một thất bại đơn lẻ. Phương pháp: tối đa 5 % tài sản ở một tổ chức phát hành doanh nghiệp.',
    menyChip: 'Tiền tệ: {pocet} ({meny}) · tiền tệ trong nước {pct} %',
    spravciChip: 'Tổ chức và nhà quản lý: {pocet} · lớn nhất {nazev} {pct} %',
    emitentChip: 'Trên {limit} % ở một tổ chức phát hành: {polozky}',
    zrealizujeteNadpis: 'Mức hoàn thành mục tiêu nếu bạn thực hiện khuyến nghị của chúng tôi',
    zrealizujetePopis: 'Bên trái là hiện tại, bên phải là sau khi thực hiện kế hoạch. Mục tiêu cần đạt 100 %.',
    vyvojNadpis: 'Phân tích tài sản và dòng tiền theo từng năm',
    vyvojPopis: 'Danh mục cho độc lập tài chính theo kế hoạch: tổng số tiền sẽ gửi vào và giá trị của nó (theo giá hiện tại, với lợi suất kỳ vọng của phân bổ đã chọn).',
    rok: 'Năm',
    vlozenoCelkem: 'Tổng đã gửi',
    hodnotaPortfolia: 'Giá trị danh mục',
    podilCile: 'Tỷ lệ so với mục tiêu',
    vyvojPozn: 'Kết quả chỉ mang tính định hướng và không thể xem là lời hứa cho tương lai.',
    vypisNadpis: 'Sao kê tài sản',
    vypisPopis: 'cơ cấu tài sản tại ngày lập kế hoạch — theo lớp tài sản, tiền tệ và tổ chức',
    majetekCelkem: 'Tổng tài sản',
    financniAktiva: 'Tài sản tài chính',
    nefinancniMajetek: 'Tài sản phi tài chính',
    dluhy: 'Nợ',
    podleTrid: 'Theo lớp tài sản',
    podleMen: 'Theo tiền tệ',
    podleInstituci: 'Theo tổ chức và nhà quản lý (tài sản tài chính)',
    pokracovani: 'tiếp theo',
    ostatni: 'khác',
    krytoZdroji: 'được bù đắp từ nguồn lực',
    neuvedeno: 'chưa ghi tổ chức',
    nezapocteno: 'Chưa tính — thiếu tỷ giá hợp lệ: {polozky}',
    polozky: 'Các khoản mục',
    polozka: 'Khoản mục',
    instituce: 'Tổ chức',
    cilovaAlokace: 'Phân bổ mục tiêu × hiện tại (tài sản tài chính)',
    rozdil: 'Chênh lệch',
    tridaPenezni: 'Thị trường tiền tệ (tài khoản, tiết kiệm)',
    tridaDluhopisy: 'Trái phiếu',
    tridaAkcie: 'Cổ phiếu',
    tridaAlternativni: 'Đầu tư thay thế và khác',
    tridaPenzijni: 'Sản phẩm hưu trí',
    tridaPojisteni: 'Bảo hiểm nhân thọ có giá trị tích lũy',
    tridaNemovitosti: 'Bất động sản, xe, vật có giá trị',
    tridaFirma: 'Công ty / kinh doanh',
    vytvoreno: 'Lập ngày',
    strana: 'Trang',
  },
  /* BLOK:navrhV2 START — Návrh řešení v 9 krocích (15. 10. 2026). Zdroj: lib/navrh/texty/*.js,
     shodu hlídá lib/navrh/__tests__/slovnikNavrhV2.test.js — needitovat ručně, upravit text v lib/navrh/texty. */
  navrhV2: {
    dilna: {
      titul: 'Bàn làm việc',
      podtitul: 'bàn làm việc của tư vấn viên · khách hàng không nhìn thấy',
      sekce: {
        pripraveno: 'Đã sẵn sàng cho khách hàng?',
        penize: 'Phân chia tiền',
        penizePod: 'trước đây là Bảng / Tóm tắt',
        texty: 'Nội dung cho khách hàng',
        textyPod: 'đề xuất của hệ thống, cho tới khi anh/chị tự viết',
        produkty: 'Phân bổ, phí và sản phẩm',
        nastaveni: 'Cài đặt tính toán và phương pháp',
        poznamka: 'Ghi chú và trợ cấp',
      },
      znacka: {
        chyba: 'lỗi',
        pozor: 'lưu ý',
        info: 'thiếu dữ liệu',
      },
      pripraveno: {
        vecOne: '{n} mục',
        vecFew: '{n} mục',
        vecMany: '{n} mục',
        nicNeblokujeKratce: 'không có gì cản trở',
        blokujeKratce: 'cản trở buổi trình bày',
        vsePripraveno: 'tất cả đã sẵn sàng',
        blokujeNadpis: 'Cản trở buổi trình bày',
        chybiNadpis: 'Còn thiếu, nhưng vẫn có thể tiếp tục',
        tiskNadpis: 'Cho kế hoạch in',
        nicNeblokuje: 'Không có gì cản trở — thu nhập và kế hoạch đã được tính theo phương pháp hiện hành',
        nicNeblokujePostaru: 'Không có gì cản trở — thu nhập đã nhập, kế hoạch vẫn đang tính theo cách cũ',
        nicNechybi: 'Không thiếu gì.',
        prejit: 'Đi tới',
        doplnitVAnalyze: 'Bổ sung trong phân tích',
        otevrit: 'Mở',
      },
      polozka: {
        prijemPrijmy: 'Thiếu thu nhập — không có thì kế hoạch không tính được',
        prijemNula: 'Thặng dư bằng không — kế hoạch không có gì để phân chia',
        cenaOchrany: 'Thiếu giá bảo vệ cho phương án {varianta} — bước 8 và phần Trước và sau chưa có giá',
        cenaOchranyCast: 'Giá bảo vệ cho phương án {varianta} mới nhập cho một số người',
        majetekOne: 'Tài sản và trách nhiệm: {n} hợp đồng đang chờ giá của công ty bảo hiểm',
        majetekFew: 'Tài sản và trách nhiệm: {n} hợp đồng đang chờ giá của công ty bảo hiểm',
        majetekMany: 'Tài sản và trách nhiệm: {n} hợp đồng đang chờ giá của công ty bảo hiểm',
        majetekOverit: 'Tài sản và trách nhiệm: nội dung hợp đồng đã thay đổi sau khi nhập giá — hãy kiểm tra lại giá (số hợp đồng: {n})',
        uverDnes: 'Khoản vay hiện tại ({nazev}): thiếu {co}',
        coUrok: 'lãi suất',
        coKonec: 'ngày kết thúc trả nợ',
        coOba: 'lãi suất và ngày kết thúc trả nợ',
        bydleni: '{nazev}: phương án vay {pct} % mới chỉ là đề xuất của hệ thống — hãy chọn cùng khách hàng',
        bydleniBezPct: '{nazev}: phương án vay mới chỉ là đề xuất của hệ thống — hãy chọn cùng khách hàng',
        schodek: 'Thiếu hụt sau khi giải ngân khoản vay: {kroky} mỗi tháng',
        schodekKrok: 'từ {rok} {castka}',
        partner: '{jmeno}: thiếu ngày sinh — chưa tính được bảo vệ',
        staryPlan: 'Kế hoạch đang tính theo cách cũ (phương pháp {datum}) — tính lại trong phần Cài đặt tính toán',
        nadPrebytek: 'Kế hoạch cần {plan} từ thặng dư, nhưng thặng dư chỉ có {prebytek} — mỗi tháng thiếu {chybi}. Hãy điều chỉnh số tiền trong phần Phân chia tiền',
        rezervaDosporit: 'Với kế hoạch, quỹ dự phòng chỉ đạt {pct} % — có thể bù từ thặng dư {castkaMes} mỗi tháng trong {mesicu} tháng (bước 4)',
        rezerva: 'Với kế hoạch, quỹ dự phòng chỉ đạt {pct} % — không còn thặng dư để bù',
        cilBezCastky: 'Mục tiêu „{nazev}“ chưa có số tiền — kế hoạch chưa tính đến',
        cilBezTerminu: 'Mục tiêu „{nazev}“ chưa có thời hạn — kế hoạch chưa tiết kiệm cho mục tiêu này',
        cilBezObojiho: 'Mục tiêu „{nazev}“ chưa có số tiền và thời hạn — kế hoạch chưa tính đến',
        zivotPod20: 'Chi tiêu tự do chỉ còn {pct} % thu nhập ({castka} mỗi tháng) — nên để 20–30 %. Khách hàng sẽ thấy điều này ở bước 8',
      },
      tisk: {
        produkty: 'Sản phẩm',
        coKdyProc: 'Việc gì / Khi nào / Vì sao',
        poznamka: 'Ghi chú cho đề xuất',
        starobni: 'Lương hưu tuổi già',
        navrhSystemu: 'đề xuất của hệ thống',
        upraveno: 'do cố vấn chỉnh sửa',
        zadnyRadek: 'không có dòng nào',
        prazdna: 'để trống',
        vyplnena: 'đã điền',
        nezadano: 'chưa nhập — không in ra',
        rucne: 'nhập thủ công',
        radkuOne: '{n} dòng',
        radkuFew: '{n} dòng',
        radkuMany: '{n} dòng',
      },
      penize: {
        prebytek: 'Thặng dư',
        naPlan: 'Cho kế hoạch hôm nay',
        zbyva: 'Còn lại lâu dài',
        presuny: 'Chuyển từ tiền tiết kiệm',
        drziSplatka: 'hôm nay {castka}, sau đó khoản trả nợ sẽ dùng hết',
        odkud: 'Tiền đến từ đâu',
        kam: 'Đi đâu',
        podlePlanu: 'theo kế hoạch',
        rozdelenoRucne: 'chia thủ công theo số tiền',
        zatimNikam: 'chưa đi đâu',
        vLetech: 'ở tuổi {vek}',
        zadneZdroje: 'Khách hàng không có khoản tiết kiệm nào để phân bổ.',
        rust: 'Tăng lương và khoản tiền về',
        pritokyCile: 'Khoản tiền về một lần cho mục tiêu',
        tabulka: 'Bảng A4 khổ ngang',
        tabulkaNeulozeno: 'Không lưu được đề xuất — bảng sẽ hiện phiên bản cũ.',
        prehled: 'Phân chia theo mục tiêu',
        sloupec: {
          cil: 'Mục tiêu',
          kdy: 'Khi nào',
          kolik: 'Số tiền',
          jednorazove: 'Một lần',
          mesicne: 'Hằng tháng',
          dosazeno: 'Đạt được',
        },
        plusKroky: '+ tăng dần theo thời gian',
        rucne: 'Điều chỉnh phân chia thủ công',
        rucnePod: 'một lần và hằng tháng theo mục tiêu, tiền đến từ đâu',
      },
      texty: {
        cile: 'Nội dung cho từng mục tiêu',
        coKdyProc: 'Việc gì / Khi nào / Vì sao cho kế hoạch in',
        co: 'Việc gì',
        kdy: 'Khi nào',
        proc: 'Vì sao',
        coPlaceholder: 'Chúng tôi khuyến nghị gì',
        pridatRadek: 'Thêm dòng',
        smazatRadek: 'Xoá dòng',
        pojistky: 'Giải pháp cho từng hợp đồng bảo hiểm',
      },
      produkty: {
        alokace: 'Phân bổ',
        alokaceZProfilu: 'Phân bổ theo hồ sơ {profil}',
        alokaceRucne: 'Phân bổ đã chỉnh thủ công',
        akcie: 'Cổ phiếu',
        dluhopisy: 'Trái phiếu',
        hotovost: 'Tiền mặt',
        upravitAlokaci: 'Chỉnh phân bổ',
        hotovo: 'Xong',
        soucet: 'Tổng {pct} %',
        soucetSpatne: 'Tổng {pct} % — phải là 100 %',
        zpetNaProfil: 'Quay lại hồ sơ',
        vstupni: 'Phí đầu vào % ({min}–{max})',
        sprava: 'Phí quản lý % mỗi năm ({min}–{max})',
        nezadano: 'chưa nhập',
        spravaVychozi: 'Để trống = biểu đồ dùng phí quản lý mặc định {pct} %.',
        titul: 'Sản phẩm',
        nazev: 'Tên sản phẩm',
        castka: 'Số tiền',
        akce: 'Hành động',
        koupit: 'Mua',
        prodat: 'Bán',
        ponechat: 'Giữ nguyên',
        navysit: 'Tăng',
        pridat: 'Thêm sản phẩm',
        smazat: 'Xoá sản phẩm',
        zadnyRadek: 'Chưa có dòng nào.',
        sjednat: 'Ký kết → Hợp đồng',
        sjednatPopis: 'Khách hàng đồng ý? Sản phẩm sẽ tự điền vào hợp đồng.',
      },
      nastaveni: {
        profil: 'Hồ sơ',
        scenar: 'Kịch bản',
        metodikaAktualni: 'Phương pháp {datum} — hiện hành, không cần tính lại.',
        metodikaBezZmen: 'Phương pháp {datum} — phương pháp mới không thay đổi gì với khách hàng này.',
      },
      poznamka: {
        placeholder: 'Ghi chú về giải pháp — sẽ được in trong kế hoạch đầy đủ',
        davky: 'Trợ cấp xã hội cho kế hoạch in',
        odhad: 'ước tính theo thu nhập',
        rucne: 'nhập thủ công',
        zpetNaOdhad: 'Quay lại ước tính',
        starobniNezadano: 'Lương hưu tuổi già: chưa nhập — kế hoạch in sẽ không ghi.',
      },
    },
    kroky14: {
      krok1: {
        nadpis: 'Vì sao chúng ta làm điều này',
        citace: '“{text}”',
        analyza: '{jmena}, phân tích {datum}',
        spojka: 'và',
        cileAria: 'Mục tiêu của anh/chị',
        mesicneOd: '{castka} mỗi tháng · từ {rok}',
        vDnesnichCenach: 'theo giá hôm nay',
        renta: 'Độc lập tài chính',
        uverem: 'bằng khoản vay',
        castkaNezadana: 'chưa nhập số tiền',
        bezTerminu: 'chưa có thời hạn',
      },
      krok2: {
        nadpis: 'Hiện tại anh/chị đang ở đâu',
        majetek: 'Tài sản',
        naUctech: 'Trong tài khoản',
        sporeni: 'Tiết kiệm và đầu tư',
        nemovitosti: 'Bất động sản',
        celkem: 'Tổng cộng',
        dluhy: 'nợ {castka}',
        bezDluhu: 'không có nợ',
        ze100: 'Trong mỗi 100 {sym} thu nhập',
        dnes: 'Hôm nay',
        sPrebytkem: 'Với thặng dư',
        prebytek: 'Thặng dư {castka} mỗi tháng',
        odsouhlaseny: 'đã thống nhất',
        nadVolne: '{castka} trong đó sẽ bớt từ chi tiêu sinh hoạt (Cuộc sống {a} → {b})',
        dobre: 'Điều anh/chị đang làm tốt',
        odklad: 'Anh/chị để dành {pct} % thu nhập ({castka}) · với thặng dư {pctPo} %',
        odkladJen: 'Anh/chị để dành {pct} % thu nhập ({castka})',
        rezerva: 'Quỹ dự phòng đã đạt {pct} %',
        rezervaHotova: 'Quỹ dự phòng của anh/chị đã đủ',
        most: 'Nếu {jmeno} không thể làm việc, gia đình thiếu {castka} mỗi tháng',
        mostJeden: 'Khi mất sức lao động, anh/chị thiếu {castka} mỗi tháng',
        mostAkce: 'Bảo vệ',
        detail: 'Cơ cấu tài sản và khoản vay',
        budouci: 'Tài sản tương lai: {nazev}',
        uvery: 'Khoản vay hiện tại',
        zbyva: 'còn {castka}',
        splatka: 'trả góp {castka}',
        hypoChybi: 'Khoản vay mua nhà còn thiếu lãi suất và ngày kết thúc — mô phỏng sẽ hiện sau khi bổ sung.',
      },
      krok3: {
        nadpis: 'Bảo vệ thu nhập',
        rucniOne: '{n} chỉnh sửa thủ công',
        rucniFew: '{n} chỉnh sửa thủ công',
        rucniMany: '{n} chỉnh sửa thủ công',
        vratitVse: 'Hoàn tác tất cả',
        invalidita: 'Rủi ro tệ nhất là mất sức lao động',
        dnes: 'Hôm nay',
        nemuze: '{jmeno} không thể làm việc',
        nemuzeJeden: 'Khi anh/chị không thể làm việc',
        duchod: 'lương hưu mất sức lao động',
        potreba: 'cần {castka}',
        chybi: 'Thiếu {castka} mỗi tháng',
        nicNechybi: 'Thu nhập đủ trang trải, không thiếu gì',
        prumer: 'lương hưu mất sức lao động {castka} là mức trung bình',
        aria: 'Hôm nay có {dnes}. Nếu {jmeno} không thể làm việc, sẽ có {prijde} và cần {potreba} mỗi tháng.',
        ariaJeden: 'Hôm nay có {dnes}. Nếu anh/chị không thể làm việc, sẽ có {prijde} và cần {potreba} mỗi tháng.',
        pojistka: 'Anh/chị đã có bảo hiểm nào chưa?',
        platba: '{castka} mỗi tháng',
        platbaNezadana: 'chưa nhập phí',
        predApo: 'Trước và sau',
        veta: 'Nếu {jmeno} mất sức khỏe, gia đình nhận {nove} thay vì {dnes}.',
        vetaJeden: 'Nếu anh/chị mất sức khỏe, anh/chị nhận {nove} thay vì {dnes}.',
        vetaNema: 'Nếu {jmeno} mất sức khỏe, gia đình nhận {nove}. Hôm nay không có gì.',
        vetaNemaJeden: 'Nếu anh/chị mất sức khỏe, anh/chị nhận {nove}. Hôm nay không có gì.',
        vetaBez: 'Nếu {jmeno} mất sức khỏe, gia đình nhận {nove}.',
        vetaBezJeden: 'Nếu anh/chị mất sức khỏe, anh/chị nhận {nove}.',
        dovetek: 'Mới = lúc đầu, giảm dần theo năm.',
        vetaCena: 'Anh/chị đang trả {dnes} mỗi tháng, mới là {nove}.',
        vetaCenaJen: 'Mới: anh/chị sẽ trả {nove} mỗi tháng.',
        dalsiRizika: 'Rủi ro khác · {n}',
        pojistne: 'phí bảo hiểm {dnes} → {nove}',
        pojistneNove: 'phí bảo hiểm {nove}',
        rizikOne: '{n} rủi ro',
        rizikFew: '{n} rủi ro',
        rizikMany: '{n} rủi ro',
        dnesNezadano: 'hôm nay chưa nhập',
        jakSePocita: 'Cách tính',
        nespocteno: '{jmeno}: chưa tính — thiếu ngày sinh',
        doplnit: 'Bổ sung trong phân tích',
        varianty: 'Anh/chị muốn mức bảo vệ lớn đến đâu?',
        invaliditaKoho: 'Mất sức lao động · {jmeno}',
        invaliditaSloupec: 'Mất sức lao động',
        variantaSloupec: 'Phương án',
        cena: 'Giá',
        cenaNezadana: 'chưa nhập giá',
        mesicne: '{castka} mỗi tháng',
        zvoleno: 'đã chọn',
        ulozeno: 'Đã lưu: {nazev}',
        vratit: 'Hoàn tác',
        coZnamenaji: 'Các phương án nghĩa là gì',
        majetek: 'Tài sản và trách nhiệm',
        bezSmluvMajetku: 'Không có hợp đồng bảo hiểm tài sản',
        vysvetlitMajetek: 'Giải thích bảo hiểm tài sản',
        upravitKryti: 'Chỉnh số tiền và lựa chọn bảo vệ',
      },
      krok4: {
        nadpis: 'Quỹ dự phòng',
        cil: 'Mục tiêu {castka}',
        zakladOne: '{n} tháng chi tiêu thiết yếu và trả góp ({castka})',
        zakladFew: '{n} tháng chi tiêu thiết yếu và trả góp ({castka})',
        zakladMany: '{n} tháng chi tiêu thiết yếu và trả góp ({castka})',
        mate: 'Anh/chị có',
        chybi: 'Còn thiếu',
        zFondu: 'Bổ sung từ quỹ',
        zaOne: 'sau {n} tháng',
        zaFew: 'sau {n} tháng',
        zaMany: 'sau {n} tháng',
        kde: 'Trong tài khoản tiết kiệm hoặc quỹ thị trường tiền tệ, không phải cổ phiếu.',
        hotova: 'Quỹ dự phòng đã đủ',
        aria: 'Quỹ dự phòng hôm nay {dnes} %, với kế hoạch {po} %',
        dnesPct: 'hôm nay {pct} %',
        poPct: 'với kế hoạch {pct} %',
        dosporitNabidka: 'Bù thêm {castka} mỗi tháng trong {mesicu} tháng',
        dosporeni: 'Chúng ta bù từ thặng dư {castka} mỗi tháng trong {mesicu} tháng.',
        dosporitZrusit: 'Hủy khoản bù thêm',
      },
      nezadano: 'chưa nhập',
    },
    kroky56: {
      k5: {
        nadpis: 'Mục tiêu của anh/chị',
        cipyAria: 'Mục tiêu của anh/chị theo năm',
        uverem: 'bằng khoản vay',
        renta: 'Thu nhập hưu trí',
        profilRadek: 'Hồ sơ: {profil} · {scenar} · giảm rủi ro trước mục tiêu',
        zmenitVDilne: 'Thay đổi trong Xưởng',
        zadneCile: 'Ngoài quỹ dự phòng và thu nhập hưu trí, kế hoạch không có mục tiêu khác.',
      },
      profil: {
        dynamicky: 'Năng động',
        vyvazeny: 'Cân bằng',
        konzervativni: 'Thận trọng',
      },
      karta: {
        castkaRok: '{castka} · {rok}',
        vek: '{jmeno} lúc {vek} tuổi',
        plneni: 'hôm nay {dnes} % → với kế hoạch {po} %',
        sPlanem: 'với kế hoạch {po} %',
        mesicne: 'Hằng tháng',
        jednorazove: 'Một lần',
        splatkaOd: 'Trả góp từ {rok}',
        bezPenez: 'Chưa có tiền',
        chybi: 'còn thiếu {castka}',
        modelove: 'Theo mô hình năm {rok}',
        cil: 'Mục tiêu',
        splneno: 'đã đạt',
        chybiNadpis: 'Còn thiếu',
        upravitCil: 'Sửa số tiền và năm của mục tiêu',
        castkaPole: 'Số tiền mục tiêu',
        rokPole: 'Năm mục tiêu',
        pouzit: 'Áp dụng',
        zrusit: 'Hủy',
        vratit: 'Khôi phục giá trị từ phân tích',
        upraveno: 'đã sửa',
        detail: 'Chi tiết',
        glideNadpis: 'Cơ cấu thay đổi thế nào',
        prvni: 'Năm đầu',
        polovina: 'Giữa kỳ',
        posledni: 'Năm cuối',
        slozeni: 'cổ phiếu {akcie} % · trái phiếu {dluhopisy} % · tiền mặt {cash} %',
        jakInvestovat: 'Cách đầu tư',
        jakInvestovatText: 'Theo kế hoạch, hồ sơ {profil}: trước mục tiêu cổ phiếu được bán dần, năm cuối tất cả là tiền mặt.',
      },
      duvod: {
        splatka: 'Từ năm {rok}, khoản trả góp của khoản vay “{popis}” chiếm hết thặng dư — hằng tháng không còn tiền cho mục tiêu này.',
        drivejsi: 'Hiện nay thặng dư dành cho các mục tiêu sớm hơn.',
        bezTerminu: 'Mục tiêu chưa có thời hạn — kế hoạch chưa tiết kiệm cho mục tiêu này.',
        jine: 'Kế hoạch hiện chưa dành tiền cho mục tiêu này.',
      },
      fin: {
        krok1: 'Anh/chị sẽ tài trợ việc mua thế nào',
        jakZaplatit: 'Cách thanh toán',
        zaplatitSporenim: 'Tiết kiệm toàn bộ',
        zaplatitUverem: 'Bằng khoản vay',
        krok2: 'Tiết kiệm vốn tự có',
        uver: 'Khoản vay',
        hypoteka: 'Vay thế chấp',
        uverem100: '100 % bằng khoản vay',
        hotove: 'Trả tiền mặt',
        hotovePct: '{pct} %',
        produkt: 'Loại khoản vay',
        spotrebitelsky: 'Vay tiêu dùng',
        stavebko: 'Vay tiết kiệm xây dựng',
        splatnost: 'Thời hạn',
        urokRocne: 'Lãi suất năm',
        volba: 'Phương án',
        vlastniZdroje: 'Vốn tự có',
        mesicneDoKoupe: 'Hằng tháng đến khi mua',
        splatka: 'Trả góp',
        a10: '10 % vốn tự có',
        a20: '20 % vốn tự có',
        a30: '30 % vốn tự có',
        a100: '100 % kèm vay tiết kiệm xây dựng',
        zastava: '100 % thế chấp bất động sản khác',
        duvodVek: 'chỉ đến 36 tuổi · năm {rok} {jmeno} sẽ {vek} tuổi',
        duvodVekNbs: 'chỉ nhà ở đầu tiên đến 35 tuổi · năm {rok} {jmeno} sẽ {vek} tuổi',
        duvodDo2026: 'nếu mua trước cuối năm 2026 chỉ được 20 % vốn tự có',
        duvodNemovitost: 'chỉ nhà ở đầu tiên khi không có bất động sản khác',
        duvodK2: 'thiếu ngày sinh của người vay thứ hai',
        duvodVekNeznamy: 'thiếu ngày sinh',
        duvodNelze: 'kế hoạch chưa tính được phương án này',
        a100Rozpis: 'vay thế chấp {hypo} + vay tiết kiệm xây dựng {stavebko}',
        zastavaRadek: 'tài sản thế chấp: {nazev} {castka}',
        zatizeni: 'hãy kiểm tra nghĩa vụ — bất động sản đang có khoản vay thế chấp',
        hypoInfo: 'Vay thế chấp {sazba} % trong {roky}',
        dalsiMoznosti: 'Các phương án tài trợ khác',
        klientVolba: '{volba} · {uver} trong {roky}',
        sporitVysledek: 'Theo mô hình sau {roky}: {hodnota} trên {cil}',
        bezVlastnich: 'Không cần vốn tự có — khoản vay trả toàn bộ giá.',
        schodek: 'Từ năm {rok} ngân sách thiếu {castka} mỗi tháng.',
      },
      k6: {
        nadpis: 'Thu nhập hưu trí',
        nazev: 'Độc lập tài chính',
        podnadpis: '{castka} mỗi tháng theo giá hôm nay · từ {rok}',
        kapital: 'Số vốn cần có',
        kapitalPozn: 'rút 4 % mỗi năm, thu nhập vô thời hạn',
        planDava: 'Kế hoạch mang lại theo mô hình',
        pasmo: '{od} – {do}',
        pasmoPozn: 'từ kịch bản xấu đến tốt',
        poPoplatcichCastka: 'sau phí {castka}',
        poPoplatcichPct: 'sau phí {pct} %',
        dnes: 'hôm nay',
        zdrojRadek: '{popis} · {kdy}',
        zdrojVek: '{rok}, lúc {vek} tuổi',
        mesicneOdDneska: 'Hằng tháng từ hôm nay',
        mesicnePopo: 'Hằng tháng {kroky}',
        mesicneOd: 'Hằng tháng từ {rok}',
        az: 'đến {castka}',
        zdrojeDoRenty: 'Tiết kiệm xây dựng và tiết kiệm hưu trí vào thu nhập hưu trí',
        ano: 'có',
        ne: 'không',
        doCeho: 'Chúng tôi đầu tư vào đâu',
        rentier: 'Danh mục tạo thu nhập: cổ phiếu {akcie} % · trái phiếu {dluhopisy} % · tiền mặt {cash} %. Giữ nguyên cả khi rút tiền.',
        bezRenty: 'Thu nhập hưu trí chưa được nhập trong phân tích.',
      },
      graf: {
        vlozeno: 'Đã góp',
        modelove: 'Theo mô hình',
        poPoplatcich: 'Sau phí',
        pasmo: 'từ kịch bản xấu đến tốt',
        pasmoBublina: 'Kịch bản xấu – tốt',
        cil: 'Mục tiêu {castka}',
        kapital: 'Số vốn {castka}',
        aria: '{nazev}: theo mô hình {hodnota} năm {rok} trên {cil}, kịch bản xấu {od}, kịch bản tốt {do}, sau phí {po}. Mô hình, không phải cam kết.',
        vetaRoku: 'Đã góp {vlozeno} · theo mô hình {hodnota} · sau phí {po}',
        dnes: 'hôm nay',
      },
      letOne: '{n} năm',
      letFew: '{n} năm',
      letMany: '{n} năm',
    },
    kroky79: {
      k7: {
        sPlanem: 'Có kế hoạch',
        naUctu: 'Trên tài khoản tiết kiệm',
        poPoplatcich: 'sau phí',
        pasmo: 'kịch bản xấu đến tốt',
        pasmoBublina: 'Kịch bản xấu – tốt',
        veta: 'Cùng số tiền, cùng mục tiêu: sau {roky} theo mô hình có kế hoạch {sPlanem} (kịch bản xấu {horsi}), trên tài khoản tiết kiệm {naUctu}.',
        vetaSPoplatky: 'Cùng số tiền, cùng mục tiêu: sau {roky} theo mô hình có kế hoạch {sPlanem} trước phí ({poPoplatcich} sau phí, kịch bản xấu {horsi}), trên tài khoản tiết kiệm {naUctu}.',
        vetaUcet: 'Tài khoản tiết kiệm = cùng số tiền vào cùng ngày, lãi suất tài khoản tiết kiệm {sazba} % mỗi năm trên mức lạm phát (theo giá hôm nay).',
        chybiNaUctu: 'Trên tài khoản tiết kiệm, năm {rok} mục tiêu “{cil}” sẽ thiếu {castka}.',
        vetaRoku: 'Có kế hoạch {sPlanem} · tài khoản tiết kiệm {naUctu}',
        aria: 'Sau {roky} theo mô hình có kế hoạch {sPlanem} trước phí, {poPoplatcich} sau phí, kịch bản xấu {horsi}, tài khoản tiết kiệm {naUctu}. Mô hình, không phải cam kết.',
        dnes: 'hôm nay',
        schodek: 'Sau khi giải ngân khoản vay, kế hoạch thiếu {seznam} mỗi tháng — chúng ta giải quyết điều đó trước (bước 8).',
        schodekPrez: 'Sau khi giải ngân khoản vay, kế hoạch thiếu {seznam} mỗi tháng — chúng ta giải quyết điều đó trước.',
        postaru: 'Được tính theo cách cũ — so sánh sẽ hiện sau khi tính lại.',
        prepocitat: 'Tính lại',
        bezCilu: 'Kế hoạch chưa chuyển tiền vào mục tiêu nào — chưa có gì để so sánh.',
        odklad: 'Chậm trễ tốn bao nhiêu',
        odkladUvod: 'Mỗi tháng cần bao nhiêu cho dòng tiền hưu trí {renta}:',
        odkladDnes: 'nếu bắt đầu hôm nay',
        odkladZa: 'nếu bắt đầu sau {roky}',
        mesicneCastka: '{castka} mỗi tháng',
      },
      k8: {
        mesicne: 'Hằng tháng',
        mesicneRozpad: 'bảo vệ {ochrana} (hiện nay {dnes}) · đầu tư {investice}',
        mesicneBezCeny: 'đầu tư {investice} · bảo vệ chưa có giá',
        mesicneBezNove: 'đầu tư {investice} · không có bảo vệ mới',
        bezNoveOchrany: 'không có bảo vệ mới',
        vicNezDnes: 'nhiều hơn hôm nay {castka}',
        orientacne: 'ước tính {castka} · ước tính của ứng dụng, không trừ',
        jednorazove: 'Tiền mới một lần',
        presunyUvod: 'Chúng ta chuyển từ khoản tiết kiệm của anh/chị:',
        presun: '{odkud} → {kam}',
        vRoce: 'năm {rok}',
        zaMesicu: 'sau {n} tháng',
        odkud: {
          ucty: 'tài khoản và tiết kiệm xây dựng',
          fondy: 'quỹ',
          penzijko: 'tiết kiệm hưu trí',
          pritok: 'thu nhập tương lai',
          dopocet: 'khoản góp thêm',
        },
        kam: {
          rezerva: 'quỹ dự phòng',
          renta: 'dòng tiền hưu trí',
        },
        vetaPrebytek: 'Từ thặng dư {prebytek}, {plan} dành cho kế hoạch, còn lại {zbyva}.',
        vetaPrebytekDrzi: 'Từ thặng dư {prebytek}, {plan} dành cho kế hoạch.',
        vetaNadPrebytek: 'Kế hoạch cần {plan} từ thặng dư, nhưng thặng dư chỉ có {prebytek} — mỗi tháng thiếu {chybi}.',
        vetaDrzi: 'Kế hoạch không dùng {castka} còn lại cho mục tiêu: từ năm {rok} khoản trả góp “{uver}” sẽ dùng hết.',
        schodek: 'Sau khi giải ngân khoản vay, mỗi tháng thiếu {seznam}.',
        schodekPolozka: 'từ năm {rok} {castka}',
        stovka: 'Anh/chị chỉ còn {pct} % thu nhập ({castka} mỗi tháng) cho chi tiêu tự do (ngoài khoản bắt buộc) — chúng tôi khuyên từ 20 đến 30 %.',
        ochranaOsob: 'Bảo vệ con người',
        cenaOsoby: '{jmeno} · mỗi tháng',
        cenaDeti: 'Trẻ em · mỗi tháng',
        cenaPh: 'giá từ công ty bảo hiểm',
        pojistne: 'Phí bảo hiểm: hiện nay {dnes} → {nove}',
        pojistneRozdil: '({rozdil})',
        cenaNezadana: 'chưa nhập giá',
        majetek: 'Tài sản và trách nhiệm',
        smlouvyOne: '{n} hợp đồng',
        smlouvyFew: '{n} hợp đồng',
        smlouvyMany: '{n} hợp đồng',
        investice: 'Đầu tư',
        poplatky: 'phí đầu vào {vstupni} % · phí quản lý {sprava} % mỗi năm',
        poplatkyNezadane: 'phí đầu vào và phí quản lý: chưa nhập',
        mesicneCastka: '{castka} mỗi tháng',
        rozdeleni: 'Phân chia thặng dư',
        zUspor: 'Một lần từ khoản tiết kiệm',
        zPrebytku: 'Hằng tháng từ thặng dư {prebytek}',
        ochranaRozdil: 'bảo vệ (chênh lệch so với hiện nay)',
        zbyvaDnes: 'còn lại hôm nay',
        udalostSplatka: 'từ năm {rok} · trả góp khoản vay “{popis}”',
        udalostDoplaceno: 'năm {rok} · trả xong “{popis}”',
        udalostRenta: 'từ năm {rok} · thêm cho dòng tiền hưu trí',
        uvolniSe: 'được giải phóng',
        cashflow: 'Dòng tiền theo thời gian',
        cashflowAria: 'Biểu đồ dòng tiền của kế hoạch: hôm nay còn {dnes} mỗi tháng, năm thấp nhất {nejhorsi}.',
        zmenitVDilne: 'Sửa trong Xưởng',
      },
      k9: {
        tri: {
          zajistit: 'Bảo vệ thu nhập và tài sản',
          rezervaDluhy: 'Quỹ dự phòng và nợ đắt',
          investovat: 'Đầu tư',
        },
        ochrana: '{varianta} · {cena} mỗi tháng',
        ochranaBezCeny: '{varianta} · chưa nhập giá',
        ochranaBezNove: '{varianta} · không có bảo vệ mới',
        majetek: 'tài sản {smlouvy}',
        majetekCena: 'tài sản {smlouvy} · {cena} mỗi tháng',
        rezerva: 'Quỹ dự phòng {castka}',
        rezervaHotovo: 'Quỹ dự phòng {castka} · xong',
        dluhy: 'trả hết khoản vay {castka}',
        investice: '{castka} mỗi tháng cho mục tiêu',
        investiceSchodek: 'Hiện {castka} mỗi tháng · từ năm {rok} thiếu {chybi}',
        chybiPodklad: 'thiếu dữ liệu',
        smysl: 'Điều này có hợp lý với anh/chị không?',
        citace: 'Lúc đầu anh/chị nói: “{hodnoty}”',
        domluveno: 'Đã thống nhất',
        ja: 'Tôi (tư vấn viên)',
        vy: 'Anh/chị',
        vyJmena: 'Anh/chị ({jmena})',
        a: 'và',
      },
      doma: {
        tlacitko: 'Chúng tôi sẽ suy nghĩ ở nhà',
        ukladam: 'Đang lưu…',
        neulozeno: 'Không lưu được kế hoạch. Vui lòng thử lại.',
        titul: 'Kế hoạch tài chính của anh/chị',
        intro: 'Xin chào, tôi gửi kế hoạch chúng ta đã cùng xem. Anh/chị cứ thong thả xem ở nhà và báo cho tôi nhé.',
      },
      snimek: {
        hero: 'Kế hoạch hằng tháng',
        heroBezCeny: 'Đầu tư mỗi tháng (bảo vệ chưa có giá)',
        poPoplatcich: 'Sau phí, sau {roky}',
        pro: 'Dành cho',
        prebytek: 'Thặng dư',
        naPlan: 'Từ thặng dư cho kế hoạch',
        presuny: 'Chuyển từ tiết kiệm',
        ochrana: 'Bảo vệ · {varianta}',
        investice: 'Đầu tư hằng tháng',
        sPlanem: 'Có kế hoạch sau {roky}',
        naUctu: 'Trên tài khoản tiết kiệm',
        garance: 'Mô hình từ số liệu của anh/chị, không phải cam kết.',
      },
    },
    ramec: {
      analyza: 'Phân tích',
      zpetNaAnalyzu: 'Quay lại phân tích',
      navrhDatum: 'Đề xuất giải pháp · {datum}',
      klient: 'Khách hàng',
      spojka: 'và',
      pasek: {
        popis: 'Hằng tháng',
        prebytek: 'Thặng dư',
        plan: 'kế hoạch',
        splatky: 'trả góp',
        zbyva: 'còn lại',
        chybi: 'thiếu',
      },
      pohled: {
        skupina: 'Chế độ xem',
        dilna: 'Bàn làm việc',
        plan: 'Kế hoạch',
        klient: 'Cho khách hàng',
      },
      kDoplneni: 'Cần bổ sung: {n}',
      ulozeni: {
        neulozeno: 'Chưa lưu',
        uklada: 'Đang lưu…',
        ulozeno: 'Đã lưu {cas}',
        chyba: 'Chưa lưu',
        offline: 'Ngoại tuyến',
        zkusitZnovu: 'Thử lại',
        chybaText: 'Không lưu được thay đổi.',
      },
      prezentovat: 'Trình bày',
      prezentovatBlokuje: 'Chưa thể trình bày: {duvod}',
      zpetDoUprav: 'Quay lại chỉnh sửa',
      dalsiKrok: 'Bước tiếp theo',
      krokZ: 'Bước {n}/{z}',
      krokyPlanu: 'Các bước của kế hoạch',
      znacka: {
        chyba: 'lỗi',
        pozor: 'lưu ý',
        info: 'thiếu dữ liệu',
      },
      nacitani: 'Đang tải đề xuất…',
      chybaNacteni: 'Không tải được đề xuất.',
      bezPrijmu: {
        kroky: 'Bước 3–9',
        veta: 'Không có thu nhập thì không tính được kế hoạch — hãy nhập thu nhập trong phần phân tích.',
        vetaNula: 'Thặng dư bằng không hoặc âm — kế hoạch không có nguồn để chi trả. Hãy điều chỉnh chi tiêu hoặc thặng dư trong phần phân tích.',
        akce: 'Đến phần thu nhập',
      },
      dialogChybi: {
        nadpis: 'Khách hàng sẽ thấy những gì còn thiếu',
        dalsi: 'Còn lại trong Bàn làm việc: {n}',
        doplnit: 'Bổ sung',
        prezentovat: 'Vẫn trình bày',
        zrusit: 'Quay lại',
      },
      staryPlan: {
        veta: 'Tính theo cách cũ ({datum})',
        vetaBezData: 'Tính theo cách cũ',
        prepocitat: 'Tính lại',
        coSeZmeni: 'Điều gì sẽ thay đổi',
      },
      offline: 'Ngoại tuyến · thay đổi sẽ được lưu khi có kết nối.',
      prezentace: {
        oblast: 'Trình bày kế hoạch',
        krokZ: 'bước {n}/{z}',
        cilZ: 'mục tiêu {n}/{z}',
        dalsi: 'Tiếp',
        predchozi: 'Trước',
        konec: 'Kết thúc trình bày',
        dokoncit: 'Hoàn tất',
      },
      uvod: {
        nadpis: 'Kế hoạch tài chính của anh chị',
        veta: 'Chúng ta sẽ cùng xem từng bước.',
      },
      dveZpravy: {
        nadpis: 'Tôi có hai tin cho anh chị',
        dobraCile: 'Tin thứ nhất là tin tốt: [[các mục tiêu của anh chị sẽ đạt được.]]',
        dobraPlan: 'Tin tốt: [[anh chị đã có kế hoạch.]]',
        lepsiCesta: 'Tin còn tốt hơn: anh chị đến đó [[bằng con đường an toàn hơn]].',
        lepsiDrive: 'Tin còn tốt hơn: anh chị có thể sống bằng dòng tiền từ vốn [[chỉ sau {za}]] — sớm hơn {o}.',
        rentaNa: 'Dòng tiền hưu trí hiện đạt [[{pct} %]] — và chúng ta thấy rõ cần làm gì.',
        rentaNezadana: 'Mục tiêu dòng tiền hưu trí chưa được đặt.',
      },
      dialogStary: {
        nadpis: 'Kế hoạch được tính theo cách cũ ({datum})',
        nadpisBezData: 'Kế hoạch được tính theo cách cũ',
        text: 'Cách tính cũ được giữ cho đến khi anh/chị tính lại. Bước 7 chỉ hiện trong phần trình bày sau khi tính lại.',
        postaru: 'Trình bày theo cách cũ',
        prepocitat: 'Tính lại và trình bày',
        zrusit: 'Quay lại',
      },
    },
    kroky: {
      proc: 'Vì sao',
      dnes: 'Tình hình hiện tại',
      zajisteni: 'Bảo vệ thu nhập',
      rezerva: 'Quỹ dự phòng',
      cile: 'Mục tiêu',
      renta: 'Dòng tiền hưu trí',
      dveCesty: 'Hai con đường',
      kolik: 'Chi phí bao nhiêu',
      triKroky: 'Ba bước',
    },
    zaklad: {
      krokCislo: 'Bước {n}',
      stitek: {
        nezadano: 'chưa nhập',
        navrh: 'đề xuất',
        postaru: 'tính theo cách cũ',
        odhad: 'ước tính',
        poplatky: 'chưa nhập phí',
      },
      model: {
        veta: 'Theo mô hình · {scenar} · theo giá hôm nay · trước phí',
        cara: 'đường chấm',
        scenar: {
          realisticky: 'kịch bản thực tế',
          pesimisticky: 'kịch bản bi quan',
          optimisticky: 'kịch bản lạc quan',
        },
        garance: 'Đây là mô hình từ số liệu của anh/chị, không phải bảo đảm.',
      },
      poplatky: {
        vychozi: 'sau phí quản lý mặc định {sprava} %',
        zadane: 'sau phí: phí đầu vào {vstupni} %, phí quản lý {sprava} %',
        legenda: '{cara} = {popis}',
        legendaCastka: '{cara} = {popis}: {castka}',
      },
      nacitani: 'Đang tải số liệu kế hoạch…',
    },
  },
  /* BLOK:navrhV2 END */
  trychtyrBuilder: {
    title: "Phễu bán hàng từ A đến Z",
    info: "Bảy bước theo phương pháp Konverzky: mồi thu hút → trang → trang cảm ơn → cuộc gọi → mini-webinar → e-mail → quảng cáo và đo lường. Bạn tự điền mẫu, không có AI tạo nội dung; lưu trên máy chủ cho bạn.",
    krokN: "Bước {n}", hotovo: "Hoàn tất", rozpracovano: "Đang làm", nezacato: "Chưa bắt đầu", postup: "Tiến độ", hotovychKroku: "{h} / {n} hoàn tất",
    ulozit: "Lưu", ukladam: "Đang lưu…", ulozeno: "Đã lưu {cas}", ulozenoBezCasu: "Đã lưu", neulozeno: "Chưa lưu", ulozeniSelhalo: "Lưu thất bại", zkusitZnovu: "Thử lại",
    mistniKopie: "Máy chủ không khả dụng — bạn đang làm với bản sao cục bộ từ trình duyệt này. Tôi sẽ thử lưu lại.",
    nacitam: "Đang tải…", povinne: "bắt buộc", vyber: "— chọn —",
    vlozitSablonu: "Chèn mẫu", pouzitNavrh: "Dùng gợi ý cho các ô trống", dosaditTitulek: "Đưa vào tiêu đề", pravidlaTitulku: "Quy tắc tiêu đề",
    mojeOdkazy: "Liên kết của tôi để chia sẻ", nahledBezSlugu: "Hiện chỉ xem trước — để có liên kết thật, hãy đặt địa chỉ danh thiếp trong", nastaveni: "Cài đặt",
    otevrit: "Mở", kopirovat: "Sao chép", zkopirovano: "Đã sao chép", kopieSelhala: "Sao chép thất bại", tisk: "In / PDF", tiskSelhal: "Không mở được bản in",
    zasady: "6 nguyên tắc của hệ thống bán hàng", krokyHovoru: "9 bước của cuộc gọi", beaty: "Kịch bản từng nhịp (thứ tự bắt buộc)",
    emailyOblouk: "Chuỗi làm ấm — 6 ngày + gửi tài liệu", emailyNoBooking: "Khi họ không đặt lịch sau yêu cầu", emailySekvence: "Chuỗi e-mail",
    den: "Ngày", cil: "Mục tiêu", predmet: "Tiêu đề", nahledRadek: "Dòng xem trước", telo: "Nội dung", ctaTlacitko: "Chữ trên liên kết (CTA)", testPraveRuky: "Bài kiểm tra tay phải", kopirovatSekvenci: "Sao chép toàn bộ chuỗi",
    uhly: "Góc quảng cáo — quảng cáo bán cú nhấp", kanaly: "Kênh và thiết lập", navodMereni: "Đo lường từng bước", otevritNastaveni: "Cài đặt web → Đo lường", idNastaveno: "Đã đặt ID", idChybi: "Thiếu ID", format: "định dạng",
    checklist: "Kiểm tra trước khi chạy", predchozi: "Trước", dalsi: "Bước tiếp theo",
  },
};

export default vi;
